var KC = Object.defineProperty;
var qC = (e, t, n) => t in e ? KC(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ae = (e, t, n) => (qC(e, typeof t != "symbol" ? t + "" : t, n), n);
import * as m from "react";
import Y, { createElement as Pe, useLayoutEffect as _s, forwardRef as mt, useRef as Be, useEffect as Le, useCallback as st, Children as Zo, isValidElement as nl, cloneElement as Wl, Fragment as XC, useState as dt, useMemo as ai, createContext as Wn, useContext as ir, useReducer as Vv, Component as ZC } from "react";
import * as nn from "react-dom";
import QC, { flushSync as Pd } from "react-dom";
function JC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Iu = { exports: {} }, Ri = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ip;
function e_() {
  if (ip)
    return Ri;
  ip = 1;
  var e = Y, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (a && a.defaultProps)
      for (u in l = a.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: a, key: f, ref: h, props: d, _owner: o.current };
  }
  return Ri.Fragment = n, Ri.jsx = s, Ri.jsxs = s, Ri;
}
var Ti = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sp;
function t_() {
  return sp || (sp = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Y, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, g = "@@iterator";
    function v(V) {
      if (V === null || typeof V != "object")
        return null;
      var se = p && V[p] || V[g];
      return typeof se == "function" ? se : null;
    }
    var y = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(V) {
      {
        for (var se = arguments.length, me = new Array(se > 1 ? se - 1 : 0), Oe = 1; Oe < se; Oe++)
          me[Oe - 1] = arguments[Oe];
        w("error", V, me);
      }
    }
    function w(V, se, me) {
      {
        var Oe = y.ReactDebugCurrentFrame, Ye = Oe.getStackAddendum();
        Ye !== "" && (se += "%s", me = me.concat([Ye]));
        var rt = me.map(function(Ge) {
          return String(Ge);
        });
        rt.unshift("Warning: " + se), Function.prototype.apply.call(console[V], console, rt);
      }
    }
    var C = !1, x = !1, E = !1, S = !1, R = !1, M;
    M = Symbol.for("react.module.reference");
    function I(V) {
      return !!(typeof V == "string" || typeof V == "function" || V === r || V === i || R || V === o || V === c || V === u || S || V === h || C || x || E || typeof V == "object" && V !== null && (V.$$typeof === f || V.$$typeof === d || V.$$typeof === s || V.$$typeof === a || V.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      V.$$typeof === M || V.getModuleId !== void 0));
    }
    function P(V, se, me) {
      var Oe = V.displayName;
      if (Oe)
        return Oe;
      var Ye = se.displayName || se.name || "";
      return Ye !== "" ? me + "(" + Ye + ")" : me;
    }
    function k(V) {
      return V.displayName || "Context";
    }
    function O(V) {
      if (V == null)
        return null;
      if (typeof V.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof V == "function")
        return V.displayName || V.name || null;
      if (typeof V == "string")
        return V;
      switch (V) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof V == "object")
        switch (V.$$typeof) {
          case a:
            var se = V;
            return k(se) + ".Consumer";
          case s:
            var me = V;
            return k(me._context) + ".Provider";
          case l:
            return P(V, V.render, "ForwardRef");
          case d:
            var Oe = V.displayName || null;
            return Oe !== null ? Oe : O(V.type) || "Memo";
          case f: {
            var Ye = V, rt = Ye._payload, Ge = Ye._init;
            try {
              return O(Ge(rt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var F = Object.assign, T = 0, L, A, N, B, $, U, G;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function q() {
      {
        if (T === 0) {
          L = console.log, A = console.info, N = console.warn, B = console.error, $ = console.group, U = console.groupCollapsed, G = console.groupEnd;
          var V = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: V,
            log: V,
            warn: V,
            error: V,
            group: V,
            groupCollapsed: V,
            groupEnd: V
          });
        }
        T++;
      }
    }
    function j() {
      {
        if (T--, T === 0) {
          var V = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: F({}, V, {
              value: L
            }),
            info: F({}, V, {
              value: A
            }),
            warn: F({}, V, {
              value: N
            }),
            error: F({}, V, {
              value: B
            }),
            group: F({}, V, {
              value: $
            }),
            groupCollapsed: F({}, V, {
              value: U
            }),
            groupEnd: F({}, V, {
              value: G
            })
          });
        }
        T < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var W = y.ReactCurrentDispatcher, z;
    function X(V, se, me) {
      {
        if (z === void 0)
          try {
            throw Error();
          } catch (Ye) {
            var Oe = Ye.stack.trim().match(/\n( *(at )?)/);
            z = Oe && Oe[1] || "";
          }
        return `
` + z + V;
      }
    }
    var J = !1, ne;
    {
      var Q = typeof WeakMap == "function" ? WeakMap : Map;
      ne = new Q();
    }
    function D(V, se) {
      if (!V || J)
        return "";
      {
        var me = ne.get(V);
        if (me !== void 0)
          return me;
      }
      var Oe;
      J = !0;
      var Ye = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var rt;
      rt = W.current, W.current = null, q();
      try {
        if (se) {
          var Ge = function() {
            throw Error();
          };
          if (Object.defineProperty(Ge.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ge, []);
            } catch (dr) {
              Oe = dr;
            }
            Reflect.construct(V, [], Ge);
          } else {
            try {
              Ge.call();
            } catch (dr) {
              Oe = dr;
            }
            V.call(Ge.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (dr) {
            Oe = dr;
          }
          V();
        }
      } catch (dr) {
        if (dr && Oe && typeof dr.stack == "string") {
          for (var We = dr.stack.split(`
`), Jt = Oe.stack.split(`
`), It = We.length - 1, Ht = Jt.length - 1; It >= 1 && Ht >= 0 && We[It] !== Jt[Ht]; )
            Ht--;
          for (; It >= 1 && Ht >= 0; It--, Ht--)
            if (We[It] !== Jt[Ht]) {
              if (It !== 1 || Ht !== 1)
                do
                  if (It--, Ht--, Ht < 0 || We[It] !== Jt[Ht]) {
                    var En = `
` + We[It].replace(" at new ", " at ");
                    return V.displayName && En.includes("<anonymous>") && (En = En.replace("<anonymous>", V.displayName)), typeof V == "function" && ne.set(V, En), En;
                  }
                while (It >= 1 && Ht >= 0);
              break;
            }
        }
      } finally {
        J = !1, W.current = rt, j(), Error.prepareStackTrace = Ye;
      }
      var Ho = V ? V.displayName || V.name : "", op = Ho ? X(Ho) : "";
      return typeof V == "function" && ne.set(V, op), op;
    }
    function te(V, se, me) {
      return D(V, !1);
    }
    function K(V) {
      var se = V.prototype;
      return !!(se && se.isReactComponent);
    }
    function ce(V, se, me) {
      if (V == null)
        return "";
      if (typeof V == "function")
        return D(V, K(V));
      if (typeof V == "string")
        return X(V);
      switch (V) {
        case c:
          return X("Suspense");
        case u:
          return X("SuspenseList");
      }
      if (typeof V == "object")
        switch (V.$$typeof) {
          case l:
            return te(V.render);
          case d:
            return ce(V.type, se, me);
          case f: {
            var Oe = V, Ye = Oe._payload, rt = Oe._init;
            try {
              return ce(rt(Ye), se, me);
            } catch {
            }
          }
        }
      return "";
    }
    var ee = Object.prototype.hasOwnProperty, re = {}, le = y.ReactDebugCurrentFrame;
    function de(V) {
      if (V) {
        var se = V._owner, me = ce(V.type, V._source, se ? se.type : null);
        le.setExtraStackFrame(me);
      } else
        le.setExtraStackFrame(null);
    }
    function be(V, se, me, Oe, Ye) {
      {
        var rt = Function.call.bind(ee);
        for (var Ge in V)
          if (rt(V, Ge)) {
            var We = void 0;
            try {
              if (typeof V[Ge] != "function") {
                var Jt = Error((Oe || "React class") + ": " + me + " type `" + Ge + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof V[Ge] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Jt.name = "Invariant Violation", Jt;
              }
              We = V[Ge](se, Ge, Oe, me, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (It) {
              We = It;
            }
            We && !(We instanceof Error) && (de(Ye), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Oe || "React class", me, Ge, typeof We), de(null)), We instanceof Error && !(We.message in re) && (re[We.message] = !0, de(Ye), b("Failed %s type: %s", me, We.message), de(null));
          }
      }
    }
    var ye = Array.isArray;
    function Ce(V) {
      return ye(V);
    }
    function ie(V) {
      {
        var se = typeof Symbol == "function" && Symbol.toStringTag, me = se && V[Symbol.toStringTag] || V.constructor.name || "Object";
        return me;
      }
    }
    function he(V) {
      try {
        return fe(V), !1;
      } catch {
        return !0;
      }
    }
    function fe(V) {
      return "" + V;
    }
    function Se(V) {
      if (he(V))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ie(V)), fe(V);
    }
    var Me = y.ReactCurrentOwner, $e = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Fe, Ae;
    Ae = {};
    function bt(V) {
      if (ee.call(V, "ref")) {
        var se = Object.getOwnPropertyDescriptor(V, "ref").get;
        if (se && se.isReactWarning)
          return !1;
      }
      return V.ref !== void 0;
    }
    function Pt(V) {
      if (ee.call(V, "key")) {
        var se = Object.getOwnPropertyDescriptor(V, "key").get;
        if (se && se.isReactWarning)
          return !1;
      }
      return V.key !== void 0;
    }
    function Te(V, se) {
      if (typeof V.ref == "string" && Me.current && se && Me.current.stateNode !== se) {
        var me = O(Me.current.type);
        Ae[me] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', O(Me.current.type), V.ref), Ae[me] = !0);
      }
    }
    function Je(V, se) {
      {
        var me = function() {
          Ne || (Ne = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", se));
        };
        me.isReactWarning = !0, Object.defineProperty(V, "key", {
          get: me,
          configurable: !0
        });
      }
    }
    function Vt(V, se) {
      {
        var me = function() {
          Fe || (Fe = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", se));
        };
        me.isReactWarning = !0, Object.defineProperty(V, "ref", {
          get: me,
          configurable: !0
        });
      }
    }
    var $o = function(V, se, me, Oe, Ye, rt, Ge) {
      var We = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: V,
        key: se,
        ref: me,
        props: Ge,
        // Record the component responsible for creating this element.
        _owner: rt
      };
      return We._store = {}, Object.defineProperty(We._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(We, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Oe
      }), Object.defineProperty(We, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ye
      }), Object.freeze && (Object.freeze(We.props), Object.freeze(We)), We;
    };
    function fn(V, se, me, Oe, Ye) {
      {
        var rt, Ge = {}, We = null, Jt = null;
        me !== void 0 && (Se(me), We = "" + me), Pt(se) && (Se(se.key), We = "" + se.key), bt(se) && (Jt = se.ref, Te(se, Ye));
        for (rt in se)
          ee.call(se, rt) && !$e.hasOwnProperty(rt) && (Ge[rt] = se[rt]);
        if (V && V.defaultProps) {
          var It = V.defaultProps;
          for (rt in It)
            Ge[rt] === void 0 && (Ge[rt] = It[rt]);
        }
        if (We || Jt) {
          var Ht = typeof V == "function" ? V.displayName || V.name || "Unknown" : V;
          We && Je(Ge, Ht), Jt && Vt(Ge, Ht);
        }
        return $o(V, We, Jt, Ye, Oe, Me.current, Ge);
      }
    }
    var nt = y.ReactCurrentOwner, Et = y.ReactDebugCurrentFrame;
    function Bt(V) {
      if (V) {
        var se = V._owner, me = ce(V.type, V._source, se ? se.type : null);
        Et.setExtraStackFrame(me);
      } else
        Et.setExtraStackFrame(null);
    }
    var yt;
    yt = !1;
    function hn(V) {
      return typeof V == "object" && V !== null && V.$$typeof === t;
    }
    function _n() {
      {
        if (nt.current) {
          var V = O(nt.current.type);
          if (V)
            return `

Check the render method of \`` + V + "`.";
        }
        return "";
      }
    }
    function Fo(V) {
      {
        if (V !== void 0) {
          var se = V.fileName.replace(/^.*[\\\/]/, ""), me = V.lineNumber;
          return `

Check your code at ` + se + ":" + me + ".";
        }
        return "";
      }
    }
    var Vo = {};
    function Pr(V) {
      {
        var se = _n();
        if (!se) {
          var me = typeof V == "string" ? V : V.displayName || V.name;
          me && (se = `

Check the top-level render call using <` + me + ">.");
        }
        return se;
      }
    }
    function Xs(V, se) {
      {
        if (!V._store || V._store.validated || V.key != null)
          return;
        V._store.validated = !0;
        var me = Pr(se);
        if (Vo[me])
          return;
        Vo[me] = !0;
        var Oe = "";
        V && V._owner && V._owner !== nt.current && (Oe = " It was passed a child from " + O(V._owner.type) + "."), Bt(V), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', me, Oe), Bt(null);
      }
    }
    function Zs(V, se) {
      {
        if (typeof V != "object")
          return;
        if (Ce(V))
          for (var me = 0; me < V.length; me++) {
            var Oe = V[me];
            hn(Oe) && Xs(Oe, se);
          }
        else if (hn(V))
          V._store && (V._store.validated = !0);
        else if (V) {
          var Ye = v(V);
          if (typeof Ye == "function" && Ye !== V.entries)
            for (var rt = Ye.call(V), Ge; !(Ge = rt.next()).done; )
              hn(Ge.value) && Xs(Ge.value, se);
        }
      }
    }
    function Nc(V) {
      {
        var se = V.type;
        if (se == null || typeof se == "string")
          return;
        var me;
        if (typeof se == "function")
          me = se.propTypes;
        else if (typeof se == "object" && (se.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        se.$$typeof === d))
          me = se.propTypes;
        else
          return;
        if (me) {
          var Oe = O(se);
          be(me, V.props, "prop", Oe, V);
        } else if (se.PropTypes !== void 0 && !yt) {
          yt = !0;
          var Ye = O(se);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ye || "Unknown");
        }
        typeof se.getDefaultProps == "function" && !se.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Dc(V) {
      {
        for (var se = Object.keys(V.props), me = 0; me < se.length; me++) {
          var Oe = se[me];
          if (Oe !== "children" && Oe !== "key") {
            Bt(V), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Oe), Bt(null);
            break;
          }
        }
        V.ref !== null && (Bt(V), b("Invalid attribute `ref` supplied to `React.Fragment`."), Bt(null));
      }
    }
    function Bo(V, se, me, Oe, Ye, rt) {
      {
        var Ge = I(V);
        if (!Ge) {
          var We = "";
          (V === void 0 || typeof V == "object" && V !== null && Object.keys(V).length === 0) && (We += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Jt = Fo(Ye);
          Jt ? We += Jt : We += _n();
          var It;
          V === null ? It = "null" : Ce(V) ? It = "array" : V !== void 0 && V.$$typeof === t ? (It = "<" + (O(V.type) || "Unknown") + " />", We = " Did you accidentally export a JSX literal instead of a component?") : It = typeof V, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", It, We);
        }
        var Ht = fn(V, se, me, Ye, rt);
        if (Ht == null)
          return Ht;
        if (Ge) {
          var En = se.children;
          if (En !== void 0)
            if (Oe)
              if (Ce(En)) {
                for (var Ho = 0; Ho < En.length; Ho++)
                  Zs(En[Ho], V);
                Object.freeze && Object.freeze(En);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Zs(En, V);
        }
        return V === r ? Dc(Ht) : Nc(Ht), Ht;
      }
    }
    function Qs(V, se, me) {
      return Bo(V, se, me, !0);
    }
    function Ac(V, se, me) {
      return Bo(V, se, me, !1);
    }
    var Lc = Ac, ro = Qs;
    Ti.Fragment = r, Ti.jsx = Lc, Ti.jsxs = ro;
  }()), Ti;
}
process.env.NODE_ENV === "production" ? Iu.exports = e_() : Iu.exports = t_();
var Id = Iu.exports;
const Ot = Id.Fragment, _ = Id.jsx, Z = Id.jsxs;
function Bv(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = Bv(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function Hv() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = Bv(e)) && (r && (r += " "), r += t);
  return r;
}
const ap = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, lp = Hv, dn = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return lp(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = t, s = Object.keys(o).map((c) => {
    const u = n == null ? void 0 : n[c], d = i == null ? void 0 : i[c];
    if (u === null)
      return null;
    const f = ap(u) || ap(d);
    return o[c][f];
  }), a = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...h } = u;
    return Object.entries(h).every((p) => {
      let [g, v] = p;
      return Array.isArray(v) ? v.includes({
        ...i,
        ...a
      }[g]) : {
        ...i,
        ...a
      }[g] === v;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return lp(e, s, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function Ke(e, ...t) {
  const n = new URL("https://base-ui.com/production-error");
  return n.searchParams.set("code", e.toString()), t.forEach((r) => n.searchParams.append("args[]", r)), `Base UI error #${e}; visit ${n} for the full message.`;
}
const cp = {};
function rn(e, t) {
  const n = m.useRef(cp);
  return n.current === cp && (n.current = e(t)), n;
}
function xr(e, t, n, r) {
  const o = rn(Wv).current;
  return r_(o, e, t, n, r) && zv(o, [e, t, n, r]), o.callback;
}
function n_(e) {
  const t = rn(Wv).current;
  return o_(t, e) && zv(t, e), t.callback;
}
function Wv() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function r_(e, t, n, r, o) {
  return e.refs[0] !== t || e.refs[1] !== n || e.refs[2] !== r || e.refs[3] !== o;
}
function o_(e, t) {
  return e.refs.length !== t.length || e.refs.some((n, r) => n !== t[r]);
}
function zv(e, t) {
  if (e.refs = t, t.every((n) => n == null)) {
    e.callback = null;
    return;
  }
  e.callback = (n) => {
    if (e.cleanup && (e.cleanup(), e.cleanup = null), n != null) {
      const r = Array(t.length).fill(null);
      for (let o = 0; o < t.length; o += 1) {
        const i = t[o];
        if (i != null)
          switch (typeof i) {
            case "function": {
              const s = i(n);
              typeof s == "function" && (r[o] = s);
              break;
            }
            case "object": {
              i.current = n;
              break;
            }
          }
      }
      e.cleanup = () => {
        for (let o = 0; o < t.length; o += 1) {
          const i = t[o];
          if (i != null)
            switch (typeof i) {
              case "function": {
                const s = r[o];
                typeof s == "function" ? s() : i(null);
                break;
              }
              case "object": {
                i.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const i_ = parseInt(m.version, 10);
function Nd(e) {
  return i_ >= e;
}
function up(e) {
  if (!/* @__PURE__ */ m.isValidElement(e))
    return null;
  const t = e, n = t.props;
  return (Nd(19) ? n == null ? void 0 : n.ref : t.ref) ?? null;
}
function Nu(e, t) {
  if (e && !t)
    return e;
  if (!e && t)
    return t;
  if (e || t)
    return {
      ...e,
      ...t
    };
}
function s_(e, t) {
  const n = {};
  for (const r in e) {
    const o = e[r];
    if (t != null && t.hasOwnProperty(r)) {
      const i = t[r](o);
      i != null && Object.assign(n, i);
      continue;
    }
    o === !0 ? n[`data-${r.toLowerCase()}`] = "" : o && (n[`data-${r.toLowerCase()}`] = o.toString());
  }
  return n;
}
function a_(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function l_(e, t) {
  return typeof e == "function" ? e(t) : e;
}
const Qi = {};
function kn(e, t, n, r, o) {
  let i = {
    ...Du(e, Qi)
  };
  return t && (i = zi(i, t)), n && (i = zi(i, n)), r && (i = zi(i, r)), o && (i = zi(i, o)), i;
}
function c_(e) {
  if (e.length === 0)
    return Qi;
  if (e.length === 1)
    return Du(e[0], Qi);
  let t = {
    ...Du(e[0], Qi)
  };
  for (let n = 1; n < e.length; n += 1)
    t = zi(t, e[n]);
  return t;
}
function zi(e, t) {
  return jv(t) ? t(e) : u_(e, t);
}
function u_(e, t) {
  if (!t)
    return e;
  for (const n in t) {
    const r = t[n];
    switch (n) {
      case "style": {
        e[n] = Nu(e.style, r);
        break;
      }
      case "className": {
        e[n] = Uv(e.className, r);
        break;
      }
      default:
        d_(n, r) ? e[n] = f_(e[n], r) : e[n] = r;
    }
  }
  return e;
}
function d_(e, t) {
  const n = e.charCodeAt(0), r = e.charCodeAt(1), o = e.charCodeAt(2);
  return n === 111 && r === 110 && o >= 65 && o <= 90 && (typeof t == "function" || typeof t > "u");
}
function jv(e) {
  return typeof e == "function";
}
function Du(e, t) {
  return jv(e) ? e(t) : e ?? Qi;
}
function f_(e, t) {
  return t ? e ? (n) => {
    if (h_(n)) {
      const o = n;
      Au(o);
      const i = t(o);
      return o.baseUIHandlerPrevented || e == null || e(o), i;
    }
    const r = t(n);
    return e == null || e(n), r;
  } : t : e;
}
function Au(e) {
  return e.preventBaseUIHandler = () => {
    e.baseUIHandlerPrevented = !0;
  }, e;
}
function Uv(e, t) {
  return t ? e ? t + " " + e : t : e;
}
function h_(e) {
  return e != null && typeof e == "object" && "nativeEvent" in e;
}
function vn() {
}
const wo = Object.freeze([]), Rt = Object.freeze({}), p_ = 500, Yv = 500, g_ = {
  style: {
    transition: "none"
  }
}, Dd = "data-base-ui-click-trigger", m_ = {
  fallbackAxisSide: "none"
}, Ad = {
  fallbackAxisSide: "end"
}, v_ = {
  clipPath: "inset(50%)",
  position: "fixed",
  top: 0,
  left: 0
};
function Ie(e, t, n = {}) {
  const r = t.render, o = b_(t, n);
  if (n.enabled === !1)
    return null;
  const i = n.state ?? Rt;
  return y_(e, r, o, i);
}
function b_(e, t = {}) {
  const {
    className: n,
    style: r,
    render: o
  } = e, {
    state: i = Rt,
    ref: s,
    props: a,
    stateAttributesMapping: l,
    enabled: c = !0
  } = t, u = c ? a_(n, i) : void 0, d = c ? l_(r, i) : void 0, f = c ? s_(i, l) : Rt, h = c ? Nu(f, Array.isArray(a) ? c_(a) : a) ?? Rt : Rt;
  return typeof document < "u" && (c ? Array.isArray(s) ? h.ref = n_([h.ref, up(o), ...s]) : h.ref = xr(h.ref, up(o), s) : xr(null, null)), c ? (u !== void 0 && (h.className = Uv(h.className, u)), d !== void 0 && (h.style = Nu(h.style, d)), h) : Rt;
}
function y_(e, t, n, r) {
  if (t) {
    if (typeof t == "function")
      return t(n, r);
    const o = kn(n, t.props);
    return o.ref = n.ref, /* @__PURE__ */ m.cloneElement(t, o);
  }
  if (e && typeof e == "string")
    return x_(e, n);
  throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: Render element or function are not defined." : Ke(8));
}
function x_(e, t) {
  return e === "button" ? /* @__PURE__ */ Pe("button", {
    type: "button",
    ...t,
    key: t.key
  }) : e === "img" ? /* @__PURE__ */ Pe("img", {
    alt: "",
    ...t,
    key: t.key
  }) : /* @__PURE__ */ m.createElement(e, t);
}
function xi(e) {
  return Ie(e.defaultTagName ?? "div", e, e);
}
function w_() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = Gv(t)) && (r && (r += " "), r += n);
  return r;
}
function Gv(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = Gv(e[r])) && (n && (n += " "), n += t);
  return n;
}
var Ld = "-";
function C_(e) {
  var t = E_(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, o = r === void 0 ? {} : r;
  function i(a) {
    var l = a.split(Ld);
    return l[0] === "" && l.length !== 1 && l.shift(), Kv(l, t) || __(a);
  }
  function s(a, l) {
    var c = n[a] || [];
    return l && o[a] ? [].concat(c, o[a]) : c;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: s
  };
}
function Kv(e, t) {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), o = r ? Kv(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length !== 0) {
    var i = e.join(Ld);
    return (s = t.validators.find(function(a) {
      var l = a.validator;
      return l(i);
    })) == null ? void 0 : s.classGroupId;
  }
}
var dp = /^\[(.+)\]$/;
function __(e) {
  if (dp.test(e)) {
    var t = dp.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function E_(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, o = M_(Object.entries(e.classGroups), n);
  return o.forEach(function(i) {
    var s = i[0], a = i[1];
    Lu(a, r, s, t);
  }), r;
}
function Lu(e, t, n, r) {
  e.forEach(function(o) {
    if (typeof o == "string") {
      var i = o === "" ? t : fp(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (S_(o)) {
        Lu(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(function(s) {
      var a = s[0], l = s[1];
      Lu(l, fp(t, a), n, r);
    });
  });
}
function fp(e, t) {
  var n = e;
  return t.split(Ld).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function S_(e) {
  return e.isThemeGetter;
}
function M_(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], o = n[1], i = o.map(function(s) {
      return typeof s == "string" ? t + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(function(a) {
        var l = a[0], c = a[1];
        return [t + l, c];
      })) : s;
    });
    return [r, i];
  }) : e;
}
function O_(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(i, s) {
    n.set(i, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(s) {
      var a = n.get(s);
      if (a !== void 0)
        return a;
      if ((a = r.get(s)) !== void 0)
        return o(s, a), a;
    },
    set: function(s, a) {
      n.has(s) ? n.set(s, a) : o(s, a);
    }
  };
}
var qv = "!";
function R_(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], o = t.length;
  return function(s) {
    for (var a = [], l = 0, c = 0, u, d = 0; d < s.length; d++) {
      var f = s[d];
      if (l === 0) {
        if (f === r && (n || s.slice(d, d + o) === t)) {
          a.push(s.slice(c, d)), c = d + o;
          continue;
        }
        if (f === "/") {
          u = d;
          continue;
        }
      }
      f === "[" ? l++ : f === "]" && l--;
    }
    var h = a.length === 0 ? s : s.substring(c), p = h.startsWith(qv), g = p ? h.substring(1) : h, v = u && u > c ? u - c : void 0;
    return {
      modifiers: a,
      hasImportantModifier: p,
      baseClassName: g,
      maybePostfixModifierPosition: v
    };
  };
}
function T_(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var o = r[0] === "[";
    o ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function k_(e) {
  return {
    cache: O_(e.cacheSize),
    splitModifiers: R_(e),
    ...C_(e)
  };
}
var P_ = /\s+/;
function I_(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, o = t.getConflictingClassGroupIds, i = /* @__PURE__ */ new Set();
  return e.trim().split(P_).map(function(s) {
    var a = n(s), l = a.modifiers, c = a.hasImportantModifier, u = a.baseClassName, d = a.maybePostfixModifierPosition, f = r(d ? u.substring(0, d) : u), h = !!d;
    if (!f) {
      if (!d)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      if (f = r(u), !f)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      h = !1;
    }
    var p = T_(l).join(":"), g = c ? p + qv : p;
    return {
      isTailwindClass: !0,
      modifierId: g,
      classGroupId: f,
      originalClassName: s,
      hasPostfixModifier: h
    };
  }).reverse().filter(function(s) {
    if (!s.isTailwindClass)
      return !0;
    var a = s.modifierId, l = s.classGroupId, c = s.hasPostfixModifier, u = a + l;
    return i.has(u) ? !1 : (i.add(u), o(l, c).forEach(function(d) {
      return i.add(a + d);
    }), !0);
  }).reverse().map(function(s) {
    return s.originalClassName;
  }).join(" ");
}
function N_() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, o, i, s = a;
  function a(c) {
    var u = t[0], d = t.slice(1), f = d.reduce(function(h, p) {
      return p(h);
    }, u());
    return r = k_(f), o = r.cache.get, i = r.cache.set, s = l, l(c);
  }
  function l(c) {
    var u = o(c);
    if (u)
      return u;
    var d = I_(c, r);
    return i(c, d), d;
  }
  return function() {
    return s(w_.apply(null, arguments));
  };
}
function pt(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var Xv = /^\[(?:([a-z-]+):)?(.+)\]$/i, D_ = /^\d+\/\d+$/, A_ = /* @__PURE__ */ new Set(["px", "full", "screen"]), L_ = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, $_ = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, F_ = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function $n(e) {
  return ho(e) || A_.has(e) || D_.test(e) || $u(e);
}
function $u(e) {
  return Io(e, "length", j_);
}
function V_(e) {
  return Io(e, "size", Zv);
}
function B_(e) {
  return Io(e, "position", Zv);
}
function H_(e) {
  return Io(e, "url", U_);
}
function Js(e) {
  return Io(e, "number", ho);
}
function ho(e) {
  return !Number.isNaN(Number(e));
}
function W_(e) {
  return e.endsWith("%") && ho(e.slice(0, -1));
}
function ki(e) {
  return hp(e) || Io(e, "number", hp);
}
function ze(e) {
  return Xv.test(e);
}
function Pi() {
  return !0;
}
function Ir(e) {
  return L_.test(e);
}
function z_(e) {
  return Io(e, "", Y_);
}
function Io(e, t, n) {
  var r = Xv.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function j_(e) {
  return $_.test(e);
}
function Zv() {
  return !1;
}
function U_(e) {
  return e.startsWith("url(");
}
function hp(e) {
  return Number.isInteger(Number(e));
}
function Y_(e) {
  return F_.test(e);
}
function G_() {
  var e = pt("colors"), t = pt("spacing"), n = pt("blur"), r = pt("brightness"), o = pt("borderColor"), i = pt("borderRadius"), s = pt("borderSpacing"), a = pt("borderWidth"), l = pt("contrast"), c = pt("grayscale"), u = pt("hueRotate"), d = pt("invert"), f = pt("gap"), h = pt("gradientColorStops"), p = pt("gradientColorStopPositions"), g = pt("inset"), v = pt("margin"), y = pt("opacity"), b = pt("padding"), w = pt("saturate"), C = pt("scale"), x = pt("sepia"), E = pt("skew"), S = pt("space"), R = pt("translate"), M = function() {
    return ["auto", "contain", "none"];
  }, I = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, P = function() {
    return ["auto", ze, t];
  }, k = function() {
    return [ze, t];
  }, O = function() {
    return ["", $n];
  }, F = function() {
    return ["auto", ho, ze];
  }, T = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, L = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, A = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, N = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, B = function() {
    return ["", "0", ze];
  }, $ = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, U = function() {
    return [ho, Js];
  }, G = function() {
    return [ho, ze];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [Pi],
      spacing: [$n],
      blur: ["none", "", Ir, ze],
      brightness: U(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Ir, ze],
      borderSpacing: k(),
      borderWidth: O(),
      contrast: U(),
      grayscale: B(),
      hueRotate: G(),
      invert: B(),
      gap: k(),
      gradientColorStops: [e],
      gradientColorStopPositions: [W_, $u],
      inset: P(),
      margin: P(),
      opacity: U(),
      padding: k(),
      saturate: U(),
      scale: U(),
      sepia: B(),
      skew: G(),
      space: k(),
      translate: k()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ze]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ir]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": $()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": $()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(T(), [ze])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: I()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": I()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": I()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: M()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": M()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": M()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", ki]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: P()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ze]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: B()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: B()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", ki]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Pi]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", ki]
        }, ze]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": F()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": F()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Pi]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [ki]
        }, ze]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": F()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": F()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ze]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ze]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(N())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(N(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(N(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [b]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [b]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [b]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [b]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [b]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [b]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [b]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [b]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [b]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [v]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [v]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [v]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [v]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [v]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [v]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [v]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [v]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [v]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [S]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [S]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", ze, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", ze, $n]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [Ir]
        }, Ir, ze]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ze, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", ze, $n]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ze, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Ir, $u]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Js]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Pi]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ze]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", ho, Js]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", ze, $n]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ze]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ze]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(L(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", $n]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", ze, $n]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: k()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ze]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ze]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(T(), [B_])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", V_]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, H_]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(L(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: L()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(L())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ze, $n]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [$n]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: O()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [$n]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Ir, z_]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Pi]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": A()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": A()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Ir, ze]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ze]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: G()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ze]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: G()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ze]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [ki, ze]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [R]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [R]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [E]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [E]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ze]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ze]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": k()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": k()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": k()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": k()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": k()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": k()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": k()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": k()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": k()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": k()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": k()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": k()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": k()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": k()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": k()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": k()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": k()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": k()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ze]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [$n, Js]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var K_ = /* @__PURE__ */ N_(G_);
function oe(...e) {
  return K_(Hv(e));
}
const Qv = dn(
  "relative inline-flex select-none items-center justify-center gap-2 overflow-hidden rounded-md border border-transparent font-medium transition-colors duration-75 focus-visible:outline-none focus-visible:ring-1 disabled:pointer-events-none disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        primary: "border-info-bolder bg-info-bold text-foundations-inverse hover:border-info-boldest hover:bg-info-bolder hover:shadow-sm focus-visible:border-info-boldest focus-visible:shadow-sm focus-visible:ring-info-boldest active:bg-info-boldest [&_[data-slot=spinner-container]]:bg-foundations-subtlest [&_[data-slot=spinner-icon]]:border-info-boldest [&_[data-slot=spinner-icon]]:border-r-info-subtle",
        secondary: "border-foundations-bold bg-foundations-default text-foundations-subtle hover:bg-foundations-subtlest hover:text-foundations-bold hover:shadow-sm focus-visible:border-info-bold focus-visible:shadow-sm focus-visible:ring-info-bold active:bg-foundations-subtler active:text-foundations-bold [&_[data-slot=spinner-container]]:bg-foundations-default [&_[data-slot=spinner-icon]]:border-info-boldest [&_[data-slot=spinner-icon]]:border-r-info-subtle",
        tertiary: "text-foundations-subtle hover:bg-foundations-subtlest hover:text-foundations-bold hover:shadow-sm focus-visible:border-info-bold focus-visible:shadow-sm focus-visible:ring-info-bold active:bg-foundations-subtler active:text-foundations-bold  [&_[data-slot=spinner-container]]:bg-foundations-default [&_[data-slot=spinner-icon]]:border-info-boldest [&_[data-slot=spinner-icon]]:border-r-info-subtle"
      },
      size: {
        xs: "px-4 py-1.5 text-xs [&_[data-slot=spinner-icon]]:size-5 [&_svg:not([class*='size-'])]:size-5",
        sm: "px-6 py-2.5 text-sm [&_[data-slot=spinner-icon]]:size-5 [&_svg:not([class*='size-'])]:size-5",
        md: "px-6 py-3 text-base [&_[data-slot=spinner-icon]]:size-6 [&_svg:not([class*='size-'])]:size-6",
        lg: "px-8 py-4 text-base [&_[data-slot=spinner-icon]]:size-6 [&_svg:not([class*='size-'])]:size-6"
      },
      disabled: {
        true: ""
      },
      colorScheme: {
        danger: "",
        success: "",
        inverse: ""
      }
    },
    compoundVariants: [
      {
        variant: "primary",
        colorScheme: "danger",
        className: "border-danger-bolder bg-danger-bold hover:border-danger-boldest hover:bg-danger-bolder focus-visible:border-danger-boldest focus-visible:ring-danger-boldest active:bg-danger-boldest [&_[data-slot=spinner-icon]]:border-red-700 [&_[data-slot=spinner-icon]]:border-r-red-300"
      },
      {
        variant: "primary",
        colorScheme: "success",
        className: "border-success-bolder bg-success-bold hover:border-success-boldest hover:bg-success-bolder focus-visible:border-success-boldest focus-visible:ring-success-boldest active:bg-success-boldest [&_[data-slot=spinner-icon]]:border-green-700 [&_[data-slot=spinner-icon]]:border-r-green-300"
      },
      {
        variant: "primary",
        colorScheme: "inverse",
        className: "border-info-bold bg-foundations-default text-info hover:border-info-bold hover:bg-info-subtler focus-visible:border-info-bold focus-visible:ring-info-bold active:bg-info-subtler active:text-info disabled:text-foundations-subtler "
      },
      {
        variant: "secondary",
        colorScheme: "danger",
        className: "border border-danger-subtle text-danger hover:bg-danger-subtler hover:text-danger focus-visible:border-danger-subtle focus-visible:ring-danger-subtle active:border-danger-subtler active:bg-danger-subtler active:text-danger"
      },
      {
        variant: "secondary",
        colorScheme: "success",
        className: "border border-success-subtle text-success hover:bg-success-subtler hover:text-success focus-visible:border-success-subtle focus-visible:ring-success-subtle active:border-success-subtler active:bg-success-subtler active:text-success"
      },
      {
        variant: "primary",
        disabled: !0,
        className: "disabled:border-foundations-subtle disabled:bg-foundations-subtler disabled:text-foundations-subtler"
      },
      {
        variant: "secondary",
        disabled: !0,
        className: "disabled:border-foundations-subtle disabled:bg-foundations-subtlest disabled:text-foundations-subtler"
      },
      {
        variant: "tertiary",
        disabled: !0,
        className: "disabled:text-foundations-subtler"
      },
      {
        colorScheme: "inverse",
        disabled: !0,
        className: "disabled:border-foundations-bold disabled:bg-foundations-subtler disabled:!text-foundations-subtler"
      }
    ],
    defaultVariants: {
      variant: "primary",
      size: "sm"
    }
  }
), rl = m.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    isLoading: r,
    colorScheme: o,
    children: i,
    render: s,
    ...a
  }, l) => {
    const c = {
      type: "button",
      className: oe(
        Qv({
          variant: t,
          size: n,
          colorScheme: o,
          disabled: a.disabled || r,
          className: e
        })
      ),
      disabled: a.disabled || r,
      children: /* @__PURE__ */ Z(Ot, { children: [
        i,
        r && /* @__PURE__ */ _(Jv, {})
      ] }),
      "data-slot": "button"
    };
    return xi({
      defaultTagName: "button",
      render: s,
      ref: l,
      props: kn(c, a)
    });
  }
);
rl.displayName = "Button";
const Jv = () => /* @__PURE__ */ _(
  "div",
  {
    "data-slot": "spinner-container",
    className: "absolute inset-0 flex items-center justify-center",
    children: /* @__PURE__ */ _(
      "div",
      {
        "data-slot": "spinner-icon",
        className: " animate-spin rounded-full border-4"
      }
    )
  }
), q_ = Y.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "div",
  {
    role: "group",
    ref: n,
    className: oe(
      "flex [&>button:focus]:z-10 [&>button:not(:first-of-type)]:rounded-l-none [&>button:not(:focus-visible):not(:last-of-type)]:border-r-transparent [&>button:not(:last-of-type)]:rounded-r-none",
      e
    ),
    ...t
  }
));
q_.displayName = "ButtonGroup";
const X_ = dn("", {
  variants: {
    size: {
      xs: "p-1 [&_svg:not([class*='size-'])]:size-4",
      sm: "p-2.5 [&_svg:not([class*='size-'])]:size-5",
      md: "p-3 [&_svg:not([class*='size-'])]:size-6",
      lg: "p-4 [&_svg:not([class*='size-'])]:size-6"
    },
    shape: {
      circle: "rounded-full"
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), cs = m.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    isLoading: r,
    colorScheme: o,
    shape: i,
    render: s,
    children: a,
    ...l
  }, c) => {
    const u = {
      type: "button",
      className: oe(
        Qv({
          variant: t,
          size: n,
          colorScheme: o,
          disabled: l.disabled || r
        }),
        X_({
          size: n,
          shape: i,
          className: e
        })
      ),
      disabled: l.disabled || r,
      children: /* @__PURE__ */ Z(Ot, { children: [
        a,
        r && /* @__PURE__ */ _(Jv, {})
      ] }),
      "data-slot": "icon-button"
    };
    return xi({
      defaultTagName: "button",
      render: s,
      ref: c,
      props: kn(u, l)
    });
  }
);
cs.displayName = "IconButton";
const Z_ = () => {
}, ge = typeof document < "u" ? m.useLayoutEffect : Z_, $d = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && ($d.displayName = "TooltipRootContext");
function Es(e) {
  const t = m.useContext($d);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipRootContext is missing. Tooltip parts must be placed within <Tooltip.Root>." : Ke(72));
  return t;
}
const Q_ = [];
function zl(e) {
  m.useEffect(e, Q_);
}
const Ii = 0;
class wr {
  constructor() {
    ae(this, "currentId", Ii);
    ae(this, "clear", () => {
      this.currentId !== Ii && (clearTimeout(this.currentId), this.currentId = Ii);
    });
    ae(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new wr();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = Ii, n();
    }, t);
  }
  isStarted() {
    return this.currentId !== Ii;
  }
}
function un() {
  const e = rn(wr.create).current;
  return zl(e.disposeEffect), e;
}
function jl() {
  return typeof window < "u";
}
function Kr(e) {
  return Fd(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Wt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function sr(e) {
  var t;
  return (t = (Fd(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Fd(e) {
  return jl() ? e instanceof Node || e instanceof Wt(e).Node : !1;
}
function qe(e) {
  return jl() ? e instanceof Element || e instanceof Wt(e).Element : !1;
}
function gt(e) {
  return jl() ? e instanceof HTMLElement || e instanceof Wt(e).HTMLElement : !1;
}
function Fu(e) {
  return !jl() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Wt(e).ShadowRoot;
}
const J_ = /* @__PURE__ */ new Set(["inline", "contents"]);
function No(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = wn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !J_.has(o);
}
const eE = /* @__PURE__ */ new Set(["table", "td", "th"]);
function tE(e) {
  return eE.has(Kr(e));
}
const nE = [":popover-open", ":modal"];
function Ul(e) {
  return nE.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const rE = ["transform", "translate", "scale", "rotate", "perspective"], oE = ["transform", "translate", "scale", "rotate", "perspective", "filter"], iE = ["paint", "layout", "strict", "content"];
function Vd(e) {
  const t = Yl(), n = qe(e) ? wn(e) : e;
  return rE.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || oE.some((r) => (n.willChange || "").includes(r)) || iE.some((r) => (n.contain || "").includes(r));
}
function sE(e) {
  let t = nr(e);
  for (; gt(t) && !Jn(t); ) {
    if (Vd(t))
      return t;
    if (Ul(t))
      return null;
    t = nr(t);
  }
  return null;
}
function Yl() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const aE = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Jn(e) {
  return aE.has(Kr(e));
}
function wn(e) {
  return Wt(e).getComputedStyle(e);
}
function Gl(e) {
  return qe(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function nr(e) {
  if (Kr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Fu(e) && e.host || // Fallback.
    sr(e)
  );
  return Fu(t) ? t.host : t;
}
function eb(e) {
  const t = nr(e);
  return Jn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : gt(t) && No(t) ? t : eb(t);
}
function Br(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = eb(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = Wt(o);
  if (i) {
    const a = Vu(s);
    return t.concat(s, s.visualViewport || [], No(o) ? o : [], a && n ? Br(a) : []);
  }
  return t.concat(o, Br(o, [], n));
}
function Vu(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Gt(e) {
  const t = rn(lE, e).current;
  return t.next = e, ge(t.effect), t;
}
function lE(e) {
  const t = {
    current: e,
    next: e,
    effect: () => {
      t.current = t.next;
    }
  };
  return t;
}
const $c = m[`useInsertionEffect${Math.random().toFixed(1)}`.slice(0, -3)], cE = (
  // React 17 doesn't have useInsertionEffect.
  $c && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
  $c !== m.useLayoutEffect ? $c : (e) => e()
);
function ve(e) {
  const t = rn(uE).current;
  return t.next = e, cE(t.effect), t.trampoline;
}
function uE() {
  const e = {
    next: void 0,
    callback: dE,
    trampoline: (...t) => {
      var n;
      return (n = e.callback) == null ? void 0 : n.call(e, ...t);
    },
    effect: () => {
      e.callback = e.next;
    }
  };
  return e;
}
function dE() {
  if (process.env.NODE_ENV !== "production")
    throw new Error("Base UI: Cannot call an event handler while rendering.");
}
const wi = typeof navigator < "u", Fc = pE(), tb = mE(), nb = gE(), fE = typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter:none"), rb = (
  // iPads can claim to be MacIntel
  Fc.platform === "MacIntel" && Fc.maxTouchPoints > 1 ? !0 : /iP(hone|ad|od)|iOS/.test(Fc.platform)
), ob = wi && /apple/i.test(navigator.vendor), Bu = wi && /android/i.test(tb) || /android/i.test(nb), hE = wi && tb.toLowerCase().startsWith("mac") && !navigator.maxTouchPoints, ib = nb.includes("jsdom/");
function pE() {
  if (!wi)
    return {
      platform: "",
      maxTouchPoints: -1
    };
  const e = navigator.userAgentData;
  return e != null && e.platform ? {
    platform: e.platform,
    maxTouchPoints: navigator.maxTouchPoints
  } : {
    platform: navigator.platform ?? "",
    maxTouchPoints: navigator.maxTouchPoints ?? -1
  };
}
function gE() {
  if (!wi)
    return "";
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map(({
    brand: t,
    version: n
  }) => `${t}/${n}`).join(" ") : navigator.userAgent;
}
function mE() {
  if (!wi)
    return "";
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform ?? "";
}
const Hu = "data-base-ui-focusable", sb = "active", ab = "selected", lb = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", Hr = "ArrowLeft", Wr = "ArrowRight", Bd = "ArrowUp", Ss = "ArrowDown";
function Bn(e) {
  var n;
  let t = e.activeElement;
  for (; ((n = t == null ? void 0 : t.shadowRoot) == null ? void 0 : n.activeElement) != null; )
    t = t.shadowRoot.activeElement;
  return t;
}
function Ve(e, t) {
  var r;
  if (!e || !t)
    return !1;
  const n = (r = t.getRootNode) == null ? void 0 : r.call(t);
  if (e.contains(t))
    return !0;
  if (n && Fu(n)) {
    let o = t;
    for (; o; ) {
      if (e === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function Xt(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function Fn(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function vE(e) {
  return e.matches("html,body");
}
function Nt(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function Hd(e) {
  return gt(e) && e.matches(lb);
}
function Wu(e) {
  return e ? e.getAttribute("role") === "combobox" && Hd(e) : !1;
}
function bE(e) {
  if (!e || ib)
    return !0;
  try {
    return e.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function ol(e) {
  return e ? e.hasAttribute(Hu) ? e : e.querySelector(`[${Hu}]`) || e : null;
}
function vo(e, t, n = !0) {
  return e.filter((o) => {
    var i;
    return o.parentId === t && (!n || ((i = o.context) == null ? void 0 : i.open));
  }).flatMap((o) => [o, ...vo(e, o.id, n)]);
}
function pp(e, t) {
  var o;
  let n = [], r = (o = e.find((i) => i.id === t)) == null ? void 0 : o.parentId;
  for (; r; ) {
    const i = e.find((s) => s.id === r);
    r = i == null ? void 0 : i.parentId, i && (n = n.concat(i));
  }
  return n;
}
function qt(e) {
  e.preventDefault(), e.stopPropagation();
}
function yE(e) {
  return "nativeEvent" in e;
}
function cb(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Bu && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function ub(e) {
  return ib ? !1 : !Bu && e.width === 0 && e.height === 0 || Bu && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function Co(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
function db(e) {
  const t = e.type;
  return t === "click" || t === "mousedown" || t === "keydown" || t === "keyup";
}
const xE = ["top", "right", "bottom", "left"], li = Math.min, mn = Math.max, il = Math.round, Ko = Math.floor, er = (e) => ({
  x: e,
  y: e
}), wE = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, CE = {
  start: "end",
  end: "start"
};
function zu(e, t, n) {
  return mn(e, li(t, n));
}
function Cr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function cn(e) {
  return e.split("-")[0];
}
function qr(e) {
  return e.split("-")[1];
}
function Wd(e) {
  return e === "x" ? "y" : "x";
}
function zd(e) {
  return e === "y" ? "height" : "width";
}
const _E = /* @__PURE__ */ new Set(["top", "bottom"]);
function On(e) {
  return _E.has(cn(e)) ? "y" : "x";
}
function jd(e) {
  return Wd(On(e));
}
function EE(e, t, n) {
  n === void 0 && (n = !1);
  const r = qr(e), o = jd(e), i = zd(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = sl(s)), [s, sl(s)];
}
function SE(e) {
  const t = sl(e);
  return [ju(e), t, ju(t)];
}
function ju(e) {
  return e.replace(/start|end/g, (t) => CE[t]);
}
const gp = ["left", "right"], mp = ["right", "left"], ME = ["top", "bottom"], OE = ["bottom", "top"];
function RE(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? mp : gp : t ? gp : mp;
    case "left":
    case "right":
      return t ? ME : OE;
    default:
      return [];
  }
}
function TE(e, t, n, r) {
  const o = qr(e);
  let i = RE(cn(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(ju)))), i;
}
function sl(e) {
  return e.replace(/left|right|bottom|top/g, (t) => wE[t]);
}
function kE(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function fb(e) {
  return typeof e != "number" ? kE(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function al(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function ea(e, t, n) {
  return Math.floor(e / t) !== n;
}
function Qo(e, t) {
  return t < 0 || t >= e.current.length;
}
function Fa(e, t) {
  return Yt(e, {
    disabledIndices: t
  });
}
function Uu(e, t) {
  return Yt(e, {
    decrement: !0,
    startingIndex: e.current.length,
    disabledIndices: t
  });
}
function Yt(e, {
  startingIndex: t = -1,
  decrement: n = !1,
  disabledIndices: r,
  amount: o = 1
} = {}) {
  let i = t;
  do
    i += n ? -o : o;
  while (i >= 0 && i <= e.current.length - 1 && zr(e, i, r));
  return i;
}
function hb(e, {
  event: t,
  orientation: n,
  loopFocus: r,
  rtl: o,
  cols: i,
  disabledIndices: s,
  minIndex: a,
  maxIndex: l,
  prevIndex: c,
  stopEvent: u = !1
}) {
  let d = c;
  const f = [], h = {};
  let p = !1;
  {
    let y = null, b = -1;
    e.current.forEach((w, C) => {
      if (w == null)
        return;
      const x = w.closest('[role="row"]');
      x && (p = !0), (x !== y || b === -1) && (y = x, b += 1, f[b] = []), f[b].push(C), h[C] = b;
    });
  }
  const g = p && f.length > 0 && f.some((y) => y.length !== i);
  function v(y) {
    if (!g || c === -1)
      return;
    const b = h[c];
    if (b == null)
      return;
    const w = f[b].indexOf(c);
    let C = y === "up" ? b - 1 : b + 1;
    r && (C < 0 ? C = f.length - 1 : C >= f.length && (C = 0));
    const x = /* @__PURE__ */ new Set();
    for (; C >= 0 && C < f.length && !x.has(C); ) {
      x.add(C);
      const E = f[C];
      if (E.length === 0) {
        C = y === "up" ? C - 1 : C + 1;
        continue;
      }
      const S = Math.min(w, E.length - 1);
      for (let R = S; R >= 0; R -= 1) {
        const M = E[R];
        if (!zr(e, M, s))
          return M;
      }
      C = y === "up" ? C - 1 : C + 1, r && (C < 0 ? C = f.length - 1 : C >= f.length && (C = 0));
    }
  }
  if (t.key === Bd) {
    const y = v("up");
    if (y !== void 0)
      u && qt(t), d = y;
    else {
      if (u && qt(t), c === -1)
        d = l;
      else if (d = Yt(e, {
        startingIndex: d,
        amount: i,
        decrement: !0,
        disabledIndices: s
      }), r && (c - i < a || d < 0)) {
        const b = c % i, w = l % i, C = l - (w - b);
        w === b ? d = l : d = w > b ? C : C - i;
      }
      Qo(e, d) && (d = c);
    }
  }
  if (t.key === Ss) {
    const y = v("down");
    y !== void 0 ? (u && qt(t), d = y) : (u && qt(t), c === -1 ? d = a : (d = Yt(e, {
      startingIndex: c,
      amount: i,
      disabledIndices: s
    }), r && c + i > l && (d = Yt(e, {
      startingIndex: c % i - i,
      amount: i,
      disabledIndices: s
    }))), Qo(e, d) && (d = c));
  }
  if (n === "both") {
    const y = Ko(c / i);
    t.key === (o ? Hr : Wr) && (u && qt(t), c % i !== i - 1 ? (d = Yt(e, {
      startingIndex: c,
      disabledIndices: s
    }), r && ea(d, i, y) && (d = Yt(e, {
      startingIndex: c - c % i - 1,
      disabledIndices: s
    }))) : r && (d = Yt(e, {
      startingIndex: c - c % i - 1,
      disabledIndices: s
    })), ea(d, i, y) && (d = c)), t.key === (o ? Wr : Hr) && (u && qt(t), c % i !== 0 ? (d = Yt(e, {
      startingIndex: c,
      decrement: !0,
      disabledIndices: s
    }), r && ea(d, i, y) && (d = Yt(e, {
      startingIndex: c + (i - c % i),
      decrement: !0,
      disabledIndices: s
    }))) : r && (d = Yt(e, {
      startingIndex: c + (i - c % i),
      decrement: !0,
      disabledIndices: s
    })), ea(d, i, y) && (d = c));
    const b = Ko(l / i) === y;
    Qo(e, d) && (r && b ? d = t.key === (o ? Wr : Hr) ? l : Yt(e, {
      startingIndex: c - c % i - 1,
      disabledIndices: s
    }) : d = c);
  }
  return d;
}
function pb(e, t, n) {
  const r = [];
  let o = 0;
  return e.forEach(({
    width: i,
    height: s
  }, a) => {
    if (i > t && process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `[Floating UI]: Invalid grid - item width at index ${a} is greater than grid columns` : Ke(29, a));
    let l = !1;
    for (n && (o = 0); !l; ) {
      const c = [];
      for (let u = 0; u < i; u += 1)
        for (let d = 0; d < s; d += 1)
          c.push(o + u + d * t);
      o % t + i <= t && c.every((u) => r[u] == null) ? (c.forEach((u) => {
        r[u] = a;
      }), l = !0) : o += 1;
    }
  }), [...r];
}
function gb(e, t, n, r, o) {
  if (e === -1)
    return -1;
  const i = n.indexOf(e), s = t[e];
  switch (o) {
    case "tl":
      return i;
    case "tr":
      return s ? i + s.width - 1 : i;
    case "bl":
      return s ? i + (s.height - 1) * r : i;
    case "br":
      return n.lastIndexOf(e);
    default:
      return -1;
  }
}
function mb(e, t) {
  return t.flatMap((n, r) => e.includes(n) ? [r] : []);
}
function zr(e, t, n) {
  if (typeof n == "function")
    return n(t);
  if (n)
    return n.includes(t);
  const r = e.current[t];
  return r ? r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true" : !1;
}
/*!
* tabbable 6.4.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var PE = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], ll = /* @__PURE__ */ PE.join(","), vb = typeof Element > "u", ci = vb ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, cl = !vb && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, ul = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", s = i || n && t && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof t.closest == "function" ? t.closest("[inert]") : ul(t.parentNode));
  return s;
}, IE = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, bb = function(t, n, r) {
  if (ul(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(ll));
  return n && ci.call(t, ll) && o.unshift(t), o = o.filter(r), o;
}, dl = function(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var s = i.shift();
    if (!ul(s, !1))
      if (s.tagName === "SLOT") {
        var a = s.assignedElements(), l = a.length ? a : s.children, c = dl(l, !0, r);
        r.flatten ? o.push.apply(o, c) : o.push({
          scopeParent: s,
          candidates: c
        });
      } else {
        var u = ci.call(s, ll);
        u && r.filter(s) && (n || !t.includes(s)) && o.push(s);
        var d = s.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(s), f = !ul(d, !1) && (!r.shadowRootFilter || r.shadowRootFilter(s));
        if (d && f) {
          var h = dl(d === !0 ? s.children : d.children, !0, r);
          r.flatten ? o.push.apply(o, h) : o.push({
            scopeParent: s,
            candidates: h
          });
        } else
          i.unshift.apply(i, s.children);
      }
  }
  return o;
}, yb = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, xb = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || IE(t)) && !yb(t) ? 0 : t.tabIndex;
}, NE = function(t, n) {
  var r = xb(t);
  return r < 0 && n && !yb(t) ? 0 : r;
}, DE = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, wb = function(t) {
  return t.tagName === "INPUT";
}, AE = function(t) {
  return wb(t) && t.type === "hidden";
}, LE = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, $E = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, FE = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || cl(t), r = function(a) {
    return n.querySelectorAll('input[type="radio"][name="' + a + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (s) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
    }
  var i = $E(o, t.form);
  return !i || i === t;
}, VE = function(t) {
  return wb(t) && t.type === "radio";
}, BE = function(t) {
  return VE(t) && !FE(t);
}, HE = function(t) {
  var n, r = t && cl(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var s, a, l;
    for (i = !!((s = o) !== null && s !== void 0 && (a = s.ownerDocument) !== null && a !== void 0 && a.contains(o) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && o; ) {
      var c, u, d;
      r = cl(o), o = (c = r) === null || c === void 0 ? void 0 : c.host, i = !!((u = o) !== null && u !== void 0 && (d = u.ownerDocument) !== null && d !== void 0 && d.contains(o));
    }
  }
  return i;
}, vp = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, WE = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t) {
    var i = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !i;
  }
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var s = ci.call(t, "details>summary:first-of-type"), a = s ? t.parentElement : t;
  if (ci.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  r === "full-native" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var l = t; t; ) {
        var c = t.parentElement, u = cl(t);
        if (c && !c.shadowRoot && o(c) === !0)
          return vp(t);
        t.assignedSlot ? t = t.assignedSlot : !c && u !== t.ownerDocument ? t = u.host : t = c;
      }
      t = l;
    }
    if (HE(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return vp(t);
  return !1;
}, zE = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return ci.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Yu = function(t, n) {
  return !(n.disabled || AE(n) || WE(n, t) || // For a details element with a summary, the summary element gets the focus
  LE(n) || zE(n));
}, Gu = function(t, n) {
  return !(BE(n) || xb(n) < 0 || !Yu(t, n));
}, jE = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Cb = function(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var s = !!o.scopeParent, a = s ? o.scopeParent : o, l = NE(a, s), c = s ? Cb(o.candidates) : a;
    l === 0 ? s ? n.push.apply(n, c) : n.push(a) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: s,
      content: c
    });
  }), r.sort(DE).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, Ms = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = dl([t], n.includeContainer, {
    filter: Gu.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: jE
  }) : r = bb(t, n.includeContainer, Gu.bind(null, n)), Cb(r);
}, UE = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = dl([t], n.includeContainer, {
    filter: Yu.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = bb(t, n.includeContainer, Yu.bind(null, n)), r;
}, _b = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return ci.call(t, ll) === !1 ? !1 : Gu(n, t);
};
const Ci = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function Eb(e, t) {
  const n = Ms(e, Ci()), r = n.length;
  if (r === 0)
    return;
  const o = Bn(Nt(e)), i = n.indexOf(o), s = i === -1 ? t === 1 ? 0 : r - 1 : i + t;
  return n[s];
}
function Kl(e) {
  return Eb(Nt(e).body, 1) || e;
}
function Sb(e) {
  return Eb(Nt(e).body, -1) || e;
}
function Mb(e, t) {
  if (!e)
    return null;
  const n = Ms(Nt(e).body, Ci()), r = n.length;
  if (r === 0)
    return null;
  const o = n.indexOf(e);
  if (o === -1)
    return null;
  const i = (o + t + r) % r;
  return n[i];
}
function Ob(e) {
  return Mb(e, 1);
}
function Rb(e) {
  return Mb(e, -1);
}
function bo(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !Ve(n, r);
}
function YE(e) {
  Ms(e, Ci()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function bp(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
const GE = {
  ...m
};
let yp = 0;
function KE(e, t = "mui") {
  const [n, r] = m.useState(e), o = e || n;
  return m.useEffect(() => {
    n == null && (yp += 1, r(`${t}-${yp}`));
  }, [n, t]), o;
}
const xp = GE.useId;
function Do(e, t) {
  if (xp !== void 0) {
    const n = xp();
    return e ?? (t ? `${t}-${n}` : n);
  }
  return KE(e, t);
}
function Tb() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
    },
    off(t, n) {
      var r;
      (r = e.get(t)) == null || r.delete(n);
    }
  };
}
class Ud {
  constructor() {
    ae(this, "nodesRef", {
      current: []
    });
    ae(this, "events", Tb());
  }
  addNode(t) {
    this.nodesRef.current.push(t);
  }
  removeNode(t) {
    const n = this.nodesRef.current.findIndex((r) => r === t);
    n !== -1 && this.nodesRef.current.splice(n, 1);
  }
}
const Yd = /* @__PURE__ */ m.createContext(null);
process.env.NODE_ENV !== "production" && (Yd.displayName = "FloatingNodeContext");
const Gd = /* @__PURE__ */ m.createContext(null);
process.env.NODE_ENV !== "production" && (Gd.displayName = "FloatingTreeContext");
const ar = () => {
  var e;
  return ((e = m.useContext(Yd)) == null ? void 0 : e.id) || null;
}, Xr = (e) => {
  const t = m.useContext(Gd);
  return e ?? t;
};
function Kd(e) {
  const t = Do(), n = Xr(e), r = ar();
  return ge(() => {
    if (!t)
      return;
    const o = {
      id: t,
      parentId: r
    };
    return n == null || n.addNode(o), () => {
      n == null || n.removeNode(o);
    };
  }, [n, t, r]), t;
}
function kb(e) {
  const {
    children: t,
    id: n
  } = e, r = ar();
  return /* @__PURE__ */ _(Yd.Provider, {
    value: m.useMemo(() => ({
      id: n,
      parentId: r
    }), [n, r]),
    children: t
  });
}
function Pb(e) {
  const {
    children: t,
    externalTree: n
  } = e, r = rn(() => n ?? new Ud()).current;
  return /* @__PURE__ */ _(Gd.Provider, {
    value: r,
    children: t
  });
}
const _o = "none", Tn = "trigger-press", Dt = "trigger-hover", Jo = "trigger-focus", qd = "outside-press", ql = "item-press", qE = "close-press", _r = "focus-out", Os = "escape-key", Va = "list-navigation", XE = "cancel-open", ji = "sibling-open", ZE = "disabled", Xl = "imperative-action";
function ke(e, t, n, r) {
  let o = !1, i = !1;
  const s = r ?? Rt;
  return {
    reason: e,
    event: t ?? new Event("base-ui"),
    cancel() {
      o = !0;
    },
    allowPropagation() {
      i = !0;
    },
    get isCanceled() {
      return o;
    },
    get isPropagationAllowed() {
      return i;
    },
    trigger: n,
    ...s
  };
}
function ui(e) {
  return `data-base-ui-${e}`;
}
function Ba(e, t, n) {
  if (n && !Co(n))
    return 0;
  if (typeof e == "number")
    return e;
  if (typeof e == "function") {
    const r = e();
    return typeof r == "number" ? r : r == null ? void 0 : r[t];
  }
  return e == null ? void 0 : e[t];
}
const Xd = /* @__PURE__ */ m.createContext({
  hasProvider: !1,
  timeoutMs: 0,
  delayRef: {
    current: 0
  },
  initialDelayRef: {
    current: 0
  },
  timeout: new wr(),
  currentIdRef: {
    current: null
  },
  currentContextRef: {
    current: null
  }
});
process.env.NODE_ENV !== "production" && (Xd.displayName = "FloatingDelayGroupContext");
function QE(e) {
  const {
    children: t,
    delay: n,
    timeoutMs: r = 0
  } = e, o = m.useRef(n), i = m.useRef(n), s = m.useRef(null), a = m.useRef(null), l = un();
  return /* @__PURE__ */ _(Xd.Provider, {
    value: m.useMemo(() => ({
      hasProvider: !0,
      delayRef: o,
      initialDelayRef: i,
      currentIdRef: s,
      timeoutMs: r,
      currentContextRef: a,
      timeout: l
    }), [r, l]),
    children: t
  });
}
function JE(e, t = {
  open: !1
}) {
  const n = "rootStore" in e ? e.rootStore : e, r = n.useState("floatingId"), {
    enabled: o = !0,
    open: i
  } = t, s = m.useContext(Xd), {
    currentIdRef: a,
    delayRef: l,
    timeoutMs: c,
    initialDelayRef: u,
    currentContextRef: d,
    hasProvider: f,
    timeout: h
  } = s, [p, g] = m.useState(!1);
  return ge(() => {
    function v() {
      var y;
      g(!1), (y = d.current) == null || y.setIsInstantPhase(!1), a.current = null, d.current = null, l.current = u.current;
    }
    if (o && a.current && !i && a.current === r) {
      if (g(!1), c) {
        const y = r;
        return h.start(c, () => {
          n.select("open") || a.current && a.current !== y || v();
        }), () => {
          h.clear();
        };
      }
      v();
    }
  }, [o, i, r, a, l, c, u, d, h, n]), ge(() => {
    if (!o || !i)
      return;
    const v = d.current, y = a.current;
    h.clear(), d.current = {
      onOpenChange: n.setOpen,
      setIsInstantPhase: g
    }, a.current = r, l.current = {
      open: 0,
      close: Ba(u.current, "close")
    }, y !== null && y !== r ? (g(!0), v == null || v.setIsInstantPhase(!0), v == null || v.onOpenChange(!1, ke(_o))) : (g(!1), v == null || v.setIsInstantPhase(!1));
  }, [o, i, r, n, a, l, c, u, d, h]), ge(() => () => {
    d.current = null;
  }, [d]), m.useMemo(() => ({
    hasProvider: f,
    delayRef: l,
    isInstantPhase: p
  }), [f, l, p]);
}
const Ib = {
  clipPath: "inset(50%)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
}, Zd = {
  ...Ib,
  position: "fixed",
  top: 0,
  left: 0
}, eS = {
  ...Ib,
  position: "absolute"
}, ta = null;
let wp = globalThis.requestAnimationFrame;
class tS {
  constructor() {
    /* This implementation uses an array as a backing data-structure for frame callbacks.
     * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
     * never calls the native `cancelAnimationFrame` if there are no frames left. This can
     * be much more efficient if there is a call pattern that alterns as
     * "request-cancel-request-cancel-…".
     * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
     * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
    ae(this, "callbacks", []);
    ae(this, "callbacksCount", 0);
    ae(this, "nextId", 1);
    ae(this, "startId", 1);
    ae(this, "isScheduled", !1);
    ae(this, "tick", (t) => {
      var o;
      this.isScheduled = !1;
      const n = this.callbacks, r = this.callbacksCount;
      if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, r > 0)
        for (let i = 0; i < n.length; i += 1)
          (o = n[i]) == null || o.call(n, t);
    });
  }
  request(t) {
    const n = this.nextId;
    this.nextId += 1, this.callbacks.push(t), this.callbacksCount += 1;
    const r = process.env.NODE_ENV === "test" && wp !== requestAnimationFrame && (wp = requestAnimationFrame, !0);
    return (!this.isScheduled || r) && (requestAnimationFrame(this.tick), this.isScheduled = !0), n;
  }
  cancel(t) {
    const n = t - this.startId;
    n < 0 || n >= this.callbacks.length || (this.callbacks[n] = null, this.callbacksCount -= 1);
  }
}
const na = new tS();
class St {
  constructor() {
    ae(this, "currentId", ta);
    ae(this, "cancel", () => {
      this.currentId !== ta && (na.cancel(this.currentId), this.currentId = ta);
    });
    ae(this, "disposeEffect", () => this.cancel);
  }
  static create() {
    return new St();
  }
  static request(t) {
    return na.request(t);
  }
  static cancel(t) {
    return na.cancel(t);
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(t) {
    this.cancel(), this.currentId = na.request(() => {
      this.currentId = ta, t();
    });
  }
}
function Rs() {
  const e = rn(St.create).current;
  return zl(e.disposeEffect), e;
}
function Pn(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
const Er = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const [r, o] = m.useState();
  return ge(() => {
    ob && o("button");
  }, []), /* @__PURE__ */ _("span", {
    ...t,
    ref: n,
    style: Zd,
    "aria-hidden": r ? void 0 : !0,
    ...{
      tabIndex: 0,
      // Role is only for VoiceOver
      role: r
    },
    "data-base-ui-focus-guard": ""
  });
});
process.env.NODE_ENV !== "production" && (Er.displayName = "FocusGuard");
let Cp = 0;
function Ha(e, t = {}) {
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: o = !1
  } = t;
  r && cancelAnimationFrame(Cp);
  const i = () => e == null ? void 0 : e.focus({
    preventScroll: n
  });
  o ? i() : Cp = requestAnimationFrame(i);
}
const ei = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap(),
  none: /* @__PURE__ */ new WeakMap()
};
function _p(e) {
  return e === "inert" ? ei.inert : e === "aria-hidden" ? ei["aria-hidden"] : ei.none;
}
let ra = /* @__PURE__ */ new WeakSet(), oa = {}, Vc = 0;
const Nb = (e) => e && (e.host || Nb(e.parentNode)), nS = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = Nb(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null);
function rS(e, t, n, r) {
  const o = "data-base-ui-inert", i = r ? "inert" : n ? "aria-hidden" : null, s = nS(t, e), a = /* @__PURE__ */ new Set(), l = new Set(s), c = [];
  oa[o] || (oa[o] = /* @__PURE__ */ new WeakMap());
  const u = oa[o];
  s.forEach(d), f(t), a.clear();
  function d(h) {
    !h || a.has(h) || (a.add(h), h.parentNode && d(h.parentNode));
  }
  function f(h) {
    !h || l.has(h) || [].forEach.call(h.children, (p) => {
      if (Kr(p) !== "script")
        if (a.has(p))
          f(p);
        else {
          const g = i ? p.getAttribute(i) : null, v = g !== null && g !== "false", y = _p(i), b = (y.get(p) || 0) + 1, w = (u.get(p) || 0) + 1;
          y.set(p, b), u.set(p, w), c.push(p), b === 1 && v && ra.add(p), w === 1 && p.setAttribute(o, ""), !v && i && p.setAttribute(i, i === "inert" ? "" : "true");
        }
    });
  }
  return Vc += 1, () => {
    c.forEach((h) => {
      const p = _p(i), v = (p.get(h) || 0) - 1, y = (u.get(h) || 0) - 1;
      p.set(h, v), u.set(h, y), v || (!ra.has(h) && i && h.removeAttribute(i), ra.delete(h)), y || h.removeAttribute(o);
    }), Vc -= 1, Vc || (ei.inert = /* @__PURE__ */ new WeakMap(), ei["aria-hidden"] = /* @__PURE__ */ new WeakMap(), ei.none = /* @__PURE__ */ new WeakMap(), ra = /* @__PURE__ */ new WeakSet(), oa = {});
  };
}
function oS(e, t = !1, n = !1) {
  const r = Nt(e[0]).body;
  return rS(e.concat(Array.from(r.querySelectorAll("[aria-live]"))), r, t, n);
}
const Qd = /* @__PURE__ */ m.createContext(null);
process.env.NODE_ENV !== "production" && (Qd.displayName = "PortalContext");
const Db = () => m.useContext(Qd), iS = ui("portal");
function Ab(e = {}) {
  const {
    ref: t,
    container: n,
    componentProps: r = Rt,
    elementProps: o,
    elementState: i
  } = e, s = Do(), a = Db(), l = a == null ? void 0 : a.portalNode, [c, u] = m.useState(null), [d, f] = m.useState(null), h = ve((y) => {
    y !== null && f(y);
  }), p = m.useRef(null);
  ge(() => {
    if (n === null) {
      p.current && (p.current = null, f(null), u(null));
      return;
    }
    if (s == null)
      return;
    const y = (n && (Fd(n) ? n : n.current)) ?? l ?? document.body;
    if (y == null) {
      p.current && (p.current = null, f(null), u(null));
      return;
    }
    p.current !== y && (p.current = y, f(null), u(y));
  }, [n, l, s]);
  const g = Ie("div", r, {
    ref: [t, h],
    state: i,
    props: [{
      id: s,
      [iS]: ""
    }, o]
  });
  return {
    portalNode: d,
    portalSubtree: c && g ? /* @__PURE__ */ nn.createPortal(g, c) : null
  };
}
const Zl = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    children: r,
    container: o,
    className: i,
    render: s,
    renderGuards: a,
    ...l
  } = t, {
    portalNode: c,
    portalSubtree: u
  } = Ab({
    container: o,
    ref: n,
    componentProps: t,
    elementProps: l
  }), d = m.useRef(null), f = m.useRef(null), h = m.useRef(null), p = m.useRef(null), [g, v] = m.useState(null), y = g == null ? void 0 : g.modal, b = g == null ? void 0 : g.open, w = typeof a == "boolean" ? a : !!g && !g.modal && g.open && !!c;
  m.useEffect(() => {
    if (!c || y)
      return;
    function x(E) {
      c && E.relatedTarget && bo(E) && (E.type === "focusin" ? bp : YE)(c);
    }
    return c.addEventListener("focusin", x, !0), c.addEventListener("focusout", x, !0), () => {
      c.removeEventListener("focusin", x, !0), c.removeEventListener("focusout", x, !0);
    };
  }, [c, y]), m.useEffect(() => {
    !c || b || bp(c);
  }, [b, c]);
  const C = m.useMemo(() => ({
    beforeOutsideRef: d,
    afterOutsideRef: f,
    beforeInsideRef: h,
    afterInsideRef: p,
    portalNode: c,
    setFocusManagerState: v
  }), [c]);
  return /* @__PURE__ */ Z(m.Fragment, {
    children: [u, /* @__PURE__ */ Z(Qd.Provider, {
      value: C,
      children: [w && c && /* @__PURE__ */ _(Er, {
        "data-type": "outside",
        ref: d,
        onFocus: (x) => {
          var E;
          if (bo(x, c))
            (E = h.current) == null || E.focus();
          else {
            const S = g ? g.domReference : null, R = Sb(S);
            R == null || R.focus();
          }
        }
      }), w && c && /* @__PURE__ */ _("span", {
        "aria-owns": c.id,
        style: v_
      }), c && /* @__PURE__ */ nn.createPortal(r, c), w && c && /* @__PURE__ */ _(Er, {
        "data-type": "outside",
        ref: f,
        onFocus: (x) => {
          var E;
          if (bo(x, c))
            (E = p.current) == null || E.focus();
          else {
            const S = g ? g.domReference : null, R = Kl(S);
            R == null || R.focus(), g != null && g.closeOnFocusOut && (g == null || g.onOpenChange(!1, ke(_r, x.nativeEvent)));
          }
        }
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (Zl.displayName = "FloatingPortal");
function pr(e) {
  return e == null ? e : "current" in e ? e.current : e;
}
function sS(e, t) {
  const n = Wt(e.target);
  return e instanceof n.KeyboardEvent ? "keyboard" : e instanceof n.FocusEvent ? t || "keyboard" : "pointerType" in e ? e.pointerType || "keyboard" : "touches" in e ? "touch" : e instanceof n.MouseEvent ? t || (e.detail === 0 ? "keyboard" : "mouse") : "";
}
const Ep = 20;
let Lr = [];
function Jd() {
  Lr = Lr.filter((e) => e.isConnected);
}
function aS(e) {
  Jd(), e && Kr(e) !== "body" && (Lr.push(e), Lr.length > Ep && (Lr = Lr.slice(-Ep)));
}
function Bc() {
  return Jd(), Lr[Lr.length - 1];
}
function lS(e) {
  if (!e)
    return null;
  const t = Ci();
  return _b(e, t) ? e : Ms(e, t)[0] || e;
}
function cS(e) {
  return !e || !e.isConnected ? !1 : typeof e.checkVisibility == "function" ? e.checkVisibility() : wn(e).display !== "none";
}
function Sp(e, t) {
  var s;
  if (!t.current.includes("floating") && !((s = e.getAttribute("role")) != null && s.includes("dialog")))
    return;
  const n = Ci(), o = UE(e, n).filter((a) => {
    const l = a.getAttribute("data-tabindex") || "";
    return _b(a, n) || a.hasAttribute("data-tabindex") && !l.startsWith("-");
  }), i = e.getAttribute("tabindex");
  t.current.includes("floating") || o.length === 0 ? i !== "0" && e.setAttribute("tabindex", "0") : (i !== "-1" || e.hasAttribute("data-tabindex") && e.getAttribute("data-tabindex") !== "-1") && (e.setAttribute("tabindex", "-1"), e.setAttribute("data-tabindex", "-1"));
}
function ef(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    order: o = ["content"],
    initialFocus: i = !0,
    returnFocus: s = !0,
    restoreFocus: a = !1,
    modal: l = !0,
    closeOnFocusOut: c = !0,
    openInteractionType: u = "",
    getInsideElements: d = () => [],
    nextFocusableElement: f,
    previousFocusableElement: h,
    beforeContentFocusGuardRef: p,
    externalTree: g
  } = e, v = "rootStore" in t ? t.rootStore : t, y = v.useState("open"), b = v.useState("domReferenceElement"), w = v.useState("floatingElement"), {
    events: C,
    dataRef: x
  } = v.context, E = ve(() => {
    var ee;
    return (ee = x.current.floatingContext) == null ? void 0 : ee.nodeId;
  }), S = ve(d), R = i === !1, M = Wu(b) && R, I = Gt(o), P = Gt(i), k = Gt(s), O = Gt(u), F = Xr(g), T = Db(), L = m.useRef(null), A = m.useRef(null), N = m.useRef(!1), B = m.useRef(!1), $ = m.useRef(!1), U = m.useRef(-1), G = m.useRef(""), H = m.useRef(""), q = m.useRef(null), j = m.useRef(null), W = xr(q, p, T == null ? void 0 : T.beforeInsideRef), z = xr(j, T == null ? void 0 : T.afterInsideRef), X = un(), J = un(), ne = Rs(), Q = T != null, D = ol(w), te = ve((ee = D) => ee ? Ms(ee, Ci()) : []), K = ve((ee) => {
    const re = te(ee);
    return I.current.map(() => re).filter(Boolean).flat();
  });
  m.useEffect(() => {
    if (r || !l)
      return;
    function ee(le) {
      le.key === "Tab" && Ve(D, Bn(Nt(D))) && te().length === 0 && !M && qt(le);
    }
    const re = Nt(D);
    return re.addEventListener("keydown", ee), () => {
      re.removeEventListener("keydown", ee);
    };
  }, [r, b, D, l, I, M, te, K]), m.useEffect(() => {
    if (r || !w)
      return;
    function ee(re) {
      const le = Xt(re), be = te().indexOf(le);
      be !== -1 && (U.current = be);
    }
    return w.addEventListener("focusin", ee), () => {
      w.removeEventListener("focusin", ee);
    };
  }, [r, w, te]), m.useEffect(() => {
    if (r || !y)
      return;
    const ee = Nt(D);
    function re() {
      $.current = !1;
    }
    function le(be) {
      const ye = Xt(be), Ce = Ve(w, ye) || Ve(b, ye) || Ve(T == null ? void 0 : T.portalNode, ye);
      $.current = !Ce, H.current = be.pointerType || "keyboard";
    }
    function de() {
      H.current = "keyboard";
    }
    return ee.addEventListener("pointerdown", le, !0), ee.addEventListener("pointerup", re, !0), ee.addEventListener("pointercancel", re, !0), ee.addEventListener("keydown", de, !0), () => {
      ee.removeEventListener("pointerdown", le, !0), ee.removeEventListener("pointerup", re, !0), ee.removeEventListener("pointercancel", re, !0), ee.removeEventListener("keydown", de, !0);
    };
  }, [r, w, b, D, y, T]), m.useEffect(() => {
    if (r || !c)
      return;
    function ee() {
      B.current = !0, J.start(0, () => {
        B.current = !1;
      });
    }
    function re(ye) {
      const Ce = ye.relatedTarget, ie = ye.currentTarget, he = Xt(ye);
      queueMicrotask(() => {
        const fe = E(), Se = v.context.triggerElements, Me = (Ce == null ? void 0 : Ce.hasAttribute(ui("focus-guard"))) && [q.current, j.current, T == null ? void 0 : T.beforeInsideRef.current, T == null ? void 0 : T.afterInsideRef.current, T == null ? void 0 : T.beforeOutsideRef.current, T == null ? void 0 : T.afterOutsideRef.current, pr(h), pr(f)].includes(Ce), $e = !(Ve(b, Ce) || Ve(w, Ce) || Ve(Ce, w) || Ve(T == null ? void 0 : T.portalNode, Ce) || Ce != null && Se.hasElement(Ce) || Se.hasMatchingElement((Ne) => Ve(Ne, Ce)) || Me || F && (vo(F.nodesRef.current, fe).find((Ne) => {
          var Fe, Ae;
          return Ve((Fe = Ne.context) == null ? void 0 : Fe.elements.floating, Ce) || Ve((Ae = Ne.context) == null ? void 0 : Ae.elements.domReference, Ce);
        }) || pp(F.nodesRef.current, fe).find((Ne) => {
          var Fe, Ae, bt;
          return [(Fe = Ne.context) == null ? void 0 : Fe.elements.floating, ol((Ae = Ne.context) == null ? void 0 : Ae.elements.floating)].includes(Ce) || ((bt = Ne.context) == null ? void 0 : bt.elements.domReference) === Ce;
        })));
        if (ie === b && D && Sp(D, I), a && ie !== b && !cS(he) && Bn(Nt(D)) === Nt(D).body) {
          if (gt(D) && (D.focus(), a === "popup")) {
            ne.request(() => {
              D.focus();
            });
            return;
          }
          const Ne = U.current, Fe = te(), Ae = Fe[Ne] || Fe[Fe.length - 1] || D;
          gt(Ae) && Ae.focus();
        }
        if (x.current.insideReactTree) {
          x.current.insideReactTree = !1;
          return;
        }
        (M || !l) && Ce && $e && !B.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        // For an "untrapped" typeable combobox (input role=combobox with
        // initialFocus=false), re-opening the popup and tabbing out should still close it even
        // when the previously focused element (e.g. the next tabbable outside the popup) is
        // focused again. Otherwise, the popup remains open on the second Tab sequence:
        // click input -> Tab (closes) -> click input -> Tab.
        // Allow closing when `isUntrappedTypeableCombobox` regardless of the previously focused element.
        (M || Ce !== Bc()) && (N.current = !0, v.setOpen(!1, ke(_r, ye)));
      });
    }
    function le() {
      $.current || (x.current.insideReactTree = !0, X.start(0, () => {
        x.current.insideReactTree = !1;
      }));
    }
    const de = gt(b) ? b : null, be = [];
    if (!(!w && !de))
      return de && (de.addEventListener("focusout", re), de.addEventListener("pointerdown", ee), be.push(() => {
        de.removeEventListener("focusout", re), de.removeEventListener("pointerdown", ee);
      })), w && (w.addEventListener("focusout", re), T && (w.addEventListener("focusout", le, !0), be.push(() => {
        w.removeEventListener("focusout", le, !0);
      })), be.push(() => {
        w.removeEventListener("focusout", re);
      })), () => {
        be.forEach((ye) => {
          ye();
        });
      };
  }, [r, b, w, D, l, F, T, v, c, a, te, M, E, I, x, X, J, ne, f, h]), m.useEffect(() => {
    var ye, Ce, ie;
    if (r || !w || !y)
      return;
    const ee = Array.from(((ye = T == null ? void 0 : T.portalNode) == null ? void 0 : ye.querySelectorAll(`[${ui("portal")}]`)) || []), le = (ie = (Ce = (F ? pp(F.nodesRef.current, E()) : []).find((he) => {
      var fe;
      return Wu(((fe = he.context) == null ? void 0 : fe.elements.domReference) || null);
    })) == null ? void 0 : Ce.context) == null ? void 0 : ie.elements.domReference, de = [w, le, ...ee, ...S(), L.current, A.current, q.current, j.current, T == null ? void 0 : T.beforeOutsideRef.current, T == null ? void 0 : T.afterOutsideRef.current, pr(h), pr(f), M ? b : null].filter((he) => he != null), be = oS(de, l || M);
    return () => {
      be();
    };
  }, [y, r, b, w, l, I, T, M, F, E, S, f, h]), ge(() => {
    if (!y || r || !gt(D))
      return;
    const ee = Nt(D), re = Bn(ee);
    queueMicrotask(() => {
      const le = K(D), de = P.current, be = typeof de == "function" ? de(O.current || "") : de;
      if (be === void 0 || be === !1)
        return;
      let ye;
      be === !0 || be === null ? ye = le[0] || D : ye = pr(be), ye = ye || le[0] || D, !Ve(D, re) && Ha(ye, {
        preventScroll: ye === D
      });
    });
  }, [r, y, D, R, K, P, O]), ge(() => {
    if (r || !D)
      return;
    const ee = Nt(D), re = Bn(ee);
    aS(re);
    function le(ye) {
      if (ye.open || (G.current = sS(ye.nativeEvent, H.current)), ye.reason === Dt && ye.nativeEvent.type === "mouseleave" && (N.current = !0), ye.reason === qd)
        if (ye.nested)
          N.current = !1;
        else if (cb(ye.nativeEvent) || ub(ye.nativeEvent))
          N.current = !1;
        else {
          let Ce = !1;
          document.createElement("div").focus({
            get preventScroll() {
              return Ce = !0, !1;
            }
          }), Ce ? N.current = !1 : N.current = !0;
        }
    }
    C.on("openchange", le);
    const de = ee.createElement("span");
    de.setAttribute("tabindex", "-1"), de.setAttribute("aria-hidden", "true"), Object.assign(de.style, Zd), Q && b && b.insertAdjacentElement("afterend", de);
    function be() {
      const ye = k.current;
      let Ce = typeof ye == "function" ? ye(G.current) : ye;
      if (Ce === void 0 || Ce === !1)
        return null;
      if (Ce === null && (Ce = !0), typeof Ce == "boolean") {
        const he = b || Bc();
        return he && he.isConnected ? he : de;
      }
      const ie = b || Bc() || de;
      return pr(Ce) || ie;
    }
    return () => {
      C.off("openchange", le);
      const ye = Bn(ee), Ce = Ve(w, ye) || F && vo(F.nodesRef.current, E(), !1).some((he) => {
        var fe;
        return Ve((fe = he.context) == null ? void 0 : fe.elements.floating, ye);
      }), ie = be();
      queueMicrotask(() => {
        const he = lS(ie), fe = typeof k.current != "boolean";
        // eslint-disable-next-line react-hooks/exhaustive-deps
        k.current && !N.current && gt(he) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(!fe && he !== ye && ye !== ee.body) || Ce) && he.focus({
          preventScroll: !0
        }), de.remove();
      });
    };
  }, [r, w, D, k, x, C, F, Q, b, E]), m.useEffect(() => {
    queueMicrotask(() => {
      N.current = !1;
    });
  }, [r]), m.useEffect(() => {
    if (r || !y)
      return;
    function ee(le) {
      const de = Xt(le);
      de != null && de.closest(`[${Dd}]`) && (B.current = !0);
    }
    const re = Nt(D);
    return re.addEventListener("pointerdown", ee, !0), () => {
      re.removeEventListener("pointerdown", ee, !0);
    };
  }, [r, y, D]), ge(() => {
    if (!r && T)
      return T.setFocusManagerState({
        modal: l,
        closeOnFocusOut: c,
        open: y,
        onOpenChange: v.setOpen,
        domReference: b
      }), () => {
        T.setFocusManagerState(null);
      };
  }, [r, T, l, y, v, c, b]), ge(() => {
    if (!(r || !D))
      return Sp(D, I), () => {
        queueMicrotask(Jd);
      };
  }, [r, D, I]);
  const ce = !r && (l ? !M : !0) && (Q || l);
  return /* @__PURE__ */ Z(m.Fragment, {
    children: [ce && /* @__PURE__ */ _(Er, {
      "data-type": "inside",
      ref: W,
      onFocus: (ee) => {
        var re;
        if (l) {
          const le = K();
          Ha(le[le.length - 1]);
        } else if (T != null && T.portalNode)
          if (N.current = !1, bo(ee, T.portalNode)) {
            const le = Kl(b);
            le == null || le.focus();
          } else
            (re = pr(h ?? T.beforeOutsideRef)) == null || re.focus();
      }
    }), n, ce && /* @__PURE__ */ _(Er, {
      "data-type": "inside",
      ref: z,
      onFocus: (ee) => {
        var re;
        if (l)
          Ha(K()[0]);
        else if (T != null && T.portalNode)
          if (c && (N.current = !0), bo(ee, T.portalNode)) {
            const le = Sb(b);
            le == null || le.focus();
          } else
            (re = pr(f ?? T.afterOutsideRef)) == null || re.focus();
      }
    })]
  });
}
function Ql(e, t = {}) {
  const n = "rootStore" in e ? e.rootStore : e, r = n.context.dataRef, {
    enabled: o = !0,
    event: i = "click",
    toggle: s = !0,
    ignoreMouse: a = !1,
    stickIfOpen: l = !0,
    touchOpenDelay: c = 0
  } = t, u = m.useRef(void 0), d = Rs(), f = un(), h = m.useMemo(() => ({
    onPointerDown(p) {
      u.current = p.pointerType;
    },
    onMouseDown(p) {
      const g = u.current, v = p.nativeEvent, y = n.select("open");
      if (p.button !== 0 || i === "click" || Co(g, !0) && a)
        return;
      const b = r.current.openEvent, w = b == null ? void 0 : b.type, C = n.select("domReferenceElement") !== p.currentTarget, x = y && C || !(y && s && (!(b && l) || w === "click" || w === "mousedown"));
      if (Hd(v.target)) {
        const S = ke(Tn, v, v.target);
        x && g === "touch" && c > 0 ? f.start(c, () => {
          n.setOpen(!0, S);
        }) : n.setOpen(x, S);
        return;
      }
      const E = p.currentTarget;
      d.request(() => {
        const S = ke(Tn, v, E);
        x && g === "touch" && c > 0 ? f.start(c, () => {
          n.setOpen(!0, S);
        }) : n.setOpen(x, S);
      });
    },
    onClick(p) {
      if (i === "mousedown-only")
        return;
      const g = u.current;
      if (i === "mousedown" && g) {
        u.current = void 0;
        return;
      }
      if (Co(g, !0) && a)
        return;
      const v = n.select("open"), y = r.current.openEvent, b = n.select("domReferenceElement") !== p.currentTarget, w = v && b || !(v && s && (!(y && l) || db(y))), C = ke(Tn, p.nativeEvent, p.currentTarget);
      w && g === "touch" && c > 0 ? f.start(c, () => {
        n.setOpen(!0, C);
      }) : n.setOpen(w, C);
    },
    onKeyDown() {
      u.current = void 0;
    }
  }), [r, i, a, n, l, s, d, f, c]);
  return m.useMemo(() => o ? {
    reference: h
  } : Rt, [o, h]);
}
function uS(e, t) {
  let n = null, r = null, o = !1;
  return {
    contextElement: e || void 0,
    getBoundingClientRect() {
      var h;
      const i = (e == null ? void 0 : e.getBoundingClientRect()) || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      }, s = t.axis === "x" || t.axis === "both", a = t.axis === "y" || t.axis === "both", l = ["mouseenter", "mousemove"].includes(((h = t.dataRef.current.openEvent) == null ? void 0 : h.type) || "") && t.pointerType !== "touch";
      let c = i.width, u = i.height, d = i.x, f = i.y;
      return n == null && t.x && s && (n = i.x - t.x), r == null && t.y && a && (r = i.y - t.y), d -= n || 0, f -= r || 0, c = 0, u = 0, !o || l ? (c = t.axis === "y" ? i.width : 0, u = t.axis === "x" ? i.height : 0, d = s && t.x != null ? t.x : d, f = a && t.y != null ? t.y : f) : o && !l && (u = t.axis === "x" ? i.height : u, c = t.axis === "y" ? i.width : c), o = !0, {
        width: c,
        height: u,
        x: d,
        y: f,
        top: f,
        right: d + c,
        bottom: f + u,
        left: d
      };
    }
  };
}
function Mp(e) {
  return e != null && e.clientX != null;
}
function dS(e, t = {}) {
  const n = "rootStore" in e ? e.rootStore : e, r = n.useState("open"), o = n.useState("floatingElement"), i = n.useState("domReferenceElement"), s = n.context.dataRef, {
    enabled: a = !0,
    axis: l = "both",
    x: c = null,
    y: u = null
  } = t, d = m.useRef(!1), f = m.useRef(null), [h, p] = m.useState(), [g, v] = m.useState([]), y = ve((E, S, R) => {
    d.current || s.current.openEvent && !Mp(s.current.openEvent) || n.set("positionReference", uS(R ?? i, {
      x: E,
      y: S,
      axis: l,
      dataRef: s,
      pointerType: h
    }));
  }), b = ve((E) => {
    c != null || u != null || (r ? f.current || v([]) : y(E.clientX, E.clientY, E.currentTarget));
  }), w = Co(h) ? o : r, C = m.useCallback(() => {
    if (!w || !a || c != null || u != null)
      return;
    const E = Wt(o);
    function S(R) {
      const M = Xt(R);
      Ve(o, M) ? (E.removeEventListener("mousemove", S), f.current = null) : y(R.clientX, R.clientY);
    }
    if (!s.current.openEvent || Mp(s.current.openEvent)) {
      E.addEventListener("mousemove", S);
      const R = () => {
        E.removeEventListener("mousemove", S), f.current = null;
      };
      return f.current = R, R;
    }
    n.set("positionReference", i);
  }, [w, a, c, u, o, s, i, n, y]);
  m.useEffect(() => C(), [C, g]), m.useEffect(() => {
    a && !o && (d.current = !1);
  }, [a, o]), m.useEffect(() => {
    !a && r && (d.current = !0);
  }, [a, r]), ge(() => {
    a && (c != null || u != null) && (d.current = !1, y(c, u));
  }, [a, c, u, y]);
  const x = m.useMemo(() => {
    function E(S) {
      p(S.pointerType);
    }
    return {
      onPointerDown: E,
      onPointerEnter: E,
      onMouseMove: b,
      onMouseEnter: b
    };
  }, [b]);
  return m.useMemo(() => a ? {
    reference: x,
    trigger: x
  } : {}, [a, x]);
}
function Op(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = On(t), s = jd(t), a = zd(s), l = cn(t), c = i === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[a] / 2 - o[a] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (qr(t)) {
    case "start":
      h[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[s] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const fS = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = i.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = Op(c, r, l), f = r, h = {}, p = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: v,
      fn: y
    } = a[g], {
      x: b,
      y: w,
      data: C,
      reset: x
    } = await y({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: h,
      rects: c,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = b ?? u, d = w ?? d, h = {
      ...h,
      [v]: {
        ...h[v],
        ...C
      }
    }, x && p <= 50 && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (c = x.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : x.rects), {
      x: u,
      y: d
    } = Op(c, f, l)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: h
  };
};
async function us(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Cr(t, e), p = fb(h), v = a[f ? d === "floating" ? "reference" : "floating" : d], y = al(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(v))) == null || n ? v : v.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), b = d === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), C = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = al(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: b,
    offsetParent: w,
    strategy: l
  }) : b);
  return {
    top: (y.top - x.top + p.top) / C.y,
    bottom: (x.bottom - y.bottom + p.bottom) / C.y,
    left: (y.left - x.left + p.left) / C.x,
    right: (x.right - y.right + p.right) / C.x
  };
}
const hS = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: g = !0,
        ...v
      } = Cr(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const y = cn(o), b = On(a), w = cn(a) === a, C = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), x = f || (w || !g ? [sl(a)] : SE(a)), E = p !== "none";
      !f && E && x.push(...TE(a, g, p, C));
      const S = [a, ...x], R = await us(t, v), M = [];
      let I = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && M.push(R[y]), d) {
        const F = EE(o, s, C);
        M.push(R[F[0]], R[F[1]]);
      }
      if (I = [...I, {
        placement: o,
        overflows: M
      }], !M.every((F) => F <= 0)) {
        var P, k;
        const F = (((P = i.flip) == null ? void 0 : P.index) || 0) + 1, T = S[F];
        if (T && (!(d === "alignment" ? b !== On(T) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        I.every((N) => On(N.placement) === b ? N.overflows[0] > 0 : !0)))
          return {
            data: {
              index: F,
              overflows: I
            },
            reset: {
              placement: T
            }
          };
        let L = (k = I.filter((A) => A.overflows[0] <= 0).sort((A, N) => A.overflows[1] - N.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!L)
          switch (h) {
            case "bestFit": {
              var O;
              const A = (O = I.filter((N) => {
                if (E) {
                  const B = On(N.placement);
                  return B === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  B === "y";
                }
                return !0;
              }).map((N) => [N.placement, N.overflows.filter((B) => B > 0).reduce((B, $) => B + $, 0)]).sort((N, B) => N[1] - B[1])[0]) == null ? void 0 : O[0];
              A && (L = A);
              break;
            }
            case "initialPlacement":
              L = a;
              break;
          }
        if (o !== L)
          return {
            reset: {
              placement: L
            }
          };
      }
      return {};
    }
  };
};
function Rp(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Tp(e) {
  return xE.some((t) => e[t] >= 0);
}
const pS = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = Cr(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await us(t, {
            ...o,
            elementContext: "reference"
          }), s = Rp(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Tp(s)
            }
          };
        }
        case "escaped": {
          const i = await us(t, {
            ...o,
            altBoundary: !0
          }), s = Rp(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Tp(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Lb = /* @__PURE__ */ new Set(["left", "top"]);
async function gS(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = cn(n), a = qr(n), l = On(n) === "y", c = Lb.has(s) ? -1 : 1, u = i && l ? -1 : 1, d = Cr(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof p == "number" && (h = a === "end" ? p * -1 : p), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const mS = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: a
      } = t, l = await gS(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, vS = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (v) => {
            let {
              x: y,
              y: b
            } = v;
            return {
              x: y,
              y: b
            };
          }
        },
        ...l
      } = Cr(e, t), c = {
        x: n,
        y: r
      }, u = await us(t, l), d = On(cn(o)), f = Wd(d);
      let h = c[f], p = c[d];
      if (i) {
        const v = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", b = h + u[v], w = h - u[y];
        h = zu(b, h, w);
      }
      if (s) {
        const v = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", b = p + u[v], w = p - u[y];
        p = zu(b, p, w);
      }
      const g = a.fn({
        ...t,
        [f]: h,
        [d]: p
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r,
          enabled: {
            [f]: i,
            [d]: s
          }
        }
      };
    }
  };
}, bS = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = Cr(e, t), u = {
        x: n,
        y: r
      }, d = On(o), f = Wd(d);
      let h = u[f], p = u[d];
      const g = Cr(a, t), v = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const w = f === "y" ? "height" : "width", C = i.reference[f] - i.floating[w] + v.mainAxis, x = i.reference[f] + i.reference[w] - v.mainAxis;
        h < C ? h = C : h > x && (h = x);
      }
      if (c) {
        var y, b;
        const w = f === "y" ? "width" : "height", C = Lb.has(cn(o)), x = i.reference[d] - i.floating[w] + (C && ((y = s.offset) == null ? void 0 : y[d]) || 0) + (C ? 0 : v.crossAxis), E = i.reference[d] + i.reference[w] + (C ? 0 : ((b = s.offset) == null ? void 0 : b[d]) || 0) - (C ? v.crossAxis : 0);
        p < x ? p = x : p > E && (p = E);
      }
      return {
        [f]: h,
        [d]: p
      };
    }
  };
}, yS = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: a
      } = t, {
        apply: l = () => {
        },
        ...c
      } = Cr(e, t), u = await us(t, c), d = cn(o), f = qr(o), h = On(o) === "y", {
        width: p,
        height: g
      } = i.floating;
      let v, y;
      d === "top" || d === "bottom" ? (v = d, y = f === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (y = d, v = f === "end" ? "top" : "bottom");
      const b = g - u.top - u.bottom, w = p - u.left - u.right, C = li(g - u[v], b), x = li(p - u[y], w), E = !t.middlewareData.shift;
      let S = C, R = x;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (R = w), (r = t.middlewareData.shift) != null && r.enabled.y && (S = b), E && !f) {
        const I = mn(u.left, 0), P = mn(u.right, 0), k = mn(u.top, 0), O = mn(u.bottom, 0);
        h ? R = p - 2 * (I !== 0 || P !== 0 ? I + P : mn(u.left, u.right)) : S = g - 2 * (k !== 0 || O !== 0 ? k + O : mn(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: R,
        availableHeight: S
      });
      const M = await s.getDimensions(a.floating);
      return p !== M.width || g !== M.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function $b(e) {
  const t = wn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = gt(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, a = il(n) !== i || il(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function tf(e) {
  return qe(e) ? e : e.contextElement;
}
function ti(e) {
  const t = tf(e);
  if (!gt(t))
    return er(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = $b(t);
  let s = (i ? il(n.width) : n.width) / r, a = (i ? il(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const xS = /* @__PURE__ */ er(0);
function Fb(e) {
  const t = Wt(e);
  return !Yl() || !t.visualViewport ? xS : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function wS(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Wt(e) ? !1 : t;
}
function Eo(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = tf(e);
  let s = er(1);
  t && (r ? qe(r) && (s = ti(r)) : s = ti(e));
  const a = wS(i, n, r) ? Fb(i) : er(0);
  let l = (o.left + a.x) / s.x, c = (o.top + a.y) / s.y, u = o.width / s.x, d = o.height / s.y;
  if (i) {
    const f = Wt(i), h = r && qe(r) ? Wt(r) : r;
    let p = f, g = Vu(p);
    for (; g && r && h !== p; ) {
      const v = ti(g), y = g.getBoundingClientRect(), b = wn(g), w = y.left + (g.clientLeft + parseFloat(b.paddingLeft)) * v.x, C = y.top + (g.clientTop + parseFloat(b.paddingTop)) * v.y;
      l *= v.x, c *= v.y, u *= v.x, d *= v.y, l += w, c += C, p = Wt(g), g = Vu(p);
    }
  }
  return al({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function Jl(e, t) {
  const n = Gl(e).scrollLeft;
  return t ? t.left + n : Eo(sr(e)).left + n;
}
function Vb(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Jl(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function CS(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = sr(r), a = t ? Ul(t.floating) : !1;
  if (r === s || a && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = er(1);
  const u = er(0), d = gt(r);
  if ((d || !d && !i) && ((Kr(r) !== "body" || No(s)) && (l = Gl(r)), gt(r))) {
    const h = Eo(r);
    c = ti(r), u.x = h.x + r.clientLeft, u.y = h.y + r.clientTop;
  }
  const f = s && !d && !i ? Vb(s, l) : er(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + f.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + f.y
  };
}
function _S(e) {
  return Array.from(e.getClientRects());
}
function ES(e) {
  const t = sr(e), n = Gl(e), r = e.ownerDocument.body, o = mn(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = mn(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Jl(e);
  const a = -n.scrollTop;
  return wn(r).direction === "rtl" && (s += mn(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
const kp = 25;
function SS(e, t) {
  const n = Wt(e), r = sr(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    const u = Yl();
    (!u || u && t === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  const c = Jl(r);
  if (c <= 0) {
    const u = r.ownerDocument, d = u.body, f = getComputedStyle(d), h = u.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, p = Math.abs(r.clientWidth - d.clientWidth - h);
    p <= kp && (i -= p);
  } else
    c <= kp && (i += c);
  return {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
const MS = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function OS(e, t) {
  const n = Eo(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = gt(e) ? ti(e) : er(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function Pp(e, t, n) {
  let r;
  if (t === "viewport")
    r = SS(e, n);
  else if (t === "document")
    r = ES(sr(e));
  else if (qe(t))
    r = OS(t, n);
  else {
    const o = Fb(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return al(r);
}
function Bb(e, t) {
  const n = nr(e);
  return n === t || !qe(n) || Jn(n) ? !1 : wn(n).position === "fixed" || Bb(n, t);
}
function RS(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Br(e, [], !1).filter((a) => qe(a) && Kr(a) !== "body"), o = null;
  const i = wn(e).position === "fixed";
  let s = i ? nr(e) : e;
  for (; qe(s) && !Jn(s); ) {
    const a = wn(s), l = Vd(s);
    !l && a.position === "fixed" && (o = null), (i ? !l && !o : !l && a.position === "static" && !!o && MS.has(o.position) || No(s) && !l && Bb(e, s)) ? r = r.filter((u) => u !== s) : o = a, s = nr(s);
  }
  return t.set(e, r), r;
}
function TS(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Ul(t) ? [] : RS(t, this._c) : [].concat(n), r], a = s[0], l = s.reduce((c, u) => {
    const d = Pp(t, u, o);
    return c.top = mn(d.top, c.top), c.right = li(d.right, c.right), c.bottom = li(d.bottom, c.bottom), c.left = mn(d.left, c.left), c;
  }, Pp(t, a, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function kS(e) {
  const {
    width: t,
    height: n
  } = $b(e);
  return {
    width: t,
    height: n
  };
}
function PS(e, t, n) {
  const r = gt(t), o = sr(t), i = n === "fixed", s = Eo(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = er(0);
  function c() {
    l.x = Jl(o);
  }
  if (r || !r && !i)
    if ((Kr(t) !== "body" || No(o)) && (a = Gl(t)), r) {
      const h = Eo(t, !0, i, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else
      o && c();
  i && !r && o && c();
  const u = o && !r && !i ? Vb(o, a) : er(0), d = s.left + a.scrollLeft - l.x - u.x, f = s.top + a.scrollTop - l.y - u.y;
  return {
    x: d,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Hc(e) {
  return wn(e).position === "static";
}
function Ip(e, t) {
  if (!gt(e) || wn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return sr(e) === n && (n = n.ownerDocument.body), n;
}
function Hb(e, t) {
  const n = Wt(e);
  if (Ul(e))
    return n;
  if (!gt(e)) {
    let o = nr(e);
    for (; o && !Jn(o); ) {
      if (qe(o) && !Hc(o))
        return o;
      o = nr(o);
    }
    return n;
  }
  let r = Ip(e, t);
  for (; r && tE(r) && Hc(r); )
    r = Ip(r, t);
  return r && Jn(r) && Hc(r) && !Vd(r) ? n : r || sE(e) || n;
}
const IS = async function(e) {
  const t = this.getOffsetParent || Hb, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: PS(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function NS(e) {
  return wn(e).direction === "rtl";
}
const DS = {
  convertOffsetParentRelativeRectToViewportRelativeRect: CS,
  getDocumentElement: sr,
  getClippingRect: TS,
  getOffsetParent: Hb,
  getElementRects: IS,
  getClientRects: _S,
  getDimensions: kS,
  getScale: ti,
  isElement: qe,
  isRTL: NS
};
function Wb(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function AS(e, t) {
  let n = null, r;
  const o = sr(e);
  function i() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), i();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: d,
      width: f,
      height: h
    } = c;
    if (a || t(), !f || !h)
      return;
    const p = Ko(d), g = Ko(o.clientWidth - (u + f)), v = Ko(o.clientHeight - (d + h)), y = Ko(u), w = {
      rootMargin: -p + "px " + -g + "px " + -v + "px " + -y + "px",
      threshold: mn(0, li(1, l)) || 1
    };
    let C = !0;
    function x(E) {
      const S = E[0].intersectionRatio;
      if (S !== l) {
        if (!C)
          return s();
        S ? s(!1, S) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !Wb(c, e.getBoundingClientRect()) && s(), C = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, w);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function Np(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = tf(e), u = o || i ? [...c ? Br(c) : [], ...Br(t)] : [];
  u.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), i && y.addEventListener("resize", n);
  });
  const d = c && a ? AS(c, n) : null;
  let f = -1, h = null;
  s && (h = new ResizeObserver((y) => {
    let [b] = y;
    b && b.target === c && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var w;
      (w = h) == null || w.observe(t);
    })), n();
  }), c && !l && h.observe(c), h.observe(t));
  let p, g = l ? Eo(e) : null;
  l && v();
  function v() {
    const y = Eo(e);
    g && !Wb(g, y) && n(), g = y, p = requestAnimationFrame(v);
  }
  return n(), () => {
    var y;
    u.forEach((b) => {
      o && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), d == null || d(), (y = h) == null || y.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const LS = mS, $S = vS, FS = hS, VS = yS, BS = pS, HS = bS, WS = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: DS,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return fS(e, t, {
    ...o,
    platform: i
  });
};
var zS = typeof document < "u", jS = function() {
}, Wa = zS ? _s : jS;
function fl(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!fl(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !fl(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function zb(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Dp(e, t) {
  const n = zb(e);
  return Math.round(t * n) / n;
}
function Wc(e) {
  const t = m.useRef(e);
  return Wa(() => {
    t.current = e;
  }), t;
}
function US(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = m.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = m.useState(r);
  fl(f, r) || h(r);
  const [p, g] = m.useState(null), [v, y] = m.useState(null), b = m.useCallback((N) => {
    N !== E.current && (E.current = N, g(N));
  }, []), w = m.useCallback((N) => {
    N !== S.current && (S.current = N, y(N));
  }, []), C = i || p, x = s || v, E = m.useRef(null), S = m.useRef(null), R = m.useRef(u), M = l != null, I = Wc(l), P = Wc(o), k = Wc(c), O = m.useCallback(() => {
    if (!E.current || !S.current)
      return;
    const N = {
      placement: t,
      strategy: n,
      middleware: f
    };
    P.current && (N.platform = P.current), WS(E.current, S.current, N).then((B) => {
      const $ = {
        ...B,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: k.current !== !1
      };
      F.current && !fl(R.current, $) && (R.current = $, nn.flushSync(() => {
        d($);
      }));
    });
  }, [f, t, n, P, k]);
  Wa(() => {
    c === !1 && R.current.isPositioned && (R.current.isPositioned = !1, d((N) => ({
      ...N,
      isPositioned: !1
    })));
  }, [c]);
  const F = m.useRef(!1);
  Wa(() => (F.current = !0, () => {
    F.current = !1;
  }), []), Wa(() => {
    if (C && (E.current = C), x && (S.current = x), C && x) {
      if (I.current)
        return I.current(C, x, O);
      O();
    }
  }, [C, x, O, I, M]);
  const T = m.useMemo(() => ({
    reference: E,
    floating: S,
    setReference: b,
    setFloating: w
  }), [b, w]), L = m.useMemo(() => ({
    reference: C,
    floating: x
  }), [C, x]), A = m.useMemo(() => {
    const N = {
      position: n,
      left: 0,
      top: 0
    };
    if (!L.floating)
      return N;
    const B = Dp(L.floating, u.x), $ = Dp(L.floating, u.y);
    return a ? {
      ...N,
      transform: "translate(" + B + "px, " + $ + "px)",
      ...zb(L.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: B,
      top: $
    };
  }, [n, a, L.floating, u.x, u.y]);
  return m.useMemo(() => ({
    ...u,
    update: O,
    refs: T,
    elements: L,
    floatingStyles: A
  }), [u, O, T, L, A]);
}
const YS = (e, t) => ({
  ...LS(e),
  options: [e, t]
}), GS = (e, t) => ({
  ...$S(e),
  options: [e, t]
}), KS = (e, t) => ({
  ...HS(e),
  options: [e, t]
}), qS = (e, t) => ({
  ...FS(e),
  options: [e, t]
}), XS = (e, t) => ({
  ...VS(e),
  options: [e, t]
}), ZS = (e, t) => ({
  ...BS(e),
  options: [e, t]
}), QS = {
  intentional: "onClick",
  sloppy: "onPointerDown"
};
function JS(e) {
  return {
    escapeKey: typeof e == "boolean" ? e : (e == null ? void 0 : e.escapeKey) ?? !1,
    outsidePress: typeof e == "boolean" ? e : (e == null ? void 0 : e.outsidePress) ?? !0
  };
}
function ec(e, t = {}) {
  const n = "rootStore" in e ? e.rootStore : e, r = n.useState("open"), o = n.useState("floatingElement"), i = n.useState("referenceElement"), s = n.useState("domReferenceElement"), {
    onOpenChange: a,
    dataRef: l
  } = n.context, {
    enabled: c = !0,
    escapeKey: u = !0,
    outsidePress: d = !0,
    outsidePressEvent: f = "sloppy",
    referencePress: h = !1,
    referencePressEvent: p = "sloppy",
    ancestorScroll: g = !1,
    bubbles: v,
    externalTree: y
  } = t, b = Xr(y), w = ve(typeof d == "function" ? d : () => !1), C = typeof d == "function" ? w : d, x = m.useRef(!1), {
    escapeKey: E,
    outsidePress: S
  } = JS(v), R = m.useRef(null), M = un(), I = un(), P = ve(() => {
    I.clear(), l.current.insideReactTree = !1;
  }), k = m.useRef(!1), O = m.useRef(""), F = ve((D) => {
    O.current = D.pointerType;
  }), T = ve(() => {
    const D = O.current, te = D === "pen" || !D ? "mouse" : D, K = typeof f == "function" ? f() : f;
    return typeof K == "string" ? K : K[te];
  }), L = ve((D) => {
    var re;
    if (!r || !c || !u || D.key !== "Escape" || k.current)
      return;
    const te = (re = l.current.floatingContext) == null ? void 0 : re.nodeId, K = b ? vo(b.nodesRef.current, te) : [];
    if (!E && K.length > 0) {
      let le = !0;
      if (K.forEach((de) => {
        var be;
        (be = de.context) != null && be.open && !de.context.dataRef.current.__escapeKeyBubbles && (le = !1);
      }), !le)
        return;
    }
    const ce = yE(D) ? D.nativeEvent : D, ee = ke(Os, ce);
    n.setOpen(!1, ee), !E && !ee.isPropagationAllowed && D.stopPropagation();
  }), A = ve((D) => {
    const te = T();
    return te === "intentional" && D.type !== "click" || te === "sloppy" && D.type === "click";
  }), N = ve(() => {
    l.current.insideReactTree = !0, I.start(0, P);
  }), B = ve((D, te = !1) => {
    var Ce;
    if (A(D)) {
      P();
      return;
    }
    if (l.current.insideReactTree) {
      P();
      return;
    }
    if (T() === "intentional" && te || typeof C == "function" && !C(D))
      return;
    const K = Xt(D), ce = `[${ui("inert")}]`, ee = Nt(n.select("floatingElement")).querySelectorAll(ce), re = n.context.triggerElements;
    if (K && (re.hasElement(K) || re.hasMatchingElement((ie) => Ve(ie, K))))
      return;
    let le = qe(K) ? K : null;
    for (; le && !Jn(le); ) {
      const ie = nr(le);
      if (Jn(ie) || !qe(ie))
        break;
      le = ie;
    }
    if (ee.length && qe(K) && !vE(K) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !Ve(K, n.select("floatingElement")) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(ee).every((ie) => !Ve(le, ie)))
      return;
    if (gt(K) && !("touches" in D)) {
      const ie = Jn(K), he = wn(K), fe = /auto|scroll/, Se = ie || fe.test(he.overflowX), Me = ie || fe.test(he.overflowY), $e = Se && K.clientWidth > 0 && K.scrollWidth > K.clientWidth, Ne = Me && K.clientHeight > 0 && K.scrollHeight > K.clientHeight, Fe = he.direction === "rtl", Ae = Ne && (Fe ? D.offsetX <= K.offsetWidth - K.clientWidth : D.offsetX > K.clientWidth), bt = $e && D.offsetY > K.clientHeight;
      if (Ae || bt)
        return;
    }
    const de = (Ce = l.current.floatingContext) == null ? void 0 : Ce.nodeId, be = b && vo(b.nodesRef.current, de).some((ie) => {
      var he;
      return Fn(D, (he = ie.context) == null ? void 0 : he.elements.floating);
    });
    if (Fn(D, n.select("floatingElement")) || Fn(D, n.select("domReferenceElement")) || be)
      return;
    const ye = b ? vo(b.nodesRef.current, de) : [];
    if (ye.length > 0) {
      let ie = !0;
      if (ye.forEach((he) => {
        var fe;
        (fe = he.context) != null && fe.open && !he.context.dataRef.current.__outsidePressBubbles && (ie = !1);
      }), !ie)
        return;
    }
    n.setOpen(!1, ke(qd, D)), P();
  }), $ = ve((D) => {
    T() !== "sloppy" || D.pointerType === "touch" || !n.select("open") || !c || Fn(D, n.select("floatingElement")) || Fn(D, n.select("domReferenceElement")) || B(D);
  }), U = ve((D) => {
    if (T() !== "sloppy" || !n.select("open") || !c || Fn(D, n.select("floatingElement")) || Fn(D, n.select("domReferenceElement")))
      return;
    const te = D.touches[0];
    te && (R.current = {
      startTime: Date.now(),
      startX: te.clientX,
      startY: te.clientY,
      dismissOnTouchEnd: !1,
      dismissOnMouseDown: !0
    }, M.start(1e3, () => {
      R.current && (R.current.dismissOnTouchEnd = !1, R.current.dismissOnMouseDown = !1);
    }));
  }), G = ve((D) => {
    const te = Xt(D);
    function K() {
      U(D), te == null || te.removeEventListener(D.type, K);
    }
    te == null || te.addEventListener(D.type, K);
  }), H = ve((D) => {
    const te = x.current;
    if (x.current = !1, M.clear(), D.type === "mousedown" && R.current && !R.current.dismissOnMouseDown)
      return;
    const K = Xt(D);
    function ce() {
      D.type === "pointerdown" ? $(D) : B(D, te), K == null || K.removeEventListener(D.type, ce);
    }
    K == null || K.addEventListener(D.type, ce);
  }), q = ve((D) => {
    if (T() !== "sloppy" || !R.current || Fn(D, n.select("floatingElement")) || Fn(D, n.select("domReferenceElement")))
      return;
    const te = D.touches[0];
    if (!te)
      return;
    const K = Math.abs(te.clientX - R.current.startX), ce = Math.abs(te.clientY - R.current.startY), ee = Math.sqrt(K * K + ce * ce);
    ee > 5 && (R.current.dismissOnTouchEnd = !0), ee > 10 && (B(D), M.clear(), R.current = null);
  }), j = ve((D) => {
    const te = Xt(D);
    function K() {
      q(D), te == null || te.removeEventListener(D.type, K);
    }
    te == null || te.addEventListener(D.type, K);
  }), W = ve((D) => {
    T() !== "sloppy" || !R.current || Fn(D, n.select("floatingElement")) || Fn(D, n.select("domReferenceElement")) || (R.current.dismissOnTouchEnd && B(D), M.clear(), R.current = null);
  }), z = ve((D) => {
    const te = Xt(D);
    function K() {
      W(D), te == null || te.removeEventListener(D.type, K);
    }
    te == null || te.addEventListener(D.type, K);
  });
  m.useEffect(() => {
    if (!r || !c)
      return;
    l.current.__escapeKeyBubbles = E, l.current.__outsidePressBubbles = S;
    const D = new wr();
    function te(le) {
      n.setOpen(!1, ke(_o, le));
    }
    function K() {
      D.clear(), k.current = !0;
    }
    function ce() {
      D.start(
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        Yl() ? 5 : 0,
        () => {
          k.current = !1;
        }
      );
    }
    const ee = Nt(o);
    ee.addEventListener("pointerdown", F, !0), u && (ee.addEventListener("keydown", L), ee.addEventListener("compositionstart", K), ee.addEventListener("compositionend", ce)), C && (ee.addEventListener("click", H, !0), ee.addEventListener("pointerdown", H, !0), ee.addEventListener("touchstart", G, !0), ee.addEventListener("touchmove", j, !0), ee.addEventListener("touchend", z, !0), ee.addEventListener("mousedown", H, !0));
    let re = [];
    return g && (qe(s) && (re = Br(s)), qe(o) && (re = re.concat(Br(o))), !qe(i) && i && i.contextElement && (re = re.concat(Br(i.contextElement)))), re = re.filter((le) => {
      var de;
      return le !== ((de = ee.defaultView) == null ? void 0 : de.visualViewport);
    }), re.forEach((le) => {
      le.addEventListener("scroll", te, {
        passive: !0
      });
    }), () => {
      ee.removeEventListener("pointerdown", F, !0), u && (ee.removeEventListener("keydown", L), ee.removeEventListener("compositionstart", K), ee.removeEventListener("compositionend", ce)), C && (ee.removeEventListener("click", H, !0), ee.removeEventListener("pointerdown", H, !0), ee.removeEventListener("touchstart", G, !0), ee.removeEventListener("touchmove", j, !0), ee.removeEventListener("touchend", z, !0), ee.removeEventListener("mousedown", H, !0)), re.forEach((le) => {
        le.removeEventListener("scroll", te);
      }), D.clear(), x.current = !1;
    };
  }, [l, o, i, s, u, C, r, a, g, c, E, S, L, B, H, $, G, j, z, F, n]), m.useEffect(P, [C, P]);
  const X = m.useMemo(() => ({
    onKeyDown: L,
    ...h && {
      [QS[p]]: (D) => {
        n.setOpen(!1, ke(Tn, D.nativeEvent));
      },
      ...p !== "intentional" && {
        onClick(D) {
          n.setOpen(!1, ke(Tn, D.nativeEvent));
        }
      }
    }
  }), [L, n, h, p]), J = ve((D) => {
    const te = Xt(D.nativeEvent);
    !Ve(n.select("floatingElement"), te) || D.button !== 0 || (x.current = !0);
  }), ne = ve((D) => {
    !r || !c || D.button !== 0 || (x.current = !0);
  }), Q = m.useMemo(() => ({
    onKeyDown: L,
    // `onMouseDown` may be blocked if `event.preventDefault()` is called in
    // `onPointerDown`, such as with <NumberField.ScrubArea>.
    // See https://github.com/mui/base-ui/pull/3379
    onPointerDown: J,
    onMouseDown: J,
    onMouseUp: J,
    onClickCapture: N,
    onMouseDownCapture(D) {
      N(), ne(D);
    },
    onPointerDownCapture(D) {
      N(), ne(D);
    },
    onMouseUpCapture: N,
    onTouchEndCapture: N,
    onTouchMoveCapture: N
  }), [L, J, N, ne]);
  return m.useMemo(() => c ? {
    reference: X,
    floating: Q,
    trigger: X
  } : {}, [c, X, Q]);
}
var e2 = (e, t, n) => {
  if (t.length === 1 && t[0] === n) {
    let r = !1;
    try {
      const o = {};
      e(o) === o && (r = !0);
    } catch {
    }
    if (r) {
      let o;
      try {
        throw new Error();
      } catch (i) {
        ({ stack: o } = i);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: o }
      );
    }
  }
}, t2 = (e, t, n) => {
  const { memoize: r, memoizeOptions: o } = t, { inputSelectorResults: i, inputSelectorResultsCopy: s } = e, a = r(() => ({}), ...o);
  if (!(a.apply(null, i) === a.apply(null, s))) {
    let c;
    try {
      throw new Error();
    } catch (u) {
      ({ stack: c } = u);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: i,
        secondInputs: s,
        stack: c
      }
    );
  }
}, n2 = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, hl = /* @__PURE__ */ Symbol("NOT_FOUND");
function r2(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function o2(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function i2(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((n) => typeof n == "function")) {
    const n = e.map(
      (r) => typeof r == "function" ? `function ${r.name || "unnamed"}()` : typeof r
    ).join(", ");
    throw new TypeError(`${t}[${n}]`);
  }
}
var Ap = (e) => Array.isArray(e) ? e : [e];
function s2(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return i2(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function Lp(e, t) {
  const n = [], { length: r } = e;
  for (let o = 0; o < r; o++)
    n.push(e[o].apply(null, t));
  return n;
}
var a2 = (e, t) => {
  const { identityFunctionCheck: n, inputStabilityCheck: r } = {
    ...n2,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: e2
    },
    inputStabilityCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: t2
    }
  };
};
function l2(e) {
  let t;
  return {
    get(n) {
      return t && e(t.key, n) ? t.value : hl;
    },
    put(n, r) {
      t = { key: n, value: r };
    },
    getEntries() {
      return t ? [t] : [];
    },
    clear() {
      t = void 0;
    }
  };
}
function c2(e, t) {
  let n = [];
  function r(a) {
    const l = n.findIndex((c) => t(a, c.key));
    if (l > -1) {
      const c = n[l];
      return l > 0 && (n.splice(l, 1), n.unshift(c)), c.value;
    }
    return hl;
  }
  function o(a, l) {
    r(a) === hl && (n.unshift({ key: a, value: l }), n.length > e && n.pop());
  }
  function i() {
    return n;
  }
  function s() {
    n = [];
  }
  return { get: r, put: o, getEntries: i, clear: s };
}
var u2 = (e, t) => e === t;
function d2(e) {
  return function(n, r) {
    if (n === null || r === null || n.length !== r.length)
      return !1;
    const { length: o } = n;
    for (let i = 0; i < o; i++)
      if (!e(n[i], r[i]))
        return !1;
    return !0;
  };
}
function f2(e, t) {
  const n = typeof t == "object" ? t : { equalityCheck: t }, {
    equalityCheck: r = u2,
    maxSize: o = 1,
    resultEqualityCheck: i
  } = n, s = d2(r);
  let a = 0;
  const l = o <= 1 ? l2(s) : c2(o, s);
  function c() {
    let u = l.get(arguments);
    if (u === hl) {
      if (u = e.apply(null, arguments), a++, i) {
        const f = l.getEntries().find(
          (h) => i(h.value, u)
        );
        f && (u = f.value, a !== 0 && a--);
      }
      l.put(arguments, u);
    }
    return u;
  }
  return c.clearCache = () => {
    l.clear(), c.resetResultsCount();
  }, c.resultsCount = () => a, c.resetResultsCount = () => {
    a = 0;
  }, c;
}
var h2 = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, p2 = typeof WeakRef < "u" ? WeakRef : h2, g2 = 0, $p = 1;
function ia() {
  return {
    s: g2,
    v: void 0,
    o: null,
    p: null
  };
}
function jb(e, t = {}) {
  let n = ia();
  const { resultEqualityCheck: r } = t;
  let o, i = 0;
  function s() {
    var d;
    let a = n;
    const { length: l } = arguments;
    for (let f = 0, h = l; f < h; f++) {
      const p = arguments[f];
      if (typeof p == "function" || typeof p == "object" && p !== null) {
        let g = a.o;
        g === null && (a.o = g = /* @__PURE__ */ new WeakMap());
        const v = g.get(p);
        v === void 0 ? (a = ia(), g.set(p, a)) : a = v;
      } else {
        let g = a.p;
        g === null && (a.p = g = /* @__PURE__ */ new Map());
        const v = g.get(p);
        v === void 0 ? (a = ia(), g.set(p, a)) : a = v;
      }
    }
    const c = a;
    let u;
    if (a.s === $p)
      u = a.v;
    else if (u = e.apply(null, arguments), i++, r) {
      const f = ((d = o == null ? void 0 : o.deref) == null ? void 0 : d.call(o)) ?? o;
      f != null && r(f, u) && (u = f, i !== 0 && i--), o = typeof u == "object" && u !== null || typeof u == "function" ? new p2(u) : u;
    }
    return c.s = $p, c.v = u, u;
  }
  return s.clearCache = () => {
    n = ia(), s.resetResultsCount();
  }, s.resultsCount = () => i, s.resetResultsCount = () => {
    i = 0;
  }, s;
}
function Ub(e, ...t) {
  const n = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, r = (...o) => {
    let i = 0, s = 0, a, l = {}, c = o.pop();
    typeof c == "object" && (l = c, c = o.pop()), r2(
      c,
      `createSelector expects an output function after the inputs, but received: [${typeof c}]`
    );
    const u = {
      ...n,
      ...l
    }, {
      memoize: d,
      memoizeOptions: f = [],
      argsMemoize: h = jb,
      argsMemoizeOptions: p = [],
      devModeChecks: g = {}
    } = u, v = Ap(f), y = Ap(p), b = s2(o), w = d(function() {
      return i++, c.apply(
        null,
        arguments
      );
    }, ...v);
    let C = !0;
    const x = h(function() {
      s++;
      const S = Lp(
        b,
        arguments
      );
      if (a = w.apply(null, S), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: R, inputStabilityCheck: M } = a2(C, g);
        if (R.shouldRun && R.run(
          c,
          S,
          a
        ), M.shouldRun) {
          const I = Lp(
            b,
            arguments
          );
          M.run(
            { inputSelectorResults: S, inputSelectorResultsCopy: I },
            { memoize: d, memoizeOptions: v },
            arguments
          );
        }
        C && (C = !1);
      }
      return a;
    }, ...y);
    return Object.assign(x, {
      resultFunc: c,
      memoizedResultFunc: w,
      dependencies: b,
      dependencyRecomputations: () => s,
      resetDependencyRecomputations: () => {
        s = 0;
      },
      lastResult: () => a,
      recomputations: () => i,
      resetRecomputations: () => {
        i = 0;
      },
      memoize: d,
      argsMemoize: h
    });
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var m2 = /* @__PURE__ */ Ub(jb), v2 = Object.assign(
  (e, t = m2) => {
    o2(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const n = Object.keys(e), r = n.map(
      (i) => e[i]
    );
    return t(
      r,
      (...i) => i.reduce((s, a, l) => (s[n[l]] = a, s), {})
    );
  },
  { withTypes: () => v2 }
);
Ub({
  memoize: f2,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
});
const Ee = (e, t, n, r, o, i, ...s) => {
  if (s.length > 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of selectors" : Ke(1));
  let a;
  if (e && t && n && r && o && i)
    a = (l, c, u, d) => {
      const f = e(l, c, u, d), h = t(l, c, u, d), p = n(l, c, u, d), g = r(l, c, u, d), v = o(l, c, u, d);
      return i(f, h, p, g, v, c, u, d);
    };
  else if (e && t && n && r && o)
    a = (l, c, u, d) => {
      const f = e(l, c, u, d), h = t(l, c, u, d), p = n(l, c, u, d), g = r(l, c, u, d);
      return o(f, h, p, g, c, u, d);
    };
  else if (e && t && n && r)
    a = (l, c, u, d) => {
      const f = e(l, c, u, d), h = t(l, c, u, d), p = n(l, c, u, d);
      return r(f, h, p, c, u, d);
    };
  else if (e && t && n)
    a = (l, c, u, d) => {
      const f = e(l, c, u, d), h = t(l, c, u, d);
      return n(f, h, c, u, d);
    };
  else if (e && t)
    a = (l, c, u, d) => {
      const f = e(l, c, u, d);
      return t(f, c, u, d);
    };
  else if (e)
    a = e;
  else
    throw new Error("Missing arguments");
  return a;
};
var Ku = { exports: {} }, zc = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fp;
function b2() {
  if (Fp)
    return zc;
  Fp = 1;
  var e = Y;
  function t(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, i = e.useLayoutEffect, s = e.useDebugValue;
  function a(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), g = p[0].inst, v = p[1];
    return i(
      function() {
        g.value = h, g.getSnapshot = f, l(g) && v({ inst: g });
      },
      [d, h, f]
    ), o(
      function() {
        return l(g) && v({ inst: g }), d(function() {
          l(g) && v({ inst: g });
        });
      },
      [d]
    ), s(h), h;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return zc.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, zc;
}
var jc = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vp;
function y2() {
  return Vp || (Vp = 1, process.env.NODE_ENV !== "production" && function() {
    function e(h, p) {
      return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
    }
    function t(h, p) {
      u || o.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var g = p();
      if (!d) {
        var v = p();
        i(g, v) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      v = s({
        inst: { value: g, getSnapshot: p }
      });
      var y = v[0].inst, b = v[1];
      return l(
        function() {
          y.value = g, y.getSnapshot = p, n(y) && b({ inst: y });
        },
        [h, g, p]
      ), a(
        function() {
          return n(y) && b({ inst: y }), h(function() {
            n(y) && b({ inst: y });
          });
        },
        [h]
      ), c(g), g;
    }
    function n(h) {
      var p = h.getSnapshot;
      h = h.value;
      try {
        var g = p();
        return !i(h, g);
      } catch {
        return !0;
      }
    }
    function r(h, p) {
      return p();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = Y, i = typeof Object.is == "function" ? Object.is : e, s = o.useState, a = o.useEffect, l = o.useLayoutEffect, c = o.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    jc.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), jc;
}
process.env.NODE_ENV === "production" ? Ku.exports = b2() : Ku.exports = y2();
var nf = Ku.exports, qu = { exports: {} }, Uc = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bp;
function x2() {
  if (Bp)
    return Uc;
  Bp = 1;
  var e = Y, t = nf;
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, o = t.useSyncExternalStore, i = e.useRef, s = e.useEffect, a = e.useMemo, l = e.useDebugValue;
  return Uc.useSyncExternalStoreWithSelector = function(c, u, d, f, h) {
    var p = i(null);
    if (p.current === null) {
      var g = { hasValue: !1, value: null };
      p.current = g;
    } else
      g = p.current;
    p = a(
      function() {
        function y(E) {
          if (!b) {
            if (b = !0, w = E, E = f(E), h !== void 0 && g.hasValue) {
              var S = g.value;
              if (h(S, E))
                return C = S;
            }
            return C = E;
          }
          if (S = C, r(w, E))
            return S;
          var R = f(E);
          return h !== void 0 && h(S, R) ? (w = E, S) : (w = E, C = R);
        }
        var b = !1, w, C, x = d === void 0 ? null : d;
        return [
          function() {
            return y(u());
          },
          x === null ? void 0 : function() {
            return y(x());
          }
        ];
      },
      [u, d, f, h]
    );
    var v = o(c, p[0], p[1]);
    return s(
      function() {
        g.hasValue = !0, g.value = v;
      },
      [v]
    ), l(v), v;
  }, Uc;
}
var Yc = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hp;
function w2() {
  return Hp || (Hp = 1, process.env.NODE_ENV !== "production" && function() {
    function e(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = Y, n = nf, r = typeof Object.is == "function" ? Object.is : e, o = n.useSyncExternalStore, i = t.useRef, s = t.useEffect, a = t.useMemo, l = t.useDebugValue;
    Yc.useSyncExternalStoreWithSelector = function(c, u, d, f, h) {
      var p = i(null);
      if (p.current === null) {
        var g = { hasValue: !1, value: null };
        p.current = g;
      } else
        g = p.current;
      p = a(
        function() {
          function y(E) {
            if (!b) {
              if (b = !0, w = E, E = f(E), h !== void 0 && g.hasValue) {
                var S = g.value;
                if (h(S, E))
                  return C = S;
              }
              return C = E;
            }
            if (S = C, r(w, E))
              return S;
            var R = f(E);
            return h !== void 0 && h(S, R) ? (w = E, S) : (w = E, C = R);
          }
          var b = !1, w, C, x = d === void 0 ? null : d;
          return [
            function() {
              return y(u());
            },
            x === null ? void 0 : function() {
              return y(x());
            }
          ];
        },
        [u, d, f, h]
      );
      var v = o(c, p[0], p[1]);
      return s(
        function() {
          g.hasValue = !0, g.value = v;
        },
        [v]
      ), l(v), v;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Yc;
}
process.env.NODE_ENV === "production" ? qu.exports = x2() : qu.exports = w2();
var C2 = qu.exports;
const _2 = Nd(19), E2 = _2 ? M2 : O2;
function S2(e, t, n, r, o) {
  return E2(e, t, n, r, o);
}
function M2(e, t, n, r, o) {
  const i = m.useCallback(() => t(e.getSnapshot(), n, r, o), [e, t, n, r, o]);
  return nf.useSyncExternalStore(e.subscribe, i, i);
}
function O2(e, t, n, r, o) {
  return C2.useSyncExternalStoreWithSelector(e.subscribe, e.getSnapshot, e.getSnapshot, (i) => t(i, n, r, o));
}
class Ji {
  /**
   * The current state of the store.
   * This property is updated immediately when the state changes as a result of calling {@link setState}, {@link update}, or {@link set}.
   * To subscribe to state changes, use the {@link useState} method. The value returned by {@link useState} is updated after the component renders (similarly to React's useState).
   * The values can be used directly (to avoid subscribing to the store) in effects or event handlers.
   *
   * Do not modify properties in state directly. Instead, use the provided methods to ensure proper state management and listener notification.
   */
  // Internal state to handle recursive `setState()` calls
  constructor(t) {
    /**
     * Registers a listener that will be called whenever the store's state changes.
     *
     * @param fn The listener function to be called on state changes.
     * @returns A function to unsubscribe the listener.
     */
    ae(this, "subscribe", (t) => (this.listeners.add(t), () => {
      this.listeners.delete(t);
    }));
    /**
     * Returns the current state of the store.
     */
    ae(this, "getSnapshot", () => this.state);
    this.state = t, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
  }
  /**
   * Updates the entire store's state and notifies all registered listeners.
   *
   * @param newState The new state to set for the store.
   */
  setState(t) {
    if (this.state === t)
      return;
    this.state = t, this.updateTick += 1;
    const n = this.updateTick;
    for (const r of this.listeners) {
      if (n !== this.updateTick)
        return;
      r(t);
    }
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   *
   * @param changes An object containing the changes to apply to the current state.
   */
  update(t) {
    for (const n in t)
      if (!Object.is(this.state[n], t[n])) {
        Ji.prototype.setState.call(this, {
          ...this.state,
          ...t
        });
        return;
      }
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */
  set(t, n) {
    Object.is(this.state[t], n) || Ji.prototype.setState.call(this, {
      ...this.state,
      [t]: n
    });
  }
  /**
   * Gives the state a new reference and updates all registered listeners.
   */
  notifyAll() {
    const t = {
      ...this.state
    };
    Ji.prototype.setState.call(this, t);
  }
}
class Ts extends Ji {
  /**
   * Creates a new ReactStore instance.
   *
   * @param state Initial state of the store.
   * @param context Non-reactive context values.
   * @param selectors Optional selectors for use with `useState`.
   */
  constructor(n, r = {}, o) {
    super(n);
    /**
     * Non-reactive values such as refs, callbacks, etc.
     */
    /**
     * Keeps track of which properties are controlled.
     */
    ae(this, "controlledValues", /* @__PURE__ */ new Map());
    /** Gets the current value from the store using a selector with the provided key.
     *
     * @param key Key of the selector to use.
     */
    ae(this, "select", (n, r, o, i) => {
      const s = this.selectors[n];
      return s(this.state, r, o, i);
    });
    /**
     * Returns a value from the store's state using a selector function.
     * Used to subscribe to specific parts of the state.
     * This methods causes a rerender whenever the selected state changes.
     *
     * @param key Key of the selector to use.
     */
    ae(this, "useState", (n, r, o, i) => {
      m.useDebugValue(n);
      const s = this.selectors[n];
      return S2(this, s, r, o, i);
    });
    this.context = r, this.selectors = o;
  }
  /**
   * Synchronizes a single external value into the store.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValue(n, r) {
    m.useDebugValue(n), ge(() => {
      this.state[n] !== r && this.set(n, r);
    }, [n, r]);
  }
  /**
   * Synchronizes a single external value into the store and
   * cleans it up (sets to `undefined`) on unmount.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValueWithCleanup(n, r) {
    const o = this;
    ge(() => (o.state[n] !== r && o.set(n, r), () => {
      o.set(n, void 0);
    }), [o, n, r]);
  }
  /**
   * Synchronizes multiple external values into the store.
   *
   * Note that the while the values in `state` are updated immediately, the values returned
   * by `useState` are updated before the next render (similarly to React's `useState`).
   */
  useSyncedValues(n) {
    const r = this;
    if (process.env.NODE_ENV !== "production") {
      m.useDebugValue(n, (a) => Object.keys(a));
      const i = m.useRef(Object.keys(n)).current, s = Object.keys(n);
      (i.length !== s.length || i.some((a, l) => a !== s[l])) && console.error("ReactStore.useSyncedValues expects the same prop keys on every render. Keys should be stable.");
    }
    const o = Object.values(n);
    ge(() => {
      r.update(n);
    }, [r, ...o]);
  }
  /**
   * Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key.
   * - If `controlled` is non-undefined, the key is marked as controlled and the store's
   *   state at `key` is updated to match `controlled`. Local writes to that key are ignored.
   * - If `controlled` is undefined, the key is marked as uncontrolled. The store's state
   *   is initialized to `defaultValue` on first render and can be updated with local writes.
   */
  useControlledProp(n, r, o) {
    m.useDebugValue(n);
    const i = this, s = r !== void 0;
    if (process.env.NODE_ENV !== "production") {
      const a = this.controlledValues.get(n);
      a !== void 0 && a !== s && console.error(`A component is changing the ${s ? "" : "un"}controlled state of ${n.toString()} to be ${s ? "un" : ""}controlled. Elements should not switch from uncontrolled to controlled (or vice versa).`);
    }
    this.controlledValues.has(n) || (this.controlledValues.set(n, s), !s && !Object.is(this.state[n], o) && super.setState({
      ...this.state,
      [n]: o
    })), ge(() => {
      s && !Object.is(i.state[n], r) && super.setState({
        ...i.state,
        [n]: r
      });
    }, [i, n, r, o, s]);
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   * If the key is controlled (registered via {@link useControlledProp} with a non-undefined value),
   * the update is ignored and no listeners are notified.
   *
   * @param key The state key to update.
   * @param value The new value to set for the specified key.
   */
  set(n, r) {
    this.controlledValues.get(n) !== !0 && super.set(n, r);
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   * Controlled keys are filtered out and not updated.
   *
   * @param values An object containing the changes to apply to the current state.
   */
  update(n) {
    const r = {
      ...n
    };
    for (const o in r)
      if (Object.hasOwn(r, o) && this.controlledValues.get(o) === !0) {
        delete r[o];
        continue;
      }
    super.update(r);
  }
  /**
   * Updates the entire store's state and notifies all registered listeners.
   * Controlled keys are left unchanged; only uncontrolled keys from `newState` are applied.
   *
   * @param newState The new state to set for the store.
   */
  setState(n) {
    const r = {
      ...n
    };
    for (const o in r)
      if (Object.hasOwn(r, o) && this.controlledValues.get(o) === !0) {
        delete r[o];
        continue;
      }
    super.setState({
      ...this.state,
      ...r
    });
  }
  /**
   * Wraps a function with `useStableCallback` to ensure it has a stable reference
   * and assigns it to the context.
   *
   * @param key Key of the event callback. Must be a function in the context.
   * @param fn Function to assign.
   */
  useContextCallback(n, r) {
    m.useDebugValue(n);
    const o = ve(r ?? vn);
    this.context[n] = o;
  }
  /**
   * Returns a stable setter function for a specific key in the store's state.
   * It's commonly used to pass as a ref callback to React elements.
   *
   * @param key Key of the state to set.
   */
  useStateSetter(n) {
    const r = m.useRef(void 0);
    return r.current === void 0 && (r.current = (o) => {
      this.set(n, o);
    }), r.current;
  }
  /**
   * Observes changes derived from the store's selectors and calls the listener when the selected value changes.
   *
   * @param key Key of the selector to observe.
   * @param listener Listener function called when the selector result changes.
   */
  observe(n, r) {
    let o;
    typeof n == "function" ? o = n : o = this.selectors[n];
    let i = o(this.state);
    return r(i, i, this), this.subscribe((s) => {
      const a = o(s);
      if (!Object.is(i, a)) {
        const l = i;
        i = a, r(a, l, this);
      }
    });
  }
}
const R2 = {
  open: Ee((e) => e.open),
  domReferenceElement: Ee((e) => e.domReferenceElement),
  referenceElement: Ee((e) => e.positionReference ?? e.referenceElement),
  floatingElement: Ee((e) => e.floatingElement),
  floatingId: Ee((e) => e.floatingId)
};
class rf extends Ts {
  constructor(n) {
    const {
      nested: r,
      noEmit: o,
      onOpenChange: i,
      triggerElements: s,
      ...a
    } = n;
    super({
      ...a,
      positionReference: a.referenceElement,
      domReferenceElement: a.referenceElement
    }, {
      onOpenChange: i,
      dataRef: {
        current: {}
      },
      events: Tb(),
      nested: r,
      noEmit: o,
      triggerElements: s
    }, R2);
    /**
     * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
     *
     * @param newOpen The new open state.
     * @param eventDetails Details about the event that triggered the open state change.
     */
    ae(this, "setOpen", (n, r) => {
      var o, i;
      if ((!n || !this.state.open || // Prevent a pending hover-open from overwriting a click-open event, while allowing
      // click events to upgrade a hover-open.
      db(r.event)) && (this.context.dataRef.current.openEvent = n ? r.event : void 0), !this.context.noEmit) {
        const s = {
          open: n,
          reason: r.reason,
          nativeEvent: r.event,
          nested: this.context.nested,
          triggerElement: r.trigger
        };
        this.context.events.emit("openchange", s);
      }
      (i = (o = this.context).onOpenChange) == null || i.call(o, n, r);
    });
  }
}
function tc(e, t = !1, n = !1) {
  const [r, o] = m.useState(e && t ? "idle" : void 0), [i, s] = m.useState(e);
  return e && !i && (s(!0), o("starting")), !e && i && r !== "ending" && !n && o("ending"), !e && !i && r === "ending" && o(void 0), ge(() => {
    if (!e && i && r !== "ending" && n) {
      const a = St.request(() => {
        o("ending");
      });
      return () => {
        St.cancel(a);
      };
    }
  }, [e, i, r, n]), ge(() => {
    if (!e || t)
      return;
    const a = St.request(() => {
      o(void 0);
    });
    return () => {
      St.cancel(a);
    };
  }, [t, e]), ge(() => {
    if (!e || !t)
      return;
    e && i && r !== "idle" && o("starting");
    const a = St.request(() => {
      o("idle");
    });
    return () => {
      St.cancel(a);
    };
  }, [t, e, i, o, r]), m.useMemo(() => ({
    mounted: i,
    setMounted: s,
    transitionStatus: r
  }), [i, r]);
}
let So = /* @__PURE__ */ function(e) {
  return e.startingStyle = "data-starting-style", e.endingStyle = "data-ending-style", e;
}({});
const T2 = {
  [So.startingStyle]: ""
}, k2 = {
  [So.endingStyle]: ""
}, lr = {
  transitionStatus(e) {
    return e === "starting" ? T2 : e === "ending" ? k2 : null;
  }
};
function of(e, t = !1, n = !0) {
  const r = Rs();
  return ve((o, i = null) => {
    r.cancel();
    function s() {
      nn.flushSync(o);
    }
    const a = pr(e);
    if (a == null)
      return;
    const l = a;
    if (typeof l.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED)
      o();
    else {
      let c = function() {
        const d = So.startingStyle;
        if (!l.hasAttribute(d)) {
          r.request(u);
          return;
        }
        const f = new MutationObserver(() => {
          l.hasAttribute(d) || (f.disconnect(), u());
        });
        f.observe(l, {
          attributes: !0,
          attributeFilter: [d]
        }), i == null || i.addEventListener("abort", () => f.disconnect(), {
          once: !0
        });
      }, u = function() {
        Promise.all(l.getAnimations().map((d) => d.finished)).then(() => {
          i != null && i.aborted || s();
        }).catch(() => {
          const d = l.getAnimations();
          if (n) {
            if (i != null && i.aborted)
              return;
            s();
          } else
            d.length > 0 && d.some((f) => f.pending || f.playState !== "finished") && u();
        });
      };
      if (t) {
        c();
        return;
      }
      r.request(u);
    }
  });
}
function Zr(e) {
  const {
    enabled: t = !0,
    open: n,
    ref: r,
    onComplete: o
  } = e, i = ve(o), s = of(r, n, !1);
  m.useEffect(() => {
    if (!t)
      return;
    const a = new AbortController();
    return s(i, a.signal), () => {
      a.abort();
    };
  }, [t, n, i, s]);
}
function Yb(e, t) {
  const n = m.useRef(null), r = m.useRef(null);
  return m.useCallback((o) => {
    if (e !== void 0) {
      if (n.current !== null) {
        const i = n.current, s = r.current, a = t.context.triggerElements.getById(i);
        s && a === s && t.context.triggerElements.delete(i), n.current = null, r.current = null;
      }
      o !== null && (n.current = e, r.current = o, t.context.triggerElements.add(e, o));
    }
  }, [t, e]);
}
function nc(e, t, n, r) {
  const o = n.useState("isMountedByTrigger", e), i = Yb(e, n), s = ve((a) => {
    if (i(a), !a || !n.select("open"))
      return;
    const l = n.select("activeTriggerId");
    if (l === e) {
      n.update({
        activeTriggerElement: a,
        ...r
      });
      return;
    }
    l == null && n.update({
      activeTriggerId: e,
      activeTriggerElement: a,
      ...r
    });
  });
  return ge(() => {
    o && n.update({
      activeTriggerElement: t.current,
      ...r
    });
  }, [o, n, t, ...Object.values(r)]), {
    registerTrigger: s,
    isMountedByThisTrigger: o
  };
}
function rc(e) {
  const t = e.useState("open");
  ge(() => {
    if (t && !e.select("activeTriggerId") && e.context.triggerElements.size === 1) {
      const n = e.context.triggerElements.entries().next();
      if (!n.done) {
        const [r, o] = n.value;
        e.update({
          activeTriggerId: r,
          activeTriggerElement: o
        });
      }
    }
  }, [t, e]);
}
function oc(e, t, n) {
  const {
    mounted: r,
    setMounted: o,
    transitionStatus: i
  } = tc(e);
  t.useSyncedValues({
    mounted: r,
    transitionStatus: i
  });
  const s = ve(() => {
    var l, c;
    o(!1), t.update({
      activeTriggerId: null,
      activeTriggerElement: null,
      mounted: !1
    }), n == null || n(), (c = (l = t.context).onOpenChangeComplete) == null || c.call(l, !1);
  }), a = t.useState("preventUnmountingOnClose");
  return Zr({
    enabled: !a,
    open: e,
    ref: t.context.popupRef,
    onComplete() {
      e || s();
    }
  }), {
    forceUnmount: s,
    transitionStatus: i
  };
}
class _i {
  constructor() {
    this.elements = /* @__PURE__ */ new Set(), this.idMap = /* @__PURE__ */ new Map();
  }
  /**
   * Adds a trigger element with the given ID.
   *
   * Note: The provided element is assumed to not be registered under multiple IDs.
   */
  add(t, n) {
    const r = this.idMap.get(t);
    if (r !== n && (r !== void 0 && this.elements.delete(r), this.elements.add(n), this.idMap.set(t, n), process.env.NODE_ENV !== "production" && this.elements.size !== this.idMap.size))
      throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: A trigger element cannot be registered under multiple IDs in PopupTriggerMap." : Ke(87));
  }
  /**
   * Removes the trigger element with the given ID.
   */
  delete(t) {
    const n = this.idMap.get(t);
    n && (this.elements.delete(n), this.idMap.delete(t));
  }
  /**
   * Whether the given element is registered as a trigger.
   */
  hasElement(t) {
    return this.elements.has(t);
  }
  /**
   * Whether there is a registered trigger element matching the given predicate.
   */
  hasMatchingElement(t) {
    for (const n of this.elements)
      if (t(n))
        return !0;
    return !1;
  }
  getById(t) {
    return this.idMap.get(t);
  }
  entries() {
    return this.idMap.entries();
  }
  get size() {
    return this.idMap.size;
  }
}
function P2() {
  return new rf({
    open: !1,
    floatingElement: null,
    referenceElement: null,
    triggerElements: new _i(),
    floatingId: "",
    nested: !1,
    noEmit: !1,
    onOpenChange: void 0
  });
}
function ic() {
  return {
    open: !1,
    mounted: !1,
    transitionStatus: "idle",
    floatingRootContext: P2(),
    preventUnmountingOnClose: !1,
    payload: void 0,
    activeTriggerId: null,
    activeTriggerElement: null,
    popupElement: null,
    positionerElement: null,
    activeTriggerProps: Rt,
    inactiveTriggerProps: Rt,
    popupProps: Rt
  };
}
const sc = {
  open: Ee((e) => e.open),
  mounted: Ee((e) => e.mounted),
  transitionStatus: Ee((e) => e.transitionStatus),
  floatingRootContext: Ee((e) => e.floatingRootContext),
  preventUnmountingOnClose: Ee((e) => e.preventUnmountingOnClose),
  payload: Ee((e) => e.payload),
  activeTriggerId: Ee((e) => e.activeTriggerId),
  activeTriggerElement: Ee((e) => e.mounted ? e.activeTriggerElement : null),
  /**
   * Whether the trigger with the given ID was used to open the popup.
   */
  isTriggerActive: Ee((e, t) => t !== void 0 && e.activeTriggerId === t),
  /**
   * Whether the popup is open and was activated by a trigger with the given ID.
   */
  isOpenedByTrigger: Ee((e, t) => t !== void 0 && e.activeTriggerId === t && e.open),
  /**
   * Whether the popup is mounted and was activated by a trigger with the given ID.
   */
  isMountedByTrigger: Ee((e, t) => t !== void 0 && e.activeTriggerId === t && e.mounted),
  triggerProps: Ee((e, t) => t ? e.activeTriggerProps : e.inactiveTriggerProps),
  popupProps: Ee((e) => e.popupProps),
  popupElement: Ee((e) => e.popupElement),
  positionerElement: Ee((e) => e.positionerElement)
};
function I2(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r = {}
  } = e, o = Do(), i = ar() != null;
  if (process.env.NODE_ENV !== "production") {
    const a = r.reference;
    a && !qe(a) && console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `context.setPositionReference()`", "instead.");
  }
  const s = rn(() => new rf({
    open: t,
    onOpenChange: n,
    referenceElement: r.reference ?? null,
    floatingElement: r.floating ?? null,
    triggerElements: r.triggers ?? new _i(),
    floatingId: o,
    nested: i,
    noEmit: e.noEmit || !1
  })).current;
  return ge(() => {
    const a = {
      open: t,
      floatingId: o
    };
    r.reference !== void 0 && (a.referenceElement = r.reference, a.domReferenceElement = qe(r.reference) ? r.reference : null), r.floating !== void 0 && (a.floatingElement = r.floating), s.update(a);
  }, [t, o, r.reference, r.floating, s]), s.context.onOpenChange = n, s.context.nested = i, s.context.noEmit = e.noEmit || !1, s;
}
function N2(e = {}) {
  const {
    nodeId: t,
    externalTree: n
  } = e, r = I2(e), o = e.rootContext || r, i = {
    reference: o.useState("referenceElement"),
    floating: o.useState("floatingElement"),
    domReference: o.useState("domReferenceElement")
  }, [s, a] = m.useState(null), l = m.useRef(null), c = Xr(n);
  ge(() => {
    i.domReference && (l.current = i.domReference);
  }, [i.domReference]);
  const u = US({
    ...e,
    elements: {
      ...i,
      ...s && {
        reference: s
      }
    }
  }), d = m.useCallback((S) => {
    const R = qe(S) ? {
      getBoundingClientRect: () => S.getBoundingClientRect(),
      getClientRects: () => S.getClientRects(),
      contextElement: S
    } : S;
    a(R), u.refs.setReference(R);
  }, [u.refs]), [f, h] = m.useState(null), [p, g] = m.useState(null);
  o.useSyncedValue("referenceElement", f), o.useSyncedValue("domReferenceElement", qe(f) ? f : null), o.useSyncedValue("floatingElement", p);
  const v = m.useCallback((S) => {
    (qe(S) || S === null) && (l.current = S, h(S)), (qe(u.refs.reference.current) || u.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    S !== null && !qe(S)) && u.refs.setReference(S);
  }, [u.refs, h]), y = m.useCallback((S) => {
    g(S), u.refs.setFloating(S);
  }, [u.refs]), b = m.useMemo(() => ({
    ...u.refs,
    setReference: v,
    setFloating: y,
    setPositionReference: d,
    domReference: l
  }), [u.refs, v, y, d]), w = m.useMemo(() => ({
    ...u.elements,
    domReference: i.domReference
  }), [u.elements, i.domReference]), C = o.useState("open"), x = o.useState("floatingId"), E = m.useMemo(() => ({
    ...u,
    dataRef: o.context.dataRef,
    open: C,
    onOpenChange: o.setOpen,
    events: o.context.events,
    floatingId: x,
    refs: b,
    elements: w,
    nodeId: t,
    rootStore: o
  }), [u, b, w, t, o, C, x]);
  return ge(() => {
    o.context.dataRef.current.floatingContext = E;
    const S = c == null ? void 0 : c.nodesRef.current.find((R) => R.id === t);
    S && (S.context = E);
  }), m.useMemo(() => ({
    ...u,
    context: E,
    refs: b,
    elements: w,
    rootStore: o
  }), [u, b, w, E, o]);
}
function ac(e) {
  const {
    popupStore: t,
    noEmit: n = !1,
    treatPopupAsFloatingElement: r = !1,
    onOpenChange: o
  } = e, i = Do(), s = ar() != null, a = t.useState("open"), l = t.useState("activeTriggerElement"), c = t.useState(r ? "popupElement" : "positionerElement"), u = t.context.triggerElements, d = rn(() => new rf({
    open: a,
    referenceElement: l,
    floatingElement: c,
    triggerElements: u,
    onOpenChange: o,
    floatingId: i,
    nested: s,
    noEmit: n
  })).current;
  return ge(() => {
    const f = {
      open: a,
      floatingId: i,
      referenceElement: l,
      floatingElement: c
    };
    qe(l) && (f.domReferenceElement = l), d.state.positionReference === d.state.referenceElement && (f.positionReference = l), d.update(f);
  }, [a, i, l, c, d]), d.context.onOpenChange = o, d.context.nested = s, d.context.noEmit = n, d;
}
const Gc = hE && ob;
function Gb(e, t = {}) {
  const n = "rootStore" in e ? e.rootStore : e, {
    events: r,
    dataRef: o
  } = n.context, {
    enabled: i = !0,
    visibleOnly: s = !0,
    delay: a
  } = t, l = m.useRef(!1), c = m.useRef(null), u = un(), d = m.useRef(!0);
  m.useEffect(() => {
    const h = n.select("domReferenceElement");
    if (!i)
      return;
    const p = Wt(h);
    function g() {
      const b = n.select("domReferenceElement");
      !n.select("open") && gt(b) && b === Bn(Nt(b)) && (l.current = !0);
    }
    function v() {
      d.current = !0;
    }
    function y() {
      d.current = !1;
    }
    return p.addEventListener("blur", g), Gc && (p.addEventListener("keydown", v, !0), p.addEventListener("pointerdown", y, !0)), () => {
      p.removeEventListener("blur", g), Gc && (p.removeEventListener("keydown", v, !0), p.removeEventListener("pointerdown", y, !0));
    };
  }, [n, i]), m.useEffect(() => {
    if (!i)
      return;
    function h(p) {
      if (p.reason === Tn || p.reason === Os) {
        const g = n.select("domReferenceElement");
        qe(g) && (c.current = g, l.current = !0);
      }
    }
    return r.on("openchange", h), () => {
      r.off("openchange", h);
    };
  }, [r, i, n]);
  const f = m.useMemo(() => ({
    onMouseLeave() {
      l.current = !1, c.current = null;
    },
    onFocus(h) {
      const p = h.currentTarget;
      if (l.current) {
        if (c.current === p)
          return;
        l.current = !1, c.current = null;
      }
      const g = Xt(h.nativeEvent);
      if (s && qe(g)) {
        if (Gc && !h.relatedTarget) {
          if (!d.current && !Hd(g))
            return;
        } else if (!bE(g))
          return;
      }
      const v = h.relatedTarget && n.context.triggerElements.hasElement(h.relatedTarget), {
        nativeEvent: y,
        currentTarget: b
      } = h, w = typeof a == "function" ? a() : a;
      if (n.select("open") && v || w === 0 || w === void 0) {
        n.setOpen(!0, ke(Jo, y, b));
        return;
      }
      u.start(w, () => {
        l.current || n.setOpen(!0, ke(Jo, y, b));
      });
    },
    onBlur(h) {
      l.current = !1, c.current = null;
      const p = h.relatedTarget, g = h.nativeEvent, v = qe(p) && p.hasAttribute(ui("focus-guard")) && p.getAttribute("data-type") === "outside";
      u.start(0, () => {
        var C;
        const y = n.select("domReferenceElement"), b = Bn(y ? y.ownerDocument : document);
        if (!p && b === y || Ve((C = o.current.floatingContext) == null ? void 0 : C.refs.floating.current, b) || Ve(y, b) || v)
          return;
        const w = p ?? b;
        if (qe(w)) {
          const x = n.context.triggerElements;
          if (x.hasElement(w) || x.hasMatchingElement((E) => Ve(E, w)))
            return;
        }
        n.setOpen(!1, ke(Jo, g));
      });
    }
  }), [o, n, s, u, a]);
  return m.useMemo(() => i ? {
    reference: f,
    trigger: f
  } : {}, [i, f]);
}
const Xu = ui("safe-polygon"), D2 = `button,a,[role="button"],select,[tabindex]:not([tabindex="-1"]),${lb}`;
function A2(e) {
  return e ? !!e.closest(D2) : !1;
}
function Kb(e) {
  const t = m.useRef(void 0), n = m.useRef(!1), r = m.useRef(void 0), o = m.useRef(!0), i = m.useRef(!1), s = m.useRef(() => {
  }), a = m.useRef(!1), l = un(), c = un(), u = m.useRef(void 0);
  return m.useMemo(() => {
    const d = e.context.dataRef.current;
    return d.hoverInteractionState || (d.hoverInteractionState = {
      pointerTypeRef: t,
      interactedInsideRef: n,
      handlerRef: r,
      blockMouseMoveRef: o,
      performedPointerEventsMutationRef: i,
      unbindMouseMoveRef: s,
      restTimeoutPendingRef: a,
      openChangeTimeout: l,
      restTimeout: c,
      handleCloseOptionsRef: u
    }), d.hoverInteractionState;
  }, [e, t, n, r, o, i, s, a, l, c, u]);
}
const L2 = /* @__PURE__ */ new Set(["click", "mousedown"]);
function sf(e, t = {}) {
  const n = "rootStore" in e ? e.rootStore : e, r = n.useState("open"), o = n.useState("floatingElement"), i = n.useState("domReferenceElement"), {
    dataRef: s
  } = n.context, {
    enabled: a = !0,
    closeDelay: l = 0,
    externalTree: c
  } = t, {
    pointerTypeRef: u,
    interactedInsideRef: d,
    handlerRef: f,
    performedPointerEventsMutationRef: h,
    unbindMouseMoveRef: p,
    restTimeoutPendingRef: g,
    openChangeTimeout: v,
    handleCloseOptionsRef: y
  } = Kb(n), b = Xr(c), w = ar(), C = ve(() => d.current ? !0 : s.current.openEvent ? L2.has(s.current.openEvent.type) : !1), x = ve(() => {
    var P;
    const I = (P = s.current.openEvent) == null ? void 0 : P.type;
    return (I == null ? void 0 : I.includes("mouse")) && I !== "mousedown";
  }), E = m.useCallback((I, P = !0) => {
    const k = $2(l, u.current);
    k && !f.current ? v.start(k, () => n.setOpen(!1, ke(Dt, I))) : P && (v.clear(), n.setOpen(!1, ke(Dt, I)));
  }, [l, f, n, u, v]), S = ve(() => {
    p.current(), f.current = void 0;
  }), R = ve(() => {
    if (h.current) {
      const I = Nt(o).body;
      I.style.pointerEvents = "", I.removeAttribute(Xu), h.current = !1;
    }
  }), M = ve((I) => {
    const P = Xt(I);
    if (!A2(P)) {
      d.current = !1;
      return;
    }
    d.current = !0;
  });
  ge(() => {
    r || (u.current = void 0, g.current = !1, d.current = !1, S(), R());
  }, [r, u, g, d, S, R]), m.useEffect(() => () => {
    S();
  }, [S]), m.useEffect(() => R, [R]), ge(() => {
    var I, P, k;
    if (a && r && (I = y.current) != null && I.blockPointerEvents && x() && qe(i) && o) {
      h.current = !0;
      const O = Nt(o).body;
      O.setAttribute(Xu, "");
      const F = i, T = o, L = (k = (P = b == null ? void 0 : b.nodesRef.current.find((A) => A.id === w)) == null ? void 0 : P.context) == null ? void 0 : k.elements.floating;
      return L && (L.style.pointerEvents = ""), O.style.pointerEvents = "none", F.style.pointerEvents = "auto", T.style.pointerEvents = "auto", () => {
        O.style.pointerEvents = "", F.style.pointerEvents = "", T.style.pointerEvents = "";
      };
    }
  }, [a, r, i, o, y, x, b, w, h]), m.useEffect(() => {
    if (!a)
      return;
    function I(F) {
      if (C() || !s.current.floatingContext || !n.select("open"))
        return;
      const T = n.context.triggerElements;
      F.relatedTarget && T.hasElement(F.relatedTarget) || (R(), S(), C() || E(F));
    }
    function P(F) {
      var T;
      v.clear(), R(), (T = f.current) == null || T.call(f, F), S();
    }
    function k(F) {
      C() || E(F, !1);
    }
    const O = o;
    return O && (O.addEventListener("mouseleave", I), O.addEventListener("mouseenter", P), O.addEventListener("mouseleave", k), O.addEventListener("pointerdown", M, !0)), () => {
      O && (O.removeEventListener("mouseleave", I), O.removeEventListener("mouseenter", P), O.removeEventListener("mouseleave", k), O.removeEventListener("pointerdown", M, !0));
    };
  });
}
function $2(e, t) {
  return t && !Co(t) ? 0 : typeof e == "function" ? e() : e;
}
function Kc(e) {
  return typeof e == "function" ? e() : e;
}
const F2 = {
  current: null
};
function lc(e, t = {}) {
  var A;
  const n = "rootStore" in e ? e.rootStore : e, {
    dataRef: r,
    events: o
  } = n.context, {
    enabled: i = !0,
    delay: s = 0,
    handleClose: a = null,
    mouseOnly: l = !1,
    restMs: c = 0,
    move: u = !0,
    triggerElementRef: d = F2,
    externalTree: f,
    isActiveTrigger: h = !0
  } = t, p = Xr(f), {
    pointerTypeRef: g,
    interactedInsideRef: v,
    handlerRef: y,
    blockMouseMoveRef: b,
    performedPointerEventsMutationRef: w,
    unbindMouseMoveRef: C,
    restTimeoutPendingRef: x,
    openChangeTimeout: E,
    restTimeout: S,
    handleCloseOptionsRef: R
  } = Kb(n), M = Gt(a), I = Gt(s), P = Gt(c);
  h && (R.current = (A = M.current) == null ? void 0 : A.__options);
  const k = ve(() => v.current ? !0 : r.current.openEvent ? ["click", "mousedown"].includes(r.current.openEvent.type) : !1), O = m.useCallback((N, B = !0) => {
    const $ = Ba(I.current, "close", g.current);
    $ && !y.current ? E.start($, () => n.setOpen(!1, ke(Dt, N))) : B && (E.clear(), n.setOpen(!1, ke(Dt, N)));
  }, [I, y, n, g, E]), F = ve(() => {
    C.current(), y.current = void 0;
  }), T = ve(() => {
    if (w.current) {
      const N = Nt(n.select("domReferenceElement")).body;
      N.style.pointerEvents = "", N.removeAttribute(Xu), w.current = !1;
    }
  });
  m.useEffect(() => {
    if (!i)
      return;
    function N(B) {
      B.open || (E.clear(), S.clear(), b.current = !0, x.current = !1);
    }
    return o.on("openchange", N), () => {
      o.off("openchange", N);
    };
  }, [i, o, E, S, b, x]);
  const L = ve((N) => {
    var U;
    if (k() || !r.current.floatingContext)
      return;
    const B = n.context.triggerElements;
    if (N.relatedTarget && B.hasElement(N.relatedTarget))
      return;
    const $ = d.current;
    (U = M.current) == null || U.call(M, {
      ...r.current.floatingContext,
      tree: p,
      x: N.clientX,
      y: N.clientY,
      onClose() {
        T(), F(), !k() && $ === n.select("domReferenceElement") && O(N);
      }
    })(N);
  });
  return m.useEffect(() => {
    if (!i)
      return;
    const N = d.current ?? (h ? n.select("domReferenceElement") : null);
    if (!qe(N))
      return;
    function B(G) {
      if (E.clear(), b.current = !1, l && !Co(g.current) || Kc(P.current) > 0 && !Ba(I.current, "open"))
        return;
      const H = Ba(I.current, "open", g.current), q = n.select("domReferenceElement"), j = n.context.triggerElements, W = (j.hasElement(G.target) || j.hasMatchingElement((ne) => Ve(ne, G.target))) && (!q || !Ve(q, G.target)), z = G.currentTarget ?? null, X = n.select("open"), J = !X || W;
      W && X ? n.setOpen(!0, ke(Dt, G, z)) : H ? E.start(H, () => {
        J && n.setOpen(!0, ke(Dt, G, z));
      }) : J && n.setOpen(!0, ke(Dt, G, z));
    }
    function $(G) {
      if (k()) {
        T();
        return;
      }
      C.current();
      const H = n.select("domReferenceElement"), q = Nt(H);
      S.clear(), x.current = !1;
      const j = n.context.triggerElements;
      if (G.relatedTarget && j.hasElement(G.relatedTarget))
        return;
      if (M.current && r.current.floatingContext) {
        n.select("open") || E.clear();
        const z = d.current;
        y.current = M.current({
          ...r.current.floatingContext,
          tree: p,
          x: G.clientX,
          y: G.clientY,
          onClose() {
            T(), F(), !k() && z === n.select("domReferenceElement") && O(G, !0);
          }
        });
        const X = y.current;
        X(G), q.addEventListener("mousemove", X), C.current = () => {
          q.removeEventListener("mousemove", X);
        };
        return;
      }
      (g.current === "touch" ? !Ve(n.select("floatingElement"), G.relatedTarget) : !0) && O(G);
    }
    function U(G) {
      L(G);
    }
    return n.select("open") && N.addEventListener("mouseleave", U), u && N.addEventListener("mousemove", B, {
      once: !0
    }), N.addEventListener("mouseenter", B), N.addEventListener("mouseleave", $), () => {
      N.removeEventListener("mouseleave", U), u && N.removeEventListener("mousemove", B), N.removeEventListener("mouseenter", B), N.removeEventListener("mouseleave", $);
    };
  }, [F, T, b, r, I, O, n, i, M, L, h, k, l, u, g, P, S, x, E, d, p, C, y]), m.useMemo(() => {
    function N(B) {
      g.current = B.pointerType;
    }
    return {
      onPointerDown: N,
      onPointerEnter: N,
      onMouseMove(B) {
        const {
          nativeEvent: $
        } = B, U = B.currentTarget, G = n.select("domReferenceElement"), H = n.context.triggerElements, q = n.select("open"), j = (H.hasElement(B.target) || H.hasMatchingElement((z) => Ve(z, B.target))) && (!G || !Ve(G, B.target));
        if (l && !Co(g.current) || q && !j || Kc(P.current) === 0 || !j && x.current && B.movementX ** 2 + B.movementY ** 2 < 2)
          return;
        S.clear();
        function W() {
          if (x.current = !1, k())
            return;
          const z = n.select("open");
          !b.current && (!z || j) && n.setOpen(!0, ke(Dt, $, U));
        }
        g.current === "touch" ? nn.flushSync(() => {
          W();
        }) : j && q ? W() : (x.current = !0, S.start(Kc(P.current), W));
      }
    };
  }, [b, k, l, n, g, P, S, x]);
}
function Qr(e = []) {
  const t = e.map((c) => c == null ? void 0 : c.reference), n = e.map((c) => c == null ? void 0 : c.floating), r = e.map((c) => c == null ? void 0 : c.item), o = e.map((c) => c == null ? void 0 : c.trigger), i = m.useCallback(
    (c) => sa(c, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), s = m.useCallback(
    (c) => sa(c, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), a = m.useCallback(
    (c) => sa(c, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  ), l = m.useCallback(
    (c) => sa(c, e, "trigger"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o
  );
  return m.useMemo(() => ({
    getReferenceProps: i,
    getFloatingProps: s,
    getItemProps: a,
    getTriggerProps: l
  }), [i, s, a, l]);
}
function sa(e, t, n) {
  var s;
  const r = /* @__PURE__ */ new Map(), o = n === "item", i = {};
  n === "floating" && (i.tabIndex = -1, i[Hu] = "");
  for (const a in e)
    o && e && (a === sb || a === ab) || (i[a] = e[a]);
  for (let a = 0; a < t.length; a += 1) {
    let l;
    const c = (s = t[a]) == null ? void 0 : s[n];
    typeof c == "function" ? l = e ? c(e) : null : l = c, l && Wp(i, l, o, r);
  }
  return Wp(i, e, o, r), i;
}
function Wp(e, t, n, r) {
  var o;
  for (const i in t) {
    const s = t[i];
    n && (i === sb || i === ab) || (i.startsWith("on") ? (r.has(i) || r.set(i, []), typeof s == "function" && ((o = r.get(i)) == null || o.push(s), e[i] = (...a) => {
      var l;
      return (l = r.get(i)) == null ? void 0 : l.map((c) => c(...a)).find((c) => c !== void 0);
    })) : e[i] = s);
  }
}
const V2 = "Escape";
function cc(e, t, n) {
  switch (e) {
    case "vertical":
      return t;
    case "horizontal":
      return n;
    default:
      return t || n;
  }
}
function aa(e, t) {
  return cc(t, e === Bd || e === Ss, e === Hr || e === Wr);
}
function qc(e, t, n) {
  return cc(t, e === Ss, n ? e === Hr : e === Wr) || e === "Enter" || e === " " || e === "";
}
function B2(e, t, n) {
  return cc(t, n ? e === Hr : e === Wr, e === Ss);
}
function H2(e, t, n, r) {
  const o = n ? e === Wr : e === Hr, i = e === Bd;
  return t === "both" || t === "horizontal" && r && r > 1 ? e === V2 : cc(t, o, i);
}
function W2(e, t) {
  const n = "rootStore" in e ? e.rootStore : e, r = n.useState("open"), o = n.useState("floatingElement"), i = n.useState("domReferenceElement"), s = n.context.dataRef, {
    listRef: a,
    activeIndex: l,
    onNavigate: c = () => {
    },
    enabled: u = !0,
    selectedIndex: d = null,
    allowEscape: f = !1,
    loopFocus: h = !1,
    nested: p = !1,
    rtl: g = !1,
    virtual: v = !1,
    focusItemOnOpen: y = "auto",
    focusItemOnHover: b = !0,
    openOnArrowKeyDown: w = !0,
    disabledIndices: C = void 0,
    orientation: x = "vertical",
    parentOrientation: E,
    cols: S = 1,
    scrollItemIntoView: R = !0,
    itemSizes: M,
    dense: I = !1,
    id: P,
    resetOnPointerLeave: k = !0,
    externalTree: O
  } = t;
  process.env.NODE_ENV !== "production" && (f && (h || console.warn("`useListNavigation` looping must be enabled to allow escaping."), v || console.warn("`useListNavigation` must be virtual to allow escaping.")), x === "vertical" && S > 1 && console.warn("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const F = ol(o), T = Gt(F), L = ar(), A = Xr(O);
  ge(() => {
    s.current.orientation = x;
  }, [s, x]);
  const N = Wu(i), B = m.useRef(y), $ = m.useRef(d ?? -1), U = m.useRef(null), G = m.useRef(!0), H = ve((ie) => {
    c($.current === -1 ? null : $.current, ie);
  }), q = m.useRef(H), j = m.useRef(!!o), W = m.useRef(r), z = m.useRef(!1), X = m.useRef(!1), J = Gt(C), ne = Gt(r), Q = Gt(R), D = Gt(d), te = Gt(k), K = ve(() => {
    function ie(Me) {
      v ? A == null || A.events.emit("virtualfocus", Me) : Ha(Me, {
        sync: z.current,
        preventScroll: !0
      });
    }
    const he = a.current[$.current], fe = X.current;
    he && ie(he), (z.current ? (Me) => Me() : requestAnimationFrame)(() => {
      var Fe;
      const Me = a.current[$.current] || he;
      if (!Me)
        return;
      he || ie(Me);
      const $e = Q.current;
      $e && // eslint-disable-next-line @typescript-eslint/no-use-before-define
      ee && (fe || !G.current) && ((Fe = Me.scrollIntoView) == null || Fe.call(Me, typeof $e == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : $e));
    });
  });
  ge(() => {
    u && (r && o ? ($.current = d ?? -1, B.current && d != null && (X.current = !0, H())) : j.current && ($.current = -1, q.current()));
  }, [u, r, o, d, H]), ge(() => {
    if (u) {
      if (!r) {
        z.current = !1;
        return;
      }
      if (o)
        if (l == null) {
          if (z.current = !1, D.current != null)
            return;
          if (j.current && ($.current = -1, K()), (!W.current || !j.current) && B.current && (U.current != null || B.current === !0 && U.current == null)) {
            let ie = 0;
            const he = () => {
              a.current[0] == null ? (ie < 2 && (ie ? requestAnimationFrame : queueMicrotask)(he), ie += 1) : ($.current = U.current == null || qc(U.current, x, g) || p ? Fa(a) : Uu(a), U.current = null, H());
            };
            he();
          }
        } else
          Qo(a, l) || ($.current = l, K(), X.current = !1);
    }
  }, [u, r, o, l, D, p, a, x, g, H, K, J]), ge(() => {
    var Me, $e;
    if (!u || o || !A || v || !j.current)
      return;
    const ie = A.nodesRef.current, he = ($e = (Me = ie.find((Ne) => Ne.id === L)) == null ? void 0 : Me.context) == null ? void 0 : $e.elements.floating, fe = Bn(Nt(o)), Se = ie.some((Ne) => Ne.context && Ve(Ne.context.elements.floating, fe));
    he && !Se && G.current && he.focus({
      preventScroll: !0
    });
  }, [u, o, A, L, v]), ge(() => {
    q.current = H, W.current = r, j.current = !!o;
  }), ge(() => {
    r || (U.current = null, B.current = y);
  }, [r, y]);
  const ce = l != null, ee = m.useMemo(() => {
    function ie(fe) {
      if (!ne.current)
        return;
      const Se = a.current.indexOf(fe.currentTarget);
      Se !== -1 && $.current !== Se && ($.current = Se, H(fe));
    }
    return {
      onFocus(fe) {
        z.current = !0, ie(fe);
      },
      onClick: ({
        currentTarget: fe
      }) => fe.focus({
        preventScroll: !0
      }),
      // Safari
      onMouseMove(fe) {
        z.current = !0, X.current = !1, b && ie(fe);
      },
      onPointerLeave(fe) {
        var Me;
        if (!ne.current || !G.current || fe.pointerType === "touch")
          return;
        z.current = !0;
        const Se = fe.relatedTarget;
        !b || a.current.includes(Se) || te.current && ($.current = -1, H(fe), v || (Me = T.current) == null || Me.focus({
          preventScroll: !0
        }));
      }
    };
  }, [ne, T, b, a, H, te, v]), re = m.useCallback(() => {
    var ie, he, fe;
    return E ?? ((fe = (he = (ie = A == null ? void 0 : A.nodesRef.current.find((Se) => Se.id === L)) == null ? void 0 : ie.context) == null ? void 0 : he.dataRef) == null ? void 0 : fe.current.orientation);
  }, [L, A, E]), le = ve((ie) => {
    if (G.current = !1, z.current = !0, ie.which === 229 || !ne.current && ie.currentTarget === T.current)
      return;
    if (p && H2(ie.key, x, g, S)) {
      aa(ie.key, re()) || qt(ie), n.setOpen(!1, ke(Va, ie.nativeEvent)), gt(i) && (v ? A == null || A.events.emit("virtualfocus", i) : i.focus());
      return;
    }
    const he = $.current, fe = Fa(a, C), Se = Uu(a, C);
    if (N || (ie.key === "Home" && (qt(ie), $.current = fe, H(ie)), ie.key === "End" && (qt(ie), $.current = Se, H(ie))), S > 1) {
      const Me = M || Array.from({
        length: a.current.length
      }, () => ({
        width: 1,
        height: 1
      })), $e = pb(Me, S, I), Ne = $e.findIndex((bt) => bt != null && !zr(a, bt, C)), Fe = $e.reduce((bt, Pt, Te) => Pt != null && !zr(a, Pt, C) ? Te : bt, -1), Ae = $e[hb({
        current: $e.map((bt) => bt != null ? a.current[bt] : null)
      }, {
        event: ie,
        orientation: x,
        loopFocus: h,
        rtl: g,
        cols: S,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: mb([...(typeof C != "function" ? C : null) || a.current.map((bt, Pt) => zr(a, Pt, C) ? Pt : void 0), void 0], $e),
        minIndex: Ne,
        maxIndex: Fe,
        prevIndex: gb(
          $.current > Se ? fe : $.current,
          Me,
          $e,
          S,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          // eslint-disable-next-line no-nested-ternary
          ie.key === Ss ? "bl" : ie.key === (g ? Hr : Wr) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (Ae != null && ($.current = Ae, H(ie)), x === "both")
        return;
    }
    if (aa(ie.key, x)) {
      if (qt(ie), r && !v && Bn(ie.currentTarget.ownerDocument) === ie.currentTarget) {
        $.current = qc(ie.key, x, g) ? fe : Se, H(ie);
        return;
      }
      qc(ie.key, x, g) ? h ? he >= Se ? f && he !== a.current.length ? $.current = -1 : (z.current = !1, $.current = fe) : $.current = Yt(a, {
        startingIndex: he,
        disabledIndices: C
      }) : $.current = Math.min(Se, Yt(a, {
        startingIndex: he,
        disabledIndices: C
      })) : h ? he <= fe ? f && he !== -1 ? $.current = a.current.length : (z.current = !1, $.current = Se) : $.current = Yt(a, {
        startingIndex: he,
        decrement: !0,
        disabledIndices: C
      }) : $.current = Math.max(fe, Yt(a, {
        startingIndex: he,
        decrement: !0,
        disabledIndices: C
      })), Qo(a, $.current) && ($.current = -1), H(ie);
    }
  }), de = m.useMemo(() => v && r && ce && {
    "aria-activedescendant": `${P}-${l}`
  }, [v, r, ce, P, l]), be = m.useMemo(() => ({
    "aria-orientation": x === "both" ? void 0 : x,
    ...N ? {} : de,
    onKeyDown(ie) {
      if (ie.key === "Tab" && ie.shiftKey && r && !v) {
        const he = Xt(ie.nativeEvent);
        if (he && !Ve(T.current, he))
          return;
        qt(ie), n.setOpen(!1, ke(_r, ie.nativeEvent)), gt(i) && i.focus();
        return;
      }
      le(ie);
    },
    onPointerMove() {
      G.current = !0;
    }
  }), [de, le, T, x, N, n, r, v, i]), ye = m.useMemo(() => {
    function ie(fe) {
      y === "auto" && cb(fe.nativeEvent) && (B.current = !v);
    }
    function he(fe) {
      B.current = y, y === "auto" && ub(fe.nativeEvent) && (B.current = !0);
    }
    return {
      onKeyDown(fe) {
        const Se = n.select("open");
        G.current = !1;
        const Me = fe.key.startsWith("Arrow"), $e = B2(fe.key, re(), g), Ne = aa(fe.key, x), Fe = (p ? $e : Ne) || fe.key === "Enter" || fe.key.trim() === "";
        if (v && Se)
          return le(fe);
        if (!(!Se && !w && Me)) {
          if (Fe) {
            const Ae = aa(fe.key, re());
            U.current = p && Ae ? null : fe.key;
          }
          if (p) {
            $e && (qt(fe), Se ? ($.current = Fa(a, J.current), H(fe)) : n.setOpen(!0, ke(Va, fe.nativeEvent, fe.currentTarget)));
            return;
          }
          Ne && (D.current != null && ($.current = D.current), qt(fe), !Se && w ? n.setOpen(!0, ke(Va, fe.nativeEvent, fe.currentTarget)) : le(fe), Se && H(fe));
        }
      },
      onFocus(fe) {
        n.select("open") && !v && ($.current = -1, H(fe));
      },
      onPointerDown: he,
      onPointerEnter: he,
      onMouseDown: ie,
      onClick: ie
    };
  }, [le, J, y, a, p, H, n, w, x, re, g, D, v]), Ce = m.useMemo(() => ({
    ...de,
    ...ye
  }), [de, ye]);
  return m.useMemo(() => u ? {
    reference: Ce,
    floating: be,
    item: ee,
    trigger: ye
  } : {}, [u, Ce, be, ye, ee]);
}
const z2 = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function af(e, t = {}) {
  const n = "rootStore" in e ? e.rootStore : e, r = n.useState("open"), o = n.useState("floatingId"), i = n.useState("domReferenceElement"), s = n.useState("floatingElement"), {
    enabled: a = !0,
    role: l = "dialog"
  } = t, c = Do(), u = (i == null ? void 0 : i.id) || c, d = m.useMemo(() => {
    var w;
    return ((w = ol(s)) == null ? void 0 : w.id) || o;
  }, [s, o]), f = z2.get(l) ?? l, p = ar() != null, g = m.useMemo(() => f === "tooltip" || l === "label" ? Rt : {
    "aria-haspopup": f === "alertdialog" ? "dialog" : f,
    "aria-expanded": "false",
    ...f === "listbox" && {
      role: "combobox"
    },
    ...f === "menu" && p && {
      role: "menuitem"
    },
    ...l === "select" && {
      "aria-autocomplete": "none"
    },
    ...l === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [f, p, l]), v = m.useMemo(() => f === "tooltip" || l === "label" ? {
    [`aria-${l === "label" ? "labelledby" : "describedby"}`]: r ? d : void 0
  } : {
    ...g,
    "aria-expanded": r ? "true" : "false",
    "aria-controls": r ? d : void 0,
    ...f === "menu" && {
      id: u
    }
  }, [f, d, r, u, l, g]), y = m.useMemo(() => {
    const w = {
      id: d,
      ...f && {
        role: f
      }
    };
    return f === "tooltip" || l === "label" ? w : {
      ...w,
      ...f === "menu" && {
        "aria-labelledby": u
      }
    };
  }, [f, d, u, l]), b = m.useCallback(({
    active: w,
    selected: C
  }) => {
    const x = {
      role: "option",
      ...w && {
        id: `${d}-fui-option`
      }
    };
    switch (l) {
      case "select":
      case "combobox":
        return {
          ...x,
          "aria-selected": C
        };
    }
    return {};
  }, [d, l]);
  return m.useMemo(() => a ? {
    reference: v,
    floating: y,
    item: b,
    trigger: g
  } : {}, [a, v, y, g, b]);
}
function j2(e, t) {
  const n = "rootStore" in e ? e.rootStore : e, r = n.useState("open"), o = n.context.dataRef, {
    listRef: i,
    activeIndex: s,
    onMatch: a,
    onTypingChange: l,
    enabled: c = !0,
    findMatch: u = null,
    resetMs: d = 750,
    ignoreKeys: f = wo,
    selectedIndex: h = null
  } = t, p = un(), g = m.useRef(""), v = m.useRef(h ?? s ?? -1), y = m.useRef(null);
  ge(() => {
    r && (p.clear(), y.current = null, g.current = "");
  }, [r, p]), ge(() => {
    r && g.current === "" && (v.current = h ?? s ?? -1);
  }, [r, h, s]);
  const b = ve((E) => {
    E ? o.current.typing || (o.current.typing = E, l == null || l(E)) : o.current.typing && (o.current.typing = E, l == null || l(E));
  }), w = ve((E) => {
    function S(k, O, F) {
      const T = u ? u(O, F) : O.find((L) => (L == null ? void 0 : L.toLocaleLowerCase().indexOf(F.toLocaleLowerCase())) === 0);
      return T ? k.indexOf(T) : -1;
    }
    const R = i.current;
    if (g.current.length > 0 && g.current[0] !== " " && (S(R, R, g.current) === -1 ? b(!1) : E.key === " " && qt(E)), R == null || f.includes(E.key) || // Character key.
    E.key.length !== 1 || // Modifier key.
    E.ctrlKey || E.metaKey || E.altKey)
      return;
    r && E.key !== " " && (qt(E), b(!0)), R.every((k) => {
      var O, F;
      return k ? ((O = k[0]) == null ? void 0 : O.toLocaleLowerCase()) !== ((F = k[1]) == null ? void 0 : F.toLocaleLowerCase()) : !0;
    }) && g.current === E.key && (g.current = "", v.current = y.current), g.current += E.key, p.start(d, () => {
      g.current = "", v.current = y.current, b(!1);
    });
    const I = v.current, P = S(R, [...R.slice((I || 0) + 1), ...R.slice(0, (I || 0) + 1)], g.current);
    P !== -1 ? (a == null || a(P), y.current = P) : E.key !== " " && (g.current = "", b(!1));
  }), C = m.useMemo(() => ({
    onKeyDown: w
  }), [w]), x = m.useMemo(() => ({
    onKeyDown: w,
    onKeyUp(E) {
      E.key === " " && b(!1);
    }
  }), [w, b]);
  return m.useMemo(() => c ? {
    reference: C,
    floating: x
  } : {}, [c, C, x]);
}
function zp(e, t) {
  const [n, r] = e;
  let o = !1;
  const i = t.length;
  for (let s = 0, a = i - 1; s < i; a = s++) {
    const [l, c] = t[s] || [0, 0], [u, d] = t[a] || [0, 0];
    c >= r != d >= r && n <= (u - l) * (r - c) / (d - c) + l && (o = !o);
  }
  return o;
}
function U2(e, t) {
  return e[0] >= t.x && e[0] <= t.x + t.width && e[1] >= t.y && e[1] <= t.y + t.height;
}
function uc(e = {}) {
  const {
    buffer: t = 0.5,
    blockPointerEvents: n = !1,
    requireIntent: r = !0
  } = e, o = new wr();
  let i = !1, s = null, a = null, l = typeof performance < "u" ? performance.now() : 0;
  function c(d, f) {
    const h = performance.now(), p = h - l;
    if (s === null || a === null || p === 0)
      return s = d, a = f, l = h, null;
    const g = d - s, v = f - a, b = Math.sqrt(g * g + v * v) / p;
    return s = d, a = f, l = h, b;
  }
  const u = ({
    x: d,
    y: f,
    placement: h,
    elements: p,
    onClose: g,
    nodeId: v,
    tree: y
  }) => function(w) {
    function C() {
      o.clear(), g();
    }
    if (o.clear(), !p.domReference || !p.floating || h == null || d == null || f == null)
      return;
    const {
      clientX: x,
      clientY: E
    } = w, S = [x, E], R = Xt(w), M = w.type === "mouseleave", I = Ve(p.floating, R), P = Ve(p.domReference, R), k = p.domReference.getBoundingClientRect(), O = p.floating.getBoundingClientRect(), F = h.split("-")[0], T = d > O.right - O.width / 2, L = f > O.bottom - O.height / 2, A = U2(S, k), N = O.width > k.width, B = O.height > k.height, $ = (N ? k : O).left, U = (N ? k : O).right, G = (B ? k : O).top, H = (B ? k : O).bottom;
    if (I && (i = !0, !M))
      return;
    if (P && (i = !1), P && !M) {
      i = !0;
      return;
    }
    if (M && qe(w.relatedTarget) && Ve(p.floating, w.relatedTarget) || y && vo(y.nodesRef.current, v).some(({
      context: W
    }) => W == null ? void 0 : W.open))
      return;
    if (F === "top" && f >= k.bottom - 1 || F === "bottom" && f <= k.top + 1 || F === "left" && d >= k.right - 1 || F === "right" && d <= k.left + 1)
      return C();
    let q = [];
    switch (F) {
      case "top":
        q = [[$, k.top + 1], [$, O.bottom - 1], [U, O.bottom - 1], [U, k.top + 1]];
        break;
      case "bottom":
        q = [[$, O.top + 1], [$, k.bottom - 1], [U, k.bottom - 1], [U, O.top + 1]];
        break;
      case "left":
        q = [[O.right - 1, H], [O.right - 1, G], [k.left + 1, G], [k.left + 1, H]];
        break;
      case "right":
        q = [[k.right - 1, H], [k.right - 1, G], [O.left + 1, G], [O.left + 1, H]];
        break;
    }
    function j([W, z]) {
      switch (F) {
        case "top": {
          const X = [N ? W + t / 2 : T ? W + t * 4 : W - t * 4, z + t + 1], J = [N ? W - t / 2 : T ? W + t * 4 : W - t * 4, z + t + 1], ne = [[O.left, T || N ? O.bottom - t : O.top], [O.right, T ? N ? O.bottom - t : O.top : O.bottom - t]];
          return [X, J, ...ne];
        }
        case "bottom": {
          const X = [N ? W + t / 2 : T ? W + t * 4 : W - t * 4, z - t], J = [N ? W - t / 2 : T ? W + t * 4 : W - t * 4, z - t], ne = [[O.left, T || N ? O.top + t : O.bottom], [O.right, T ? N ? O.top + t : O.bottom : O.top + t]];
          return [X, J, ...ne];
        }
        case "left": {
          const X = [W + t + 1, B ? z + t / 2 : L ? z + t * 4 : z - t * 4], J = [W + t + 1, B ? z - t / 2 : L ? z + t * 4 : z - t * 4];
          return [...[[L || B ? O.right - t : O.left, O.top], [L ? B ? O.right - t : O.left : O.right - t, O.bottom]], X, J];
        }
        case "right": {
          const X = [W - t, B ? z + t / 2 : L ? z + t * 4 : z - t * 4], J = [W - t, B ? z - t / 2 : L ? z + t * 4 : z - t * 4], ne = [[L || B ? O.left + t : O.right, O.top], [L ? B ? O.left + t : O.right : O.left + t, O.bottom]];
          return [X, J, ...ne];
        }
        default:
          return [];
      }
    }
    if (!zp([x, E], q)) {
      if (i && !A)
        return C();
      if (!M && r) {
        const W = c(w.clientX, w.clientY);
        if (W !== null && W < 0.1)
          return C();
      }
      zp([x, E], j([d, f])) ? !i && r && o.start(40, C) : C();
    }
  };
  return u.__options = {
    blockPointerEvents: n
  }, u;
}
const Y2 = {
  ...sc,
  disabled: Ee((e) => e.disabled),
  instantType: Ee((e) => e.instantType),
  isInstantPhase: Ee((e) => e.isInstantPhase),
  trackCursorAxis: Ee((e) => e.trackCursorAxis),
  disableHoverablePopup: Ee((e) => e.disableHoverablePopup),
  lastOpenChangeReason: Ee((e) => e.openChangeReason),
  closeDelay: Ee((e) => e.closeDelay),
  hasViewport: Ee((e) => e.hasViewport)
};
class lf extends Ts {
  constructor(n) {
    super({
      ...G2(),
      ...n
    }, {
      popupRef: /* @__PURE__ */ m.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new _i()
    }, Y2);
    ae(this, "setOpen", (n, r) => {
      var c, u;
      const o = r.reason, i = o === Dt, s = n && o === Jo, a = !n && (o === Tn || o === Os);
      if (r.preventUnmountOnClose = () => {
        this.set("preventUnmountingOnClose", !0);
      }, (u = (c = this.context).onOpenChange) == null || u.call(c, n, r), r.isCanceled)
        return;
      const l = () => {
        var h;
        const d = {
          open: n,
          openChangeReason: o
        };
        s ? d.instantType = "focus" : a ? d.instantType = "dismiss" : o === Dt && (d.instantType = void 0);
        const f = ((h = r.trigger) == null ? void 0 : h.id) ?? null;
        (f || n) && (d.activeTriggerId = f, d.activeTriggerElement = r.trigger ?? null), this.update(d);
      };
      i ? nn.flushSync(l) : l();
    });
  }
  static useStore(n, r) {
    const o = rn(() => new lf(r)).current, i = n ?? o, s = ac({
      popupStore: i,
      onOpenChange: i.setOpen
    });
    return i.state.floatingRootContext = s, i;
  }
}
function G2() {
  return {
    ...ic(),
    disabled: !1,
    instantType: void 0,
    isInstantPhase: !1,
    trackCursorAxis: "none",
    disableHoverablePopup: !1,
    openChangeReason: null,
    closeDelay: 0,
    hasViewport: !1
  };
}
function K2(e) {
  const {
    disabled: t = !1,
    defaultOpen: n = !1,
    open: r,
    disableHoverablePopup: o = !1,
    trackCursorAxis: i = "none",
    actionsRef: s,
    onOpenChange: a,
    onOpenChangeComplete: l,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null,
    children: f
  } = e, h = lf.useStore(c == null ? void 0 : c.store, {
    open: r ?? n,
    activeTriggerId: u !== void 0 ? u : d
  });
  h.useControlledProp("open", r, n), h.useControlledProp("activeTriggerId", u, d), h.useContextCallback("onOpenChange", a), h.useContextCallback("onOpenChangeComplete", l);
  const p = h.useState("open"), g = !t && p, v = h.useState("activeTriggerId"), y = h.useState("payload");
  h.useSyncedValues({
    trackCursorAxis: i,
    disableHoverablePopup: o
  }), ge(() => {
    p && t && h.setOpen(!1, ke(ZE));
  }, [p, t, h]), h.useSyncedValue("disabled", t), rc(h);
  const {
    forceUnmount: b,
    transitionStatus: w
  } = oc(g, h), C = h.useState("isInstantPhase"), x = h.useState("instantType"), E = h.useState("lastOpenChangeReason"), S = m.useRef(null);
  ge(() => {
    w === "ending" && E === _o || w !== "ending" && C ? (x !== "delay" && (S.current = x), h.set("instantType", "delay")) : S.current !== null && (h.set("instantType", S.current), S.current = null);
  }, [w, C, E, x, h]), ge(() => {
    g && v == null && h.set("payload", void 0);
  }, [h, v, g]);
  const R = m.useCallback(() => {
    h.setOpen(!1, q2(h, Xl));
  }, [h]);
  m.useImperativeHandle(s, () => ({
    unmount: b,
    close: R
  }), [b, R]);
  const M = h.useState("floatingRootContext"), I = Gb(M, {
    enabled: !t
  }), P = ec(M, {
    enabled: !t,
    referencePress: !0
  }), k = dS(M, {
    enabled: !t && i !== "none",
    axis: i === "none" ? void 0 : i
  }), {
    getReferenceProps: O,
    getFloatingProps: F,
    getTriggerProps: T
  } = Qr([I, P, k]), L = m.useMemo(() => O(), [O]), A = m.useMemo(() => T(), [T]), N = m.useMemo(() => F(), [F]);
  return h.useSyncedValues({
    activeTriggerProps: L,
    inactiveTriggerProps: A,
    popupProps: N
  }), /* @__PURE__ */ _($d.Provider, {
    value: h,
    children: typeof f == "function" ? f({
      payload: y
    }) : f
  });
}
function q2(e, t) {
  const n = ke(t);
  return n.preventUnmountOnClose = () => {
    e.set("preventUnmountingOnClose", !0);
  }, n;
}
let Hn = function(e) {
  return e.open = "data-open", e.closed = "data-closed", e[e.startingStyle = So.startingStyle] = "startingStyle", e[e.endingStyle = So.endingStyle] = "endingStyle", e.anchorHidden = "data-anchor-hidden", e;
}({}), Zu = /* @__PURE__ */ function(e) {
  return e.popupOpen = "data-popup-open", e.pressed = "data-pressed", e;
}({});
const X2 = {
  [Zu.popupOpen]: ""
}, Z2 = {
  [Zu.popupOpen]: "",
  [Zu.pressed]: ""
}, Q2 = {
  [Hn.open]: ""
}, J2 = {
  [Hn.closed]: ""
}, eM = {
  [Hn.anchorHidden]: ""
}, dc = {
  open(e) {
    return e ? X2 : null;
  }
}, Qu = {
  open(e) {
    return e ? Z2 : null;
  }
}, Un = {
  open(e) {
    return e ? Q2 : J2;
  },
  anchorHidden(e) {
    return e ? eM : null;
  }
};
function Kt(e) {
  return Do(e, "base-ui");
}
const cf = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (cf.displayName = "TooltipProviderContext");
function tM() {
  return m.useContext(cf);
}
const nM = 600, qb = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    handle: i,
    payload: s,
    disabled: a,
    delay: l,
    closeDelay: c,
    id: u,
    ...d
  } = t, f = Es(!0), h = (i == null ? void 0 : i.store) ?? f;
  if (!h)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Trigger> must be either used within a <Tooltip.Root> component or provided with a handle." : Ke(82));
  const p = Kt(u), g = h.useState("isTriggerActive", p), v = h.useState("isOpenedByTrigger", p), y = h.useState("floatingRootContext"), b = m.useRef(null), w = l ?? nM, C = c ?? 0, {
    registerTrigger: x,
    isMountedByThisTrigger: E
  } = nc(p, b, h, {
    payload: s,
    closeDelay: C
  }), S = tM(), {
    delayRef: R,
    isInstantPhase: M,
    hasProvider: I
  } = JE(y, {
    open: v
  });
  h.useSyncedValue("isInstantPhase", M);
  const P = h.useState("disabled"), k = a ?? P, O = h.useState("trackCursorAxis"), F = h.useState("disableHoverablePopup"), T = lc(y, {
    enabled: !k,
    mouseOnly: !0,
    move: !1,
    handleClose: !F && O !== "both" ? uc() : null,
    restMs() {
      const B = S == null ? void 0 : S.delay, $ = typeof R.current == "object" ? R.current.open : void 0;
      let U = w;
      return I && ($ !== 0 ? U = l ?? B ?? w : U = 0), U;
    },
    delay() {
      const B = typeof R.current == "object" ? R.current.close : void 0;
      let $ = C;
      return c == null && I && ($ = B), {
        close: $
      };
    },
    triggerElementRef: b,
    isActiveTrigger: g
  }), L = m.useMemo(() => ({
    open: v
  }), [v]), A = h.useState("triggerProps", E);
  return Ie("button", t, {
    state: L,
    ref: [n, x, b],
    props: [T, A, {
      id: p
    }, d],
    stateAttributesMapping: dc
  });
});
process.env.NODE_ENV !== "production" && (qb.displayName = "TooltipTrigger");
const uf = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (uf.displayName = "TooltipPortalContext");
function rM() {
  const e = m.useContext(uf);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Portal> is missing." : Ke(70));
  return e;
}
const Xb = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    children: r,
    container: o,
    className: i,
    render: s,
    ...a
  } = t, {
    portalNode: l,
    portalSubtree: c
  } = Ab({
    container: o,
    ref: n,
    componentProps: t,
    elementProps: a
  });
  return !c && !l ? null : /* @__PURE__ */ Z(m.Fragment, {
    children: [c, l && /* @__PURE__ */ nn.createPortal(r, l)]
  });
});
process.env.NODE_ENV !== "production" && (Xb.displayName = "FloatingPortalLite");
const Zb = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t;
  return Es().useState("mounted") || r ? /* @__PURE__ */ _(uf.Provider, {
    value: r,
    children: /* @__PURE__ */ _(Xb, {
      ref: n,
      ...o
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Zb.displayName = "TooltipPortal");
const df = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (df.displayName = "TooltipPositionerContext");
function Qb() {
  const e = m.useContext(df);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipPositionerContext is missing. TooltipPositioner parts must be placed within <Tooltip.Positioner>." : Ke(71));
  return e;
}
const Jb = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (Jb.displayName = "DirectionContext");
function fc() {
  const e = m.useContext(Jb);
  return (e == null ? void 0 : e.direction) ?? "ltr";
}
const oM = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    var B, $;
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: a,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0,
      offsetParent: d = "real"
    } = Cr(e, t) || {};
    if (c == null)
      return {};
    const f = fb(u), h = {
      x: n,
      y: r
    }, p = jd(o), g = zd(p), v = await s.getDimensions(c), y = p === "y", b = y ? "top" : "left", w = y ? "bottom" : "right", C = y ? "clientHeight" : "clientWidth", x = i.reference[g] + i.reference[p] - h[p] - i.floating[g], E = h[p] - i.reference[p], S = d === "real" ? await ((B = s.getOffsetParent) == null ? void 0 : B.call(s, c)) : a.floating;
    let R = a.floating[C] || i.floating[g];
    (!R || !await (($ = s.isElement) == null ? void 0 : $.call(s, S))) && (R = a.floating[C] || i.floating[g]);
    const M = x / 2 - E / 2, I = R / 2 - v[g] / 2 - 1, P = Math.min(f[b], I), k = Math.min(f[w], I), O = P, F = R - v[g] - k, T = R / 2 - v[g] / 2 + M, L = zu(O, T, F), A = !l.arrow && qr(o) != null && T !== L && i.reference[g] / 2 - (T < O ? P : k) - v[g] / 2 < 0, N = A ? T < O ? T - O : T - F : 0;
    return {
      [p]: h[p] + N,
      data: {
        [p]: L,
        centerOffset: T - L - N,
        ...A && {
          alignmentOffset: N
        }
      },
      reset: A
    };
  }
}), iM = (e, t) => ({
  ...oM(e),
  options: [e, t]
}), sM = {
  name: "hide",
  async fn(e) {
    var a;
    const {
      width: t,
      height: n,
      x: r,
      y: o
    } = e.rects.reference, i = t === 0 && n === 0 && r === 0 && o === 0;
    return {
      data: {
        referenceHidden: ((a = (await ZS().fn(e)).data) == null ? void 0 : a.referenceHidden) || i
      }
    };
  }
}, za = {
  sideX: "left",
  sideY: "top"
}, e0 = {
  name: "adaptiveOrigin",
  async fn(e) {
    var b, w;
    const {
      x: t,
      y: n,
      rects: {
        floating: r
      },
      elements: {
        floating: o
      },
      platform: i,
      strategy: s,
      placement: a
    } = e, l = Wt(o), c = l.getComputedStyle(o);
    if (!(c.transitionDuration !== "0s" && c.transitionDuration !== ""))
      return {
        x: t,
        y: n,
        data: za
      };
    const d = await ((b = i.getOffsetParent) == null ? void 0 : b.call(i, o));
    let f = {
      width: 0,
      height: 0
    };
    if (s === "fixed" && (l != null && l.visualViewport))
      f = {
        width: l.visualViewport.width,
        height: l.visualViewport.height
      };
    else if (d === l) {
      const C = Pn(o);
      f = {
        width: C.documentElement.clientWidth,
        height: C.documentElement.clientHeight
      };
    } else
      await ((w = i.isElement) == null ? void 0 : w.call(i, d)) && (f = await i.getDimensions(d));
    const h = cn(a);
    let p = t, g = n;
    h === "left" && (p = f.width - (t + r.width)), h === "top" && (g = f.height - (n + r.height));
    const v = h === "left" ? "right" : za.sideX, y = h === "top" ? "bottom" : za.sideY;
    return {
      x: p,
      y: g,
      data: {
        sideX: v,
        sideY: y
      }
    };
  }
};
function t0(e, t, n) {
  const r = e === "inline-start" || e === "inline-end";
  return {
    top: "top",
    right: r ? n ? "inline-start" : "inline-end" : "right",
    bottom: "bottom",
    left: r ? n ? "inline-end" : "inline-start" : "left"
  }[t];
}
function jp(e, t, n) {
  const {
    rects: r,
    placement: o
  } = e;
  return {
    side: t0(t, cn(o), n),
    align: qr(o) || "center",
    anchor: {
      width: r.reference.width,
      height: r.reference.height
    },
    positioner: {
      width: r.floating.width,
      height: r.floating.height
    }
  };
}
function ff(e) {
  var $o, fn;
  const {
    // Public parameters
    anchor: t,
    positionMethod: n = "absolute",
    side: r = "bottom",
    sideOffset: o = 0,
    align: i = "center",
    alignOffset: s = 0,
    collisionBoundary: a,
    collisionPadding: l = 5,
    sticky: c = !1,
    arrowPadding: u = 5,
    disableAnchorTracking: d = !1,
    // Private parameters
    keepMounted: f = !1,
    floatingRootContext: h,
    mounted: p,
    collisionAvoidance: g,
    shiftCrossAxis: v = !1,
    nodeId: y,
    adaptiveOrigin: b,
    lazyFlip: w = !1,
    externalTree: C
  } = e, [x, E] = m.useState(null);
  !p && x !== null && E(null);
  const S = g.side || "flip", R = g.align || "flip", M = g.fallbackAxisSide || "end", I = typeof t == "function" ? t : void 0, P = ve(I), k = I ? P : t, O = Gt(t), T = fc() === "rtl", L = x || {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    "inline-end": T ? "left" : "right",
    "inline-start": T ? "right" : "left"
  }[r], A = i === "center" ? L : `${L}-${i}`;
  let N = l;
  const B = 1, $ = r === "bottom" ? B : 0, U = r === "top" ? B : 0, G = r === "right" ? B : 0, H = r === "left" ? B : 0;
  typeof N == "number" ? N = {
    top: N + $,
    right: N + H,
    bottom: N + U,
    left: N + G
  } : N && (N = {
    top: (N.top || 0) + $,
    right: (N.right || 0) + H,
    bottom: (N.bottom || 0) + U,
    left: (N.left || 0) + G
  });
  const q = {
    boundary: a === "clipping-ancestors" ? "clippingAncestors" : a,
    padding: N
  }, j = m.useRef(null), W = Gt(o), z = Gt(s), ne = [YS((nt) => {
    const Et = jp(nt, r, T), Bt = typeof W.current == "function" ? W.current(Et) : W.current, yt = typeof z.current == "function" ? z.current(Et) : z.current;
    return {
      mainAxis: Bt,
      crossAxis: yt,
      alignmentAxis: yt
    };
  }, [typeof o != "function" ? o : 0, typeof s != "function" ? s : 0, T, r])], Q = R === "none" && S !== "shift", D = !Q && (c || v || S === "shift"), te = S === "none" ? null : qS({
    ...q,
    // Ensure the popup flips if it's been limited by its --available-height and it resizes.
    // Since the size() padding is smaller than the flip() padding, flip() will take precedence.
    padding: {
      top: N.top + B,
      right: N.right + B,
      bottom: N.bottom + B,
      left: N.left + B
    },
    mainAxis: !v && S === "flip",
    crossAxis: R === "flip" ? "alignment" : !1,
    fallbackAxisSideDirection: M
  }), K = Q ? null : GS((nt) => {
    const Et = Pn(nt.elements.floating).documentElement;
    return {
      ...q,
      // Use the Layout Viewport to avoid shifting around when pinch-zooming
      // for context menus.
      rootBoundary: v ? {
        x: 0,
        y: 0,
        width: Et.clientWidth,
        height: Et.clientHeight
      } : void 0,
      mainAxis: R !== "none",
      crossAxis: D,
      limiter: c || v ? void 0 : KS((Bt) => {
        if (!j.current)
          return {};
        const {
          width: yt,
          height: hn
        } = j.current.getBoundingClientRect(), _n = On(cn(Bt.placement)), Fo = _n === "y" ? yt : hn, Vo = _n === "y" ? N.left + N.right : N.top + N.bottom;
        return {
          offset: Fo / 2 + Vo / 2
        };
      })
    };
  }, [q, c, v, N, R]);
  S === "shift" || R === "shift" || i === "center" ? ne.push(K, te) : ne.push(te, K), ne.push(XS({
    ...q,
    apply({
      elements: {
        floating: nt
      },
      rects: {
        reference: Et
      },
      availableWidth: Bt,
      availableHeight: yt
    }) {
      Object.entries({
        "--available-width": `${Bt}px`,
        "--available-height": `${yt}px`,
        "--anchor-width": `${Et.width}px`,
        "--anchor-height": `${Et.height}px`
      }).forEach(([hn, _n]) => {
        nt.style.setProperty(hn, _n);
      });
    }
  }), iM(() => ({
    // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
    // we'll create a fake element.
    element: j.current || document.createElement("div"),
    padding: u,
    offsetParent: "floating"
  }), [u]), {
    name: "transformOrigin",
    fn(nt) {
      var Oe, Ye, rt;
      const {
        elements: Et,
        middlewareData: Bt,
        placement: yt,
        rects: hn,
        y: _n
      } = nt, Fo = cn(yt), Vo = On(Fo), Pr = j.current, Xs = ((Oe = Bt.arrow) == null ? void 0 : Oe.x) || 0, Zs = ((Ye = Bt.arrow) == null ? void 0 : Ye.y) || 0, Nc = (Pr == null ? void 0 : Pr.clientWidth) || 0, Dc = (Pr == null ? void 0 : Pr.clientHeight) || 0, Bo = Xs + Nc / 2, Qs = Zs + Dc / 2, Ac = Math.abs(((rt = Bt.shift) == null ? void 0 : rt.y) || 0), Lc = hn.reference.height / 2, ro = typeof o == "function" ? o(jp(nt, r, T)) : o, V = Ac > ro, se = {
        top: `${Bo}px calc(100% + ${ro}px)`,
        bottom: `${Bo}px ${-ro}px`,
        left: `calc(100% + ${ro}px) ${Qs}px`,
        right: `${-ro}px ${Qs}px`
      }[Fo], me = `${Bo}px ${hn.reference.y + Lc - _n}px`;
      return Et.floating.style.setProperty("--transform-origin", D && Vo === "y" && V ? me : se), {};
    }
  }, sM, b), ge(() => {
    !p && h && h.update({
      referenceElement: null,
      floatingElement: null,
      domReferenceElement: null
    });
  }, [p, h]);
  const ce = m.useMemo(() => ({
    elementResize: !d && typeof ResizeObserver < "u",
    layoutShift: !d && typeof IntersectionObserver < "u"
  }), [d]), {
    refs: ee,
    elements: re,
    x: le,
    y: de,
    middlewareData: be,
    update: ye,
    placement: Ce,
    context: ie,
    isPositioned: he,
    floatingStyles: fe
  } = N2({
    rootContext: h,
    placement: A,
    middleware: ne,
    strategy: n,
    whileElementsMounted: f ? void 0 : (...nt) => Np(...nt, ce),
    nodeId: y,
    externalTree: C
  }), {
    sideX: Se,
    sideY: Me
  } = be.adaptiveOrigin || za, $e = he ? n : "fixed", Ne = m.useMemo(() => b ? {
    position: $e,
    [Se]: le,
    [Me]: de
  } : {
    position: $e,
    ...fe
  }, [b, $e, Se, le, Me, de, fe]), Fe = m.useRef(null);
  ge(() => {
    if (!p)
      return;
    const nt = O.current, Et = typeof nt == "function" ? nt() : nt, yt = (Up(Et) ? Et.current : Et) || null || null;
    yt !== Fe.current && (ee.setPositionReference(yt), Fe.current = yt);
  }, [p, ee, k, O]), m.useEffect(() => {
    if (!p)
      return;
    const nt = O.current;
    typeof nt != "function" && Up(nt) && nt.current !== Fe.current && (ee.setPositionReference(nt.current), Fe.current = nt.current);
  }, [p, ee, k, O]), m.useEffect(() => {
    if (f && p && re.domReference && re.floating)
      return Np(re.domReference, re.floating, ye, ce);
  }, [f, p, re, ye, ce]);
  const Ae = cn(Ce), bt = t0(r, Ae, T), Pt = qr(Ce) || "center", Te = !!(($o = be.hide) != null && $o.referenceHidden);
  ge(() => {
    w && p && he && E(Ae);
  }, [w, p, he, Ae]);
  const Je = m.useMemo(() => {
    var nt, Et;
    return {
      position: "absolute",
      top: (nt = be.arrow) == null ? void 0 : nt.y,
      left: (Et = be.arrow) == null ? void 0 : Et.x
    };
  }, [be.arrow]), Vt = ((fn = be.arrow) == null ? void 0 : fn.centerOffset) !== 0;
  return m.useMemo(() => ({
    positionerStyles: Ne,
    arrowStyles: Je,
    arrowRef: j,
    arrowUncentered: Vt,
    side: bt,
    align: Pt,
    physicalSide: Ae,
    anchorHidden: Te,
    refs: ee,
    context: ie,
    isPositioned: he,
    update: ye
  }), [Ne, Je, j, Vt, bt, Pt, Ae, Te, ee, ie, he, ye]);
}
function Up(e) {
  return e != null && "current" in e;
}
function ks(e) {
  return e === "starting" ? g_ : Rt;
}
const n0 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    anchor: i,
    positionMethod: s = "absolute",
    side: a = "top",
    align: l = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: h = 5,
    sticky: p = !1,
    disableAnchorTracking: g = !1,
    collisionAvoidance: v = Ad,
    ...y
  } = t, b = Es(), w = rM(), C = b.useState("open"), x = b.useState("mounted"), E = b.useState("trackCursorAxis"), S = b.useState("disableHoverablePopup"), R = b.useState("floatingRootContext"), M = b.useState("instantType"), I = b.useState("transitionStatus"), P = b.useState("hasViewport"), k = ff({
    anchor: i,
    positionMethod: s,
    floatingRootContext: R,
    mounted: x,
    side: a,
    sideOffset: c,
    align: l,
    alignOffset: u,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: p,
    arrowPadding: h,
    disableAnchorTracking: g,
    keepMounted: w,
    collisionAvoidance: v,
    adaptiveOrigin: P ? e0 : void 0
  }), O = m.useMemo(() => {
    const A = {};
    return (!C || E === "both" || S) && (A.pointerEvents = "none"), {
      role: "presentation",
      hidden: !x,
      style: {
        ...k.positionerStyles,
        ...A
      }
    };
  }, [C, E, S, x, k.positionerStyles]), F = m.useMemo(() => ({
    open: C,
    side: k.side,
    align: k.align,
    anchorHidden: k.anchorHidden,
    instant: E !== "none" ? "tracking-cursor" : M
  }), [C, k.side, k.align, k.anchorHidden, E, M]), T = m.useMemo(() => ({
    ...F,
    arrowRef: k.arrowRef,
    arrowStyles: k.arrowStyles,
    arrowUncentered: k.arrowUncentered
  }), [F, k.arrowRef, k.arrowStyles, k.arrowUncentered]), L = Ie("div", t, {
    state: F,
    props: [O, ks(I), y],
    ref: [n, b.useStateSetter("positionerElement")],
    stateAttributesMapping: Un
  });
  return /* @__PURE__ */ _(df.Provider, {
    value: T,
    children: L
  });
});
process.env.NODE_ENV !== "production" && (n0.displayName = "TooltipPositioner");
const aM = {
  ...Un,
  ...lr
}, r0 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    ...i
  } = t, s = Es(), {
    side: a,
    align: l
  } = Qb(), c = s.useState("open"), u = s.useState("instantType"), d = s.useState("transitionStatus"), f = s.useState("popupProps"), h = s.useState("floatingRootContext");
  Zr({
    open: c,
    ref: s.context.popupRef,
    onComplete() {
      var b, w;
      c && ((w = (b = s.context).onOpenChangeComplete) == null || w.call(b, !0));
    }
  });
  const p = s.useState("disabled"), g = s.useState("closeDelay");
  sf(h, {
    enabled: !p,
    closeDelay: g
  });
  const v = m.useMemo(() => ({
    open: c,
    side: a,
    align: l,
    instant: u,
    transitionStatus: d
  }), [c, a, l, u, d]);
  return Ie("div", t, {
    state: v,
    ref: [n, s.context.popupRef, s.useStateSetter("popupElement")],
    props: [f, ks(d), i],
    stateAttributesMapping: aM
  });
});
process.env.NODE_ENV !== "production" && (r0.displayName = "TooltipPopup");
const o0 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    ...i
  } = t, a = Es().useState("instantType"), {
    open: l,
    arrowRef: c,
    side: u,
    align: d,
    arrowUncentered: f,
    arrowStyles: h
  } = Qb(), p = m.useMemo(() => ({
    open: l,
    side: u,
    align: d,
    uncentered: f,
    instant: a
  }), [l, u, d, f, a]);
  return Ie("div", t, {
    state: p,
    ref: [n, c],
    props: [{
      style: h,
      "aria-hidden": !0
    }, i],
    stateAttributesMapping: Un
  });
});
process.env.NODE_ENV !== "production" && (o0.displayName = "TooltipArrow");
const i0 = function(t) {
  const {
    delay: n,
    closeDelay: r,
    timeout: o = 400
  } = t, i = m.useMemo(() => ({
    delay: n,
    closeDelay: r
  }), [n, r]), s = m.useMemo(() => ({
    open: n,
    close: r
  }), [n, r]);
  return /* @__PURE__ */ _(cf.Provider, {
    value: i,
    children: /* @__PURE__ */ _(QE, {
      delay: s,
      timeoutMs: o,
      children: t.children
    })
  });
};
process.env.NODE_ENV !== "production" && (i0.displayName = "TooltipProvider");
function hf(e) {
  return Nd(19) ? e : e ? "true" : void 0;
}
const lM = dn(
  "max-w-lg origin-[--transform-origin] rounded-lg bg-clip-padding outline outline-1 -outline-offset-1 outline-[theme(borderColor.foundations-subtle)] transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[starting-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 data-[instant]:duration-0",
  {
    variants: {
      variant: {
        dark: "bg-foundations-inverse text-foundations-inverse outline-transparent [&_[data-slot=arrow-bg]]:fill-[theme(backgroundColor.foundations-inverse)]",
        light: "bg-foundations-default text-foundations-boldest [&_[data-slot=arrow-bg]]:fill-[theme(backgroundColor.foundations-default)] [&_[data-slot=arrow-border]]:fill-[theme(borderColor.foundations-subtle)]"
      },
      size: {
        default: "p-2 text-sm lg:p-3 lg:[&_.tooltip-arrow]:h-4 lg:[&_.tooltip-arrow]:w-8",
        sm: "px-2.5 py-1.5 text-xs"
      }
    },
    defaultVariants: {
      variant: "dark",
      size: "default"
    }
  }
), Yp = (e) => /* @__PURE__ */ _(i0, { delay: 350, ...e }), cM = K2, uM = m.forwardRef((e, t) => /* @__PURE__ */ _(qb, { "data-slot": "tooltip-trigger", ...e })), dM = m.forwardRef(
  ({
    side: e = "top",
    sideOffset: t = 10,
    collisionPadding: n = 4,
    collisionBoundary: r,
    align: o,
    alignOffset: i = 0,
    className: s,
    hideArrow: a = !1,
    variant: l,
    size: c,
    children: u
  }, d) => /* @__PURE__ */ _(Zb, { children: /* @__PURE__ */ _(
    n0,
    {
      "data-slot": "tooltip-positioner",
      side: e,
      sideOffset: t,
      collisionPadding: n,
      align: o,
      alignOffset: i,
      collisionBoundary: r,
      className: "z-50",
      children: /* @__PURE__ */ Z(
        r0,
        {
          "data-slot": "tooltip-content",
          ref: d,
          className: oe(
            "break-words",
            lM({ variant: l, size: c }),
            s
          ),
          children: [
            u,
            !a && /* @__PURE__ */ _(
              o0,
              {
                "data-slot": "tooltip-arrow",
                className: "z-50 data-[side=bottom]:top-[-8px] data-[side=left]:right-[-13px] data-[side=right]:left-[-13px] data-[side=top]:bottom-[-8px] data-[side=left]:rotate-90 data-[side=right]:-rotate-90 data-[side=top]:rotate-180",
                children: /* @__PURE__ */ _(fM, {})
              }
            )
          ]
        }
      )
    }
  ) })
), xt = Object.assign(cM, {
  Trigger: uM,
  Popup: dM
});
function fM(e) {
  return /* @__PURE__ */ Z("svg", { width: "20", height: "10", viewBox: "0 0 20 10", fill: "none", ...e, children: [
    /* @__PURE__ */ _(
      "path",
      {
        "data-slot": "arrow-bg",
        d: "M9.66437 2.60207L4.80758 6.97318C4.07308 7.63423 3.11989 8 2.13172 8H0V10H20V8H18.5349C17.5468 8 16.5936 7.63423 15.8591 6.97318L11.0023 2.60207C10.622 2.2598 10.0447 2.25979 9.66437 2.60207Z"
      }
    ),
    /* @__PURE__ */ _(
      "path",
      {
        "data-slot": "arrow-border",
        d: "M10.3333 3.34539L5.47654 7.71648C4.55842 8.54279 3.36693 9 2.13172 9H0V8H2.13172C3.11989 8 4.07308 7.63423 4.80758 6.97318L9.66437 2.60207C10.0447 2.25979 10.622 2.2598 11.0023 2.60207L15.8591 6.97318C16.5936 7.63423 17.5468 8 18.5349 8H20V9H18.5349C17.2998 9 16.1083 8.54278 15.1901 7.71648L10.3333 3.34539Z"
      }
    )
  ] });
}
const s0 = ({
  children: e,
  render: t,
  content: n,
  hoverable: r,
  size: o,
  variant: i,
  disabled: s,
  ...a
}) => {
  const [l, c] = m.useState(null), [u, d] = m.useState(!1);
  m.useEffect(() => {
    if (!l)
      return;
    const p = () => {
      d(l.scrollWidth > l.clientWidth);
    }, g = new ResizeObserver((v) => {
      requestAnimationFrame(() => {
        for (const y of v)
          y.contentBoxSize && p();
      });
    });
    return g.observe(l), () => g.unobserve(l);
  }, [l]);
  const h = xi({
    defaultTagName: "p",
    render: t,
    ref: c,
    props: kn({
      className: "truncate",
      "data-slot": "overflow-text"
    }, a)
  });
  return /* @__PURE__ */ Z(
    xt,
    {
      disabled: s || !u,
      disableHoverablePopup: !r,
      children: [
        /* @__PURE__ */ _(xt.Trigger, { render: h, children: e }),
        /* @__PURE__ */ _(xt.Popup, { size: o, variant: i, children: n ?? (l == null ? void 0 : l.textContent) })
      ]
    }
  );
}, hM = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "div",
  {
    ref: n,
    className: oe(
      "h-4 animate-pulse rounded bg-foundations-subtlest",
      e
    ),
    ...t
  }
));
hM.displayName = "Skeleton";
const pf = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (pf.displayName = "DialogRootContext");
function Tr(e) {
  const t = m.useContext(pf);
  if (e === !1 && t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DialogRootContext is missing. Dialog parts must be placed within <Dialog.Root>." : Ke(27));
  return t;
}
const pM = {
  ...Un,
  ...lr
}, gf = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    forceRender: i = !1,
    ...s
  } = t, {
    store: a
  } = Tr(), l = a.useState("open"), c = a.useState("nested"), u = a.useState("mounted"), d = a.useState("transitionStatus"), f = m.useMemo(() => ({
    open: l,
    transitionStatus: d
  }), [l, d]);
  return Ie("div", t, {
    state: f,
    ref: [a.context.backdropRef, n],
    stateAttributesMapping: pM,
    props: [{
      role: "presentation",
      hidden: !u,
      style: {
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, s],
    enabled: i || !c
  });
});
process.env.NODE_ENV !== "production" && (gf.displayName = "DialogBackdrop");
let Ju;
process.env.NODE_ENV !== "production" && (Ju = /* @__PURE__ */ new Set());
function Gp(...e) {
  if (process.env.NODE_ENV !== "production") {
    const t = e.join(" ");
    Ju.has(t) || (Ju.add(t), console.error(`Base UI: ${t}`));
  }
}
const mf = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (mf.displayName = "CompositeRootContext");
function vf(e = !1) {
  const t = m.useContext(mf);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>." : Ke(16));
  return t;
}
function gM(e) {
  const {
    focusableWhenDisabled: t,
    disabled: n,
    composite: r = !1,
    tabIndex: o = 0,
    isNativeButton: i
  } = e, s = r && t !== !1, a = r && t === !1;
  return {
    props: m.useMemo(() => {
      const c = {
        // allow Tabbing away from focusableWhenDisabled elements
        onKeyDown(u) {
          n && t && u.key !== "Tab" && u.preventDefault();
        }
      };
      return r || (c.tabIndex = o, !i && n && (c.tabIndex = t ? o : -1)), (i && (t || s) || !i && n) && (c["aria-disabled"] = n), i && (!t || a) && (c.disabled = n), c;
    }, [r, n, t, s, a, i, o])
  };
}
function Jr(e = {}) {
  const {
    disabled: t = !1,
    focusableWhenDisabled: n,
    tabIndex: r = 0,
    native: o = !0
  } = e, i = m.useRef(null), s = vf(!0) !== void 0, a = ve(() => {
    const f = i.current;
    return !!((f == null ? void 0 : f.tagName) === "A" && (f != null && f.href));
  }), {
    props: l
  } = gM({
    focusableWhenDisabled: n,
    disabled: t,
    composite: s,
    tabIndex: r,
    isNativeButton: o
  });
  process.env.NODE_ENV !== "production" && m.useEffect(() => {
    if (!i.current)
      return;
    const f = i.current.tagName === "BUTTON";
    o ? f || Gp("A component that acts as a button was not rendered as a native <button>, which does not match the default. Ensure that the element passed to the `render` prop of the component is a real <button>, or set the `nativeButton` prop on the component to `false`.") : f && Gp("A component that acts as a button was rendered as a native <button>, which does not match the default. Ensure that the element passed to the `render` prop of the component is not a real <button>, or set the `nativeButton` prop on the component to `true`.");
  }, [o]);
  const c = m.useCallback(() => {
    const f = i.current;
    mM(f) && s && t && l.disabled === void 0 && f.disabled && (f.disabled = !1);
  }, [t, l.disabled, s]);
  ge(c, [c]);
  const u = m.useCallback((f = {}) => {
    const {
      onClick: h,
      onMouseDown: p,
      onKeyUp: g,
      onKeyDown: v,
      onPointerDown: y,
      ...b
    } = f;
    return kn({
      type: o ? "button" : void 0,
      onClick(C) {
        if (t) {
          C.preventDefault();
          return;
        }
        h == null || h(C);
      },
      onMouseDown(C) {
        t || p == null || p(C);
      },
      onKeyDown(C) {
        if (t || (Au(C), v == null || v(C)), C.baseUIHandlerPrevented)
          return;
        const x = C.target === C.currentTarget && !o && !a() && !t, E = C.key === "Enter", S = C.key === " ";
        x && ((S || E) && C.preventDefault(), E && (h == null || h(C)));
      },
      onKeyUp(C) {
        t || (Au(C), g == null || g(C)), !C.baseUIHandlerPrevented && C.target === C.currentTarget && !o && !t && C.key === " " && (h == null || h(C));
      },
      onPointerDown(C) {
        if (t) {
          C.preventDefault();
          return;
        }
        y == null || y(C);
      }
    }, o ? void 0 : {
      role: "button"
    }, l, b);
  }, [t, l, o, a]), d = ve((f) => {
    i.current = f, c();
  });
  return {
    getButtonProps: u,
    buttonRef: d
  };
}
function mM(e) {
  return gt(e) && e.tagName === "BUTTON";
}
const hc = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    disabled: i = !1,
    nativeButton: s = !0,
    ...a
  } = t, {
    store: l
  } = Tr(), c = l.useState("open");
  function u(p) {
    c && l.setOpen(!1, ke(qE, p.nativeEvent));
  }
  const {
    getButtonProps: d,
    buttonRef: f
  } = Jr({
    disabled: i,
    native: s
  }), h = m.useMemo(() => ({
    disabled: i
  }), [i]);
  return Ie("button", t, {
    state: h,
    ref: [n, f],
    props: [{
      onClick: u
    }, a, d]
  });
});
process.env.NODE_ENV !== "production" && (hc.displayName = "DialogClose");
const bf = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    id: i,
    ...s
  } = t, {
    store: a
  } = Tr(), l = Kt(i);
  return a.useSyncedValueWithCleanup("descriptionElementId", l), Ie("p", t, {
    ref: n,
    props: [{
      id: l
    }, s]
  });
});
process.env.NODE_ENV !== "production" && (bf.displayName = "DialogDescription");
let vM = /* @__PURE__ */ function(e) {
  return e.nestedDialogs = "--nested-dialogs", e;
}({}), bM = function(e) {
  return e[e.open = Hn.open] = "open", e[e.closed = Hn.closed] = "closed", e[e.startingStyle = Hn.startingStyle] = "startingStyle", e[e.endingStyle = Hn.endingStyle] = "endingStyle", e.nested = "data-nested", e.nestedDialogOpen = "data-nested-dialog-open", e;
}({});
const yf = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (yf.displayName = "DialogPortalContext");
function a0() {
  const e = m.useContext(yf);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Portal> is missing." : Ke(26));
  return e;
}
const ni = "ArrowUp", po = "ArrowDown", ds = "ArrowLeft", ri = "ArrowRight", Ps = "Home", Is = "End", l0 = /* @__PURE__ */ new Set([ds, ri]), yM = /* @__PURE__ */ new Set([ds, ri, Ps, Is]), c0 = /* @__PURE__ */ new Set([ni, po]), xM = /* @__PURE__ */ new Set([ni, po, Ps, Is]), u0 = /* @__PURE__ */ new Set([...l0, ...c0]), wM = /* @__PURE__ */ new Set([...u0, Ps, Is]), xf = /* @__PURE__ */ new Set([ni, po, ds, ri, Ps, Is]), CM = "Shift", _M = "Control", EM = "Alt", SM = "Meta", MM = /* @__PURE__ */ new Set([CM, _M, EM, SM]);
function OM(e) {
  return gt(e) && e.tagName === "INPUT";
}
function Kp(e) {
  return !!(OM(e) && e.selectionStart != null || gt(e) && e.tagName === "TEXTAREA");
}
function qp(e, t, n, r) {
  if (!e || !t || !t.scrollTo)
    return;
  let o = e.scrollLeft, i = e.scrollTop;
  const s = e.clientWidth < e.scrollWidth, a = e.clientHeight < e.scrollHeight;
  if (s && r !== "vertical") {
    const l = Xp(e, t, "left"), c = la(e), u = la(t);
    n === "ltr" && (l + t.offsetWidth + u.scrollMarginRight > e.scrollLeft + e.clientWidth - c.scrollPaddingRight ? o = l + t.offsetWidth + u.scrollMarginRight - e.clientWidth + c.scrollPaddingRight : l - u.scrollMarginLeft < e.scrollLeft + c.scrollPaddingLeft && (o = l - u.scrollMarginLeft - c.scrollPaddingLeft)), n === "rtl" && (l - u.scrollMarginRight < e.scrollLeft + c.scrollPaddingLeft ? o = l - u.scrollMarginLeft - c.scrollPaddingLeft : l + t.offsetWidth + u.scrollMarginRight > e.scrollLeft + e.clientWidth - c.scrollPaddingRight && (o = l + t.offsetWidth + u.scrollMarginRight - e.clientWidth + c.scrollPaddingRight));
  }
  if (a && r !== "horizontal") {
    const l = Xp(e, t, "top"), c = la(e), u = la(t);
    l - u.scrollMarginTop < e.scrollTop + c.scrollPaddingTop ? i = l - u.scrollMarginTop - c.scrollPaddingTop : l + t.offsetHeight + u.scrollMarginBottom > e.scrollTop + e.clientHeight - c.scrollPaddingBottom && (i = l + t.offsetHeight + u.scrollMarginBottom - e.clientHeight + c.scrollPaddingBottom);
  }
  e.scrollTo({
    left: o,
    top: i,
    behavior: "auto"
  });
}
function Xp(e, t, n) {
  const r = n === "left" ? "offsetLeft" : "offsetTop";
  let o = 0;
  for (; t.offsetParent && (o += t[r], t.offsetParent !== e); )
    t = t.offsetParent;
  return o;
}
function la(e) {
  const t = getComputedStyle(e);
  return {
    scrollMarginTop: parseFloat(t.scrollMarginTop) || 0,
    scrollMarginRight: parseFloat(t.scrollMarginRight) || 0,
    scrollMarginBottom: parseFloat(t.scrollMarginBottom) || 0,
    scrollMarginLeft: parseFloat(t.scrollMarginLeft) || 0,
    scrollPaddingTop: parseFloat(t.scrollPaddingTop) || 0,
    scrollPaddingRight: parseFloat(t.scrollPaddingRight) || 0,
    scrollPaddingBottom: parseFloat(t.scrollPaddingBottom) || 0,
    scrollPaddingLeft: parseFloat(t.scrollPaddingLeft) || 0
  };
}
const RM = {
  ...Un,
  ...lr,
  nestedDialogOpen(e) {
    return e ? {
      [bM.nestedDialogOpen]: ""
    } : null;
  }
}, wf = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    finalFocus: o,
    initialFocus: i,
    render: s,
    ...a
  } = t, {
    store: l
  } = Tr(), c = l.useState("descriptionElementId"), u = l.useState("disablePointerDismissal"), d = l.useState("floatingRootContext"), f = l.useState("popupProps"), h = l.useState("modal"), p = l.useState("mounted"), g = l.useState("nested"), v = l.useState("nestedOpenDialogCount"), y = l.useState("open"), b = l.useState("openMethod"), w = l.useState("titleElementId"), C = l.useState("transitionStatus"), x = l.useState("role");
  a0(), Zr({
    open: y,
    ref: l.context.popupRef,
    onComplete() {
      var P, k;
      y && ((k = (P = l.context).onOpenChangeComplete) == null || k.call(P, !0));
    }
  });
  function E(P) {
    return P === "touch" ? l.context.popupRef.current : !0;
  }
  const S = i === void 0 ? E : i, R = v > 0, M = m.useMemo(() => ({
    open: y,
    nested: g,
    transitionStatus: C,
    nestedDialogOpen: R
  }), [y, g, C, R]), I = Ie("div", t, {
    state: M,
    props: [f, {
      "aria-labelledby": w ?? void 0,
      "aria-describedby": c ?? void 0,
      role: x,
      tabIndex: -1,
      hidden: !p,
      onKeyDown(P) {
        xf.has(P.key) && P.stopPropagation();
      },
      style: {
        [vM.nestedDialogs]: v
      }
    }, a],
    ref: [n, l.context.popupRef, l.useStateSetter("popupElement")],
    stateAttributesMapping: RM
  });
  return /* @__PURE__ */ _(ef, {
    context: d,
    openInteractionType: b,
    disabled: !p,
    closeOnFocusOut: !u,
    initialFocus: S,
    returnFocus: o,
    modal: h !== !1,
    restoreFocus: "popup",
    children: I
  });
});
process.env.NODE_ENV !== "production" && (wf.displayName = "DialogPopup");
const pc = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    cutout: r,
    ...o
  } = t;
  let i;
  if (r) {
    const s = r == null ? void 0 : r.getBoundingClientRect();
    i = `polygon(
      0% 0%,
      100% 0%,
      100% 100%,
      0% 100%,
      0% 0%,
      ${s.left}px ${s.top}px,
      ${s.left}px ${s.bottom}px,
      ${s.right}px ${s.bottom}px,
      ${s.right}px ${s.top}px,
      ${s.left}px ${s.top}px
    )`;
  }
  return /* @__PURE__ */ _("div", {
    ref: n,
    role: "presentation",
    "data-base-ui-inert": "",
    ...o,
    style: {
      position: "fixed",
      inset: 0,
      userSelect: "none",
      WebkitUserSelect: "none",
      clipPath: i
    }
  });
});
process.env.NODE_ENV !== "production" && (pc.displayName = "InternalBackdrop");
const Cf = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t, {
    store: i
  } = Tr(), s = i.useState("mounted"), a = i.useState("modal"), l = i.useState("open");
  return s || r ? /* @__PURE__ */ _(yf.Provider, {
    value: r,
    children: /* @__PURE__ */ Z(Zl, {
      ref: n,
      ...o,
      children: [s && a === !0 && /* @__PURE__ */ _(pc, {
        ref: i.context.internalBackdropRef,
        inert: hf(!l)
      }), t.children]
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Cf.displayName = "DialogPortal");
let Zp = {}, Qp = {}, Jp = "";
function TM(e) {
  if (typeof document > "u")
    return !1;
  const t = Pn(e);
  return Wt(t).innerWidth - t.documentElement.clientWidth > 0;
}
function kM(e) {
  if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u")
    return !1;
  const r = Pn(e).documentElement, o = {
    scrollbarGutter: r.style.scrollbarGutter,
    overflowY: r.style.overflowY
  };
  r.style.scrollbarGutter = "stable", r.style.overflowY = "scroll";
  const i = r.offsetWidth;
  r.style.overflowY = "hidden";
  const s = r.offsetWidth;
  return Object.assign(r.style, o), i === s;
}
function PM(e) {
  const t = Pn(e), n = t.documentElement, r = t.body, o = No(n) ? n : r, i = o.style.overflow;
  return o.style.overflow = "hidden", () => {
    o.style.overflow = i;
  };
}
function IM(e) {
  var f;
  const t = Pn(e), n = t.documentElement, r = t.body, o = Wt(n);
  let i = 0, s = 0, a = !1;
  const l = St.create();
  if (fE && (((f = o.visualViewport) == null ? void 0 : f.scale) ?? 1) !== 1)
    return () => {
    };
  function c() {
    const h = o.getComputedStyle(n), p = o.getComputedStyle(r), y = (h.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
    i = n.scrollTop, s = n.scrollLeft, Zp = {
      scrollbarGutter: n.style.scrollbarGutter,
      overflowY: n.style.overflowY,
      overflowX: n.style.overflowX
    }, Jp = n.style.scrollBehavior, Qp = {
      position: r.style.position,
      height: r.style.height,
      width: r.style.width,
      boxSizing: r.style.boxSizing,
      overflowY: r.style.overflowY,
      overflowX: r.style.overflowX,
      scrollBehavior: r.style.scrollBehavior
    };
    const b = n.scrollHeight > n.clientHeight, w = n.scrollWidth > n.clientWidth, C = h.overflowY === "scroll" || p.overflowY === "scroll", x = h.overflowX === "scroll" || p.overflowX === "scroll", E = Math.max(0, o.innerWidth - r.clientWidth), S = Math.max(0, o.innerHeight - r.clientHeight), R = parseFloat(p.marginTop) + parseFloat(p.marginBottom), M = parseFloat(p.marginLeft) + parseFloat(p.marginRight), I = No(n) ? n : r;
    if (a = kM(e), a) {
      n.style.scrollbarGutter = y, I.style.overflowY = "hidden", I.style.overflowX = "hidden";
      return;
    }
    Object.assign(n.style, {
      scrollbarGutter: y,
      overflowY: "hidden",
      overflowX: "hidden"
    }), (b || C) && (n.style.overflowY = "scroll"), (w || x) && (n.style.overflowX = "scroll"), Object.assign(r.style, {
      position: "relative",
      height: R || S ? `calc(100dvh - ${R + S}px)` : "100dvh",
      width: M || E ? `calc(100vw - ${M + E}px)` : "100vw",
      boxSizing: "border-box",
      overflow: "hidden",
      scrollBehavior: "unset"
    }), r.scrollTop = i, r.scrollLeft = s, n.setAttribute("data-base-ui-scroll-locked", ""), n.style.scrollBehavior = "unset";
  }
  function u() {
    Object.assign(n.style, Zp), Object.assign(r.style, Qp), a || (n.scrollTop = i, n.scrollLeft = s, n.removeAttribute("data-base-ui-scroll-locked"), n.style.scrollBehavior = Jp);
  }
  function d() {
    u(), l.request(c);
  }
  return c(), o.addEventListener("resize", d), () => {
    l.cancel(), u(), typeof o.removeEventListener == "function" && o.removeEventListener("resize", d);
  };
}
class NM {
  constructor() {
    ae(this, "lockCount", 0);
    ae(this, "restore", null);
    ae(this, "timeoutLock", wr.create());
    ae(this, "timeoutUnlock", wr.create());
    ae(this, "release", () => {
      this.lockCount -= 1, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
    });
    ae(this, "unlock", () => {
      var t;
      this.lockCount === 0 && this.restore && ((t = this.restore) == null || t.call(this), this.restore = null);
    });
  }
  acquire(t) {
    return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(t)), this.release;
  }
  lock(t) {
    if (this.lockCount === 0 || this.restore !== null)
      return;
    const r = Pn(t).documentElement, o = Wt(r).getComputedStyle(r).overflowY;
    if (o === "hidden" || o === "clip") {
      this.restore = vn;
      return;
    }
    const i = rb || !TM(t);
    this.restore = i ? PM(t) : IM(t);
  }
}
const DM = new NM();
function _f(e = !0, t = null) {
  ge(() => {
    if (e)
      return DM.acquire(t);
  }, [e, t]);
}
function AM(e) {
  const t = m.useRef(""), n = m.useCallback((o) => {
    o.defaultPrevented || (t.current = o.pointerType, e(o, o.pointerType));
  }, [e]);
  return {
    onClick: m.useCallback((o) => {
      if (o.detail === 0) {
        e(o, "keyboard");
        return;
      }
      "pointerType" in o && e(o, o.pointerType), e(o, t.current), t.current = "";
    }, [e]),
    onPointerDown: n
  };
}
function Ef(e) {
  const [t, n] = m.useState(null), r = ve((a, l) => {
    e || n(l || // On iOS Safari, the hitslop around touch targets means tapping outside an element's
    // bounds does not fire `pointerdown` but does fire `mousedown`. The `interactionType`
    // will be "" in that case.
    (rb ? "touch" : ""));
  }), o = m.useCallback(() => {
    n(null);
  }, []), {
    onClick: i,
    onPointerDown: s
  } = AM(r);
  return m.useMemo(() => ({
    openMethod: t,
    reset: o,
    triggerProps: {
      onClick: i,
      onPointerDown: s
    }
  }), [t, o, i, s]);
}
function LM(e) {
  const {
    store: t,
    parentContext: n,
    actionsRef: r
  } = e, o = t.useState("open"), i = t.useState("disablePointerDismissal"), s = t.useState("modal"), a = t.useState("popupElement"), {
    openMethod: l,
    triggerProps: c,
    reset: u
  } = Ef(o);
  rc(t);
  const {
    forceUnmount: d
  } = oc(o, t, () => {
    u();
  }), f = ve((I) => {
    const P = ke(I);
    return P.preventUnmountOnClose = () => {
      t.set("preventUnmountingOnClose", !0);
    }, P;
  }), h = m.useCallback(() => {
    t.setOpen(!1, f(Xl));
  }, [t, f]);
  m.useImperativeHandle(r, () => ({
    unmount: d,
    close: h
  }), [d, h]);
  const p = ac({
    popupStore: t,
    onOpenChange: t.setOpen,
    treatPopupAsFloatingElement: !0,
    noEmit: !0
  }), [g, v] = m.useState(0), y = g === 0, b = af(p), w = ec(p, {
    outsidePressEvent() {
      return t.context.internalBackdropRef.current || t.context.backdropRef.current ? "intentional" : {
        mouse: s === "trap-focus" ? "sloppy" : "intentional",
        touch: "sloppy"
      };
    },
    outsidePress(I) {
      if ("button" in I && I.button !== 0 || "touches" in I && I.touches.length !== 1)
        return !1;
      const P = Xt(I);
      if (y && !i) {
        const k = P;
        return s && (t.context.internalBackdropRef.current || t.context.backdropRef.current) ? t.context.internalBackdropRef.current === k || t.context.backdropRef.current === k || Ve(k, a) && !(k != null && k.hasAttribute("data-base-ui-portal")) : !0;
      }
      return !1;
    },
    escapeKey: y
  });
  _f(o && s === !0, a);
  const {
    getReferenceProps: C,
    getFloatingProps: x,
    getTriggerProps: E
  } = Qr([b, w]);
  t.useContextCallback("onNestedDialogOpen", (I) => {
    v(I + 1);
  }), t.useContextCallback("onNestedDialogClose", () => {
    v(0);
  }), m.useEffect(() => (n != null && n.onNestedDialogOpen && o && n.onNestedDialogOpen(g), n != null && n.onNestedDialogClose && !o && n.onNestedDialogClose(), () => {
    n != null && n.onNestedDialogClose && o && n.onNestedDialogClose();
  }), [o, n, g]);
  const S = m.useMemo(() => C(c), [C, c]), R = m.useMemo(() => E(c), [E, c]), M = m.useMemo(() => x(), [x]);
  t.useSyncedValues({
    openMethod: l,
    activeTriggerProps: S,
    inactiveTriggerProps: R,
    popupProps: M,
    floatingRootContext: p,
    nestedOpenDialogCount: g
  });
}
const $M = {
  ...sc,
  modal: Ee((e) => e.modal),
  nested: Ee((e) => e.nested),
  nestedOpenDialogCount: Ee((e) => e.nestedOpenDialogCount),
  disablePointerDismissal: Ee((e) => e.disablePointerDismissal),
  openMethod: Ee((e) => e.openMethod),
  descriptionElementId: Ee((e) => e.descriptionElementId),
  titleElementId: Ee((e) => e.titleElementId),
  viewportElement: Ee((e) => e.viewportElement),
  role: Ee((e) => e.role)
};
class FM extends Ts {
  constructor(n) {
    super(VM(n), {
      popupRef: /* @__PURE__ */ m.createRef(),
      backdropRef: /* @__PURE__ */ m.createRef(),
      internalBackdropRef: /* @__PURE__ */ m.createRef(),
      triggerElements: new _i(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0
    }, $M);
    ae(this, "setOpen", (n, r) => {
      var a, l, c, u;
      if (r.preventUnmountOnClose = () => {
        this.set("preventUnmountingOnClose", !0);
      }, !n && r.trigger == null && this.state.activeTriggerId != null && (r.trigger = this.state.activeTriggerElement ?? void 0), (l = (a = this.context).onOpenChange) == null || l.call(a, n, r), r.isCanceled)
        return;
      const o = {
        open: n,
        nativeEvent: r.event,
        reason: r.reason,
        nested: this.state.nested
      };
      (c = this.state.floatingRootContext.context.events) == null || c.emit("openchange", o);
      const i = {
        open: n
      }, s = ((u = r.trigger) == null ? void 0 : u.id) ?? null;
      (s || n) && (i.activeTriggerId = s, i.activeTriggerElement = r.trigger ?? null), this.update(i);
    });
  }
}
function VM(e = {}) {
  return {
    ...ic(),
    modal: !0,
    disablePointerDismissal: !1,
    popupElement: null,
    viewportElement: null,
    descriptionElementId: void 0,
    titleElementId: void 0,
    openMethod: null,
    nested: !1,
    nestedOpenDialogCount: 0,
    role: "dialog",
    ...e
  };
}
function d0(e) {
  const {
    children: t,
    open: n,
    defaultOpen: r = !1,
    onOpenChange: o,
    onOpenChangeComplete: i,
    disablePointerDismissal: s = !1,
    modal: a = !0,
    actionsRef: l,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null
  } = e, f = Tr(!0), h = !!f, p = rn(() => (c == null ? void 0 : c.store) ?? new FM({
    open: n ?? r,
    activeTriggerId: u !== void 0 ? u : d,
    modal: a,
    disablePointerDismissal: s,
    nested: h
  })).current;
  p.useControlledProp("open", n, r), p.useControlledProp("activeTriggerId", u, d), p.useSyncedValues({
    disablePointerDismissal: s,
    nested: h,
    modal: a
  }), p.useContextCallback("onOpenChange", o), p.useContextCallback("onOpenChangeComplete", i);
  const g = p.useState("payload");
  LM({
    store: p,
    actionsRef: l,
    parentContext: f == null ? void 0 : f.store.context,
    onOpenChange: o,
    triggerIdProp: u
  });
  const v = m.useMemo(() => ({
    store: p
  }), [p]);
  return /* @__PURE__ */ _(pf.Provider, {
    value: v,
    children: typeof t == "function" ? t({
      payload: g
    }) : t
  });
}
let eg = function(e) {
  return e[e.open = Hn.open] = "open", e[e.closed = Hn.closed] = "closed", e[e.startingStyle = Hn.startingStyle] = "startingStyle", e[e.endingStyle = Hn.endingStyle] = "endingStyle", e.nested = "data-nested", e.nestedDialogOpen = "data-nested-dialog-open", e;
}({});
const BM = {
  ...Un,
  ...lr,
  nested(e) {
    return e ? {
      [eg.nested]: ""
    } : null;
  },
  nestedDialogOpen(e) {
    return e ? {
      [eg.nestedDialogOpen]: ""
    } : null;
  }
}, Sf = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    children: i,
    ...s
  } = t, a = a0(), {
    store: l
  } = Tr(), c = l.useState("open"), u = l.useState("nested"), d = l.useState("transitionStatus"), f = l.useState("nestedOpenDialogCount"), h = l.useState("mounted"), p = f > 0, g = m.useMemo(() => ({
    open: c,
    nested: u,
    transitionStatus: d,
    nestedDialogOpen: p
  }), [c, u, d, p]);
  return Ie("div", t, {
    enabled: a || h,
    state: g,
    ref: [n, l.useStateSetter("viewportElement")],
    stateAttributesMapping: BM,
    props: [{
      role: "presentation",
      hidden: !h,
      children: i
    }, s]
  });
});
process.env.NODE_ENV !== "production" && (Sf.displayName = "DialogViewport");
const Mf = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    id: i,
    ...s
  } = t, {
    store: a
  } = Tr(), l = Kt(i);
  return a.useSyncedValueWithCleanup("titleElementId", l), Ie("h2", t, {
    ref: n,
    props: [{
      id: l
    }, s]
  });
});
process.env.NODE_ENV !== "production" && (Mf.displayName = "DialogTitle");
const Of = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    disabled: i = !1,
    nativeButton: s = !0,
    id: a,
    payload: l,
    handle: c,
    ...u
  } = t, d = Tr(!0), f = (c == null ? void 0 : c.store) ?? (d == null ? void 0 : d.store);
  if (!f)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Trigger> must be used within <Dialog.Root> or provided with a handle." : Ke(79));
  const h = Kt(a), p = f.useState("floatingRootContext"), g = f.useState("isOpenedByTrigger", h), v = m.useRef(null), {
    registerTrigger: y,
    isMountedByThisTrigger: b
  } = nc(h, v, f, {
    payload: l
  }), {
    getButtonProps: w,
    buttonRef: C
  } = Jr({
    disabled: i,
    native: s
  }), x = Ql(p, {
    enabled: p != null
  }), E = Qr([x]), S = m.useMemo(() => ({
    disabled: i,
    open: g
  }), [i, g]), R = f.useState("triggerProps", b);
  return Ie("button", t, {
    state: S,
    ref: [C, n, y, v],
    props: [E.getReferenceProps(), R, {
      [Dd]: "",
      id: h
    }, u, w],
    stateAttributesMapping: dc
  });
});
process.env.NODE_ENV !== "production" && (Of.displayName = "DialogTrigger");
const HM = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Calendar/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2Z"
})), eo = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Check/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m5 13 4 4L19 7"
})), f0 = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronDown/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m19 9-7 7-7-7"
})), WM = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronLeft/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m15 19-7-7 7-7"
})), Rf = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronRight/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m9 5 7 7-7 7"
})), h0 = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Copy/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6.667 13.333H5c-.92 0-1.667-.746-1.667-1.666V5c0-.92.746-1.667 1.667-1.667h6.667c.92 0 1.666.746 1.666 1.667v1.667m-5 10H15c.92 0 1.667-.747 1.667-1.667V8.333c0-.92-.747-1.666-1.667-1.666H8.333c-.92 0-1.666.746-1.666 1.666V15c0 .92.746 1.667 1.666 1.667Z"
})), zM = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "DotsHorizontal/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
})), Xc = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ExclamationCircle/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), jM = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ExternalLink/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M10 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4M14 4h6m0 0v6m0-6L10 14"
})), UM = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "EyeOff/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m3 3 3.59 3.59M21 21l-3.589-3.589m-3.536 1.414A10.05 10.05 0 0 1 12 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 0 1 1.563-3.029m5.858.908a3 3 0 1 1 4.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532L6.59 6.59m7.532 7.532 3.29 3.29M6.59 6.59A9.953 9.953 0 0 1 12 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 0 1-4.132 5.411"
})), YM = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Eye/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
}), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M2.458 12C3.733 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.543 7-1.275 4.057-5.065 7-9.542 7-4.478 0-8.268-2.943-9.543-7Z"
})), tg = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "FolderDownload/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 10v6m0 0-3-3m3 3 3-3M3 17V7a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"
})), p0 = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "InformationCircle/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), GM = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "QuestionMarkCircle/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), KM = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Search/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
})), g0 = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "XCircle/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m10 14 2-2m0 0 2-2m-2 2-2-2m2 2 2 2m7-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), Tf = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "X/outline"
}, e), /* @__PURE__ */ m.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6 18 18 6M6 6l12 12"
}));
function qM(e) {
  return /* @__PURE__ */ _(d0, { ...e });
}
function m0(e) {
  return /* @__PURE__ */ _(Cf, { ...e });
}
function XM(e) {
  return /* @__PURE__ */ _(Of, { "data-slot": "dialog-trigger", ...e });
}
function ZM({ className: e, ...t }) {
  return /* @__PURE__ */ Z(
    hc,
    {
      "data-slot": "dialog-close",
      className: oe("shrink-0", e),
      ...t,
      children: [
        /* @__PURE__ */ _(Tf, { className: "h-5 w-5 text-foundations-subtler" }),
        /* @__PURE__ */ _("span", { className: "sr-only", children: "Close" })
      ]
    }
  );
}
function v0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ _(
    gf,
    {
      className: oe(
        "fixed inset-0 z-50 bg-[rgba(0,0,0,0.5)] transition-opacity duration-300",
        "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
        "data-[ending-style]:ease-in data-[starting-style]:ease-out",
        e
      ),
      "data-slot": "dialog-backdrop",
      ...t
    }
  );
}
function b0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ _(
    Sf,
    {
      className: oe(
        "fixed inset-0 z-50 grid grid-rows-[1fr_auto_1fr] justify-items-center p-4",
        e
      ),
      "data-slot": "dialog-viewport",
      ...t
    }
  );
}
function QM({
  className: e,
  children: t,
  backdropClassName: n,
  showCloseButton: r = !1,
  ...o
}) {
  return /* @__PURE__ */ Z(m0, { children: [
    /* @__PURE__ */ _(v0, { className: n }),
    /* @__PURE__ */ _(b0, { children: /* @__PURE__ */ Z(
      wf,
      {
        className: oe(
          "relative row-start-2 flex max-h-full min-h-0 w-full min-w-0 flex-col rounded-lg border border-foundations-subtle bg-foundations-default bg-clip-padding shadow-xl transition-all duration-300 ease-in-out will-change-transform",
          "opacity-[calc(1-0.1*var(--nested-dialogs))] data-[nested-dialog-open]:origin-top",
          "before:pointer-events-none before:absolute before:inset-0 before:rounded-[calc(var(--radius-lg)-1px)] before:shadow-[0_1px_--theme(--color-black/4%)]",
          "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
          "max-sm:opacity-[calc(1-min(var(--nested-dialogs),1))] max-sm:before:hidden max-sm:data-[ending-style]:translate-y-4 max-sm:data-[starting-style]:translate-y-4",
          "sm:my-8 sm:w-full sm:max-w-lg sm:-translate-y-[calc(1.25rem*var(--nested-dialogs))] sm:scale-[calc(1-0.1*var(--nested-dialogs))] sm:data-[nested]:data-[ending-style]:translate-y-8 sm:data-[nested]:data-[starting-style]:translate-y-8",
          "sm:data-[ending-style]:scale-95 sm:data-[starting-style]:scale-95",
          e
        ),
        "data-slot": "dialog-popup",
        ...o,
        children: [
          t,
          r && /* @__PURE__ */ Z(hc, { className: "opacity-72 pointer-coarse:after:absolute pointer-coarse:after:size-full pointer-coarse:after:min-h-11 pointer-coarse:after:min-w-11 focus-visible:ring-ring focus-visible:ring-offset-background absolute end-2 top-2 inline-flex shrink-0 cursor-pointer items-center justify-center rounded-md border border-transparent outline-none transition-[color,background-color,box-shadow,opacity] size-7 hover:opacity-100 focus-visible:ring-2 focus-visible:ring-offset-1 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0", children: [
            /* @__PURE__ */ _(Tf, {}),
            /* @__PURE__ */ _("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    ) })
  ] });
}
function JM({ className: e, ...t }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: oe(
        "in-[[data-slot=dialog-popup]:has([data-slot=dialog-panel])]:pb-3 flex items-center justify-between gap-2 p-6 pb-4 max-sm:pb-4",
        e
      ),
      "data-slot": "dialog-header",
      ...t
    }
  );
}
function eO({
  className: e,
  variant: t = "default",
  ...n
}) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: oe(
        "flex flex-col gap-2 sm:flex-row-reverse",
        t === "default" && "border-t border-t-foundations-subtle px-12 py-4",
        t === "bare" && "border-t-0 p-0",
        e
      ),
      "data-slot": "dialog-footer",
      ...n
    }
  );
}
function tO({
  className: e,
  render: t,
  ref: n,
  ...r
}) {
  return /* @__PURE__ */ _(
    Mf,
    {
      ref: n,
      render: t || /* @__PURE__ */ _("h3", {}),
      className: oe(
        "text-lg font-medium leading-6 text-foundations-boldest",
        e
      ),
      "data-slot": "dialog-title",
      ...r
    }
  );
}
function nO({
  className: e,
  ref: t,
  ...n
}) {
  return /* @__PURE__ */ _(
    bf,
    {
      ref: t,
      className: oe("text-sm text-foundations-subtle", e),
      "data-slot": "dialog-description",
      ...n
    }
  );
}
function rO({ className: e, ...t }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: oe("px-6 py-4", e),
      "data-slot": "dialog-panel",
      ...t
    }
  );
}
const r$ = Object.assign(qM, {
  Trigger: XM,
  Portal: m0,
  Close: ZM,
  Backdrop: v0,
  Popup: QM,
  Header: JM,
  Footer: eO,
  Title: tO,
  Description: nO,
  Panel: rO,
  Viewport: b0
});
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function Ns(e) {
  return e + 0.5 | 0;
}
const $r = (e, t, n) => Math.max(Math.min(e, n), t);
function Ui(e) {
  return $r(Ns(e * 2.55), 0, 255);
}
function jr(e) {
  return $r(Ns(e * 255), 0, 255);
}
function vr(e) {
  return $r(Ns(e / 2.55) / 100, 0, 1);
}
function ng(e) {
  return $r(Ns(e * 100), 0, 100);
}
const Sn = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, ed = [..."0123456789ABCDEF"], oO = (e) => ed[e & 15], iO = (e) => ed[(e & 240) >> 4] + ed[e & 15], ca = (e) => (e & 240) >> 4 === (e & 15), sO = (e) => ca(e.r) && ca(e.g) && ca(e.b) && ca(e.a);
function aO(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & Sn[e[1]] * 17,
    g: 255 & Sn[e[2]] * 17,
    b: 255 & Sn[e[3]] * 17,
    a: t === 5 ? Sn[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: Sn[e[1]] << 4 | Sn[e[2]],
    g: Sn[e[3]] << 4 | Sn[e[4]],
    b: Sn[e[5]] << 4 | Sn[e[6]],
    a: t === 9 ? Sn[e[7]] << 4 | Sn[e[8]] : 255
  })), n;
}
const lO = (e, t) => e < 255 ? t(e) : "";
function cO(e) {
  var t = sO(e) ? oO : iO;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + lO(e.a, t) : void 0;
}
const uO = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function y0(e, t, n) {
  const r = t * Math.min(n, 1 - n), o = (i, s = (i + e / 30) % 12) => n - r * Math.max(Math.min(s - 3, 9 - s, 1), -1);
  return [o(0), o(8), o(4)];
}
function dO(e, t, n) {
  const r = (o, i = (o + e / 60) % 6) => n - n * t * Math.max(Math.min(i, 4 - i, 1), 0);
  return [r(5), r(3), r(1)];
}
function fO(e, t, n) {
  const r = y0(e, 1, 0.5);
  let o;
  for (t + n > 1 && (o = 1 / (t + n), t *= o, n *= o), o = 0; o < 3; o++)
    r[o] *= 1 - t - n, r[o] += t;
  return r;
}
function hO(e, t, n, r, o) {
  return e === o ? (t - n) / r + (t < n ? 6 : 0) : t === o ? (n - e) / r + 2 : (e - t) / r + 4;
}
function kf(e) {
  const n = e.r / 255, r = e.g / 255, o = e.b / 255, i = Math.max(n, r, o), s = Math.min(n, r, o), a = (i + s) / 2;
  let l, c, u;
  return i !== s && (u = i - s, c = a > 0.5 ? u / (2 - i - s) : u / (i + s), l = hO(n, r, o, u, i), l = l * 60 + 0.5), [l | 0, c || 0, a];
}
function Pf(e, t, n, r) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, r)).map(jr);
}
function If(e, t, n) {
  return Pf(y0, e, t, n);
}
function pO(e, t, n) {
  return Pf(fO, e, t, n);
}
function gO(e, t, n) {
  return Pf(dO, e, t, n);
}
function x0(e) {
  return (e % 360 + 360) % 360;
}
function mO(e) {
  const t = uO.exec(e);
  let n = 255, r;
  if (!t)
    return;
  t[5] !== r && (n = t[6] ? Ui(+t[5]) : jr(+t[5]));
  const o = x0(+t[2]), i = +t[3] / 100, s = +t[4] / 100;
  return t[1] === "hwb" ? r = pO(o, i, s) : t[1] === "hsv" ? r = gO(o, i, s) : r = If(o, i, s), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: n
  };
}
function vO(e, t) {
  var n = kf(e);
  n[0] = x0(n[0] + t), n = If(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function bO(e) {
  if (!e)
    return;
  const t = kf(e), n = t[0], r = ng(t[1]), o = ng(t[2]);
  return e.a < 255 ? `hsla(${n}, ${r}%, ${o}%, ${vr(e.a)})` : `hsl(${n}, ${r}%, ${o}%)`;
}
const rg = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, og = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function yO() {
  const e = {}, t = Object.keys(og), n = Object.keys(rg);
  let r, o, i, s, a;
  for (r = 0; r < t.length; r++) {
    for (s = a = t[r], o = 0; o < n.length; o++)
      i = n[o], a = a.replace(i, rg[i]);
    i = parseInt(og[s], 16), e[a] = [i >> 16 & 255, i >> 8 & 255, i & 255];
  }
  return e;
}
let ua;
function xO(e) {
  ua || (ua = yO(), ua.transparent = [0, 0, 0, 0]);
  const t = ua[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const wO = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function CO(e) {
  const t = wO.exec(e);
  let n = 255, r, o, i;
  if (t) {
    if (t[7] !== r) {
      const s = +t[7];
      n = t[8] ? Ui(s) : $r(s * 255, 0, 255);
    }
    return r = +t[1], o = +t[3], i = +t[5], r = 255 & (t[2] ? Ui(r) : $r(r, 0, 255)), o = 255 & (t[4] ? Ui(o) : $r(o, 0, 255)), i = 255 & (t[6] ? Ui(i) : $r(i, 0, 255)), {
      r,
      g: o,
      b: i,
      a: n
    };
  }
}
function _O(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${vr(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const Zc = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, Wo = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function EO(e, t, n) {
  const r = Wo(vr(e.r)), o = Wo(vr(e.g)), i = Wo(vr(e.b));
  return {
    r: jr(Zc(r + n * (Wo(vr(t.r)) - r))),
    g: jr(Zc(o + n * (Wo(vr(t.g)) - o))),
    b: jr(Zc(i + n * (Wo(vr(t.b)) - i))),
    a: e.a + n * (t.a - e.a)
  };
}
function da(e, t, n) {
  if (e) {
    let r = kf(e);
    r[t] = Math.max(0, Math.min(r[t] + r[t] * n, t === 0 ? 360 : 1)), r = If(r), e.r = r[0], e.g = r[1], e.b = r[2];
  }
}
function w0(e, t) {
  return e && Object.assign(t || {}, e);
}
function ig(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = jr(e[3]))) : (t = w0(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = jr(t.a)), t;
}
function SO(e) {
  return e.charAt(0) === "r" ? CO(e) : mO(e);
}
class fs {
  constructor(t) {
    if (t instanceof fs)
      return t;
    const n = typeof t;
    let r;
    n === "object" ? r = ig(t) : n === "string" && (r = aO(t) || xO(t) || SO(t)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = w0(this._rgb);
    return t && (t.a = vr(t.a)), t;
  }
  set rgb(t) {
    this._rgb = ig(t);
  }
  rgbString() {
    return this._valid ? _O(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? cO(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? bO(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const r = this.rgb, o = t.rgb;
      let i;
      const s = n === i ? 0.5 : n, a = 2 * s - 1, l = r.a - o.a, c = ((a * l === -1 ? a : (a + l) / (1 + a * l)) + 1) / 2;
      i = 1 - c, r.r = 255 & c * r.r + i * o.r + 0.5, r.g = 255 & c * r.g + i * o.g + 0.5, r.b = 255 & c * r.b + i * o.b + 0.5, r.a = s * r.a + (1 - s) * o.a, this.rgb = r;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = EO(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new fs(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = jr(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = Ns(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return da(this._rgb, 2, t), this;
  }
  darken(t) {
    return da(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return da(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return da(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return vO(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.3.3
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
function fr() {
}
const MO = (() => {
  let e = 0;
  return () => e++;
})();
function ut(e) {
  return e === null || typeof e > "u";
}
function Ct(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function Xe(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function Ut(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function pn(e, t) {
  return Ut(e) ? e : t;
}
function et(e, t) {
  return typeof e > "u" ? t : e;
}
const OO = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, C0 = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function Mt(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function ct(e, t, n, r) {
  let o, i, s;
  if (Ct(e))
    if (i = e.length, r)
      for (o = i - 1; o >= 0; o--)
        t.call(n, e[o], o);
    else
      for (o = 0; o < i; o++)
        t.call(n, e[o], o);
  else if (Xe(e))
    for (s = Object.keys(e), i = s.length, o = 0; o < i; o++)
      t.call(n, e[s[o]], s[o]);
}
function pl(e, t) {
  let n, r, o, i;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, r = e.length; n < r; ++n)
    if (o = e[n], i = t[n], o.datasetIndex !== i.datasetIndex || o.index !== i.index)
      return !1;
  return !0;
}
function gl(e) {
  if (Ct(e))
    return e.map(gl);
  if (Xe(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), r = n.length;
    let o = 0;
    for (; o < r; ++o)
      t[n[o]] = gl(e[n[o]]);
    return t;
  }
  return e;
}
function _0(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function RO(e, t, n, r) {
  if (!_0(e))
    return;
  const o = t[e], i = n[e];
  Xe(o) && Xe(i) ? hs(o, i, r) : t[e] = gl(i);
}
function hs(e, t, n) {
  const r = Ct(t) ? t : [
    t
  ], o = r.length;
  if (!Xe(e))
    return e;
  n = n || {};
  const i = n.merger || RO;
  let s;
  for (let a = 0; a < o; ++a) {
    if (s = r[a], !Xe(s))
      continue;
    const l = Object.keys(s);
    for (let c = 0, u = l.length; c < u; ++c)
      i(l[c], e, s, n);
  }
  return e;
}
function es(e, t) {
  return hs(e, t, {
    merger: TO
  });
}
function TO(e, t, n) {
  if (!_0(e))
    return;
  const r = t[e], o = n[e];
  Xe(r) && Xe(o) ? es(r, o) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = gl(o));
}
const sg = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function kO(e) {
  const t = e.split("."), n = [];
  let r = "";
  for (const o of t)
    r += o, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (n.push(r), r = "");
  return n;
}
function PO(e) {
  const t = kO(e);
  return (n) => {
    for (const r of t) {
      if (r === "")
        break;
      n = n && n[r];
    }
    return n;
  };
}
function Mo(e, t) {
  return (sg[t] || (sg[t] = PO(t)))(e);
}
function Nf(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const ps = (e) => typeof e < "u", Ur = (e) => typeof e == "function", ag = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function IO(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const Ft = Math.PI, wt = 2 * Ft, NO = wt + Ft, ml = Number.POSITIVE_INFINITY, DO = Ft / 180, Tt = Ft / 2, oo = Ft / 4, lg = Ft * 2 / 3, Fr = Math.log10, tr = Math.sign;
function ts(e, t, n) {
  return Math.abs(e - t) < n;
}
function cg(e) {
  const t = Math.round(e);
  e = ts(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor(Fr(e))), r = e / n;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
}
function AO(e) {
  const t = [], n = Math.sqrt(e);
  let r;
  for (r = 1; r < n; r++)
    e % r === 0 && (t.push(r), t.push(e / r));
  return n === (n | 0) && t.push(n), t.sort((o, i) => o - i).pop(), t;
}
function gs(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function LO(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
function E0(e, t, n) {
  let r, o, i;
  for (r = 0, o = e.length; r < o; r++)
    i = e[r][n], isNaN(i) || (t.min = Math.min(t.min, i), t.max = Math.max(t.max, i));
}
function Zn(e) {
  return e * (Ft / 180);
}
function Df(e) {
  return e * (180 / Ft);
}
function ug(e) {
  if (!Ut(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
function S0(e, t) {
  const n = t.x - e.x, r = t.y - e.y, o = Math.sqrt(n * n + r * r);
  let i = Math.atan2(r, n);
  return i < -0.5 * Ft && (i += wt), {
    angle: i,
    distance: o
  };
}
function td(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function $O(e, t) {
  return (e - t + NO) % wt - Ft;
}
function Vn(e) {
  return (e % wt + wt) % wt;
}
function ms(e, t, n, r) {
  const o = Vn(e), i = Vn(t), s = Vn(n), a = Vn(i - o), l = Vn(s - o), c = Vn(o - i), u = Vn(o - s);
  return o === i || o === s || r && i === s || a > l && c < u;
}
function Zt(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function FO(e) {
  return Zt(e, -32768, 32767);
}
function vl(e, t, n, r = 1e-6) {
  return e >= Math.min(t, n) - r && e <= Math.max(t, n) + r;
}
function Af(e, t, n) {
  n = n || ((s) => e[s] < t);
  let r = e.length - 1, o = 0, i;
  for (; r - o > 1; )
    i = o + r >> 1, n(i) ? o = i : r = i;
  return {
    lo: o,
    hi: r
  };
}
const go = (e, t, n, r) => Af(e, n, r ? (o) => {
  const i = e[o][t];
  return i < n || i === n && e[o + 1][t] === n;
} : (o) => e[o][t] < n), VO = (e, t, n) => Af(e, n, (r) => e[r][t] >= n);
function BO(e, t, n) {
  let r = 0, o = e.length;
  for (; r < o && e[r] < t; )
    r++;
  for (; o > r && e[o - 1] > n; )
    o--;
  return r > 0 || o < e.length ? e.slice(r, o) : e;
}
const M0 = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function HO(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), M0.forEach((n) => {
    const r = "_onData" + Nf(n), o = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const s = o.apply(this, i);
        return e._chartjs.listeners.forEach((a) => {
          typeof a[r] == "function" && a[r](...i);
        }), s;
      }
    });
  });
}
function dg(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const r = n.listeners, o = r.indexOf(t);
  o !== -1 && r.splice(o, 1), !(r.length > 0) && (M0.forEach((i) => {
    delete e[i];
  }), delete e._chartjs);
}
function O0(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const R0 = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function T0(e, t) {
  let n = [], r = !1;
  return function(...o) {
    n = o, r || (r = !0, R0.call(window, () => {
      r = !1, e.apply(t, n);
    }));
  };
}
function WO(e, t) {
  let n;
  return function(...r) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, r)) : e.apply(this, r), t;
  };
}
const zO = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", fg = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2;
function jO(e, t, n) {
  const r = t.length;
  let o = 0, i = r;
  if (e._sorted) {
    const { iScale: s, _parsed: a } = e, l = s.axis, { min: c, max: u, minDefined: d, maxDefined: f } = s.getUserBounds();
    d && (o = Zt(Math.min(
      // @ts-expect-error Need to type _parsed
      go(a, l, c).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? r : go(t, l, s.getPixelForValue(c)).lo
    ), 0, r - 1)), f ? i = Zt(Math.max(
      // @ts-expect-error Need to type _parsed
      go(a, s.axis, u, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? 0 : go(t, l, s.getPixelForValue(u), !0).hi + 1
    ), o, r) - o : i = r - o;
  }
  return {
    start: o,
    count: i
  };
}
function UO(e) {
  const { xScale: t, yScale: n, _scaleRanges: r } = e, o = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!r)
    return e._scaleRanges = o, !0;
  const i = r.xmin !== t.min || r.xmax !== t.max || r.ymin !== n.min || r.ymax !== n.max;
  return Object.assign(r, o), i;
}
const fa = (e) => e === 0 || e === 1, hg = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * wt / n)), pg = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * wt / n) + 1, ns = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * Tt) + 1,
  easeOutSine: (e) => Math.sin(e * Tt),
  easeInOutSine: (e) => -0.5 * (Math.cos(Ft * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => fa(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => fa(e) ? e : hg(e, 0.075, 0.3),
  easeOutElastic: (e) => fa(e) ? e : pg(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return fa(e) ? e : e < 0.5 ? 0.5 * hg(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * pg(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - ns.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? ns.easeInBounce(e * 2) * 0.5 : ns.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function Lf(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function gg(e) {
  return Lf(e) ? e : new fs(e);
}
function Qc(e) {
  return Lf(e) ? e : new fs(e).saturate(0.5).darken(0.1).hexString();
}
const YO = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], GO = [
  "color",
  "borderColor",
  "backgroundColor"
];
function KO(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: GO
    },
    numbers: {
      type: "number",
      properties: YO
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function qO(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const mg = /* @__PURE__ */ new Map();
function XO(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let r = mg.get(n);
  return r || (r = new Intl.NumberFormat(e, t), mg.set(n, r)), r;
}
function gc(e, t, n) {
  return XO(t, n).format(e);
}
const k0 = {
  values(e) {
    return Ct(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const r = this.chart.options.locale;
    let o, i = e;
    if (n.length > 1) {
      const c = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (c < 1e-4 || c > 1e15) && (o = "scientific"), i = ZO(e, n);
    }
    const s = Fr(Math.abs(i)), a = isNaN(s) ? 1 : Math.max(Math.min(-1 * Math.floor(s), 20), 0), l = {
      notation: o,
      minimumFractionDigits: a,
      maximumFractionDigits: a
    };
    return Object.assign(l, this.options.ticks.format), gc(e, r, l);
  },
  logarithmic(e, t, n) {
    if (e === 0)
      return "0";
    const r = n[t].significand || e / Math.pow(10, Math.floor(Fr(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(r) || t > 0.8 * n.length ? k0.numeric.call(this, e, t, n) : "";
  }
};
function ZO(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var mc = {
  formatters: k0
};
function QO(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, n) => n.lineWidth,
      tickColor: (t, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: mc.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const Oo = /* @__PURE__ */ Object.create(null), nd = /* @__PURE__ */ Object.create(null);
function rs(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let r = 0, o = n.length; r < o; ++r) {
    const i = n[r];
    e = e[i] || (e[i] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function Jc(e, t, n) {
  return typeof t == "string" ? hs(rs(e, t), n) : hs(rs(e, ""), t);
}
class JO {
  constructor(t, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (r) => r.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (r, o) => Qc(o.backgroundColor), this.hoverBorderColor = (r, o) => Qc(o.borderColor), this.hoverColor = (r, o) => Qc(o.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(n);
  }
  set(t, n) {
    return Jc(this, t, n);
  }
  get(t) {
    return rs(this, t);
  }
  describe(t, n) {
    return Jc(nd, t, n);
  }
  override(t, n) {
    return Jc(Oo, t, n);
  }
  route(t, n, r, o) {
    const i = rs(this, t), s = rs(this, r), a = "_" + n;
    Object.defineProperties(i, {
      [a]: {
        value: i[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const l = this[a], c = s[o];
          return Xe(l) ? Object.assign({}, c, l) : et(l, c);
        },
        set(l) {
          this[a] = l;
        }
      }
    });
  }
  apply(t) {
    t.forEach((n) => n(this));
  }
}
var At = /* @__PURE__ */ new JO({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  KO,
  qO,
  QO
]);
function eR(e) {
  return !e || ut(e.size) || ut(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function bl(e, t, n, r, o) {
  let i = t[o];
  return i || (i = t[o] = e.measureText(o).width, n.push(o)), i > r && (r = i), r;
}
function tR(e, t, n, r) {
  r = r || {};
  let o = r.data = r.data || {}, i = r.garbageCollect = r.garbageCollect || [];
  r.font !== t && (o = r.data = {}, i = r.garbageCollect = [], r.font = t), e.save(), e.font = t;
  let s = 0;
  const a = n.length;
  let l, c, u, d, f;
  for (l = 0; l < a; l++)
    if (d = n[l], d != null && !Ct(d))
      s = bl(e, o, i, s, d);
    else if (Ct(d))
      for (c = 0, u = d.length; c < u; c++)
        f = d[c], f != null && !Ct(f) && (s = bl(e, o, i, s, f));
  e.restore();
  const h = i.length / 2;
  if (h > n.length) {
    for (l = 0; l < h; l++)
      delete o[i[l]];
    i.splice(0, h);
  }
  return s;
}
function io(e, t, n) {
  const r = e.currentDevicePixelRatio, o = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - o) * r) / r + o;
}
function vg(e, t) {
  t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore();
}
function rd(e, t, n, r) {
  nR(e, t, n, r, null);
}
function nR(e, t, n, r, o) {
  let i, s, a, l, c, u, d, f;
  const h = t.pointStyle, p = t.rotation, g = t.radius;
  let v = (p || 0) * DO;
  if (h && typeof h == "object" && (i = h.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, r), e.rotate(v), e.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), e.restore();
    return;
  }
  if (!(isNaN(g) || g <= 0)) {
    switch (e.beginPath(), h) {
      default:
        o ? e.ellipse(n, r, o / 2, g, 0, 0, wt) : e.arc(n, r, g, 0, wt), e.closePath();
        break;
      case "triangle":
        u = o ? o / 2 : g, e.moveTo(n + Math.sin(v) * u, r - Math.cos(v) * g), v += lg, e.lineTo(n + Math.sin(v) * u, r - Math.cos(v) * g), v += lg, e.lineTo(n + Math.sin(v) * u, r - Math.cos(v) * g), e.closePath();
        break;
      case "rectRounded":
        c = g * 0.516, l = g - c, s = Math.cos(v + oo) * l, d = Math.cos(v + oo) * (o ? o / 2 - c : l), a = Math.sin(v + oo) * l, f = Math.sin(v + oo) * (o ? o / 2 - c : l), e.arc(n - d, r - a, c, v - Ft, v - Tt), e.arc(n + f, r - s, c, v - Tt, v), e.arc(n + d, r + a, c, v, v + Tt), e.arc(n - f, r + s, c, v + Tt, v + Ft), e.closePath();
        break;
      case "rect":
        if (!p) {
          l = Math.SQRT1_2 * g, u = o ? o / 2 : l, e.rect(n - u, r - l, 2 * u, 2 * l);
          break;
        }
        v += oo;
      case "rectRot":
        d = Math.cos(v) * (o ? o / 2 : g), s = Math.cos(v) * g, a = Math.sin(v) * g, f = Math.sin(v) * (o ? o / 2 : g), e.moveTo(n - d, r - a), e.lineTo(n + f, r - s), e.lineTo(n + d, r + a), e.lineTo(n - f, r + s), e.closePath();
        break;
      case "crossRot":
        v += oo;
      case "cross":
        d = Math.cos(v) * (o ? o / 2 : g), s = Math.cos(v) * g, a = Math.sin(v) * g, f = Math.sin(v) * (o ? o / 2 : g), e.moveTo(n - d, r - a), e.lineTo(n + d, r + a), e.moveTo(n + f, r - s), e.lineTo(n - f, r + s);
        break;
      case "star":
        d = Math.cos(v) * (o ? o / 2 : g), s = Math.cos(v) * g, a = Math.sin(v) * g, f = Math.sin(v) * (o ? o / 2 : g), e.moveTo(n - d, r - a), e.lineTo(n + d, r + a), e.moveTo(n + f, r - s), e.lineTo(n - f, r + s), v += oo, d = Math.cos(v) * (o ? o / 2 : g), s = Math.cos(v) * g, a = Math.sin(v) * g, f = Math.sin(v) * (o ? o / 2 : g), e.moveTo(n - d, r - a), e.lineTo(n + d, r + a), e.moveTo(n + f, r - s), e.lineTo(n - f, r + s);
        break;
      case "line":
        s = o ? o / 2 : Math.cos(v) * g, a = Math.sin(v) * g, e.moveTo(n - s, r - a), e.lineTo(n + s, r + a);
        break;
      case "dash":
        e.moveTo(n, r), e.lineTo(n + Math.cos(v) * (o ? o / 2 : g), r + Math.sin(v) * g);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function br(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function P0(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function I0(e) {
  e.restore();
}
function rR(e, t, n, r, o) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (o === "middle") {
    const i = (t.x + n.x) / 2;
    e.lineTo(i, t.y), e.lineTo(i, n.y);
  } else
    o === "after" != !!r ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
function oR(e, t, n, r) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(r ? t.cp1x : t.cp2x, r ? t.cp1y : t.cp2y, r ? n.cp2x : n.cp1x, r ? n.cp2y : n.cp1y, n.x, n.y);
}
function iR(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), ut(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function sR(e, t, n, r, o) {
  if (o.strikethrough || o.underline) {
    const i = e.measureText(r), s = t - i.actualBoundingBoxLeft, a = t + i.actualBoundingBoxRight, l = n - i.actualBoundingBoxAscent, c = n + i.actualBoundingBoxDescent, u = o.strikethrough ? (l + c) / 2 : c;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = o.decorationWidth || 2, e.moveTo(s, u), e.lineTo(a, u), e.stroke();
  }
}
function aR(e, t) {
  const n = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
function yl(e, t, n, r, o, i = {}) {
  const s = Ct(t) ? t : [
    t
  ], a = i.strokeWidth > 0 && i.strokeColor !== "";
  let l, c;
  for (e.save(), e.font = o.string, iR(e, i), l = 0; l < s.length; ++l)
    c = s[l], i.backdrop && aR(e, i.backdrop), a && (i.strokeColor && (e.strokeStyle = i.strokeColor), ut(i.strokeWidth) || (e.lineWidth = i.strokeWidth), e.strokeText(c, n, r, i.maxWidth)), e.fillText(c, n, r, i.maxWidth), sR(e, n, r, c, i), r += Number(o.lineHeight);
  e.restore();
}
function xl(e, t) {
  const { x: n, y: r, w: o, h: i, radius: s } = t;
  e.arc(n + s.topLeft, r + s.topLeft, s.topLeft, -Tt, Ft, !0), e.lineTo(n, r + i - s.bottomLeft), e.arc(n + s.bottomLeft, r + i - s.bottomLeft, s.bottomLeft, Ft, Tt, !0), e.lineTo(n + o - s.bottomRight, r + i), e.arc(n + o - s.bottomRight, r + i - s.bottomRight, s.bottomRight, Tt, 0, !0), e.lineTo(n + o, r + s.topRight), e.arc(n + o - s.topRight, r + s.topRight, s.topRight, 0, -Tt, !0), e.lineTo(n + s.topLeft, r);
}
const lR = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, cR = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function uR(e, t) {
  const n = ("" + e).match(lR);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const dR = (e) => +e || 0;
function $f(e, t) {
  const n = {}, r = Xe(t), o = r ? Object.keys(t) : t, i = Xe(e) ? r ? (s) => et(e[s], e[t[s]]) : (s) => e[s] : () => e;
  for (const s of o)
    n[s] = dR(i(s));
  return n;
}
function N0(e) {
  return $f(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function oi(e) {
  return $f(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function In(e) {
  const t = N0(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function yn(e, t) {
  e = e || {}, t = t || At.font;
  let n = et(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let r = et(e.style, t.style);
  r && !("" + r).match(cR) && (console.warn('Invalid font style specified: "' + r + '"'), r = void 0);
  const o = {
    family: et(e.family, t.family),
    lineHeight: uR(et(e.lineHeight, t.lineHeight), n),
    size: n,
    style: r,
    weight: et(e.weight, t.weight),
    string: ""
  };
  return o.string = eR(o), o;
}
function ha(e, t, n, r) {
  let o = !0, i, s, a;
  for (i = 0, s = e.length; i < s; ++i)
    if (a = e[i], a !== void 0 && (t !== void 0 && typeof a == "function" && (a = a(t), o = !1), n !== void 0 && Ct(a) && (a = a[n % a.length], o = !1), a !== void 0))
      return r && !o && (r.cacheable = !1), a;
}
function fR(e, t, n) {
  const { min: r, max: o } = e, i = C0(t, (o - r) / 2), s = (a, l) => n && a === 0 ? 0 : a + l;
  return {
    min: s(r, -Math.abs(i)),
    max: s(o, i)
  };
}
function to(e, t) {
  return Object.assign(Object.create(e), t);
}
function Ff(e, t = [
  ""
], n, r, o = () => e[0]) {
  const i = n || e;
  typeof r > "u" && (r = $0("_fallback", e));
  const s = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: i,
    _fallback: r,
    _getTarget: o,
    override: (a) => Ff([
      a,
      ...e
    ], t, i, r)
  };
  return new Proxy(s, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, l) {
      return delete a[l], delete a._keys, delete e[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, l) {
      return A0(a, l, () => xR(l, t, e, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, l) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(a, l) {
      return yg(a).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(a) {
      return yg(a);
    },
    /**
    * A trap for setting property values.
    */
    set(a, l, c) {
      const u = a._storage || (a._storage = o());
      return a[l] = u[l] = c, delete a._keys, !0;
    }
  });
}
function di(e, t, n, r) {
  const o = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: D0(e, r),
    setContext: (i) => di(e, i, n, r),
    override: (i) => di(e.override(i), t, n, r)
  };
  return new Proxy(o, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, s) {
      return delete i[s], delete e[s], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, s, a) {
      return A0(i, s, () => pR(i, s, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, s) {
      return i._descriptors.allKeys ? Reflect.has(e, s) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, s);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(i, s) {
      return Reflect.has(e, s);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(i, s, a) {
      return e[s] = a, delete i[s], !0;
    }
  });
}
function D0(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = t.scriptable, _indexable: r = t.indexable, _allKeys: o = t.allKeys } = e;
  return {
    allKeys: o,
    scriptable: n,
    indexable: r,
    isScriptable: Ur(n) ? n : () => n,
    isIndexable: Ur(r) ? r : () => r
  };
}
const hR = (e, t) => e ? e + Nf(t) : t, Vf = (e, t) => Xe(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function A0(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t))
    return e[t];
  const r = n();
  return e[t] = r, r;
}
function pR(e, t, n) {
  const { _proxy: r, _context: o, _subProxy: i, _descriptors: s } = e;
  let a = r[t];
  return Ur(a) && s.isScriptable(t) && (a = gR(t, a, e, n)), Ct(a) && a.length && (a = mR(t, a, e, s.isIndexable)), Vf(t, a) && (a = di(a, o, i && i[t], s)), a;
}
function gR(e, t, n, r) {
  const { _proxy: o, _context: i, _subProxy: s, _stack: a } = n;
  if (a.has(e))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + e);
  a.add(e);
  let l = t(i, s || r);
  return a.delete(e), Vf(e, l) && (l = Bf(o._scopes, o, e, l)), l;
}
function mR(e, t, n, r) {
  const { _proxy: o, _context: i, _subProxy: s, _descriptors: a } = n;
  if (typeof i.index < "u" && r(e))
    return t[i.index % t.length];
  if (Xe(t[0])) {
    const l = t, c = o._scopes.filter((u) => u !== l);
    t = [];
    for (const u of l) {
      const d = Bf(c, o, e, u);
      t.push(di(d, i, s && s[e], a));
    }
  }
  return t;
}
function L0(e, t, n) {
  return Ur(e) ? e(t, n) : e;
}
const vR = (e, t) => e === !0 ? t : typeof e == "string" ? Mo(t, e) : void 0;
function bR(e, t, n, r, o) {
  for (const i of t) {
    const s = vR(n, i);
    if (s) {
      e.add(s);
      const a = L0(s._fallback, n, o);
      if (typeof a < "u" && a !== n && a !== r)
        return a;
    } else if (s === !1 && typeof r < "u" && n !== r)
      return null;
  }
  return !1;
}
function Bf(e, t, n, r) {
  const o = t._rootScopes, i = L0(t._fallback, n, r), s = [
    ...e,
    ...o
  ], a = /* @__PURE__ */ new Set();
  a.add(r);
  let l = bg(a, s, n, i || n, r);
  return l === null || typeof i < "u" && i !== n && (l = bg(a, s, i, l, r), l === null) ? !1 : Ff(Array.from(a), [
    ""
  ], o, i, () => yR(t, n, r));
}
function bg(e, t, n, r, o) {
  for (; n; )
    n = bR(e, t, n, r, o);
  return n;
}
function yR(e, t, n) {
  const r = e._getTarget();
  t in r || (r[t] = {});
  const o = r[t];
  return Ct(o) && Xe(n) ? n : o || {};
}
function xR(e, t, n, r) {
  let o;
  for (const i of t)
    if (o = $0(hR(i, e), n), typeof o < "u")
      return Vf(e, o) ? Bf(n, r, e, o) : o;
}
function $0(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const r = n[e];
    if (typeof r < "u")
      return r;
  }
}
function yg(e) {
  let t = e._keys;
  return t || (t = e._keys = wR(e._scopes)), t;
}
function wR(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const r of Object.keys(n).filter((o) => !o.startsWith("_")))
      t.add(r);
  return Array.from(t);
}
const CR = Number.EPSILON || 1e-14, fi = (e, t) => t < e.length && !e[t].skip && e[t], F0 = (e) => e === "x" ? "y" : "x";
function _R(e, t, n, r) {
  const o = e.skip ? t : e, i = t, s = n.skip ? t : n, a = td(i, o), l = td(s, i);
  let c = a / (a + l), u = l / (a + l);
  c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
  const d = r * c, f = r * u;
  return {
    previous: {
      x: i.x - d * (s.x - o.x),
      y: i.y - d * (s.y - o.y)
    },
    next: {
      x: i.x + f * (s.x - o.x),
      y: i.y + f * (s.y - o.y)
    }
  };
}
function ER(e, t, n) {
  const r = e.length;
  let o, i, s, a, l, c = fi(e, 0);
  for (let u = 0; u < r - 1; ++u)
    if (l = c, c = fi(e, u + 1), !(!l || !c)) {
      if (ts(t[u], 0, CR)) {
        n[u] = n[u + 1] = 0;
        continue;
      }
      o = n[u] / t[u], i = n[u + 1] / t[u], a = Math.pow(o, 2) + Math.pow(i, 2), !(a <= 9) && (s = 3 / Math.sqrt(a), n[u] = o * s * t[u], n[u + 1] = i * s * t[u]);
    }
}
function SR(e, t, n = "x") {
  const r = F0(n), o = e.length;
  let i, s, a, l = fi(e, 0);
  for (let c = 0; c < o; ++c) {
    if (s = a, a = l, l = fi(e, c + 1), !a)
      continue;
    const u = a[n], d = a[r];
    s && (i = (u - s[n]) / 3, a[`cp1${n}`] = u - i, a[`cp1${r}`] = d - i * t[c]), l && (i = (l[n] - u) / 3, a[`cp2${n}`] = u + i, a[`cp2${r}`] = d + i * t[c]);
  }
}
function MR(e, t = "x") {
  const n = F0(t), r = e.length, o = Array(r).fill(0), i = Array(r);
  let s, a, l, c = fi(e, 0);
  for (s = 0; s < r; ++s)
    if (a = l, l = c, c = fi(e, s + 1), !!l) {
      if (c) {
        const u = c[t] - l[t];
        o[s] = u !== 0 ? (c[n] - l[n]) / u : 0;
      }
      i[s] = a ? c ? tr(o[s - 1]) !== tr(o[s]) ? 0 : (o[s - 1] + o[s]) / 2 : o[s - 1] : o[s];
    }
  ER(e, o, i), SR(e, i, t);
}
function pa(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
function OR(e, t) {
  let n, r, o, i, s, a = br(e[0], t);
  for (n = 0, r = e.length; n < r; ++n)
    s = i, i = a, a = n < r - 1 && br(e[n + 1], t), i && (o = e[n], s && (o.cp1x = pa(o.cp1x, t.left, t.right), o.cp1y = pa(o.cp1y, t.top, t.bottom)), a && (o.cp2x = pa(o.cp2x, t.left, t.right), o.cp2y = pa(o.cp2y, t.top, t.bottom)));
}
function RR(e, t, n, r, o) {
  let i, s, a, l;
  if (t.spanGaps && (e = e.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    MR(e, o);
  else {
    let c = r ? e[e.length - 1] : e[0];
    for (i = 0, s = e.length; i < s; ++i)
      a = e[i], l = _R(c, a, e[Math.min(i + 1, s - (r ? 0 : 1)) % s], t.tension), a.cp1x = l.previous.x, a.cp1y = l.previous.y, a.cp2x = l.next.x, a.cp2y = l.next.y, c = a;
  }
  t.capBezierPoints && OR(e, n);
}
function V0() {
  return typeof window < "u" && typeof document < "u";
}
function Hf(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function wl(e, t, n) {
  let r;
  return typeof e == "string" ? (r = parseInt(e, 10), e.indexOf("%") !== -1 && (r = r / 100 * t.parentNode[n])) : r = e, r;
}
const vc = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function TR(e, t) {
  return vc(e).getPropertyValue(t);
}
const kR = [
  "top",
  "right",
  "bottom",
  "left"
];
function yo(e, t, n) {
  const r = {};
  n = n ? "-" + n : "";
  for (let o = 0; o < 4; o++) {
    const i = kR[o];
    r[i] = parseFloat(e[t + "-" + i + n]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const PR = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function IR(e, t) {
  const n = e.touches, r = n && n.length ? n[0] : e, { offsetX: o, offsetY: i } = r;
  let s = !1, a, l;
  if (PR(o, i, e.target))
    a = o, l = i;
  else {
    const c = t.getBoundingClientRect();
    a = r.clientX - c.left, l = r.clientY - c.top, s = !0;
  }
  return {
    x: a,
    y: l,
    box: s
  };
}
function lo(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: r } = t, o = vc(n), i = o.boxSizing === "border-box", s = yo(o, "padding"), a = yo(o, "border", "width"), { x: l, y: c, box: u } = IR(e, n), d = s.left + (u && a.left), f = s.top + (u && a.top);
  let { width: h, height: p } = t;
  return i && (h -= s.width + a.width, p -= s.height + a.height), {
    x: Math.round((l - d) / h * n.width / r),
    y: Math.round((c - f) / p * n.height / r)
  };
}
function NR(e, t, n) {
  let r, o;
  if (t === void 0 || n === void 0) {
    const i = Hf(e);
    if (!i)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const s = i.getBoundingClientRect(), a = vc(i), l = yo(a, "border", "width"), c = yo(a, "padding");
      t = s.width - c.width - l.width, n = s.height - c.height - l.height, r = wl(a.maxWidth, i, "clientWidth"), o = wl(a.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: r || ml,
    maxHeight: o || ml
  };
}
const ga = (e) => Math.round(e * 10) / 10;
function DR(e, t, n, r) {
  const o = vc(e), i = yo(o, "margin"), s = wl(o.maxWidth, e, "clientWidth") || ml, a = wl(o.maxHeight, e, "clientHeight") || ml, l = NR(e, t, n);
  let { width: c, height: u } = l;
  if (o.boxSizing === "content-box") {
    const f = yo(o, "border", "width"), h = yo(o, "padding");
    c -= h.width + f.width, u -= h.height + f.height;
  }
  return c = Math.max(0, c - i.width), u = Math.max(0, r ? c / r : u - i.height), c = ga(Math.min(c, s, l.maxWidth)), u = ga(Math.min(u, a, l.maxHeight)), c && !u && (u = ga(c / 2)), (t !== void 0 || n !== void 0) && r && l.height && u > l.height && (u = l.height, c = ga(Math.floor(u * r))), {
    width: c,
    height: u
  };
}
function xg(e, t, n) {
  const r = t || 1, o = Math.floor(e.height * r), i = Math.floor(e.width * r);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const s = e.canvas;
  return s.style && (n || !s.style.height && !s.style.width) && (s.style.height = `${e.height}px`, s.style.width = `${e.width}px`), e.currentDevicePixelRatio !== r || s.height !== o || s.width !== i ? (e.currentDevicePixelRatio = r, s.height = o, s.width = i, e.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const AR = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
  } catch {
  }
  return e;
}();
function wg(e, t) {
  const n = TR(e, t), r = n && n.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function co(e, t, n, r) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
function LR(e, t, n, r) {
  return {
    x: e.x + n * (t.x - e.x),
    y: r === "middle" ? n < 0.5 ? e.y : t.y : r === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
function $R(e, t, n, r) {
  const o = {
    x: e.cp2x,
    y: e.cp2y
  }, i = {
    x: t.cp1x,
    y: t.cp1y
  }, s = co(e, o, n), a = co(o, i, n), l = co(i, t, n), c = co(s, a, n), u = co(a, l, n);
  return co(c, u, n);
}
const FR = function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, r) {
      return n - r;
    },
    leftForLtr(n, r) {
      return n - r;
    }
  };
}, VR = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function eu(e, t, n) {
  return e ? FR(t, n) : VR();
}
function BR(e, t) {
  let n, r;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, r = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = r);
}
function HR(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function B0(e) {
  return e === "angle" ? {
    between: ms,
    compare: $O,
    normalize: Vn
  } : {
    between: vl,
    compare: (t, n) => t - n,
    normalize: (t) => t
  };
}
function Cg({ start: e, end: t, count: n, loop: r, style: o }) {
  return {
    start: e % n,
    end: t % n,
    loop: r && (t - e + 1) % n === 0,
    style: o
  };
}
function WR(e, t, n) {
  const { property: r, start: o, end: i } = n, { between: s, normalize: a } = B0(r), l = t.length;
  let { start: c, end: u, loop: d } = e, f, h;
  if (d) {
    for (c += l, u += l, f = 0, h = l; f < h && s(a(t[c % l][r]), o, i); ++f)
      c--, u--;
    c %= l, u %= l;
  }
  return u < c && (u += l), {
    start: c,
    end: u,
    loop: d,
    style: e.style
  };
}
function zR(e, t, n) {
  if (!n)
    return [
      e
    ];
  const { property: r, start: o, end: i } = n, s = t.length, { compare: a, between: l, normalize: c } = B0(r), { start: u, end: d, loop: f, style: h } = WR(e, t, n), p = [];
  let g = !1, v = null, y, b, w;
  const C = () => l(o, w, y) && a(o, w) !== 0, x = () => a(i, y) === 0 || l(i, w, y), E = () => g || C(), S = () => !g || x();
  for (let R = u, M = u; R <= d; ++R)
    b = t[R % s], !b.skip && (y = c(b[r]), y !== w && (g = l(y, o, i), v === null && E() && (v = a(y, o) === 0 ? R : M), v !== null && S() && (p.push(Cg({
      start: v,
      end: R,
      loop: f,
      count: s,
      style: h
    })), v = null), M = R, w = y));
  return v !== null && p.push(Cg({
    start: v,
    end: d,
    loop: f,
    count: s,
    style: h
  })), p;
}
function jR(e, t) {
  const n = [], r = e.segments;
  for (let o = 0; o < r.length; o++) {
    const i = zR(r[o], e.points, t);
    i.length && n.push(...i);
  }
  return n;
}
function UR(e, t, n, r) {
  let o = 0, i = t - 1;
  if (n && !r)
    for (; o < t && !e[o].skip; )
      o++;
  for (; o < t && e[o].skip; )
    o++;
  for (o %= t, n && (i += o); i > o && e[i % t].skip; )
    i--;
  return i %= t, {
    start: o,
    end: i
  };
}
function YR(e, t, n, r) {
  const o = e.length, i = [];
  let s = t, a = e[t], l;
  for (l = t + 1; l <= n; ++l) {
    const c = e[l % o];
    c.skip || c.stop ? a.skip || (r = !1, i.push({
      start: t % o,
      end: (l - 1) % o,
      loop: r
    }), t = s = c.stop ? l : null) : (s = l, a.skip && (t = l)), a = c;
  }
  return s !== null && i.push({
    start: t % o,
    end: s % o,
    loop: r
  }), i;
}
function GR(e, t) {
  const n = e.points, r = e.options.spanGaps, o = n.length;
  if (!o)
    return [];
  const i = !!e._loop, { start: s, end: a } = UR(n, o, i, r);
  if (r === !0)
    return _g(e, [
      {
        start: s,
        end: a,
        loop: i
      }
    ], n, t);
  const l = a < s ? a + o : a, c = !!e._fullLoop && s === 0 && a === o - 1;
  return _g(e, YR(n, s, l, c), n, t);
}
function _g(e, t, n, r) {
  return !r || !r.setContext || !n ? t : KR(e, t, n, r);
}
function KR(e, t, n, r) {
  const o = e._chart.getContext(), i = Eg(e.options), { _datasetIndex: s, options: { spanGaps: a } } = e, l = n.length, c = [];
  let u = i, d = t[0].start, f = d;
  function h(p, g, v, y) {
    const b = a ? -1 : 1;
    if (p !== g) {
      for (p += l; n[p % l].skip; )
        p -= b;
      for (; n[g % l].skip; )
        g += b;
      p % l !== g % l && (c.push({
        start: p % l,
        end: g % l,
        loop: v,
        style: y
      }), u = y, d = g % l);
    }
  }
  for (const p of t) {
    d = a ? d : p.start;
    let g = n[d % l], v;
    for (f = d + 1; f <= p.end; f++) {
      const y = n[f % l];
      v = Eg(r.setContext(to(o, {
        type: "segment",
        p0: g,
        p1: y,
        p0DataIndex: (f - 1) % l,
        p1DataIndex: f % l,
        datasetIndex: s
      }))), qR(v, u) && h(d, f - 1, p.loop, u), g = y, u = v;
    }
    d < f - 1 && h(d, f - 1, p.loop, u);
  }
  return c;
}
function Eg(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function qR(e, t) {
  if (!t)
    return !1;
  const n = [], r = function(o, i) {
    return Lf(i) ? (n.includes(i) || n.push(i), n.indexOf(i)) : i;
  };
  return JSON.stringify(e, r) !== JSON.stringify(t, r);
}
/*!
 * Chart.js v4.3.3
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
class XR {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, r, o) {
    const i = n.listeners[o], s = n.duration;
    i.forEach((a) => a({
      chart: t,
      initial: n.initial,
      numSteps: s,
      currentStep: Math.min(r - n.start, s)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = R0.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((r, o) => {
      if (!r.running || !r.items.length)
        return;
      const i = r.items;
      let s = i.length - 1, a = !1, l;
      for (; s >= 0; --s)
        l = i[s], l._active ? (l._total > r.duration && (r.duration = l._total), l.tick(t), a = !0) : (i[s] = i[i.length - 1], i.pop());
      a && (o.draw(), this._notify(o, r, t, "progress")), i.length || (r.running = !1, this._notify(o, r, t, "complete"), r.initial = !1), n += i.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let r = n.get(t);
    return r || (r = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, r)), r;
  }
  listen(t, n, r) {
    this._getAnims(t).listeners[n].push(r);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((r, o) => Math.max(r, o._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const r = n.items;
    let o = r.length - 1;
    for (; o >= 0; --o)
      r[o].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var gr = /* @__PURE__ */ new XR();
const Sg = "transparent", ZR = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const r = gg(e || Sg), o = r.valid && gg(t || Sg);
    return o && o.valid ? o.mix(r, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
};
class QR {
  constructor(t, n, r, o) {
    const i = n[r];
    o = ha([
      t.to,
      o,
      i,
      t.from
    ]);
    const s = ha([
      t.from,
      i,
      o
    ]);
    this._active = !0, this._fn = t.fn || ZR[t.type || typeof s], this._easing = ns[t.easing] || ns.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = r, this._from = s, this._to = o, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, r) {
    if (this._active) {
      this._notify(!1);
      const o = this._target[this._prop], i = r - this._start, s = this._duration - i;
      this._start = r, this._duration = Math.floor(Math.max(s, t.duration)), this._total += i, this._loop = !!t.loop, this._to = ha([
        t.to,
        n,
        o,
        t.from
      ]), this._from = ha([
        t.from,
        o,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, r = this._duration, o = this._prop, i = this._from, s = this._loop, a = this._to;
    let l;
    if (this._active = i !== a && (s || n < r), !this._active) {
      this._target[o] = a, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[o] = i;
      return;
    }
    l = n / r % 2, l = s && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[o] = this._fn(i, a, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, r) => {
      t.push({
        res: n,
        rej: r
      });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", r = this._promises || [];
    for (let o = 0; o < r.length; o++)
      r[o][n]();
  }
}
class H0 {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!Xe(t))
      return;
    const n = Object.keys(At.animation), r = this._properties;
    Object.getOwnPropertyNames(t).forEach((o) => {
      const i = t[o];
      if (!Xe(i))
        return;
      const s = {};
      for (const a of n)
        s[a] = i[a];
      (Ct(i.properties) && i.properties || [
        o
      ]).forEach((a) => {
        (a === o || !r.has(a)) && r.set(a, s);
      });
    });
  }
  _animateOptions(t, n) {
    const r = n.options, o = eT(t, r);
    if (!o)
      return [];
    const i = this._createAnimations(o, r);
    return r.$shared && JR(t.options.$animations, r).then(() => {
      t.options = r;
    }, () => {
    }), i;
  }
  _createAnimations(t, n) {
    const r = this._properties, o = [], i = t.$animations || (t.$animations = {}), s = Object.keys(n), a = Date.now();
    let l;
    for (l = s.length - 1; l >= 0; --l) {
      const c = s[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        o.push(...this._animateOptions(t, n));
        continue;
      }
      const u = n[c];
      let d = i[c];
      const f = r.get(c);
      if (d)
        if (f && d.active()) {
          d.update(f, u, a);
          continue;
        } else
          d.cancel();
      if (!f || !f.duration) {
        t[c] = u;
        continue;
      }
      i[c] = d = new QR(f, t, c, u), o.push(d);
    }
    return o;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const r = this._createAnimations(t, n);
    if (r.length)
      return gr.add(this._chart, r), !0;
  }
}
function JR(e, t) {
  const n = [], r = Object.keys(t);
  for (let o = 0; o < r.length; o++) {
    const i = e[r[o]];
    i && i.active() && n.push(i.wait());
  }
  return Promise.all(n);
}
function eT(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function Mg(e, t) {
  const n = e && e.options || {}, r = n.reverse, o = n.min === void 0 ? t : 0, i = n.max === void 0 ? t : 0;
  return {
    start: r ? i : o,
    end: r ? o : i
  };
}
function tT(e, t, n) {
  if (n === !1)
    return !1;
  const r = Mg(e, n), o = Mg(t, n);
  return {
    top: o.end,
    right: r.end,
    bottom: o.start,
    left: r.start
  };
}
function nT(e) {
  let t, n, r, o;
  return Xe(e) ? (t = e.top, n = e.right, r = e.bottom, o = e.left) : t = n = r = o = e, {
    top: t,
    right: n,
    bottom: r,
    left: o,
    disabled: e === !1
  };
}
function W0(e, t) {
  const n = [], r = e._getSortedDatasetMetas(t);
  let o, i;
  for (o = 0, i = r.length; o < i; ++o)
    n.push(r[o].index);
  return n;
}
function Og(e, t, n, r = {}) {
  const o = e.keys, i = r.mode === "single";
  let s, a, l, c;
  if (t !== null) {
    for (s = 0, a = o.length; s < a; ++s) {
      if (l = +o[s], l === n) {
        if (r.all)
          continue;
        break;
      }
      c = e.values[l], Ut(c) && (i || t === 0 || tr(t) === tr(c)) && (t += c);
    }
    return t;
  }
}
function rT(e) {
  const t = Object.keys(e), n = new Array(t.length);
  let r, o, i;
  for (r = 0, o = t.length; r < o; ++r)
    i = t[r], n[r] = {
      x: i,
      y: e[i]
    };
  return n;
}
function Rg(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
function oT(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function iT(e) {
  const { min: t, max: n, minDefined: r, maxDefined: o } = e.getUserBounds();
  return {
    min: r ? t : Number.NEGATIVE_INFINITY,
    max: o ? n : Number.POSITIVE_INFINITY
  };
}
function sT(e, t, n) {
  const r = e[t] || (e[t] = {});
  return r[n] || (r[n] = {});
}
function Tg(e, t, n, r) {
  for (const o of t.getMatchingVisibleMetas(r).reverse()) {
    const i = e[o.index];
    if (n && i > 0 || !n && i < 0)
      return o.index;
  }
  return null;
}
function kg(e, t) {
  const { chart: n, _cachedMeta: r } = e, o = n._stacks || (n._stacks = {}), { iScale: i, vScale: s, index: a } = r, l = i.axis, c = s.axis, u = oT(i, s, r), d = t.length;
  let f;
  for (let h = 0; h < d; ++h) {
    const p = t[h], { [l]: g, [c]: v } = p, y = p._stacks || (p._stacks = {});
    f = y[c] = sT(o, u, g), f[a] = v, f._top = Tg(f, s, !0, r.type), f._bottom = Tg(f, s, !1, r.type);
    const b = f._visualValues || (f._visualValues = {});
    b[a] = v;
  }
}
function tu(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((r) => n[r].axis === t).shift();
}
function aT(e, t) {
  return to(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function lT(e, t, n) {
  return to(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
function Ni(e, t) {
  const n = e.controller.index, r = e.vScale && e.vScale.axis;
  if (r) {
    t = t || e._parsed;
    for (const o of t) {
      const i = o._stacks;
      if (!i || i[r] === void 0 || i[r][n] === void 0)
        return;
      delete i[r][n], i[r]._visualValues !== void 0 && i[r]._visualValues[n] !== void 0 && delete i[r]._visualValues[n];
    }
  }
}
const nu = (e) => e === "reset" || e === "none", Pg = (e, t) => t ? e : Object.assign({}, e), cT = (e, t, n) => e && !t.hidden && t._stacked && {
  keys: W0(n, !0),
  values: null
};
class xo {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = Rg(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && Ni(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, r = this.getDataset(), o = (d, f, h, p) => d === "x" ? f : d === "r" ? p : h, i = n.xAxisID = et(r.xAxisID, tu(t, "x")), s = n.yAxisID = et(r.yAxisID, tu(t, "y")), a = n.rAxisID = et(r.rAxisID, tu(t, "r")), l = n.indexAxis, c = n.iAxisID = o(l, i, s, a), u = n.vAxisID = o(l, s, i, a);
    n.xScale = this.getScaleForId(i), n.yScale = this.getScaleForId(s), n.rScale = this.getScaleForId(a), n.iScale = this.getScaleForId(c), n.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && dg(this._data, this), t._stacked && Ni(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), r = this._data;
    if (Xe(n))
      this._data = rT(n);
    else if (r !== n) {
      if (r) {
        dg(r, this);
        const o = this._cachedMeta;
        Ni(o), o._parsed = [];
      }
      n && Object.isExtensible(n) && HO(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, r = this.getDataset();
    let o = !1;
    this._dataCheck();
    const i = n._stacked;
    n._stacked = Rg(n.vScale, n), n.stack !== r.stack && (o = !0, Ni(n), n.stack = r.stack), this._resyncElements(t), (o || i !== n._stacked) && kg(this, n._parsed);
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), r = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(r, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: r, _data: o } = this, { iScale: i, _stacked: s } = r, a = i.axis;
    let l = t === 0 && n === o.length ? !0 : r._sorted, c = t > 0 && r._parsed[t - 1], u, d, f;
    if (this._parsing === !1)
      r._parsed = o, r._sorted = !0, f = o;
    else {
      Ct(o[t]) ? f = this.parseArrayData(r, o, t, n) : Xe(o[t]) ? f = this.parseObjectData(r, o, t, n) : f = this.parsePrimitiveData(r, o, t, n);
      const h = () => d[a] === null || c && d[a] < c[a];
      for (u = 0; u < n; ++u)
        r._parsed[u + t] = d = f[u], l && (h() && (l = !1), c = d);
      r._sorted = l;
    }
    s && kg(this, f);
  }
  parsePrimitiveData(t, n, r, o) {
    const { iScale: i, vScale: s } = t, a = i.axis, l = s.axis, c = i.getLabels(), u = i === s, d = new Array(o);
    let f, h, p;
    for (f = 0, h = o; f < h; ++f)
      p = f + r, d[f] = {
        [a]: u || i.parse(c[p], p),
        [l]: s.parse(n[p], p)
      };
    return d;
  }
  parseArrayData(t, n, r, o) {
    const { xScale: i, yScale: s } = t, a = new Array(o);
    let l, c, u, d;
    for (l = 0, c = o; l < c; ++l)
      u = l + r, d = n[u], a[l] = {
        x: i.parse(d[0], u),
        y: s.parse(d[1], u)
      };
    return a;
  }
  parseObjectData(t, n, r, o) {
    const { xScale: i, yScale: s } = t, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(o);
    let u, d, f, h;
    for (u = 0, d = o; u < d; ++u)
      f = u + r, h = n[f], c[u] = {
        x: i.parse(Mo(h, a), f),
        y: s.parse(Mo(h, l), f)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, r) {
    const o = this.chart, i = this._cachedMeta, s = n[t.axis], a = {
      keys: W0(o, !0),
      values: n._stacks[t.axis]._visualValues
    };
    return Og(a, s, i.index, {
      mode: r
    });
  }
  updateRangeFromParsed(t, n, r, o) {
    const i = r[n.axis];
    let s = i === null ? NaN : i;
    const a = o && r._stacks[n.axis];
    o && a && (o.values = a, s = Og(o, i, this._cachedMeta.index)), t.min = Math.min(t.min, s), t.max = Math.max(t.max, s);
  }
  getMinMax(t, n) {
    const r = this._cachedMeta, o = r._parsed, i = r._sorted && t === r.iScale, s = o.length, a = this._getOtherScale(t), l = cT(n, r, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: d } = iT(a);
    let f, h;
    function p() {
      h = o[f];
      const g = h[a.axis];
      return !Ut(h[t.axis]) || u > g || d < g;
    }
    for (f = 0; f < s && !(!p() && (this.updateRangeFromParsed(c, t, h, l), i)); ++f)
      ;
    if (i) {
      for (f = s - 1; f >= 0; --f)
        if (!p()) {
          this.updateRangeFromParsed(c, t, h, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, r = [];
    let o, i, s;
    for (o = 0, i = n.length; o < i; ++o)
      s = n[o][t.axis], Ut(s) && r.push(s);
    return r;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = n.iScale, o = n.vScale, i = this.getParsed(t);
    return {
      label: r ? "" + r.getLabelForValue(i[r.axis]) : "",
      value: o ? "" + o.getLabelForValue(i[o.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = nT(et(this.options.clip, tT(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, r = this._cachedMeta, o = r.data || [], i = n.chartArea, s = [], a = this._drawStart || 0, l = this._drawCount || o.length - a, c = this.options.drawActiveElementsOnTop;
    let u;
    for (r.dataset && r.dataset.draw(t, i, a, l), u = a; u < a + l; ++u) {
      const d = o[u];
      d.hidden || (d.active && c ? s.push(d) : d.draw(t, i));
    }
    for (u = 0; u < s.length; ++u)
      s[u].draw(t, i);
  }
  getStyle(t, n) {
    const r = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(r) : this.resolveDataElementOptions(t || 0, r);
  }
  getContext(t, n, r) {
    const o = this.getDataset();
    let i;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const s = this._cachedMeta.data[t];
      i = s.$context || (s.$context = lT(this.getContext(), t, s)), i.parsed = this.getParsed(t), i.raw = o.data[t], i.index = i.dataIndex = t;
    } else
      i = this.$context || (this.$context = aT(this.chart.getContext(), this.index)), i.dataset = o, i.index = i.datasetIndex = this.index;
    return i.active = !!n, i.mode = r, i;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", r) {
    const o = n === "active", i = this._cachedDataOpts, s = t + "-" + n, a = i[s], l = this.enableOptionSharing && ps(r);
    if (a)
      return Pg(a, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, t), d = o ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], f = c.getOptionScopes(this.getDataset(), u), h = Object.keys(At.elements[t]), p = () => this.getContext(r, o, n), g = c.resolveNamedOptions(f, h, p, d);
    return g.$shared && (g.$shared = l, i[s] = Object.freeze(Pg(g, l))), g;
  }
  _resolveAnimations(t, n, r) {
    const o = this.chart, i = this._cachedDataOpts, s = `animation-${n}`, a = i[s];
    if (a)
      return a;
    let l;
    if (o.options.animation !== !1) {
      const u = this.chart.config, d = u.datasetAnimationScopeKeys(this._type, n), f = u.getOptionScopes(this.getDataset(), d);
      l = u.createResolver(f, this.getContext(t, r, n));
    }
    const c = new H0(o, l && l.animations);
    return l && l._cacheable && (i[s] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || nu(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const r = this.resolveDataElementOptions(t, n), o = this._sharedOptions, i = this.getSharedOptions(r), s = this.includeOptions(n, i) || i !== o;
    return this.updateSharedOptions(i, n, r), {
      sharedOptions: i,
      includeOptions: s
    };
  }
  updateElement(t, n, r, o) {
    nu(o) ? Object.assign(t, r) : this._resolveAnimations(n, o).update(t, r);
  }
  updateSharedOptions(t, n, r) {
    t && !nu(n) && this._resolveAnimations(void 0, n).update(t, r);
  }
  _setStyle(t, n, r, o) {
    t.active = o;
    const i = this.getStyle(n, o);
    this._resolveAnimations(n, r, o).update(t, {
      options: !o && this.getSharedOptions(i) || i
    });
  }
  removeHoverStyle(t, n, r) {
    this._setStyle(t, r, "active", !1);
  }
  setHoverStyle(t, n, r) {
    this._setStyle(t, r, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, r = this._cachedMeta.data;
    for (const [a, l, c] of this._syncList)
      this[a](l, c);
    this._syncList = [];
    const o = r.length, i = n.length, s = Math.min(i, o);
    s && this.parse(0, s), i > o ? this._insertElements(o, i - o, t) : i < o && this._removeElements(i, o - i);
  }
  _insertElements(t, n, r = !0) {
    const o = this._cachedMeta, i = o.data, s = t + n;
    let a;
    const l = (c) => {
      for (c.length += n, a = c.length - 1; a >= s; a--)
        c[a] = c[a - n];
    };
    for (l(i), a = t; a < s; ++a)
      i[a] = new this.dataElementType();
    this._parsing && l(o._parsed), this.parse(t, n), r && this.updateElements(i, t, n, "reset");
  }
  updateElements(t, n, r, o) {
  }
  _removeElements(t, n) {
    const r = this._cachedMeta;
    if (this._parsing) {
      const o = r._parsed.splice(t, n);
      r._stacked && Ni(r, o);
    }
    r.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, r, o] = t;
      this[n](r, o);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, n) {
    n && this._sync([
      "_removeElements",
      t,
      n
    ]);
    const r = arguments.length - 2;
    r && this._sync([
      "_insertElements",
      t,
      r
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
ae(xo, "defaults", {}), ae(xo, "datasetElementType", null), ae(xo, "dataElementType", null);
function uT(e, t) {
  if (!e._cache.$bar) {
    const n = e.getMatchingVisibleMetas(t);
    let r = [];
    for (let o = 0, i = n.length; o < i; o++)
      r = r.concat(n[o].controller.getAllParsedValues(e));
    e._cache.$bar = O0(r.sort((o, i) => o - i));
  }
  return e._cache.$bar;
}
function dT(e) {
  const t = e.iScale, n = uT(t, e.type);
  let r = t._length, o, i, s, a;
  const l = () => {
    s === 32767 || s === -32768 || (ps(a) && (r = Math.min(r, Math.abs(s - a) || r)), a = s);
  };
  for (o = 0, i = n.length; o < i; ++o)
    s = t.getPixelForValue(n[o]), l();
  for (a = void 0, o = 0, i = t.ticks.length; o < i; ++o)
    s = t.getPixelForTick(o), l();
  return r;
}
function fT(e, t, n, r) {
  const o = n.barThickness;
  let i, s;
  return ut(o) ? (i = t.min * n.categoryPercentage, s = n.barPercentage) : (i = o * r, s = 1), {
    chunk: i / r,
    ratio: s,
    start: t.pixels[e] - i / 2
  };
}
function hT(e, t, n, r) {
  const o = t.pixels, i = o[e];
  let s = e > 0 ? o[e - 1] : null, a = e < o.length - 1 ? o[e + 1] : null;
  const l = n.categoryPercentage;
  s === null && (s = i - (a === null ? t.end - t.start : a - i)), a === null && (a = i + i - s);
  const c = i - (i - Math.min(s, a)) / 2 * l;
  return {
    chunk: Math.abs(a - s) / 2 * l / r,
    ratio: n.barPercentage,
    start: c
  };
}
function pT(e, t, n, r) {
  const o = n.parse(e[0], r), i = n.parse(e[1], r), s = Math.min(o, i), a = Math.max(o, i);
  let l = s, c = a;
  Math.abs(s) > Math.abs(a) && (l = a, c = s), t[n.axis] = c, t._custom = {
    barStart: l,
    barEnd: c,
    start: o,
    end: i,
    min: s,
    max: a
  };
}
function z0(e, t, n, r) {
  return Ct(e) ? pT(e, t, n, r) : t[n.axis] = n.parse(e, r), t;
}
function Ig(e, t, n, r) {
  const o = e.iScale, i = e.vScale, s = o.getLabels(), a = o === i, l = [];
  let c, u, d, f;
  for (c = n, u = n + r; c < u; ++c)
    f = t[c], d = {}, d[o.axis] = a || o.parse(s[c], c), l.push(z0(f, d, i, c));
  return l;
}
function ru(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function gT(e, t, n) {
  return e !== 0 ? tr(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1);
}
function mT(e) {
  let t, n, r, o, i;
  return e.horizontal ? (t = e.base > e.x, n = "left", r = "right") : (t = e.base < e.y, n = "bottom", r = "top"), t ? (o = "end", i = "start") : (o = "start", i = "end"), {
    start: n,
    end: r,
    reverse: t,
    top: o,
    bottom: i
  };
}
function vT(e, t, n, r) {
  let o = t.borderSkipped;
  const i = {};
  if (!o) {
    e.borderSkipped = i;
    return;
  }
  if (o === !0) {
    e.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: s, end: a, reverse: l, top: c, bottom: u } = mT(e);
  o === "middle" && n && (e.enableBorderRadius = !0, (n._top || 0) === r ? o = c : (n._bottom || 0) === r ? o = u : (i[Ng(u, s, a, l)] = !0, o = c)), i[Ng(o, s, a, l)] = !0, e.borderSkipped = i;
}
function Ng(e, t, n, r) {
  return r ? (e = bT(e, t, n), e = Dg(e, n, t)) : e = Dg(e, t, n), e;
}
function bT(e, t, n) {
  return e === t ? n : e === n ? t : e;
}
function Dg(e, t, n) {
  return e === "start" ? t : e === "end" ? n : e;
}
function yT(e, { inflateAmount: t }, n) {
  e.inflateAmount = t === "auto" ? n === 1 ? 0.33 : 0 : t;
}
class ja extends xo {
  parsePrimitiveData(t, n, r, o) {
    return Ig(t, n, r, o);
  }
  parseArrayData(t, n, r, o) {
    return Ig(t, n, r, o);
  }
  parseObjectData(t, n, r, o) {
    const { iScale: i, vScale: s } = t, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = i.axis === "x" ? a : l, u = s.axis === "x" ? a : l, d = [];
    let f, h, p, g;
    for (f = r, h = r + o; f < h; ++f)
      g = n[f], p = {}, p[i.axis] = i.parse(Mo(g, c), f), d.push(z0(Mo(g, u), p, s, f));
    return d;
  }
  updateRangeFromParsed(t, n, r, o) {
    super.updateRangeFromParsed(t, n, r, o);
    const i = r._custom;
    i && n === this._cachedMeta.vScale && (t.min = Math.min(t.min, i.min), t.max = Math.max(t.max, i.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, { iScale: r, vScale: o } = n, i = this.getParsed(t), s = i._custom, a = ru(s) ? "[" + s.start + ", " + s.end + "]" : "" + o.getLabelForValue(i[o.axis]);
    return {
      label: "" + r.getLabelForValue(i[r.axis]),
      value: a
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, t);
  }
  updateElements(t, n, r, o) {
    const i = o === "reset", { index: s, _cachedMeta: { vScale: a } } = this, l = a.getBasePixel(), c = a.isHorizontal(), u = this._getRuler(), { sharedOptions: d, includeOptions: f } = this._getSharedOptions(n, o);
    for (let h = n; h < n + r; h++) {
      const p = this.getParsed(h), g = i || ut(p[a.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(h), v = this._calculateBarIndexPixels(h, u), y = (p._stacks || {})[a.axis], b = {
        horizontal: c,
        base: g.base,
        enableBorderRadius: !y || ru(p._custom) || s === y._top || s === y._bottom,
        x: c ? g.head : v.center,
        y: c ? v.center : g.head,
        height: c ? v.size : Math.abs(g.size),
        width: c ? Math.abs(g.size) : v.size
      };
      f && (b.options = d || this.resolveDataElementOptions(h, t[h].active ? "active" : o));
      const w = b.options || t[h].options;
      vT(b, w, y, s), yT(b, w, u.ratio), this.updateElement(t[h], h, b, o);
    }
  }
  _getStacks(t, n) {
    const { iScale: r } = this._cachedMeta, o = r.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), i = r.options.stacked, s = [], a = (l) => {
      const c = l.controller.getParsed(n), u = c && c[l.vScale.axis];
      if (ut(u) || isNaN(u))
        return !0;
    };
    for (const l of o)
      if (!(n !== void 0 && a(l)) && ((i === !1 || s.indexOf(l.stack) === -1 || i === void 0 && l.stack === void 0) && s.push(l.stack), l.index === t))
        break;
    return s.length || s.push(void 0), s;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, n, r) {
    const o = this._getStacks(t, r), i = n !== void 0 ? o.indexOf(n) : -1;
    return i === -1 ? o.length - 1 : i;
  }
  _getRuler() {
    const t = this.options, n = this._cachedMeta, r = n.iScale, o = [];
    let i, s;
    for (i = 0, s = n.data.length; i < s; ++i)
      o.push(r.getPixelForValue(this.getParsed(i)[r.axis], i));
    const a = t.barThickness;
    return {
      min: a || dT(n),
      pixels: o,
      start: r._startPixel,
      end: r._endPixel,
      stackCount: this._getStackCount(),
      scale: r,
      grouped: t.grouped,
      ratio: a ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: n, _stacked: r, index: o }, options: { base: i, minBarLength: s } } = this, a = i || 0, l = this.getParsed(t), c = l._custom, u = ru(c);
    let d = l[n.axis], f = 0, h = r ? this.applyStack(n, l, r) : d, p, g;
    h !== d && (f = h - d, h = d), u && (d = c.barStart, h = c.barEnd - c.barStart, d !== 0 && tr(d) !== tr(c.barEnd) && (f = 0), f += d);
    const v = !ut(i) && !u ? i : f;
    let y = n.getPixelForValue(v);
    if (this.chart.getDataVisibility(t) ? p = n.getPixelForValue(f + h) : p = y, g = p - y, Math.abs(g) < s) {
      g = gT(g, n, a) * s, d === a && (y -= g / 2);
      const b = n.getPixelForDecimal(0), w = n.getPixelForDecimal(1), C = Math.min(b, w), x = Math.max(b, w);
      y = Math.max(Math.min(y, x), C), p = y + g, r && !u && (l._stacks[n.axis]._visualValues[o] = n.getValueForPixel(p) - n.getValueForPixel(y));
    }
    if (y === n.getPixelForValue(a)) {
      const b = tr(g) * n.getLineWidthForValue(a) / 2;
      y += b, g -= b;
    }
    return {
      size: g,
      base: y,
      head: p,
      center: p + g / 2
    };
  }
  _calculateBarIndexPixels(t, n) {
    const r = n.scale, o = this.options, i = o.skipNull, s = et(o.maxBarThickness, 1 / 0);
    let a, l;
    if (n.grouped) {
      const c = i ? this._getStackCount(t) : n.stackCount, u = o.barThickness === "flex" ? hT(t, n, o, c) : fT(t, n, o, c), d = this._getStackIndex(this.index, this._cachedMeta.stack, i ? t : void 0);
      a = u.start + u.chunk * d + u.chunk / 2, l = Math.min(s, u.chunk * u.ratio);
    } else
      a = r.getPixelForValue(this.getParsed(t)[r.axis], t), l = Math.min(s, n.min * n.ratio);
    return {
      base: a - l / 2,
      head: a + l / 2,
      center: a,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, n = t.vScale, r = t.data, o = r.length;
    let i = 0;
    for (; i < o; ++i)
      this.getParsed(i)[n.axis] !== null && r[i].draw(this._ctx);
  }
}
ae(ja, "id", "bar"), ae(ja, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), ae(ja, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
function xT(e, t, n) {
  let r = 1, o = 1, i = 0, s = 0;
  if (t < wt) {
    const a = e, l = a + t, c = Math.cos(a), u = Math.sin(a), d = Math.cos(l), f = Math.sin(l), h = (w, C, x) => ms(w, a, l, !0) ? 1 : Math.max(C, C * n, x, x * n), p = (w, C, x) => ms(w, a, l, !0) ? -1 : Math.min(C, C * n, x, x * n), g = h(0, c, d), v = h(Tt, u, f), y = p(Ft, c, d), b = p(Ft + Tt, u, f);
    r = (g - y) / 2, o = (v - b) / 2, i = -(g + y) / 2, s = -(v + b) / 2;
  }
  return {
    ratioX: r,
    ratioY: o,
    offsetX: i,
    offsetY: s
  };
}
class Yi extends xo {
  constructor(t, n) {
    super(t, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, n) {
    const r = this.getDataset().data, o = this._cachedMeta;
    if (this._parsing === !1)
      o._parsed = r;
    else {
      let i = (l) => +r[l];
      if (Xe(r[t])) {
        const { key: l = "value" } = this._parsing;
        i = (c) => +Mo(r[c], l);
      }
      let s, a;
      for (s = t, a = t + n; s < a; ++s)
        o._parsed[s] = i(s);
    }
  }
  _getRotation() {
    return Zn(this.options.rotation - 90);
  }
  _getCircumference() {
    return Zn(this.options.circumference);
  }
  _getRotationExtents() {
    let t = wt, n = -wt;
    for (let r = 0; r < this.chart.data.datasets.length; ++r)
      if (this.chart.isDatasetVisible(r) && this.chart.getDatasetMeta(r).type === this._type) {
        const o = this.chart.getDatasetMeta(r).controller, i = o._getRotation(), s = o._getCircumference();
        t = Math.min(t, i), n = Math.max(n, i + s);
      }
    return {
      rotation: t,
      circumference: n - t
    };
  }
  update(t) {
    const n = this.chart, { chartArea: r } = n, o = this._cachedMeta, i = o.data, s = this.getMaxBorderWidth() + this.getMaxOffset(i) + this.options.spacing, a = Math.max((Math.min(r.width, r.height) - s) / 2, 0), l = Math.min(OO(this.options.cutout, a), 1), c = this._getRingWeight(this.index), { circumference: u, rotation: d } = this._getRotationExtents(), { ratioX: f, ratioY: h, offsetX: p, offsetY: g } = xT(d, u, l), v = (r.width - s) / f, y = (r.height - s) / h, b = Math.max(Math.min(v, y) / 2, 0), w = C0(this.options.radius, b), C = Math.max(w * l, 0), x = (w - C) / this._getVisibleDatasetWeightTotal();
    this.offsetX = p * w, this.offsetY = g * w, o.total = this.calculateTotal(), this.outerRadius = w - x * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - x * c, 0), this.updateElements(i, 0, i.length, t);
  }
  _circumference(t, n) {
    const r = this.options, o = this._cachedMeta, i = this._getCircumference();
    return n && r.animation.animateRotate || !this.chart.getDataVisibility(t) || o._parsed[t] === null || o.data[t].hidden ? 0 : this.calculateCircumference(o._parsed[t] * i / wt);
  }
  updateElements(t, n, r, o) {
    const i = o === "reset", s = this.chart, a = s.chartArea, c = s.options.animation, u = (a.left + a.right) / 2, d = (a.top + a.bottom) / 2, f = i && c.animateScale, h = f ? 0 : this.innerRadius, p = f ? 0 : this.outerRadius, { sharedOptions: g, includeOptions: v } = this._getSharedOptions(n, o);
    let y = this._getRotation(), b;
    for (b = 0; b < n; ++b)
      y += this._circumference(b, i);
    for (b = n; b < n + r; ++b) {
      const w = this._circumference(b, i), C = t[b], x = {
        x: u + this.offsetX,
        y: d + this.offsetY,
        startAngle: y,
        endAngle: y + w,
        circumference: w,
        outerRadius: p,
        innerRadius: h
      };
      v && (x.options = g || this.resolveDataElementOptions(b, C.active ? "active" : o)), y += w, this.updateElement(C, b, x, o);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, n = t.data;
    let r = 0, o;
    for (o = 0; o < n.length; o++) {
      const i = t._parsed[o];
      i !== null && !isNaN(i) && this.chart.getDataVisibility(o) && !n[o].hidden && (r += Math.abs(i));
    }
    return r;
  }
  calculateCircumference(t) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(t) ? wt * (Math.abs(t) / n) : 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = this.chart, o = r.data.labels || [], i = gc(n._parsed[t], r.options.locale);
    return {
      label: o[t] || "",
      value: i
    };
  }
  getMaxBorderWidth(t) {
    let n = 0;
    const r = this.chart;
    let o, i, s, a, l;
    if (!t) {
      for (o = 0, i = r.data.datasets.length; o < i; ++o)
        if (r.isDatasetVisible(o)) {
          s = r.getDatasetMeta(o), t = s.data, a = s.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (o = 0, i = t.length; o < i; ++o)
      l = a.resolveDataElementOptions(o), l.borderAlign !== "inner" && (n = Math.max(n, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(t) {
    let n = 0;
    for (let r = 0, o = t.length; r < o; ++r) {
      const i = this.resolveDataElementOptions(r);
      n = Math.max(n, i.offset || 0, i.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(t) {
    let n = 0;
    for (let r = 0; r < t; ++r)
      this.chart.isDatasetVisible(r) && (n += this._getRingWeight(r));
    return n;
  }
  _getRingWeight(t) {
    return Math.max(et(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
ae(Yi, "id", "doughnut"), ae(Yi, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), ae(Yi, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), ae(Yi, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: r, color: o } } = t.legend.options;
            return n.labels.map((i, s) => {
              const l = t.getDatasetMeta(0).controller.getStyle(s);
              return {
                text: i,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: o,
                lineWidth: l.borderWidth,
                pointStyle: r,
                hidden: !t.getDataVisibility(s),
                index: s
              };
            });
          }
          return [];
        }
      },
      onClick(t, n, r) {
        r.chart.toggleDataVisibility(n.index), r.chart.update();
      }
    }
  }
});
class Ua extends xo {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const n = this._cachedMeta, { dataset: r, data: o = [], _dataset: i } = n, s = this.chart._animationsDisabled;
    let { start: a, count: l } = jO(n, o, s);
    this._drawStart = a, this._drawCount = l, UO(n) && (a = 0, l = o.length), r._chart = this.chart, r._datasetIndex = this.index, r._decimated = !!i._decimated, r.points = o;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(r, void 0, {
      animated: !s,
      options: c
    }, t), this.updateElements(o, a, l, t);
  }
  updateElements(t, n, r, o) {
    const i = o === "reset", { iScale: s, vScale: a, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: u, includeOptions: d } = this._getSharedOptions(n, o), f = s.axis, h = a.axis, { spanGaps: p, segment: g } = this.options, v = gs(p) ? p : Number.POSITIVE_INFINITY, y = this.chart._animationsDisabled || i || o === "none", b = n + r, w = t.length;
    let C = n > 0 && this.getParsed(n - 1);
    for (let x = 0; x < w; ++x) {
      const E = t[x], S = y ? E : {};
      if (x < n || x >= b) {
        S.skip = !0;
        continue;
      }
      const R = this.getParsed(x), M = ut(R[h]), I = S[f] = s.getPixelForValue(R[f], x), P = S[h] = i || M ? a.getBasePixel() : a.getPixelForValue(l ? this.applyStack(a, R, l) : R[h], x);
      S.skip = isNaN(I) || isNaN(P) || M, S.stop = x > 0 && Math.abs(R[f] - C[f]) > v, g && (S.parsed = R, S.raw = c.data[x]), d && (S.options = u || this.resolveDataElementOptions(x, E.active ? "active" : o)), y || this.updateElement(E, x, S, o), C = R;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.dataset, r = n.options && n.options.borderWidth || 0, o = t.data || [];
    if (!o.length)
      return r;
    const i = o[0].size(this.resolveDataElementOptions(0)), s = o[o.length - 1].size(this.resolveDataElementOptions(o.length - 1));
    return Math.max(r, i, s) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
ae(Ua, "id", "line"), ae(Ua, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), ae(Ua, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
function so() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Wf {
  constructor(t) {
    ae(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(Wf.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return so();
  }
  parse() {
    return so();
  }
  format() {
    return so();
  }
  add() {
    return so();
  }
  diff() {
    return so();
  }
  startOf() {
    return so();
  }
  endOf() {
    return so();
  }
}
var j0 = {
  _date: Wf
};
function wT(e, t, n, r) {
  const { controller: o, data: i, _sorted: s } = e, a = o._cachedMeta.iScale;
  if (a && t === a.axis && t !== "r" && s && i.length) {
    const l = a._reversePixels ? VO : go;
    if (r) {
      if (o._sharedOptions) {
        const c = i[0], u = typeof c.getRange == "function" && c.getRange(t);
        if (u) {
          const d = l(i, t, n - u), f = l(i, t, n + u);
          return {
            lo: d.lo,
            hi: f.hi
          };
        }
      }
    } else
      return l(i, t, n);
  }
  return {
    lo: 0,
    hi: i.length - 1
  };
}
function Ds(e, t, n, r, o) {
  const i = e.getSortedVisibleDatasetMetas(), s = n[t];
  for (let a = 0, l = i.length; a < l; ++a) {
    const { index: c, data: u } = i[a], { lo: d, hi: f } = wT(i[a], t, s, o);
    for (let h = d; h <= f; ++h) {
      const p = u[h];
      p.skip || r(p, c, h);
    }
  }
}
function CT(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(r, o) {
    const i = t ? Math.abs(r.x - o.x) : 0, s = n ? Math.abs(r.y - o.y) : 0;
    return Math.sqrt(Math.pow(i, 2) + Math.pow(s, 2));
  };
}
function ou(e, t, n, r, o) {
  const i = [];
  return !o && !e.isPointInArea(t) || Ds(e, n, t, function(a, l, c) {
    !o && !br(a, e.chartArea, 0) || a.inRange(t.x, t.y, r) && i.push({
      element: a,
      datasetIndex: l,
      index: c
    });
  }, !0), i;
}
function _T(e, t, n, r) {
  let o = [];
  function i(s, a, l) {
    const { startAngle: c, endAngle: u } = s.getProps([
      "startAngle",
      "endAngle"
    ], r), { angle: d } = S0(s, {
      x: t.x,
      y: t.y
    });
    ms(d, c, u) && o.push({
      element: s,
      datasetIndex: a,
      index: l
    });
  }
  return Ds(e, n, t, i), o;
}
function ET(e, t, n, r, o, i) {
  let s = [];
  const a = CT(n);
  let l = Number.POSITIVE_INFINITY;
  function c(u, d, f) {
    const h = u.inRange(t.x, t.y, o);
    if (r && !h)
      return;
    const p = u.getCenterPoint(o);
    if (!(!!i || e.isPointInArea(p)) && !h)
      return;
    const v = a(t, p);
    v < l ? (s = [
      {
        element: u,
        datasetIndex: d,
        index: f
      }
    ], l = v) : v === l && s.push({
      element: u,
      datasetIndex: d,
      index: f
    });
  }
  return Ds(e, n, t, c), s;
}
function iu(e, t, n, r, o, i) {
  return !i && !e.isPointInArea(t) ? [] : n === "r" && !r ? _T(e, t, n, o) : ET(e, t, n, r, o, i);
}
function Ag(e, t, n, r, o) {
  const i = [], s = n === "x" ? "inXRange" : "inYRange";
  let a = !1;
  return Ds(e, n, t, (l, c, u) => {
    l[s](t[n], o) && (i.push({
      element: l,
      datasetIndex: c,
      index: u
    }), a = a || l.inRange(t.x, t.y, o));
  }), r && !a ? [] : i;
}
var ST = {
  evaluateInteractionItems: Ds,
  modes: {
    index(e, t, n, r) {
      const o = lo(t, e), i = n.axis || "x", s = n.includeInvisible || !1, a = n.intersect ? ou(e, o, i, r, s) : iu(e, o, i, !1, r, s), l = [];
      return a.length ? (e.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = a[0].index, d = c.data[u];
        d && !d.skip && l.push({
          element: d,
          datasetIndex: c.index,
          index: u
        });
      }), l) : [];
    },
    dataset(e, t, n, r) {
      const o = lo(t, e), i = n.axis || "xy", s = n.includeInvisible || !1;
      let a = n.intersect ? ou(e, o, i, r, s) : iu(e, o, i, !1, r, s);
      if (a.length > 0) {
        const l = a[0].datasetIndex, c = e.getDatasetMeta(l).data;
        a = [];
        for (let u = 0; u < c.length; ++u)
          a.push({
            element: c[u],
            datasetIndex: l,
            index: u
          });
      }
      return a;
    },
    point(e, t, n, r) {
      const o = lo(t, e), i = n.axis || "xy", s = n.includeInvisible || !1;
      return ou(e, o, i, r, s);
    },
    nearest(e, t, n, r) {
      const o = lo(t, e), i = n.axis || "xy", s = n.includeInvisible || !1;
      return iu(e, o, i, n.intersect, r, s);
    },
    x(e, t, n, r) {
      const o = lo(t, e);
      return Ag(e, o, "x", n.intersect, r);
    },
    y(e, t, n, r) {
      const o = lo(t, e);
      return Ag(e, o, "y", n.intersect, r);
    }
  }
};
const U0 = [
  "left",
  "top",
  "right",
  "bottom"
];
function Di(e, t) {
  return e.filter((n) => n.pos === t);
}
function Lg(e, t) {
  return e.filter((n) => U0.indexOf(n.pos) === -1 && n.box.axis === t);
}
function Ai(e, t) {
  return e.sort((n, r) => {
    const o = t ? r : n, i = t ? n : r;
    return o.weight === i.weight ? o.index - i.index : o.weight - i.weight;
  });
}
function MT(e) {
  const t = [];
  let n, r, o, i, s, a;
  for (n = 0, r = (e || []).length; n < r; ++n)
    o = e[n], { position: i, options: { stack: s, stackWeight: a = 1 } } = o, t.push({
      index: n,
      box: o,
      pos: i,
      horizontal: o.isHorizontal(),
      weight: o.weight,
      stack: s && i + s,
      stackWeight: a
    });
  return t;
}
function OT(e) {
  const t = {};
  for (const n of e) {
    const { stack: r, pos: o, stackWeight: i } = n;
    if (!r || !U0.includes(o))
      continue;
    const s = t[r] || (t[r] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    s.count++, s.weight += i;
  }
  return t;
}
function RT(e, t) {
  const n = OT(e), { vBoxMaxWidth: r, hBoxMaxHeight: o } = t;
  let i, s, a;
  for (i = 0, s = e.length; i < s; ++i) {
    a = e[i];
    const { fullSize: l } = a.box, c = n[a.stack], u = c && a.stackWeight / c.weight;
    a.horizontal ? (a.width = u ? u * r : l && t.availableWidth, a.height = o) : (a.width = r, a.height = u ? u * o : l && t.availableHeight);
  }
  return n;
}
function TT(e) {
  const t = MT(e), n = Ai(t.filter((c) => c.box.fullSize), !0), r = Ai(Di(t, "left"), !0), o = Ai(Di(t, "right")), i = Ai(Di(t, "top"), !0), s = Ai(Di(t, "bottom")), a = Lg(t, "x"), l = Lg(t, "y");
  return {
    fullSize: n,
    leftAndTop: r.concat(i),
    rightAndBottom: o.concat(l).concat(s).concat(a),
    chartArea: Di(t, "chartArea"),
    vertical: r.concat(o).concat(l),
    horizontal: i.concat(s).concat(a)
  };
}
function $g(e, t, n, r) {
  return Math.max(e[n], t[n]) + Math.max(e[r], t[r]);
}
function Y0(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function kT(e, t, n, r) {
  const { pos: o, box: i } = n, s = e.maxPadding;
  if (!Xe(o)) {
    n.size && (e[o] -= n.size);
    const d = r[n.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, n.horizontal ? i.height : i.width), n.size = d.size / d.count, e[o] += n.size;
  }
  i.getPadding && Y0(s, i.getPadding());
  const a = Math.max(0, t.outerWidth - $g(s, e, "left", "right")), l = Math.max(0, t.outerHeight - $g(s, e, "top", "bottom")), c = a !== e.w, u = l !== e.h;
  return e.w = a, e.h = l, n.horizontal ? {
    same: c,
    other: u
  } : {
    same: u,
    other: c
  };
}
function PT(e) {
  const t = e.maxPadding;
  function n(r) {
    const o = Math.max(t[r] - e[r], 0);
    return e[r] += o, o;
  }
  e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function IT(e, t) {
  const n = t.maxPadding;
  function r(o) {
    const i = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return o.forEach((s) => {
      i[s] = Math.max(t[s], n[s]);
    }), i;
  }
  return r(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Gi(e, t, n, r) {
  const o = [];
  let i, s, a, l, c, u;
  for (i = 0, s = e.length, c = 0; i < s; ++i) {
    a = e[i], l = a.box, l.update(a.width || t.w, a.height || t.h, IT(a.horizontal, t));
    const { same: d, other: f } = kT(t, n, a, r);
    c |= d && o.length, u = u || f, l.fullSize || o.push(a);
  }
  return c && Gi(o, t, n, r) || u;
}
function ma(e, t, n, r, o) {
  e.top = n, e.left = t, e.right = t + r, e.bottom = n + o, e.width = r, e.height = o;
}
function Fg(e, t, n, r) {
  const o = n.padding;
  let { x: i, y: s } = t;
  for (const a of e) {
    const l = a.box, c = r[a.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, u = a.stackWeight / c.weight || 1;
    if (a.horizontal) {
      const d = t.w * u, f = c.size || l.height;
      ps(c.start) && (s = c.start), l.fullSize ? ma(l, o.left, s, n.outerWidth - o.right - o.left, f) : ma(l, t.left + c.placed, s, d, f), c.start = s, c.placed += d, s = l.bottom;
    } else {
      const d = t.h * u, f = c.size || l.width;
      ps(c.start) && (i = c.start), l.fullSize ? ma(l, i, o.top, f, n.outerHeight - o.bottom - o.top) : ma(l, i, t.top + c.placed, f, d), c.start = i, c.placed += d, i = l.right;
    }
  }
  t.x = i, t.y = s;
}
var va = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            t.draw(n);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, r) {
    if (!e)
      return;
    const o = In(e.options.layout.padding), i = Math.max(t - o.width, 0), s = Math.max(n - o.height, 0), a = TT(e.boxes), l = a.vertical, c = a.horizontal;
    ct(e.boxes, (g) => {
      typeof g.beforeLayout == "function" && g.beforeLayout();
    });
    const u = l.reduce((g, v) => v.box.options && v.box.options.display === !1 ? g : g + 1, 0) || 1, d = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: o,
      availableWidth: i,
      availableHeight: s,
      vBoxMaxWidth: i / 2 / u,
      hBoxMaxHeight: s / 2
    }), f = Object.assign({}, o);
    Y0(f, In(r));
    const h = Object.assign({
      maxPadding: f,
      w: i,
      h: s,
      x: o.left,
      y: o.top
    }, o), p = RT(l.concat(c), d);
    Gi(a.fullSize, h, d, p), Gi(l, h, d, p), Gi(c, h, d, p) && Gi(l, h, d, p), PT(h), Fg(a.leftAndTop, h, d, p), h.x += h.w, h.y += h.h, Fg(a.rightAndBottom, h, d, p), e.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, ct(a.chartArea, (g) => {
      const v = g.box;
      Object.assign(v, e.chartArea), v.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class G0 {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, r) {
  }
  removeEventListener(t, n, r) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, r, o) {
    return n = Math.max(0, n || t.width), r = r || t.height, {
      width: n,
      height: Math.max(0, o ? Math.floor(n / o) : r)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class NT extends G0 {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const Ya = "$chartjs", DT = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, Vg = (e) => e === null || e === "";
function AT(e, t) {
  const n = e.style, r = e.getAttribute("height"), o = e.getAttribute("width");
  if (e[Ya] = {
    initial: {
      height: r,
      width: o,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", Vg(o)) {
    const i = wg(e, "width");
    i !== void 0 && (e.width = i);
  }
  if (Vg(r))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const i = wg(e, "height");
      i !== void 0 && (e.height = i);
    }
  return e;
}
const K0 = AR ? {
  passive: !0
} : !1;
function LT(e, t, n) {
  e.addEventListener(t, n, K0);
}
function $T(e, t, n) {
  e.canvas.removeEventListener(t, n, K0);
}
function FT(e, t) {
  const n = DT[e.type] || e.type, { x: r, y: o } = lo(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: r !== void 0 ? r : null,
    y: o !== void 0 ? o : null
  };
}
function Cl(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
function VT(e, t, n) {
  const r = e.canvas, o = new MutationObserver((i) => {
    let s = !1;
    for (const a of i)
      s = s || Cl(a.addedNodes, r), s = s && !Cl(a.removedNodes, r);
    s && n();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
function BT(e, t, n) {
  const r = e.canvas, o = new MutationObserver((i) => {
    let s = !1;
    for (const a of i)
      s = s || Cl(a.removedNodes, r), s = s && !Cl(a.addedNodes, r);
    s && n();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
const vs = /* @__PURE__ */ new Map();
let Bg = 0;
function q0() {
  const e = window.devicePixelRatio;
  e !== Bg && (Bg = e, vs.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
function HT(e, t) {
  vs.size || window.addEventListener("resize", q0), vs.set(e, t);
}
function WT(e) {
  vs.delete(e), vs.size || window.removeEventListener("resize", q0);
}
function zT(e, t, n) {
  const r = e.canvas, o = r && Hf(r);
  if (!o)
    return;
  const i = T0((a, l) => {
    const c = o.clientWidth;
    n(a, l), c < o.clientWidth && n();
  }, window), s = new ResizeObserver((a) => {
    const l = a[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || i(c, u);
  });
  return s.observe(o), HT(e, i), s;
}
function su(e, t, n) {
  n && n.disconnect(), t === "resize" && WT(e);
}
function jT(e, t, n) {
  const r = e.canvas, o = T0((i) => {
    e.ctx !== null && n(FT(i, e));
  }, e);
  return LT(r, t, o), o;
}
class UT extends G0 {
  acquireContext(t, n) {
    const r = t && t.getContext && t.getContext("2d");
    return r && r.canvas === t ? (AT(t, n), r) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[Ya])
      return !1;
    const r = n[Ya].initial;
    [
      "height",
      "width"
    ].forEach((i) => {
      const s = r[i];
      ut(s) ? n.removeAttribute(i) : n.setAttribute(i, s);
    });
    const o = r.style || {};
    return Object.keys(o).forEach((i) => {
      n.style[i] = o[i];
    }), n.width = n.width, delete n[Ya], !0;
  }
  addEventListener(t, n, r) {
    this.removeEventListener(t, n);
    const o = t.$proxies || (t.$proxies = {}), s = {
      attach: VT,
      detach: BT,
      resize: zT
    }[n] || jT;
    o[n] = s(t, n, r);
  }
  removeEventListener(t, n) {
    const r = t.$proxies || (t.$proxies = {}), o = r[n];
    if (!o)
      return;
    ({
      attach: su,
      detach: su,
      resize: su
    }[n] || $T)(t, n, o), r[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, r, o) {
    return DR(t, n, r, o);
  }
  isAttached(t) {
    const n = Hf(t);
    return !!(n && n.isConnected);
  }
}
function YT(e) {
  return !V0() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? NT : UT;
}
var $a;
let Ao = ($a = class {
  constructor() {
    ae(this, "x");
    ae(this, "y");
    ae(this, "active", !1);
    ae(this, "options");
    ae(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: n, y: r } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: n,
      y: r
    };
  }
  hasValue() {
    return gs(this.x) && gs(this.y);
  }
  getProps(t, n) {
    const r = this.$animations;
    if (!n || !r)
      return this;
    const o = {};
    return t.forEach((i) => {
      o[i] = r[i] && r[i].active() ? r[i]._to : this[i];
    }), o;
  }
}, ae($a, "defaults", {}), ae($a, "defaultRoutes"), $a);
function GT(e, t) {
  const n = e.options.ticks, r = KT(e), o = Math.min(n.maxTicksLimit || r, r), i = n.major.enabled ? XT(t) : [], s = i.length, a = i[0], l = i[s - 1], c = [];
  if (s > o)
    return ZT(t, c, i, s / o), c;
  const u = qT(i, t, o);
  if (s > 0) {
    let d, f;
    const h = s > 1 ? Math.round((l - a) / (s - 1)) : null;
    for (ba(t, c, u, ut(h) ? 0 : a - h, a), d = 0, f = s - 1; d < f; d++)
      ba(t, c, u, i[d], i[d + 1]);
    return ba(t, c, u, l, ut(h) ? t.length : l + h), c;
  }
  return ba(t, c, u), c;
}
function KT(e) {
  const t = e.options.offset, n = e._tickSize(), r = e._length / n + (t ? 0 : 1), o = e._maxLength / n;
  return Math.floor(Math.min(r, o));
}
function qT(e, t, n) {
  const r = QT(e), o = t.length / n;
  if (!r)
    return Math.max(o, 1);
  const i = AO(r);
  for (let s = 0, a = i.length - 1; s < a; s++) {
    const l = i[s];
    if (l > o)
      return l;
  }
  return Math.max(o, 1);
}
function XT(e) {
  const t = [];
  let n, r;
  for (n = 0, r = e.length; n < r; n++)
    e[n].major && t.push(n);
  return t;
}
function ZT(e, t, n, r) {
  let o = 0, i = n[0], s;
  for (r = Math.ceil(r), s = 0; s < e.length; s++)
    s === i && (t.push(e[s]), o++, i = n[o * r]);
}
function ba(e, t, n, r, o) {
  const i = et(r, 0), s = Math.min(et(o, e.length), e.length);
  let a = 0, l, c, u;
  for (n = Math.ceil(n), o && (l = o - r, n = l / Math.floor(l / n)), u = i; u < 0; )
    a++, u = Math.round(i + a * n);
  for (c = Math.max(i, 0); c < s; c++)
    c === u && (t.push(e[c]), a++, u = Math.round(i + a * n));
}
function QT(e) {
  const t = e.length;
  let n, r;
  if (t < 2)
    return !1;
  for (r = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== r)
      return !1;
  return r;
}
const JT = (e) => e === "left" ? "right" : e === "right" ? "left" : e, Hg = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n, Wg = (e, t) => Math.min(t || e, e);
function zg(e, t) {
  const n = [], r = e.length / t, o = e.length;
  let i = 0;
  for (; i < o; i += r)
    n.push(e[Math.floor(i)]);
  return n;
}
function ek(e, t, n) {
  const r = e.ticks.length, o = Math.min(t, r - 1), i = e._startPixel, s = e._endPixel, a = 1e-6;
  let l = e.getPixelForTick(o), c;
  if (!(n && (r === 1 ? c = Math.max(l - i, s - l) : t === 0 ? c = (e.getPixelForTick(1) - l) / 2 : c = (l - e.getPixelForTick(o - 1)) / 2, l += o < t ? c : -c, l < i - a || l > s + a)))
    return l;
}
function tk(e, t) {
  ct(e, (n) => {
    const r = n.gc, o = r.length / 2;
    let i;
    if (o > t) {
      for (i = 0; i < o; ++i)
        delete n.data[r[i]];
      r.splice(0, o);
    }
  });
}
function Li(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function jg(e, t) {
  if (!e.display)
    return 0;
  const n = yn(e.font, t), r = In(e.padding);
  return (Ct(e.text) ? e.text.length : 1) * n.lineHeight + r.height;
}
function nk(e, t) {
  return to(e, {
    scale: t,
    type: "scale"
  });
}
function rk(e, t, n) {
  return to(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
function ok(e, t, n) {
  let r = zO(e);
  return (n && t !== "right" || !n && t === "right") && (r = JT(r)), r;
}
function ik(e, t, n, r) {
  const { top: o, left: i, bottom: s, right: a, chart: l } = e, { chartArea: c, scales: u } = l;
  let d = 0, f, h, p;
  const g = s - o, v = a - i;
  if (e.isHorizontal()) {
    if (h = fg(r, i, a), Xe(n)) {
      const y = Object.keys(n)[0], b = n[y];
      p = u[y].getPixelForValue(b) + g - t;
    } else
      n === "center" ? p = (c.bottom + c.top) / 2 + g - t : p = Hg(e, n, t);
    f = a - i;
  } else {
    if (Xe(n)) {
      const y = Object.keys(n)[0], b = n[y];
      h = u[y].getPixelForValue(b) - v + t;
    } else
      n === "center" ? h = (c.left + c.right) / 2 - v + t : h = Hg(e, n, t);
    p = fg(r, s, o), d = n === "left" ? -Tt : Tt;
  }
  return {
    titleX: h,
    titleY: p,
    maxWidth: f,
    rotation: d
  };
}
class Lo extends Ao {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: r, _suggestedMax: o } = this;
    return t = pn(t, Number.POSITIVE_INFINITY), n = pn(n, Number.NEGATIVE_INFINITY), r = pn(r, Number.POSITIVE_INFINITY), o = pn(o, Number.NEGATIVE_INFINITY), {
      min: pn(t, r),
      max: pn(n, o),
      minDefined: Ut(t),
      maxDefined: Ut(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: r, minDefined: o, maxDefined: i } = this.getUserBounds(), s;
    if (o && i)
      return {
        min: n,
        max: r
      };
    const a = this.getMatchingVisibleMetas();
    for (let l = 0, c = a.length; l < c; ++l)
      s = a[l].controller.getMinMax(this, t), o || (n = Math.min(n, s.min)), i || (r = Math.max(r, s.max));
    return n = i && n > r ? r : n, r = o && n > r ? n : r, {
      min: pn(n, pn(r, n)),
      max: pn(r, pn(n, r))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Mt(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, n, r) {
    const { beginAtZero: o, grace: i, ticks: s } = this.options, a = s.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = r = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, r), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + r.left + r.right : this.height + r.top + r.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = fR(this, i, o), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = a < this.ticks.length;
    this._convertTicksToLabels(l ? zg(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), s.display && (s.autoSkip || s.source === "auto") && (this.ticks = GT(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, r;
    this.isHorizontal() ? (n = this.left, r = this.right) : (n = this.top, r = this.bottom, t = !t), this._startPixel = n, this._endPixel = r, this._reversePixels = t, this._length = r - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Mt(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    Mt(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Mt(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), Mt(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Mt(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let r, o, i;
    for (r = 0, o = t.length; r < o; r++)
      i = t[r], i.label = Mt(n.callback, [
        i.value,
        r,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    Mt(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    Mt(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, r = Wg(this.ticks.length, t.ticks.maxTicksLimit), o = n.minRotation || 0, i = n.maxRotation;
    let s = o, a, l, c;
    if (!this._isVisible() || !n.display || o >= i || r <= 1 || !this.isHorizontal()) {
      this.labelRotation = o;
      return;
    }
    const u = this._getLabelSizes(), d = u.widest.width, f = u.highest.height, h = Zt(this.chart.width - d, 0, this.maxWidth);
    a = t.offset ? this.maxWidth / r : h / (r - 1), d + 6 > a && (a = h / (r - (t.offset ? 0.5 : 1)), l = this.maxHeight - Li(t.grid) - n.padding - jg(t.title, this.chart.options.font), c = Math.sqrt(d * d + f * f), s = Df(Math.min(Math.asin(Zt((u.highest.height + 6) / a, -1, 1)), Math.asin(Zt(l / c, -1, 1)) - Math.asin(Zt(f / c, -1, 1)))), s = Math.max(o, Math.min(i, s))), this.labelRotation = s;
  }
  afterCalculateLabelRotation() {
    Mt(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Mt(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: r, title: o, grid: i } } = this, s = this._isVisible(), a = this.isHorizontal();
    if (s) {
      const l = jg(o, n.options.font);
      if (a ? (t.width = this.maxWidth, t.height = Li(i) + l) : (t.height = this.maxHeight, t.width = Li(i) + l), r.display && this.ticks.length) {
        const { first: c, last: u, widest: d, highest: f } = this._getLabelSizes(), h = r.padding * 2, p = Zn(this.labelRotation), g = Math.cos(p), v = Math.sin(p);
        if (a) {
          const y = r.mirror ? 0 : v * d.width + g * f.height;
          t.height = Math.min(this.maxHeight, t.height + y + h);
        } else {
          const y = r.mirror ? 0 : g * d.width + v * f.height;
          t.width = Math.min(this.maxWidth, t.width + y + h);
        }
        this._calculatePadding(c, u, v, g);
      }
    }
    this._handleMargins(), a ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, r, o) {
    const { ticks: { align: i, padding: s }, position: a } = this.options, l = this.labelRotation !== 0, c = a !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, h = 0;
      l ? c ? (f = o * t.width, h = r * n.height) : (f = r * t.height, h = o * n.width) : i === "start" ? h = n.width : i === "end" ? f = t.width : i !== "inner" && (f = t.width / 2, h = n.width / 2), this.paddingLeft = Math.max((f - u + s) * this.width / (this.width - u), 0), this.paddingRight = Math.max((h - d + s) * this.width / (this.width - d), 0);
    } else {
      let u = n.height / 2, d = t.height / 2;
      i === "start" ? (u = 0, d = t.height) : i === "end" && (u = n.height, d = 0), this.paddingTop = u + s, this.paddingBottom = d + s;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Mt(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, r;
    for (n = 0, r = t.length; n < r; n++)
      ut(t[n].label) && (t.splice(n, 1), r--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let r = this.ticks;
      n < r.length && (r = zg(r, n)), this._labelSizes = t = this._computeLabelSizes(r, r.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, n, r) {
    const { ctx: o, _longestTextCache: i } = this, s = [], a = [], l = Math.floor(n / Wg(n, r));
    let c = 0, u = 0, d, f, h, p, g, v, y, b, w, C, x;
    for (d = 0; d < n; d += l) {
      if (p = t[d].label, g = this._resolveTickFontOptions(d), o.font = v = g.string, y = i[v] = i[v] || {
        data: {},
        gc: []
      }, b = g.lineHeight, w = C = 0, !ut(p) && !Ct(p))
        w = bl(o, y.data, y.gc, w, p), C = b;
      else if (Ct(p))
        for (f = 0, h = p.length; f < h; ++f)
          x = p[f], !ut(x) && !Ct(x) && (w = bl(o, y.data, y.gc, w, x), C += b);
      s.push(w), a.push(C), c = Math.max(w, c), u = Math.max(C, u);
    }
    tk(i, n);
    const E = s.indexOf(c), S = a.indexOf(u), R = (M) => ({
      width: s[M] || 0,
      height: a[M] || 0
    });
    return {
      first: R(0),
      last: R(n - 1),
      widest: R(E),
      highest: R(S),
      widths: s,
      heights: a
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return FO(this._alignToPixels ? io(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const r = n[t];
      return r.$context || (r.$context = rk(this.getContext(), t, r));
    }
    return this.$context || (this.$context = nk(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = Zn(this.labelRotation), r = Math.abs(Math.cos(n)), o = Math.abs(Math.sin(n)), i = this._getLabelSizes(), s = t.autoSkipPadding || 0, a = i ? i.widest.width + s : 0, l = i ? i.highest.height + s : 0;
    return this.isHorizontal() ? l * r > a * o ? a / r : l / o : l * o < a * r ? l / r : a / o;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, r = this.chart, o = this.options, { grid: i, position: s, border: a } = o, l = i.offset, c = this.isHorizontal(), d = this.ticks.length + (l ? 1 : 0), f = Li(i), h = [], p = a.setContext(this.getContext()), g = p.display ? p.width : 0, v = g / 2, y = function(L) {
      return io(r, L, g);
    };
    let b, w, C, x, E, S, R, M, I, P, k, O;
    if (s === "top")
      b = y(this.bottom), S = this.bottom - f, M = b - v, P = y(t.top) + v, O = t.bottom;
    else if (s === "bottom")
      b = y(this.top), P = t.top, O = y(t.bottom) - v, S = b + v, M = this.top + f;
    else if (s === "left")
      b = y(this.right), E = this.right - f, R = b - v, I = y(t.left) + v, k = t.right;
    else if (s === "right")
      b = y(this.left), I = t.left, k = y(t.right) - v, E = b + v, R = this.left + f;
    else if (n === "x") {
      if (s === "center")
        b = y((t.top + t.bottom) / 2 + 0.5);
      else if (Xe(s)) {
        const L = Object.keys(s)[0], A = s[L];
        b = y(this.chart.scales[L].getPixelForValue(A));
      }
      P = t.top, O = t.bottom, S = b + v, M = S + f;
    } else if (n === "y") {
      if (s === "center")
        b = y((t.left + t.right) / 2);
      else if (Xe(s)) {
        const L = Object.keys(s)[0], A = s[L];
        b = y(this.chart.scales[L].getPixelForValue(A));
      }
      E = b - v, R = E - f, I = t.left, k = t.right;
    }
    const F = et(o.ticks.maxTicksLimit, d), T = Math.max(1, Math.ceil(d / F));
    for (w = 0; w < d; w += T) {
      const L = this.getContext(w), A = i.setContext(L), N = a.setContext(L), B = A.lineWidth, $ = A.color, U = N.dash || [], G = N.dashOffset, H = A.tickWidth, q = A.tickColor, j = A.tickBorderDash || [], W = A.tickBorderDashOffset;
      C = ek(this, w, l), C !== void 0 && (x = io(r, C, B), c ? E = R = I = k = x : S = M = P = O = x, h.push({
        tx1: E,
        ty1: S,
        tx2: R,
        ty2: M,
        x1: I,
        y1: P,
        x2: k,
        y2: O,
        width: B,
        color: $,
        borderDash: U,
        borderDashOffset: G,
        tickWidth: H,
        tickColor: q,
        tickBorderDash: j,
        tickBorderDashOffset: W
      }));
    }
    return this._ticksLength = d, this._borderValue = b, h;
  }
  _computeLabelItems(t) {
    const n = this.axis, r = this.options, { position: o, ticks: i } = r, s = this.isHorizontal(), a = this.ticks, { align: l, crossAlign: c, padding: u, mirror: d } = i, f = Li(r.grid), h = f + u, p = d ? -u : h, g = -Zn(this.labelRotation), v = [];
    let y, b, w, C, x, E, S, R, M, I, P, k, O = "middle";
    if (o === "top")
      E = this.bottom - p, S = this._getXAxisLabelAlignment();
    else if (o === "bottom")
      E = this.top + p, S = this._getXAxisLabelAlignment();
    else if (o === "left") {
      const T = this._getYAxisLabelAlignment(f);
      S = T.textAlign, x = T.x;
    } else if (o === "right") {
      const T = this._getYAxisLabelAlignment(f);
      S = T.textAlign, x = T.x;
    } else if (n === "x") {
      if (o === "center")
        E = (t.top + t.bottom) / 2 + h;
      else if (Xe(o)) {
        const T = Object.keys(o)[0], L = o[T];
        E = this.chart.scales[T].getPixelForValue(L) + h;
      }
      S = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (o === "center")
        x = (t.left + t.right) / 2 - h;
      else if (Xe(o)) {
        const T = Object.keys(o)[0], L = o[T];
        x = this.chart.scales[T].getPixelForValue(L);
      }
      S = this._getYAxisLabelAlignment(f).textAlign;
    }
    n === "y" && (l === "start" ? O = "top" : l === "end" && (O = "bottom"));
    const F = this._getLabelSizes();
    for (y = 0, b = a.length; y < b; ++y) {
      w = a[y], C = w.label;
      const T = i.setContext(this.getContext(y));
      R = this.getPixelForTick(y) + i.labelOffset, M = this._resolveTickFontOptions(y), I = M.lineHeight, P = Ct(C) ? C.length : 1;
      const L = P / 2, A = T.color, N = T.textStrokeColor, B = T.textStrokeWidth;
      let $ = S;
      s ? (x = R, S === "inner" && (y === b - 1 ? $ = this.options.reverse ? "left" : "right" : y === 0 ? $ = this.options.reverse ? "right" : "left" : $ = "center"), o === "top" ? c === "near" || g !== 0 ? k = -P * I + I / 2 : c === "center" ? k = -F.highest.height / 2 - L * I + I : k = -F.highest.height + I / 2 : c === "near" || g !== 0 ? k = I / 2 : c === "center" ? k = F.highest.height / 2 - L * I : k = F.highest.height - P * I, d && (k *= -1), g !== 0 && !T.showLabelBackdrop && (x += I / 2 * Math.sin(g))) : (E = R, k = (1 - P) * I / 2);
      let U;
      if (T.showLabelBackdrop) {
        const G = In(T.backdropPadding), H = F.heights[y], q = F.widths[y];
        let j = k - G.top, W = 0 - G.left;
        switch (O) {
          case "middle":
            j -= H / 2;
            break;
          case "bottom":
            j -= H;
            break;
        }
        switch (S) {
          case "center":
            W -= q / 2;
            break;
          case "right":
            W -= q;
            break;
        }
        U = {
          left: W,
          top: j,
          width: q + G.width,
          height: H + G.height,
          color: T.backdropColor
        };
      }
      v.push({
        label: C,
        font: M,
        textOffset: k,
        options: {
          rotation: g,
          color: A,
          strokeColor: N,
          strokeWidth: B,
          textAlign: $,
          textBaseline: O,
          translation: [
            x,
            E
          ],
          backdrop: U
        }
      });
    }
    return v;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-Zn(this.labelRotation))
      return t === "top" ? "left" : "right";
    let o = "center";
    return n.align === "start" ? o = "left" : n.align === "end" ? o = "right" : n.align === "inner" && (o = "inner"), o;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: r, mirror: o, padding: i } } = this.options, s = this._getLabelSizes(), a = t + i, l = s.widest.width;
    let c, u;
    return n === "left" ? o ? (u = this.right + i, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - a, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : n === "right" ? o ? (u = this.left + i, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + a, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", {
      textAlign: c,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: r, top: o, width: i, height: s } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(r, o, i, s), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const o = this.ticks.findIndex((i) => i.value === t);
    return o >= 0 ? n.setContext(this.getContext(o)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, r = this.ctx, o = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let i, s;
    const a = (l, c, u) => {
      !u.width || !u.color || (r.save(), r.lineWidth = u.width, r.strokeStyle = u.color, r.setLineDash(u.borderDash || []), r.lineDashOffset = u.borderDashOffset, r.beginPath(), r.moveTo(l.x, l.y), r.lineTo(c.x, c.y), r.stroke(), r.restore());
    };
    if (n.display)
      for (i = 0, s = o.length; i < s; ++i) {
        const l = o[i];
        n.drawOnChartArea && a({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), n.drawTicks && a({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { border: r, grid: o } } = this, i = r.setContext(this.getContext()), s = r.display ? i.width : 0;
    if (!s)
      return;
    const a = o.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, u, d, f;
    this.isHorizontal() ? (c = io(t, this.left, s) - s / 2, u = io(t, this.right, a) + a / 2, d = f = l) : (d = io(t, this.top, s) - s / 2, f = io(t, this.bottom, a) + a / 2, c = u = l), n.save(), n.lineWidth = i.width, n.strokeStyle = i.color, n.beginPath(), n.moveTo(c, d), n.lineTo(u, f), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const r = this.ctx, o = this._computeLabelArea();
    o && P0(r, o);
    const i = this.getLabelItems(t);
    for (const s of i) {
      const a = s.options, l = s.font, c = s.label, u = s.textOffset;
      yl(r, c, 0, u, l, a);
    }
    o && I0(r);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: r, reverse: o } } = this;
    if (!r.display)
      return;
    const i = yn(r.font), s = In(r.padding), a = r.align;
    let l = i.lineHeight / 2;
    n === "bottom" || n === "center" || Xe(n) ? (l += s.bottom, Ct(r.text) && (l += i.lineHeight * (r.text.length - 1))) : l += s.top;
    const { titleX: c, titleY: u, maxWidth: d, rotation: f } = ik(this, l, n, a);
    yl(t, r.text, 0, 0, i, {
      color: r.color,
      maxWidth: d,
      rotation: f,
      textAlign: ok(a, n, o),
      textBaseline: "middle",
      translation: [
        c,
        u
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, r = et(t.grid && t.grid.z, -1), o = et(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Lo.prototype.draw ? [
      {
        z: n,
        draw: (i) => {
          this.draw(i);
        }
      }
    ] : [
      {
        z: r,
        draw: (i) => {
          this.drawBackground(), this.drawGrid(i), this.drawTitle();
        }
      },
      {
        z: o,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (i) => {
          this.drawLabels(i);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), r = this.axis + "AxisID", o = [];
    let i, s;
    for (i = 0, s = n.length; i < s; ++i) {
      const a = n[i];
      a[r] === this.id && (!t || a.type === t) && o.push(a);
    }
    return o;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return yn(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class ya {
  constructor(t, n, r) {
    this.type = t, this.scope = n, this.override = r, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let r;
    lk(n) && (r = this.register(n));
    const o = this.items, i = t.id, s = this.scope + "." + i;
    if (!i)
      throw new Error("class does not have id: " + t);
    return i in o || (o[i] = t, sk(t, s, r), this.override && At.override(t.id, t.overrides)), s;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, r = t.id, o = this.scope;
    r in n && delete n[r], o && r in At[o] && (delete At[o][r], this.override && delete Oo[r]);
  }
}
function sk(e, t, n) {
  const r = hs(/* @__PURE__ */ Object.create(null), [
    n ? At.get(n) : {},
    At.get(t),
    e.defaults
  ]);
  At.set(t, r), e.defaultRoutes && ak(t, e.defaultRoutes), e.descriptors && At.describe(t, e.descriptors);
}
function ak(e, t) {
  Object.keys(t).forEach((n) => {
    const r = n.split("."), o = r.pop(), i = [
      e
    ].concat(r).join("."), s = t[n].split("."), a = s.pop(), l = s.join(".");
    At.route(i, o, l, a);
  });
}
function lk(e) {
  return "id" in e && "defaults" in e;
}
class ck {
  constructor() {
    this.controllers = new ya(xo, "datasets", !0), this.elements = new ya(Ao, "elements"), this.plugins = new ya(Object, "plugins"), this.scales = new ya(Lo, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, r) {
    [
      ...n
    ].forEach((o) => {
      const i = r || this._getRegistryForType(o);
      r || i.isForType(o) || i === this.plugins && o.id ? this._exec(t, i, o) : ct(o, (s) => {
        const a = r || this._getRegistryForType(s);
        this._exec(t, a, s);
      });
    });
  }
  _exec(t, n, r) {
    const o = Nf(t);
    Mt(r["before" + o], [], r), n[t](r), Mt(r["after" + o], [], r);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const r = this._typedRegistries[n];
      if (r.isForType(t))
        return r;
    }
    return this.plugins;
  }
  _get(t, n, r) {
    const o = n.get(t);
    if (o === void 0)
      throw new Error('"' + t + '" is not a registered ' + r + ".");
    return o;
  }
}
var Gn = /* @__PURE__ */ new ck();
class uk {
  constructor() {
    this._init = [];
  }
  notify(t, n, r, o) {
    n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const i = o ? this._descriptors(t).filter(o) : this._descriptors(t), s = this._notify(i, t, n, r);
    return n === "afterDestroy" && (this._notify(i, t, "stop"), this._notify(this._init, t, "uninstall")), s;
  }
  _notify(t, n, r, o) {
    o = o || {};
    for (const i of t) {
      const s = i.plugin, a = s[r], l = [
        n,
        o,
        i.options
      ];
      if (Mt(a, l, s) === !1 && o.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    ut(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const r = t && t.config, o = et(r.options && r.options.plugins, {}), i = dk(r);
    return o === !1 && !n ? [] : hk(t, i, o, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], r = this._cache, o = (i, s) => i.filter((a) => !s.some((l) => a.plugin.id === l.plugin.id));
    this._notify(o(n, r), t, "stop"), this._notify(o(r, n), t, "start");
  }
}
function dk(e) {
  const t = {}, n = [], r = Object.keys(Gn.plugins.items);
  for (let i = 0; i < r.length; i++)
    n.push(Gn.getPlugin(r[i]));
  const o = e.plugins || [];
  for (let i = 0; i < o.length; i++) {
    const s = o[i];
    n.indexOf(s) === -1 && (n.push(s), t[s.id] = !0);
  }
  return {
    plugins: n,
    localIds: t
  };
}
function fk(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function hk(e, { plugins: t, localIds: n }, r, o) {
  const i = [], s = e.getContext();
  for (const a of t) {
    const l = a.id, c = fk(r[l], o);
    c !== null && i.push({
      plugin: a,
      options: pk(e.config, {
        plugin: a,
        local: n[l]
      }, c, s)
    });
  }
  return i;
}
function pk(e, { plugin: t, local: n }, r, o) {
  const i = e.pluginScopeKeys(t), s = e.getOptionScopes(r, i);
  return n && t.defaults && s.push(t.defaults), e.createResolver(s, o, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function od(e, t) {
  const n = At.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function gk(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function mk(e, t) {
  return e === t ? "_index_" : "_value_";
}
function Ug(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function vk(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function id(e, ...t) {
  if (Ug(e))
    return e;
  for (const n of t) {
    const r = n.axis || vk(n.position) || e.length > 1 && Ug(e[0].toLowerCase());
    if (r)
      return r;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function Yg(e, t, n) {
  if (n[t + "AxisID"] === e)
    return {
      axis: t
    };
}
function bk(e, t) {
  if (t.data && t.data.datasets) {
    const n = t.data.datasets.filter((r) => r.xAxisID === e || r.yAxisID === e);
    if (n.length)
      return Yg(e, "x", n[0]) || Yg(e, "y", n[0]);
  }
  return {};
}
function yk(e, t) {
  const n = Oo[e.type] || {
    scales: {}
  }, r = t.scales || {}, o = od(e.type, t), i = /* @__PURE__ */ Object.create(null);
  return Object.keys(r).forEach((s) => {
    const a = r[s];
    if (!Xe(a))
      return console.error(`Invalid scale configuration for scale: ${s}`);
    if (a._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${s}`);
    const l = id(s, a, bk(s, e), At.scales[a.type]), c = mk(l, o), u = n.scales || {};
    i[s] = es(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      a,
      u[l],
      u[c]
    ]);
  }), e.data.datasets.forEach((s) => {
    const a = s.type || e.type, l = s.indexAxis || od(a, t), u = (Oo[a] || {}).scales || {};
    Object.keys(u).forEach((d) => {
      const f = gk(d, l), h = s[f + "AxisID"] || f;
      i[h] = i[h] || /* @__PURE__ */ Object.create(null), es(i[h], [
        {
          axis: f
        },
        r[h],
        u[d]
      ]);
    });
  }), Object.keys(i).forEach((s) => {
    const a = i[s];
    es(a, [
      At.scales[a.type],
      At.scale
    ]);
  }), i;
}
function X0(e) {
  const t = e.options || (e.options = {});
  t.plugins = et(t.plugins, {}), t.scales = yk(e, t);
}
function Z0(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function xk(e) {
  return e = e || {}, e.data = Z0(e.data), X0(e), e;
}
const Gg = /* @__PURE__ */ new Map(), Q0 = /* @__PURE__ */ new Set();
function xa(e, t) {
  let n = Gg.get(e);
  return n || (n = t(), Gg.set(e, n), Q0.add(n)), n;
}
const $i = (e, t, n) => {
  const r = Mo(t, n);
  r !== void 0 && e.add(r);
};
class wk {
  constructor(t) {
    this._config = xk(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = Z0(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), X0(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return xa(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, n) {
    return xa(`${t}.transition.${n}`, () => [
      [
        `datasets.${t}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, n) {
    return xa(`${t}-${n}`, () => [
      [
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const n = t.id, r = this.type;
    return xa(`${r}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, n) {
    const r = this._scopeCache;
    let o = r.get(t);
    return (!o || n) && (o = /* @__PURE__ */ new Map(), r.set(t, o)), o;
  }
  getOptionScopes(t, n, r) {
    const { options: o, type: i } = this, s = this._cachedScopes(t, r), a = s.get(n);
    if (a)
      return a;
    const l = /* @__PURE__ */ new Set();
    n.forEach((u) => {
      t && (l.add(t), u.forEach((d) => $i(l, t, d))), u.forEach((d) => $i(l, o, d)), u.forEach((d) => $i(l, Oo[i] || {}, d)), u.forEach((d) => $i(l, At, d)), u.forEach((d) => $i(l, nd, d));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), Q0.has(n) && s.set(n, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      Oo[n] || {},
      At.datasets[n] || {},
      {
        type: n
      },
      At,
      nd
    ];
  }
  resolveNamedOptions(t, n, r, o = [
    ""
  ]) {
    const i = {
      $shared: !0
    }, { resolver: s, subPrefixes: a } = Kg(this._resolverCache, t, o);
    let l = s;
    if (_k(s, n)) {
      i.$shared = !1, r = Ur(r) ? r() : r;
      const c = this.createResolver(t, r, a);
      l = di(s, r, c);
    }
    for (const c of n)
      i[c] = l[c];
    return i;
  }
  createResolver(t, n, r = [
    ""
  ], o) {
    const { resolver: i } = Kg(this._resolverCache, t, r);
    return Xe(n) ? di(i, n, void 0, o) : i;
  }
}
function Kg(e, t, n) {
  let r = e.get(t);
  r || (r = /* @__PURE__ */ new Map(), e.set(t, r));
  const o = n.join();
  let i = r.get(o);
  return i || (i = {
    resolver: Ff(t, n),
    subPrefixes: n.filter((a) => !a.toLowerCase().includes("hover"))
  }, r.set(o, i)), i;
}
const Ck = (e) => Xe(e) && Object.getOwnPropertyNames(e).reduce((t, n) => t || Ur(e[n]), !1);
function _k(e, t) {
  const { isScriptable: n, isIndexable: r } = D0(e);
  for (const o of t) {
    const i = n(o), s = r(o), a = (s || i) && e[o];
    if (i && (Ur(a) || Ck(a)) || s && Ct(a))
      return !0;
  }
  return !1;
}
var Ek = "4.3.3";
const Sk = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function qg(e, t) {
  return e === "top" || e === "bottom" || Sk.indexOf(e) === -1 && t === "x";
}
function Xg(e, t) {
  return function(n, r) {
    return n[e] === r[e] ? n[t] - r[t] : n[e] - r[e];
  };
}
function Zg(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), Mt(n && n.onComplete, [
    e
  ], t);
}
function Mk(e) {
  const t = e.chart, n = t.options.animation;
  Mt(n && n.onProgress, [
    e
  ], t);
}
function J0(e) {
  return V0() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const Ga = {}, Qg = (e) => {
  const t = J0(e);
  return Object.values(Ga).filter((n) => n.canvas === t).pop();
};
function Ok(e, t, n) {
  const r = Object.keys(e);
  for (const o of r) {
    const i = +o;
    if (i >= t) {
      const s = e[o];
      delete e[o], (n > 0 || i > t) && (e[i + n] = s);
    }
  }
}
function Rk(e, t, n, r) {
  return !n || e.type === "mouseout" ? null : r ? t : e;
}
function Tk(e) {
  const { xScale: t, yScale: n } = e;
  if (t && n)
    return {
      left: t.left,
      right: t.right,
      top: n.top,
      bottom: n.bottom
    };
}
var Dr;
let zf = (Dr = class {
  static register(...t) {
    Gn.add(...t), Jg();
  }
  static unregister(...t) {
    Gn.remove(...t), Jg();
  }
  constructor(t, n) {
    const r = this.config = new wk(n), o = J0(t), i = Qg(o);
    if (i)
      throw new Error("Canvas is already in use. Chart with ID '" + i.id + "' must be destroyed before the canvas with ID '" + i.canvas.id + "' can be reused.");
    const s = r.createResolver(r.chartOptionScopes(), this.getContext());
    this.platform = new (r.platform || YT(o))(), this.platform.updateConfig(r);
    const a = this.platform.acquireContext(o, s.aspectRatio), l = a && a.canvas, c = l && l.height, u = l && l.width;
    if (this.id = MO(), this.ctx = a, this.canvas = l, this.width = u, this.height = c, this._options = s, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new uk(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = WO((d) => this.update(d), s.resizeDelay || 0), this._dataChanges = [], Ga[this.id] = this, !a || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    gr.listen(this, "complete", Zg), gr.listen(this, "progress", Mk), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: r, height: o, _aspectRatio: i } = this;
    return ut(t) ? n && i ? i : o ? r / o : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return Gn;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : xg(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return vg(this.canvas, this.ctx), this;
  }
  stop() {
    return gr.stop(this), this;
  }
  resize(t, n) {
    gr.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: n
    } : this._resize(t, n);
  }
  _resize(t, n) {
    const r = this.options, o = this.canvas, i = r.maintainAspectRatio && this.aspectRatio, s = this.platform.getMaximumSize(o, t, n, i), a = r.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = s.width, this.height = s.height, this._aspectRatio = this.aspectRatio, xg(this, a, !0) && (this.notifyPlugins("resize", {
      size: s
    }), Mt(r.onResize, [
      this,
      s
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    ct(n, (r, o) => {
      r.id = o;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, r = this.scales, o = Object.keys(r).reduce((s, a) => (s[a] = !1, s), {});
    let i = [];
    n && (i = i.concat(Object.keys(n).map((s) => {
      const a = n[s], l = id(s, a), c = l === "r", u = l === "x";
      return {
        options: a,
        dposition: c ? "chartArea" : u ? "bottom" : "left",
        dtype: c ? "radialLinear" : u ? "category" : "linear"
      };
    }))), ct(i, (s) => {
      const a = s.options, l = a.id, c = id(l, a), u = et(a.type, s.dtype);
      (a.position === void 0 || qg(a.position, c) !== qg(s.dposition)) && (a.position = s.dposition), o[l] = !0;
      let d = null;
      if (l in r && r[l].type === u)
        d = r[l];
      else {
        const f = Gn.getScale(u);
        d = new f({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), r[d.id] = d;
      }
      d.init(a, t);
    }), ct(o, (s, a) => {
      s || delete r[a];
    }), ct(r, (s) => {
      va.configure(this, s, s.options), va.addBox(this, s);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, r = t.length;
    if (t.sort((o, i) => o.index - i.index), r > n) {
      for (let o = n; o < r; ++o)
        this._destroyDatasetMeta(o);
      t.splice(n, r - n);
    }
    this._sortedMetasets = t.slice(0).sort(Xg("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((r, o) => {
      n.filter((i) => i === r._dataset).length === 0 && this._destroyDatasetMeta(o);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let r, o;
    for (this._removeUnreferencedMetasets(), r = 0, o = n.length; r < o; r++) {
      const i = n[r];
      let s = this.getDatasetMeta(r);
      const a = i.type || this.config.type;
      if (s.type && s.type !== a && (this._destroyDatasetMeta(r), s = this.getDatasetMeta(r)), s.type = a, s.indexAxis = i.indexAxis || od(a, this.options), s.order = i.order || 0, s.index = r, s.label = "" + i.label, s.visible = this.isDatasetVisible(r), s.controller)
        s.controller.updateIndex(r), s.controller.linkScales();
      else {
        const l = Gn.getController(a), { datasetElementType: c, dataElementType: u } = At.datasets[a];
        Object.assign(l, {
          dataElementType: Gn.getElement(u),
          datasetElementType: c && Gn.getElement(c)
        }), s.controller = new l(this, r), t.push(s.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    ct(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const r = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), o = this._animationsDisabled = !r.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const i = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let s = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: d } = this.getDatasetMeta(c), f = !o && i.indexOf(d) === -1;
      d.buildOrUpdateElements(f), s = Math.max(+d.getMaxOverflow(), s);
    }
    s = this._minPadding = r.layout.autoPadding ? s : 0, this._updateLayout(s), o || ct(i, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(Xg("z", "_idx"));
    const { _active: a, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
  }
  _updateScales() {
    ct(this.scales, (t) => {
      va.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), r = new Set(t.events);
    (!ag(n, r) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: r, start: o, count: i } of n) {
      const s = r === "_removeElements" ? -i : i;
      Ok(t, o, s);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, r = (i) => new Set(t.filter((s) => s[0] === i).map((s, a) => a + "," + s.splice(1).join(","))), o = r(0);
    for (let i = 1; i < n; i++)
      if (!ag(o, r(i)))
        return;
    return Array.from(o).map((i) => i.split(",")).map((i) => ({
      method: i[1],
      start: +i[2],
      count: +i[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    va.update(this, this.width, this.height, t);
    const n = this.chartArea, r = n.width <= 0 || n.height <= 0;
    this._layers = [], ct(this.boxes, (o) => {
      r && o.position === "chartArea" || (o.configure && o.configure(), this._layers.push(...o._layers()));
    }, this), this._layers.forEach((o, i) => {
      o._idx = i;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this._updateDataset(n, Ur(t) ? t({
          datasetIndex: n
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, n) {
    const r = this.getDatasetMeta(t), o = {
      meta: r,
      index: t,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", o) !== !1 && (r.controller._update(n), o.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", o));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (gr.has(this) ? this.attached && !gr.running(this) && gr.start(this) : (this.draw(), Zg({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: r, height: o } = this._resizeBeforeDraw;
      this._resize(r, o), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, r = [];
    let o, i;
    for (o = 0, i = n.length; o < i; ++o) {
      const s = n[o];
      (!t || s.visible) && r.push(s);
    }
    return r;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, r = t._clip, o = !r.disabled, i = Tk(t) || this.chartArea, s = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", s) !== !1 && (o && P0(n, {
      left: r.left === !1 ? 0 : i.left - r.left,
      right: r.right === !1 ? this.width : i.right + r.right,
      top: r.top === !1 ? 0 : i.top - r.top,
      bottom: r.bottom === !1 ? this.height : i.bottom + r.bottom
    }), t.controller.draw(), o && I0(n), s.cancelable = !1, this.notifyPlugins("afterDatasetDraw", s));
  }
  isPointInArea(t) {
    return br(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, r, o) {
    const i = ST.modes[n];
    return typeof i == "function" ? i(this, t, r, o) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], r = this._metasets;
    let o = r.filter((i) => i && i._dataset === n).pop();
    return o || (o = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, r.push(o)), o;
  }
  getContext() {
    return this.$context || (this.$context = to(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const r = this.getDatasetMeta(t);
    return typeof r.hidden == "boolean" ? !r.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const r = this.getDatasetMeta(t);
    r.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, r) {
    const o = r ? "show" : "hide", i = this.getDatasetMeta(t), s = i.controller._resolveAnimations(void 0, o);
    ps(n) ? (i.data[n].hidden = !r, this.update()) : (this.setDatasetVisibility(t, r), s.update(i, {
      visible: r
    }), this.update((a) => a.datasetIndex === t ? o : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), gr.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), vg(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete Ga[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, r = (i, s) => {
      n.addEventListener(this, i, s), t[i] = s;
    }, o = (i, s, a) => {
      i.offsetX = s, i.offsetY = a, this._eventHandler(i);
    };
    ct(this.options.events, (i) => r(i, o));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, r = (l, c) => {
      n.addEventListener(this, l, c), t[l] = c;
    }, o = (l, c) => {
      t[l] && (n.removeEventListener(this, l, c), delete t[l]);
    }, i = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let s;
    const a = () => {
      o("attach", a), this.attached = !0, this.resize(), r("resize", i), r("detach", s);
    };
    s = () => {
      this.attached = !1, o("resize", i), this._stop(), this._resize(0, 0), r("attach", a);
    }, n.isAttached(this.canvas) ? a() : s();
  }
  unbindEvents() {
    ct(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, ct(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, r) {
    const o = r ? "set" : "remove";
    let i, s, a, l;
    for (n === "dataset" && (i = this.getDatasetMeta(t[0].datasetIndex), i.controller["_" + o + "DatasetHoverStyle"]()), a = 0, l = t.length; a < l; ++a) {
      s = t[a];
      const c = s && this.getDatasetMeta(s.datasetIndex).controller;
      c && c[o + "HoverStyle"](s.element, s.datasetIndex, s.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], r = t.map(({ datasetIndex: i, index: s }) => {
      const a = this.getDatasetMeta(i);
      if (!a)
        throw new Error("No dataset found at index " + i);
      return {
        datasetIndex: i,
        element: a.data[s],
        index: s
      };
    });
    !pl(r, n) && (this._active = r, this._lastEvent = null, this._updateHoverStyles(r, n));
  }
  notifyPlugins(t, n, r) {
    return this._plugins.notify(this, t, n, r);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((n) => n.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, n, r) {
    const o = this.options.hover, i = (l, c) => l.filter((u) => !c.some((d) => u.datasetIndex === d.datasetIndex && u.index === d.index)), s = i(n, t), a = r ? t : i(t, n);
    s.length && this.updateHoverStyle(s, o.mode, !1), a.length && o.mode && this.updateHoverStyle(a, o.mode, !0);
  }
  _eventHandler(t, n) {
    const r = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, o = (s) => (s.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", r, o) === !1)
      return;
    const i = this._handleEvent(t, n, r.inChartArea);
    return r.cancelable = !1, this.notifyPlugins("afterEvent", r, o), (i || r.changed) && this.render(), this;
  }
  _handleEvent(t, n, r) {
    const { _active: o = [], options: i } = this, s = n, a = this._getActiveElements(t, o, r, s), l = IO(t), c = Rk(t, this._lastEvent, r, l);
    r && (this._lastEvent = null, Mt(i.onHover, [
      t,
      a,
      this
    ], this), l && Mt(i.onClick, [
      t,
      a,
      this
    ], this));
    const u = !pl(a, o);
    return (u || n) && (this._active = a, this._updateHoverStyles(a, o, n)), this._lastEvent = c, u;
  }
  _getActiveElements(t, n, r, o) {
    if (t.type === "mouseout")
      return [];
    if (!r)
      return n;
    const i = this.options.hover;
    return this.getElementsAtEventForMode(t, i.mode, i, o);
  }
}, ae(Dr, "defaults", At), ae(Dr, "instances", Ga), ae(Dr, "overrides", Oo), ae(Dr, "registry", Gn), ae(Dr, "version", Ek), ae(Dr, "getChart", Qg), Dr);
function Jg() {
  return ct(zf.instances, (e) => e._plugins.invalidate());
}
function kk(e, t, n) {
  const { startAngle: r, pixelMargin: o, x: i, y: s, outerRadius: a, innerRadius: l } = t;
  let c = o / a;
  e.beginPath(), e.arc(i, s, a, r - c, n + c), l > o ? (c = o / l, e.arc(i, s, l, n + c, r - c, !0)) : e.arc(i, s, o, n + Tt, r - Tt), e.closePath(), e.clip();
}
function Pk(e) {
  return $f(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function Ik(e, t, n, r) {
  const o = Pk(e.options.borderRadius), i = (n - t) / 2, s = Math.min(i, r * t / 2), a = (l) => {
    const c = (n - Math.min(i, l)) * r / 2;
    return Zt(l, 0, Math.min(i, c));
  };
  return {
    outerStart: a(o.outerStart),
    outerEnd: a(o.outerEnd),
    innerStart: Zt(o.innerStart, 0, s),
    innerEnd: Zt(o.innerEnd, 0, s)
  };
}
function zo(e, t, n, r) {
  return {
    x: n + e * Math.cos(t),
    y: r + e * Math.sin(t)
  };
}
function _l(e, t, n, r, o, i) {
  const { x: s, y: a, startAngle: l, pixelMargin: c, innerRadius: u } = t, d = Math.max(t.outerRadius + r + n - c, 0), f = u > 0 ? u + r + n + c : 0;
  let h = 0;
  const p = o - l;
  if (r) {
    const T = u > 0 ? u - r : 0, L = d > 0 ? d - r : 0, A = (T + L) / 2, N = A !== 0 ? p * A / (A + r) : p;
    h = (p - N) / 2;
  }
  const g = Math.max(1e-3, p * d - n / Ft) / d, v = (p - g) / 2, y = l + v + h, b = o - v - h, { outerStart: w, outerEnd: C, innerStart: x, innerEnd: E } = Ik(t, f, d, b - y), S = d - w, R = d - C, M = y + w / S, I = b - C / R, P = f + x, k = f + E, O = y + x / P, F = b - E / k;
  if (e.beginPath(), i) {
    const T = (M + I) / 2;
    if (e.arc(s, a, d, M, T), e.arc(s, a, d, T, I), C > 0) {
      const B = zo(R, I, s, a);
      e.arc(B.x, B.y, C, I, b + Tt);
    }
    const L = zo(k, b, s, a);
    if (e.lineTo(L.x, L.y), E > 0) {
      const B = zo(k, F, s, a);
      e.arc(B.x, B.y, E, b + Tt, F + Math.PI);
    }
    const A = (b - E / f + (y + x / f)) / 2;
    if (e.arc(s, a, f, b - E / f, A, !0), e.arc(s, a, f, A, y + x / f, !0), x > 0) {
      const B = zo(P, O, s, a);
      e.arc(B.x, B.y, x, O + Math.PI, y - Tt);
    }
    const N = zo(S, y, s, a);
    if (e.lineTo(N.x, N.y), w > 0) {
      const B = zo(S, M, s, a);
      e.arc(B.x, B.y, w, y - Tt, M);
    }
  } else {
    e.moveTo(s, a);
    const T = Math.cos(M) * d + s, L = Math.sin(M) * d + a;
    e.lineTo(T, L);
    const A = Math.cos(I) * d + s, N = Math.sin(I) * d + a;
    e.lineTo(A, N);
  }
  e.closePath();
}
function Nk(e, t, n, r, o) {
  const { fullCircles: i, startAngle: s, circumference: a } = t;
  let l = t.endAngle;
  if (i) {
    _l(e, t, n, r, l, o);
    for (let c = 0; c < i; ++c)
      e.fill();
    isNaN(a) || (l = s + (a % wt || wt));
  }
  return _l(e, t, n, r, l, o), e.fill(), l;
}
function Dk(e, t, n, r, o) {
  const { fullCircles: i, startAngle: s, circumference: a, options: l } = t, { borderWidth: c, borderJoinStyle: u, borderDash: d, borderDashOffset: f } = l, h = l.borderAlign === "inner";
  if (!c)
    return;
  e.setLineDash(d || []), e.lineDashOffset = f, h ? (e.lineWidth = c * 2, e.lineJoin = u || "round") : (e.lineWidth = c, e.lineJoin = u || "bevel");
  let p = t.endAngle;
  if (i) {
    _l(e, t, n, r, p, o);
    for (let g = 0; g < i; ++g)
      e.stroke();
    isNaN(a) || (p = s + (a % wt || wt));
  }
  h && kk(e, t, p), i || (_l(e, t, n, r, p, o), e.stroke());
}
class Ki extends Ao {
  constructor(n) {
    super();
    ae(this, "circumference");
    ae(this, "endAngle");
    ae(this, "fullCircles");
    ae(this, "innerRadius");
    ae(this, "outerRadius");
    ae(this, "pixelMargin");
    ae(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, n && Object.assign(this, n);
  }
  inRange(n, r, o) {
    const i = this.getProps([
      "x",
      "y"
    ], o), { angle: s, distance: a } = S0(i, {
      x: n,
      y: r
    }), { startAngle: l, endAngle: c, innerRadius: u, outerRadius: d, circumference: f } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], o), h = (this.options.spacing + this.options.borderWidth) / 2, g = et(f, c - l) >= wt || ms(s, l, c), v = vl(a, u + h, d + h);
    return g && v;
  }
  getCenterPoint(n) {
    const { x: r, y: o, startAngle: i, endAngle: s, innerRadius: a, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], n), { offset: c, spacing: u } = this.options, d = (i + s) / 2, f = (a + l + u + c) / 2;
    return {
      x: r + Math.cos(d) * f,
      y: o + Math.sin(d) * f
    };
  }
  tooltipPosition(n) {
    return this.getCenterPoint(n);
  }
  draw(n) {
    const { options: r, circumference: o } = this, i = (r.offset || 0) / 4, s = (r.spacing || 0) / 2, a = r.circular;
    if (this.pixelMargin = r.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = o > wt ? Math.floor(o / wt) : 0, o === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    n.save();
    const l = (this.startAngle + this.endAngle) / 2;
    n.translate(Math.cos(l) * i, Math.sin(l) * i);
    const c = 1 - Math.sin(Math.min(Ft, o || 0)), u = i * c;
    n.fillStyle = r.backgroundColor, n.strokeStyle = r.borderColor, Nk(n, this, u, s, a), Dk(n, this, u, s, a), n.restore();
  }
}
ae(Ki, "id", "arc"), ae(Ki, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), ae(Ki, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), ae(Ki, "descriptors", {
  _scriptable: !0,
  _indexable: (n) => n !== "borderDash"
});
function ey(e, t, n = t) {
  e.lineCap = et(n.borderCapStyle, t.borderCapStyle), e.setLineDash(et(n.borderDash, t.borderDash)), e.lineDashOffset = et(n.borderDashOffset, t.borderDashOffset), e.lineJoin = et(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = et(n.borderWidth, t.borderWidth), e.strokeStyle = et(n.borderColor, t.borderColor);
}
function Ak(e, t, n) {
  e.lineTo(n.x, n.y);
}
function Lk(e) {
  return e.stepped ? rR : e.tension || e.cubicInterpolationMode === "monotone" ? oR : Ak;
}
function ty(e, t, n = {}) {
  const r = e.length, { start: o = 0, end: i = r - 1 } = n, { start: s, end: a } = t, l = Math.max(o, s), c = Math.min(i, a), u = o < s && i < s || o > a && i > a;
  return {
    count: r,
    start: l,
    loop: t.loop,
    ilen: c < l && !u ? r + c - l : c - l
  };
}
function $k(e, t, n, r) {
  const { points: o, options: i } = t, { count: s, start: a, loop: l, ilen: c } = ty(o, n, r), u = Lk(i);
  let { move: d = !0, reverse: f } = r || {}, h, p, g;
  for (h = 0; h <= c; ++h)
    p = o[(a + (f ? c - h : h)) % s], !p.skip && (d ? (e.moveTo(p.x, p.y), d = !1) : u(e, g, p, f, i.stepped), g = p);
  return l && (p = o[(a + (f ? c : 0)) % s], u(e, g, p, f, i.stepped)), !!l;
}
function Fk(e, t, n, r) {
  const o = t.points, { count: i, start: s, ilen: a } = ty(o, n, r), { move: l = !0, reverse: c } = r || {};
  let u = 0, d = 0, f, h, p, g, v, y;
  const b = (C) => (s + (c ? a - C : C)) % i, w = () => {
    g !== v && (e.lineTo(u, v), e.lineTo(u, g), e.lineTo(u, y));
  };
  for (l && (h = o[b(0)], e.moveTo(h.x, h.y)), f = 0; f <= a; ++f) {
    if (h = o[b(f)], h.skip)
      continue;
    const C = h.x, x = h.y, E = C | 0;
    E === p ? (x < g ? g = x : x > v && (v = x), u = (d * u + C) / ++d) : (w(), e.lineTo(C, x), p = E, d = 0, g = v = x), y = x;
  }
  w();
}
function sd(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? Fk : $k;
}
function Vk(e) {
  return e.stepped ? LR : e.tension || e.cubicInterpolationMode === "monotone" ? $R : co;
}
function Bk(e, t, n, r) {
  let o = t._path;
  o || (o = t._path = new Path2D(), t.path(o, n, r) && o.closePath()), ey(e, t.options), e.stroke(o);
}
function Hk(e, t, n, r) {
  const { segments: o, options: i } = t, s = sd(t);
  for (const a of o)
    ey(e, i, a.style), e.beginPath(), s(e, t, a, {
      start: n,
      end: n + r - 1
    }) && e.closePath(), e.stroke();
}
const Wk = typeof Path2D == "function";
function zk(e, t, n, r) {
  Wk && !t.options.segment ? Bk(e, t, n, r) : Hk(e, t, n, r);
}
class qi extends Ao {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const r = this.options;
    if ((r.tension || r.cubicInterpolationMode === "monotone") && !r.stepped && !this._pointsUpdated) {
      const o = r.spanGaps ? this._loop : this._fullLoop;
      RR(this._points, r, t, o, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = GR(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, r = t.length;
    return r && n[t[r - 1].end];
  }
  interpolate(t, n) {
    const r = this.options, o = t[n], i = this.points, s = jR(this, {
      property: n,
      start: o,
      end: o
    });
    if (!s.length)
      return;
    const a = [], l = Vk(r);
    let c, u;
    for (c = 0, u = s.length; c < u; ++c) {
      const { start: d, end: f } = s[c], h = i[d], p = i[f];
      if (h === p) {
        a.push(h);
        continue;
      }
      const g = Math.abs((o - h[n]) / (p[n] - h[n])), v = l(h, p, g, r.stepped);
      v[n] = t[n], a.push(v);
    }
    return a.length === 1 ? a[0] : a;
  }
  pathSegment(t, n, r) {
    return sd(this)(t, this, n, r);
  }
  path(t, n, r) {
    const o = this.segments, i = sd(this);
    let s = this._loop;
    n = n || 0, r = r || this.points.length - n;
    for (const a of o)
      s &= i(t, this, a, {
        start: n,
        end: n + r - 1
      });
    return !!s;
  }
  draw(t, n, r, o) {
    const i = this.options || {};
    (this.points || []).length && i.borderWidth && (t.save(), zk(t, this, r, o), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
ae(qi, "id", "line"), ae(qi, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), ae(qi, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), ae(qi, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function em(e, t, n, r) {
  const o = e.options, { [n]: i } = e.getProps([
    n
  ], r);
  return Math.abs(t - i) < o.radius + o.hitRadius;
}
class Ka extends Ao {
  constructor(n) {
    super();
    ae(this, "parsed");
    ae(this, "skip");
    ae(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, r, o) {
    const i = this.options, { x: s, y: a } = this.getProps([
      "x",
      "y"
    ], o);
    return Math.pow(n - s, 2) + Math.pow(r - a, 2) < Math.pow(i.hitRadius + i.radius, 2);
  }
  inXRange(n, r) {
    return em(this, n, "x", r);
  }
  inYRange(n, r) {
    return em(this, n, "y", r);
  }
  getCenterPoint(n) {
    const { x: r, y: o } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: r,
      y: o
    };
  }
  size(n) {
    n = n || this.options || {};
    let r = n.radius || 0;
    r = Math.max(r, r && n.hoverRadius || 0);
    const o = r && n.borderWidth || 0;
    return (r + o) * 2;
  }
  draw(n, r) {
    const o = this.options;
    this.skip || o.radius < 0.1 || !br(this, r, this.size(o) / 2) || (n.strokeStyle = o.borderColor, n.lineWidth = o.borderWidth, n.fillStyle = o.backgroundColor, rd(n, o, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
ae(Ka, "id", "point"), /**
* @type {any}
*/
ae(Ka, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
ae(Ka, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function ny(e, t) {
  const { x: n, y: r, base: o, width: i, height: s } = e.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let a, l, c, u, d;
  return e.horizontal ? (d = s / 2, a = Math.min(n, o), l = Math.max(n, o), c = r - d, u = r + d) : (d = i / 2, a = n - d, l = n + d, c = Math.min(r, o), u = Math.max(r, o)), {
    left: a,
    top: c,
    right: l,
    bottom: u
  };
}
function Vr(e, t, n, r) {
  return e ? 0 : Zt(t, n, r);
}
function jk(e, t, n) {
  const r = e.options.borderWidth, o = e.borderSkipped, i = N0(r);
  return {
    t: Vr(o.top, i.top, 0, n),
    r: Vr(o.right, i.right, 0, t),
    b: Vr(o.bottom, i.bottom, 0, n),
    l: Vr(o.left, i.left, 0, t)
  };
}
function Uk(e, t, n) {
  const { enableBorderRadius: r } = e.getProps([
    "enableBorderRadius"
  ]), o = e.options.borderRadius, i = oi(o), s = Math.min(t, n), a = e.borderSkipped, l = r || Xe(o);
  return {
    topLeft: Vr(!l || a.top || a.left, i.topLeft, 0, s),
    topRight: Vr(!l || a.top || a.right, i.topRight, 0, s),
    bottomLeft: Vr(!l || a.bottom || a.left, i.bottomLeft, 0, s),
    bottomRight: Vr(!l || a.bottom || a.right, i.bottomRight, 0, s)
  };
}
function Yk(e) {
  const t = ny(e), n = t.right - t.left, r = t.bottom - t.top, o = jk(e, n / 2, r / 2), i = Uk(e, n / 2, r / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: n,
      h: r,
      radius: i
    },
    inner: {
      x: t.left + o.l,
      y: t.top + o.t,
      w: n - o.l - o.r,
      h: r - o.t - o.b,
      radius: {
        topLeft: Math.max(0, i.topLeft - Math.max(o.t, o.l)),
        topRight: Math.max(0, i.topRight - Math.max(o.t, o.r)),
        bottomLeft: Math.max(0, i.bottomLeft - Math.max(o.b, o.l)),
        bottomRight: Math.max(0, i.bottomRight - Math.max(o.b, o.r))
      }
    }
  };
}
function au(e, t, n, r) {
  const o = t === null, i = n === null, a = e && !(o && i) && ny(e, r);
  return a && (o || vl(t, a.left, a.right)) && (i || vl(n, a.top, a.bottom));
}
function Gk(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function Kk(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
function lu(e, t, n = {}) {
  const r = e.x !== n.x ? -t : 0, o = e.y !== n.y ? -t : 0, i = (e.x + e.w !== n.x + n.w ? t : 0) - r, s = (e.y + e.h !== n.y + n.h ? t : 0) - o;
  return {
    x: e.x + r,
    y: e.y + o,
    w: e.w + i,
    h: e.h + s,
    radius: e.radius
  };
}
class qa extends Ao {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: n, options: { borderColor: r, backgroundColor: o } } = this, { inner: i, outer: s } = Yk(this), a = Gk(s.radius) ? xl : Kk;
    t.save(), (s.w !== i.w || s.h !== i.h) && (t.beginPath(), a(t, lu(s, n, i)), t.clip(), a(t, lu(i, -n, s)), t.fillStyle = r, t.fill("evenodd")), t.beginPath(), a(t, lu(i, n)), t.fillStyle = o, t.fill(), t.restore();
  }
  inRange(t, n, r) {
    return au(this, t, n, r);
  }
  inXRange(t, n) {
    return au(this, t, null, n);
  }
  inYRange(t, n) {
    return au(this, null, t, n);
  }
  getCenterPoint(t) {
    const { x: n, y: r, base: o, horizontal: i } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: i ? (n + o) / 2 : n,
      y: i ? r : (r + o) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
ae(qa, "id", "bar"), ae(qa, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), ae(qa, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
const Xi = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, r = 0, o = 0, i = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const s = e[t].element;
      if (s && s.hasValue()) {
        const a = s.tooltipPosition();
        r += a.x, o += a.y, ++i;
      }
    }
    return {
      x: r / i,
      y: o / i
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, r = t.y, o = Number.POSITIVE_INFINITY, i, s, a;
    for (i = 0, s = e.length; i < s; ++i) {
      const l = e[i].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = td(t, c);
        u < o && (o = u, a = l);
      }
    }
    if (a) {
      const l = a.tooltipPosition();
      n = l.x, r = l.y;
    }
    return {
      x: n,
      y: r
    };
  }
};
function Yn(e, t) {
  return t && (Ct(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function mr(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function qk(e, t) {
  const { element: n, datasetIndex: r, index: o } = t, i = e.getDatasetMeta(r).controller, { label: s, value: a } = i.getLabelAndValue(o);
  return {
    chart: e,
    label: s,
    parsed: i.getParsed(o),
    raw: e.data.datasets[r].data[o],
    formattedValue: a,
    dataset: i.getDataset(),
    dataIndex: o,
    datasetIndex: r,
    element: n
  };
}
function tm(e, t) {
  const n = e.chart.ctx, { body: r, footer: o, title: i } = e, { boxWidth: s, boxHeight: a } = t, l = yn(t.bodyFont), c = yn(t.titleFont), u = yn(t.footerFont), d = i.length, f = o.length, h = r.length, p = In(t.padding);
  let g = p.height, v = 0, y = r.reduce((C, x) => C + x.before.length + x.lines.length + x.after.length, 0);
  if (y += e.beforeBody.length + e.afterBody.length, d && (g += d * c.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), y) {
    const C = t.displayColors ? Math.max(a, l.lineHeight) : l.lineHeight;
    g += h * C + (y - h) * l.lineHeight + (y - 1) * t.bodySpacing;
  }
  f && (g += t.footerMarginTop + f * u.lineHeight + (f - 1) * t.footerSpacing);
  let b = 0;
  const w = function(C) {
    v = Math.max(v, n.measureText(C).width + b);
  };
  return n.save(), n.font = c.string, ct(e.title, w), n.font = l.string, ct(e.beforeBody.concat(e.afterBody), w), b = t.displayColors ? s + 2 + t.boxPadding : 0, ct(r, (C) => {
    ct(C.before, w), ct(C.lines, w), ct(C.after, w);
  }), b = 0, n.font = u.string, ct(e.footer, w), n.restore(), v += p.width, {
    width: v,
    height: g
  };
}
function Xk(e, t) {
  const { y: n, height: r } = t;
  return n < r / 2 ? "top" : n > e.height - r / 2 ? "bottom" : "center";
}
function Zk(e, t, n, r) {
  const { x: o, width: i } = r, s = n.caretSize + n.caretPadding;
  if (e === "left" && o + i + s > t.width || e === "right" && o - i - s < 0)
    return !0;
}
function Qk(e, t, n, r) {
  const { x: o, width: i } = n, { width: s, chartArea: { left: a, right: l } } = e;
  let c = "center";
  return r === "center" ? c = o <= (a + l) / 2 ? "left" : "right" : o <= i / 2 ? c = "left" : o >= s - i / 2 && (c = "right"), Zk(c, e, t, n) && (c = "center"), c;
}
function nm(e, t, n) {
  const r = n.yAlign || t.yAlign || Xk(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || Qk(e, t, n, r),
    yAlign: r
  };
}
function Jk(e, t) {
  let { x: n, width: r } = e;
  return t === "right" ? n -= r : t === "center" && (n -= r / 2), n;
}
function eP(e, t, n) {
  let { y: r, height: o } = e;
  return t === "top" ? r += n : t === "bottom" ? r -= o + n : r -= o / 2, r;
}
function rm(e, t, n, r) {
  const { caretSize: o, caretPadding: i, cornerRadius: s } = e, { xAlign: a, yAlign: l } = n, c = o + i, { topLeft: u, topRight: d, bottomLeft: f, bottomRight: h } = oi(s);
  let p = Jk(t, a);
  const g = eP(t, l, c);
  return l === "center" ? a === "left" ? p += c : a === "right" && (p -= c) : a === "left" ? p -= Math.max(u, f) + o : a === "right" && (p += Math.max(d, h) + o), {
    x: Zt(p, 0, r.width - t.width),
    y: Zt(g, 0, r.height - t.height)
  };
}
function wa(e, t, n) {
  const r = In(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - r.right : e.x + r.left;
}
function om(e) {
  return Yn([], mr(e));
}
function tP(e, t, n) {
  return to(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
function im(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
const ry = {
  beforeTitle: fr,
  title(e) {
    if (e.length > 0) {
      const t = e[0], n = t.chart.data.labels, r = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (r > 0 && t.dataIndex < r)
        return n[t.dataIndex];
    }
    return "";
  },
  afterTitle: fr,
  beforeBody: fr,
  beforeLabel: fr,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const n = e.formattedValue;
    return ut(n) || (t += n), t;
  },
  labelColor(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: fr,
  afterBody: fr,
  beforeFooter: fr,
  footer: fr,
  afterFooter: fr
};
function on(e, t, n, r) {
  const o = e[t].call(n, r);
  return typeof o > "u" ? ry[t].call(n, r) : o;
}
class ad extends Ao {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, r = this.options.setContext(this.getContext()), o = r.enabled && n.options.animation && r.animations, i = new H0(this.chart, o);
    return o._cacheable && (this._cachedAnimations = Object.freeze(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = tP(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: r } = n, o = on(r, "beforeTitle", this, t), i = on(r, "title", this, t), s = on(r, "afterTitle", this, t);
    let a = [];
    return a = Yn(a, mr(o)), a = Yn(a, mr(i)), a = Yn(a, mr(s)), a;
  }
  getBeforeBody(t, n) {
    return om(on(n.callbacks, "beforeBody", this, t));
  }
  getBody(t, n) {
    const { callbacks: r } = n, o = [];
    return ct(t, (i) => {
      const s = {
        before: [],
        lines: [],
        after: []
      }, a = im(r, i);
      Yn(s.before, mr(on(a, "beforeLabel", this, i))), Yn(s.lines, on(a, "label", this, i)), Yn(s.after, mr(on(a, "afterLabel", this, i))), o.push(s);
    }), o;
  }
  getAfterBody(t, n) {
    return om(on(n.callbacks, "afterBody", this, t));
  }
  getFooter(t, n) {
    const { callbacks: r } = n, o = on(r, "beforeFooter", this, t), i = on(r, "footer", this, t), s = on(r, "afterFooter", this, t);
    let a = [];
    return a = Yn(a, mr(o)), a = Yn(a, mr(i)), a = Yn(a, mr(s)), a;
  }
  _createItems(t) {
    const n = this._active, r = this.chart.data, o = [], i = [], s = [];
    let a = [], l, c;
    for (l = 0, c = n.length; l < c; ++l)
      a.push(qk(this.chart, n[l]));
    return t.filter && (a = a.filter((u, d, f) => t.filter(u, d, f, r))), t.itemSort && (a = a.sort((u, d) => t.itemSort(u, d, r))), ct(a, (u) => {
      const d = im(t.callbacks, u);
      o.push(on(d, "labelColor", this, u)), i.push(on(d, "labelPointStyle", this, u)), s.push(on(d, "labelTextColor", this, u));
    }), this.labelColors = o, this.labelPointStyles = i, this.labelTextColors = s, this.dataPoints = a, a;
  }
  update(t, n) {
    const r = this.options.setContext(this.getContext()), o = this._active;
    let i, s = [];
    if (!o.length)
      this.opacity !== 0 && (i = {
        opacity: 0
      });
    else {
      const a = Xi[r.position].call(this, o, this._eventPosition);
      s = this._createItems(r), this.title = this.getTitle(s, r), this.beforeBody = this.getBeforeBody(s, r), this.body = this.getBody(s, r), this.afterBody = this.getAfterBody(s, r), this.footer = this.getFooter(s, r);
      const l = this._size = tm(this, r), c = Object.assign({}, a, l), u = nm(this.chart, r, c), d = rm(r, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, i = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: a.x,
        caretY: a.y
      };
    }
    this._tooltipItems = s, this.$context = void 0, i && this._resolveAnimations().update(this, i), t && r.external && r.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(t, n, r, o) {
    const i = this.getCaretPosition(t, r, o);
    n.lineTo(i.x1, i.y1), n.lineTo(i.x2, i.y2), n.lineTo(i.x3, i.y3);
  }
  getCaretPosition(t, n, r) {
    const { xAlign: o, yAlign: i } = this, { caretSize: s, cornerRadius: a } = r, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: d } = oi(a), { x: f, y: h } = t, { width: p, height: g } = n;
    let v, y, b, w, C, x;
    return i === "center" ? (C = h + g / 2, o === "left" ? (v = f, y = v - s, w = C + s, x = C - s) : (v = f + p, y = v + s, w = C - s, x = C + s), b = v) : (o === "left" ? y = f + Math.max(l, u) + s : o === "right" ? y = f + p - Math.max(c, d) - s : y = this.caretX, i === "top" ? (w = h, C = w - s, v = y - s, b = y + s) : (w = h + g, C = w + s, v = y + s, b = y - s), x = w), {
      x1: v,
      x2: y,
      x3: b,
      y1: w,
      y2: C,
      y3: x
    };
  }
  drawTitle(t, n, r) {
    const o = this.title, i = o.length;
    let s, a, l;
    if (i) {
      const c = eu(r.rtl, this.x, this.width);
      for (t.x = wa(this, r.titleAlign, r), n.textAlign = c.textAlign(r.titleAlign), n.textBaseline = "middle", s = yn(r.titleFont), a = r.titleSpacing, n.fillStyle = r.titleColor, n.font = s.string, l = 0; l < i; ++l)
        n.fillText(o[l], c.x(t.x), t.y + s.lineHeight / 2), t.y += s.lineHeight + a, l + 1 === i && (t.y += r.titleMarginBottom - a);
    }
  }
  _drawColorBox(t, n, r, o, i) {
    const s = this.labelColors[r], a = this.labelPointStyles[r], { boxHeight: l, boxWidth: c } = i, u = yn(i.bodyFont), d = wa(this, "left", i), f = o.x(d), h = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, p = n.y + h;
    if (i.usePointStyle) {
      const g = {
        radius: Math.min(c, l) / 2,
        pointStyle: a.pointStyle,
        rotation: a.rotation,
        borderWidth: 1
      }, v = o.leftForLtr(f, c) + c / 2, y = p + l / 2;
      t.strokeStyle = i.multiKeyBackground, t.fillStyle = i.multiKeyBackground, rd(t, g, v, y), t.strokeStyle = s.borderColor, t.fillStyle = s.backgroundColor, rd(t, g, v, y);
    } else {
      t.lineWidth = Xe(s.borderWidth) ? Math.max(...Object.values(s.borderWidth)) : s.borderWidth || 1, t.strokeStyle = s.borderColor, t.setLineDash(s.borderDash || []), t.lineDashOffset = s.borderDashOffset || 0;
      const g = o.leftForLtr(f, c), v = o.leftForLtr(o.xPlus(f, 1), c - 2), y = oi(s.borderRadius);
      Object.values(y).some((b) => b !== 0) ? (t.beginPath(), t.fillStyle = i.multiKeyBackground, xl(t, {
        x: g,
        y: p,
        w: c,
        h: l,
        radius: y
      }), t.fill(), t.stroke(), t.fillStyle = s.backgroundColor, t.beginPath(), xl(t, {
        x: v,
        y: p + 1,
        w: c - 2,
        h: l - 2,
        radius: y
      }), t.fill()) : (t.fillStyle = i.multiKeyBackground, t.fillRect(g, p, c, l), t.strokeRect(g, p, c, l), t.fillStyle = s.backgroundColor, t.fillRect(v, p + 1, c - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[r];
  }
  drawBody(t, n, r) {
    const { body: o } = this, { bodySpacing: i, bodyAlign: s, displayColors: a, boxHeight: l, boxWidth: c, boxPadding: u } = r, d = yn(r.bodyFont);
    let f = d.lineHeight, h = 0;
    const p = eu(r.rtl, this.x, this.width), g = function(R) {
      n.fillText(R, p.x(t.x + h), t.y + f / 2), t.y += f + i;
    }, v = p.textAlign(s);
    let y, b, w, C, x, E, S;
    for (n.textAlign = s, n.textBaseline = "middle", n.font = d.string, t.x = wa(this, v, r), n.fillStyle = r.bodyColor, ct(this.beforeBody, g), h = a && v !== "right" ? s === "center" ? c / 2 + u : c + 2 + u : 0, C = 0, E = o.length; C < E; ++C) {
      for (y = o[C], b = this.labelTextColors[C], n.fillStyle = b, ct(y.before, g), w = y.lines, a && w.length && (this._drawColorBox(n, t, C, p, r), f = Math.max(d.lineHeight, l)), x = 0, S = w.length; x < S; ++x)
        g(w[x]), f = d.lineHeight;
      ct(y.after, g);
    }
    h = 0, f = d.lineHeight, ct(this.afterBody, g), t.y -= i;
  }
  drawFooter(t, n, r) {
    const o = this.footer, i = o.length;
    let s, a;
    if (i) {
      const l = eu(r.rtl, this.x, this.width);
      for (t.x = wa(this, r.footerAlign, r), t.y += r.footerMarginTop, n.textAlign = l.textAlign(r.footerAlign), n.textBaseline = "middle", s = yn(r.footerFont), n.fillStyle = r.footerColor, n.font = s.string, a = 0; a < i; ++a)
        n.fillText(o[a], l.x(t.x), t.y + s.lineHeight / 2), t.y += s.lineHeight + r.footerSpacing;
    }
  }
  drawBackground(t, n, r, o) {
    const { xAlign: i, yAlign: s } = this, { x: a, y: l } = t, { width: c, height: u } = r, { topLeft: d, topRight: f, bottomLeft: h, bottomRight: p } = oi(o.cornerRadius);
    n.fillStyle = o.backgroundColor, n.strokeStyle = o.borderColor, n.lineWidth = o.borderWidth, n.beginPath(), n.moveTo(a + d, l), s === "top" && this.drawCaret(t, n, r, o), n.lineTo(a + c - f, l), n.quadraticCurveTo(a + c, l, a + c, l + f), s === "center" && i === "right" && this.drawCaret(t, n, r, o), n.lineTo(a + c, l + u - p), n.quadraticCurveTo(a + c, l + u, a + c - p, l + u), s === "bottom" && this.drawCaret(t, n, r, o), n.lineTo(a + h, l + u), n.quadraticCurveTo(a, l + u, a, l + u - h), s === "center" && i === "left" && this.drawCaret(t, n, r, o), n.lineTo(a, l + d), n.quadraticCurveTo(a, l, a + d, l), n.closePath(), n.fill(), o.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, r = this.$animations, o = r && r.x, i = r && r.y;
    if (o || i) {
      const s = Xi[t.position].call(this, this._active, this._eventPosition);
      if (!s)
        return;
      const a = this._size = tm(this, t), l = Object.assign({}, s, this._size), c = nm(n, t, l), u = rm(t, l, c, n);
      (o._to !== u.x || i._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = a.width, this.height = a.height, this.caretX = s.x, this.caretY = s.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let r = this.opacity;
    if (!r)
      return;
    this._updateAnimationTarget(n);
    const o = {
      width: this.width,
      height: this.height
    }, i = {
      x: this.x,
      y: this.y
    };
    r = Math.abs(r) < 1e-3 ? 0 : r;
    const s = In(n.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && a && (t.save(), t.globalAlpha = r, this.drawBackground(i, t, o, n), BR(t, n.textDirection), i.y += s.top, this.drawTitle(i, t, n), this.drawBody(i, t, n), this.drawFooter(i, t, n), HR(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const r = this._active, o = t.map(({ datasetIndex: a, index: l }) => {
      const c = this.chart.getDatasetMeta(a);
      if (!c)
        throw new Error("Cannot find a dataset at index " + a);
      return {
        datasetIndex: a,
        element: c.data[l],
        index: l
      };
    }), i = !pl(r, o), s = this._positionChanged(o, n);
    (i || s) && (this._active = o, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, r = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const o = this.options, i = this._active || [], s = this._getActiveElements(t, i, n, r), a = this._positionChanged(s, t), l = n || !pl(s, i) || a;
    return l && (this._active = s, (o.enabled || o.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), l;
  }
  _getActiveElements(t, n, r, o) {
    const i = this.options;
    if (t.type === "mouseout")
      return [];
    if (!o)
      return n;
    const s = this.chart.getElementsAtEventForMode(t, i.mode, i, r);
    return i.reverse && s.reverse(), s;
  }
  _positionChanged(t, n) {
    const { caretX: r, caretY: o, options: i } = this, s = Xi[i.position].call(this, t, n);
    return s !== !1 && (r !== s.x || o !== s.y);
  }
}
ae(ad, "positioners", Xi);
var nP = {
  id: "tooltip",
  _element: ad,
  positioners: Xi,
  afterInit(e, t, n) {
    n && (e.tooltip = new ad({
      chart: e,
      options: n
    }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: ry
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const rP = (e, t, n, r) => (typeof t == "string" ? (n = e.push(t) - 1, r.unshift({
  index: n,
  label: t
})) : isNaN(t) && (n = null), n);
function oP(e, t, n, r) {
  const o = e.indexOf(t);
  if (o === -1)
    return rP(e, t, n, r);
  const i = e.lastIndexOf(t);
  return o !== i ? n : o;
}
const iP = (e, t) => e === null ? null : Zt(Math.round(e), 0, t);
function sm(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
class ld extends Lo {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const n = this._addedLabels;
    if (n.length) {
      const r = this.getLabels();
      for (const { index: o, label: i } of n)
        r[o] === i && r.splice(o, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, n) {
    if (ut(t))
      return null;
    const r = this.getLabels();
    return n = isFinite(n) && r[n] === t ? n : oP(r, t, et(n, t), this._addedLabels), iP(n, r.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let { min: r, max: o } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (r = 0), n || (o = this.getLabels().length - 1)), this.min = r, this.max = o;
  }
  buildTicks() {
    const t = this.min, n = this.max, r = this.options.offset, o = [];
    let i = this.getLabels();
    i = t === 0 && n === i.length - 1 ? i : i.slice(t, n + 1), this._valueRange = Math.max(i.length - (r ? 0 : 1), 1), this._startValue = this.min - (r ? 0.5 : 0);
    for (let s = t; s <= n; s++)
      o.push({
        value: s
      });
    return o;
  }
  getLabelForValue(t) {
    return sm.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
ae(ld, "id", "category"), ae(ld, "defaults", {
  ticks: {
    callback: sm
  }
});
function sP(e, t) {
  const n = [], { bounds: o, step: i, min: s, max: a, precision: l, count: c, maxTicks: u, maxDigits: d, includeBounds: f } = e, h = i || 1, p = u - 1, { min: g, max: v } = t, y = !ut(s), b = !ut(a), w = !ut(c), C = (v - g) / (d + 1);
  let x = cg((v - g) / p / h) * h, E, S, R, M;
  if (x < 1e-14 && !y && !b)
    return [
      {
        value: g
      },
      {
        value: v
      }
    ];
  M = Math.ceil(v / x) - Math.floor(g / x), M > p && (x = cg(M * x / p / h) * h), ut(l) || (E = Math.pow(10, l), x = Math.ceil(x * E) / E), o === "ticks" ? (S = Math.floor(g / x) * x, R = Math.ceil(v / x) * x) : (S = g, R = v), y && b && i && LO((a - s) / i, x / 1e3) ? (M = Math.round(Math.min((a - s) / x, u)), x = (a - s) / M, S = s, R = a) : w ? (S = y ? s : S, R = b ? a : R, M = c - 1, x = (R - S) / M) : (M = (R - S) / x, ts(M, Math.round(M), x / 1e3) ? M = Math.round(M) : M = Math.ceil(M));
  const I = Math.max(ug(x), ug(S));
  E = Math.pow(10, ut(l) ? I : l), S = Math.round(S * E) / E, R = Math.round(R * E) / E;
  let P = 0;
  for (y && (f && S !== s ? (n.push({
    value: s
  }), S < s && P++, ts(Math.round((S + P * x) * E) / E, s, am(s, C, e)) && P++) : S < s && P++); P < M; ++P) {
    const k = Math.round((S + P * x) * E) / E;
    if (b && k > a)
      break;
    n.push({
      value: k
    });
  }
  return b && f && R !== a ? n.length && ts(n[n.length - 1].value, a, am(a, C, e)) ? n[n.length - 1].value = a : n.push({
    value: a
  }) : (!b || R === a) && n.push({
    value: R
  }), n;
}
function am(e, t, { horizontal: n, minRotation: r }) {
  const o = Zn(r), i = (n ? Math.sin(o) : Math.cos(o)) || 1e-3, s = 0.75 * t * ("" + e).length;
  return Math.min(t / i, s);
}
class El extends Lo {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return ut(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: r } = this.getUserBounds();
    let { min: o, max: i } = this;
    const s = (l) => o = n ? o : l, a = (l) => i = r ? i : l;
    if (t) {
      const l = tr(o), c = tr(i);
      l < 0 && c < 0 ? a(0) : l > 0 && c > 0 && s(0);
    }
    if (o === i) {
      let l = i === 0 ? 1 : Math.abs(i * 0.05);
      a(i + l), t || s(o - l);
    }
    this.min = o, this.max = i;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: r } = t, o;
    return r ? (o = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1, o > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${o} ticks. Limiting to 1000.`), o = 1e3)) : (o = this.computeTickLimit(), n = n || 11), n && (o = Math.min(n, o)), o;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let r = this.getTickLimit();
    r = Math.max(2, r);
    const o = {
      maxTicks: r,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, i = this._range || this, s = sP(o, i);
    return t.bounds === "ticks" && E0(s, this, "value"), t.reverse ? (s.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), s;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, r = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const o = (r - n) / Math.max(t.length - 1, 1) / 2;
      n -= o, r += o;
    }
    this._startValue = n, this._endValue = r, this._valueRange = r - n;
  }
  getLabelForValue(t) {
    return gc(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class cd extends El {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = Ut(t) ? t : 0, this.max = Ut(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, r = Zn(this.options.ticks.minRotation), o = (t ? Math.sin(r) : Math.cos(r)) || 1e-3, i = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, i.lineHeight / o));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
ae(cd, "id", "linear"), ae(cd, "defaults", {
  ticks: {
    callback: mc.formatters.numeric
  }
});
const bs = (e) => Math.floor(Fr(e)), ao = (e, t) => Math.pow(10, bs(e) + t);
function lm(e) {
  return e / Math.pow(10, bs(e)) === 1;
}
function cm(e, t, n) {
  const r = Math.pow(10, n), o = Math.floor(e / r);
  return Math.ceil(t / r) - o;
}
function aP(e, t) {
  const n = t - e;
  let r = bs(n);
  for (; cm(e, t, r) > 10; )
    r++;
  for (; cm(e, t, r) < 10; )
    r--;
  return Math.min(r, bs(e));
}
function lP(e, { min: t, max: n }) {
  t = pn(e.min, t);
  const r = [], o = bs(t);
  let i = aP(t, n), s = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
  const a = Math.pow(10, i), l = o > i ? Math.pow(10, o) : 0, c = Math.round((t - l) * s) / s, u = Math.floor((t - l) / a / 10) * a * 10;
  let d = Math.floor((c - u) / Math.pow(10, i)), f = pn(e.min, Math.round((l + u + d * Math.pow(10, i)) * s) / s);
  for (; f < n; )
    r.push({
      value: f,
      major: lm(f),
      significand: d
    }), d >= 10 ? d = d < 15 ? 15 : 20 : d++, d >= 20 && (i++, d = 2, s = i >= 0 ? 1 : s), f = Math.round((l + u + d * Math.pow(10, i)) * s) / s;
  const h = pn(e.max, f);
  return r.push({
    value: h,
    major: lm(h),
    significand: d
  }), r;
}
class um extends Lo {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    const r = El.prototype.parse.apply(this, [
      t,
      n
    ]);
    if (r === 0) {
      this._zero = !0;
      return;
    }
    return Ut(r) && r > 0 ? r : null;
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = Ut(t) ? Math.max(0, t) : null, this.max = Ut(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !Ut(this._userMin) && (this.min = t === ao(this.min, 0) ? ao(this.min, -1) : ao(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let r = this.min, o = this.max;
    const i = (a) => r = t ? r : a, s = (a) => o = n ? o : a;
    r === o && (r <= 0 ? (i(1), s(10)) : (i(ao(r, -1)), s(ao(o, 1)))), r <= 0 && i(ao(o, -1)), o <= 0 && s(ao(r, 1)), this.min = r, this.max = o;
  }
  buildTicks() {
    const t = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, r = lP(n, this);
    return t.bounds === "ticks" && E0(r, this, "value"), t.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : gc(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = Fr(t), this._valueRange = Fr(this.max) - Fr(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (Fr(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const n = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
ae(um, "id", "logarithmic"), ae(um, "defaults", {
  ticks: {
    callback: mc.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function ud(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const n = In(t.backdropPadding);
    return et(t.font && t.font.size, At.font.size) + n.height;
  }
  return 0;
}
function cP(e, t, n) {
  return n = Ct(n) ? n : [
    n
  ], {
    w: tR(e, t.string, n),
    h: n.length * t.lineHeight
  };
}
function dm(e, t, n, r, o) {
  return e === r || e === o ? {
    start: t - n / 2,
    end: t + n / 2
  } : e < r || e > o ? {
    start: t - n,
    end: t
  } : {
    start: t,
    end: t + n
  };
}
function uP(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, n = Object.assign({}, t), r = [], o = [], i = e._pointLabels.length, s = e.options.pointLabels, a = s.centerPointLabels ? Ft / i : 0;
  for (let l = 0; l < i; l++) {
    const c = s.setContext(e.getPointLabelContext(l));
    o[l] = c.padding;
    const u = e.getPointPosition(l, e.drawingArea + o[l], a), d = yn(c.font), f = cP(e.ctx, d, e._pointLabels[l]);
    r[l] = f;
    const h = Vn(e.getIndexAngle(l) + a), p = Math.round(Df(h)), g = dm(p, u.x, f.w, 0, 180), v = dm(p, u.y, f.h, 90, 270);
    dP(n, t, h, g, v);
  }
  e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b), e._pointLabelItems = pP(e, r, o);
}
function dP(e, t, n, r, o) {
  const i = Math.abs(Math.sin(n)), s = Math.abs(Math.cos(n));
  let a = 0, l = 0;
  r.start < t.l ? (a = (t.l - r.start) / i, e.l = Math.min(e.l, t.l - a)) : r.end > t.r && (a = (r.end - t.r) / i, e.r = Math.max(e.r, t.r + a)), o.start < t.t ? (l = (t.t - o.start) / s, e.t = Math.min(e.t, t.t - l)) : o.end > t.b && (l = (o.end - t.b) / s, e.b = Math.max(e.b, t.b + l));
}
function fP(e, t, n) {
  const r = e.drawingArea, { extra: o, additionalAngle: i, padding: s, size: a } = n, l = e.getPointPosition(t, r + o + s, i), c = Math.round(Df(Vn(l.angle + Tt))), u = vP(l.y, a.h, c), d = gP(c), f = mP(l.x, a.w, d);
  return {
    visible: !0,
    x: l.x,
    y: u,
    textAlign: d,
    left: f,
    top: u,
    right: f + a.w,
    bottom: u + a.h
  };
}
function hP(e, t) {
  if (!t)
    return !0;
  const { left: n, top: r, right: o, bottom: i } = e;
  return !(br({
    x: n,
    y: r
  }, t) || br({
    x: n,
    y: i
  }, t) || br({
    x: o,
    y: r
  }, t) || br({
    x: o,
    y: i
  }, t));
}
function pP(e, t, n) {
  const r = [], o = e._pointLabels.length, i = e.options, { centerPointLabels: s, display: a } = i.pointLabels, l = {
    extra: ud(i) / 2,
    additionalAngle: s ? Ft / o : 0
  };
  let c;
  for (let u = 0; u < o; u++) {
    l.padding = n[u], l.size = t[u];
    const d = fP(e, u, l);
    r.push(d), a === "auto" && (d.visible = hP(d, c), d.visible && (c = d));
  }
  return r;
}
function gP(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function mP(e, t, n) {
  return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function vP(e, t, n) {
  return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function bP(e, t, n) {
  const { left: r, top: o, right: i, bottom: s } = n, { backdropColor: a } = t;
  if (!ut(a)) {
    const l = oi(t.borderRadius), c = In(t.backdropPadding);
    e.fillStyle = a;
    const u = r - c.left, d = o - c.top, f = i - r + c.width, h = s - o + c.height;
    Object.values(l).some((p) => p !== 0) ? (e.beginPath(), xl(e, {
      x: u,
      y: d,
      w: f,
      h,
      radius: l
    }), e.fill()) : e.fillRect(u, d, f, h);
  }
}
function yP(e, t) {
  const { ctx: n, options: { pointLabels: r } } = e;
  for (let o = t - 1; o >= 0; o--) {
    const i = e._pointLabelItems[o];
    if (!i.visible)
      continue;
    const s = r.setContext(e.getPointLabelContext(o));
    bP(n, s, i);
    const a = yn(s.font), { x: l, y: c, textAlign: u } = i;
    yl(n, e._pointLabels[o], l, c + a.lineHeight / 2, a, {
      color: s.color,
      textAlign: u,
      textBaseline: "middle"
    });
  }
}
function oy(e, t, n, r) {
  const { ctx: o } = e;
  if (n)
    o.arc(e.xCenter, e.yCenter, t, 0, wt);
  else {
    let i = e.getPointPosition(0, t);
    o.moveTo(i.x, i.y);
    for (let s = 1; s < r; s++)
      i = e.getPointPosition(s, t), o.lineTo(i.x, i.y);
  }
}
function xP(e, t, n, r, o) {
  const i = e.ctx, s = t.circular, { color: a, lineWidth: l } = t;
  !s && !r || !a || !l || n < 0 || (i.save(), i.strokeStyle = a, i.lineWidth = l, i.setLineDash(o.dash), i.lineDashOffset = o.dashOffset, i.beginPath(), oy(e, n, s, r), i.closePath(), i.stroke(), i.restore());
}
function wP(e, t, n) {
  return to(e, {
    label: n,
    index: t,
    type: "pointLabel"
  });
}
class Ca extends El {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = In(ud(this.options) / 2), n = this.width = this.maxWidth - t.width, r = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + n / 2 + t.left), this.yCenter = Math.floor(this.top + r / 2 + t.top), this.drawingArea = Math.floor(Math.min(n, r) / 2);
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!1);
    this.min = Ut(t) && !isNaN(t) ? t : 0, this.max = Ut(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / ud(this.options));
  }
  generateTickLabels(t) {
    El.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((n, r) => {
      const o = Mt(this.options.pointLabels.callback, [
        n,
        r
      ], this);
      return o || o === 0 ? o : "";
    }).filter((n, r) => this.chart.getDataVisibility(r));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? uP(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, n, r, o) {
    this.xCenter += Math.floor((t - n) / 2), this.yCenter += Math.floor((r - o) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, n, r, o));
  }
  getIndexAngle(t) {
    const n = wt / (this._pointLabels.length || 1), r = this.options.startAngle || 0;
    return Vn(t * n + Zn(r));
  }
  getDistanceFromCenterForValue(t) {
    if (ut(t))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * n : (t - this.min) * n;
  }
  getValueForDistanceFromCenter(t) {
    if (ut(t))
      return NaN;
    const n = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(t) {
    const n = this._pointLabels || [];
    if (t >= 0 && t < n.length) {
      const r = n[t];
      return wP(this.getContext(), t, r);
    }
  }
  getPointPosition(t, n, r = 0) {
    const o = this.getIndexAngle(t) - Tt + r;
    return {
      x: Math.cos(o) * n + this.xCenter,
      y: Math.sin(o) * n + this.yCenter,
      angle: o
    };
  }
  getPointPositionForValue(t, n) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: n, top: r, right: o, bottom: i } = this._pointLabelItems[t];
    return {
      left: n,
      top: r,
      right: o,
      bottom: i
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: n } } = this.options;
    if (t) {
      const r = this.ctx;
      r.save(), r.beginPath(), oy(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), r.closePath(), r.fillStyle = t, r.fill(), r.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, n = this.options, { angleLines: r, grid: o, border: i } = n, s = this._pointLabels.length;
    let a, l, c;
    if (n.pointLabels.display && yP(this, s), o.display && this.ticks.forEach((u, d) => {
      if (d !== 0) {
        l = this.getDistanceFromCenterForValue(u.value);
        const f = this.getContext(d), h = o.setContext(f), p = i.setContext(f);
        xP(this, h, l, s, p);
      }
    }), r.display) {
      for (t.save(), a = s - 1; a >= 0; a--) {
        const u = r.setContext(this.getPointLabelContext(a)), { color: d, lineWidth: f } = u;
        !f || !d || (t.lineWidth = f, t.strokeStyle = d, t.setLineDash(u.borderDash), t.lineDashOffset = u.borderDashOffset, l = this.getDistanceFromCenterForValue(n.ticks.reverse ? this.min : this.max), c = this.getPointPosition(a, l), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(c.x, c.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, n = this.options, r = n.ticks;
    if (!r.display)
      return;
    const o = this.getIndexAngle(0);
    let i, s;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(o), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((a, l) => {
      if (l === 0 && !n.reverse)
        return;
      const c = r.setContext(this.getContext(l)), u = yn(c.font);
      if (i = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        t.font = u.string, s = t.measureText(a.label).width, t.fillStyle = c.backdropColor;
        const d = In(c.backdropPadding);
        t.fillRect(-s / 2 - d.left, -i - u.size / 2 - d.top, s + d.width, u.size + d.height);
      }
      yl(t, a.label, 0, -i, u, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
ae(Ca, "id", "radialLinear"), ae(Ca, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: mc.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), ae(Ca, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), ae(Ca, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const bc = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, sn = /* @__PURE__ */ Object.keys(bc);
function fm(e, t) {
  return e - t;
}
function hm(e, t) {
  if (ut(t))
    return null;
  const n = e._adapter, { parser: r, round: o, isoWeekday: i } = e._parseOpts;
  let s = t;
  return typeof r == "function" && (s = r(s)), Ut(s) || (s = typeof r == "string" ? n.parse(s, r) : n.parse(s)), s === null ? null : (o && (s = o === "week" && (gs(i) || i === !0) ? n.startOf(s, "isoWeek", i) : n.startOf(s, o)), +s);
}
function pm(e, t, n, r) {
  const o = sn.length;
  for (let i = sn.indexOf(e); i < o - 1; ++i) {
    const s = bc[sn[i]], a = s.steps ? s.steps : Number.MAX_SAFE_INTEGER;
    if (s.common && Math.ceil((n - t) / (a * s.size)) <= r)
      return sn[i];
  }
  return sn[o - 1];
}
function CP(e, t, n, r, o) {
  for (let i = sn.length - 1; i >= sn.indexOf(n); i--) {
    const s = sn[i];
    if (bc[s].common && e._adapter.diff(o, r, s) >= t - 1)
      return s;
  }
  return sn[n ? sn.indexOf(n) : 0];
}
function _P(e) {
  for (let t = sn.indexOf(e) + 1, n = sn.length; t < n; ++t)
    if (bc[sn[t]].common)
      return sn[t];
}
function gm(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: r, hi: o } = Af(n, t), i = n[r] >= t ? n[r] : n[o];
    e[i] = !0;
  }
}
function EP(e, t, n, r) {
  const o = e._adapter, i = +o.startOf(t[0].value, r), s = t[t.length - 1].value;
  let a, l;
  for (a = i; a <= s; a = +o.add(a, 1, r))
    l = n[a], l >= 0 && (t[l].major = !0);
  return t;
}
function mm(e, t, n) {
  const r = [], o = {}, i = t.length;
  let s, a;
  for (s = 0; s < i; ++s)
    a = t[s], o[a] = s, r.push({
      value: a,
      major: !1
    });
  return i === 0 || !n ? r : EP(e, r, o, n);
}
class ys extends Lo {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n = {}) {
    const r = t.time || (t.time = {}), o = this._adapter = new j0._date(t.adapters.date);
    o.init(n), es(r.displayFormats, o.formats()), this._parseOpts = {
      parser: r.parser,
      round: r.round,
      isoWeekday: r.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : hm(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, r = t.time.unit || "day";
    let { min: o, max: i, minDefined: s, maxDefined: a } = this.getUserBounds();
    function l(c) {
      !s && !isNaN(c.min) && (o = Math.min(o, c.min)), !a && !isNaN(c.max) && (i = Math.max(i, c.max));
    }
    (!s || !a) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), o = Ut(o) && !isNaN(o) ? o : +n.startOf(Date.now(), r), i = Ut(i) && !isNaN(i) ? i : +n.endOf(Date.now(), r) + 1, this.min = Math.min(o, i - 1), this.max = Math.max(o + 1, i);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, r = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], r = t[t.length - 1]), {
      min: n,
      max: r
    };
  }
  buildTicks() {
    const t = this.options, n = t.time, r = t.ticks, o = r.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && o.length && (this.min = this._userMin || o[0], this.max = this._userMax || o[o.length - 1]);
    const i = this.min, s = this.max, a = BO(o, i, s);
    return this._unit = n.unit || (r.autoSkip ? pm(n.minUnit, this.min, this.max, this._getLabelCapacity(i)) : CP(this, a.length, n.minUnit, this.min, this.max)), this._majorUnit = !r.major.enabled || this._unit === "year" ? void 0 : _P(this._unit), this.initOffsets(o), t.reverse && a.reverse(), mm(this, a, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let n = 0, r = 0, o, i;
    this.options.offset && t.length && (o = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - o : n = (this.getDecimalForValue(t[1]) - o) / 2, i = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? r = i : r = (i - this.getDecimalForValue(t[t.length - 2])) / 2);
    const s = t.length < 3 ? 0.5 : 0.25;
    n = Zt(n, 0, s), r = Zt(r, 0, s), this._offsets = {
      start: n,
      end: r,
      factor: 1 / (n + 1 + r)
    };
  }
  _generate() {
    const t = this._adapter, n = this.min, r = this.max, o = this.options, i = o.time, s = i.unit || pm(i.minUnit, n, r, this._getLabelCapacity(n)), a = et(o.ticks.stepSize, 1), l = s === "week" ? i.isoWeekday : !1, c = gs(l) || l === !0, u = {};
    let d = n, f, h;
    if (c && (d = +t.startOf(d, "isoWeek", l)), d = +t.startOf(d, c ? "day" : s), t.diff(r, n, s) > 1e5 * a)
      throw new Error(n + " and " + r + " are too far apart with stepSize of " + a + " " + s);
    const p = o.ticks.source === "data" && this.getDataTimestamps();
    for (f = d, h = 0; f < r; f = +t.add(f, a, s), h++)
      gm(u, f, p);
    return (f === r || o.bounds === "ticks" || h === 1) && gm(u, f, p), Object.keys(u).sort(fm).map((g) => +g);
  }
  getLabelForValue(t) {
    const n = this._adapter, r = this.options.time;
    return r.tooltipFormat ? n.format(t, r.tooltipFormat) : n.format(t, r.displayFormats.datetime);
  }
  format(t, n) {
    const o = this.options.time.displayFormats, i = this._unit, s = n || o[i];
    return this._adapter.format(t, s);
  }
  _tickFormatFunction(t, n, r, o) {
    const i = this.options, s = i.ticks.callback;
    if (s)
      return Mt(s, [
        t,
        n,
        r
      ], this);
    const a = i.time.displayFormats, l = this._unit, c = this._majorUnit, u = l && a[l], d = c && a[c], f = r[n], h = c && d && f && f.major;
    return this._adapter.format(t, o || (h ? d : u));
  }
  generateTickLabels(t) {
    let n, r, o;
    for (n = 0, r = t.length; n < r; ++n)
      o = t[n], o.label = this._tickFormatFunction(o.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, r = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + r) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, r = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + r * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, r = this.ctx.measureText(t).width, o = Zn(this.isHorizontal() ? n.maxRotation : n.minRotation), i = Math.cos(o), s = Math.sin(o), a = this._resolveTickFontOptions(0).size;
    return {
      w: r * i + a * s,
      h: r * s + a * i
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, r = n.displayFormats, o = r[n.unit] || r.millisecond, i = this._tickFormatFunction(t, 0, mm(this, [
      t
    ], this._majorUnit), o), s = this._getLabelSize(i), a = Math.floor(this.isHorizontal() ? this.width / s.w : this.height / s.h) - 1;
    return a > 0 ? a : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, r;
    if (t.length)
      return t;
    const o = this.getMatchingVisibleMetas();
    if (this._normalized && o.length)
      return this._cache.data = o[0].controller.getAllParsedValues(this);
    for (n = 0, r = o.length; n < r; ++n)
      t = t.concat(o[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, r;
    if (t.length)
      return t;
    const o = this.getLabels();
    for (n = 0, r = o.length; n < r; ++n)
      t.push(hm(this, o[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return O0(t.sort(fm));
  }
}
ae(ys, "id", "time"), ae(ys, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function _a(e, t, n) {
  let r = 0, o = e.length - 1, i, s, a, l;
  n ? (t >= e[r].pos && t <= e[o].pos && ({ lo: r, hi: o } = go(e, "pos", t)), { pos: i, time: a } = e[r], { pos: s, time: l } = e[o]) : (t >= e[r].time && t <= e[o].time && ({ lo: r, hi: o } = go(e, "time", t)), { time: i, pos: a } = e[r], { time: s, pos: l } = e[o]);
  const c = s - i;
  return c ? a + (l - a) * (t - i) / c : a;
}
class vm extends ys {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = _a(n, this.min), this._tableRange = _a(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: r } = this, o = [], i = [];
    let s, a, l, c, u;
    for (s = 0, a = t.length; s < a; ++s)
      c = t[s], c >= n && c <= r && o.push(c);
    if (o.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: r,
          pos: 1
        }
      ];
    for (s = 0, a = o.length; s < a; ++s)
      u = o[s + 1], l = o[s - 1], c = o[s], Math.round((u + l) / 2) !== c && i.push({
        time: c,
        pos: s / (a - 1)
      });
    return i;
  }
  _generate() {
    const t = this.min, n = this.max;
    let r = super.getDataTimestamps();
    return (!r.includes(t) || !r.length) && r.splice(0, 0, t), (!r.includes(n) || r.length === 1) && r.push(n), r.sort((o, i) => o - i);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), r = this.getLabelTimestamps();
    return n.length && r.length ? t = this.normalize(n.concat(r)) : t = n.length ? n : r, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (_a(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, r = this.getDecimalForPixel(t) / n.factor - n.end;
    return _a(this._table, r * this._tableRange + this._minPos, !0);
  }
}
ae(vm, "id", "timeseries"), ae(vm, "defaults", ys.defaults);
function zn(e) {
  "@babel/helpers - typeof";
  return zn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zn(e);
}
function at(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function pe(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function we(e) {
  pe(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || zn(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function bn(e, t) {
  pe(2, arguments);
  var n = we(e), r = at(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Nn(e, t) {
  pe(2, arguments);
  var n = we(e), r = at(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var o = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var s = i.getDate();
  return o >= s ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), o), n);
}
function As(e, t) {
  pe(2, arguments);
  var n = we(e).getTime(), r = at(t);
  return new Date(n + r);
}
var SP = 36e5;
function MP(e, t) {
  pe(2, arguments);
  var n = at(t);
  return As(e, n * SP);
}
var OP = {};
function cr() {
  return OP;
}
function Dn(e, t) {
  var n, r, o, i, s, a, l, c;
  pe(1, arguments);
  var u = cr(), d = at((n = (r = (o = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (s = t.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = we(e), h = f.getDay(), p = (h < d ? 7 : 0) + h - d;
  return f.setDate(f.getDate() - p), f.setHours(0, 0, 0, 0), f;
}
function Ro(e) {
  return pe(1, arguments), Dn(e, {
    weekStartsOn: 1
  });
}
function RP(e) {
  pe(1, arguments);
  var t = we(e), n = t.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var o = Ro(r), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  var s = Ro(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function TP(e) {
  pe(1, arguments);
  var t = RP(e), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0);
  var r = Ro(n);
  return r;
}
function hi(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function To(e) {
  pe(1, arguments);
  var t = we(e);
  return t.setHours(0, 0, 0, 0), t;
}
var kP = 864e5;
function Rn(e, t) {
  pe(2, arguments);
  var n = To(e), r = To(t), o = n.getTime() - hi(n), i = r.getTime() - hi(r);
  return Math.round((o - i) / kP);
}
var PP = 6e4;
function IP(e, t) {
  pe(2, arguments);
  var n = at(t);
  return As(e, n * PP);
}
function NP(e, t) {
  pe(2, arguments);
  var n = at(t), r = n * 3;
  return Nn(e, r);
}
function DP(e, t) {
  pe(2, arguments);
  var n = at(t);
  return As(e, n * 1e3);
}
function Sl(e, t) {
  pe(2, arguments);
  var n = at(t), r = n * 7;
  return bn(e, r);
}
function iy(e, t) {
  pe(2, arguments);
  var n = at(t);
  return Nn(e, n * 12);
}
function AP(e) {
  pe(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (zn(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return t.forEach(function(r) {
    var o = we(r);
    (n === void 0 || n < o || isNaN(Number(o))) && (n = o);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function LP(e) {
  pe(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (zn(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return t.forEach(function(r) {
    var o = we(r);
    (n === void 0 || n > o || isNaN(o.getDate())) && (n = o);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function os(e, t) {
  pe(2, arguments);
  var n = we(e), r = we(t), o = n.getTime() - r.getTime();
  return o < 0 ? -1 : o > 0 ? 1 : o;
}
var yc = 6e4, xc = 36e5, $P = 1e3;
function an(e, t) {
  pe(2, arguments);
  var n = To(e), r = To(t);
  return n.getTime() === r.getTime();
}
function jf(e) {
  return pe(1, arguments), e instanceof Date || zn(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Uf(e) {
  if (pe(1, arguments), !jf(e) && typeof e != "number")
    return !1;
  var t = we(e);
  return !isNaN(Number(t));
}
function pi(e, t) {
  pe(2, arguments);
  var n = we(e), r = we(t), o = n.getFullYear() - r.getFullYear(), i = n.getMonth() - r.getMonth();
  return o * 12 + i;
}
var FP = 6048e5;
function VP(e, t, n) {
  pe(2, arguments);
  var r = Dn(e, n), o = Dn(t, n), i = r.getTime() - hi(r), s = o.getTime() - hi(o);
  return Math.round((i - s) / FP);
}
function BP(e, t) {
  pe(2, arguments);
  var n = we(e), r = we(t);
  return n.getFullYear() - r.getFullYear();
}
function bm(e, t) {
  var n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function sy(e, t) {
  pe(2, arguments);
  var n = we(e), r = we(t), o = bm(n, r), i = Math.abs(Rn(n, r));
  n.setDate(n.getDate() - o * i);
  var s = +(bm(n, r) === -o), a = o * (i - s);
  return a === 0 ? 0 : a;
}
function wc(e, t) {
  return pe(2, arguments), we(e).getTime() - we(t).getTime();
}
var ym = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, HP = "trunc";
function Ls(e) {
  return e ? ym[e] : ym[HP];
}
function WP(e, t, n) {
  pe(2, arguments);
  var r = wc(e, t) / xc;
  return Ls(n == null ? void 0 : n.roundingMethod)(r);
}
function zP(e, t, n) {
  pe(2, arguments);
  var r = wc(e, t) / yc;
  return Ls(n == null ? void 0 : n.roundingMethod)(r);
}
function ay(e) {
  pe(1, arguments);
  var t = we(e);
  return t.setHours(23, 59, 59, 999), t;
}
function $s(e) {
  pe(1, arguments);
  var t = we(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function jP(e) {
  pe(1, arguments);
  var t = we(e);
  return ay(t).getTime() === $s(t).getTime();
}
function ly(e, t) {
  pe(2, arguments);
  var n = we(e), r = we(t), o = os(n, r), i = Math.abs(pi(n, r)), s;
  if (i < 1)
    s = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - o * i);
    var a = os(n, r) === -o;
    jP(we(e)) && i === 1 && os(e, r) === 1 && (a = !1), s = o * (i - Number(a));
  }
  return s === 0 ? 0 : s;
}
function UP(e, t, n) {
  pe(2, arguments);
  var r = ly(e, t) / 3;
  return Ls(n == null ? void 0 : n.roundingMethod)(r);
}
function YP(e, t, n) {
  pe(2, arguments);
  var r = wc(e, t) / 1e3;
  return Ls(n == null ? void 0 : n.roundingMethod)(r);
}
function GP(e, t, n) {
  pe(2, arguments);
  var r = sy(e, t) / 7;
  return Ls(n == null ? void 0 : n.roundingMethod)(r);
}
function KP(e, t) {
  pe(2, arguments);
  var n = we(e), r = we(t), o = os(n, r), i = Math.abs(BP(n, r));
  n.setFullYear(1584), r.setFullYear(1584);
  var s = os(n, r) === -o, a = o * (i - Number(s));
  return a === 0 ? 0 : a;
}
function qP(e) {
  pe(1, arguments);
  var t = we(e);
  return t.setSeconds(0, 0), t;
}
function XP(e) {
  pe(1, arguments);
  var t = we(e), n = t.getMonth(), r = n - n % 3;
  return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
}
function en(e) {
  pe(1, arguments);
  var t = we(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function ZP(e) {
  pe(1, arguments);
  var t = we(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function cy(e) {
  pe(1, arguments);
  var t = we(e), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function QP(e) {
  pe(1, arguments);
  var t = we(e);
  return t.setMinutes(59, 59, 999), t;
}
function Cc(e, t) {
  var n, r, o, i, s, a, l, c;
  pe(1, arguments);
  var u = cr(), d = at((n = (r = (o = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (s = t.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = we(e), h = f.getDay(), p = (h < d ? -7 : 0) + 6 - (h - d);
  return f.setDate(f.getDate() + p), f.setHours(23, 59, 59, 999), f;
}
function uy(e) {
  return pe(1, arguments), Cc(e, {
    weekStartsOn: 1
  });
}
function JP(e) {
  pe(1, arguments);
  var t = we(e);
  return t.setSeconds(59, 999), t;
}
function eI(e) {
  pe(1, arguments);
  var t = we(e), n = t.getMonth(), r = n - n % 3 + 3;
  return t.setMonth(r, 0), t.setHours(23, 59, 59, 999), t;
}
function tI(e) {
  pe(1, arguments);
  var t = we(e);
  return t.setMilliseconds(999), t;
}
function dy(e, t) {
  pe(2, arguments);
  var n = at(t);
  return As(e, -n);
}
var nI = 864e5;
function rI(e) {
  pe(1, arguments);
  var t = we(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), o = n - r;
  return Math.floor(o / nI) + 1;
}
function gi(e) {
  pe(1, arguments);
  var t = 1, n = we(e), r = n.getUTCDay(), o = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function fy(e) {
  pe(1, arguments);
  var t = we(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = gi(r), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var s = gi(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function oI(e) {
  pe(1, arguments);
  var t = fy(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = gi(n);
  return r;
}
var iI = 6048e5;
function hy(e) {
  pe(1, arguments);
  var t = we(e), n = gi(t).getTime() - oI(t).getTime();
  return Math.round(n / iI) + 1;
}
function ko(e, t) {
  var n, r, o, i, s, a, l, c;
  pe(1, arguments);
  var u = cr(), d = at((n = (r = (o = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (s = t.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = we(e), h = f.getUTCDay(), p = (h < d ? 7 : 0) + h - d;
  return f.setUTCDate(f.getUTCDate() - p), f.setUTCHours(0, 0, 0, 0), f;
}
function Yf(e, t) {
  var n, r, o, i, s, a, l, c;
  pe(1, arguments);
  var u = we(e), d = u.getUTCFullYear(), f = cr(), h = at((n = (r = (o = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (s = t.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(d + 1, 0, h), p.setUTCHours(0, 0, 0, 0);
  var g = ko(p, t), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(d, 0, h), v.setUTCHours(0, 0, 0, 0);
  var y = ko(v, t);
  return u.getTime() >= g.getTime() ? d + 1 : u.getTime() >= y.getTime() ? d : d - 1;
}
function sI(e, t) {
  var n, r, o, i, s, a, l, c;
  pe(1, arguments);
  var u = cr(), d = at((n = (r = (o = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (s = t.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = Yf(e, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(f, 0, d), h.setUTCHours(0, 0, 0, 0);
  var p = ko(h, t);
  return p;
}
var aI = 6048e5;
function py(e, t) {
  pe(1, arguments);
  var n = we(e), r = ko(n, t).getTime() - sI(n, t).getTime();
  return Math.round(r / aI) + 1;
}
function lt(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var lI = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), o = r > 0 ? r : 1 - r;
    return lt(n === "yy" ? o % 100 : o, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : lt(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return lt(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return lt(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return lt(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return lt(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return lt(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, o = t.getUTCMilliseconds(), i = Math.floor(o * Math.pow(10, r - 3));
    return lt(i, n.length);
  }
};
const Nr = lI;
var jo = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, cI = {
  // Era
  G: function(t, n, r) {
    var o = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(o, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(o, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(o, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var o = t.getUTCFullYear(), i = o > 0 ? o : 1 - o;
      return r.ordinalNumber(i, {
        unit: "year"
      });
    }
    return Nr.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, o) {
    var i = Yf(t, o), s = i > 0 ? i : 1 - i;
    if (n === "YY") {
      var a = s % 100;
      return lt(a, 2);
    }
    return n === "Yo" ? r.ordinalNumber(s, {
      unit: "year"
    }) : lt(s, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = fy(t);
    return lt(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return lt(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(o);
      case "QQ":
        return lt(o, 2);
      case "Qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(o);
      case "qq":
        return lt(o, 2);
      case "qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Nr.M(t, n);
      case "Mo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(o + 1);
      case "LL":
        return lt(o + 1, 2);
      case "Lo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, o) {
    var i = py(t, o);
    return n === "wo" ? r.ordinalNumber(i, {
      unit: "week"
    }) : lt(i, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var o = hy(t);
    return n === "Io" ? r.ordinalNumber(o, {
      unit: "week"
    }) : lt(o, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Nr.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var o = rI(t);
    return n === "Do" ? r.ordinalNumber(o, {
      unit: "dayOfYear"
    }) : lt(o, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var o = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, o) {
    var i = t.getUTCDay(), s = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(s);
      case "ee":
        return lt(s, 2);
      case "eo":
        return r.ordinalNumber(s, {
          unit: "day"
        });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, o) {
    var i = t.getUTCDay(), s = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(s);
      case "cc":
        return lt(s, n.length);
      case "co":
        return r.ordinalNumber(s, {
          unit: "day"
        });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var o = t.getUTCDay(), i = o === 0 ? 7 : o;
    switch (n) {
      case "i":
        return String(i);
      case "ii":
        return lt(i, n.length);
      case "io":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var o = t.getUTCHours(), i = o / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var o = t.getUTCHours(), i;
    switch (o === 12 ? i = jo.noon : o === 0 ? i = jo.midnight : i = o / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var o = t.getUTCHours(), i;
    switch (o >= 17 ? i = jo.evening : o >= 12 ? i = jo.afternoon : o >= 4 ? i = jo.morning : i = jo.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var o = t.getUTCHours() % 12;
      return o === 0 && (o = 12), r.ordinalNumber(o, {
        unit: "hour"
      });
    }
    return Nr.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Nr.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var o = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : lt(o, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var o = t.getUTCHours();
    return o === 0 && (o = 24), n === "ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : lt(o, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Nr.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Nr.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return Nr.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, o) {
    var i = o._originalDate || t, s = i.getTimezoneOffset();
    if (s === 0)
      return "Z";
    switch (n) {
      case "X":
        return wm(s);
      case "XXXX":
      case "XX":
        return uo(s);
      case "XXXXX":
      case "XXX":
      default:
        return uo(s, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, o) {
    var i = o._originalDate || t, s = i.getTimezoneOffset();
    switch (n) {
      case "x":
        return wm(s);
      case "xxxx":
      case "xx":
        return uo(s);
      case "xxxxx":
      case "xxx":
      default:
        return uo(s, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, o) {
    var i = o._originalDate || t, s = i.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + xm(s, ":");
      case "OOOO":
      default:
        return "GMT" + uo(s, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, o) {
    var i = o._originalDate || t, s = i.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + xm(s, ":");
      case "zzzz":
      default:
        return "GMT" + uo(s, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, o) {
    var i = o._originalDate || t, s = Math.floor(i.getTime() / 1e3);
    return lt(s, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, o) {
    var i = o._originalDate || t, s = i.getTime();
    return lt(s, n.length);
  }
};
function xm(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(o);
  var s = t || "";
  return n + String(o) + s + lt(i, 2);
}
function wm(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + lt(Math.abs(e) / 60, 2);
  }
  return uo(e, t);
}
function uo(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", o = Math.abs(e), i = lt(Math.floor(o / 60), 2), s = lt(o % 60, 2);
  return r + i + n + s;
}
const uI = cI;
var Cm = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, gy = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, dI = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], o = r[1], i = r[2];
  if (!i)
    return Cm(t, n);
  var s;
  switch (o) {
    case "P":
      s = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      s = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      s = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      s = n.dateTime({
        width: "full"
      });
      break;
  }
  return s.replace("{{date}}", Cm(o, n)).replace("{{time}}", gy(i, n));
}, fI = {
  p: gy,
  P: dI
};
const dd = fI;
var hI = ["D", "DD"], pI = ["YY", "YYYY"];
function my(e) {
  return hI.indexOf(e) !== -1;
}
function vy(e) {
  return pI.indexOf(e) !== -1;
}
function Ml(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var gI = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, mI = function(t, n, r) {
  var o, i = gI[t];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
const vI = mI;
function cu(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var bI = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, yI = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, xI = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, wI = {
  date: cu({
    formats: bI,
    defaultWidth: "full"
  }),
  time: cu({
    formats: yI,
    defaultWidth: "full"
  }),
  dateTime: cu({
    formats: xI,
    defaultWidth: "full"
  })
};
const CI = wI;
var _I = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, EI = function(t, n, r, o) {
  return _I[t];
};
const SI = EI;
function Fi(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", o;
    if (r === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : i;
      o = e.formattingValues[s] || e.formattingValues[i];
    } else {
      var a = e.defaultWidth, l = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[l] || e.values[a];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[c];
  };
}
var MI = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, OI = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, RI = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, TI = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, kI = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, PI = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, II = function(t, n) {
  var r = Number(t), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, NI = {
  ordinalNumber: II,
  era: Fi({
    values: MI,
    defaultWidth: "wide"
  }),
  quarter: Fi({
    values: OI,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Fi({
    values: RI,
    defaultWidth: "wide"
  }),
  day: Fi({
    values: TI,
    defaultWidth: "wide"
  }),
  dayPeriod: Fi({
    values: kI,
    defaultWidth: "wide",
    formattingValues: PI,
    defaultFormattingWidth: "wide"
  })
};
const DI = NI;
function Vi(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    var s = i[0], a = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(a) ? LI(a, function(d) {
      return d.test(s);
    }) : AI(a, function(d) {
      return d.test(s);
    }), c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var u = t.slice(s.length);
    return {
      value: c,
      rest: u
    };
  };
}
function AI(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function LI(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function $I(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var o = r[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    var s = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    var a = t.slice(o.length);
    return {
      value: s,
      rest: a
    };
  };
}
var FI = /^(\d+)(th|st|nd|rd)?/i, VI = /\d+/i, BI = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, HI = {
  any: [/^b/i, /^(a|c)/i]
}, WI = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, zI = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, jI = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, UI = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, YI = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, GI = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, KI = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, qI = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, XI = {
  ordinalNumber: $I({
    matchPattern: FI,
    parsePattern: VI,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Vi({
    matchPatterns: BI,
    defaultMatchWidth: "wide",
    parsePatterns: HI,
    defaultParseWidth: "any"
  }),
  quarter: Vi({
    matchPatterns: WI,
    defaultMatchWidth: "wide",
    parsePatterns: zI,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Vi({
    matchPatterns: jI,
    defaultMatchWidth: "wide",
    parsePatterns: UI,
    defaultParseWidth: "any"
  }),
  day: Vi({
    matchPatterns: YI,
    defaultMatchWidth: "wide",
    parsePatterns: GI,
    defaultParseWidth: "any"
  }),
  dayPeriod: Vi({
    matchPatterns: KI,
    defaultMatchWidth: "any",
    parsePatterns: qI,
    defaultParseWidth: "any"
  })
};
const ZI = XI;
var QI = {
  code: "en-US",
  formatDistance: vI,
  formatLong: CI,
  formatRelative: SI,
  localize: DI,
  match: ZI,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Gf = QI;
var JI = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, e5 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, t5 = /^'([^]*?)'?$/, n5 = /''/g, r5 = /[a-zA-Z]/;
function Qt(e, t, n) {
  var r, o, i, s, a, l, c, u, d, f, h, p, g, v, y, b, w, C;
  pe(2, arguments);
  var x = String(t), E = cr(), S = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : E.locale) !== null && r !== void 0 ? r : Gf, R = at((i = (s = (a = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (c = n.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : E.firstWeekContainsDate) !== null && s !== void 0 ? s : (d = E.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(R >= 1 && R <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var M = at((h = (p = (g = (v = n == null ? void 0 : n.weekStartsOn) !== null && v !== void 0 ? v : n == null || (y = n.locale) === null || y === void 0 || (b = y.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && g !== void 0 ? g : E.weekStartsOn) !== null && p !== void 0 ? p : (w = E.locale) === null || w === void 0 || (C = w.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(M >= 0 && M <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!S.localize)
    throw new RangeError("locale must contain localize property");
  if (!S.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var I = we(e);
  if (!Uf(I))
    throw new RangeError("Invalid time value");
  var P = hi(I), k = dy(I, P), O = {
    firstWeekContainsDate: R,
    weekStartsOn: M,
    locale: S,
    _originalDate: I
  }, F = x.match(e5).map(function(T) {
    var L = T[0];
    if (L === "p" || L === "P") {
      var A = dd[L];
      return A(T, S.formatLong);
    }
    return T;
  }).join("").match(JI).map(function(T) {
    if (T === "''")
      return "'";
    var L = T[0];
    if (L === "'")
      return o5(T);
    var A = uI[L];
    if (A)
      return !(n != null && n.useAdditionalWeekYearTokens) && vy(T) && Ml(T, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && my(T) && Ml(T, t, String(e)), A(k, T, S.localize, O);
    if (L.match(r5))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + L + "`");
    return T;
  }).join("");
  return F;
}
function o5(e) {
  var t = e.match(t5);
  return t ? t[1].replace(n5, "'") : e;
}
function i5(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function s5(e) {
  pe(1, arguments);
  var t = we(e), n = t.getFullYear(), r = t.getMonth(), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
var a5 = 6048e5;
function l5(e) {
  pe(1, arguments);
  var t = we(e), n = Ro(t).getTime() - TP(t).getTime();
  return Math.round(n / a5) + 1;
}
function c5(e) {
  pe(1, arguments);
  var t = we(e), n = t.getTime();
  return n;
}
function u5(e) {
  return pe(1, arguments), Math.floor(c5(e) / 1e3);
}
function d5(e, t) {
  var n, r, o, i, s, a, l, c;
  pe(1, arguments);
  var u = we(e), d = u.getFullYear(), f = cr(), h = at((n = (r = (o = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (s = t.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setFullYear(d + 1, 0, h), p.setHours(0, 0, 0, 0);
  var g = Dn(p, t), v = /* @__PURE__ */ new Date(0);
  v.setFullYear(d, 0, h), v.setHours(0, 0, 0, 0);
  var y = Dn(v, t);
  return u.getTime() >= g.getTime() ? d + 1 : u.getTime() >= y.getTime() ? d : d - 1;
}
function f5(e, t) {
  var n, r, o, i, s, a, l, c;
  pe(1, arguments);
  var u = cr(), d = at((n = (r = (o = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (s = t.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = d5(e, t), h = /* @__PURE__ */ new Date(0);
  h.setFullYear(f, 0, d), h.setHours(0, 0, 0, 0);
  var p = Dn(h, t);
  return p;
}
var h5 = 6048e5;
function p5(e, t) {
  pe(1, arguments);
  var n = we(e), r = Dn(n, t).getTime() - f5(n, t).getTime();
  return Math.round(r / h5) + 1;
}
function g5(e) {
  pe(1, arguments);
  var t = we(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function m5(e, t) {
  return pe(1, arguments), VP(g5(e), en(e), t) + 1;
}
function by(e, t) {
  pe(2, arguments);
  var n = we(e), r = we(t);
  return n.getTime() > r.getTime();
}
function yy(e, t) {
  pe(2, arguments);
  var n = we(e), r = we(t);
  return n.getTime() < r.getTime();
}
function _m(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function v5(e, t) {
  if (e) {
    if (typeof e == "string")
      return _m(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _m(e, t);
  }
}
function Em(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = v5(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, o = function() {
      };
      return {
        s: o,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: o
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, s = !1, a;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var c = n.next();
      return i = c.done, c;
    },
    e: function(c) {
      s = !0, a = c;
    },
    f: function() {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (s)
          throw a;
      }
    }
  };
}
function _e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fd(e, t) {
  return fd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, fd(e, t);
}
function Ze(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && fd(e, t);
}
function Ol(e) {
  return Ol = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ol(e);
}
function b5() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function y5(e, t) {
  if (t && (zn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _e(e);
}
function Qe(e) {
  var t = b5();
  return function() {
    var r = Ol(e), o;
    if (t) {
      var i = Ol(this).constructor;
      o = Reflect.construct(r, arguments, i);
    } else
      o = r.apply(this, arguments);
    return y5(this, o);
  };
}
function je(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function x5(e, t) {
  if (zn(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (zn(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function xy(e) {
  var t = x5(e, "string");
  return zn(t) === "symbol" ? t : String(t);
}
function Sm(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, xy(r.key), r);
  }
}
function Ue(e, t, n) {
  return t && Sm(e.prototype, t), n && Sm(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function xe(e, t, n) {
  return t = xy(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var w5 = 10, wy = /* @__PURE__ */ function() {
  function e() {
    je(this, e), xe(this, "priority", void 0), xe(this, "subPriority", 0);
  }
  return Ue(e, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), e;
}(), C5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n(r, o, i, s, a) {
    var l;
    return je(this, n), l = t.call(this), l.value = r, l.validateValue = o, l.setValue = i, l.priority = s, a && (l.subPriority = a), l;
  }
  return Ue(n, [{
    key: "validate",
    value: function(o, i) {
      return this.validateValue(o, this.value, i);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return this.setValue(o, i, this.value, s);
    }
  }]), n;
}(wy), _5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", w5), xe(_e(r), "subPriority", -1), r;
  }
  return Ue(n, [{
    key: "set",
    value: function(o, i) {
      if (i.timestampIsSet)
        return o;
      var s = /* @__PURE__ */ new Date(0);
      return s.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), s.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), s;
    }
  }]), n;
}(wy), tt = /* @__PURE__ */ function() {
  function e() {
    je(this, e), xe(this, "incompatibleTokens", void 0), xe(this, "priority", void 0), xe(this, "subPriority", void 0);
  }
  return Ue(e, [{
    key: "run",
    value: function(n, r, o, i) {
      var s = this.parse(n, r, o, i);
      return s ? {
        setter: new C5(s.value, this.validate, this.set, this.priority, this.subPriority),
        rest: s.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, o) {
      return !0;
    }
  }]), e;
}(), E5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 140), xe(_e(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return s.era(o, {
            width: "abbreviated"
          }) || s.era(o, {
            width: "narrow"
          });
        case "GGGGG":
          return s.era(o, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return s.era(o, {
            width: "wide"
          }) || s.era(o, {
            width: "abbreviated"
          }) || s.era(o, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return i.era = s, o.setUTCFullYear(s, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt), Lt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Kn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function $t(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function _t(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function qn(e, t) {
  var n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, s = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * xc + i * yc + s * $P),
    rest: t.slice(n[0].length)
  };
}
function Cy(e) {
  return _t(Lt.anyDigitsSigned, e);
}
function kt(e, t) {
  switch (e) {
    case 1:
      return _t(Lt.singleDigit, t);
    case 2:
      return _t(Lt.twoDigits, t);
    case 3:
      return _t(Lt.threeDigits, t);
    case 4:
      return _t(Lt.fourDigits, t);
    default:
      return _t(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Rl(e, t) {
  switch (e) {
    case 1:
      return _t(Lt.singleDigitSigned, t);
    case 2:
      return _t(Lt.twoDigitsSigned, t);
    case 3:
      return _t(Lt.threeDigitsSigned, t);
    case 4:
      return _t(Lt.fourDigitsSigned, t);
    default:
      return _t(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Kf(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function _y(e, t) {
  var n = t > 0, r = n ? t : 1 - t, o;
  if (r <= 50)
    o = e || 100;
  else {
    var i = r + 50, s = Math.floor(i / 100) * 100, a = e >= i % 100;
    o = e + s - (a ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function Ey(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var S5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 130), xe(_e(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return $t(kt(4, o), a);
        case "yo":
          return $t(s.ordinalNumber(o, {
            unit: "year"
          }), a);
        default:
          return $t(kt(i.length, o), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = o.getUTCFullYear();
      if (s.isTwoDigitYear) {
        var l = _y(s.year, a);
        return o.setUTCFullYear(l, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
      var c = !("era" in i) || i.era === 1 ? s.year : 1 - s.year;
      return o.setUTCFullYear(c, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt), M5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 130), xe(_e(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return $t(kt(4, o), a);
        case "Yo":
          return $t(s.ordinalNumber(o, {
            unit: "year"
          }), a);
        default:
          return $t(kt(i.length, o), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      var l = Yf(o, a);
      if (s.isTwoDigitYear) {
        var c = _y(s.year, l);
        return o.setUTCFullYear(c, 0, a.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), ko(o, a);
      }
      var u = !("era" in i) || i.era === 1 ? s.year : 1 - s.year;
      return o.setUTCFullYear(u, 0, a.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), ko(o, a);
    }
  }]), n;
}(tt), O5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 130), xe(_e(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i) {
      return Rl(i === "R" ? 4 : i.length, o);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = /* @__PURE__ */ new Date(0);
      return a.setUTCFullYear(s, 0, 4), a.setUTCHours(0, 0, 0, 0), gi(a);
    }
  }]), n;
}(tt), R5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 130), xe(_e(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i) {
      return Rl(i === "u" ? 4 : i.length, o);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCFullYear(s, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt), T5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 120), xe(_e(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "Q":
        case "QQ":
          return kt(i.length, o);
        case "Qo":
          return s.ordinalNumber(o, {
            unit: "quarter"
          });
        case "QQQ":
          return s.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return s.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return s.quarter(o, {
            width: "wide",
            context: "formatting"
          }) || s.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth((s - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt), k5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 120), xe(_e(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "q":
        case "qq":
          return kt(i.length, o);
        case "qo":
          return s.ordinalNumber(o, {
            unit: "quarter"
          });
        case "qqq":
          return s.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return s.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return s.quarter(o, {
            width: "wide",
            context: "standalone"
          }) || s.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth((s - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt), P5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), xe(_e(r), "priority", 110), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return c - 1;
      };
      switch (i) {
        case "M":
          return $t(_t(Lt.month, o), a);
        case "MM":
          return $t(kt(2, o), a);
        case "Mo":
          return $t(s.ordinalNumber(o, {
            unit: "month"
          }), a);
        case "MMM":
          return s.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return s.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return s.month(o, {
            width: "wide",
            context: "formatting"
          }) || s.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth(s, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt), I5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 110), xe(_e(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return c - 1;
      };
      switch (i) {
        case "L":
          return $t(_t(Lt.month, o), a);
        case "LL":
          return $t(kt(2, o), a);
        case "Lo":
          return $t(s.ordinalNumber(o, {
            unit: "month"
          }), a);
        case "LLL":
          return s.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return s.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return s.month(o, {
            width: "wide",
            context: "standalone"
          }) || s.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth(s, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt);
function N5(e, t, n) {
  pe(2, arguments);
  var r = we(e), o = at(t), i = py(r, n) - o;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
var D5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 100), xe(_e(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "w":
          return _t(Lt.week, o);
        case "wo":
          return s.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return kt(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      return ko(N5(o, s, a), a);
    }
  }]), n;
}(tt);
function A5(e, t) {
  pe(2, arguments);
  var n = we(e), r = at(t), o = hy(n) - r;
  return n.setUTCDate(n.getUTCDate() - o * 7), n;
}
var L5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 100), xe(_e(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "I":
          return _t(Lt.week, o);
        case "Io":
          return s.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return kt(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return gi(A5(o, s));
    }
  }]), n;
}(tt), $5 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], F5 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], V5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 90), xe(_e(r), "subPriority", 1), xe(_e(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "d":
          return _t(Lt.date, o);
        case "do":
          return s.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return kt(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      var s = o.getUTCFullYear(), a = Ey(s), l = o.getUTCMonth();
      return a ? i >= 1 && i <= F5[l] : i >= 1 && i <= $5[l];
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCDate(s), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt), B5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 90), xe(_e(r), "subpriority", 1), xe(_e(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "D":
        case "DD":
          return _t(Lt.dayOfYear, o);
        case "Do":
          return s.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return kt(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      var s = o.getUTCFullYear(), a = Ey(s);
      return a ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth(0, s), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt);
function qf(e, t, n) {
  var r, o, i, s, a, l, c, u;
  pe(2, arguments);
  var d = cr(), f = at((r = (o = (i = (s = n == null ? void 0 : n.weekStartsOn) !== null && s !== void 0 ? s : n == null || (a = n.locale) === null || a === void 0 || (l = a.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && o !== void 0 ? o : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = we(e), p = at(t), g = h.getUTCDay(), v = p % 7, y = (v + 7) % 7, b = (y < f ? 7 : 0) + p - g;
  return h.setUTCDate(h.getUTCDate() + b), h;
}
var H5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 90), xe(_e(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return s.day(o, {
            width: "wide",
            context: "formatting"
          }) || s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      return o = qf(o, s, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt), W5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 90), xe(_e(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s, a) {
      var l = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + a.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        case "e":
        case "ee":
          return $t(kt(i.length, o), l);
        case "eo":
          return $t(s.ordinalNumber(o, {
            unit: "day"
          }), l);
        case "eee":
          return s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return s.day(o, {
            width: "wide",
            context: "formatting"
          }) || s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      return o = qf(o, s, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt), z5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 90), xe(_e(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s, a) {
      var l = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + a.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        case "c":
        case "cc":
          return $t(kt(i.length, o), l);
        case "co":
          return $t(s.ordinalNumber(o, {
            unit: "day"
          }), l);
        case "ccc":
          return s.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(o, {
            width: "short",
            context: "standalone"
          }) || s.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return s.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return s.day(o, {
            width: "short",
            context: "standalone"
          }) || s.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return s.day(o, {
            width: "wide",
            context: "standalone"
          }) || s.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(o, {
            width: "short",
            context: "standalone"
          }) || s.day(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      return o = qf(o, s, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt);
function j5(e, t) {
  pe(2, arguments);
  var n = at(t);
  n % 7 === 0 && (n = n - 7);
  var r = 1, o = we(e), i = o.getUTCDay(), s = n % 7, a = (s + 7) % 7, l = (a < r ? 7 : 0) + n - i;
  return o.setUTCDate(o.getUTCDate() + l), o;
}
var U5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 90), xe(_e(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (i) {
        case "i":
        case "ii":
          return kt(i.length, o);
        case "io":
          return s.ordinalNumber(o, {
            unit: "day"
          });
        case "iii":
          return $t(s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiii":
          return $t(s.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiiii":
          return $t(s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiii":
        default:
          return $t(s.day(o, {
            width: "wide",
            context: "formatting"
          }) || s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o = j5(o, s), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(tt), Y5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 80), xe(_e(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return s.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCHours(Kf(s), 0, 0, 0), o;
    }
  }]), n;
}(tt), G5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 80), xe(_e(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return s.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCHours(Kf(s), 0, 0, 0), o;
    }
  }]), n;
}(tt), K5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 80), xe(_e(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return s.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCHours(Kf(s), 0, 0, 0), o;
    }
  }]), n;
}(tt), q5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 70), xe(_e(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "h":
          return _t(Lt.hour12h, o);
        case "ho":
          return s.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return kt(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = o.getUTCHours() >= 12;
      return a && s < 12 ? o.setUTCHours(s + 12, 0, 0, 0) : !a && s === 12 ? o.setUTCHours(0, 0, 0, 0) : o.setUTCHours(s, 0, 0, 0), o;
    }
  }]), n;
}(tt), X5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 70), xe(_e(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "H":
          return _t(Lt.hour23h, o);
        case "Ho":
          return s.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return kt(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCHours(s, 0, 0, 0), o;
    }
  }]), n;
}(tt), Z5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 70), xe(_e(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "K":
          return _t(Lt.hour11h, o);
        case "Ko":
          return s.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return kt(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = o.getUTCHours() >= 12;
      return a && s < 12 ? o.setUTCHours(s + 12, 0, 0, 0) : o.setUTCHours(s, 0, 0, 0), o;
    }
  }]), n;
}(tt), Q5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 70), xe(_e(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "k":
          return _t(Lt.hour24h, o);
        case "ko":
          return s.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return kt(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = s <= 24 ? s % 24 : s;
      return o.setUTCHours(a, 0, 0, 0), o;
    }
  }]), n;
}(tt), J5 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 60), xe(_e(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "m":
          return _t(Lt.minute, o);
        case "mo":
          return s.ordinalNumber(o, {
            unit: "minute"
          });
        default:
          return kt(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMinutes(s, 0, 0), o;
    }
  }]), n;
}(tt), e6 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 50), xe(_e(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "s":
          return _t(Lt.second, o);
        case "so":
          return s.ordinalNumber(o, {
            unit: "second"
          });
        default:
          return kt(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCSeconds(s, 0), o;
    }
  }]), n;
}(tt), t6 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 30), xe(_e(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i) {
      var s = function(l) {
        return Math.floor(l * Math.pow(10, -i.length + 3));
      };
      return $t(kt(i.length, o), s);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMilliseconds(s), o;
    }
  }]), n;
}(tt), n6 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 10), xe(_e(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i) {
      switch (i) {
        case "X":
          return qn(Kn.basicOptionalMinutes, o);
        case "XX":
          return qn(Kn.basic, o);
        case "XXXX":
          return qn(Kn.basicOptionalSeconds, o);
        case "XXXXX":
          return qn(Kn.extendedOptionalSeconds, o);
        case "XXX":
        default:
          return qn(Kn.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return i.timestampIsSet ? o : new Date(o.getTime() - s);
    }
  }]), n;
}(tt), r6 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 10), xe(_e(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i) {
      switch (i) {
        case "x":
          return qn(Kn.basicOptionalMinutes, o);
        case "xx":
          return qn(Kn.basic, o);
        case "xxxx":
          return qn(Kn.basicOptionalSeconds, o);
        case "xxxxx":
          return qn(Kn.extendedOptionalSeconds, o);
        case "xxx":
        default:
          return qn(Kn.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return i.timestampIsSet ? o : new Date(o.getTime() - s);
    }
  }]), n;
}(tt), o6 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 40), xe(_e(r), "incompatibleTokens", "*"), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o) {
      return Cy(o);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return [new Date(s * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(tt), i6 = /* @__PURE__ */ function(e) {
  Ze(n, e);
  var t = Qe(n);
  function n() {
    var r;
    je(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)), xe(_e(r), "priority", 20), xe(_e(r), "incompatibleTokens", "*"), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o) {
      return Cy(o);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return [new Date(s), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(tt), s6 = {
  G: new E5(),
  y: new S5(),
  Y: new M5(),
  R: new O5(),
  u: new R5(),
  Q: new T5(),
  q: new k5(),
  M: new P5(),
  L: new I5(),
  w: new D5(),
  I: new L5(),
  d: new V5(),
  D: new B5(),
  E: new H5(),
  e: new W5(),
  c: new z5(),
  i: new U5(),
  a: new Y5(),
  b: new G5(),
  B: new K5(),
  h: new q5(),
  H: new X5(),
  K: new Z5(),
  k: new Q5(),
  m: new J5(),
  s: new e6(),
  S: new t6(),
  X: new n6(),
  x: new r6(),
  t: new o6(),
  T: new i6()
}, a6 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, l6 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, c6 = /^'([^]*?)'?$/, u6 = /''/g, d6 = /\S/, f6 = /[a-zA-Z]/;
function qo(e, t, n, r) {
  var o, i, s, a, l, c, u, d, f, h, p, g, v, y, b, w, C, x;
  pe(3, arguments);
  var E = String(e), S = String(t), R = cr(), M = (o = (i = r == null ? void 0 : r.locale) !== null && i !== void 0 ? i : R.locale) !== null && o !== void 0 ? o : Gf;
  if (!M.match)
    throw new RangeError("locale must contain match property");
  var I = at((s = (a = (l = (c = r == null ? void 0 : r.firstWeekContainsDate) !== null && c !== void 0 ? c : r == null || (u = r.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : R.firstWeekContainsDate) !== null && a !== void 0 ? a : (f = R.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && s !== void 0 ? s : 1);
  if (!(I >= 1 && I <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var P = at((p = (g = (v = (y = r == null ? void 0 : r.weekStartsOn) !== null && y !== void 0 ? y : r == null || (b = r.locale) === null || b === void 0 || (w = b.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && v !== void 0 ? v : R.weekStartsOn) !== null && g !== void 0 ? g : (C = R.locale) === null || C === void 0 || (x = C.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(P >= 0 && P <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (S === "")
    return E === "" ? we(n) : /* @__PURE__ */ new Date(NaN);
  var k = {
    firstWeekContainsDate: I,
    weekStartsOn: P,
    locale: M
  }, O = [new _5()], F = S.match(l6).map(function(X) {
    var J = X[0];
    if (J in dd) {
      var ne = dd[J];
      return ne(X, M.formatLong);
    }
    return X;
  }).join("").match(a6), T = [], L = Em(F), A;
  try {
    var N = function() {
      var J = A.value;
      !(r != null && r.useAdditionalWeekYearTokens) && vy(J) && Ml(J, S, e), !(r != null && r.useAdditionalDayOfYearTokens) && my(J) && Ml(J, S, e);
      var ne = J[0], Q = s6[ne];
      if (Q) {
        var D = Q.incompatibleTokens;
        if (Array.isArray(D)) {
          var te = T.find(function(ce) {
            return D.includes(ce.token) || ce.token === ne;
          });
          if (te)
            throw new RangeError("The format string mustn't contain `".concat(te.fullToken, "` and `").concat(J, "` at the same time"));
        } else if (Q.incompatibleTokens === "*" && T.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(J, "` and any other token at the same time"));
        T.push({
          token: ne,
          fullToken: J
        });
        var K = Q.run(E, J, M.match, k);
        if (!K)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        O.push(K.setter), E = K.rest;
      } else {
        if (ne.match(f6))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + ne + "`");
        if (J === "''" ? J = "'" : ne === "'" && (J = h6(J)), E.indexOf(J) === 0)
          E = E.slice(J.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (L.s(); !(A = L.n()).done; ) {
      var B = N();
      if (zn(B) === "object")
        return B.v;
    }
  } catch (X) {
    L.e(X);
  } finally {
    L.f();
  }
  if (E.length > 0 && d6.test(E))
    return /* @__PURE__ */ new Date(NaN);
  var $ = O.map(function(X) {
    return X.priority;
  }).sort(function(X, J) {
    return J - X;
  }).filter(function(X, J, ne) {
    return ne.indexOf(X) === J;
  }).map(function(X) {
    return O.filter(function(J) {
      return J.priority === X;
    }).sort(function(J, ne) {
      return ne.subPriority - J.subPriority;
    });
  }).map(function(X) {
    return X[0];
  }), U = we(n);
  if (isNaN(U.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var G = dy(U, hi(U)), H = {}, q = Em($), j;
  try {
    for (q.s(); !(j = q.n()).done; ) {
      var W = j.value;
      if (!W.validate(G, k))
        return /* @__PURE__ */ new Date(NaN);
      var z = W.set(G, H, k);
      Array.isArray(z) ? (G = z[0], i5(H, z[1])) : G = z;
    }
  } catch (X) {
    q.e(X);
  } finally {
    q.f();
  }
  return G;
}
function h6(e) {
  return e.match(c6)[1].replace(u6, "'");
}
function p6(e) {
  pe(1, arguments);
  var t = we(e);
  return t.setMinutes(0, 0, 0), t;
}
function Xf(e, t) {
  pe(2, arguments);
  var n = we(e), r = we(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function g6(e) {
  pe(1, arguments);
  var t = we(e);
  return t.setMilliseconds(0), t;
}
function m6(e, t) {
  pe(2, arguments);
  var n = we(e), r = we(t);
  return n.getFullYear() === r.getFullYear();
}
function Mm(e, t) {
  pe(2, arguments);
  var n = at(t);
  return bn(e, -n);
}
function v6(e, t) {
  var n;
  pe(1, arguments);
  var r = at((n = t == null ? void 0 : t.additionalDigits) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var o = w6(e), i;
  if (o.date) {
    var s = C6(o.date, r);
    i = _6(s.restDateString, s.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var a = i.getTime(), l = 0, c;
  if (o.time && (l = E6(o.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (o.timezone) {
    if (c = S6(o.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var u = new Date(a + l), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), d.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), d;
  }
  return new Date(a + l + c);
}
var Ea = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, b6 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, y6 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, x6 = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function w6(e) {
  var t = {}, n = e.split(Ea.dateTimeDelimiter), r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], Ea.timeZoneDelimiter.test(t.date) && (t.date = e.split(Ea.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
    var o = Ea.timezone.exec(r);
    o ? (t.time = r.replace(o[1], ""), t.timezone = o[1]) : t.time = r;
  }
  return t;
}
function C6(e, t) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
  if (!r)
    return {
      year: NaN,
      restDateString: ""
    };
  var o = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? o : i * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function _6(e, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = e.match(b6);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], o = Bi(n[1]), i = Bi(n[2]) - 1, s = Bi(n[3]), a = Bi(n[4]), l = Bi(n[5]) - 1;
  if (r)
    return k6(t, a, l) ? M6(t, a, l) : /* @__PURE__ */ new Date(NaN);
  var c = /* @__PURE__ */ new Date(0);
  return !R6(t, i, s) || !T6(t, o) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, i, Math.max(o, s)), c);
}
function Bi(e) {
  return e ? parseInt(e) : 1;
}
function E6(e) {
  var t = e.match(y6);
  if (!t)
    return NaN;
  var n = uu(t[1]), r = uu(t[2]), o = uu(t[3]);
  return P6(n, r, o) ? n * xc + r * yc + o * 1e3 : NaN;
}
function uu(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function S6(e) {
  if (e === "Z")
    return 0;
  var t = e.match(x6);
  if (!t)
    return 0;
  var n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), o = t[3] && parseInt(t[3]) || 0;
  return I6(r, o) ? n * (r * xc + o * yc) : NaN;
}
function M6(e, t, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var o = r.getUTCDay() || 7, i = (t - 1) * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
var O6 = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Sy(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function R6(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (O6[t] || (Sy(e) ? 29 : 28));
}
function T6(e, t) {
  return t >= 1 && t <= (Sy(e) ? 366 : 365);
}
function k6(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function P6(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function I6(e, t) {
  return t >= 0 && t <= 59;
}
function du(e, t) {
  pe(2, arguments);
  var n = we(e), r = at(t), o = n.getFullYear(), i = n.getDate(), s = /* @__PURE__ */ new Date(0);
  s.setFullYear(o, r, 15), s.setHours(0, 0, 0, 0);
  var a = s5(s);
  return n.setMonth(r, Math.min(i, a)), n;
}
function Om(e, t) {
  pe(2, arguments);
  var n = we(e), r = at(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(r), n);
}
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
const N6 = {
  datetime: "MMM d, yyyy, h:mm:ss aaaa",
  millisecond: "h:mm:ss.SSS aaaa",
  second: "h:mm:ss aaaa",
  minute: "h:mm aaaa",
  hour: "ha",
  day: "MMM d",
  week: "PP",
  month: "MMM yyyy",
  quarter: "qqq - yyyy",
  year: "yyyy"
};
j0._date.override({
  _id: "date-fns",
  // DEBUG
  formats: function() {
    return N6;
  },
  parse: function(e, t) {
    if (e === null || typeof e > "u")
      return null;
    const n = typeof e;
    return n === "number" || e instanceof Date ? e = we(e) : n === "string" && (typeof t == "string" ? e = qo(e, t, /* @__PURE__ */ new Date(), this.options) : e = v6(e, this.options)), Uf(e) ? e.getTime() : null;
  },
  format: function(e, t) {
    return Qt(e, t, this.options);
  },
  add: function(e, t, n) {
    switch (n) {
      case "millisecond":
        return As(e, t);
      case "second":
        return DP(e, t);
      case "minute":
        return IP(e, t);
      case "hour":
        return MP(e, t);
      case "day":
        return bn(e, t);
      case "week":
        return Sl(e, t);
      case "month":
        return Nn(e, t);
      case "quarter":
        return NP(e, t);
      case "year":
        return iy(e, t);
      default:
        return e;
    }
  },
  diff: function(e, t, n) {
    switch (n) {
      case "millisecond":
        return wc(e, t);
      case "second":
        return YP(e, t);
      case "minute":
        return zP(e, t);
      case "hour":
        return WP(e, t);
      case "day":
        return sy(e, t);
      case "week":
        return GP(e, t);
      case "month":
        return ly(e, t);
      case "quarter":
        return UP(e, t);
      case "year":
        return KP(e, t);
      default:
        return 0;
    }
  },
  startOf: function(e, t, n) {
    switch (t) {
      case "second":
        return g6(e);
      case "minute":
        return qP(e);
      case "hour":
        return p6(e);
      case "day":
        return To(e);
      case "week":
        return Dn(e);
      case "isoWeek":
        return Dn(e, { weekStartsOn: +n });
      case "month":
        return en(e);
      case "quarter":
        return XP(e);
      case "year":
        return cy(e);
      default:
        return e;
    }
  },
  endOf: function(e, t) {
    switch (t) {
      case "second":
        return tI(e);
      case "minute":
        return JP(e);
      case "hour":
        return QP(e);
      case "day":
        return ay(e);
      case "week":
        return Cc(e);
      case "month":
        return $s(e);
      case "quarter":
        return eI(e);
      case "year":
        return ZP(e);
      default:
        return e;
    }
  }
});
function yr(e, t) {
  const { format: n = "rgba" } = t || {}, r = `rgba(${getComputedStyle(
    document.documentElement
  ).getPropertyValue(e)})`;
  return n === "hex" ? D6(r) : r;
}
const D6 = (e) => {
  const t = e.replace(/^rgba?\(|\s+|\)$/g, "").split(","), n = parseInt(t[0], 10), r = parseInt(t[1], 10), o = parseInt(t[2], 10), i = Math.round(parseFloat(t[3]) * 255), s = (a) => a.toString(16).padStart(2, "0");
  return `#${s(n)}${s(r)}${s(o)}${Number.isNaN(i) ? "" : s(i)}`;
}, My = () => /* @__PURE__ */ Z("div", { className: "relative flex h-52 w-full flex-1 flex-col justify-between", children: [
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ Z("div", { className: "absolute inset-0 flex flex-col items-center justify-center space-y-2.5", children: [
    /* @__PURE__ */ _(Oy, {}),
    /* @__PURE__ */ _("p", { className: "text-xs font-medium text-foundations-boldest", children: "No data in this period" })
  ] })
] }), Oy = ({ className: e }) => /* @__PURE__ */ Z(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "84",
    viewBox: "0 0 112 84",
    fill: "none",
    className: e,
    children: [
      /* @__PURE__ */ _(
        "path",
        {
          d: "M56.7368 84C79.9328 84 98.7368 65.196 98.7368 42C98.7368 18.804 79.9328 0 56.7368 0C33.5409 0 14.7368 18.804 14.7368 42C14.7368 65.196 33.5409 84 56.7368 84Z",
          className: "fill-[theme(backgroundColor.foundations-subtlest)]"
        }
      ),
      /* @__PURE__ */ _("g", { filter: "url(#filter0_d_18659_25530)", children: /* @__PURE__ */ _(
        "path",
        {
          d: "M8.19249 29.5547H103.392C104.328 29.5547 105.224 29.9262 105.886 30.5874C106.547 31.2486 106.918 32.1455 106.918 33.0806V50.7102C106.918 51.6454 106.547 52.5422 105.886 53.2034C105.224 53.8647 104.328 54.2362 103.392 54.2362H8.19249C7.25736 54.2362 6.36052 53.8647 5.69928 53.2034C5.03805 52.5422 4.66656 51.6454 4.66656 50.7102V33.0806C4.66656 32.1455 5.03805 31.2486 5.69928 30.5874C6.36052 29.9262 7.25736 29.5547 8.19249 29.5547V29.5547Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M53.324 35.1953H34.9892C33.8208 35.1953 32.8736 36.1425 32.8736 37.3109C32.8736 38.4793 33.8208 39.4264 34.9892 39.4264H53.324C54.4924 39.4264 55.4395 38.4793 55.4395 37.3109C55.4395 36.1425 54.4924 35.1953 53.324 35.1953Z",
          className: "fill-[theme(backgroundColor.chart-categorical-8-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M66.0171 44.3633H34.989C33.8206 44.3633 32.8734 45.3104 32.8734 46.4788C32.8734 47.6472 33.8206 48.5944 34.989 48.5944H66.0171C67.1855 48.5944 68.1327 47.6472 68.1327 46.4788C68.1327 45.3104 67.1855 44.3633 66.0171 44.3633Z",
          className: "fill-[theme(backgroundColor.chart-categorical-8-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M27.2341 41.8951C27.2341 36.2479 22.6562 31.6699 17.0089 31.6699C11.3617 31.6699 6.78375 36.2479 6.78375 41.8951C6.78375 47.5423 11.3617 52.1203 17.0089 52.1203C22.6562 52.1203 27.2341 47.5423 27.2341 41.8951Z",
          className: "fill-[theme(backgroundColor.chart-neutral)]"
        }
      ),
      /* @__PURE__ */ Z("g", { clipPath: "url(#clip0_18659_25530)", children: [
        /* @__PURE__ */ _(
          "path",
          {
            d: "M12.1339 42.6223C12.1339 42.2787 12.4124 42.0001 12.7561 42.0001H14.0005C14.3442 42.0001 14.6227 42.2787 14.6227 42.6223V45.7334C14.6227 46.0771 14.3442 46.3556 14.0005 46.3556H12.7561C12.4124 46.3556 12.1339 46.0771 12.1339 45.7334V42.6223Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            d: "M15.8672 40.1334C15.8672 39.7898 16.1458 39.5112 16.4894 39.5112H17.7338C18.0775 39.5112 18.3561 39.7898 18.3561 40.1334V45.7334C18.3561 46.0771 18.0775 46.3556 17.7338 46.3556H16.4894C16.1458 46.3556 15.8672 46.0771 15.8672 45.7334V40.1334Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            d: "M19.6005 38.2668C19.6005 37.9231 19.8791 37.6445 20.2227 37.6445H21.4672C21.8108 37.6445 22.0894 37.9231 22.0894 38.2668V45.7334C22.0894 46.0771 21.8108 46.3556 21.4672 46.3556H20.2227C19.8791 46.3556 19.6005 46.0771 19.6005 45.7334V38.2668Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        )
      ] }),
      /* @__PURE__ */ Z("defs", { children: [
        /* @__PURE__ */ Z(
          "filter",
          {
            id: "filter0_d_18659_25530",
            x: "0.435454",
            y: "27.4391",
            width: "110.714",
            height: "33.1439",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ _(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ _("feOffset", { dy: "2.11556" }),
              /* @__PURE__ */ _("feGaussianBlur", { stdDeviation: "2.11556" }),
              /* @__PURE__ */ _(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
                }
              ),
              /* @__PURE__ */ _(
                "feBlend",
                {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_18659_25530"
                }
              ),
              /* @__PURE__ */ _(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_18659_25530",
                  result: "shape"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ _("clipPath", { id: "clip0_18659_25530", children: /* @__PURE__ */ _(
          "rect",
          {
            width: "12.4444",
            height: "12.4444",
            className: "fill-[theme(backgroundColor.foundations-default)]",
            transform: "translate(10.8894 35.7773)"
          }
        ) })
      ] })
    ]
  }
), Ry = m.createContext(null);
function Fs() {
  const e = m.useContext(Ry);
  if (!e)
    throw new Error(
      "Chart compound components must be used within a <Chart> component"
    );
  return e;
}
const A6 = ({
  children: e,
  type: t,
  labels: n,
  datasets: r
}) => {
  const [o, i] = m.useState(null), s = m.useRef(null), a = n.length > 50, l = m.useMemo(
    () => ({
      chart: o,
      setChart: i,
      type: t,
      labels: n,
      datasets: r,
      tooltipRef: s,
      isLargeDataSet: a
    }),
    [o, t, n, r, a]
  );
  return /* @__PURE__ */ _(Ry.Provider, { value: l, children: e });
}, Ty = "label";
function Rm(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function L6(e, t) {
  const n = e.options;
  n && t && Object.assign(n, t);
}
function ky(e, t) {
  e.labels = t;
}
function Py(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ty;
  const r = [];
  e.datasets = t.map((o) => {
    const i = e.datasets.find((s) => s[n] === o[n]);
    return !i || !o.data || r.includes(i) ? {
      ...o
    } : (r.push(i), Object.assign(i, o), i);
  });
}
function $6(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ty;
  const n = {
    labels: [],
    datasets: []
  };
  return ky(n, e.labels), Py(n, e.datasets, t), n;
}
function F6(e, t) {
  const { height: n = 150, width: r = 300, redraw: o = !1, datasetIdKey: i, type: s, data: a, options: l, plugins: c = [], fallbackContent: u, updateMode: d, ...f } = e, h = Be(null), p = Be(), g = () => {
    h.current && (p.current = new zf(h.current, {
      type: s,
      data: $6(a, i),
      options: l && {
        ...l
      },
      plugins: c
    }), Rm(t, p.current));
  }, v = () => {
    Rm(t, null), p.current && (p.current.destroy(), p.current = null);
  };
  return Le(() => {
    !o && p.current && l && L6(p.current, l);
  }, [
    o,
    l
  ]), Le(() => {
    !o && p.current && ky(p.current.config.data, a.labels);
  }, [
    o,
    a.labels
  ]), Le(() => {
    !o && p.current && a.datasets && Py(p.current.config.data, a.datasets, i);
  }, [
    o,
    a.datasets
  ]), Le(() => {
    p.current && (o ? (v(), setTimeout(g)) : p.current.update(d));
  }, [
    o,
    l,
    a.labels,
    a.datasets,
    d
  ]), Le(() => {
    p.current && (v(), setTimeout(g));
  }, [
    s
  ]), Le(() => (g(), () => v()), []), /* @__PURE__ */ Y.createElement("canvas", Object.assign({
    ref: h,
    role: "img",
    height: n,
    width: r
  }, f), u);
}
const V6 = /* @__PURE__ */ mt(F6), B6 = (e) => {
  let t = null;
  return {
    id: "hover-label",
    afterEvent(r, { inChartArea: o, event: i }) {
      var a, l;
      if (!o) {
        t = null;
        return;
      }
      const [s] = r.getElementsAtEventForMode(
        //@ts-expect-error
        i,
        "nearest",
        { intersect: !1, axis: (l = (a = r.config.options) == null ? void 0 : a.interaction) == null ? void 0 : l.axis },
        !0
      );
      t = (s == null ? void 0 : s.index) ?? null;
    },
    afterDatasetDraw(r) {
      var w;
      const o = r.config.type;
      if (o === "doughnut" || o === "pie")
        return;
      const {
        ctx: i,
        chartArea: { top: s, bottom: a },
        scales: { x: l }
      } = r;
      if (i.save(), t == null)
        return;
      const c = (w = r.data.labels) == null ? void 0 : w[t], d = r.getDatasetMeta(0).data[t], f = d ? d.x : l.getPixelForValue(new Date(c).getTime()), h = 1;
      i.beginPath(), i.setLineDash([3, 3]), i.strokeStyle = yr("--border-foundations-bolder"), i.lineWidth = h;
      const p = f - h / 2;
      i.moveTo(p, s), i.lineTo(p, a), i.stroke();
      const g = 8, v = new Date(c).getTime(), y = Qt(v, e), b = i.measureText(`${y}`).width + g;
      i.fillStyle = yr(
        "--background-foundations-subtlest"
      ), i.roundRect(f - b / 2, a + 12, b, 20, 4), i.fill(), i.font = "500 12px 'DM Sans', Arial", i.fillStyle = yr("--text-foundations-boldest"), i.fillText(
        y,
        f - b / 2 + g / 2,
        a + 12 + 20 / 2 + 5
      ), i.restore();
    }
  };
}, H6 = {
  id: "fully-rendered",
  afterRender: function(e) {
    e.$rendered || (e.$rendered = !0);
  }
}, W6 = (e, t) => ({
  id: "center-text",
  afterDatasetDraw(n) {
    const { ctx: r, chartArea: o } = n, i = (o.left + o.right) / 2, s = (o.top + o.bottom) / 2;
    r.save(), r.textAlign = "center", r.textBaseline = "middle", r.font = `${(t == null ? void 0 : t.fontWeight) || "700"} ${(t == null ? void 0 : t.fontSize) || "32px"} 'DM Sans', Arial`, r.fillStyle = (t == null ? void 0 : t.color) || yr("--text-foundations-boldest"), r.fillText(e, i, s), r.restore();
  }
}), Iy = ({
  horizontal: e = !1,
  extraScales: t,
  scaleXWeekFormat: n = !1,
  disableAnimation: r = !1,
  maxYValue: o,
  formatXLabel: i,
  formatYLabel: s,
  crossHairTooltipFormat: a = "MMM d, yyy",
  className: l,
  centerText: c
} = {}) => {
  const { setChart: u, type: d, labels: f, datasets: h, tooltipRef: p } = Fs();
  return /* @__PURE__ */ _("div", { className: oe("h-full", l), children: /* @__PURE__ */ _(
    V6,
    {
      ref: u,
      width: "100%",
      type: d,
      data: {
        labels: f,
        datasets: h
      },
      options: {
        layout: d === "doughnut" || d === "pie" ? {
          padding: 0
        } : {
          padding: {
            right: 40
          }
        },
        animation: r ? !1 : d === "doughnut" || d === "pie" ? {
          animateRotate: !0,
          animateScale: !1
        } : !0,
        transitions: {
          active: {
            animation: {
              duration: 0
            }
          }
        },
        responsive: !0,
        maintainAspectRatio: !1,
        indexAxis: e ? "y" : "x",
        interaction: d === "doughnut" || d === "pie" ? {
          intersect: !0,
          mode: "point"
        } : {
          intersect: !1,
          axis: "x",
          mode: "nearest"
        },
        elements: {
          point: {
            radius: f.length === 1 ? 4 : 0,
            hitRadius: 4,
            pointStyle: "circle"
          },
          line: {
            borderWidth: 2,
            tension: 0.02
          }
        },
        cutout: "70%",
        plugins: {
          tooltip: d === "doughnut" || d === "pie" ? {
            mode: "point",
            intersect: !0,
            enabled: !1,
            external: (g) => {
              var w, C;
              if (!g.chart.$rendered)
                return;
              const v = g.tooltip;
              if (v.opacity === 0) {
                (w = p.current) == null || w.updateTooltip({
                  opacity: 0,
                  top: void 0,
                  left: void 0,
                  xAlign: void 0
                });
                return;
              }
              const y = g.chart.canvas.getBoundingClientRect(), b = {
                opacity: 1,
                left: y.left + v.caretX + window.scrollX,
                top: y.top + v.caretY + window.scrollY,
                xAlign: v.xAlign,
                dataPoints: v.dataPoints.map(
                  (x) => {
                    var E;
                    return {
                      label: x.label,
                      dataset: x.dataset,
                      raw: x.raw,
                      rawLabel: (E = x.chart.data.labels) == null ? void 0 : E[x.dataIndex],
                      dataIndex: x.dataIndex
                    };
                  }
                )
              };
              (C = p.current) == null || C.updateTooltip(b);
            }
          } : {
            mode: "nearest",
            intersect: !1,
            enabled: !1,
            external: (g) => {
              var w, C;
              if (!g.chart.$rendered)
                return;
              const v = g.tooltip;
              if (v.opacity === 0) {
                (w = p.current) == null || w.updateTooltip({
                  opacity: 0,
                  top: void 0,
                  left: void 0,
                  xAlign: void 0
                });
                return;
              }
              const y = g.chart.canvas.getBoundingClientRect(), b = {
                opacity: 1,
                left: y.left + v.caretX + window.scrollX,
                top: y.top + v.caretY + window.scrollY,
                xAlign: v.xAlign,
                dataPoints: v.dataPoints.map(
                  (x) => {
                    var E;
                    return {
                      label: x.label,
                      dataset: x.dataset,
                      raw: x.raw,
                      rawLabel: (E = x.chart.data.labels) == null ? void 0 : E[x.dataIndex],
                      dataIndex: x.dataIndex
                    };
                  }
                )
              };
              (C = p.current) == null || C.updateTooltip(b);
            }
          }
        },
        ...d !== "doughnut" && d !== "pie" ? {
          scales: {
            y: {
              beginAtZero: !0,
              grace: "5%",
              grid: {
                display: !1
              },
              ticks: {
                padding: 8,
                color: yr(
                  "--text-foundations-bold"
                ),
                count: 2,
                callback: s
              },
              border: {
                display: !1
              },
              max: o
            },
            x: {
              offset: !0,
              type: "time",
              time: {
                unit: "day",
                displayFormats: {
                  day: n ? "E" : "MMM d"
                },
                tooltipFormat: "MMM d, yyy"
              },
              grid: {
                color: "transparent",
                tickColor: yr(
                  "--border-foundations-bold"
                ),
                offset: !1
              },
              ticks: {
                padding: 8,
                color: yr(
                  "--text-foundations-bold"
                ),
                align: "center",
                autoSkip: !1,
                maxRotation: 0,
                minRotation: 0,
                source: "labels",
                callback(g, v) {
                  return v === 0 || v === f.length - 1 ? i ? i(g, v) : Qt(g, "MMM d, yyy") : void 0;
                }
              },
              border: {
                color: yr(
                  "--border-foundations-bold"
                )
              }
            },
            ...t
          }
        } : {}
      },
      plugins: [
        m.useMemo(
          () => B6(a || "MMM d, yyy"),
          [a]
        ),
        H6,
        ...c && (d === "doughnut" || d === "pie") ? [
          m.useMemo(
            () => W6(c.text, {
              fontSize: c.fontSize,
              fontWeight: c.fontWeight,
              color: c.color
            }),
            [
              c.text,
              c.fontSize,
              c.fontWeight,
              c.color
            ]
          )
        ] : []
      ]
    }
  ) });
};
Iy.displayName = "Chart.Canvas";
function Ny() {
  const [e, t] = m.useReducer((n) => !n, !1);
  return t;
}
const z6 = ({
  variant: e = "row",
  className: t,
  labelFormatter: n,
  descriptionFormatter: r
}) => {
  const { chart: o, datasets: i } = Fs(), [s, a] = m.useState(null), [l, c] = m.useState(/* @__PURE__ */ new Set()), u = Ny();
  if (!o)
    return null;
  const d = m.useCallback(
    (f) => {
      l.has(f) ? (c((p) => {
        const g = new Set(p);
        return g.delete(f), g;
      }), o.setDatasetVisibility(f, !0)) : (c((p) => new Set(p).add(f)), o.setDatasetVisibility(f, !1)), o.update(), u();
    },
    [o, l, u, c]
  );
  return /* @__PURE__ */ _(
    "div",
    {
      className: oe(
        "flex flex-wrap justify-center gap-2",
        e === "column" && "flex-col items-start",
        t
      ),
      children: i.map((f, h) => {
        var p;
        return /* @__PURE__ */ _(
          "button",
          {
            className: oe(
              "flex items-center space-x-1 p-1 transition-opacity duration-300",
              s !== null && s !== h && "opacity-20",
              l.has(h) && "line-through opacity-50"
            ),
            onClick: () => d(h),
            onMouseEnter: () => {
              l.has(h) || (a(h), o.config.data.datasets.forEach((g, v) => {
                var y, b, w, C;
                if (!l.has(v)) {
                  if (h === v) {
                    o.config.data.datasets[h].backgroundColor = g.backgroundColor, o.config.data.datasets[h].borderColor = g.borderColor;
                    return;
                  }
                  g.backgroundColor = (b = (y = g.backgroundColor) == null ? void 0 : y.replace) == null ? void 0 : b.call(y, ")", ", 0.3)"), g.borderColor = (C = (w = g.borderColor) == null ? void 0 : w.replace) == null ? void 0 : C.call(
                    w,
                    ")",
                    ", 0.3)"
                  );
                }
              }), o.update(), u());
            },
            onMouseLeave: () => {
              a(null), o.config.data.datasets.forEach((g, v) => {
                l.has(v) || (g.backgroundColor = g.backgroundColor = i[v].backgroundColor, g.borderColor = g.borderColor = i[v].borderColor);
              }), o.update(), u();
            },
            children: /* @__PURE__ */ Z("div", { className: "flex flex-1 flex-col items-start gap-0.5", children: [
              /* @__PURE__ */ Z("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ _(
                  "div",
                  {
                    className: oe(
                      "h-2 w-2 shrink-0 rounded-full bg-foundations-subtle transition-opacity duration-300",
                      l.has(h) && "opacity-30"
                    ),
                    style: {
                      backgroundColor: ((p = f.backgroundColor) == null ? void 0 : p.toString()) || void 0
                    }
                  }
                ),
                /* @__PURE__ */ _("span", { className: "text-xs font-medium text-foundations-bolder", children: n ? n(f.label || "", h) : f.label })
              ] }),
              r && /* @__PURE__ */ _("span", { className: "text-xs font-medium text-foundations-bold", children: r(f.label || "", h) })
            ] })
          },
          f.label
        );
      })
    }
  );
}, j6 = ({
  variant: e = "row",
  className: t,
  labelFormatter: n,
  descriptionFormatter: r
}) => {
  const { chart: o, labels: i, datasets: s } = Fs(), [a, l] = m.useState(null), [c, u] = m.useState(/* @__PURE__ */ new Set()), d = Ny();
  if (!o)
    return null;
  const f = m.useCallback(
    (p) => {
      c.has(p) ? (u((v) => {
        const y = new Set(v);
        return y.delete(p), y;
      }), o.toggleDataVisibility(p)) : (u((v) => new Set(v).add(p)), o.toggleDataVisibility(p)), o.update(), d();
    },
    [o, c, d, u]
  ), h = (p) => {
    const v = s[0].backgroundColor;
    return Array.isArray(v) ? v[p] : v;
  };
  return /* @__PURE__ */ _(
    "div",
    {
      className: oe(
        "flex flex-wrap justify-center gap-2 pb-4",
        e === "column" && "flex-col items-start",
        t
      ),
      children: i.map((p, g) => {
        const v = c.has(g), y = h(g);
        return /* @__PURE__ */ _(
          "button",
          {
            className: oe(
              "flex p-1 transition-opacity duration-300",
              a !== null && a !== g && "opacity-20",
              v && "line-through opacity-50"
            ),
            onClick: () => f(g),
            onMouseEnter: () => {
              if (v)
                return;
              l(g);
              const b = o.config.data.datasets[0], w = b.backgroundColor, C = b.borderColor;
              Array.isArray(w) && (b.backgroundColor = w.map(
                (x, E) => E === g || c.has(E) ? x : x.replace(")", ", 0.3)")
              )), Array.isArray(C) && (b.borderColor = C.map(
                (x, E) => E === g || c.has(E) ? x : x.replace(")", ", 0.3)")
              )), o.update(), d();
            },
            onMouseLeave: () => {
              l(null);
              const b = o.config.data.datasets[0];
              b.backgroundColor = s[0].backgroundColor, b.borderColor = s[0].borderColor, o.update(), d();
            },
            children: /* @__PURE__ */ Z("div", { className: "flex flex-1 flex-col items-start gap-0.5", children: [
              /* @__PURE__ */ Z("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ _(
                  "div",
                  {
                    className: oe(
                      "h-2 w-2 shrink-0 rounded-full transition-opacity duration-300",
                      v && "opacity-30"
                    ),
                    style: {
                      backgroundColor: (y == null ? void 0 : y.toString()) || void 0
                    }
                  }
                ),
                /* @__PURE__ */ _("span", { className: "text-xs font-medium text-foundations-bolder", children: n ? n(p, g) : p })
              ] }),
              r && /* @__PURE__ */ _("span", { className: "text-xs font-medium text-foundations-bold", children: r(p, g) })
            ] })
          },
          `${p}-${g}`
        );
      })
    }
  );
}, Dy = ({
  variant: e = "row",
  className: t,
  labelFormatter: n,
  descriptionFormatter: r
} = {}) => {
  const { type: o, chart: i, datasets: s } = Fs();
  return i ? o === "doughnut" || o === "pie" ? /* @__PURE__ */ _(
    j6,
    {
      variant: e,
      className: t,
      labelFormatter: n,
      descriptionFormatter: r
    }
  ) : s.length <= 1 ? null : /* @__PURE__ */ _(
    z6,
    {
      variant: e,
      className: t,
      labelFormatter: n,
      descriptionFormatter: r
    }
  ) : null;
};
Dy.displayName = "Chart.Legend";
function He() {
  return He = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, He.apply(this, arguments);
}
function U6(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ay(...e) {
  return (t) => e.forEach(
    (n) => U6(n, t)
  );
}
function rr(...e) {
  return st(Ay(...e), e);
}
const mi = /* @__PURE__ */ mt((e, t) => {
  const { children: n, ...r } = e, o = Zo.toArray(n), i = o.find(G6);
  if (i) {
    const s = i.props.children, a = o.map((l) => l === i ? Zo.count(s) > 1 ? Zo.only(null) : /* @__PURE__ */ nl(s) ? s.props.children : null : l);
    return /* @__PURE__ */ Pe(hd, He({}, r, {
      ref: t
    }), /* @__PURE__ */ nl(s) ? /* @__PURE__ */ Wl(s, void 0, a) : null);
  }
  return /* @__PURE__ */ Pe(hd, He({}, r, {
    ref: t
  }), n);
});
mi.displayName = "Slot";
const hd = /* @__PURE__ */ mt((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ nl(n) ? /* @__PURE__ */ Wl(n, {
    ...K6(r, n.props),
    ref: t ? Ay(t, n.ref) : n.ref
  }) : Zo.count(n) > 1 ? Zo.only(null) : null;
});
hd.displayName = "SlotClone";
const Y6 = ({ children: e }) => /* @__PURE__ */ Pe(XC, null, e);
function G6(e) {
  return /* @__PURE__ */ nl(e) && e.type === Y6;
}
function K6(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const q6 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Cn = q6.reduce((e, t) => {
  const n = /* @__PURE__ */ mt((r, o) => {
    const { asChild: i, ...s } = r, a = i ? mi : t;
    return Le(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ Pe(a, He({}, s, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function X6(e, t) {
  e && Pd(
    () => e.dispatchEvent(t)
  );
}
const Ly = /* @__PURE__ */ mt((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ QC.createPortal(/* @__PURE__ */ Pe(Cn.div, He({}, o, {
    ref: t
  })), r) : null;
}), Z6 = Ly, $y = ({ children: e }) => /* @__PURE__ */ _(Z6, { asChild: !0, children: e });
function pd(e) {
  const t = m.useRef(e);
  return m.useEffect(() => {
    t.current = e;
  }), m.useMemo(
    () => (...n) => {
      var r;
      return (r = t.current) == null ? void 0 : r.call(t, ...n);
    },
    []
  );
}
const Fy = m.memo(
  m.forwardRef(
    ({
      isLargeDataSet: e,
      tooltipLabelFormatter: t,
      tooltipValueFormatter: n,
      showLabel: r,
      tooltipVariant: o
    }, i) => {
      const [s, a] = m.useState({
        opacity: 0,
        top: 0,
        left: 0,
        xAlign: ""
      });
      m.useImperativeHandle(i, () => ({
        updateTooltip: (h) => {
          s.opacity === h.opacity && s.left === h.left && s.top === h.top || a((p) => ({
            opacity: h.opacity,
            top: h.top ?? p.top,
            left: h.left ?? p.left,
            xAlign: h.xAlign ?? p.xAlign,
            dataPoints: h.dataPoints ?? p.dataPoints
          }));
        }
      }));
      const { top: l, left: c, opacity: u, xAlign: d, dataPoints: f } = s;
      return /* @__PURE__ */ _(
        "div",
        {
          className: oe(
            "pointer-events-none fixed z-50 -translate-y-[calc(100%-8px)] space-y-2 rounded-lg border border-foundations-subtle bg-foundations-default shadow-3 transition-all",
            d === "left" ? "translate-x-[calc(8px+6px)]" : "-translate-x-[calc(100%+8px+6px)]",
            o === "line" ? "px-3 py-2" : "p-4",
            e ? "duration-100" : "duration-200"
          ),
          style: {
            top: l,
            left: c,
            opacity: u
          },
          children: f == null ? void 0 : f.map((h) => {
            const p = h.dataset.backgroundColor, g = Array.isArray(p) ? p[h.dataIndex] : p;
            return /* @__PURE__ */ Z(
              "div",
              {
                className: oe(
                  "flex gap-2 whitespace-nowrap",
                  o === "line" ? "items-stretch" : "items-center"
                ),
                children: [
                  /* @__PURE__ */ _(
                    "div",
                    {
                      className: oe(
                        "rounded-full",
                        o === "line" ? "w-[3px]" : "size-2"
                      ),
                      style: {
                        backgroundColor: g
                      }
                    }
                  ),
                  /* @__PURE__ */ Z(
                    "div",
                    {
                      className: oe(
                        "flex text-xs font-medium text-foundations-boldest",
                        o === "line" ? "flex-col gap-1" : "flex-row gap-4"
                      ),
                      children: [
                        r && /* @__PURE__ */ _("p", { children: h.dataset.label }),
                        /* @__PURE__ */ _(
                          "p",
                          {
                            className: oe(
                              "text-[11px] uppercase",
                              o === "line" ? " text-[11px] text-foundations-subtle" : "text-current"
                            ),
                            children: t ? t(h.rawLabel, h.dataIndex) : h.label
                          }
                        ),
                        /* @__PURE__ */ _(
                          "p",
                          {
                            className: oe(
                              o === "line" ? "text-current" : "text-foundations-subtle"
                            ),
                            children: n ? n(h.raw, h.dataIndex) : String(h.raw)
                          }
                        )
                      ]
                    }
                  )
                ]
              },
              h.dataset.label ?? h.label
            );
          })
        }
      );
    }
  )
);
Fy.displayName = "TooltipInternal";
const Vy = ({
  labelFormatter: e,
  valueFormatter: t,
  variant: n = "line"
} = {}) => {
  const { tooltipRef: r, isLargeDataSet: o, datasets: i } = Fs();
  return /* @__PURE__ */ _($y, { children: /* @__PURE__ */ _(
    Fy,
    {
      ref: r,
      tooltipVariant: n,
      tooltipLabelFormatter: e && pd(e),
      tooltipValueFormatter: t && pd(t),
      isLargeDataSet: o,
      showLabel: i.length > 1
    }
  ) });
};
Vy.displayName = "Chart.Tooltip";
zf.register(
  ld,
  cd,
  ys,
  qa,
  qi,
  Ka,
  Ua,
  ja,
  Ki,
  Yi,
  nP
);
const By = ({
  type: e,
  labels: t,
  datasets: n,
  children: r,
  className: o
}) => t.length === 0 ? /* @__PURE__ */ _(My, {}) : /* @__PURE__ */ _(A6, { type: e, labels: t, datasets: n, children: /* @__PURE__ */ _("div", { className: oe("relative flex flex-col", o), children: r }) });
By.displayName = "Chart";
const s$ = Object.assign(By, {
  Canvas: Iy,
  Legend: Dy,
  Tooltip: Vy
});
function a$(e) {
  return {
    grace: "5%",
    grid: {
      drawOnChartArea: !1,
      drawTicks: !1
    },
    ticks: {
      padding: 8,
      color: yr("--text-foundations-subtle")
    },
    border: {
      display: !1
    },
    ...e
  };
}
const Q6 = (e) => /* @__PURE__ */ m.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ArrowNarrowShortUp/solid"
}, e), /* @__PURE__ */ m.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.293 9.707a1 1 0 0 1 0-1.414l4.005-4a1.002 1.002 0 0 1 1.416 0l4.005 4a1 1 0 0 1-1.416 1.414l-2.296-2.293V15a1 1 0 0 1-1.001 1 1.002 1.002 0 0 1-1.001-1V7.414L6.709 9.707a1.002 1.002 0 0 1-1.416 0Z",
  clipRule: "evenodd"
})), Zf = (e) => Number(e.toFixed(2)), J6 = dn(
  "transition-all duration-1000 stroke-neutral-300",
  {
    variants: {
      variant: {
        success: "stroke-[theme(backgroundColor.chart-categorical-2-subtle)]",
        danger: "stroke-[theme(backgroundColor.chart-categorical-3-subtle)]",
        primary: "stroke-[theme(backgroundColor.info-bold)]"
      }
    }
  }
), Hy = m.forwardRef(
  ({
    variant: e,
    value: t,
    size: n = 170,
    strokeWidth: r = 10,
    strokeClassName: o,
    strokeLinecap: i = "round"
  }, s) => {
    const l = n / 2 - r, c = 2 * Math.PI * l, u = c * ((100 - (t || 0)) / 100);
    return /* @__PURE__ */ Z("svg", { ref: s, width: n, height: n, children: [
      /* @__PURE__ */ _(
        "circle",
        {
          className: oe("stroke-neutral-100", o),
          fill: "none",
          strokeWidth: r,
          r: l,
          cx: n / 2,
          cy: n / 2
        }
      ),
      /* @__PURE__ */ _(
        "circle",
        {
          className: oe(
            "stroke-[theme(backgroundColor.chart-neutral)]",
            J6({ variant: e })
          ),
          fill: "none",
          strokeWidth: r,
          r: l,
          cx: n / 2,
          cy: n / 2,
          strokeDasharray: c,
          strokeDashoffset: u,
          strokeLinecap: i,
          transform: "rotate(-90)",
          "transform-origin": "center"
        }
      )
    ] });
  }
), eN = m.forwardRef(
  ({
    variant: e,
    value: t,
    size: n = 170,
    strokeWidth: r = 10,
    strokeClassName: o,
    className: i,
    children: s
  }, a) => /* @__PURE__ */ Z("div", { ref: a, className: oe("relative inline-flex", i), children: [
    /* @__PURE__ */ _(
      Hy,
      {
        value: t,
        variant: e,
        size: n,
        strokeWidth: r,
        strokeClassName: o
      }
    ),
    /* @__PURE__ */ _("div", { className: "absolute inset-0 flex flex-col items-center justify-center space-y-1.5", children: t === null ? /* @__PURE__ */ Z("div", { className: "flex scale-[0.8] flex-col items-center", children: [
      /* @__PURE__ */ _(Oy, {}),
      /* @__PURE__ */ _("p", { className: "-mt-4 text-xs font-medium text-foundations-boldest", children: "No data in this period" })
    ] }) : /* @__PURE__ */ Z(Ot, { children: [
      /* @__PURE__ */ Z("p", { className: "text-xl font-bold text-foundations-boldest", children: [
        Zf(t),
        "%"
      ] }),
      s
    ] }) })
  ] })
);
eN.displayName = "CircleChart";
const tN = dn(
  "flex items-center justify-center rounded-md border border-foundations-bold bg-foundations-subtlest text-foundations-boldest py-0.5 px-1.5",
  {
    variants: {
      variant: {
        success: "bg-success-subtler border-success-subtle",
        danger: "bg-danger-subtler border-danger-subtle"
      }
    }
  }
), l$ = m.forwardRef(({ diffPercentage: e, variant: t, className: n, ...r }, o) => /* @__PURE__ */ Z(
  "span",
  {
    ref: o,
    className: oe(tN({ variant: t }), n),
    ...r,
    children: [
      !!e && /* @__PURE__ */ _(
        Q6,
        {
          className: oe("h-4 w-4", e < 0 && " rotate-180")
        }
      ),
      /* @__PURE__ */ Z("span", { className: "text-xs font-medium", children: [
        Zf(Math.abs(e)),
        "%"
      ] })
    ]
  }
)), nN = ({
  items: e,
  formatValue: t,
  onBarHover: n
}) => {
  const r = m.useMemo(
    () => Math.max(...e.map((o) => o.value)),
    [e]
  );
  return e.length === 0 ? /* @__PURE__ */ _(My, {}) : /* @__PURE__ */ _("div", { className: "space-y-4 text-xs font-medium", children: e.map((o) => {
    const i = (t == null ? void 0 : t(o)) || o.value;
    return /* @__PURE__ */ Z("div", { children: [
      /* @__PURE__ */ _("p", { className: "uppercase text-foundations-bold", children: o.label }),
      /* @__PURE__ */ Z(
        "div",
        {
          className: "mt-0.5 flex items-center space-x-2",
          style: {
            width: `${o.value ? o.value / r * 100 : 0}%`
          },
          children: [
            /* @__PURE__ */ Z(
              xt,
              {
                onOpenChangeComplete: (s) => {
                  n == null || n(s, o);
                },
                disableHoverablePopup: !0,
                children: [
                  /* @__PURE__ */ _(
                    xt.Trigger,
                    {
                      delay: 0,
                      render: /* @__PURE__ */ _(
                        "div",
                        {
                          className: "h-2 min-w-[2px] flex-1 bg-neutral-200",
                          style: {
                            backgroundColor: o.color
                          }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ Z(
                    xt.Popup,
                    {
                      variant: "light",
                      className: "flex items-center gap-2 whitespace-nowrap shadow-3",
                      hideArrow: !0,
                      children: [
                        /* @__PURE__ */ _(
                          "div",
                          {
                            className: "rounded-full size-2",
                            style: {
                              backgroundColor: o.color
                            }
                          }
                        ),
                        /* @__PURE__ */ Z("div", { className: "flex gap-4 text-xs font-medium text-foundations-boldest", children: [
                          /* @__PURE__ */ _("p", { className: "uppercase", children: o.label }),
                          /* @__PURE__ */ Z("p", { className: "text-foundations-subtle", children: [
                            i,
                            " ",
                            o.percentage && /* @__PURE__ */ Z("span", { children: [
                              "(",
                              Zf(o.percentage),
                              "%)"
                            ] })
                          ] })
                        ] })
                      ]
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ _("span", { className: "tabular-nums text-foundations-subtle", children: i })
          ]
        }
      )
    ] }, o.label);
  }) });
};
nN.displayName = "HorizontalBarsChart";
function Vs({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = m.useRef(e !== void 0), [i, s] = m.useState(t), a = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    m.useEffect(() => {
      o !== (e !== void 0) && console.error([`Base UI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: c
    } = m.useRef(t);
    m.useEffect(() => {
      !o && JSON.stringify(c) !== JSON.stringify(t) && console.error([`Base UI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const l = m.useCallback((c) => {
    o || s(c);
  }, []);
  return [a, l];
}
let gd;
process.env.NODE_ENV !== "production" && (gd = /* @__PURE__ */ new Set());
function Wy(...e) {
  if (process.env.NODE_ENV !== "production") {
    const t = e.join(" ");
    gd.has(t) || (gd.add(t), console.warn(`Base UI: ${t}`));
  }
}
const Qf = /* @__PURE__ */ m.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  elementsRef: {
    current: []
  },
  nextIndexRef: {
    current: 0
  }
});
process.env.NODE_ENV !== "production" && (Qf.displayName = "CompositeListContext");
function rN() {
  return m.useContext(Qf);
}
function Jf(e) {
  const {
    children: t,
    elementsRef: n,
    labelsRef: r,
    onMapChange: o
  } = e, i = ve(o), s = m.useRef(0), a = rn(iN).current, l = rn(oN).current, [c, u] = m.useState(0), d = m.useRef(c), f = ve((y, b) => {
    l.set(y, b ?? null), d.current += 1, u(d.current);
  }), h = ve((y) => {
    l.delete(y), d.current += 1, u(d.current);
  }), p = m.useMemo(() => {
    const y = /* @__PURE__ */ new Map();
    return Array.from(l.keys()).filter((w) => w.isConnected).sort(sN).forEach((w, C) => {
      const x = l.get(w) ?? {};
      y.set(w, {
        ...x,
        index: C
      });
    }), y;
  }, [l, c]);
  ge(() => {
    if (typeof MutationObserver != "function" || p.size === 0)
      return;
    const y = new MutationObserver((b) => {
      const w = /* @__PURE__ */ new Set(), C = (x) => w.has(x) ? w.delete(x) : w.add(x);
      b.forEach((x) => {
        x.removedNodes.forEach(C), x.addedNodes.forEach(C);
      }), w.size === 0 && (d.current += 1, u(d.current));
    });
    return p.forEach((b, w) => {
      w.parentElement && y.observe(w.parentElement, {
        childList: !0
      });
    }), () => {
      y.disconnect();
    };
  }, [p]), ge(() => {
    d.current === c && (n.current.length !== p.size && (n.current.length = p.size), r && r.current.length !== p.size && (r.current.length = p.size), s.current = p.size), i(p);
  }, [i, p, n, r, c]), ge(() => () => {
    n.current = [];
  }, [n]), ge(() => () => {
    r && (r.current = []);
  }, [r]);
  const g = ve((y) => (a.add(y), () => {
    a.delete(y);
  }));
  ge(() => {
    a.forEach((y) => y(p));
  }, [a, p]);
  const v = m.useMemo(() => ({
    register: f,
    unregister: h,
    subscribeMapChange: g,
    elementsRef: n,
    labelsRef: r,
    nextIndexRef: s
  }), [f, h, g, n, r, s]);
  return /* @__PURE__ */ _(Qf.Provider, {
    value: v,
    children: t
  });
}
function oN() {
  return /* @__PURE__ */ new Map();
}
function iN() {
  return /* @__PURE__ */ new Set();
}
function sN(e, t) {
  const n = e.compareDocumentPosition(t);
  return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
function aN(e) {
  const {
    open: t,
    defaultOpen: n,
    onOpenChange: r,
    disabled: o
  } = e, i = t !== void 0, [s, a] = Vs({
    controlled: t,
    default: n,
    name: "Collapsible",
    state: "open"
  }), {
    mounted: l,
    setMounted: c,
    transitionStatus: u
  } = tc(s, !0, !0), [d, f] = m.useState(s), [{
    height: h,
    width: p
  }, g] = m.useState({
    height: void 0,
    width: void 0
  }), v = Kt(), [y, b] = m.useState(), w = y ?? v, [C, x] = m.useState(!1), [E, S] = m.useState(!1), R = m.useRef(null), M = m.useRef(null), I = m.useRef(null), P = m.useRef(null), k = of(P, !1), O = ve((F) => {
    const T = !s, L = ke(Tn, F.nativeEvent);
    if (r(T, L), L.isCanceled)
      return;
    const A = P.current;
    M.current === "css-animation" && A != null && A.style.removeProperty("animation-name"), !C && !E && (M.current != null && M.current !== "css-animation" && !l && T && c(!0), M.current === "css-animation" && (!d && T && f(!0), !l && T && c(!0))), a(T), M.current === "none" && l && !T && c(!1);
  });
  return ge(() => {
    i && M.current === "none" && !E && !s && c(!1);
  }, [i, E, s, t, c]), m.useMemo(() => ({
    abortControllerRef: R,
    animationTypeRef: M,
    disabled: o,
    handleTrigger: O,
    height: h,
    mounted: l,
    open: s,
    panelId: w,
    panelRef: P,
    runOnceAnimationsFinish: k,
    setDimensions: g,
    setHiddenUntilFound: x,
    setKeepMounted: S,
    setMounted: c,
    setOpen: a,
    setPanelIdState: b,
    setVisible: f,
    transitionDimensionRef: I,
    transitionStatus: u,
    visible: d,
    width: p
  }), [R, M, o, O, h, l, s, w, P, k, g, x, S, c, a, f, I, u, d, p]);
}
const eh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (eh.displayName = "CollapsibleRootContext");
function zy() {
  const e = m.useContext(eh);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CollapsibleRootContext is missing. Collapsible parts must be placed within <Collapsible.Root>." : Ke(15));
  return e;
}
let lN = /* @__PURE__ */ function(e) {
  return e[e.None = 0] = "None", e[e.GuessFromOrder = 1] = "GuessFromOrder", e;
}({});
function Ei(e = {}) {
  const {
    label: t,
    metadata: n,
    textRef: r,
    indexGuessBehavior: o,
    index: i
  } = e, {
    register: s,
    unregister: a,
    subscribeMapChange: l,
    elementsRef: c,
    labelsRef: u,
    nextIndexRef: d
  } = rN(), f = m.useRef(-1), [h, p] = m.useState(i ?? (o === lN.GuessFromOrder ? () => {
    if (f.current === -1) {
      const y = d.current;
      d.current += 1, f.current = y;
    }
    return f.current;
  } : -1)), g = m.useRef(null), v = m.useCallback((y) => {
    var b;
    if (g.current = y, h !== -1 && y !== null && (c.current[h] = y, u)) {
      const w = t !== void 0;
      u.current[h] = w ? t : ((b = r == null ? void 0 : r.current) == null ? void 0 : b.textContent) ?? y.textContent;
    }
  }, [h, c, u, t, r]);
  return ge(() => {
    if (i != null)
      return;
    const y = g.current;
    if (y)
      return s(y, n), () => {
        a(y);
      };
  }, [i, s, a, n]), ge(() => {
    if (i == null)
      return l((y) => {
        var w;
        const b = g.current ? (w = y.get(g.current)) == null ? void 0 : w.index : null;
        b != null && p(b);
      });
  }, [i, l, p]), m.useMemo(() => ({
    ref: v,
    index: h
  }), [h, v]);
}
let is = function(e) {
  return e.open = "data-open", e.closed = "data-closed", e[e.startingStyle = So.startingStyle] = "startingStyle", e[e.endingStyle = So.endingStyle] = "endingStyle", e;
}({}), cN = /* @__PURE__ */ function(e) {
  return e.panelOpen = "data-panel-open", e;
}({});
const uN = {
  [is.open]: ""
}, dN = {
  [is.closed]: ""
}, fN = {
  open(e) {
    return e ? {
      [cN.panelOpen]: ""
    } : null;
  }
}, hN = {
  open(e) {
    return e ? uN : dN;
  }
};
function pN(e) {
  return e == null || e.hasAttribute("disabled") || e.getAttribute("aria-disabled") === "true";
}
let gN = /* @__PURE__ */ function(e) {
  return e.disabled = "data-disabled", e.orientation = "data-orientation", e;
}({});
function mN(e) {
  const {
    abortControllerRef: t,
    animationTypeRef: n,
    externalRef: r,
    height: o,
    hiddenUntilFound: i,
    keepMounted: s,
    id: a,
    mounted: l,
    onOpenChange: c,
    open: u,
    panelRef: d,
    runOnceAnimationsFinish: f,
    setDimensions: h,
    setMounted: p,
    setOpen: g,
    setVisible: v,
    transitionDimensionRef: y,
    visible: b,
    width: w
  } = e, C = m.useRef(!1), x = m.useRef(null), E = m.useRef(u), S = m.useRef(u), R = Rs(), M = m.useMemo(() => n.current === "css-animation" ? !b : !u && !l, [u, l, b, n]), I = ve((k) => {
    if (!k)
      return;
    if (n.current == null || y.current == null) {
      const T = getComputedStyle(k), L = T.animationName !== "none" && T.animationName !== "", A = T.transitionDuration !== "0s" && T.transitionDuration !== "";
      L && A ? process.env.NODE_ENV !== "production" && Wy("CSS transitions and CSS animations both detected on Collapsible or Accordion panel.", "Only one of either animation type should be used.") : T.animationName === "none" && T.transitionDuration !== "0s" ? n.current = "css-transition" : T.animationName !== "none" && T.transitionDuration === "0s" ? n.current = "css-animation" : n.current = "none", k.getAttribute(gN.orientation) === "horizontal" || T.transitionProperty.indexOf("width") > -1 ? y.current = "width" : y.current = "height";
    }
    if (n.current !== "css-transition")
      return;
    (o === void 0 || w === void 0) && (h({
      height: k.scrollHeight,
      width: k.scrollWidth
    }), S.current && k.style.setProperty("transition-duration", "0s"));
    let O = -1, F = -1;
    return O = St.request(() => {
      S.current = !1, F = St.request(() => {
        setTimeout(() => {
          k.style.removeProperty("transition-duration");
        });
      });
    }), () => {
      St.cancel(O), St.cancel(F);
    };
  }), P = xr(r, d, I);
  return ge(() => {
    if (n.current !== "css-transition")
      return;
    const k = d.current;
    if (!k)
      return;
    let O = -1;
    if (t.current != null && (t.current.abort(), t.current = null), u) {
      const F = {
        "justify-content": k.style.justifyContent,
        "align-items": k.style.alignItems,
        "align-content": k.style.alignContent,
        "justify-items": k.style.justifyItems
      };
      Object.keys(F).forEach((T) => {
        k.style.setProperty(T, "initial", "important");
      }), !S.current && !s && k.setAttribute(is.startingStyle, ""), h({
        height: k.scrollHeight,
        width: k.scrollWidth
      }), O = St.request(() => {
        Object.entries(F).forEach(([T, L]) => {
          L === "" ? k.style.removeProperty(T) : k.style.setProperty(T, L);
        });
      });
    } else {
      if (k.scrollHeight === 0 && k.scrollWidth === 0)
        return;
      h({
        height: k.scrollHeight,
        width: k.scrollWidth
      });
      const F = new AbortController();
      t.current = F;
      const T = F.signal;
      let L = null;
      const A = is.endingStyle;
      return L = new MutationObserver((N) => {
        N.some(($) => $.type === "attributes" && $.attributeName === A) && (L == null || L.disconnect(), L = null, f(() => {
          h({
            height: 0,
            width: 0
          }), k.style.removeProperty("content-visibility"), p(!1), t.current === F && (t.current = null);
        }, T));
      }), L.observe(k, {
        attributes: !0,
        attributeFilter: [A]
      }), () => {
        L == null || L.disconnect(), R.cancel(), t.current === F && (F.abort(), t.current = null);
      };
    }
    return () => {
      St.cancel(O);
    };
  }, [t, n, R, i, s, l, u, d, f, h, p]), ge(() => {
    if (n.current !== "css-animation")
      return;
    const k = d.current;
    k && (x.current = k.style.animationName || x.current, k.style.setProperty("animation-name", "none"), h({
      height: k.scrollHeight,
      width: k.scrollWidth
    }), !E.current && !C.current && k.style.removeProperty("animation-name"), u ? (t.current != null && (t.current.abort(), t.current = null), p(!0), v(!0)) : (t.current = new AbortController(), f(() => {
      p(!1), v(!1), t.current = null;
    }, t.current.signal)));
  }, [t, n, u, d, f, h, p, v, b]), zl(() => {
    const k = St.request(() => {
      E.current = !1;
    });
    return () => St.cancel(k);
  }), ge(() => {
    if (!i)
      return;
    const k = d.current;
    if (!k)
      return;
    let O = -1, F = -1;
    return u && C.current && (k.style.transitionDuration = "0s", h({
      height: k.scrollHeight,
      width: k.scrollWidth
    }), O = St.request(() => {
      C.current = !1, F = St.request(() => {
        setTimeout(() => {
          k.style.removeProperty("transition-duration");
        });
      });
    })), () => {
      St.cancel(O), St.cancel(F);
    };
  }, [i, u, d, h]), ge(() => {
    const k = d.current;
    k && i && M && (k.setAttribute("hidden", "until-found"), n.current === "css-transition" && k.setAttribute(is.startingStyle, ""));
  }, [i, M, n, d]), m.useEffect(function() {
    const O = d.current;
    if (!O)
      return;
    function F(T) {
      C.current = !0, g(!0), c(!0, ke(_o, T));
    }
    return O.addEventListener("beforematch", F), () => {
      O.removeEventListener("beforematch", F);
    };
  }, [c, d, g]), m.useMemo(() => ({
    props: {
      hidden: M,
      id: a,
      ref: P
    }
  }), [M, a, P]);
}
let Tm = /* @__PURE__ */ function(e) {
  return e.disabled = "data-disabled", e.valid = "data-valid", e.invalid = "data-invalid", e.touched = "data-touched", e.dirty = "data-dirty", e.filled = "data-filled", e.focused = "data-focused", e;
}({});
const vN = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: null,
  valueMissing: !1
}, bN = {
  valid(e) {
    return e === null ? null : e ? {
      [Tm.valid]: ""
    } : {
      [Tm.invalid]: ""
    };
  }
}, jy = /* @__PURE__ */ m.createContext({
  invalid: void 0,
  name: void 0,
  validityData: {
    state: vN,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: vn,
  disabled: void 0,
  touched: !1,
  setTouched: vn,
  dirty: !1,
  setDirty: vn,
  filled: !1,
  setFilled: vn,
  focused: !1,
  setFocused: vn,
  validate: () => null,
  validationMode: "onSubmit",
  validationDebounceTime: 0,
  shouldValidateOnChange: () => !1,
  state: {
    disabled: !1,
    valid: null,
    touched: !1,
    dirty: !1,
    filled: !1,
    focused: !1
  },
  markedDirtyRef: {
    current: !1
  },
  validation: {
    getValidationProps: (e = Rt) => e,
    getInputValidationProps: (e = Rt) => e,
    inputRef: {
      current: null
    },
    commit: async () => {
    }
  }
});
process.env.NODE_ENV !== "production" && (jy.displayName = "FieldRootContext");
function th(e = !0) {
  const t = m.useContext(jy);
  if (t.setValidityData === vn && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>." : Ke(28));
  return t;
}
function yN(e, t) {
  return {
    ...e,
    state: {
      ...e.state,
      valid: !t && e.state.valid
    }
  };
}
const Uy = /* @__PURE__ */ m.createContext({
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  clearErrors: vn,
  validationMode: "onSubmit",
  submitAttemptedRef: {
    current: !1
  }
});
process.env.NODE_ENV !== "production" && (Uy.displayName = "FormContext");
function Yy() {
  return m.useContext(Uy);
}
function xN(e) {
  const {
    enabled: t = !0,
    value: n,
    id: r,
    name: o,
    controlRef: i,
    commit: s
  } = e, {
    formRef: a
  } = Yy(), {
    invalid: l,
    markedDirtyRef: c,
    validityData: u,
    setValidityData: d
  } = th(), f = ve(e.getValue);
  ge(() => {
    if (!t)
      return;
    let h = n;
    h === void 0 && (h = f()), u.initialValue === null && h !== null && d((p) => ({
      ...p,
      initialValue: h
    }));
  }, [t, d, n, u.initialValue, f]), ge(() => {
    !t || !r || a.current.fields.set(r, {
      getValue: f,
      name: o,
      controlRef: i,
      validityData: yN(u, l),
      validate(h = !0) {
        let p = n;
        p === void 0 && (p = f()), c.current = !0, h ? nn.flushSync(() => s(p)) : s(p);
      }
    });
  }, [s, i, t, a, f, r, l, c, o, u, n]), ge(() => {
    const h = a.current.fields;
    return () => {
      r && h.delete(r);
    };
  }, [a, r]);
}
const Gy = /* @__PURE__ */ m.createContext({
  controlId: void 0,
  setControlId: vn,
  labelId: void 0,
  setLabelId: vn,
  messageIds: [],
  setMessageIds: vn,
  getDescriptionProps: (e) => e
});
process.env.NODE_ENV !== "production" && (Gy.displayName = "LabelableContext");
function Ky() {
  return m.useContext(Gy);
}
function wN(e = {}) {
  const {
    id: t,
    implicit: n = !1,
    controlRef: r
  } = e, {
    controlId: o,
    setControlId: i
  } = Ky(), s = Kt(t);
  return ge(() => {
    if (!(!n && !t || i === vn)) {
      if (n) {
        const a = r == null ? void 0 : r.current;
        qe(a) && a.closest("label") != null ? i(t ?? null) : i(o ?? s);
      } else
        t && i(t);
      return () => {
        t && i(void 0);
      };
    }
  }, [t, r, o, i, n, s]), o ?? s;
}
function CN(e, t) {
  const n = m.useRef(e), r = ve(t);
  ge(() => {
    n.current !== e && r(n.current);
  }, [e, r]), ge(() => {
    n.current = e;
  }, [e]);
}
function _N(e) {
  const t = e.getBoundingClientRect();
  if (process.env.NODE_ENV === "test")
    return t;
  const n = window.getComputedStyle(e, "::before"), r = window.getComputedStyle(e, "::after");
  if (!(n.content !== "none" || r.content !== "none"))
    return t;
  const i = parseFloat(n.width) || 0, s = parseFloat(n.height) || 0, a = parseFloat(r.width) || 0, l = parseFloat(r.height) || 0, c = Math.max(t.width, i, a), u = Math.max(t.height, s, l), d = c - t.width, f = u - t.height;
  return {
    left: t.left - d / 2,
    right: t.right + d / 2,
    top: t.top - f / 2,
    bottom: t.bottom + f / 2
  };
}
const qy = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    orientation: i = "horizontal",
    ...s
  } = t, a = m.useMemo(() => ({
    orientation: i
  }), [i]);
  return Ie("div", t, {
    state: a,
    ref: n,
    props: [{
      role: "separator",
      "aria-orientation": i
    }, s]
  });
});
process.env.NODE_ENV !== "production" && (qy.displayName = "Separator");
const Xy = {
  ...hN,
  ...lr
}, Zy = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    defaultOpen: i = !1,
    disabled: s = !1,
    onOpenChange: a,
    open: l,
    ...c
  } = t, u = ve(a), d = aN({
    open: l,
    defaultOpen: i,
    onOpenChange: u,
    disabled: s
  }), f = m.useMemo(() => ({
    open: d.open,
    disabled: d.disabled,
    transitionStatus: d.transitionStatus
  }), [d.open, d.disabled, d.transitionStatus]), h = m.useMemo(() => ({
    ...d,
    onOpenChange: u,
    state: f
  }), [d, u, f]), p = Ie("div", t, {
    state: f,
    ref: n,
    props: c,
    stateAttributesMapping: Xy
  });
  return /* @__PURE__ */ _(eh.Provider, {
    value: h,
    children: p
  });
});
process.env.NODE_ENV !== "production" && (Zy.displayName = "CollapsibleRoot");
const EN = {
  ...fN,
  ...lr
}, Qy = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    panelId: r,
    open: o,
    handleTrigger: i,
    state: s,
    disabled: a
  } = zy(), {
    className: l,
    disabled: c = a,
    id: u,
    render: d,
    nativeButton: f = !0,
    ...h
  } = t, {
    getButtonProps: p,
    buttonRef: g
  } = Jr({
    disabled: c,
    focusableWhenDisabled: !0,
    native: f
  }), v = m.useMemo(() => ({
    "aria-controls": o ? r : void 0,
    "aria-expanded": o,
    onClick: i
  }), [r, o, i]);
  return Ie("button", t, {
    state: s,
    ref: [n, g],
    props: [v, h, p],
    stateAttributesMapping: EN
  });
});
process.env.NODE_ENV !== "production" && (Qy.displayName = "CollapsibleTrigger");
let km = /* @__PURE__ */ function(e) {
  return e.collapsiblePanelHeight = "--collapsible-panel-height", e.collapsiblePanelWidth = "--collapsible-panel-width", e;
}({});
const Jy = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    hiddenUntilFound: o,
    keepMounted: i,
    render: s,
    id: a,
    ...l
  } = t;
  process.env.NODE_ENV !== "production" && ge(() => {
    o && i === !1 && Wy("The `keepMounted={false}` prop on a Collapsible will be ignored when using `hiddenUntilFound` since it requires the Panel to remain mounted even when closed.");
  }, [o, i]);
  const {
    abortControllerRef: c,
    animationTypeRef: u,
    height: d,
    mounted: f,
    onOpenChange: h,
    open: p,
    panelId: g,
    panelRef: v,
    runOnceAnimationsFinish: y,
    setDimensions: b,
    setHiddenUntilFound: w,
    setKeepMounted: C,
    setMounted: x,
    setPanelIdState: E,
    setOpen: S,
    setVisible: R,
    state: M,
    transitionDimensionRef: I,
    visible: P,
    width: k,
    transitionStatus: O
  } = zy(), F = o ?? !1, T = i ?? !1;
  ge(() => {
    if (a)
      return E(a), () => {
        E(void 0);
      };
  }, [a, E]), ge(() => {
    w(F);
  }, [w, F]), ge(() => {
    C(T);
  }, [C, T]);
  const {
    props: L
  } = mN({
    abortControllerRef: c,
    animationTypeRef: u,
    externalRef: n,
    height: d,
    hiddenUntilFound: F,
    id: g,
    keepMounted: T,
    mounted: f,
    onOpenChange: h,
    open: p,
    panelRef: v,
    runOnceAnimationsFinish: y,
    setDimensions: b,
    setMounted: x,
    setOpen: S,
    setVisible: R,
    transitionDimensionRef: I,
    visible: P,
    width: k
  });
  Zr({
    open: p && O === "idle",
    ref: v,
    onComplete() {
      p && b({
        height: void 0,
        width: void 0
      });
    }
  });
  const A = m.useMemo(() => ({
    ...M,
    transitionStatus: O
  }), [M, O]), N = Ie("div", t, {
    state: A,
    ref: [n, v],
    props: [L, {
      style: {
        [km.collapsiblePanelHeight]: d === void 0 ? "auto" : `${d}px`,
        [km.collapsiblePanelWidth]: k === void 0 ? "auto" : `${k}px`
      }
    }, l],
    stateAttributesMapping: Xy
  });
  return T || F || !T && f ? N : null;
});
process.env.NODE_ENV !== "production" && (Jy.displayName = "CollapsiblePanel");
const e1 = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (e1.displayName = "ContextMenuRootContext");
function Bs(e = !0) {
  const t = m.useContext(e1);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ContextMenuRootContext is missing. ContextMenu parts must be placed within <ContextMenu.Root>." : Ke(25));
  return t;
}
const nh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (nh.displayName = "MenuPositionerContext");
function Hs(e) {
  const t = m.useContext(nh);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuPositionerContext is missing. MenuPositioner parts must be placed within <Menu.Positioner>." : Ke(33));
  return t;
}
const rh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (rh.displayName = "MenuRootContext");
function Ln(e) {
  const t = m.useContext(rh);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRootContext is missing. Menu parts must be placed within <Menu.Root>." : Ke(36));
  return t;
}
const SN = {
  ...Un,
  ...lr
}, t1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    ...i
  } = t, {
    store: s
  } = Ln(), a = s.useState("open"), l = s.useState("mounted"), c = s.useState("transitionStatus"), u = s.useState("lastOpenChangeReason"), d = Bs(), f = m.useMemo(() => ({
    open: a,
    transitionStatus: c
  }), [a, c]);
  return Ie("div", t, {
    ref: d != null && d.backdropRef ? [n, d.backdropRef] : n,
    state: f,
    stateAttributesMapping: SN,
    props: [{
      role: "presentation",
      hidden: !l,
      style: {
        pointerEvents: u === Dt ? "none" : void 0,
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, i]
  });
});
process.env.NODE_ENV !== "production" && (t1.displayName = "MenuBackdrop");
const oh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (oh.displayName = "MenuCheckboxItemContext");
function MN() {
  const e = m.useContext(oh);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuCheckboxItemContext is missing. MenuCheckboxItem parts must be placed within <Menu.CheckboxItem>." : Ke(30));
  return e;
}
const ih = {
  type: "regular-item"
};
function _c(e) {
  const {
    closeOnClick: t,
    disabled: n = !1,
    highlighted: r,
    id: o,
    store: i,
    nativeButton: s,
    itemMetadata: a,
    nodeId: l
  } = e, c = m.useRef(null), u = Bs(!0), d = u !== void 0, {
    events: f
  } = i.useState("floatingTreeRoot"), {
    getButtonProps: h,
    buttonRef: p
  } = Jr({
    disabled: n,
    focusableWhenDisabled: !0,
    native: s
  }), g = m.useCallback((y) => kn({
    id: o,
    role: "menuitem",
    tabIndex: r ? 0 : -1,
    onMouseMove(b) {
      l && f.emit("itemhover", {
        nodeId: l,
        target: b.currentTarget
      });
    },
    onMouseEnter() {
      a.type === "submenu-trigger" && a.setActive();
    },
    onKeyUp(b) {
      b.key === " " && i.context.typingRef.current && b.preventBaseUIHandler();
    },
    onClick(b) {
      t && f.emit("close", {
        domEvent: b,
        reason: ql
      });
    },
    onMouseUp(b) {
      if (u) {
        const w = u.initialCursorPointRef.current;
        if (u.initialCursorPointRef.current = null, d && w && Math.abs(b.clientX - w.x) <= 1 && Math.abs(b.clientY - w.y) <= 1)
          return;
      }
      c.current && i.context.allowMouseUpTriggerRef.current && (!d || b.button === 2) && a.type === "regular-item" && c.current.click();
    }
  }, y, h), [o, r, h, t, f, i, d, u, a, l]), v = xr(c, p);
  return m.useMemo(() => ({
    getItemProps: g,
    itemRef: v
  }), [g, v]);
}
let Pm = /* @__PURE__ */ function(e) {
  return e.checked = "data-checked", e.unchecked = "data-unchecked", e.disabled = "data-disabled", e.highlighted = "data-highlighted", e;
}({});
const Ec = {
  checked(e) {
    return e ? {
      [Pm.checked]: ""
    } : {
      [Pm.unchecked]: ""
    };
  },
  ...lr
}, n1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    id: i,
    label: s,
    nativeButton: a = !1,
    disabled: l = !1,
    closeOnClick: c = !1,
    checked: u,
    defaultChecked: d,
    onCheckedChange: f,
    ...h
  } = t, p = Ei({
    label: s
  }), g = Hs(!0), v = Kt(i), {
    store: y
  } = Ln(), b = y.useState("isActive", p.index), w = y.useState("itemProps"), [C, x] = Vs({
    controlled: u,
    default: d ?? !1,
    name: "MenuCheckboxItem",
    state: "checked"
  }), {
    getItemProps: E,
    itemRef: S
  } = _c({
    closeOnClick: c,
    disabled: l,
    highlighted: b,
    id: v,
    store: y,
    nativeButton: a,
    nodeId: g == null ? void 0 : g.nodeId,
    itemMetadata: ih
  }), R = m.useMemo(() => ({
    disabled: l,
    highlighted: b,
    checked: C
  }), [l, b, C]), M = ve((P) => {
    const k = {
      ...ke(ql, P.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    f == null || f(!C, k), !k.isCanceled && x((O) => !O);
  }), I = Ie("div", t, {
    state: R,
    stateAttributesMapping: Ec,
    props: [w, {
      role: "menuitemcheckbox",
      "aria-checked": C,
      onClick: M
    }, h, E],
    ref: [S, n, p.ref]
  });
  return /* @__PURE__ */ _(oh.Provider, {
    value: R,
    children: I
  });
});
process.env.NODE_ENV !== "production" && (n1.displayName = "MenuCheckboxItem");
const r1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    keepMounted: i = !1,
    ...s
  } = t, a = MN(), l = m.useRef(null), {
    transitionStatus: c,
    setMounted: u
  } = tc(a.checked);
  Zr({
    open: a.checked,
    ref: l,
    onComplete() {
      a.checked || u(!1);
    }
  });
  const d = m.useMemo(() => ({
    checked: a.checked,
    disabled: a.disabled,
    highlighted: a.highlighted,
    transitionStatus: c
  }), [a.checked, a.disabled, a.highlighted, c]);
  return Ie("span", t, {
    state: d,
    ref: [n, l],
    stateAttributesMapping: Ec,
    props: {
      "aria-hidden": !0,
      ...s
    },
    enabled: i || a.checked
  });
});
process.env.NODE_ENV !== "production" && (r1.displayName = "MenuCheckboxItemIndicator");
const sh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (sh.displayName = "MenuGroupContext");
function ON() {
  const e = m.useContext(sh);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuGroupRootContext is missing. Menu group parts must be used within <Menu.Group>." : Ke(31));
  return e;
}
const o1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    ...i
  } = t, [s, a] = m.useState(void 0), l = m.useMemo(() => ({
    setLabelId: a
  }), [a]), c = Ie("div", t, {
    ref: n,
    props: {
      role: "group",
      "aria-labelledby": s,
      ...i
    }
  });
  return /* @__PURE__ */ _(sh.Provider, {
    value: l,
    children: c
  });
});
process.env.NODE_ENV !== "production" && (o1.displayName = "MenuGroup");
const i1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    id: i,
    ...s
  } = t, a = Kt(i), {
    setLabelId: l
  } = ON();
  return ge(() => (l(a), () => {
    l(void 0);
  }), [l, a]), Ie("div", t, {
    ref: n,
    props: {
      id: a,
      role: "presentation",
      ...s
    }
  });
});
process.env.NODE_ENV !== "production" && (i1.displayName = "MenuGroupLabel");
const s1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    id: i,
    label: s,
    nativeButton: a = !1,
    disabled: l = !1,
    closeOnClick: c = !0,
    ...u
  } = t, d = Ei({
    label: s
  }), f = Hs(!0), h = Kt(i), {
    store: p
  } = Ln(), g = p.useState("isActive", d.index), v = p.useState("itemProps"), {
    getItemProps: y,
    itemRef: b
  } = _c({
    closeOnClick: c,
    disabled: l,
    highlighted: g,
    id: h,
    store: p,
    nativeButton: a,
    nodeId: f == null ? void 0 : f.nodeId,
    itemMetadata: ih
  }), w = m.useMemo(() => ({
    disabled: l,
    highlighted: g
  }), [l, g]);
  return Ie("div", t, {
    state: w,
    props: [v, u, y],
    ref: [b, n, d.ref]
  });
});
process.env.NODE_ENV !== "production" && (s1.displayName = "MenuItem");
const a1 = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (a1.displayName = "ToolbarRootContext");
function l1(e) {
  const t = m.useContext(a1);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToolbarRootContext is missing. Toolbar parts must be placed within <Toolbar.Root>." : Ke(69));
  return t;
}
const RN = {
  ...Un,
  ...lr
}, c1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    finalFocus: i,
    ...s
  } = t, {
    store: a
  } = Ln(), {
    side: l,
    align: c
  } = Hs(), u = l1(!0) != null, d = a.useState("open"), f = a.useState("transitionStatus"), h = a.useState("popupProps"), p = a.useState("mounted"), g = a.useState("instantType"), v = a.useState("activeTriggerElement"), y = a.useState("parent"), b = a.useState("lastOpenChangeReason"), w = a.useState("rootId"), C = a.useState("floatingRootContext"), x = a.useState("floatingTreeRoot"), E = a.useState("closeDelay"), S = a.useState("activeTriggerElement"), R = y.type === "context-menu";
  Zr({
    open: d,
    ref: a.context.popupRef,
    onComplete() {
      var F, T;
      d && ((T = (F = a.context).onOpenChangeComplete) == null || T.call(F, !0));
    }
  }), m.useEffect(() => {
    function F(T) {
      a.setOpen(!1, ke(T.reason, T.domEvent));
    }
    return x.events.on("close", F), () => {
      x.events.off("close", F);
    };
  }, [x.events, a]);
  const M = a.useState("hoverEnabled"), I = a.useState("disabled");
  sf(C, {
    enabled: M && !I && !R && y.type !== "menubar",
    closeDelay: E
  });
  const P = m.useMemo(() => ({
    transitionStatus: f,
    side: l,
    align: c,
    open: d,
    nested: y.type === "menu",
    instant: g
  }), [f, l, c, d, y.type, g]), k = Ie("div", t, {
    state: P,
    ref: [n, a.context.popupRef],
    stateAttributesMapping: RN,
    props: [h, {
      onKeyDown(F) {
        u && xf.has(F.key) && F.stopPropagation();
      }
    }, ks(f), s, {
      "data-rootownerid": w
    }]
  });
  let O = y.type === void 0 || R;
  return (v || y.type === "menubar" && b !== qd) && (O = !0), /* @__PURE__ */ _(ef, {
    context: C,
    modal: R,
    disabled: !p,
    returnFocus: i === void 0 ? O : i,
    initialFocus: y.type !== "menu",
    restoreFocus: !0,
    externalTree: y.type !== "menubar" ? x : void 0,
    previousFocusableElement: S,
    nextFocusableElement: y.type === void 0 ? a.context.triggerFocusTargetRef : void 0,
    beforeContentFocusGuardRef: y.type === void 0 ? a.context.beforeContentFocusGuardRef : void 0,
    children: k
  });
});
process.env.NODE_ENV !== "production" && (c1.displayName = "MenuPopup");
const ah = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (ah.displayName = "MenuPortalContext");
function TN() {
  const e = m.useContext(ah);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Portal> is missing." : Ke(32));
  return e;
}
const u1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t, {
    store: i
  } = Ln();
  return i.useState("mounted") || r ? /* @__PURE__ */ _(ah.Provider, {
    value: r,
    children: /* @__PURE__ */ _(Zl, {
      ref: n,
      ...o
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (u1.displayName = "MenuPortal");
const d1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  var ne;
  const {
    anchor: r,
    positionMethod: o = "absolute",
    className: i,
    render: s,
    side: a,
    align: l,
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: h = 5,
    sticky: p = !1,
    disableAnchorTracking: g = !1,
    collisionAvoidance: v = m_,
    ...y
  } = t, {
    store: b
  } = Ln(), w = TN(), C = Bs(!0), x = b.useState("parent"), E = b.useState("floatingRootContext"), S = b.useState("floatingTreeRoot"), R = b.useState("mounted"), M = b.useState("open"), I = b.useState("modal"), P = b.useState("activeTriggerElement"), k = b.useState("lastOpenChangeReason"), O = b.useState("floatingNodeId"), F = b.useState("floatingParentNodeId");
  let T = r, L = c, A = u, N = l, B = v;
  x.type === "context-menu" && (T = r ?? ((ne = x.context) == null ? void 0 : ne.anchor), N = N ?? "start", !a && N !== "center" && (A = t.alignOffset ?? 2, L = t.sideOffset ?? -5));
  let $ = a, U = N;
  x.type === "menu" ? ($ = $ ?? "inline-end", U = U ?? "start", B = t.collisionAvoidance ?? Ad) : x.type === "menubar" && ($ = $ ?? "bottom", U = U ?? "start");
  const G = x.type === "context-menu", H = ff({
    anchor: T,
    floatingRootContext: E,
    positionMethod: C ? "fixed" : o,
    mounted: R,
    side: $,
    sideOffset: L,
    align: U,
    alignOffset: A,
    arrowPadding: G ? 0 : h,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: p,
    nodeId: O,
    keepMounted: w,
    disableAnchorTracking: g,
    collisionAvoidance: B,
    shiftCrossAxis: G,
    externalTree: S
  }), q = m.useMemo(() => {
    const Q = {};
    return M || (Q.pointerEvents = "none"), {
      role: "presentation",
      hidden: !R,
      style: {
        ...H.positionerStyles,
        ...Q
      }
    };
  }, [M, R, H.positionerStyles]);
  m.useEffect(() => {
    function Q(D) {
      D.open ? (D.parentNodeId === O && b.set("hoverEnabled", !1), D.nodeId !== O && D.parentNodeId === b.select("floatingParentNodeId") && b.setOpen(!1, ke(ji))) : D.parentNodeId === O && D.reason !== ji && b.set("hoverEnabled", !0);
    }
    return S.events.on("menuopenchange", Q), () => {
      S.events.off("menuopenchange", Q);
    };
  }, [b, S.events, O]), m.useEffect(() => {
    if (b.select("floatingParentNodeId") == null)
      return;
    function Q(D) {
      if (D.open || D.nodeId !== b.select("floatingParentNodeId"))
        return;
      const te = D.reason ?? ji;
      b.setOpen(!1, ke(te));
    }
    return S.events.on("menuopenchange", Q), () => {
      S.events.off("menuopenchange", Q);
    };
  }, [S.events, b]), m.useEffect(() => {
    function Q(D) {
      !M || D.nodeId !== b.select("floatingParentNodeId") || D.target && P && P !== D.target && b.setOpen(!1, ke(ji));
    }
    return S.events.on("itemhover", Q), () => {
      S.events.off("itemhover", Q);
    };
  }, [S.events, M, P, b]), m.useEffect(() => {
    const Q = {
      open: M,
      nodeId: O,
      parentNodeId: F,
      reason: b.select("lastOpenChangeReason")
    };
    S.events.emit("menuopenchange", Q);
  }, [S.events, M, b, O, F]);
  const j = m.useMemo(() => ({
    open: M,
    side: H.side,
    align: H.align,
    anchorHidden: H.anchorHidden,
    nested: x.type === "menu"
  }), [M, H.side, H.align, H.anchorHidden, x.type]), W = m.useMemo(() => ({
    side: H.side,
    align: H.align,
    arrowRef: H.arrowRef,
    arrowUncentered: H.arrowUncentered,
    arrowStyles: H.arrowStyles,
    nodeId: H.context.nodeId
  }), [H.side, H.align, H.arrowRef, H.arrowUncentered, H.arrowStyles, H.context.nodeId]), z = Ie("div", t, {
    state: j,
    stateAttributesMapping: Un,
    ref: [n, b.useStateSetter("positionerElement")],
    props: [q, y]
  }), X = R && x.type !== "menu" && (x.type !== "menubar" && I && k !== Dt || x.type === "menubar" && x.context.modal);
  let J = null;
  return x.type === "menubar" ? J = x.context.contentElement : x.type === void 0 && (J = P), /* @__PURE__ */ Z(nh.Provider, {
    value: W,
    children: [X && /* @__PURE__ */ _(pc, {
      ref: x.type === "context-menu" || x.type === "nested-context-menu" ? x.context.internalBackdropRef : null,
      inert: hf(!M),
      cutout: J
    }), /* @__PURE__ */ _(kb, {
      id: O,
      children: /* @__PURE__ */ _(Jf, {
        elementsRef: b.context.itemDomElements,
        labelsRef: b.context.itemLabels,
        children: z
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (d1.displayName = "MenuPositioner");
const lh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (lh.displayName = "MenuRadioGroupContext");
function kN() {
  const e = m.useContext(lh);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioGroupContext is missing. MenuRadioGroup parts must be placed within <Menu.RadioGroup>." : Ke(34));
  return e;
}
const f1 = /* @__PURE__ */ m.memo(/* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    value: i,
    defaultValue: s,
    onValueChange: a,
    disabled: l = !1,
    ...c
  } = t, [u, d] = Vs({
    controlled: i,
    default: s,
    name: "MenuRadioGroup"
  }), f = ve(a), h = ve((y, b) => {
    f == null || f(y, b), !b.isCanceled && d(y);
  }), p = m.useMemo(() => ({
    disabled: l
  }), [l]), g = Ie("div", t, {
    state: p,
    ref: n,
    props: {
      role: "group",
      "aria-disabled": l || void 0,
      ...c
    }
  }), v = m.useMemo(() => ({
    value: u,
    setValue: h,
    disabled: l
  }), [u, h, l]);
  return /* @__PURE__ */ _(lh.Provider, {
    value: v,
    children: g
  });
}));
process.env.NODE_ENV !== "production" && (f1.displayName = "MenuRadioGroup");
const ch = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (ch.displayName = "MenuRadioItemContext");
function PN() {
  const e = m.useContext(ch);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioItemContext is missing. MenuRadioItem parts must be placed within <Menu.RadioItem>." : Ke(35));
  return e;
}
const h1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    id: i,
    label: s,
    nativeButton: a = !1,
    disabled: l = !1,
    closeOnClick: c = !1,
    value: u,
    ...d
  } = t, f = Ei({
    label: s
  }), h = Hs(!0), p = Kt(i), {
    store: g
  } = Ln(), v = g.useState("isActive", f.index), y = g.useState("itemProps"), {
    value: b,
    setValue: w,
    disabled: C
  } = kN(), x = C || l, E = b === u, {
    getItemProps: S,
    itemRef: R
  } = _c({
    closeOnClick: c,
    disabled: x,
    highlighted: v,
    id: p,
    store: g,
    nativeButton: a,
    nodeId: h == null ? void 0 : h.nodeId,
    itemMetadata: ih
  }), M = m.useMemo(() => ({
    disabled: x,
    highlighted: v,
    checked: E
  }), [x, v, E]), I = ve((k) => {
    const O = {
      ...ke(ql, k.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    w(u, O);
  }), P = Ie("div", t, {
    state: M,
    stateAttributesMapping: Ec,
    props: [y, {
      role: "menuitemradio",
      "aria-checked": E,
      onClick: I
    }, d, S],
    ref: [R, n, f.ref]
  });
  return /* @__PURE__ */ _(ch.Provider, {
    value: M,
    children: P
  });
});
process.env.NODE_ENV !== "production" && (h1.displayName = "MenuRadioItem");
const p1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    keepMounted: i = !1,
    ...s
  } = t, a = PN(), l = m.useRef(null), {
    transitionStatus: c,
    setMounted: u
  } = tc(a.checked);
  Zr({
    open: a.checked,
    ref: l,
    onComplete() {
      a.checked || u(!1);
    }
  });
  const d = m.useMemo(() => ({
    checked: a.checked,
    disabled: a.disabled,
    highlighted: a.highlighted,
    transitionStatus: c
  }), [a.checked, a.disabled, a.highlighted, c]);
  return Ie("span", t, {
    state: d,
    stateAttributesMapping: Ec,
    ref: [n, l],
    props: {
      "aria-hidden": !0,
      ...s
    },
    enabled: i || a.checked
  });
});
process.env.NODE_ENV !== "production" && (p1.displayName = "MenuRadioItemIndicator");
const g1 = /* @__PURE__ */ m.createContext(null);
process.env.NODE_ENV !== "production" && (g1.displayName = "MenubarContext");
function m1(e) {
  const t = m.useContext(g1);
  if (t === null && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenubarContext is missing. Menubar parts must be placed within <Menubar>." : Ke(5));
  return t;
}
const IN = {
  ...sc,
  disabled: Ee((e) => e.parent.type === "menubar" && e.parent.context.disabled || e.disabled),
  modal: Ee((e) => (e.parent.type === void 0 || e.parent.type === "context-menu") && (e.modal ?? !0)),
  allowMouseEnter: Ee((e) => e.parent.type === "menu" ? e.parent.store.select("allowMouseEnter") : e.allowMouseEnter),
  stickIfOpen: Ee((e) => e.stickIfOpen),
  parent: Ee((e) => e.parent),
  rootId: Ee((e) => e.parent.type === "menu" ? e.parent.store.select("rootId") : e.parent.type !== void 0 ? e.parent.context.rootId : e.rootId),
  activeIndex: Ee((e) => e.activeIndex),
  isActive: Ee((e, t) => e.activeIndex === t),
  hoverEnabled: Ee((e) => e.hoverEnabled),
  instantType: Ee((e) => e.instantType),
  lastOpenChangeReason: Ee((e) => e.openChangeReason),
  floatingTreeRoot: Ee((e) => e.parent.type === "menu" ? e.parent.store.select("floatingTreeRoot") : e.floatingTreeRoot),
  floatingNodeId: Ee((e) => e.floatingNodeId),
  floatingParentNodeId: Ee((e) => e.floatingParentNodeId),
  itemProps: Ee((e) => e.itemProps),
  closeDelay: Ee((e) => e.closeDelay),
  keyboardEventRelay: Ee((e) => {
    if (e.keyboardEventRelay)
      return e.keyboardEventRelay;
    if (e.parent.type === "menu")
      return e.parent.store.select("keyboardEventRelay");
  })
};
class uh extends Ts {
  constructor(n) {
    super({
      ...NN(),
      ...n
    }, {
      positionerRef: /* @__PURE__ */ m.createRef(),
      popupRef: /* @__PURE__ */ m.createRef(),
      typingRef: {
        current: !1
      },
      itemDomElements: {
        current: []
      },
      itemLabels: {
        current: []
      },
      allowMouseUpTriggerRef: {
        current: !1
      },
      triggerFocusTargetRef: /* @__PURE__ */ m.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ m.createRef(),
      onOpenChangeComplete: void 0,
      triggerElements: new _i()
    }, IN);
    ae(this, "unsubscribeParentListener", null);
    this.observe(Ee((r) => r.allowMouseEnter), (r, o) => {
      this.state.parent.type === "menu" && r !== o && this.state.parent.store.set("allowMouseEnter", r);
    }), this.unsubscribeParentListener = this.observe("parent", (r) => {
      var o;
      if ((o = this.unsubscribeParentListener) == null || o.call(this), r.type === "menu") {
        this.unsubscribeParentListener = r.store.subscribe(() => {
          this.notifyAll();
        }), this.context.allowMouseUpTriggerRef = r.store.context.allowMouseUpTriggerRef;
        return;
      }
      r.type !== void 0 && (this.context.allowMouseUpTriggerRef = r.context.allowMouseUpTriggerRef), this.unsubscribeParentListener = null;
    });
  }
  setOpen(n, r) {
    this.state.floatingRootContext.context.events.emit("setOpen", {
      open: n,
      eventDetails: r
    });
  }
  static useStore(n, r) {
    const o = rn(() => new uh(r)).current;
    return n ?? o;
  }
}
function NN() {
  return {
    ...ic(),
    disabled: !1,
    modal: !0,
    allowMouseEnter: !0,
    stickIfOpen: !0,
    parent: {
      type: void 0
    },
    rootId: void 0,
    activeIndex: null,
    hoverEnabled: !0,
    instantType: void 0,
    openChangeReason: null,
    floatingTreeRoot: new Ud(),
    floatingNodeId: void 0,
    floatingParentNodeId: null,
    itemProps: Rt,
    keyboardEventRelay: void 0,
    closeDelay: 0
  };
}
const dh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (dh.displayName = "MenuSubmenuRootContext");
function v1() {
  return m.useContext(dh);
}
function b1(e) {
  const {
    children: t,
    open: n,
    onOpenChange: r,
    onOpenChangeComplete: o,
    defaultOpen: i = !1,
    disabled: s = !1,
    modal: a,
    loopFocus: l = !0,
    orientation: c = "vertical",
    actionsRef: u,
    closeParentOnEsc: d = !1,
    handle: f,
    triggerId: h,
    defaultTriggerId: p = null,
    highlightItemOnHover: g = !0
  } = e, v = Bs(!0), y = Ln(!0), b = m1(!0), w = v1(), C = m.useMemo(() => w && y ? {
    type: "menu",
    store: y.store
  } : b ? {
    type: "menubar",
    context: b
  } : v && !y ? {
    type: "context-menu",
    context: v
  } : {
    type: void 0
  }, [v, y, b, w]), x = uh.useStore(f == null ? void 0 : f.store, {
    parent: C
  }), E = x.useState("floatingTreeRoot"), S = Kd(E), R = ar();
  ge(() => {
    v && !y ? x.update({
      parent: {
        type: "context-menu",
        context: v
      },
      floatingNodeId: S,
      floatingParentNodeId: R
    }) : y && x.update({
      floatingNodeId: S,
      floatingParentNodeId: R
    });
  }, [v, y, S, R, x]), x.useControlledProp("open", n, i), x.useControlledProp("activeTriggerId", h, p), x.useContextCallback("onOpenChangeComplete", o);
  const M = x.useState("open"), I = x.useState("activeTriggerElement"), P = x.useState("positionerElement"), k = x.useState("hoverEnabled"), O = x.useState("modal"), F = x.useState("disabled"), T = x.useState("lastOpenChangeReason"), L = x.useState("parent"), A = x.useState("activeIndex"), N = x.useState("payload"), B = x.useState("floatingParentNodeId"), $ = m.useRef(null), U = B != null;
  let G;
  process.env.NODE_ENV !== "production" && L.type !== void 0 && a !== void 0 && console.warn("Base UI: The `modal` prop is not supported on nested menus. It will be ignored."), x.useSyncedValues({
    disabled: s,
    modal: L.type === void 0 ? a : void 0,
    rootId: Do()
  });
  const {
    openMethod: H,
    triggerProps: q,
    reset: j
  } = Ef(M);
  rc(x);
  const {
    forceUnmount: W
  } = oc(M, x, () => {
    x.update({
      allowMouseEnter: !1,
      stickIfOpen: !0
    }), j();
  }), z = m.useRef(L.type !== "context-menu"), X = un();
  m.useEffect(() => {
    if (M || ($.current = null), L.type === "context-menu") {
      if (!M) {
        X.clear(), z.current = !1;
        return;
      }
      X.start(500, () => {
        z.current = !0;
      });
    }
  }, [X, M, L.type]), _f(M && O && T !== Dt && H !== "touch", P), ge(() => {
    !M && !k && x.set("hoverEnabled", !0);
  }, [M, k, x]);
  const J = m.useRef(!0), ne = un(), Q = ve((Te, Je) => {
    const Vt = Je.reason;
    if (M === Te && Je.trigger === I && T === Vt || (Je.preventUnmountOnClose = () => {
      x.set("preventUnmountingOnClose", !0);
    }, !Te && Je.trigger == null && (Je.trigger = I ?? void 0), r == null || r(Te, Je), Je.isCanceled))
      return;
    const $o = {
      open: Te,
      nativeEvent: Je.event,
      reason: Je.reason,
      nested: U
    };
    G == null || G.emit("openchange", $o);
    const fn = Je.event;
    if (Te === !1 && (fn == null ? void 0 : fn.type) === "click" && fn.pointerType === "touch" && !J.current)
      return;
    if (!Te && A !== null) {
      const yt = x.context.itemDomElements.current[A];
      queueMicrotask(() => {
        yt == null || yt.setAttribute("tabindex", "-1");
      });
    }
    Te && Vt === Jo ? (J.current = !1, ne.start(300, () => {
      J.current = !0;
    })) : (J.current = !0, ne.clear());
    const nt = (Vt === Tn || Vt === ql) && fn.detail === 0 && (fn == null ? void 0 : fn.isTrusted), Et = !Te && (Vt === Os || Vt == null);
    function Bt() {
      var _n;
      const yt = {
        open: Te,
        openChangeReason: Vt
      };
      $.current = Je.event ?? null;
      const hn = ((_n = Je.trigger) == null ? void 0 : _n.id) ?? null;
      (hn || Te) && (yt.activeTriggerId = hn, yt.activeTriggerElement = Je.trigger ?? null), x.update(yt);
    }
    Vt === Dt ? nn.flushSync(Bt) : Bt(), L.type === "menubar" && (Vt === Jo || Vt === _r || Vt === Dt || Vt === Va || Vt === ji) ? x.set("instantType", "group") : nt || Et ? x.set("instantType", nt ? "click" : "dismiss") : x.set("instantType", void 0);
  }), D = m.useCallback((Te) => {
    const Je = ke(Te);
    return Je.preventUnmountOnClose = () => {
      x.set("preventUnmountingOnClose", !0);
    }, Je;
  }, [x]), te = m.useCallback(() => {
    x.setOpen(!1, D(Xl));
  }, [x, D]);
  m.useImperativeHandle(u, () => ({
    unmount: W,
    close: te
  }), [W, te]);
  let K;
  L.type === "context-menu" && (K = L.context), m.useImperativeHandle(K == null ? void 0 : K.positionerRef, () => P, [P]), m.useImperativeHandle(K == null ? void 0 : K.actionsRef, () => ({
    setOpen: Q
  }), [Q]);
  const ce = ac({
    popupStore: x,
    onOpenChange: Q
  });
  G = ce.context.events, m.useEffect(() => {
    const Te = ({
      open: Je,
      eventDetails: Vt
    }) => Q(Je, Vt);
    return G.on("setOpen", Te), () => {
      G == null || G.off("setOpen", Te);
    };
  }, [G, Q]);
  const ee = ec(ce, {
    enabled: !F,
    bubbles: {
      escapeKey: d && L.type === "menu"
    },
    outsidePress() {
      var Te;
      return L.type !== "context-menu" || ((Te = $.current) == null ? void 0 : Te.type) === "contextmenu" ? !0 : z.current;
    },
    externalTree: U ? E : void 0
  }), re = af(ce, {
    role: "menu"
  }), le = fc(), de = m.useCallback((Te) => {
    x.select("activeIndex") !== Te && x.set("activeIndex", Te);
  }, [x]), be = W2(ce, {
    enabled: !F,
    listRef: x.context.itemDomElements,
    activeIndex: A,
    nested: L.type !== void 0,
    loopFocus: l,
    orientation: c,
    parentOrientation: L.type === "menubar" ? L.context.orientation : void 0,
    rtl: le === "rtl",
    disabledIndices: wo,
    onNavigate: de,
    openOnArrowKeyDown: L.type !== "context-menu",
    externalTree: U ? E : void 0,
    focusItemOnHover: g
  }), ye = m.useCallback((Te) => {
    x.context.typingRef.current = Te;
  }, [x]), Ce = j2(ce, {
    listRef: x.context.itemLabels,
    activeIndex: A,
    resetMs: p_,
    onMatch: (Te) => {
      M && Te !== A && x.set("activeIndex", Te);
    },
    onTypingChange: ye
  }), {
    getReferenceProps: ie,
    getFloatingProps: he,
    getItemProps: fe,
    getTriggerProps: Se
  } = Qr([ee, re, be, Ce]), Me = m.useMemo(() => {
    const Te = kn(ie(), {
      onMouseEnter() {
        x.set("hoverEnabled", !0);
      },
      onMouseMove() {
        x.set("allowMouseEnter", !0);
      }
    }, q);
    return delete Te.role, Te;
  }, [ie, x, q]), $e = m.useMemo(() => {
    const Te = Se();
    if (!Te)
      return Te;
    const Je = kn(Te, q);
    return delete Je.role, delete Je["aria-controls"], Je;
  }, [Se, q]), Ne = Rs(), Fe = m.useMemo(() => he({
    onMouseEnter() {
      L.type === "menu" && Ne.request(() => x.set("hoverEnabled", !1));
    },
    onMouseMove() {
      x.set("allowMouseEnter", !0);
    },
    onClick() {
      x.select("hoverEnabled") && x.set("hoverEnabled", !1);
    },
    onKeyDown(Te) {
      const Je = x.select("keyboardEventRelay");
      Je && !Te.isPropagationStopped() && Je(Te);
    }
  }), [he, L.type, Ne, x]), Ae = m.useMemo(() => fe(), [fe]);
  x.useSyncedValues({
    floatingRootContext: ce,
    activeTriggerProps: Me,
    inactiveTriggerProps: $e,
    popupProps: Fe,
    itemProps: Ae
  });
  const bt = m.useMemo(() => ({
    store: x,
    parent: C
  }), [x, C]), Pt = /* @__PURE__ */ _(rh.Provider, {
    value: bt,
    children: typeof t == "function" ? t({
      payload: N
    }) : t
  });
  return L.type === void 0 || L.type === "context-menu" ? /* @__PURE__ */ _(Pb, {
    externalTree: E,
    children: Pt
  }) : Pt;
}
function DN(e) {
  const t = Ln().store, n = m.useMemo(() => ({
    parentMenu: t
  }), [t]);
  return /* @__PURE__ */ _(dh.Provider, {
    value: n,
    children: /* @__PURE__ */ _(b1, {
      ...e
    })
  });
}
function y1(e = {}) {
  const {
    highlightItemOnHover: t,
    highlightedIndex: n,
    onHighlightedIndexChange: r
  } = vf(), {
    ref: o,
    index: i
  } = Ei(e), s = n === i, a = m.useRef(null), l = xr(o, a);
  return {
    compositeProps: m.useMemo(() => ({
      tabIndex: s ? 0 : -1,
      onFocus() {
        r(i);
      },
      onMouseMove() {
        const u = a.current;
        if (!t || !u)
          return;
        const d = u.hasAttribute("disabled") || u.ariaDisabled === "true";
        !s && !d && u.focus();
      }
    }), [s, r, i, t]),
    compositeRef: l,
    index: i
  };
}
function AN(e) {
  const {
    render: t,
    className: n,
    state: r = Rt,
    props: o = wo,
    refs: i = wo,
    metadata: s,
    stateAttributesMapping: a,
    tag: l = "div",
    ...c
  } = e, {
    compositeProps: u,
    compositeRef: d
  } = y1({
    metadata: s
  });
  return Ie(l, e, {
    state: r,
    ref: [...i, d],
    props: [u, ...o, c],
    stateAttributesMapping: a
  });
}
function x1(e) {
  if (gt(e) && e.hasAttribute("data-rootownerid"))
    return e.getAttribute("data-rootownerid") ?? void 0;
  if (!Jn(e))
    return x1(nr(e));
}
function LN(e) {
  const {
    enabled: t = !0,
    mouseDownAction: n,
    open: r
  } = e, o = m.useRef(!1);
  return m.useMemo(() => t ? {
    onMouseDown: (i) => {
      (n === "open" && !r || n === "close" && r) && (o.current = !0, Pn(i.currentTarget).addEventListener("click", () => {
        o.current = !1;
      }, {
        once: !0
      }));
    },
    onClick: (i) => {
      o.current && (o.current = !1, i.preventBaseUIHandler());
    }
  } : Rt, [t, n, r]);
}
const Sa = 2, w1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    disabled: i = !1,
    nativeButton: s = !0,
    id: a,
    openOnHover: l,
    delay: c = 100,
    closeDelay: u = 0,
    handle: d,
    payload: f,
    ...h
  } = t, p = Ln(!0), g = (d == null ? void 0 : d.store) ?? (p == null ? void 0 : p.store);
  if (!g)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Trigger> must be either used within a <Menu.Root> component or provided with a handle." : Ke(85));
  const v = Kt(a), y = g.useState("isTriggerActive", v), b = g.useState("floatingRootContext"), w = g.useState("isOpenedByTrigger", v), C = m.useRef(null), x = FN(), E = vf(!0), S = Xr(), R = m.useMemo(() => S ?? new Ud(), [S]), M = Kd(R), I = ar(), {
    registerTrigger: P,
    isMountedByThisTrigger: k
  } = nc(v, C, g, {
    payload: f,
    closeDelay: u,
    parent: x,
    floatingTreeRoot: R,
    floatingNodeId: M,
    floatingParentNodeId: I,
    keyboardEventRelay: E == null ? void 0 : E.relayKeyboardEvent
  }), O = x.type === "menubar", F = g.useState("disabled"), T = i || F || O && x.context.disabled, {
    getButtonProps: L,
    buttonRef: A
  } = Jr({
    disabled: T,
    native: s
  });
  m.useEffect(() => {
    !w && x.type === void 0 && (g.context.allowMouseUpTriggerRef.current = !1);
  }, [g, w, x.type]);
  const N = m.useRef(null), B = un(), $ = ve((re) => {
    if (!N.current)
      return;
    B.clear(), g.context.allowMouseUpTriggerRef.current = !1;
    const le = re.target;
    if (Ve(N.current, le) || Ve(g.select("positionerElement"), le) || le === N.current || le != null && x1(le) === g.select("rootId"))
      return;
    const de = _N(N.current);
    re.clientX >= de.left - Sa && re.clientX <= de.right + Sa && re.clientY >= de.top - Sa && re.clientY <= de.bottom + Sa || R.events.emit("close", {
      domEvent: re,
      reason: XE
    });
  });
  m.useEffect(() => {
    w && g.select("lastOpenChangeReason") === Dt && Pn(N.current).addEventListener("mouseup", $, {
      once: !0
    });
  }, [w, $, g]);
  const U = O && x.context.hasSubmenuOpen, H = lc(b, {
    enabled: (l ?? U) && !T && x.type !== "context-menu" && (!O || U && !k),
    handleClose: uc({
      blockPointerEvents: !O
    }),
    mouseOnly: !0,
    move: !1,
    restMs: x.type === void 0 ? c : void 0,
    delay: {
      close: u
    },
    triggerElementRef: C,
    externalTree: R,
    isActiveTrigger: y
  }), q = $N(w, g.select("lastOpenChangeReason")), j = Ql(b, {
    enabled: !T && x.type !== "context-menu",
    event: w && O ? "click" : "mousedown",
    toggle: !0,
    ignoreMouse: !1,
    stickIfOpen: x.type === void 0 ? q : !1
  }), W = Gb(b, {
    enabled: !T && U
  }), z = LN({
    open: w,
    enabled: O,
    mouseDownAction: "open"
  }), X = Qr([j, W]), J = m.useMemo(() => ({
    disabled: T,
    open: w
  }), [T, w]), ne = g.useState("triggerProps", k), Q = [N, n, A, P, C], D = [X.getReferenceProps(), H ?? Rt, ne, {
    "aria-haspopup": "menu",
    id: v,
    onMouseDown: (re) => {
      if (g.select("open"))
        return;
      B.start(200, () => {
        g.context.allowMouseUpTriggerRef.current = !0;
      }), Pn(re.currentTarget).addEventListener("mouseup", $, {
        once: !0
      });
    }
  }, O ? {
    role: "menuitem"
  } : {}, z, h, L], te = m.useRef(null), K = ve((re) => {
    nn.flushSync(() => {
      g.setOpen(!1, ke(_r, re.nativeEvent, re.currentTarget));
    });
    const le = Rb(te.current);
    le == null || le.focus();
  }), ce = ve((re) => {
    var de;
    const le = g.select("positionerElement");
    if (le && bo(re, le))
      (de = g.context.beforeContentFocusGuardRef.current) == null || de.focus();
    else {
      nn.flushSync(() => {
        g.setOpen(!1, ke(_r, re.nativeEvent, re.currentTarget));
      });
      let be = Ob(g.context.triggerFocusTargetRef.current || C.current);
      for (; be !== null && Ve(le, be); ) {
        const ye = be;
        if (be = Kl(be), be === ye)
          break;
      }
      be == null || be.focus();
    }
  }), ee = Ie("button", t, {
    enabled: !O,
    stateAttributesMapping: Qu,
    state: J,
    ref: Q,
    props: D
  });
  return O ? /* @__PURE__ */ _(AN, {
    tag: "button",
    render: r,
    className: o,
    state: J,
    refs: Q,
    props: D,
    stateAttributesMapping: Qu
  }) : w ? /* @__PURE__ */ Z(m.Fragment, {
    children: [/* @__PURE__ */ _(Er, {
      ref: te,
      onFocus: K
    }, `${v}-pre-focus-guard`), /* @__PURE__ */ _(m.Fragment, {
      children: ee
    }, v), /* @__PURE__ */ _(Er, {
      ref: g.context.triggerFocusTargetRef,
      onFocus: ce
    }, `${v}-post-focus-guard`)]
  }) : /* @__PURE__ */ _(m.Fragment, {
    children: ee
  }, v);
});
process.env.NODE_ENV !== "production" && (w1.displayName = "MenuTrigger");
function $N(e, t) {
  const n = un(), [r, o] = m.useState(!1);
  return ge(() => {
    e && t === "trigger-hover" ? (o(!0), n.start(Yv, () => {
      o(!1);
    })) : e || (n.clear(), o(!1));
  }, [e, t, n]), r;
}
function FN() {
  const e = Bs(!0), t = Ln(!0), n = m1(!0);
  return m.useMemo(() => n ? {
    type: "menubar",
    context: n
  } : e && !t ? {
    type: "context-menu",
    context: e
  } : {
    type: void 0
  }, [e, t, n]);
}
const C1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    label: i,
    id: s,
    nativeButton: a = !1,
    openOnHover: l = !0,
    delay: c = 100,
    closeDelay: u = 0,
    disabled: d = !1,
    ...f
  } = t, h = Ei(), p = Hs(), {
    store: g
  } = Ln(), v = Kt(s), y = g.useState("open"), b = g.useState("floatingRootContext"), w = g.useState("floatingTreeRoot"), C = Yb(v, g), x = m.useCallback((j) => {
    const W = C(j);
    return j !== null && g.select("open") && g.select("activeTriggerId") == null && g.update({
      activeTriggerId: v,
      activeTriggerElement: j,
      closeDelay: u
    }), W;
  }, [C, u, g, v]), E = m.useRef(null), S = m.useCallback((j) => {
    E.current = j, g.set("activeTriggerElement", j);
  }, [g]), R = v1();
  if (!(R != null && R.parentMenu))
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.SubmenuTrigger> must be placed in <Menu.SubmenuRoot>." : Ke(37));
  g.useSyncedValue("closeDelay", u);
  const M = R.parentMenu, I = M.useState("itemProps"), P = M.useState("isActive", h.index), k = m.useMemo(() => ({
    type: "submenu-trigger",
    setActive: () => M.set("activeIndex", h.index)
  }), [M, h.index]), O = g.useState("disabled"), F = d || O, {
    getItemProps: T,
    itemRef: L
  } = _c({
    closeOnClick: !1,
    disabled: F,
    highlighted: P,
    id: v,
    store: g,
    nativeButton: a,
    itemMetadata: k,
    nodeId: p == null ? void 0 : p.nodeId
  }), A = g.useState("hoverEnabled"), N = g.useState("allowMouseEnter"), B = lc(b, {
    enabled: A && l && !F && N,
    handleClose: uc({
      blockPointerEvents: !0
    }),
    mouseOnly: !0,
    move: !0,
    restMs: c,
    delay: {
      open: c,
      close: u
    },
    triggerElementRef: E,
    externalTree: w
  }), $ = Ql(b, {
    enabled: !F,
    event: "mousedown",
    toggle: !l,
    ignoreMouse: l,
    stickIfOpen: !1
  }), U = Qr([$]), G = g.useState("triggerProps", !0);
  delete G.id;
  const H = m.useMemo(() => ({
    disabled: F,
    highlighted: P,
    open: y
  }), [F, P, y]);
  return Ie("div", t, {
    state: H,
    stateAttributesMapping: dc,
    props: [U.getReferenceProps(), B, G, I, {
      tabIndex: y || P ? 0 : -1,
      onBlur() {
        P && M.set("activeIndex", null);
      }
    }, f, T],
    ref: [n, h.ref, L, x, S]
  });
});
process.env.NODE_ENV !== "production" && (C1.displayName = "MenuSubmenuTrigger");
const _1 = "data-composite-item-active", VN = [];
function BN(e) {
  const {
    itemSizes: t,
    cols: n = 1,
    loopFocus: r = !0,
    dense: o = !1,
    orientation: i = "both",
    direction: s,
    highlightedIndex: a,
    onHighlightedIndexChange: l,
    rootRef: c,
    enableHomeAndEndKeys: u = !1,
    stopEventPropagation: d = !1,
    disabledIndices: f,
    modifierKeys: h = VN
  } = e, [p, g] = m.useState(0), v = n > 1, y = m.useRef(null), b = xr(y, c), w = m.useRef([]), C = m.useRef(!1), x = a ?? p, E = ve((M, I = !1) => {
    if ((l ?? g)(M), I) {
      const P = w.current[M];
      qp(y.current, P, s, i);
    }
  }), S = ve((M) => {
    if (M.size === 0 || C.current)
      return;
    C.current = !0;
    const I = Array.from(M.keys()), P = I.find((O) => O == null ? void 0 : O.hasAttribute(_1)) ?? null, k = P ? I.indexOf(P) : -1;
    k !== -1 && E(k), qp(y.current, P, s, i);
  }), R = m.useMemo(() => ({
    "aria-orientation": i === "both" ? void 0 : i,
    ref: b,
    onFocus(M) {
      !y.current || !Kp(M.target) || M.target.setSelectionRange(0, M.target.value.length ?? 0);
    },
    onKeyDown(M) {
      const I = u ? wM : u0;
      if (!I.has(M.key) || HN(M, h) || !y.current)
        return;
      const k = s === "rtl", O = k ? ds : ri, F = {
        horizontal: O,
        vertical: po,
        both: O
      }[i], T = k ? ri : ds, L = {
        horizontal: T,
        vertical: ni,
        both: T
      }[i];
      if (Kp(M.target) && !pN(M.target)) {
        const H = M.target.selectionStart, q = M.target.selectionEnd, j = M.target.value ?? "";
        if (H == null || M.shiftKey || H !== q || M.key !== L && H < j.length || M.key !== F && H > 0)
          return;
      }
      let A = x;
      const N = Fa(w, f), B = Uu(w, f);
      if (v) {
        const H = t || Array.from({
          length: w.current.length
        }, () => ({
          width: 1,
          height: 1
        })), q = pb(H, n, o), j = q.findIndex((z) => z != null && !zr(w, z, f)), W = q.reduce((z, X, J) => X != null && !zr(w, X, f) ? J : z, -1);
        A = q[hb({
          current: q.map((z) => z ? w.current[z] : null)
        }, {
          event: M,
          orientation: i,
          loopFocus: r,
          cols: n,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: mb([...f || w.current.map((z, X) => zr(w, X) ? X : void 0), void 0], q),
          minIndex: j,
          maxIndex: W,
          prevIndex: gb(
            x > B ? N : x,
            H,
            q,
            n,
            // use a corner matching the edge closest to the direction we're
            // moving in so we don't end up in the same item. Prefer
            // top/left over bottom/right.
            // eslint-disable-next-line no-nested-ternary
            M.key === po ? "bl" : M.key === ri ? "tr" : "tl"
          ),
          rtl: k
        })];
      }
      const $ = {
        horizontal: [O],
        vertical: [po],
        both: [O, po]
      }[i], U = {
        horizontal: [T],
        vertical: [ni],
        both: [T, ni]
      }[i], G = v ? I : {
        horizontal: u ? yM : l0,
        vertical: u ? xM : c0,
        both: I
      }[i];
      u && (M.key === Ps ? A = N : M.key === Is && (A = B)), A === x && ($.includes(M.key) || U.includes(M.key)) && (r && A === B && $.includes(M.key) ? A = N : r && A === N && U.includes(M.key) ? A = B : A = Yt(w, {
        startingIndex: A,
        decrement: U.includes(M.key),
        disabledIndices: f
      })), A !== x && !Qo(w, A) && (d && M.stopPropagation(), G.has(M.key) && M.preventDefault(), E(A, !0), queueMicrotask(() => {
        var H;
        (H = w.current[A]) == null || H.focus();
      }));
    }
  }), [n, o, s, f, w, u, x, v, t, r, b, h, E, i, d]);
  return m.useMemo(() => ({
    props: R,
    highlightedIndex: x,
    onHighlightedIndexChange: E,
    elementsRef: w,
    disabledIndices: f,
    onMapChange: S,
    relayKeyboardEvent: R.onKeyDown
  }), [R, x, E, w, f, S]);
}
function HN(e, t) {
  for (const n of MM.values())
    if (!t.includes(n) && e.getModifierState(n))
      return !0;
  return !1;
}
function WN(e) {
  const {
    render: t,
    className: n,
    refs: r = wo,
    props: o = wo,
    state: i = Rt,
    stateAttributesMapping: s,
    highlightedIndex: a,
    onHighlightedIndexChange: l,
    orientation: c,
    dense: u,
    itemSizes: d,
    loopFocus: f,
    cols: h,
    enableHomeAndEndKeys: p,
    onMapChange: g,
    stopEventPropagation: v = !0,
    rootRef: y,
    disabledIndices: b,
    modifierKeys: w,
    highlightItemOnHover: C = !1,
    tag: x = "div",
    ...E
  } = e, S = fc(), {
    props: R,
    highlightedIndex: M,
    onHighlightedIndexChange: I,
    elementsRef: P,
    onMapChange: k,
    relayKeyboardEvent: O
  } = BN({
    itemSizes: d,
    cols: h,
    loopFocus: f,
    dense: u,
    orientation: c,
    highlightedIndex: a,
    onHighlightedIndexChange: l,
    rootRef: y,
    stopEventPropagation: v,
    enableHomeAndEndKeys: p,
    direction: S,
    disabledIndices: b,
    modifierKeys: w
  }), F = Ie(x, e, {
    state: i,
    ref: r,
    props: [R, ...o, E],
    stateAttributesMapping: s
  }), T = m.useMemo(() => ({
    highlightedIndex: M,
    onHighlightedIndexChange: I,
    highlightItemOnHover: C,
    relayKeyboardEvent: O
  }), [M, I, C, O]);
  return /* @__PURE__ */ _(mf.Provider, {
    value: T,
    children: /* @__PURE__ */ _(Jf, {
      elementsRef: P,
      onMapChange: (L) => {
        g == null || g(L), k(L);
      },
      children: F
    })
  });
}
const Im = /* @__PURE__ */ new Map();
function zN(e, t) {
  const n = JSON.stringify({
    locale: e,
    options: t
  }), r = Im.get(n);
  if (r)
    return r;
  const o = new Intl.NumberFormat(e, t);
  return Im.set(n, o), o;
}
function Nm(e, t, n) {
  return e == null ? "" : zN(t, n).format(e);
}
function jN(e, t, n) {
  return (e - t) * 100 / (n - t);
}
const fh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (fh.displayName = "PopoverRootContext");
function Ws(e) {
  const t = m.useContext(fh);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverRootContext is missing. Popover parts must be placed within <Popover.Root>." : Ke(47));
  return t;
}
function UN() {
  return {
    ...ic(),
    disabled: !1,
    modal: !1,
    instantType: void 0,
    openMethod: null,
    openChangeReason: null,
    titleElementId: void 0,
    descriptionElementId: void 0,
    stickIfOpen: !0,
    nested: !1,
    openOnHover: !1,
    closeDelay: 0,
    hasViewport: !1
  };
}
const YN = {
  ...sc,
  disabled: Ee((e) => e.disabled),
  instantType: Ee((e) => e.instantType),
  openMethod: Ee((e) => e.openMethod),
  openChangeReason: Ee((e) => e.openChangeReason),
  modal: Ee((e) => e.modal),
  stickIfOpen: Ee((e) => e.stickIfOpen),
  titleElementId: Ee((e) => e.titleElementId),
  descriptionElementId: Ee((e) => e.descriptionElementId),
  openOnHover: Ee((e) => e.openOnHover),
  closeDelay: Ee((e) => e.closeDelay),
  hasViewport: Ee((e) => e.hasViewport)
};
class hh extends Ts {
  constructor(n) {
    const r = {
      ...UN(),
      ...n
    };
    r.open && (n == null ? void 0 : n.mounted) === void 0 && (r.mounted = !0);
    super(r, {
      popupRef: /* @__PURE__ */ m.createRef(),
      backdropRef: /* @__PURE__ */ m.createRef(),
      internalBackdropRef: /* @__PURE__ */ m.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerFocusTargetRef: /* @__PURE__ */ m.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ m.createRef(),
      stickIfOpenTimeout: new wr(),
      triggerElements: new _i()
    }, YN);
    ae(this, "setOpen", (n, r) => {
      var u, d;
      const o = r.reason === Dt, i = r.reason === Tn && r.event.detail === 0, s = !n && (r.reason === Os || r.reason == null);
      if (r.preventUnmountOnClose = () => {
        this.set("preventUnmountingOnClose", !0);
      }, (d = (u = this.context).onOpenChange) == null || d.call(u, n, r), r.isCanceled)
        return;
      const a = {
        open: n,
        nativeEvent: r.event,
        reason: r.reason,
        nested: this.state.nested,
        triggerElement: r.trigger
      }, l = this.state.floatingRootContext.context.events;
      l == null || l.emit("openchange", a);
      const c = () => {
        var p;
        const f = {
          open: n,
          openChangeReason: r.reason
        }, h = ((p = r.trigger) == null ? void 0 : p.id) ?? null;
        (h || n) && (f.activeTriggerId = h, f.activeTriggerElement = r.trigger ?? null), this.update(f);
      };
      o ? (this.set("stickIfOpen", !0), this.context.stickIfOpenTimeout.start(Yv, () => {
        this.set("stickIfOpen", !1);
      }), nn.flushSync(c)) : c(), i || s ? this.set("instantType", i ? "click" : "dismiss") : r.reason === _r ? this.set("instantType", "focus") : this.set("instantType", void 0);
    });
    ae(this, "disposeEffect", () => this.context.stickIfOpenTimeout.disposeEffect());
  }
  static useStore(n, r) {
    const o = rn(() => new hh(r)).current, i = n ?? o;
    return zl(o.disposeEffect), i;
  }
}
function Dm({
  props: e
}) {
  const {
    children: t,
    open: n,
    defaultOpen: r = !1,
    onOpenChange: o,
    onOpenChangeComplete: i,
    modal: s = !1,
    handle: a,
    triggerId: l,
    defaultTriggerId: c = null
  } = e, u = hh.useStore(a == null ? void 0 : a.store, {
    open: n ?? r,
    modal: s,
    activeTriggerId: l !== void 0 ? l : c
  });
  u.useControlledProp("open", n, r), u.useControlledProp("activeTriggerId", l, c);
  const d = u.useState("open"), f = u.useState("positionerElement"), h = u.useState("payload"), p = u.useState("openChangeReason");
  u.useContextCallback("onOpenChange", o), u.useContextCallback("onOpenChangeComplete", i);
  const {
    openMethod: g,
    triggerProps: v,
    reset: y
  } = Ef(d);
  rc(u);
  const {
    forceUnmount: b
  } = oc(d, u, () => {
    u.update({
      stickIfOpen: !0,
      openChangeReason: null
    }), y();
  });
  _f(d && s === !0 && p !== Dt && g !== "touch", f), m.useEffect(() => {
    d || u.context.stickIfOpenTimeout.clear();
  }, [u, d]);
  const w = m.useCallback((T) => {
    const L = ke(T);
    return L.preventUnmountOnClose = () => {
      u.set("preventUnmountingOnClose", !0);
    }, L;
  }, [u]), C = m.useCallback(() => {
    u.setOpen(!1, w(Xl));
  }, [u, w]);
  m.useImperativeHandle(e.actionsRef, () => ({
    unmount: b,
    close: C
  }), [b, C]);
  const x = ac({
    popupStore: u,
    onOpenChange: u.setOpen
  }), E = ec(x, {
    outsidePressEvent: {
      // Ensure `aria-hidden` on outside elements is removed immediately
      // on outside press when trapping focus.
      mouse: s === "trap-focus" ? "sloppy" : "intentional",
      touch: "sloppy"
    }
  }), S = af(x), {
    getReferenceProps: R,
    getFloatingProps: M,
    getTriggerProps: I
  } = Qr([E, S]), P = m.useMemo(() => R(v), [R, v]), k = m.useMemo(() => I(v), [I, v]), O = m.useMemo(() => M(), [M]);
  u.useSyncedValues({
    modal: s,
    openMethod: g,
    activeTriggerProps: P,
    inactiveTriggerProps: k,
    popupProps: O,
    floatingRootContext: x,
    nested: ar() != null
  });
  const F = m.useMemo(() => ({
    store: u
  }), [u]);
  return /* @__PURE__ */ _(fh.Provider, {
    value: F,
    children: typeof t == "function" ? t({
      payload: h
    }) : t
  });
}
function GN(e) {
  return Ws(!0) ? /* @__PURE__ */ _(Dm, {
    props: e
  }) : /* @__PURE__ */ _(Pb, {
    children: /* @__PURE__ */ _(Dm, {
      props: e
    })
  });
}
const KN = 300, E1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    disabled: i = !1,
    nativeButton: s = !0,
    handle: a,
    payload: l,
    openOnHover: c = !1,
    delay: u = KN,
    closeDelay: d = 0,
    id: f,
    ...h
  } = t, p = Ws(!0), g = (a == null ? void 0 : a.store) ?? (p == null ? void 0 : p.store);
  if (!g)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Trigger> must be either used within a <Popover.Root> component or provided with a handle." : Ke(74));
  const v = Kt(f), y = g.useState("isTriggerActive", v), b = g.useState("floatingRootContext"), w = g.useState("isOpenedByTrigger", v), C = m.useRef(null), {
    registerTrigger: x,
    isMountedByThisTrigger: E
  } = nc(v, C, g, {
    payload: l,
    disabled: i,
    openOnHover: c,
    closeDelay: d
  }), S = g.useState("openChangeReason"), R = g.useState("stickIfOpen"), M = g.useState("openMethod"), I = lc(b, {
    enabled: b != null && c && (M !== "touch" || S !== Tn),
    mouseOnly: !0,
    move: !1,
    handleClose: uc(),
    restMs: u,
    delay: {
      close: d
    },
    triggerElementRef: C,
    isActiveTrigger: y
  }), P = Ql(b, {
    enabled: b != null,
    stickIfOpen: R
  }), k = Qr([P]), O = g.useState("triggerProps", E), F = m.useMemo(() => ({
    disabled: i,
    open: w
  }), [i, w]), {
    getButtonProps: T,
    buttonRef: L
  } = Jr({
    disabled: i,
    native: s
  }), A = m.useMemo(() => ({
    open(G) {
      return G && S === Tn ? Qu.open(G) : dc.open(G);
    }
  }), [S]), N = Ie("button", t, {
    state: F,
    ref: [L, n, x, C],
    props: [k.getReferenceProps(), I, O, {
      [Dd]: "",
      id: v
    }, h, T],
    stateAttributesMapping: A
  }), B = m.useRef(null), $ = ve((G) => {
    nn.flushSync(() => {
      g.setOpen(!1, ke(_r, G.nativeEvent, G.currentTarget));
    });
    const H = Rb(B.current);
    H == null || H.focus();
  }), U = ve((G) => {
    var q;
    const H = g.select("positionerElement");
    if (H && bo(G, H))
      (q = g.context.beforeContentFocusGuardRef.current) == null || q.focus();
    else {
      nn.flushSync(() => {
        g.setOpen(!1, ke(_r, G.nativeEvent, G.currentTarget));
      });
      let j = Ob(g.context.triggerFocusTargetRef.current || C.current);
      for (; j !== null && Ve(H, j); ) {
        const W = j;
        if (j = Kl(j), j === W)
          break;
      }
      j == null || j.focus();
    }
  });
  return y ? /* @__PURE__ */ Z(m.Fragment, {
    children: [/* @__PURE__ */ _(Er, {
      ref: B,
      onFocus: $
    }), /* @__PURE__ */ _(m.Fragment, {
      children: N
    }, v), /* @__PURE__ */ _(Er, {
      ref: g.context.triggerFocusTargetRef,
      onFocus: U
    })]
  }) : /* @__PURE__ */ _(m.Fragment, {
    children: N
  }, v);
});
process.env.NODE_ENV !== "production" && (E1.displayName = "PopoverTrigger");
const ph = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (ph.displayName = "PopoverPortalContext");
function qN() {
  const e = m.useContext(ph);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Portal> is missing." : Ke(45));
  return e;
}
const S1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t, {
    store: i
  } = Ws();
  return i.useState("mounted") || r ? /* @__PURE__ */ _(ph.Provider, {
    value: r,
    children: /* @__PURE__ */ _(Zl, {
      ref: n,
      ...o,
      renderGuards: !1
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (S1.displayName = "PopoverPortal");
const gh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (gh.displayName = "PopoverPositionerContext");
function XN() {
  const e = m.useContext(gh);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverPositionerContext is missing. PopoverPositioner parts must be placed within <Popover.Positioner>." : Ke(46));
  return e;
}
const M1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    anchor: i,
    positionMethod: s = "absolute",
    side: a = "bottom",
    align: l = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: h = 5,
    sticky: p = !1,
    disableAnchorTracking: g = !1,
    collisionAvoidance: v = Ad,
    ...y
  } = t, {
    store: b
  } = Ws(), w = qN(), C = Kd(), x = b.useState("floatingRootContext"), E = b.useState("mounted"), S = b.useState("open"), R = b.useState("openChangeReason"), M = b.useState("activeTriggerElement"), I = b.useState("modal"), P = b.useState("positionerElement"), k = b.useState("instantType"), O = b.useState("transitionStatus"), F = b.useState("hasViewport"), T = m.useRef(null), L = of(P, !1, !1), A = ff({
    anchor: i,
    floatingRootContext: x,
    positionMethod: s,
    mounted: E,
    side: a,
    sideOffset: c,
    align: l,
    alignOffset: u,
    arrowPadding: h,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: p,
    disableAnchorTracking: g,
    keepMounted: w,
    nodeId: C,
    collisionAvoidance: v,
    adaptiveOrigin: F ? e0 : void 0
  }), N = m.useMemo(() => {
    const q = {};
    return S || (q.pointerEvents = "none"), {
      role: "presentation",
      hidden: !E,
      style: {
        ...A.positionerStyles,
        ...q
      }
    };
  }, [S, E, A.positionerStyles]), B = m.useMemo(() => ({
    props: N,
    ...A
  }), [N, A]), $ = x == null ? void 0 : x.select("domReferenceElement");
  ge(() => {
    const q = $, j = T.current;
    if (q && (T.current = q), j && q && q !== j) {
      b.set("instantType", void 0);
      const W = new AbortController();
      return L(() => {
        b.set("instantType", "trigger-change");
      }, W.signal), () => {
        W.abort();
      };
    }
  }, [$, L, b]);
  const U = m.useMemo(() => ({
    open: S,
    side: B.side,
    align: B.align,
    anchorHidden: B.anchorHidden,
    instant: k
  }), [S, B.side, B.align, B.anchorHidden, k]), G = m.useCallback((q) => {
    b.set("positionerElement", q);
  }, [b]), H = Ie("div", t, {
    state: U,
    props: [B.props, ks(O), y],
    ref: [n, G],
    stateAttributesMapping: Un
  });
  return /* @__PURE__ */ Z(gh.Provider, {
    value: B,
    children: [E && I === !0 && R !== Dt && /* @__PURE__ */ _(pc, {
      ref: b.context.internalBackdropRef,
      inert: hf(!S),
      cutout: M
    }), /* @__PURE__ */ _(kb, {
      id: C,
      children: H
    })]
  });
});
process.env.NODE_ENV !== "production" && (M1.displayName = "PopoverPositioner");
const ZN = {
  ...Un,
  ...lr
}, O1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    initialFocus: i,
    finalFocus: s,
    ...a
  } = t, {
    store: l
  } = Ws(), c = XN(), u = l1(!0) != null, d = l.useState("open"), f = l.useState("openMethod"), h = l.useState("instantType"), p = l.useState("transitionStatus"), g = l.useState("popupProps"), v = l.useState("titleElementId"), y = l.useState("descriptionElementId"), b = l.useState("modal"), w = l.useState("mounted"), C = l.useState("openChangeReason"), x = l.useState("activeTriggerElement"), E = l.useState("floatingRootContext");
  Zr({
    open: d,
    ref: l.context.popupRef,
    onComplete() {
      var T, L;
      d && ((L = (T = l.context).onOpenChangeComplete) == null || L.call(T, !0));
    }
  });
  const S = l.useState("disabled"), R = l.useState("openOnHover"), M = l.useState("closeDelay");
  sf(E, {
    enabled: R && !S,
    closeDelay: M
  });
  function I(T) {
    return T === "touch" ? l.context.popupRef.current : !0;
  }
  const P = i === void 0 ? I : i, k = m.useMemo(() => ({
    open: d,
    side: c.side,
    align: c.align,
    instant: h,
    transitionStatus: p
  }), [d, c.side, c.align, h, p]), O = m.useCallback((T) => {
    l.set("popupElement", T);
  }, [l]), F = Ie("div", t, {
    state: k,
    ref: [n, l.context.popupRef, O],
    props: [g, {
      "aria-labelledby": v,
      "aria-describedby": y,
      onKeyDown(T) {
        u && xf.has(T.key) && T.stopPropagation();
      }
    }, ks(p), a],
    stateAttributesMapping: ZN
  });
  return /* @__PURE__ */ _(ef, {
    context: E,
    openInteractionType: f,
    modal: b === "trap-focus",
    disabled: !w || C === Dt,
    initialFocus: P,
    returnFocus: s,
    restoreFocus: "popup",
    previousFocusableElement: gt(x) ? x : void 0,
    nextFocusableElement: l.context.triggerFocusTargetRef,
    beforeContentFocusGuardRef: l.context.beforeContentFocusGuardRef,
    children: F
  });
});
process.env.NODE_ENV !== "production" && (O1.displayName = "PopoverPopup");
const mh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (mh.displayName = "ProgressRootContext");
function Sc() {
  const e = m.useContext(mh);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ProgressRootContext is missing. Progress parts must be placed within <Progress.Root>." : Ke(51));
  return e;
}
let fu = /* @__PURE__ */ function(e) {
  return e.complete = "data-complete", e.indeterminate = "data-indeterminate", e.progressing = "data-progressing", e;
}({});
const zs = {
  status(e) {
    return e === "progressing" ? {
      [fu.progressing]: ""
    } : e === "complete" ? {
      [fu.complete]: ""
    } : e === "indeterminate" ? {
      [fu.indeterminate]: ""
    } : null;
  }
};
function QN(e, t, n) {
  return e == null ? "" : n ? Nm(e, t, n) : Nm(e / 100, t, {
    style: "percent"
  });
}
function JN(e, t) {
  return t == null ? "indeterminate progress" : e || `${t}%`;
}
const R1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    format: r,
    getAriaValueText: o = JN,
    locale: i,
    max: s = 100,
    min: a = 0,
    value: l,
    render: c,
    className: u,
    ...d
  } = t, [f, h] = m.useState(), p = Gt(r);
  let g = "indeterminate";
  Number.isFinite(l) && (g = l === s ? "complete" : "progressing");
  const v = QN(l, i, p.current), y = m.useMemo(() => ({
    status: g
  }), [g]), b = {
    "aria-labelledby": f,
    "aria-valuemax": s,
    "aria-valuemin": a,
    "aria-valuenow": l ?? void 0,
    "aria-valuetext": o(v, l),
    role: "progressbar"
  }, w = m.useMemo(() => ({
    formattedValue: v,
    max: s,
    min: a,
    setLabelId: h,
    state: y,
    status: g,
    value: l
  }), [v, s, a, h, y, g, l]), C = Ie("div", t, {
    state: y,
    ref: n,
    props: [b, d],
    stateAttributesMapping: zs
  });
  return /* @__PURE__ */ _(mh.Provider, {
    value: w,
    children: C
  });
});
process.env.NODE_ENV !== "production" && (R1.displayName = "ProgressRoot");
const T1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    ...i
  } = t, {
    state: s
  } = Sc();
  return Ie("div", t, {
    state: s,
    ref: n,
    props: i,
    stateAttributesMapping: zs
  });
});
process.env.NODE_ENV !== "production" && (T1.displayName = "ProgressTrack");
const k1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    ...i
  } = t, {
    max: s,
    min: a,
    value: l,
    state: c
  } = Sc(), u = Number.isFinite(l) && l !== null ? jN(l, a, s) : null, d = m.useCallback(() => u == null ? {} : {
    insetInlineStart: 0,
    height: "inherit",
    width: `${u}%`
  }, [u]);
  return Ie("div", t, {
    state: c,
    ref: n,
    props: [{
      style: d()
    }, i],
    stateAttributesMapping: zs
  });
});
process.env.NODE_ENV !== "production" && (k1.displayName = "ProgressIndicator");
const P1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    children: i,
    ...s
  } = t, {
    value: a,
    formattedValue: l,
    state: c
  } = Sc(), u = a == null ? "indeterminate" : l, d = a == null ? null : l;
  return Ie("span", t, {
    state: c,
    ref: n,
    props: [{
      "aria-hidden": !0,
      children: typeof i == "function" ? i(u, a) : d
    }, s],
    stateAttributesMapping: zs
  });
});
process.env.NODE_ENV !== "production" && (P1.displayName = "ProgressValue");
const I1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    id: i,
    ...s
  } = t, a = Kt(i), {
    setLabelId: l,
    state: c
  } = Sc();
  return ge(() => (l(a), () => l(void 0)), [a, l]), Ie("span", t, {
    state: c,
    ref: n,
    props: [{
      id: a
    }, s],
    stateAttributesMapping: zs
  });
});
process.env.NODE_ENV !== "production" && (I1.displayName = "ProgressLabel");
const vh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (vh.displayName = "SwitchRootContext");
function eD() {
  const e = m.useContext(vh);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SwitchRootContext is missing. Switch parts must be placed within <Switch.Root>." : Ke(63));
  return e;
}
let Am = /* @__PURE__ */ function(e) {
  return e.checked = "data-checked", e.unchecked = "data-unchecked", e.disabled = "data-disabled", e.readonly = "data-readonly", e.required = "data-required", e.valid = "data-valid", e.invalid = "data-invalid", e.touched = "data-touched", e.dirty = "data-dirty", e.filled = "data-filled", e.focused = "data-focused", e;
}({});
const N1 = {
  ...bN,
  checked(e) {
    return e ? {
      [Am.checked]: ""
    } : {
      [Am.unchecked]: ""
    };
  }
}, D1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    checked: r,
    className: o,
    defaultChecked: i,
    id: s,
    inputRef: a,
    name: l,
    nativeButton: c = !1,
    onCheckedChange: u,
    readOnly: d = !1,
    required: f = !1,
    disabled: h = !1,
    render: p,
    uncheckedValue: g,
    value: v,
    ...y
  } = t, {
    clearErrors: b
  } = Yy(), {
    state: w,
    setTouched: C,
    setDirty: x,
    validityData: E,
    setFilled: S,
    setFocused: R,
    shouldValidateOnChange: M,
    validationMode: I,
    disabled: P,
    name: k,
    validation: O
  } = th(), {
    labelId: F
  } = Ky(), T = P || h, L = k ?? l, A = ve(u), N = m.useRef(null), B = xr(N, a, O.inputRef), $ = m.useRef(null), U = Kt(), G = wN({
    id: s,
    implicit: !1,
    controlRef: $
  }), H = c ? void 0 : G, [q, j] = Vs({
    controlled: r,
    default: !!i,
    name: "Switch",
    state: "checked"
  });
  xN({
    id: U,
    commit: O.commit,
    value: q,
    controlRef: $,
    name: L,
    getValue: () => q
  }), ge(() => {
    N.current && S(N.current.checked);
  }, [N, S]), CN(q, () => {
    b(L), x(q !== E.initialValue), S(q), M() ? O.commit(q) : O.commit(q, !0);
  });
  const {
    getButtonProps: W,
    buttonRef: z
  } = Jr({
    disabled: T,
    native: c
  }), X = {
    id: c ? G : U,
    role: "switch",
    "aria-checked": q,
    "aria-readonly": d || void 0,
    "aria-required": f || void 0,
    "aria-labelledby": F,
    onFocus() {
      T || R(!0);
    },
    onBlur() {
      const D = N.current;
      !D || T || (C(!0), R(!1), I === "onBlur" && O.commit(D.checked));
    },
    onClick(D) {
      var te;
      d || T || (D.preventDefault(), (te = N == null ? void 0 : N.current) == null || te.click());
    }
  }, J = m.useMemo(() => kn(
    {
      checked: q,
      disabled: T,
      id: H,
      name: L,
      required: f,
      style: L ? eS : Zd,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      ref: B,
      onChange(D) {
        if (D.nativeEvent.defaultPrevented)
          return;
        const te = D.target.checked, K = ke(_o, D.nativeEvent);
        A == null || A(te, K), !K.isCanceled && j(te);
      },
      onFocus() {
        var D;
        (D = $.current) == null || D.focus();
      }
    },
    O.getInputValidationProps,
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    v !== void 0 ? {
      value: v
    } : Rt
  ), [q, T, B, H, L, A, f, j, O, v]), ne = m.useMemo(() => ({
    ...w,
    checked: q,
    disabled: T,
    readOnly: d,
    required: f
  }), [w, q, T, d, f]), Q = Ie("span", t, {
    state: ne,
    ref: [n, $, z],
    props: [X, O.getValidationProps, y, W],
    stateAttributesMapping: N1
  });
  return /* @__PURE__ */ Z(vh.Provider, {
    value: ne,
    children: [Q, !q && L && g !== void 0 && /* @__PURE__ */ _("input", {
      type: "hidden",
      name: L,
      value: g
    }), /* @__PURE__ */ _("input", {
      ...J
    })]
  });
});
process.env.NODE_ENV !== "production" && (D1.displayName = "SwitchRoot");
const A1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    ...i
  } = t, {
    state: s
  } = th(), a = eD(), l = {
    ...s,
    ...a
  };
  return Ie("span", t, {
    state: l,
    ref: n,
    stateAttributesMapping: N1,
    props: i
  });
});
process.env.NODE_ENV !== "production" && (A1.displayName = "SwitchThumb");
const bh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (bh.displayName = "TabsRootContext");
function yh() {
  const e = m.useContext(bh);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsRootContext is missing. Tabs parts must be placed within <Tabs.Root>." : Ke(64));
  return e;
}
let tD = /* @__PURE__ */ function(e) {
  return e.activationDirection = "data-activation-direction", e.orientation = "data-orientation", e;
}({});
const xh = {
  tabActivationDirection: (e) => ({
    [tD.activationDirection]: e
  })
}, L1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    defaultValue: o = 0,
    onValueChange: i,
    orientation: s = "horizontal",
    render: a,
    value: l,
    ...c
  } = t, u = fc(), d = Object.hasOwn(t, "defaultValue"), f = m.useRef([]), [h, p] = m.useState(() => /* @__PURE__ */ new Map()), [g, v] = Vs({
    controlled: l,
    default: o,
    name: "Tabs",
    state: "value"
  }), y = l !== void 0, [b, w] = m.useState(() => /* @__PURE__ */ new Map()), [C, x] = m.useState("none"), E = ve((A, N) => {
    i == null || i(A, N), !N.isCanceled && (v(A), x(N.activationDirection));
  }), S = ve((A, N) => {
    p((B) => {
      if (B.get(A) === N)
        return B;
      const $ = new Map(B);
      return $.set(A, N), $;
    });
  }), R = ve((A, N) => {
    p((B) => {
      if (!B.has(A) || B.get(A) !== N)
        return B;
      const $ = new Map(B);
      return $.delete(A), $;
    });
  }), M = m.useCallback((A) => h.get(A), [h]), I = m.useCallback((A) => {
    for (const N of b.values())
      if (A === (N == null ? void 0 : N.value))
        return N == null ? void 0 : N.id;
  }, [b]), P = m.useCallback((A) => {
    if (A === void 0)
      return null;
    for (const [N, B] of b.entries())
      if (B != null && A === (B.value ?? B.index))
        return N;
    return null;
  }, [b]), k = m.useMemo(() => ({
    direction: u,
    getTabElementBySelectedValue: P,
    getTabIdByPanelValue: I,
    getTabPanelIdByValue: M,
    onValueChange: E,
    orientation: s,
    registerMountedTabPanel: S,
    setTabMap: w,
    unregisterMountedTabPanel: R,
    tabActivationDirection: C,
    value: g
  }), [u, P, I, M, E, s, S, w, R, C, g]), O = m.useMemo(() => {
    for (const A of b.values())
      if (A != null && A.value === g)
        return A;
  }, [b, g]), F = m.useMemo(() => {
    for (const A of b.values())
      if (A != null && !A.disabled)
        return A.value;
  }, [b]);
  ge(() => {
    if (y || b.size === 0)
      return;
    const A = O == null ? void 0 : O.disabled, N = O == null && g !== null;
    if (d && A && g === o || !A && !N)
      return;
    const $ = F ?? null;
    g !== $ && (v($), x("none"));
  }, [o, F, d, y, O, x, v, b, g]);
  const L = Ie("div", t, {
    state: {
      orientation: s,
      tabActivationDirection: C
    },
    ref: n,
    props: c,
    stateAttributesMapping: xh
  });
  return /* @__PURE__ */ _(bh.Provider, {
    value: k,
    children: /* @__PURE__ */ _(Jf, {
      elementsRef: f,
      children: L
    })
  });
});
process.env.NODE_ENV !== "production" && (L1.displayName = "TabsRoot");
const wh = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (wh.displayName = "TabsListContext");
function nD() {
  const e = m.useContext(wh);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsListContext is missing. TabsList parts must be placed within <Tabs.List>." : Ke(65));
  return e;
}
const $1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    disabled: o = !1,
    render: i,
    value: s,
    id: a,
    nativeButton: l = !0,
    ...c
  } = t, {
    value: u,
    getTabPanelIdByValue: d,
    orientation: f
  } = yh(), {
    activateOnFocus: h,
    highlightedTabIndex: p,
    onTabActivation: g,
    setHighlightedTabIndex: v,
    tabsListElement: y
  } = nD(), b = Kt(a), w = m.useMemo(() => ({
    disabled: o,
    id: b,
    value: s
  }), [o, b, s]), {
    compositeProps: C,
    compositeRef: x,
    index: E
    // hook is used instead of the CompositeItem component
    // because the index is needed for Tab internals
  } = y1({
    metadata: w
  }), S = s === u, R = m.useRef(!1);
  ge(() => {
    if (R.current) {
      R.current = !1;
      return;
    }
    if (!(S && E > -1 && p !== E))
      return;
    const B = y;
    if (B != null) {
      const $ = Bn(Pn(B));
      if ($ && Ve(B, $))
        return;
    }
    o || v(E);
  }, [S, E, p, v, o, y]);
  const {
    getButtonProps: M,
    buttonRef: I
  } = Jr({
    disabled: o,
    native: l,
    focusableWhenDisabled: !0
  }), P = d(s), k = m.useRef(!1), O = m.useRef(!1);
  function F(B) {
    S || o || g(s, ke(_o, B.nativeEvent, void 0, {
      activationDirection: "none"
    }));
  }
  function T(B) {
    S || (E > -1 && !o && v(E), !o && h && (!k.current || // keyboard or touch focus
    k.current && O.current) && g(s, ke(_o, B.nativeEvent, void 0, {
      activationDirection: "none"
    })));
  }
  function L(B) {
    if (S || o)
      return;
    k.current = !0;
    function $() {
      k.current = !1, O.current = !1;
    }
    (!B.button || B.button === 0) && (O.current = !0, Pn(B.currentTarget).addEventListener("pointerup", $, {
      once: !0
    }));
  }
  const A = m.useMemo(() => ({
    disabled: o,
    active: S,
    orientation: f
  }), [o, S, f]);
  return Ie("button", t, {
    state: A,
    ref: [n, I, x],
    props: [C, {
      role: "tab",
      "aria-controls": P,
      "aria-selected": S,
      id: b,
      onClick: F,
      onFocus: T,
      onPointerDown: L,
      [_1]: S ? "" : void 0,
      onKeyDownCapture() {
        R.current = !0;
      }
    }, c, M]
  });
});
process.env.NODE_ENV !== "production" && ($1.displayName = "TabsTab");
let rD = /* @__PURE__ */ function(e) {
  return e.index = "data-index", e.activationDirection = "data-activation-direction", e.orientation = "data-orientation", e.hidden = "data-hidden", e;
}({});
const F1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    value: o,
    render: i,
    keepMounted: s = !1,
    ...a
  } = t, {
    value: l,
    getTabIdByPanelValue: c,
    orientation: u,
    tabActivationDirection: d,
    registerMountedTabPanel: f,
    unregisterMountedTabPanel: h
  } = yh(), p = Kt(), g = m.useMemo(() => ({
    id: p,
    value: o
  }), [p, o]), {
    ref: v,
    index: y
  } = Ei({
    metadata: g
  }), b = o !== l, w = c(o), C = m.useMemo(() => ({
    hidden: b,
    orientation: u,
    tabActivationDirection: d
  }), [b, u, d]), x = Ie("div", t, {
    state: C,
    ref: [n, v],
    props: [{
      "aria-labelledby": w,
      hidden: b,
      id: p ?? void 0,
      role: "tabpanel",
      tabIndex: b ? -1 : 0,
      [rD.index]: y
    }, a],
    stateAttributesMapping: xh
  });
  return ge(() => {
    if (!(b && !s) && p != null)
      return f(o, p), () => {
        h(o, p);
      };
  }, [b, s, o, p, f, h]), !b || s ? x : null;
});
process.env.NODE_ENV !== "production" && (F1.displayName = "TabsPanel");
const V1 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    activateOnFocus: r = !1,
    className: o,
    loopFocus: i = !0,
    render: s,
    ...a
  } = t, {
    getTabElementBySelectedValue: l,
    onValueChange: c,
    orientation: u,
    value: d,
    setTabMap: f,
    tabActivationDirection: h
  } = yh(), [p, g] = m.useState(0), [v, y] = m.useState(null), b = oD(
    d,
    // the old value
    u,
    v,
    l
  ), w = ve((S, R) => {
    if (S !== d) {
      const M = b(S);
      R.activationDirection = M, c(S, R);
    }
  }), C = m.useMemo(() => ({
    orientation: u,
    tabActivationDirection: h
  }), [u, h]), x = {
    "aria-orientation": u === "vertical" ? "vertical" : void 0,
    role: "tablist"
  }, E = m.useMemo(() => ({
    activateOnFocus: r,
    highlightedTabIndex: p,
    onTabActivation: w,
    setHighlightedTabIndex: g,
    tabsListElement: v,
    value: d
  }), [r, p, w, g, v, d]);
  return /* @__PURE__ */ _(wh.Provider, {
    value: E,
    children: /* @__PURE__ */ _(WN, {
      render: s,
      className: o,
      state: C,
      refs: [n, y],
      props: [x, a],
      stateAttributesMapping: xh,
      highlightedIndex: p,
      enableHomeAndEndKeys: !0,
      loopFocus: i,
      orientation: u,
      onHighlightedIndexChange: g,
      onMapChange: f,
      disabledIndices: wo
    })
  });
});
process.env.NODE_ENV !== "production" && (V1.displayName = "TabsList");
function Lm(e, t) {
  const {
    left: n,
    top: r
  } = e.getBoundingClientRect(), {
    left: o,
    top: i
  } = t.getBoundingClientRect(), s = n - o, a = r - i;
  return {
    left: s,
    top: a
  };
}
function oD(e, t, n, r) {
  const [o, i] = m.useState(null);
  return ge(() => {
    if (e == null || n == null) {
      i(null);
      return;
    }
    const s = r(e);
    if (s == null) {
      i(null);
      return;
    }
    const {
      left: a,
      top: l
    } = Lm(s, n);
    i(t === "horizontal" ? a : l);
  }, [t, r, n, e]), m.useCallback((s) => {
    if (s === e)
      return "none";
    if (s == null)
      return i(null), "none";
    if (s != null && n != null) {
      const a = r(s);
      if (a != null) {
        const {
          left: l,
          top: c
        } = Lm(a, n);
        if (o == null)
          return i(t === "horizontal" ? l : c), "none";
        if (t === "horizontal") {
          if (l < o)
            return i(l), "left";
          if (l > o)
            return i(l), "right";
        } else {
          if (c < o)
            return i(c), "up";
          if (c > o)
            return i(c), "down";
        }
      }
    }
    return "none";
  }, [r, t, o, n, e]);
}
const iD = dn(
  "inline-flex flex-shrink-0 items-center py-0.5 text-xs font-medium text-foundations-bolder",
  {
    variants: {
      variant: {
        primary: "border border-info-subtle bg-info-subtler",
        secondary: "bg-gold-400 text-white",
        warning: "border border-warning-subtle bg-warning-subtler",
        dimmed: "bg-foundations-bolder text-white",
        default: "border border-foundations-subtle bg-foundations-subtlest text-foundations-subtle",
        success: "border border-success-subtle bg-success-subtler",
        danger: "border border-danger-subtle bg-danger-subtler",
        pending: "bg-warning-subtler text-gold-400"
      },
      size: {
        sm: "px-2",
        md: "px-2.5"
      },
      shape: {
        pill: "rounded-full",
        square: "rounded-md"
      }
    },
    defaultVariants: {
      size: "md",
      shape: "pill",
      variant: "default"
    }
  }
), sD = Y.forwardRef(
  ({ variant: e, size: t, shape: n, className: r, render: o, ...i }, s) => {
    const a = {
      className: oe(iD({ variant: e, size: t, shape: n, className: r })),
      "data-slot": "badge"
    };
    return xi({
      defaultTagName: "div",
      render: o,
      ref: s,
      props: kn(a, i)
    });
  }
);
sD.displayName = "Badge";
const aD = dn(
  "relative flex w-full flex-shrink-0 items-center overflow-hidden rounded-md p-4",
  {
    variants: {
      state: {
        success: "",
        danger: "",
        informative: "",
        warning: "",
        neutral: ""
      },
      contrast: {
        low: "border text-foundations-boldest [&_.close-btn]:text-foundations-subtle [&_.icon]:h-5 [&_.icon]:w-5 [&_.icon_svg]:h-4 [&_.icon_svg]:w-4",
        medium: "text-foundations-inverse shadow-2 [&_.icon]:h-8 [&_.icon]:w-8 [&_.icon_svg]:h-6 [&_.icon_svg]:w-6"
      },
      fullWidth: {
        true: "",
        false: "max-w-[25rem]"
      }
    },
    defaultVariants: {
      state: "informative",
      contrast: "low",
      fullWidth: !1
    },
    compoundVariants: [
      {
        state: "success",
        contrast: "low",
        className: "border-success-subtle bg-success-subtler [&_.icon]:bg-success-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "danger",
        contrast: "low",
        className: "border-danger-subtle bg-danger-subtler [&_.icon]:bg-danger-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "informative",
        contrast: "low",
        className: "border-info-subtle bg-info-subtler [&_.icon]:bg-info-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "warning",
        contrast: "low",
        className: "border-warning-subtle bg-warning-subtler [&_.icon]:bg-warning-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "neutral",
        contrast: "low",
        className: "border-foundations-subtle bg-foundations-subtelst-02 text-foundations-subtle [&_.icon]:bg-transparent [&_.icon]:text-foundations-subtle"
      },
      {
        state: "success",
        contrast: "medium",
        className: "bg-success-subtle text-foundations-boldest [&_.icon]:bg-success-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "danger",
        contrast: "medium",
        className: "bg-danger-subtle text-foundations-boldest [&_.icon]:bg-danger-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "informative",
        contrast: "medium",
        className: "bg-info-subtle text-foundations-boldest [&_.icon]:bg-info-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "warning",
        contrast: "medium",
        className: "bg-warning-subtle text-foundations-boldest [&_.icon]:bg-warning-bold [&_.icon]:text-foundations-inverse"
      }
    ]
  }
), lD = m.forwardRef(
  ({
    title: e,
    state: t = "neutral",
    contrast: n,
    fullWidth: r,
    className: o,
    onClose: i,
    actions: s,
    content: a,
    Icon: l,
    ...c
  }, u) => /* @__PURE__ */ Z(
    "div",
    {
      ref: u,
      className: oe(aD({ state: t, contrast: n, fullWidth: r }), o),
      ...c,
      children: [
        /* @__PURE__ */ _(B1, { state: t, CustomIcon: l }),
        /* @__PURE__ */ Z("div", { className: "ml-4 flex-1", children: [
          /* @__PURE__ */ _("div", { className: "text-sm font-medium", children: e }),
          a && /* @__PURE__ */ _("div", { className: "mt-2", children: a })
        ] }),
        s && /* @__PURE__ */ _("div", { className: "ml-4 space-x-2", children: s }),
        i && /* @__PURE__ */ _(
          "button",
          {
            onClick: i,
            className: "close-btn ml-2 flex-shrink-0 rounded-sm hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
            children: /* @__PURE__ */ _(Tf, { className: "h-4 w-4 " })
          }
        )
      ]
    }
  )
);
lD.displayName = "Alert";
const cD = {
  success: eo,
  danger: Xc,
  informative: p0,
  warning: Xc,
  neutral: Xc
}, B1 = ({
  state: e,
  CustomIcon: t
}) => {
  const n = cD[e];
  return /* @__PURE__ */ _("div", { className: "icon flex flex-shrink-0 items-center justify-center rounded-full", children: t ? /* @__PURE__ */ _(t, {}) : /* @__PURE__ */ _(n, {}) });
};
B1.displayName = "AlertIcon";
const uD = m.forwardRef(
  ({ className: e, disableHover: t, render: n, ...r }, o) => {
    const i = {
      className: oe(
        "block rounded-lg border border-foundations-subtle bg-foundations-default p-6 transition-colors focus:border-info-bold focus:outline-none focus:ring-1 focus:ring-info-bold [&:has(.link-overlay:focus)]:border-info-bold [&:has(.link-overlay:focus)]:ring-1 [&:has(.link-overlay:focus)]:ring-info-bold",
        !t && "hover:border-foundations-bold hover:shadow-3",
        e
      ),
      "data-slot": "card"
    };
    return xi({
      defaultTagName: "div",
      render: n,
      ref: o,
      props: kn(i, r)
    });
  }
);
uD.displayName = "Card";
const dD = m.forwardRef(
  ({ asChild: e, className: t, ...n }, r) => /* @__PURE__ */ _(
    e ? mi : "div",
    {
      ref: r,
      className: oe(
        "relative [&_button]:relative [&_button]:z-[1] [&_a:not(.link-overlay)]:relative [&_a:not(.link-overlay)]:z-[1]",
        t
      ),
      ...n
    }
  )
);
dD.displayName = "LinkBox";
const fD = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "a",
  {
    ref: n,
    className: oe(
      "link-overlay before:absolute before:inset-0 focus:outline-none",
      e
    ),
    ...t
  }
));
fD.displayName = "LinkOverlay";
const hD = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 66,
    viewBox: "0 0 184 150",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/08", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ Z("g", { id: "Mask Group 3", children: [
        /* @__PURE__ */ Z("g", { id: "Group 26805", children: [
          /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _(
            "path",
            {
              id: "Path 25918",
              d: "M39.5 30.6754C38.3371 30.9512 37.2627 31.5449 36.4038 32.4038C35.1848 33.6228 34.5 35.2761 34.5 37V62C34.5 63.7239 35.1848 65.3772 36.4038 66.5962C37.6228 67.8152 39.2761 68.5 41 68.5H176C177.724 68.5 179.377 67.8152 180.596 66.5962C181.815 65.3772 182.5 63.7239 182.5 62V37C182.5 35.2761 181.815 33.6228 180.596 32.4038C179.377 31.1848 177.724 30.5 176 30.5H41H39.5V30.6754Z",
              className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]",
              strokeWidth: 3
            }
          ) }),
          /* @__PURE__ */ Z("g", { id: "Group 26775", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5617",
                d: "M105 40H79C77.3431 40 76 41.3431 76 43C76 44.6569 77.3431 46 79 46H105C106.657 46 108 44.6569 108 43C108 41.3431 106.657 40 105 40Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5618",
                d: "M123 53H79C77.3431 53 76 54.3431 76 56C76 57.6569 77.3431 59 79 59H123C124.657 59 126 57.6569 126 56C126 54.3431 124.657 53 123 53Z",
                className: "fill-[theme(backgroundColor.foundations-subtle)]"
              }
            )
          ] }),
          /* @__PURE__ */ Z("g", { id: "Group 26804", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5624",
                d: "M68 49.5C68 41.4919 61.5081 35 53.5 35C45.4919 35 39 41.4919 39 49.5C39 57.5081 45.4919 64 53.5 64C61.5081 64 68 57.5081 68 49.5Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _("g", { id: "bx-search", children: /* @__PURE__ */ _(
              "path",
              {
                id: "Path 25920",
                d: "M52.6007 54.194C53.842 54.1939 55.0477 53.7785 56.0257 53.014L59.1007 56.089L60.0897 55.1L57.0137 52.024C57.7865 51.0248 58.1981 49.7934 58.1815 48.5303C58.1648 47.2672 57.7208 46.047 56.9219 45.0686C56.123 44.0901 55.0162 43.4111 53.782 43.1422C52.5478 42.8733 51.2588 43.0303 50.1253 43.5877C48.9917 44.1451 48.0804 45.07 47.5398 46.2117C46.9992 47.3533 46.8612 48.6444 47.1483 49.8746C47.4354 51.1047 48.1306 52.2013 49.1208 52.9857C50.1109 53.7701 51.3375 54.196 52.6007 54.194ZM52.6007 44.4C53.4314 44.4 54.2434 44.6464 54.9341 45.1079C55.6248 45.5694 56.1631 46.2253 56.481 46.9928C56.7989 47.7602 56.8821 48.6047 56.72 49.4194C56.5579 50.2341 56.1579 50.9825 55.5705 51.5699C54.9832 52.1573 54.2348 52.5573 53.4201 52.7193C52.6054 52.8814 51.7609 52.7982 50.9934 52.4803C50.226 52.1624 49.57 51.6241 49.1085 50.9334C48.647 50.2427 48.4007 49.4307 48.4007 48.6C48.4007 47.4861 48.8432 46.4178 49.6308 45.6302C50.4185 44.8425 51.4868 44.4 52.6007 44.4Z",
                className: "fill-[theme(backgroundColor.foundations-default)]"
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ Z("g", { id: "Group 26784", children: [
          /* @__PURE__ */ _("g", { id: "Group_2", children: /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5623",
              d: "M161 81.5H26C22.4101 81.5 19.5 84.4101 19.5 88V113C19.5 116.59 22.4101 119.5 26 119.5H161C164.59 119.5 167.5 116.59 167.5 113V88C167.5 84.4102 164.59 81.5 161 81.5Z",
              className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]",
              strokeWidth: 3
            }
          ) }),
          /* @__PURE__ */ Z("g", { id: "Group 26775_2", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5617_2",
                d: "M90 91H64C62.3431 91 61 92.3431 61 94C61 95.6569 62.3431 97 64 97H90C91.6569 97 93 95.6569 93 94C93 92.3431 91.6569 91 90 91Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5618_2",
                d: "M108 104H64C62.3431 104 61 105.343 61 107C61 108.657 62.3431 110 64 110H108C109.657 110 111 108.657 111 107C111 105.343 109.657 104 108 104Z",
                className: "fill-[theme(backgroundColor.foundations-subtle)]"
              }
            )
          ] }),
          /* @__PURE__ */ Z("g", { id: "Group 26807", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5624_2",
                d: "M53 100.5C53 92.4919 46.5081 86 38.5 86C30.4919 86 24 92.4919 24 100.5C24 108.508 30.4919 115 38.5 115C46.5081 115 53 108.508 53 100.5Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _("g", { id: "bx-search_2", children: /* @__PURE__ */ _(
              "path",
              {
                id: "Path 25920_2",
                d: "M37.6007 105.194C38.842 105.194 40.0477 104.778 41.0257 104.014L44.1007 107.089L45.0897 106.1L42.0137 103.024C42.7865 102.025 43.1981 100.793 43.1815 99.5303C43.1648 98.2672 42.7208 97.047 41.9219 96.0686C41.123 95.0901 40.0162 94.4111 38.782 94.1422C37.5478 93.8733 36.2588 94.0303 35.1253 94.5877C33.9917 95.1451 33.0804 96.07 32.5398 97.2117C31.9992 98.3533 31.8612 99.6444 32.1483 100.875C32.4354 102.105 33.1306 103.201 34.1208 103.986C35.1109 104.77 36.3375 105.196 37.6007 105.194ZM37.6007 95.4C38.4314 95.4 39.2434 95.6464 39.9341 96.1079C40.6248 96.5694 41.1631 97.2253 41.481 97.9928C41.7989 98.7602 41.8821 99.6047 41.72 100.419C41.5579 101.234 41.1579 101.983 40.5705 102.57C39.9832 103.157 39.2348 103.557 38.4201 103.719C37.6054 103.881 36.7609 103.798 35.9934 103.48C35.226 103.162 34.57 102.624 34.1085 101.933C33.647 101.243 33.4007 100.431 33.4007 99.6C33.4007 98.4861 33.8432 97.4178 34.6308 96.6302C35.4185 95.8425 36.4868 95.4 37.6007 95.4Z",
                fill: "white"
              }
            ) })
          ] })
        ] })
      ] })
    ] })
  }
), H1 = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 150 153",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/07", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Subtraction 1",
          d: "M109.755 47.2509L109.748 47.2439C108.398 45.9026 107.328 44.3068 106.599 42.549C106.102 41.3514 105.77 40.0949 105.61 38.8138C105.395 37.0834 103.972 35.5 101.996 35.5H47.9978C46.0262 35.5 44.6038 37.0766 44.3853 38.8043C43.9832 41.9829 42.5372 44.9584 40.2478 47.2478C37.9584 49.5372 34.9829 50.9832 31.8043 51.3853C30.0766 51.6038 28.5 53.0262 28.5 54.9978V148C28.5 149.933 30.067 151.5 32 151.5H118C119.933 151.5 121.5 149.933 121.5 148V55.0044C121.5 53.0279 119.916 51.6052 118.186 51.3897C116.905 51.2301 115.648 50.8984 114.45 50.4015C112.692 49.6721 111.097 48.6013 109.755 47.2509Z",
          strokeWidth: 3,
          className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 665",
          d: "M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ _("g", { id: "ic_add_48px", children: /* @__PURE__ */ _(
        "path",
        {
          id: "Path 25936",
          d: "M84.8995 87.8997C84.1184 88.6807 82.8521 88.6807 82.0711 87.8997L76.4142 82.2428C75.6332 81.4618 74.3668 81.4618 73.5858 82.2428L67.9289 87.8997C67.1479 88.6807 65.8816 88.6807 65.1005 87.8997C64.3195 87.1186 64.3195 85.8523 65.1005 85.0712L70.7574 79.4144C71.5384 78.6333 71.5384 77.367 70.7574 76.5859L65.1005 70.9291C64.3195 70.148 64.3195 68.8817 65.1005 68.1007C65.8816 67.3196 67.1479 67.3196 67.9289 68.1007L73.5858 73.7575C74.3668 74.5386 75.6332 74.5386 76.4142 73.7575L82.0711 68.1007C82.8521 67.3196 84.1184 67.3196 84.8995 68.1007C85.6805 68.8817 85.6805 70.148 84.8995 70.9291L79.2426 76.5859C78.4616 77.367 78.4616 78.6333 79.2426 79.4144L84.8995 85.0712C85.6805 85.8523 85.6805 87.1186 84.8995 87.8997Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5617",
          d: "M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5618",
          d: "M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      )
    ] })
  }
), c$ = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/10", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ Z("g", { id: "Group 1489", children: [
        /* @__PURE__ */ Z("g", { id: "Group 3", children: [
          /* @__PURE__ */ _(
            "rect",
            {
              id: "Rectangle 1",
              x: 34,
              y: 46,
              width: 67,
              height: 39,
              rx: 3,
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "circle",
            {
              id: "Ellipse 1",
              cx: 68,
              cy: 65,
              r: 12,
              className: "fill-[theme(backgroundColor.foundations-subtlest)]"
            }
          )
        ] }),
        /* @__PURE__ */ Z("g", { id: "Group 1", children: [
          /* @__PURE__ */ _(
            "rect",
            {
              id: "Rectangle 1_2",
              x: 49,
              y: 65,
              width: 67,
              height: 39,
              rx: 3,
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "circle",
            {
              id: "Ellipse 1_2",
              cx: 83,
              cy: 84,
              r: 12,
              className: "fill-[theme(backgroundColor.foundations-default)]"
            }
          )
        ] })
      ] })
    ] })
  }
), u$ = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 168,
    viewBox: "0 0 194 168",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/01", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5625",
          d: "M159 0H39C33.4772 0 29 5.37258 29 12V156C29 162.627 33.4772 168 39 168H159C164.523 168 169 162.627 169 156V12C169 5.37258 164.523 0 159 0Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ Z("g", { id: "Group 26800", children: [
        /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Path 25918",
            d: "M49.5 64.6754C48.3371 64.9512 47.2627 65.5449 46.4038 66.4038C45.1848 67.6228 44.5 69.2761 44.5 71V96C44.5 97.7239 45.1848 99.3772 46.4038 100.596C47.6228 101.815 49.2761 102.5 51 102.5H186C187.724 102.5 189.377 101.815 190.596 100.596C191.815 99.3772 192.5 97.7239 192.5 96V71C192.5 69.2761 191.815 67.6228 190.596 66.4038C189.377 65.1848 187.724 64.5 186 64.5H51H49.5V64.6754Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26775", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617",
              d: "M125 74H99C97.3431 74 96 75.3431 96 77C96 78.6569 97.3431 80 99 80H125C126.657 80 128 78.6569 128 77C128 75.3431 126.657 74 125 74Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618",
              d: "M143 87H99C97.3431 87 96 88.3431 96 90C96 91.6569 97.3431 93 99 93H143C144.657 93 146 91.6569 146 90C146 88.3431 144.657 87 143 87Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ _("g", { id: "Group 26799", children: /* @__PURE__ */ _("g", { id: "Group 26756", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 647",
            d: "M76.5 93C81.7467 93 86 88.7467 86 83.5C86 78.2533 81.7467 74 76.5 74C71.2533 74 67 78.2533 67 83.5C67 88.7467 71.2533 93 76.5 93Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) })
      ] }),
      /* @__PURE__ */ Z("g", { id: "Group 26798", children: [
        /* @__PURE__ */ _("g", { id: "Group_2", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Path 25919",
            d: "M6.5 112.675C5.33714 112.951 4.26267 113.545 3.40381 114.404C2.18482 115.623 1.5 117.276 1.5 119V144C1.5 145.724 2.18482 147.377 3.40381 148.596C4.62279 149.815 6.27609 150.5 8 150.5H143C144.724 150.5 146.377 149.815 147.596 148.596C148.815 147.377 149.5 145.724 149.5 144V119C149.5 117.276 148.815 115.623 147.596 114.404C146.377 113.185 144.724 112.5 143 112.5H8H6.5V112.675Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26775_2", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_2",
              d: "M68 122H42C40.3431 122 39 123.343 39 125C39 126.657 40.3431 128 42 128H68C69.6569 128 71 126.657 71 125C71 123.343 69.6569 122 68 122Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_2",
              d: "M86 135H42C40.3431 135 39 136.343 39 138C39 139.657 40.3431 141 42 141H86C87.6569 141 89 139.657 89 138C89 136.343 87.6569 135 86 135Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ _("g", { id: "Group 26796", children: /* @__PURE__ */ _("g", { id: "Group 26757", children: /* @__PURE__ */ _("g", { id: "Ellipse 648", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Vector",
            d: "M20.5 141C25.7467 141 30 136.747 30 131.5C30 126.253 25.7467 122 20.5 122C15.2533 122 11 126.253 11 131.5C11 136.747 15.2533 141 20.5 141Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) }) })
      ] }),
      /* @__PURE__ */ Z("g", { id: "Group 26802", children: [
        /* @__PURE__ */ _("g", { id: "Group_3", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Rectangle 5623",
            d: "M143 16.5H8C4.41015 16.5 1.5 19.4101 1.5 23V48C1.5 51.5899 4.41015 54.5 8 54.5H143C146.59 54.5 149.5 51.5899 149.5 48V23C149.5 19.4102 146.59 16.5 143 16.5Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26775_3", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_3",
              d: "M80 26H54C52.3431 26 51 27.3431 51 29C51 30.6569 52.3431 32 54 32H80C81.6569 32 83 30.6569 83 29C83 27.3431 81.6569 26 80 26Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_3",
              d: "M98 39H54C52.3431 39 51 40.3431 51 42C51 43.6569 52.3431 45 54 45H98C99.6569 45 101 43.6569 101 42C101 40.3431 99.6569 39 98 39Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ _("g", { id: "Group 26801", children: /* @__PURE__ */ _("g", { id: "Group 26756_2", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 647_2",
            d: "M33.5 45C38.7467 45 43 40.7467 43 35.5C43 30.2533 38.7467 26 33.5 26C28.2533 26 24 30.2533 24 35.5C24 40.7467 28.2533 45 33.5 45Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) })
      ] })
    ] })
  }
), d$ = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 169,
    viewBox: "0 0 150 169",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/02", children: [
      /* @__PURE__ */ Z("g", { id: "Mask Group 1", children: [
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 652",
            d: "M75 158C116.421 158 150 124.421 150 83C150 41.5786 116.421 8 75 8C33.5786 8 0 41.5786 0 83C0 124.421 33.5786 158 75 158Z",
            className: "fill-[theme(backgroundColor.foundations-subtler)]"
          }
        ),
        /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Rectangle 5615",
            d: "M118 49.5H32C28.4101 49.5 25.5 52.4101 25.5 56V161C25.5 164.59 28.4101 167.5 32 167.5H118C121.59 167.5 124.5 164.59 124.5 161V56C124.5 52.4101 121.59 49.5 118 49.5Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26776", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617",
              d: "M65 66H39C37.3431 66 36 67.3431 36 69C36 70.6569 37.3431 72 39 72H65C66.6569 72 68 70.6569 68 69C68 67.3431 66.6569 66 65 66Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618",
              d: "M83 79H39C37.3431 79 36 80.3431 36 82C36 83.6569 37.3431 85 39 85H83C84.6569 85 86 83.6569 86 82C86 80.3431 84.6569 79 83 79Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          )
        ] }),
        /* @__PURE__ */ Z("g", { id: "Group 26777", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_2",
              d: "M65 93H39C37.3431 93 36 94.3431 36 96C36 97.6569 37.3431 99 39 99H65C66.6569 99 68 97.6569 68 96C68 94.3431 66.6569 93 65 93Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_2",
              d: "M83 106H39C37.3431 106 36 107.343 36 109C36 110.657 37.3431 112 39 112H83C84.6569 112 86 110.657 86 109C86 107.343 84.6569 106 83 106Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          )
        ] }),
        /* @__PURE__ */ Z("g", { id: "Group 26778", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_3",
              d: "M65 120H39C37.3431 120 36 121.343 36 123C36 124.657 37.3431 126 39 126H65C66.6569 126 68 124.657 68 123C68 121.343 66.6569 120 65 120Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_3",
              d: "M83 133H39C37.3431 133 36 134.343 36 136C36 137.657 37.3431 139 39 139H83C84.6569 139 86 137.657 86 136C86 134.343 84.6569 133 83 133Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ Z("g", { id: "Group 26779", children: [
        /* @__PURE__ */ _("g", { id: "Group_2", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Rectangle 5616",
            d: "M118 0H32C29.2386 0 27 2.23858 27 5V35C27 37.7614 29.2386 40 32 40H118C120.761 40 123 37.7614 123 35V5C123 2.23858 120.761 0 118 0Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26775", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_4",
              d: "M65 11H39C37.3431 11 36 12.3431 36 14C36 15.6569 37.3431 17 39 17H65C66.6569 17 68 15.6569 68 14C68 12.3431 66.6569 11 65 11Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_4",
              d: "M83 24H39C37.3431 24 36 25.3431 36 27C36 28.6569 37.3431 30 39 30H83C84.6569 30 86 28.6569 86 27C86 25.3431 84.6569 24 83 24Z",
              className: "fill-[theme(backgroundColor.foundations-subtlest)]"
            }
          )
        ] })
      ] })
    ] })
  }
), f$ = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 158,
    height: 169,
    viewBox: "0 0 158 169",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/03", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 652",
          d: "M79 158C122.63 158 158 122.63 158 79C158 35.3695 122.63 0 79 0C35.3695 0 0 35.3695 0 79C0 122.63 35.3695 158 79 158Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _("g", { id: "Mask Group", children: /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5615",
          d: "M122 49.5H36C32.4101 49.5 29.5 52.4101 29.5 56V161C29.5 164.59 32.4101 167.5 36 167.5H122C125.59 167.5 128.5 164.59 128.5 161V56C128.5 52.4101 125.59 49.5 122 49.5Z",
          strokeWidth: 3,
          className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
        }
      ) }) }),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5617",
          d: "M70 61H44C42.3431 61 41 62.3431 41 64C41 65.6569 42.3431 67 44 67H70C71.6569 67 73 65.6569 73 64C73 62.3431 71.6569 61 70 61Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5620",
          d: "M70 103H44C42.3431 103 41 104.343 41 106C41 107.657 42.3431 109 44 109H70C71.6569 109 73 107.657 73 106C73 104.343 71.6569 103 70 103Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _("g", { id: "Rectangle 5618", children: /* @__PURE__ */ _(
        "path",
        {
          id: "Vector",
          d: "M112 76H46C43.7909 76 42 77.7909 42 80V90C42 92.2091 43.7909 94 46 94H112C114.209 94 116 92.2091 116 90V80C116 77.7909 114.209 76 112 76Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5619",
          d: "M112 117H46C43.2386 117 41 119.239 41 122V130C41 132.761 43.2386 135 46 135H112C114.761 135 117 132.761 117 130V122C117 119.239 114.761 117 112 117Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ Z("g", { id: "Group 26781", children: [
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 654",
            d: "M57 40C59.2091 40 61 38.2091 61 36C61 33.7909 59.2091 32 57 32C54.7909 32 53 33.7909 53 36C53 38.2091 54.7909 40 57 40Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 655",
            d: "M79 40C81.2091 40 83 38.2091 83 36C83 33.7909 81.2091 32 79 32C76.7909 32 75 33.7909 75 36C75 38.2091 76.7909 40 79 40Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 656",
            d: "M101 40C103.209 40 105 38.2091 105 36C105 33.7909 103.209 32 101 32C98.7909 32 97 33.7909 97 36C97 38.2091 98.7909 40 101 40Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        )
      ] }),
      /* @__PURE__ */ Z("g", { id: "Group 26782", children: [
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 658",
            d: "M90 96C92.7614 96 95 93.7614 95 91C95 88.2386 92.7614 86 90 86C87.2386 86 85 88.2386 85 91C85 93.7614 87.2386 96 90 96Z",
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            id: "Path 25916",
            d: "M93.9071 112.37C93.1071 112.37 92.3601 112.37 91.6801 112.327C90.8425 112.27 90.0367 111.984 89.3515 111.499C88.6662 111.014 88.128 110.349 87.7961 109.578L83.5771 101.24C83.2676 100.88 83.1131 100.412 83.1472 99.938C83.1813 99.4643 83.4012 99.0233 83.7591 98.711C84.0522 98.4754 84.418 98.3485 84.7941 98.352C85.071 98.3601 85.3428 98.4281 85.5909 98.5513C85.839 98.6746 86.0574 98.8502 86.2311 99.066L88.1471 101.681L88.1761 101.715V91.78C88.1761 91.2871 88.3719 90.8144 88.7204 90.4659C89.069 90.1173 89.5417 89.9215 90.0346 89.9215C90.5275 89.9215 91.0002 90.1173 91.3487 90.4659C91.6973 90.8144 91.8931 91.2871 91.8931 91.78V98.28C91.8715 98.0408 91.9 97.7998 91.9767 97.5722C92.0534 97.3446 92.1767 97.1355 92.3387 96.9582C92.5007 96.781 92.6979 96.6394 92.9176 96.5425C93.1374 96.4456 93.3749 96.3956 93.6151 96.3956C93.8552 96.3956 94.0928 96.4456 94.3125 96.5425C94.5323 96.6394 94.7294 96.781 94.8914 96.9582C95.0534 97.1355 95.1767 97.3446 95.2535 97.5722C95.3302 97.7998 95.3587 98.0408 95.3371 98.28V99.635C95.3155 99.3958 95.344 99.1548 95.4207 98.9272C95.4974 98.6996 95.6207 98.4905 95.7827 98.3132C95.9447 98.136 96.1419 97.9944 96.3616 97.8975C96.5814 97.8006 96.8189 97.7506 97.0591 97.7506C97.2992 97.7506 97.5368 97.8006 97.7565 97.8975C97.9763 97.9944 98.1734 98.136 98.3354 98.3132C98.4974 98.4905 98.6207 98.6996 98.6975 98.9272C98.7742 99.1548 98.8027 99.3958 98.7811 99.635V100.679C98.7595 100.44 98.788 100.199 98.8647 99.9712C98.9414 99.7436 99.0647 99.5345 99.2267 99.3572C99.3887 99.18 99.5859 99.0384 99.8056 98.9415C100.025 98.8446 100.263 98.7946 100.503 98.7946C100.743 98.7946 100.981 98.8446 101.201 98.9415C101.42 99.0384 101.617 99.18 101.779 99.3572C101.941 99.5345 102.065 99.7436 102.141 99.9712C102.218 100.199 102.247 100.44 102.225 100.679V107.016C102.191 108.965 101.31 112.251 98.2111 112.251C97.9861 112.261 96.0801 112.371 93.9111 112.371L93.9071 112.37Z",
            className: "fill-[theme(backgroundColor.foundations-bold)] stroke-[theme(backgroundColor.foundations-default)]"
          }
        )
      ] })
    ] })
  }
), h$ = (e) => /* @__PURE__ */ Z(
  "svg",
  {
    width: "150",
    height: "150",
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ _(
        "path",
        {
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtlest)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M120 150H30V53C34.242 52.9952 38.3089 51.308 41.3084 48.3085C44.308 45.3089 45.9952 41.242 46 37H104C103.996 39.1014 104.408 41.1828 105.213 43.1238C106.018 45.0648 107.2 46.8268 108.691 48.308C110.172 49.7991 111.934 50.9816 113.875 51.787C115.817 52.5924 117.898 53.0047 120 53V150Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ _("g", { clipPath: "url(#clip0_22879_245463)", children: /* @__PURE__ */ _(
        "path",
        {
          d: "M73.4 66.7992C73.4 65.9156 74.1163 65.1992 75 65.1992C75.8837 65.1992 76.6 65.9156 76.6 66.7992V75.5992C76.6 76.041 76.9582 76.3992 77.4 76.3992C77.8418 76.3992 78.2 76.041 78.2 75.5992V68.3992C78.2 67.5156 78.9163 66.7992 79.8 66.7992C80.6837 66.7992 81.4 67.5156 81.4 68.3992V75.5992C81.4 76.041 81.7582 76.3992 82.2 76.3992C82.6418 76.3992 83 76.041 83 75.5992V71.5992C83 70.7156 83.7163 69.9992 84.6 69.9992C85.4837 69.9992 86.2 70.7156 86.2 71.5992V79.5992C86.2 85.7848 81.1856 90.7992 75 90.7992C68.8144 90.7992 63.8 85.7848 63.8 79.5992V76.3992C63.8 75.5156 64.5163 74.7992 65.4 74.7992C66.2837 74.7992 67 75.5156 67 76.3992V80.3992C67 80.841 67.3582 81.1992 67.8 81.1992C68.2418 81.1992 68.6 80.841 68.6 80.3992V68.3992C68.6 67.5156 69.3163 66.7992 70.2 66.7992C71.0837 66.7992 71.8 67.5156 71.8 68.3992V75.5992C71.8 76.041 72.1582 76.3992 72.6 76.3992C73.0418 76.3992 73.4 76.041 73.4 75.5992V66.7992Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ _("clipPath", { id: "clip0_22879_245463", children: /* @__PURE__ */ _(
        "rect",
        {
          width: "32",
          height: "32",
          className: "fill-[theme(backgroundColor.foundations-default)]",
          transform: "translate(59 62)"
        }
      ) }) })
    ]
  }
), pD = (e, t = 5, n = "*") => {
  const r = String(e), o = n.repeat(
    Math.max(r.length - t, 3)
  );
  return r.slice(0, t) + o;
};
function gD(e, t) {
  return /* @__PURE__ */ m.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ m.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 13l4 4L19 7"
  }));
}
const mD = m.forwardRef(gD), vD = mD, W1 = () => {
  const [e, t] = dt(null), [n, r] = dt(!1);
  return Le(() => {
    if (!n)
      return;
    const i = setTimeout(() => {
      r(!1);
    }, 1500);
    return () => clearTimeout(i);
  }, [n]), { copiedText: e, copy: async (i) => {
    try {
      return await navigator.clipboard.writeText(i), t(i), r(!0), !0;
    } catch (s) {
      return console.warn("Copy failed", s), t(null), !1;
    }
  }, isCopied: n };
}, bD = ({
  text: e,
  className: t,
  size: n,
  iconClassName: r
}) => {
  const [o, i] = m.useState(!1), { copy: s, isCopied: a } = W1();
  return /* @__PURE__ */ Z(xt, { open: o, children: [
    /* @__PURE__ */ _(
      xt.Trigger,
      {
        delay: 0,
        render: /* @__PURE__ */ _(
          cs,
          {
            size: n,
            className: oe("inline-flex shrink-0 px-1 py-0.5", t),
            onMouseEnter: () => i(!0),
            onMouseLeave: () => i(!1),
            onFocus: () => i(!0),
            onBlur: () => i(!1),
            variant: "tertiary",
            onClick: (l) => {
              l.stopPropagation(), a || s(e);
            }
          }
        ),
        children: a ? /* @__PURE__ */ _(vD, { className: oe("text-success", r) }) : /* @__PURE__ */ _(h0, { className: r })
      }
    ),
    /* @__PURE__ */ _(xt.Popup, { size: "sm", children: a ? "Copied!" : "Copy" })
  ] });
}, z1 = mt(
  ({
    type: e = "text",
    value: t,
    defaultValue: n,
    name: r,
    label: o,
    helpText: i,
    onChange: s,
    onFocus: a,
    onBlur: l,
    icon: c,
    className: u,
    containerClassName: d,
    readOnly: f,
    copyable: h,
    encrypted: p,
    nativeChangeEvent: g,
    ...v
  }, y) => {
    const [b, w] = dt(
      !(t || n)
    ), [C, x] = dt(!1), [E, S] = dt(!1), R = p && !b, M = ai(
      () => R ? pD(t || "") : t,
      [R, t]
    );
    return /* @__PURE__ */ Z("div", { className: d, children: [
      o && /* @__PURE__ */ _(
        "label",
        {
          htmlFor: r,
          className: "mb-4 block text-sm font-medium text-foundations-bold",
          children: o
        }
      ),
      /* @__PURE__ */ Z("div", { className: "relative block", children: [
        /* @__PURE__ */ _(
          "input",
          {
            type: R ? "text" : e,
            name: r,
            id: r,
            ref: y,
            defaultValue: n,
            value: M,
            placeholder: "Type your method...",
            onChange: (P) => {
              g ? s(P) : s(P.currentTarget.value, P);
            },
            className: oe(
              "peer block w-full min-w-0 flex-1 rounded-md border-foundations-bold bg-foundations-default text-foundations-bolder placeholder:text-foundations-subtle focus:border-info-bold focus:outline-none focus:ring-info-bold sm:text-sm",
              c ? "pl-8" : "",
              h && p ? "pr-[68px] truncate" : h || p ? "pr-9 truncate" : "",
              u
            ),
            readOnly: f || R,
            onFocus: (P) => {
              a == null || a(P), S(!0), b || x(!0);
            },
            onBlur: (P) => {
              l == null || l(P), S(!1);
            },
            ...v
          }
        ),
        /* @__PURE__ */ _("span", { className: "pointer-events-none absolute inset-y-0 left-2 flex transform items-center text-foundations-subtler peer-focus:text-blue-500", children: c }),
        (h || p) && /* @__PURE__ */ Z("div", { className: "absolute inset-y-0 right-2 flex items-center justify-center gap-2 text-foundations-subtler peer-focus:text-blue-500", children: [
          p && /* @__PURE__ */ Z(
            xt,
            {
              open: C,
              onOpenChange: (P) => x(P),
              children: [
                /* @__PURE__ */ _(
                  xt.Trigger,
                  {
                    onClick: () => {
                      x(!1), w((P) => !P);
                    },
                    "data-testid": "reveal-input",
                    children: b ? /* @__PURE__ */ _(UM, { className: "h-5 w-5" }) : /* @__PURE__ */ _(YM, { className: "h-5 w-5" })
                  }
                ),
                /* @__PURE__ */ _(xt.Popup, { size: "sm", children: E && !b ? "Reveal first to be able to edit" : b ? "Hide" : "Reveal" })
              ]
            }
          ),
          h && /* @__PURE__ */ _(bD, { text: t ?? "", iconClassName: "h-5 w-5" })
        ] })
      ] }),
      i && /* @__PURE__ */ _(
        "p",
        {
          className: "mt-2 text-sm text-foundations-subtler",
          id: "email-description",
          children: i
        }
      )
    ] });
  }
);
z1.displayName = "Input";
var yD = Object.defineProperty, xD = Object.defineProperties, wD = Object.getOwnPropertyDescriptors, Tl = Object.getOwnPropertySymbols, j1 = Object.prototype.hasOwnProperty, U1 = Object.prototype.propertyIsEnumerable, $m = (e, t, n) => t in e ? yD(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, CD = (e, t) => {
  for (var n in t || (t = {}))
    j1.call(t, n) && $m(e, n, t[n]);
  if (Tl)
    for (var n of Tl(t))
      U1.call(t, n) && $m(e, n, t[n]);
  return e;
}, _D = (e, t) => xD(e, wD(t)), ED = (e, t) => {
  var n = {};
  for (var r in e)
    j1.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && Tl)
    for (var r of Tl(e))
      t.indexOf(r) < 0 && U1.call(e, r) && (n[r] = e[r]);
  return n;
};
function SD(e) {
  let t = setTimeout(e, 0), n = setTimeout(e, 10), r = setTimeout(e, 50);
  return [t, n, r];
}
function MD(e) {
  let t = m.useRef();
  return m.useEffect(() => {
    t.current = e;
  }), t.current;
}
var OD = 18, Y1 = 40, RD = `${Y1}px`, TD = ["[data-lastpass-icon-root]", "com-1password-button", "[data-dashlanecreated]", '[style$="2147483647 !important;"]'].join(",");
function kD({ containerRef: e, inputRef: t, pushPasswordManagerStrategy: n, isFocused: r }) {
  let [o, i] = m.useState(!1), [s, a] = m.useState(!1), [l, c] = m.useState(!1), u = m.useMemo(() => n === "none" ? !1 : (n === "increase-width" || n === "experimental-no-flickering") && o && s, [o, s, n]), d = m.useCallback(() => {
    let f = e.current, h = t.current;
    if (!f || !h || l || n === "none")
      return;
    let p = f, g = p.getBoundingClientRect().left + p.offsetWidth, v = p.getBoundingClientRect().top + p.offsetHeight / 2, y = g - OD, b = v;
    document.querySelectorAll(TD).length === 0 && document.elementFromPoint(y, b) === f || (i(!0), c(!0));
  }, [e, t, l, n]);
  return m.useEffect(() => {
    let f = e.current;
    if (!f || n === "none")
      return;
    function h() {
      let g = window.innerWidth - f.getBoundingClientRect().right;
      a(g >= Y1);
    }
    h();
    let p = setInterval(h, 1e3);
    return () => {
      clearInterval(p);
    };
  }, [e, n]), m.useEffect(() => {
    let f = r || document.activeElement === t.current;
    if (n === "none" || !f)
      return;
    let h = setTimeout(d, 0), p = setTimeout(d, 2e3), g = setTimeout(d, 5e3), v = setTimeout(() => {
      c(!0);
    }, 6e3);
    return () => {
      clearTimeout(h), clearTimeout(p), clearTimeout(g), clearTimeout(v);
    };
  }, [t, r, n, d]), { hasPWMBadge: o, willPushPWMBadge: u, PWM_BADGE_SPACE_WIDTH: RD };
}
var PD = m.createContext({}), G1 = m.forwardRef((e, t) => {
  var n = e, { value: r, onChange: o, maxLength: i, textAlign: s = "left", pattern: a, placeholder: l, inputMode: c = "numeric", onComplete: u, pushPasswordManagerStrategy: d = "increase-width", pasteTransformer: f, containerClassName: h, noScriptCSSFallback: p = ID, render: g, children: v } = n, y = ED(n, ["value", "onChange", "maxLength", "textAlign", "pattern", "placeholder", "inputMode", "onComplete", "pushPasswordManagerStrategy", "pasteTransformer", "containerClassName", "noScriptCSSFallback", "render", "children"]), b, w, C, x, E;
  let [S, R] = m.useState(typeof y.defaultValue == "string" ? y.defaultValue : ""), M = r ?? S, I = MD(M), P = m.useCallback((K) => {
    o == null || o(K), R(K);
  }, [o]), k = m.useMemo(() => a ? typeof a == "string" ? new RegExp(a) : a : null, [a]), O = m.useRef(null), F = m.useRef(null), T = m.useRef({ value: M, onChange: P, isIOS: typeof window < "u" && ((w = (b = window == null ? void 0 : window.CSS) == null ? void 0 : b.supports) == null ? void 0 : w.call(b, "-webkit-touch-callout", "none")) }), L = m.useRef({ prev: [(C = O.current) == null ? void 0 : C.selectionStart, (x = O.current) == null ? void 0 : x.selectionEnd, (E = O.current) == null ? void 0 : E.selectionDirection] });
  m.useImperativeHandle(t, () => O.current, []), m.useEffect(() => {
    let K = O.current, ce = F.current;
    if (!K || !ce)
      return;
    T.current.value !== K.value && T.current.onChange(K.value), L.current.prev = [K.selectionStart, K.selectionEnd, K.selectionDirection];
    function ee() {
      if (document.activeElement !== K) {
        G(null), q(null);
        return;
      }
      let de = K.selectionStart, be = K.selectionEnd, ye = K.selectionDirection, Ce = K.maxLength, ie = K.value, he = L.current.prev, fe = -1, Se = -1, Me;
      if (ie.length !== 0 && de !== null && be !== null) {
        let Ae = de === be, bt = de === ie.length && ie.length < Ce;
        if (Ae && !bt) {
          let Pt = de;
          if (Pt === 0)
            fe = 0, Se = 1, Me = "forward";
          else if (Pt === Ce)
            fe = Pt - 1, Se = Pt, Me = "backward";
          else if (Ce > 1 && ie.length > 1) {
            let Te = 0;
            if (he[0] !== null && he[1] !== null) {
              Me = Pt < he[1] ? "backward" : "forward";
              let Je = he[0] === he[1] && he[0] < Ce;
              Me === "backward" && !Je && (Te = -1);
            }
            fe = Te + Pt, Se = Te + Pt + 1;
          }
        }
        fe !== -1 && Se !== -1 && fe !== Se && O.current.setSelectionRange(fe, Se, Me);
      }
      let $e = fe !== -1 ? fe : de, Ne = Se !== -1 ? Se : be, Fe = Me ?? ye;
      G($e), q(Ne), L.current.prev = [$e, Ne, Fe];
    }
    if (document.addEventListener("selectionchange", ee, { capture: !0 }), ee(), document.activeElement === K && $(!0), !document.getElementById("input-otp-style")) {
      let de = document.createElement("style");
      if (de.id = "input-otp-style", document.head.appendChild(de), de.sheet) {
        let be = "background: transparent !important; color: transparent !important; border-color: transparent !important; opacity: 0 !important; box-shadow: none !important; -webkit-box-shadow: none !important; -webkit-text-fill-color: transparent !important;";
        Hi(de.sheet, "[data-input-otp]::selection { background: transparent !important; color: transparent !important; }"), Hi(de.sheet, `[data-input-otp]:autofill { ${be} }`), Hi(de.sheet, `[data-input-otp]:-webkit-autofill { ${be} }`), Hi(de.sheet, "@supports (-webkit-touch-callout: none) { [data-input-otp] { letter-spacing: -.6em !important; font-weight: 100 !important; font-stretch: ultra-condensed; font-optical-sizing: none !important; left: -1px !important; right: 1px !important; } }"), Hi(de.sheet, "[data-input-otp] + * { pointer-events: all !important; }");
      }
    }
    let re = () => {
      ce && ce.style.setProperty("--root-height", `${K.clientHeight}px`);
    };
    re();
    let le = new ResizeObserver(re);
    return le.observe(K), () => {
      document.removeEventListener("selectionchange", ee, { capture: !0 }), le.disconnect();
    };
  }, []);
  let [A, N] = m.useState(!1), [B, $] = m.useState(!1), [U, G] = m.useState(null), [H, q] = m.useState(null);
  m.useEffect(() => {
    SD(() => {
      var K, ce, ee, re;
      (K = O.current) == null || K.dispatchEvent(new Event("input"));
      let le = (ce = O.current) == null ? void 0 : ce.selectionStart, de = (ee = O.current) == null ? void 0 : ee.selectionEnd, be = (re = O.current) == null ? void 0 : re.selectionDirection;
      le !== null && de !== null && (G(le), q(de), L.current.prev = [le, de, be]);
    });
  }, [M, B]), m.useEffect(() => {
    I !== void 0 && M !== I && I.length < i && M.length === i && (u == null || u(M));
  }, [i, u, I, M]);
  let j = kD({ containerRef: F, inputRef: O, pushPasswordManagerStrategy: d, isFocused: B }), W = m.useCallback((K) => {
    let ce = K.currentTarget.value.slice(0, i);
    if (ce.length > 0 && k && !k.test(ce)) {
      K.preventDefault();
      return;
    }
    typeof I == "string" && ce.length < I.length && document.dispatchEvent(new Event("selectionchange")), P(ce);
  }, [i, P, I, k]), z = m.useCallback(() => {
    var K;
    if (O.current) {
      let ce = Math.min(O.current.value.length, i - 1), ee = O.current.value.length;
      (K = O.current) == null || K.setSelectionRange(ce, ee), G(ce), q(ee);
    }
    $(!0);
  }, [i]), X = m.useCallback((K) => {
    var ce, ee;
    let re = O.current;
    if (!f && (!T.current.isIOS || !K.clipboardData || !re))
      return;
    let le = K.clipboardData.getData("text/plain"), de = f ? f(le) : le;
    K.preventDefault();
    let be = (ce = O.current) == null ? void 0 : ce.selectionStart, ye = (ee = O.current) == null ? void 0 : ee.selectionEnd, Ce = (be !== ye ? M.slice(0, be) + de + M.slice(ye) : M.slice(0, be) + de + M.slice(be)).slice(0, i);
    if (Ce.length > 0 && k && !k.test(Ce))
      return;
    re.value = Ce, P(Ce);
    let ie = Math.min(Ce.length, i - 1), he = Ce.length;
    re.setSelectionRange(ie, he), G(ie), q(he);
  }, [i, P, k, M]), J = m.useMemo(() => ({ position: "relative", cursor: y.disabled ? "default" : "text", userSelect: "none", WebkitUserSelect: "none", pointerEvents: "none" }), [y.disabled]), ne = m.useMemo(() => ({ position: "absolute", inset: 0, width: j.willPushPWMBadge ? `calc(100% + ${j.PWM_BADGE_SPACE_WIDTH})` : "100%", clipPath: j.willPushPWMBadge ? `inset(0 ${j.PWM_BADGE_SPACE_WIDTH} 0 0)` : void 0, height: "100%", display: "flex", textAlign: s, opacity: "1", color: "transparent", pointerEvents: "all", background: "transparent", caretColor: "transparent", border: "0 solid transparent", outline: "0 solid transparent", boxShadow: "none", lineHeight: "1", letterSpacing: "-.5em", fontSize: "var(--root-height)", fontFamily: "monospace", fontVariantNumeric: "tabular-nums" }), [j.PWM_BADGE_SPACE_WIDTH, j.willPushPWMBadge, s]), Q = m.useMemo(() => m.createElement("input", _D(CD({ autoComplete: y.autoComplete || "one-time-code" }, y), { "data-input-otp": !0, "data-input-otp-placeholder-shown": M.length === 0 || void 0, "data-input-otp-mss": U, "data-input-otp-mse": H, inputMode: c, pattern: k == null ? void 0 : k.source, "aria-placeholder": l, style: ne, maxLength: i, value: M, ref: O, onPaste: (K) => {
    var ce;
    X(K), (ce = y.onPaste) == null || ce.call(y, K);
  }, onChange: W, onMouseOver: (K) => {
    var ce;
    N(!0), (ce = y.onMouseOver) == null || ce.call(y, K);
  }, onMouseLeave: (K) => {
    var ce;
    N(!1), (ce = y.onMouseLeave) == null || ce.call(y, K);
  }, onFocus: (K) => {
    var ce;
    z(), (ce = y.onFocus) == null || ce.call(y, K);
  }, onBlur: (K) => {
    var ce;
    $(!1), (ce = y.onBlur) == null || ce.call(y, K);
  } })), [W, z, X, c, ne, i, H, U, y, k == null ? void 0 : k.source, M]), D = m.useMemo(() => ({ slots: Array.from({ length: i }).map((K, ce) => {
    var ee;
    let re = B && U !== null && H !== null && (U === H && ce === U || ce >= U && ce < H), le = M[ce] !== void 0 ? M[ce] : null, de = M[0] !== void 0 ? null : (ee = l == null ? void 0 : l[ce]) != null ? ee : null;
    return { char: le, placeholderChar: de, isActive: re, hasFakeCaret: re && le === null };
  }), isFocused: B, isHovering: !y.disabled && A }), [B, A, i, H, U, y.disabled, M]), te = m.useMemo(() => g ? g(D) : m.createElement(PD.Provider, { value: D }, v), [v, D, g]);
  return m.createElement(m.Fragment, null, p !== null && m.createElement("noscript", null, m.createElement("style", null, p)), m.createElement("div", { ref: F, "data-input-otp-container": !0, style: J, className: h }, te, m.createElement("div", { style: { position: "absolute", inset: 0, pointerEvents: "none" } }, Q)));
});
G1.displayName = "Input";
function Hi(e, t) {
  try {
    e.insertRule(t);
  } catch {
    console.error("input-otp could not insert CSS rule:", t);
  }
}
var ID = `
[data-input-otp] {
  --nojs-bg: white !important;
  --nojs-fg: black !important;

  background-color: var(--nojs-bg) !important;
  color: var(--nojs-fg) !important;
  caret-color: var(--nojs-fg) !important;
  letter-spacing: .25em !important;
  text-align: center !important;
  border: 1px solid var(--nojs-fg) !important;
  border-radius: 4px !important;
  width: 100% !important;
}
@media (prefers-color-scheme: dark) {
  [data-input-otp] {
    --nojs-bg: black !important;
    --nojs-fg: white !important;
  }
}`, ND = "^\\d+$";
const DD = m.forwardRef(
  ({
    maxLength: e = 6,
    pattern: t = ND,
    value: n,
    onChange: r,
    id: o = m.useId(),
    name: i,
    disabled: s,
    inputMode: a,
    className: l,
    slotClassName: c,
    autoFocus: u = !1,
    onBlur: d,
    onFocus: f
  }, h) => /* @__PURE__ */ _(
    G1,
    {
      "data-slot": "input-otp",
      ref: h,
      id: o,
      name: i,
      maxLength: e,
      pattern: t,
      value: n,
      onChange: r,
      disabled: s,
      inputMode: a,
      autoFocus: u,
      containerClassName: oe("flex items-center gap-2", l),
      className: "disabled:cursor-not-allowed",
      render: ({ slots: p }) => p.map((g, v) => /* @__PURE__ */ _(AD, { ...g, className: c }, v)),
      onFocus: f,
      onBlur: d
    }
  )
);
DD.displayName = "InputOTP";
function AD({
  char: e,
  hasFakeCaret: t,
  isActive: n,
  placeholderChar: r,
  className: o
}) {
  return /* @__PURE__ */ Z(
    "div",
    {
      "data-slot": "input-otp-slot",
      "data-active": n,
      className: oe(
        "border-input relative flex h-9 w-9 items-center justify-center rounded-md border border-foundations-bold bg-foundations-default text-foundations-boldest outline-none transition-all data-[active=true]:border-info-bold data-[active=true]:ring-1 data-[active=true]:ring-info-bold",
        o
      ),
      children: [
        e || r,
        t && /* @__PURE__ */ _("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ _("div", { className: "h-4 w-px animate-caret-blink bg-foundations-bolder duration-1000" }) })
      ]
    }
  );
}
function K1(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
const LD = dn(
  "cursor-pointer rounded focus:ring-2 focus:ring-offset-0",
  {
    variants: {
      variant: {
        primary: "checked:bg-info-bold indeterminate:bg-info-bold hover:checked:bg-info-bold hover:indeterminate:bg-info-bold focus:checked:bg-info-bold focus:indeterminate:bg-info-bold",
        dark: "checked:bg-foundations-boldest indeterminate:bg-foundations-boldest hover:checked:bg-foundations-boldest hover:indeterminate:bg-foundations-boldest focus:checked:bg-foundations-boldest focus:indeterminate:bg-foundations-boldest"
      }
    },
    defaultVariants: {
      variant: "primary"
    }
  }
), q1 = m.forwardRef(
  ({
    disabled: e,
    readOnly: t,
    className: n,
    containerClassName: r,
    label: o,
    description: i,
    isIndeterminate: s = !1,
    variant: a,
    ...l
  }, c) => {
    const u = m.useRef(null);
    return m.useEffect(() => {
      u.current && (u.current.indeterminate = s);
    }, [s]), /* @__PURE__ */ Z(
      "label",
      {
        className: oe("flex space-x-2", r),
        "aria-disabled": e,
        children: [
          /* @__PURE__ */ _(
            "input",
            {
              ref: K1([u, c]),
              className: oe(
                LD({ variant: a }),
                o && "mt-0.5",
                e && "cursor-not-allowed border-foundations-subtle checked:bg-foundations-subtle indeterminate:bg-foundations-subtle hover:checked:bg-foundations-subtle hover:indeterminate:bg-foundations-subtle focus:checked:bg-foundations-subtle focus:indeterminate:bg-foundations-subtle",
                n
              ),
              type: "checkbox",
              disabled: e || t,
              readOnly: t,
              ...l
            }
          ),
          (o || i) && /* @__PURE__ */ Z(
            "div",
            {
              className: oe(
                "flex flex-col text-sm",
                e && "cursor-not-allowed opacity-50"
              ),
              children: [
                o && /* @__PURE__ */ _(Ot, { children: typeof o == "string" ? /* @__PURE__ */ _("span", { className: "font-medium text-foundations-boldest", children: o }) : o }),
                i && /* @__PURE__ */ _("span", { className: "text-foundations-subtle", children: i })
              ]
            }
          )
        ]
      }
    );
  }
);
q1.displayName = "Checkbox";
const $D = dn(
  "group/switch relative inline-flex rounded-full border-2 border-transparent bg-foundations-bold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-info-bold focus:ring-offset-2 focus:ring-offset-[theme(backgroundColor.foundations-default)] aria-[disabled=true]:cursor-not-allowed aria-[disabled=true]:bg-foundations-subtlest data-[checked]:bg-info-bold",
  {
    variants: {
      size: {
        default: "h-6 w-11",
        sm: "h-4 w-[30px]"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), FD = dn(
  "block translate-x-0 rounded-full bg-white transition-transform duration-200 will-change-transform",
  {
    variants: {
      size: {
        default: "h-5 w-5",
        sm: "h-3 w-3"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), p$ = m.forwardRef(({ className: e, children: t, size: n = "default", ...r }, o) => {
  const i = !!t;
  return /* @__PURE__ */ Z(
    D1,
    {
      "data-slot": "switch",
      ref: o,
      className: oe(
        $D({ size: n }),
        i && (n === "sm" ? "w-[38px]" : "w-14"),
        e
      ),
      ...r,
      children: [
        t && /* @__PURE__ */ _(
          "span",
          {
            className: oe(
              "absolute inset-y-0 left-auto z-0 inline-flex items-center font-medium tracking-wider text-foundations-subtle group-data-[checked]/switch:left-1 group-data-[checked]/switch:right-auto group-data-[checked]/switch:text-neutral-white",
              n === "sm" ? "right-0.5 text-[10px]" : "right-1 text-xs"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ _(
          A1,
          {
            "data-slot": "switch-thumb",
            className: oe(
              FD({ size: n }),
              i ? n === "sm" ? "data-[checked]:translate-x-[22px]" : "data-[checked]:translate-x-8" : n === "sm" ? "data-[checked]:translate-x-[14px]" : "data-[checked]:translate-x-5"
            )
          }
        )
      ]
    }
  );
}), VD = m.forwardRef(
  ({ className: e, label: t, description: n, ...r }, o) => /* @__PURE__ */ Z("label", { className: "flex space-x-2", children: [
    /* @__PURE__ */ _(
      "input",
      {
        ref: o,
        className: oe(
          "cursor-pointer border-foundations-subtle checked:border-info-bold checked:bg-info-bold hover:border-foundations-bold hover:checked:bg-info-bolder focus:ring-offset-[theme(backgroundColor.foundations-default)]",
          t && "mt-0.5",
          e
        ),
        type: "radio",
        ...r
      }
    ),
    /* @__PURE__ */ Z("div", { className: "flex flex-col text-sm", children: [
      t && /* @__PURE__ */ _(Ot, { children: typeof t == "string" ? /* @__PURE__ */ _("span", { className: "font-medium text-foundations-bolder", children: t }) : t }),
      n && /* @__PURE__ */ _("span", { className: "text-foundations-subtle", children: n })
    ] })
  ] })
);
VD.displayName = "Radio";
const BD = dn(
  "group/link inline-flex items-center space-x-1 font-medium transition-colors focus:text-info",
  {
    variants: {
      variant: {
        inline: "text-info underline hover:text-link-hovered",
        standalone: "text-info hover:text-link-hovered hover:underline focus:underline"
      },
      size: {
        sm: "text-xs",
        md: "text-sm",
        lg: "text-base"
      }
    },
    defaultVariants: {
      size: "md",
      variant: "standalone"
    }
  }
), Ch = m.forwardRef(
  ({
    className: e,
    children: t,
    size: n,
    variant: r = "standalone",
    showExternalIcon: o = !0,
    truncate: i = !1,
    render: s,
    ...a
  }, l) => {
    const c = {
      className: oe(BD({ variant: r, size: n }), e, {
        "max-w-full overflow-hidden": i
      }),
      children: /* @__PURE__ */ Z(Ot, { children: [
        /* @__PURE__ */ _(s0, { size: "sm", render: /* @__PURE__ */ _("span", {}), children: t }),
        o && /* @__PURE__ */ _(jM, { className: "h-4 w-4 flex-shrink-0" })
      ] }),
      "data-slot": "link"
    };
    return xi({
      defaultTagName: "a",
      ref: l,
      render: s,
      props: kn(c, a)
    });
  }
);
Ch.displayName = "Link";
function js(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = /* @__PURE__ */ Wn(s), l = n.length;
    n = [
      ...n,
      s
    ];
    function c(d) {
      const { scope: f, children: h, ...p } = d, g = (f == null ? void 0 : f[e][l]) || a, v = ai(
        () => p,
        Object.values(p)
      );
      return /* @__PURE__ */ Pe(g.Provider, {
        value: v
      }, h);
    }
    function u(d, f) {
      const h = (f == null ? void 0 : f[e][l]) || a, p = ir(h);
      if (p)
        return p;
      if (s !== void 0)
        return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [
      c,
      u
    ];
  }
  const o = () => {
    const i = n.map((s) => /* @__PURE__ */ Wn(s));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || i;
      return ai(
        () => ({
          [`__scope${e}`]: {
            ...a,
            [e]: l
          }
        }),
        [
          a,
          l
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    HD(o, ...t)
  ];
}
function HD(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const s = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return {
          ...a,
          ...d
        };
      }, {});
      return ai(
        () => ({
          [`__scope${t.scopeName}`]: s
        }),
        [
          s
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function tn(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function WD(e) {
  const t = e + "CollectionProvider", [n, r] = js(t), [o, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), s = (h) => {
    const { scope: p, children: g } = h, v = Y.useRef(null), y = Y.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ Y.createElement(o, {
      scope: p,
      itemMap: y,
      collectionRef: v
    }, g);
  }, a = e + "CollectionSlot", l = /* @__PURE__ */ Y.forwardRef((h, p) => {
    const { scope: g, children: v } = h, y = i(a, g), b = rr(p, y.collectionRef);
    return /* @__PURE__ */ Y.createElement(mi, {
      ref: b
    }, v);
  }), c = e + "CollectionItemSlot", u = "data-radix-collection-item", d = /* @__PURE__ */ Y.forwardRef((h, p) => {
    const { scope: g, children: v, ...y } = h, b = Y.useRef(null), w = rr(p, b), C = i(c, g);
    return Y.useEffect(() => (C.itemMap.set(b, {
      ref: b,
      ...y
    }), () => void C.itemMap.delete(b))), /* @__PURE__ */ Y.createElement(mi, {
      [u]: "",
      ref: w
    }, v);
  });
  function f(h) {
    const p = i(e + "CollectionConsumer", h);
    return Y.useCallback(() => {
      const v = p.collectionRef.current;
      if (!v)
        return [];
      const y = Array.from(v.querySelectorAll(`[${u}]`));
      return Array.from(p.itemMap.values()).sort(
        (C, x) => y.indexOf(C.ref.current) - y.indexOf(x.ref.current)
      );
    }, [
      p.collectionRef,
      p.itemMap
    ]);
  }
  return [
    {
      Provider: s,
      Slot: l,
      ItemSlot: d
    },
    f,
    r
  ];
}
const vi = globalThis != null && globalThis.document ? _s : () => {
}, zD = m["useId".toString()] || (() => {
});
let jD = 0;
function X1(e) {
  const [t, n] = m.useState(zD());
  return vi(() => {
    e || n(
      (r) => r ?? String(jD++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function Sr(e) {
  const t = Be(e);
  return Le(() => {
    t.current = e;
  }), ai(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function Us({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = UD({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, s = i ? e : r, a = Sr(n), l = st((c) => {
    if (i) {
      const d = typeof c == "function" ? c(e) : c;
      d !== e && a(d);
    } else
      o(c);
  }, [
    i,
    e,
    o,
    a
  ]);
  return [
    s,
    l
  ];
}
function UD({ defaultProp: e, onChange: t }) {
  const n = dt(e), [r] = n, o = Be(r), i = Sr(t);
  return Le(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
const YD = /* @__PURE__ */ Wn(void 0);
function Z1(e) {
  const t = ir(YD);
  return e || t || "ltr";
}
const hu = "rovingFocusGroup.onEntryFocus", GD = {
  bubbles: !1,
  cancelable: !0
}, _h = "RovingFocusGroup", [md, Q1, KD] = WD(_h), [qD, J1] = js(_h, [
  KD
]), [XD, ZD] = qD(_h), QD = /* @__PURE__ */ mt((e, t) => /* @__PURE__ */ Pe(md.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ Pe(md.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ Pe(JD, He({}, e, {
  ref: t
}))))), JD = /* @__PURE__ */ mt((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: o = !1, dir: i, currentTabStopId: s, defaultCurrentTabStopId: a, onCurrentTabStopIdChange: l, onEntryFocus: c, ...u } = e, d = Be(null), f = rr(t, d), h = Z1(i), [p = null, g] = Us({
    prop: s,
    defaultProp: a,
    onChange: l
  }), [v, y] = dt(!1), b = Sr(c), w = Q1(n), C = Be(!1), [x, E] = dt(0);
  return Le(() => {
    const S = d.current;
    if (S)
      return S.addEventListener(hu, b), () => S.removeEventListener(hu, b);
  }, [
    b
  ]), /* @__PURE__ */ Pe(XD, {
    scope: n,
    orientation: r,
    dir: h,
    loop: o,
    currentTabStopId: p,
    onItemFocus: st(
      (S) => g(S),
      [
        g
      ]
    ),
    onItemShiftTab: st(
      () => y(!0),
      []
    ),
    onFocusableItemAdd: st(
      () => E(
        (S) => S + 1
      ),
      []
    ),
    onFocusableItemRemove: st(
      () => E(
        (S) => S - 1
      ),
      []
    )
  }, /* @__PURE__ */ Pe(Cn.div, He({
    tabIndex: v || x === 0 ? -1 : 0,
    "data-orientation": r
  }, u, {
    ref: f,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: tn(e.onMouseDown, () => {
      C.current = !0;
    }),
    onFocus: tn(e.onFocus, (S) => {
      const R = !C.current;
      if (S.target === S.currentTarget && R && !v) {
        const M = new CustomEvent(hu, GD);
        if (S.currentTarget.dispatchEvent(M), !M.defaultPrevented) {
          const I = w().filter(
            (T) => T.focusable
          ), P = I.find(
            (T) => T.active
          ), k = I.find(
            (T) => T.id === p
          ), F = [
            P,
            k,
            ...I
          ].filter(Boolean).map(
            (T) => T.ref.current
          );
          ex(F);
        }
      }
      C.current = !1;
    }),
    onBlur: tn(
      e.onBlur,
      () => y(!1)
    )
  })));
}), e3 = "RovingFocusGroupItem", t3 = /* @__PURE__ */ mt((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: o = !1, tabStopId: i, ...s } = e, a = X1(), l = i || a, c = ZD(e3, n), u = c.currentTabStopId === l, d = Q1(n), { onFocusableItemAdd: f, onFocusableItemRemove: h } = c;
  return Le(() => {
    if (r)
      return f(), () => h();
  }, [
    r,
    f,
    h
  ]), /* @__PURE__ */ Pe(md.ItemSlot, {
    scope: n,
    id: l,
    focusable: r,
    active: o
  }, /* @__PURE__ */ Pe(Cn.span, He({
    tabIndex: u ? 0 : -1,
    "data-orientation": c.orientation
  }, s, {
    ref: t,
    onMouseDown: tn(e.onMouseDown, (p) => {
      r ? c.onItemFocus(l) : p.preventDefault();
    }),
    onFocus: tn(
      e.onFocus,
      () => c.onItemFocus(l)
    ),
    onKeyDown: tn(e.onKeyDown, (p) => {
      if (p.key === "Tab" && p.shiftKey) {
        c.onItemShiftTab();
        return;
      }
      if (p.target !== p.currentTarget)
        return;
      const g = o3(p, c.orientation, c.dir);
      if (g !== void 0) {
        p.preventDefault();
        let y = d().filter(
          (b) => b.focusable
        ).map(
          (b) => b.ref.current
        );
        if (g === "last")
          y.reverse();
        else if (g === "prev" || g === "next") {
          g === "prev" && y.reverse();
          const b = y.indexOf(p.currentTarget);
          y = c.loop ? i3(y, b + 1) : y.slice(b + 1);
        }
        setTimeout(
          () => ex(y)
        );
      }
    })
  })));
}), n3 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function r3(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function o3(e, t, n) {
  const r = r3(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return n3[r];
}
function ex(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function i3(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const s3 = QD, a3 = t3, l3 = /* @__PURE__ */ mt((e, t) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: o, ...i } = e, [s = !1, a] = Us({
    prop: n,
    onChange: o,
    defaultProp: r
  });
  return /* @__PURE__ */ Pe(Cn.button, He({
    type: "button",
    "aria-pressed": s,
    "data-state": s ? "on" : "off",
    "data-disabled": e.disabled ? "" : void 0
  }, i, {
    ref: t,
    onClick: tn(e.onClick, () => {
      e.disabled || a(!s);
    })
  }));
}), Mc = "ToggleGroup", [tx, g$] = js(Mc, [
  J1
]), nx = J1(), c3 = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { type: n, ...r } = e;
  if (n === "single") {
    const o = r;
    return /* @__PURE__ */ Y.createElement(u3, He({}, o, {
      ref: t
    }));
  }
  if (n === "multiple") {
    const o = r;
    return /* @__PURE__ */ Y.createElement(d3, He({}, o, {
      ref: t
    }));
  }
  throw new Error(`Missing prop \`type\` expected on \`${Mc}\``);
}), [rx, ox] = tx(Mc), u3 = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...i } = e, [s, a] = Us({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ Y.createElement(rx, {
    scope: e.__scopeToggleGroup,
    type: "single",
    value: s ? [
      s
    ] : [],
    onItemActivate: a,
    onItemDeactivate: Y.useCallback(
      () => a(""),
      [
        a
      ]
    )
  }, /* @__PURE__ */ Y.createElement(ix, He({}, i, {
    ref: t
  })));
}), d3 = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...i } = e, [s = [], a] = Us({
    prop: n,
    defaultProp: r,
    onChange: o
  }), l = Y.useCallback(
    (u) => a(
      (d = []) => [
        ...d,
        u
      ]
    ),
    [
      a
    ]
  ), c = Y.useCallback(
    (u) => a(
      (d = []) => d.filter(
        (f) => f !== u
      )
    ),
    [
      a
    ]
  );
  return /* @__PURE__ */ Y.createElement(rx, {
    scope: e.__scopeToggleGroup,
    type: "multiple",
    value: s,
    onItemActivate: l,
    onItemDeactivate: c
  }, /* @__PURE__ */ Y.createElement(ix, He({}, i, {
    ref: t
  })));
}), [f3, h3] = tx(Mc), ix = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, disabled: r = !1, rovingFocus: o = !0, orientation: i, dir: s, loop: a = !0, ...l } = e, c = nx(n), u = Z1(s), d = {
    role: "group",
    dir: u,
    ...l
  };
  return /* @__PURE__ */ Y.createElement(f3, {
    scope: n,
    rovingFocus: o,
    disabled: r
  }, o ? /* @__PURE__ */ Y.createElement(s3, He({
    asChild: !0
  }, c, {
    orientation: i,
    dir: u,
    loop: a
  }), /* @__PURE__ */ Y.createElement(Cn.div, He({}, d, {
    ref: t
  }))) : /* @__PURE__ */ Y.createElement(Cn.div, He({}, d, {
    ref: t
  })));
}), vd = "ToggleGroupItem", p3 = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const n = ox(vd, e.__scopeToggleGroup), r = h3(vd, e.__scopeToggleGroup), o = nx(e.__scopeToggleGroup), i = n.value.includes(e.value), s = r.disabled || e.disabled, a = {
    ...e,
    pressed: i,
    disabled: s
  }, l = Y.useRef(null);
  return r.rovingFocus ? /* @__PURE__ */ Y.createElement(a3, He({
    asChild: !0
  }, o, {
    focusable: !s,
    active: i,
    ref: l
  }), /* @__PURE__ */ Y.createElement(Fm, He({}, a, {
    ref: t
  }))) : /* @__PURE__ */ Y.createElement(Fm, He({}, a, {
    ref: t
  }));
}), Fm = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, value: r, ...o } = e, i = ox(vd, n), s = {
    role: "radio",
    "aria-checked": e.pressed,
    "aria-pressed": void 0
  }, a = i.type === "single" ? s : void 0;
  return /* @__PURE__ */ Y.createElement(l3, He({}, a, o, {
    ref: t,
    onPressedChange: (l) => {
      l ? i.onItemActivate(r) : i.onItemDeactivate(r);
    }
  }));
}), g3 = c3, m3 = p3, v3 = m.forwardRef(({ onValueChange: e, className: t, canReset: n = !1, error: r, ...o }, i) => /* @__PURE__ */ _(
  g3,
  {
    ref: i,
    className: oe(
      "inline-flex flex-shrink-0 space-x-2 rounded-md border border-foundations-subtle p-1",
      r && "border-red-500 focus:border-red-500 focus:ring-red-500",
      t
    ),
    type: "single",
    onValueChange: (s) => {
      (s || n) && e(s);
    },
    ...o
  }
));
v3.displayName = "OptionsGroup";
const b3 = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  m3,
  {
    ref: n,
    type: "button",
    className: oe(
      "rounded px-2 py-1.5 text-sm font-medium text-foundations-subtle hover:bg-neutral-200 focus:bg-neutral-200 focus:outline-none aria-checked:bg-info-bold aria-checked:text-foundations-inverse aria-checked:focus:bg-info-bolder",
      e
    ),
    ...t
  }
));
b3.displayName = "Option";
var Re = function() {
  return Re = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Re.apply(this, arguments);
};
function y3(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function sx(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function Ys(e) {
  return e.mode === "multiple";
}
function Gs(e) {
  return e.mode === "range";
}
function Oc(e) {
  return e.mode === "single";
}
var x3 = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function w3(e, t) {
  return Qt(e, "LLLL y", t);
}
function C3(e, t) {
  return Qt(e, "d", t);
}
function _3(e, t) {
  return Qt(e, "LLLL", t);
}
function E3(e) {
  return "".concat(e);
}
function S3(e, t) {
  return Qt(e, "cccccc", t);
}
function M3(e, t) {
  return Qt(e, "yyyy", t);
}
var O3 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: w3,
  formatDay: C3,
  formatMonthCaption: _3,
  formatWeekNumber: E3,
  formatWeekdayName: S3,
  formatYearCaption: M3
}), R3 = function(e, t, n) {
  return Qt(e, "do MMMM (EEEE)", n);
}, T3 = function() {
  return "Month: ";
}, k3 = function() {
  return "Go to next month";
}, P3 = function() {
  return "Go to previous month";
}, I3 = function(e, t) {
  return Qt(e, "cccc", t);
}, N3 = function(e) {
  return "Week n. ".concat(e);
}, D3 = function() {
  return "Year: ";
}, A3 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: R3,
  labelMonthDropdown: T3,
  labelNext: k3,
  labelPrevious: P3,
  labelWeekNumber: N3,
  labelWeekday: I3,
  labelYearDropdown: D3
});
function L3() {
  var e = "buttons", t = x3, n = Gf, r = {}, o = {}, i = 1, s = {}, a = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: O3,
    labels: A3,
    locale: n,
    modifiersClassNames: r,
    modifiers: o,
    numberOfMonths: i,
    styles: s,
    today: a,
    mode: "default"
  };
}
function $3(e) {
  var t = e.fromYear, n = e.toYear, r = e.fromMonth, o = e.toMonth, i = e.fromDate, s = e.toDate;
  return r ? i = en(r) : t && (i = new Date(t, 0, 1)), o ? s = $s(o) : n && (s = new Date(n, 11, 31)), {
    fromDate: i ? To(i) : void 0,
    toDate: s ? To(s) : void 0
  };
}
var ax = Wn(void 0);
function F3(e) {
  var t, n = e.initialProps, r = L3(), o = $3(n), i = o.fromDate, s = o.toDate, a = (t = n.captionLayout) !== null && t !== void 0 ? t : r.captionLayout;
  a !== "buttons" && (!i || !s) && (a = "buttons");
  var l;
  (Oc(n) || Ys(n) || Gs(n)) && (l = n.onSelect);
  var c = Re(Re(Re({}, r), n), { captionLayout: a, classNames: Re(Re({}, r.classNames), n.classNames), components: Re({}, n.components), formatters: Re(Re({}, r.formatters), n.formatters), fromDate: i, labels: Re(Re({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: Re(Re({}, r.modifiers), n.modifiers), modifiersClassNames: Re(Re({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: Re(Re({}, r.styles), n.styles), toDate: s });
  return Y.createElement(ax.Provider, { value: c }, e.children);
}
function vt() {
  var e = ir(ax);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function lx(e) {
  var t = vt(), n = t.locale, r = t.classNames, o = t.styles, i = t.formatters.formatCaption;
  return Y.createElement("div", { className: r.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: e.id }, i(e.displayMonth, { locale: n }));
}
function V3(e) {
  return Y.createElement(
    "svg",
    Re({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e),
    Y.createElement("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" })
  );
}
function cx(e) {
  var t, n, r = e.onChange, o = e.value, i = e.children, s = e.caption, a = e.className, l = e.style, c = vt(), u = (n = (t = c.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : V3;
  return Y.createElement(
    "div",
    { className: a, style: l },
    Y.createElement("span", { className: c.classNames.vhidden }, e["aria-label"]),
    Y.createElement("select", { name: e.name, "aria-label": e["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: o, onChange: r }, i),
    Y.createElement(
      "div",
      { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true" },
      s,
      Y.createElement(u, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })
    )
  );
}
function B3(e) {
  var t, n = vt(), r = n.fromDate, o = n.toDate, i = n.styles, s = n.locale, a = n.formatters.formatMonthCaption, l = n.classNames, c = n.components, u = n.labels.labelMonthDropdown;
  if (!r)
    return Y.createElement(Y.Fragment, null);
  if (!o)
    return Y.createElement(Y.Fragment, null);
  var d = [];
  if (m6(r, o))
    for (var f = en(r), h = r.getMonth(); h <= o.getMonth(); h++)
      d.push(du(f, h));
  else
    for (var f = en(/* @__PURE__ */ new Date()), h = 0; h <= 11; h++)
      d.push(du(f, h));
  var p = function(v) {
    var y = Number(v.target.value), b = du(en(e.displayMonth), y);
    e.onChange(b);
  }, g = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : cx;
  return Y.createElement(g, { name: "months", "aria-label": u(), className: l.dropdown_month, style: i.dropdown_month, onChange: p, value: e.displayMonth.getMonth(), caption: a(e.displayMonth, { locale: s }) }, d.map(function(v) {
    return Y.createElement("option", { key: v.getMonth(), value: v.getMonth() }, a(v, { locale: s }));
  }));
}
function H3(e) {
  var t, n = e.displayMonth, r = vt(), o = r.fromDate, i = r.toDate, s = r.locale, a = r.styles, l = r.classNames, c = r.components, u = r.formatters.formatYearCaption, d = r.labels.labelYearDropdown, f = [];
  if (!o)
    return Y.createElement(Y.Fragment, null);
  if (!i)
    return Y.createElement(Y.Fragment, null);
  for (var h = o.getFullYear(), p = i.getFullYear(), g = h; g <= p; g++)
    f.push(Om(cy(/* @__PURE__ */ new Date()), g));
  var v = function(b) {
    var w = Om(en(n), Number(b.target.value));
    e.onChange(w);
  }, y = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : cx;
  return Y.createElement(y, { name: "years", "aria-label": d(), className: l.dropdown_year, style: a.dropdown_year, onChange: v, value: n.getFullYear(), caption: u(n, { locale: s }) }, f.map(function(b) {
    return Y.createElement("option", { key: b.getFullYear(), value: b.getFullYear() }, u(b, { locale: s }));
  }));
}
function W3(e, t) {
  var n = dt(e), r = n[0], o = n[1], i = t === void 0 ? r : t;
  return [i, o];
}
function z3(e) {
  var t = e.month, n = e.defaultMonth, r = e.today, o = t || n || r || /* @__PURE__ */ new Date(), i = e.toDate, s = e.fromDate, a = e.numberOfMonths, l = a === void 0 ? 1 : a;
  if (i && pi(i, o) < 0) {
    var c = -1 * (l - 1);
    o = Nn(i, c);
  }
  return s && pi(o, s) < 0 && (o = s), en(o);
}
function j3() {
  var e = vt(), t = z3(e), n = W3(t, e.month), r = n[0], o = n[1], i = function(s) {
    var a;
    if (!e.disableNavigation) {
      var l = en(s);
      o(l), (a = e.onMonthChange) === null || a === void 0 || a.call(e, l);
    }
  };
  return [r, i];
}
function U3(e, t) {
  for (var n = t.reverseMonths, r = t.numberOfMonths, o = en(e), i = en(Nn(o, r)), s = pi(i, o), a = [], l = 0; l < s; l++) {
    var c = Nn(o, l);
    a.push(c);
  }
  return n && (a = a.reverse()), a;
}
function Y3(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, r = t.pagedNavigation, o = t.numberOfMonths, i = o === void 0 ? 1 : o, s = r ? i : 1, a = en(e);
    if (!n)
      return Nn(a, s);
    var l = pi(n, e);
    if (!(l < i))
      return Nn(a, s);
  }
}
function G3(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, r = t.pagedNavigation, o = t.numberOfMonths, i = o === void 0 ? 1 : o, s = r ? i : 1, a = en(e);
    if (!n)
      return Nn(a, -s);
    var l = pi(a, n);
    if (!(l <= 0))
      return Nn(a, -s);
  }
}
var ux = Wn(void 0);
function K3(e) {
  var t = vt(), n = j3(), r = n[0], o = n[1], i = U3(r, t), s = Y3(r, t), a = G3(r, t), l = function(d) {
    return i.some(function(f) {
      return Xf(d, f);
    });
  }, c = function(d, f) {
    l(d) || (f && yy(d, f) ? o(Nn(d, 1 + t.numberOfMonths * -1)) : o(d));
  }, u = {
    currentMonth: r,
    displayMonths: i,
    goToMonth: o,
    goToDate: c,
    previousMonth: a,
    nextMonth: s,
    isDateDisplayed: l
  };
  return Y.createElement(ux.Provider, { value: u }, e.children);
}
function Si() {
  var e = ir(ux);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function Vm(e) {
  var t, n = vt(), r = n.classNames, o = n.styles, i = n.components, s = Si().goToMonth, a = function(u) {
    s(u);
  }, l = (t = i == null ? void 0 : i.CaptionLabel) !== null && t !== void 0 ? t : lx, c = Y.createElement(l, { id: e.id, displayMonth: e.displayMonth });
  return Y.createElement(
    "div",
    { className: r.caption_dropdowns, style: o.caption_dropdowns },
    Y.createElement("div", { className: r.vhidden }, c),
    Y.createElement(B3, { onChange: a, displayMonth: e.displayMonth }),
    Y.createElement(H3, { onChange: a, displayMonth: e.displayMonth })
  );
}
function q3(e) {
  return Y.createElement(
    "svg",
    Re({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e),
    Y.createElement("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" })
  );
}
function X3(e) {
  return Y.createElement(
    "svg",
    Re({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e),
    Y.createElement("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" })
  );
}
var kl = mt(function(e, t) {
  var n = vt(), r = n.classNames, o = n.styles, i = [r.button_reset, r.button];
  e.className && i.push(e.className);
  var s = i.join(" "), a = Re(Re({}, o.button_reset), o.button);
  return e.style && Object.assign(a, e.style), Y.createElement("button", Re({}, e, { ref: t, type: "button", className: s, style: a }));
});
function Z3(e) {
  var t, n, r = vt(), o = r.dir, i = r.locale, s = r.classNames, a = r.styles, l = r.labels, c = l.labelPrevious, u = l.labelNext, d = r.components;
  if (!e.nextMonth && !e.previousMonth)
    return Y.createElement(Y.Fragment, null);
  var f = c(e.previousMonth, { locale: i }), h = [
    s.nav_button,
    s.nav_button_previous
  ].join(" "), p = u(e.nextMonth, { locale: i }), g = [
    s.nav_button,
    s.nav_button_next
  ].join(" "), v = (t = d == null ? void 0 : d.IconRight) !== null && t !== void 0 ? t : X3, y = (n = d == null ? void 0 : d.IconLeft) !== null && n !== void 0 ? n : q3;
  return Y.createElement(
    "div",
    { className: s.nav, style: a.nav },
    !e.hidePrevious && Y.createElement(kl, { name: "previous-month", "aria-label": f, className: h, style: a.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick }, o === "rtl" ? Y.createElement(v, { className: s.nav_icon, style: a.nav_icon }) : Y.createElement(y, { className: s.nav_icon, style: a.nav_icon })),
    !e.hideNext && Y.createElement(kl, { name: "next-month", "aria-label": p, className: g, style: a.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick }, o === "rtl" ? Y.createElement(y, { className: s.nav_icon, style: a.nav_icon }) : Y.createElement(v, { className: s.nav_icon, style: a.nav_icon }))
  );
}
function Bm(e) {
  var t = vt().numberOfMonths, n = Si(), r = n.previousMonth, o = n.nextMonth, i = n.goToMonth, s = n.displayMonths, a = s.findIndex(function(p) {
    return Xf(e.displayMonth, p);
  }), l = a === 0, c = a === s.length - 1, u = t > 1 && (l || !c), d = t > 1 && (c || !l), f = function() {
    r && i(r);
  }, h = function() {
    o && i(o);
  };
  return Y.createElement(Z3, { displayMonth: e.displayMonth, hideNext: u, hidePrevious: d, nextMonth: o, previousMonth: r, onPreviousClick: f, onNextClick: h });
}
function Q3(e) {
  var t, n = vt(), r = n.classNames, o = n.disableNavigation, i = n.styles, s = n.captionLayout, a = n.components, l = (t = a == null ? void 0 : a.CaptionLabel) !== null && t !== void 0 ? t : lx, c;
  return o ? c = Y.createElement(l, { id: e.id, displayMonth: e.displayMonth }) : s === "dropdown" ? c = Y.createElement(Vm, { displayMonth: e.displayMonth, id: e.id }) : s === "dropdown-buttons" ? c = Y.createElement(
    Y.Fragment,
    null,
    Y.createElement(Vm, { displayMonth: e.displayMonth, id: e.id }),
    Y.createElement(Bm, { displayMonth: e.displayMonth, id: e.id })
  ) : c = Y.createElement(
    Y.Fragment,
    null,
    Y.createElement(l, { id: e.id, displayMonth: e.displayMonth }),
    Y.createElement(Bm, { displayMonth: e.displayMonth, id: e.id })
  ), Y.createElement("div", { className: r.caption, style: i.caption }, c);
}
function J3(e) {
  var t = vt(), n = t.footer, r = t.styles, o = t.classNames.tfoot;
  return n ? Y.createElement(
    "tfoot",
    { className: o, style: r.tfoot },
    Y.createElement(
      "tr",
      null,
      Y.createElement("td", { colSpan: 8 }, n)
    )
  ) : Y.createElement(Y.Fragment, null);
}
function e4(e, t, n) {
  for (var r = n ? Ro(/* @__PURE__ */ new Date()) : Dn(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), o = [], i = 0; i < 7; i++) {
    var s = bn(r, i);
    o.push(s);
  }
  return o;
}
function t4() {
  var e = vt(), t = e.classNames, n = e.styles, r = e.showWeekNumber, o = e.locale, i = e.weekStartsOn, s = e.ISOWeek, a = e.formatters.formatWeekdayName, l = e.labels.labelWeekday, c = e4(o, i, s);
  return Y.createElement(
    "tr",
    { style: n.head_row, className: t.head_row },
    r && Y.createElement("td", { style: n.head_cell, className: t.head_cell }),
    c.map(function(u, d) {
      return Y.createElement("th", { key: d, scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": l(u, { locale: o }) }, a(u, { locale: o }));
    })
  );
}
function n4() {
  var e, t = vt(), n = t.classNames, r = t.styles, o = t.components, i = (e = o == null ? void 0 : o.HeadRow) !== null && e !== void 0 ? e : t4;
  return Y.createElement(
    "thead",
    { style: r.head, className: n.head },
    Y.createElement(i, null)
  );
}
function r4(e) {
  var t = vt(), n = t.locale, r = t.formatters.formatDay;
  return Y.createElement(Y.Fragment, null, r(e.date, { locale: n }));
}
var Eh = Wn(void 0);
function o4(e) {
  if (!Ys(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return Y.createElement(Eh.Provider, { value: t }, e.children);
  }
  return Y.createElement(i4, { initialProps: e.initialProps, children: e.children });
}
function i4(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = t.min, i = t.max, s = function(c, u, d) {
    var f, h;
    (f = t.onDayClick) === null || f === void 0 || f.call(t, c, u, d);
    var p = !!(u.selected && o && (r == null ? void 0 : r.length) === o);
    if (!p) {
      var g = !!(!u.selected && i && (r == null ? void 0 : r.length) === i);
      if (!g) {
        var v = r ? sx([], r, !0) : [];
        if (u.selected) {
          var y = v.findIndex(function(b) {
            return an(c, b);
          });
          v.splice(y, 1);
        } else
          v.push(c);
        (h = t.onSelect) === null || h === void 0 || h.call(t, v, c, u, d);
      }
    }
  }, a = {
    disabled: []
  };
  r && a.disabled.push(function(c) {
    var u = i && r.length > i - 1, d = r.some(function(f) {
      return an(f, c);
    });
    return !!(u && !d);
  });
  var l = {
    selected: r,
    onDayClick: s,
    modifiers: a
  };
  return Y.createElement(Eh.Provider, { value: l }, n);
}
function Sh() {
  var e = ir(Eh);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function s4(e, t) {
  var n = t || {}, r = n.from, o = n.to;
  if (!r)
    return { from: e, to: void 0 };
  if (!o && an(r, e))
    return { from: r, to: e };
  if (!o && yy(e, r))
    return { from: e, to: r };
  if (!o)
    return { from: r, to: e };
  if (!(an(o, e) && an(r, e))) {
    if (an(o, e))
      return { from: o, to: void 0 };
    if (!an(r, e))
      return by(r, e) ? { from: e, to: o } : { from: r, to: e };
  }
}
var Mh = Wn(void 0);
function a4(e) {
  if (!Gs(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return Y.createElement(Mh.Provider, { value: t }, e.children);
  }
  return Y.createElement(l4, { initialProps: e.initialProps, children: e.children });
}
function l4(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = r || {}, i = o.from, s = o.to, a = t.min, l = t.max, c = function(h, p, g) {
    var v, y;
    (v = t.onDayClick) === null || v === void 0 || v.call(t, h, p, g);
    var b = s4(h, r);
    (y = t.onSelect) === null || y === void 0 || y.call(t, b, h, p, g);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (i && (u.range_start = [i], s ? (u.range_end = [s], an(i, s) || (u.range_middle = [
    {
      after: i,
      before: s
    }
  ])) : u.range_end = [i]), a && (i && !s && u.disabled.push({
    after: Mm(i, a - 1),
    before: bn(i, a - 1)
  }), i && s && u.disabled.push({
    after: i,
    before: bn(i, a - 1)
  })), l && (i && !s && (u.disabled.push({
    before: bn(i, -l + 1)
  }), u.disabled.push({
    after: bn(i, l - 1)
  })), i && s)) {
    var d = Rn(s, i) + 1, f = l - d;
    u.disabled.push({
      before: Mm(i, f)
    }), u.disabled.push({
      after: bn(s, f)
    });
  }
  return Y.createElement(Mh.Provider, { value: { selected: r, onDayClick: c, modifiers: u } }, n);
}
function Oh() {
  var e = ir(Mh);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function Xa(e) {
  return Array.isArray(e) ? sx([], e, !0) : e !== void 0 ? [e] : [];
}
function c4(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var r = n[0], o = n[1];
    t[r] = Xa(o);
  }), t;
}
var jn;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(jn || (jn = {}));
var u4 = jn.Selected, hr = jn.Disabled, d4 = jn.Hidden, f4 = jn.Today, pu = jn.RangeEnd, gu = jn.RangeMiddle, mu = jn.RangeStart, h4 = jn.Outside;
function p4(e, t, n) {
  var r, o = (r = {}, r[u4] = Xa(e.selected), r[hr] = Xa(e.disabled), r[d4] = Xa(e.hidden), r[f4] = [e.today], r[pu] = [], r[gu] = [], r[mu] = [], r[h4] = [], r);
  return e.fromDate && o[hr].push({ before: e.fromDate }), e.toDate && o[hr].push({ after: e.toDate }), Ys(e) ? o[hr] = o[hr].concat(t.modifiers[hr]) : Gs(e) && (o[hr] = o[hr].concat(n.modifiers[hr]), o[mu] = n.modifiers[mu], o[gu] = n.modifiers[gu], o[pu] = n.modifiers[pu]), o;
}
var dx = Wn(void 0);
function g4(e) {
  var t = vt(), n = Sh(), r = Oh(), o = p4(t, n, r), i = c4(t.modifiers), s = Re(Re({}, o), i);
  return Y.createElement(dx.Provider, { value: s }, e.children);
}
function fx() {
  var e = ir(dx);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function m4(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function v4(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function b4(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function y4(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function x4(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function w4(e, t) {
  var n, r = t.from, o = t.to;
  if (!r)
    return !1;
  if (!o && an(r, e))
    return !0;
  if (!o)
    return !1;
  var i = Rn(o, r) < 0;
  i && (n = [o, r], r = n[0], o = n[1]);
  var s = Rn(e, r) >= 0 && Rn(o, e) >= 0;
  return s;
}
function C4(e) {
  return jf(e);
}
function _4(e) {
  return Array.isArray(e) && e.every(jf);
}
function E4(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (C4(n))
      return an(e, n);
    if (_4(n))
      return n.includes(e);
    if (v4(n))
      return w4(e, n);
    if (x4(n))
      return n.dayOfWeek.includes(e.getDay());
    if (m4(n)) {
      var r = Rn(n.before, e), o = Rn(n.after, e), i = r > 0, s = o < 0, a = by(n.before, n.after);
      return a ? s && i : i || s;
    }
    return b4(n) ? Rn(e, n.after) > 0 : y4(n) ? Rn(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function Rh(e, t, n) {
  var r = Object.keys(t).reduce(function(i, s) {
    var a = t[s];
    return E4(e, a) && i.push(s), i;
  }, []), o = {};
  return r.forEach(function(i) {
    return o[i] = !0;
  }), n && !Xf(e, n) && (o.outside = !0), o;
}
function S4(e, t) {
  for (var n = en(e[0]), r = $s(e[e.length - 1]), o, i, s = n; s <= r; ) {
    var a = Rh(s, t), l = !a.disabled && !a.hidden;
    if (!l) {
      s = bn(s, 1);
      continue;
    }
    if (a.selected)
      return s;
    a.today && !i && (i = s), o || (o = s), s = bn(s, 1);
  }
  return i || o;
}
var M4 = 365;
function hx(e, t) {
  var n = t.moveBy, r = t.direction, o = t.context, i = t.modifiers, s = t.retry, a = s === void 0 ? { count: 0, lastFocused: e } : s, l = o.weekStartsOn, c = o.fromDate, u = o.toDate, d = o.locale, f = {
    day: bn,
    week: Sl,
    month: Nn,
    year: iy,
    startOfWeek: function(v) {
      return o.ISOWeek ? Ro(v) : Dn(v, { locale: d, weekStartsOn: l });
    },
    endOfWeek: function(v) {
      return o.ISOWeek ? uy(v) : Cc(v, { locale: d, weekStartsOn: l });
    }
  }, h = f[n](e, r === "after" ? 1 : -1);
  r === "before" && c ? h = AP([c, h]) : r === "after" && u && (h = LP([u, h]));
  var p = !0;
  if (i) {
    var g = Rh(h, i);
    p = !g.disabled && !g.hidden;
  }
  return p ? h : a.count > M4 ? a.lastFocused : hx(h, {
    moveBy: n,
    direction: r,
    context: o,
    modifiers: i,
    retry: Re(Re({}, a), { count: a.count + 1 })
  });
}
var px = Wn(void 0);
function O4(e) {
  var t = Si(), n = fx(), r = dt(), o = r[0], i = r[1], s = dt(), a = s[0], l = s[1], c = S4(t.displayMonths, n), u = o ?? (a && t.isDateDisplayed(a)) ? a : c, d = function() {
    l(o), i(void 0);
  }, f = function(v) {
    i(v);
  }, h = vt(), p = function(v, y) {
    if (o) {
      var b = hx(o, {
        moveBy: v,
        direction: y,
        context: h,
        modifiers: n
      });
      an(o, b) || (t.goToDate(b, o), f(b));
    }
  }, g = {
    focusedDay: o,
    focusTarget: u,
    blur: d,
    focus: f,
    focusDayAfter: function() {
      return p("day", "after");
    },
    focusDayBefore: function() {
      return p("day", "before");
    },
    focusWeekAfter: function() {
      return p("week", "after");
    },
    focusWeekBefore: function() {
      return p("week", "before");
    },
    focusMonthBefore: function() {
      return p("month", "before");
    },
    focusMonthAfter: function() {
      return p("month", "after");
    },
    focusYearBefore: function() {
      return p("year", "before");
    },
    focusYearAfter: function() {
      return p("year", "after");
    },
    focusStartOfWeek: function() {
      return p("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return p("endOfWeek", "after");
    }
  };
  return Y.createElement(px.Provider, { value: g }, e.children);
}
function Th() {
  var e = ir(px);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function R4(e, t) {
  var n = fx(), r = Rh(e, n, t);
  return r;
}
var kh = Wn(void 0);
function T4(e) {
  if (!Oc(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return Y.createElement(kh.Provider, { value: t }, e.children);
  }
  return Y.createElement(k4, { initialProps: e.initialProps, children: e.children });
}
function k4(e) {
  var t = e.initialProps, n = e.children, r = function(i, s, a) {
    var l, c, u;
    if ((l = t.onDayClick) === null || l === void 0 || l.call(t, i, s, a), s.selected && !t.required) {
      (c = t.onSelect) === null || c === void 0 || c.call(t, void 0, i, s, a);
      return;
    }
    (u = t.onSelect) === null || u === void 0 || u.call(t, i, i, s, a);
  }, o = {
    selected: t.selected,
    onDayClick: r
  };
  return Y.createElement(kh.Provider, { value: o }, n);
}
function gx() {
  var e = ir(kh);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function P4(e, t) {
  var n = vt(), r = gx(), o = Sh(), i = Oh(), s = Th(), a = s.focusDayAfter, l = s.focusDayBefore, c = s.focusWeekAfter, u = s.focusWeekBefore, d = s.blur, f = s.focus, h = s.focusMonthBefore, p = s.focusMonthAfter, g = s.focusYearBefore, v = s.focusYearAfter, y = s.focusStartOfWeek, b = s.focusEndOfWeek, w = function(A) {
    var N, B, $, U;
    Oc(n) ? (N = r.onDayClick) === null || N === void 0 || N.call(r, e, t, A) : Ys(n) ? (B = o.onDayClick) === null || B === void 0 || B.call(o, e, t, A) : Gs(n) ? ($ = i.onDayClick) === null || $ === void 0 || $.call(i, e, t, A) : (U = n.onDayClick) === null || U === void 0 || U.call(n, e, t, A);
  }, C = function(A) {
    var N;
    f(e), (N = n.onDayFocus) === null || N === void 0 || N.call(n, e, t, A);
  }, x = function(A) {
    var N;
    d(), (N = n.onDayBlur) === null || N === void 0 || N.call(n, e, t, A);
  }, E = function(A) {
    var N;
    (N = n.onDayMouseEnter) === null || N === void 0 || N.call(n, e, t, A);
  }, S = function(A) {
    var N;
    (N = n.onDayMouseLeave) === null || N === void 0 || N.call(n, e, t, A);
  }, R = function(A) {
    var N;
    (N = n.onDayPointerEnter) === null || N === void 0 || N.call(n, e, t, A);
  }, M = function(A) {
    var N;
    (N = n.onDayPointerLeave) === null || N === void 0 || N.call(n, e, t, A);
  }, I = function(A) {
    var N;
    (N = n.onDayTouchCancel) === null || N === void 0 || N.call(n, e, t, A);
  }, P = function(A) {
    var N;
    (N = n.onDayTouchEnd) === null || N === void 0 || N.call(n, e, t, A);
  }, k = function(A) {
    var N;
    (N = n.onDayTouchMove) === null || N === void 0 || N.call(n, e, t, A);
  }, O = function(A) {
    var N;
    (N = n.onDayTouchStart) === null || N === void 0 || N.call(n, e, t, A);
  }, F = function(A) {
    var N;
    (N = n.onDayKeyUp) === null || N === void 0 || N.call(n, e, t, A);
  }, T = function(A) {
    var N;
    switch (A.key) {
      case "ArrowLeft":
        A.preventDefault(), A.stopPropagation(), n.dir === "rtl" ? a() : l();
        break;
      case "ArrowRight":
        A.preventDefault(), A.stopPropagation(), n.dir === "rtl" ? l() : a();
        break;
      case "ArrowDown":
        A.preventDefault(), A.stopPropagation(), c();
        break;
      case "ArrowUp":
        A.preventDefault(), A.stopPropagation(), u();
        break;
      case "PageUp":
        A.preventDefault(), A.stopPropagation(), A.shiftKey ? g() : h();
        break;
      case "PageDown":
        A.preventDefault(), A.stopPropagation(), A.shiftKey ? v() : p();
        break;
      case "Home":
        A.preventDefault(), A.stopPropagation(), y();
        break;
      case "End":
        A.preventDefault(), A.stopPropagation(), b();
        break;
    }
    (N = n.onDayKeyDown) === null || N === void 0 || N.call(n, e, t, A);
  }, L = {
    onClick: w,
    onFocus: C,
    onBlur: x,
    onKeyDown: T,
    onKeyUp: F,
    onMouseEnter: E,
    onMouseLeave: S,
    onPointerEnter: R,
    onPointerLeave: M,
    onTouchCancel: I,
    onTouchEnd: P,
    onTouchMove: k,
    onTouchStart: O
  };
  return L;
}
function I4() {
  var e = vt(), t = gx(), n = Sh(), r = Oh(), o = Oc(e) ? t.selected : Ys(e) ? n.selected : Gs(e) ? r.selected : void 0;
  return o;
}
function N4(e) {
  return Object.values(jn).includes(e);
}
function D4(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(r) {
    var o = e.modifiersClassNames[r];
    if (o)
      n.push(o);
    else if (N4(r)) {
      var i = e.classNames["day_".concat(r)];
      i && n.push(i);
    }
  }), n;
}
function A4(e, t) {
  var n = Re({}, e.styles.day);
  return Object.keys(t).forEach(function(r) {
    var o;
    n = Re(Re({}, n), (o = e.modifiersStyles) === null || o === void 0 ? void 0 : o[r]);
  }), n;
}
function L4(e, t, n) {
  var r, o, i, s = vt(), a = Th(), l = R4(e, t), c = P4(e, l), u = I4(), d = !!(s.onDayClick || s.mode !== "default");
  Le(function() {
    var E;
    l.outside || a.focusedDay && d && an(a.focusedDay, e) && ((E = n.current) === null || E === void 0 || E.focus());
  }, [
    a.focusedDay,
    e,
    n,
    d,
    l.outside
  ]);
  var f = D4(s, l).join(" "), h = A4(s, l), p = !!(l.outside && !s.showOutsideDays || l.hidden), g = (i = (o = s.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && i !== void 0 ? i : r4, v = Y.createElement(g, { date: e, displayMonth: t, activeModifiers: l }), y = {
    style: h,
    className: f,
    children: v,
    role: "gridcell"
  }, b = a.focusTarget && an(a.focusTarget, e) && !l.outside, w = a.focusedDay && an(a.focusedDay, e), C = Re(Re(Re({}, y), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = w || b ? 0 : -1, r)), c), x = {
    isButton: d,
    isHidden: p,
    activeModifiers: l,
    selectedDays: u,
    buttonProps: C,
    divProps: y
  };
  return x;
}
function $4(e) {
  var t = Be(null), n = L4(e.date, e.displayMonth, t);
  return n.isHidden ? Y.createElement("div", { role: "gridcell" }) : n.isButton ? Y.createElement(kl, Re({ name: "day", ref: t }, n.buttonProps)) : Y.createElement("div", Re({}, n.divProps));
}
function F4(e) {
  var t = e.number, n = e.dates, r = vt(), o = r.onWeekNumberClick, i = r.styles, s = r.classNames, a = r.locale, l = r.labels.labelWeekNumber, c = r.formatters.formatWeekNumber, u = c(Number(t), { locale: a });
  if (!o)
    return Y.createElement("span", { className: s.weeknumber, style: i.weeknumber }, u);
  var d = l(Number(t), { locale: a }), f = function(h) {
    o(t, n, h);
  };
  return Y.createElement(kl, { name: "week-number", "aria-label": d, className: s.weeknumber, style: i.weeknumber, onClick: f }, u);
}
function V4(e) {
  var t, n, r = vt(), o = r.styles, i = r.classNames, s = r.showWeekNumber, a = r.components, l = (t = a == null ? void 0 : a.Day) !== null && t !== void 0 ? t : $4, c = (n = a == null ? void 0 : a.WeekNumber) !== null && n !== void 0 ? n : F4, u;
  return s && (u = Y.createElement(
    "td",
    { className: i.cell, style: o.cell },
    Y.createElement(c, { number: e.weekNumber, dates: e.dates })
  )), Y.createElement(
    "tr",
    { className: i.row, style: o.row },
    u,
    e.dates.map(function(d) {
      return Y.createElement(
        "td",
        { className: i.cell, style: o.cell, key: u5(d), role: "presentation" },
        Y.createElement(l, { displayMonth: e.displayMonth, date: d })
      );
    })
  );
}
function Hm(e, t, n) {
  for (var r = n != null && n.ISOWeek ? uy(t) : Cc(t, n), o = n != null && n.ISOWeek ? Ro(e) : Dn(e, n), i = Rn(r, o), s = [], a = 0; a <= i; a++)
    s.push(bn(o, a));
  var l = s.reduce(function(c, u) {
    var d = n != null && n.ISOWeek ? l5(u) : p5(u, n), f = c.find(function(h) {
      return h.weekNumber === d;
    });
    return f ? (f.dates.push(u), c) : (c.push({
      weekNumber: d,
      dates: [u]
    }), c);
  }, []);
  return l;
}
function B4(e, t) {
  var n = Hm(en(e), $s(e), t);
  if (t != null && t.useFixedWeeks) {
    var r = m5(e, t);
    if (r < 6) {
      var o = n[n.length - 1], i = o.dates[o.dates.length - 1], s = Sl(i, 6 - r), a = Hm(Sl(i, 1), s, t);
      n.push.apply(n, a);
    }
  }
  return n;
}
function H4(e) {
  var t, n, r, o = vt(), i = o.locale, s = o.classNames, a = o.styles, l = o.hideHead, c = o.fixedWeeks, u = o.components, d = o.weekStartsOn, f = o.firstWeekContainsDate, h = o.ISOWeek, p = B4(e.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: h,
    locale: i,
    weekStartsOn: d,
    firstWeekContainsDate: f
  }), g = (t = u == null ? void 0 : u.Head) !== null && t !== void 0 ? t : n4, v = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : V4, y = (r = u == null ? void 0 : u.Footer) !== null && r !== void 0 ? r : J3;
  return Y.createElement(
    "table",
    { id: e.id, className: s.table, style: a.table, role: "grid", "aria-labelledby": e["aria-labelledby"] },
    !l && Y.createElement(g, null),
    Y.createElement("tbody", { className: s.tbody, style: a.tbody, role: "rowgroup" }, p.map(function(b) {
      return Y.createElement(v, { displayMonth: e.displayMonth, key: b.weekNumber, dates: b.dates, weekNumber: b.weekNumber });
    })),
    Y.createElement(y, { displayMonth: e.displayMonth })
  );
}
function W4() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var z4 = W4() ? m.useLayoutEffect : m.useEffect, vu = !1, j4 = 0;
function Wm() {
  return "react-day-picker-".concat(++j4);
}
function U4(e) {
  var t, n = e ?? (vu ? Wm() : null), r = m.useState(n), o = r[0], i = r[1];
  return z4(function() {
    o === null && i(Wm());
  }, []), m.useEffect(function() {
    vu === !1 && (vu = !0);
  }, []), (t = e ?? o) !== null && t !== void 0 ? t : void 0;
}
function Y4(e) {
  var t, n, r = vt(), o = r.dir, i = r.classNames, s = r.styles, a = r.components, l = Si().displayMonths, c = U4(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0), u = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0, d = [i.month], f = s.month, h = e.displayIndex === 0, p = e.displayIndex === l.length - 1, g = !h && !p;
  o === "rtl" && (t = [h, p], p = t[0], h = t[1]), h && (d.push(i.caption_start), f = Re(Re({}, f), s.caption_start)), p && (d.push(i.caption_end), f = Re(Re({}, f), s.caption_end)), g && (d.push(i.caption_between), f = Re(Re({}, f), s.caption_between));
  var v = (n = a == null ? void 0 : a.Caption) !== null && n !== void 0 ? n : Q3;
  return Y.createElement(
    "div",
    { key: e.displayIndex, className: d.join(" "), style: f },
    Y.createElement(v, { id: c, displayMonth: e.displayMonth }),
    Y.createElement(H4, { id: u, "aria-labelledby": c, displayMonth: e.displayMonth })
  );
}
function G4(e) {
  var t = e.initialProps, n = vt(), r = Th(), o = Si(), i = dt(!1), s = i[0], a = i[1];
  Le(function() {
    n.initialFocus && r.focusTarget && (s || (r.focus(r.focusTarget), a(!0)));
  }, [
    n.initialFocus,
    s,
    r.focus,
    r.focusTarget,
    r
  ]);
  var l = [n.classNames.root, n.className];
  n.numberOfMonths > 1 && l.push(n.classNames.multiple_months), n.showWeekNumber && l.push(n.classNames.with_weeknumber);
  var c = Re(Re({}, n.styles.root), n.style), u = Object.keys(t).filter(function(d) {
    return d.startsWith("data-");
  }).reduce(function(d, f) {
    var h;
    return Re(Re({}, d), (h = {}, h[f] = t[f], h));
  }, {});
  return Y.createElement(
    "div",
    Re({ className: l.join(" "), style: c, dir: n.dir, id: n.id }, u),
    Y.createElement("div", { className: n.classNames.months, style: n.styles.months }, o.displayMonths.map(function(d, f) {
      return Y.createElement(Y4, { key: f, displayIndex: f, displayMonth: d });
    }))
  );
}
function K4(e) {
  var t = e.children, n = y3(e, ["children"]);
  return Y.createElement(
    F3,
    { initialProps: n },
    Y.createElement(
      K3,
      null,
      Y.createElement(
        T4,
        { initialProps: n },
        Y.createElement(
          o4,
          { initialProps: n },
          Y.createElement(
            a4,
            { initialProps: n },
            Y.createElement(
              g4,
              null,
              Y.createElement(O4, null, t)
            )
          )
        )
      )
    )
  );
}
function q4(e) {
  return Y.createElement(
    K4,
    Re({}, e),
    Y.createElement(G4, { initialProps: e })
  );
}
const mx = ({
  className: e,
  ...t
}) => /* @__PURE__ */ _(
  q4,
  {
    showOutsideDays: !0,
    fixedWeeks: !0,
    weekStartsOn: 1,
    className: oe(
      "flex rounded-lg bg-foundations-default px-6 py-3",
      e
    ),
    formatters: {
      formatWeekdayName: (n) => Qt(n, "E")
    },
    classNames: {
      table: "w-full border-collapse space-y-4",
      head_row: "flex",
      head_cell: "w-9 text-xs text-foundations-subtle font-normal uppercase",
      row: "flex w-full mt-2",
      cell: "p-0 flex justify-center group/cell",
      day: "h-9 w-9 p-0 font-normal text-foundations-boldest text-sm rounded-full aria-selected:!text-neutral-white hover:bg-neutral-100 focus:outline-none focus:ring-2 focus:ring-info-bold focus:z-10",
      day_selected: "!bg-info-bold hover:!bg-info-bolder focus:bg-info-bolder",
      day_today: "bg-neutral-100 rounded-full",
      day_range_start: "start rounded-l-full group-last/cell:rounded-r-full group-[&:not(:last-child)]/cell:rounded-r-none",
      day_range_end: "end group-first/cell:rounded-full group-[&:not(:first-child)]/cell:rounded-l-none group-[&:not(:first-child)]/cell:rounded-r-full [&.start]:!rounded-full",
      day_outside: "[&:not(:disabled)]:text-foundations-subtle",
      day_disabled: "!text-neutral-300 cursor-not-allowed",
      day_range_middle: "bg-info-bold rounded-none group-first/cell:rounded-l-full group-last/cell:rounded-r-full",
      day_hidden: "invisible"
    },
    components: {
      Caption: X4
    },
    footer: t.CustomFooter,
    ...t
  }
);
mx.displayName = "Calendar";
const X4 = (e) => {
  const { goToMonth: t, nextMonth: n, previousMonth: r } = Si();
  return /* @__PURE__ */ Z("div", { className: "mb-4 flex items-center justify-between", children: [
    /* @__PURE__ */ _(
      cs,
      {
        variant: "tertiary",
        size: "xs",
        disabled: !r,
        onClick: () => r && t(r),
        "aria-label": "Go to previous month",
        children: /* @__PURE__ */ _(WM, {})
      }
    ),
    /* @__PURE__ */ _(
      "div",
      {
        id: e.id,
        "aria-live": "polite",
        role: "presentation",
        className: "text-sm font-medium text-foundations-boldest",
        children: Qt(e.displayMonth, "MMMM yyyy")
      }
    ),
    /* @__PURE__ */ _(
      cs,
      {
        variant: "tertiary",
        size: "xs",
        disabled: !n,
        onClick: () => n && t(n),
        "aria-label": "Go to next month",
        children: /* @__PURE__ */ _(Rf, {})
      }
    )
  ] });
}, Z4 = (e) => e.querySelector("input,textarea") || e, Rc = {
  mask: /^.*$/,
  preprocessors: [],
  postprocessors: [],
  plugins: [],
  overwriteMode: "shift"
};
class Q4 {
  constructor() {
    this.now = null, this.past = [], this.future = [];
  }
  undo() {
    const t = this.past.pop();
    t && this.now && (this.future.push(this.now), this.updateElement(t, "historyUndo"));
  }
  redo() {
    const t = this.future.pop();
    t && this.now && (this.past.push(this.now), this.updateElement(t, "historyRedo"));
  }
  updateHistory(t) {
    if (!this.now) {
      this.now = t;
      return;
    }
    const n = this.now.value !== t.value, r = this.now.selection.some((o, i) => o !== t.selection[i]);
    !n && !r || (n && (this.past.push(this.now), this.future = []), this.now = t);
  }
  updateElement(t, n) {
    this.now = t, this.updateElementState(t, {
      inputType: n,
      data: null
    });
  }
}
function J4(e, ...t) {
  return t.every(({
    value: n
  }) => n === e.value);
}
function e9(e, ...t) {
  return t.every(({
    value: n,
    selection: r
  }) => n === e.value && r[0] === e.selection[0] && r[1] === e.selection[1]);
}
function t9({
  value: e,
  selection: t
}, n, r) {
  const [o, i] = t, s = typeof r == "function" ? r({
    value: e,
    selection: t
  }) : r;
  return {
    value: e,
    selection: s === "replace" ? [o, o + n.length] : [o, i]
  };
}
function Tc(e) {
  return typeof e == "string";
}
function zm(e, t, n, r) {
  let o = "";
  for (let i = t.length; i < e.length; i++) {
    const s = e[i], a = (r == null ? void 0 : r.value[i]) === s;
    if (!Tc(s) || s === n && !a)
      return o;
    o += s;
  }
  return o;
}
function vx(e, t) {
  return Array.isArray(t) ? e.length === t.length && Array.from(e).every((n, r) => {
    const o = t[r];
    return Tc(o) ? n === o : n.match(o);
  }) : t.test(e);
}
function n9(e, t, n) {
  let r = null, o = null;
  const i = Array.from(e.value).reduce((a, l, c) => {
    const u = zm(t, a, l, n), d = a + u, f = t[d.length];
    return Tc(f) ? d + f : l.match(f) ? (r === null && c >= e.selection[0] && (r = d.length), o === null && c >= e.selection[1] && (o = d.length), d + l) : d;
  }, ""), s = zm(t, i, "", n);
  return {
    value: vx(i + s, t) ? i + s : i,
    selection: [r ?? i.length, o ?? i.length]
  };
}
function r9({
  value: e,
  selection: t
}, n) {
  const [r, o] = t;
  let i = r, s = o;
  return {
    value: Array.from(e).reduce((l, c, u) => {
      const d = l + c;
      return r === u && (i = l.length), o === u && (s = l.length), d.match(n) ? d : l;
    }, ""),
    selection: [i, s]
  };
}
function Ma(e, t, n = null) {
  if (vx(e.value, t))
    return e;
  const {
    value: r,
    selection: o
  } = Array.isArray(t) ? n9(e, t, n) : r9(e, t);
  return {
    selection: o,
    value: Array.isArray(t) ? r.slice(0, t.length) : r
  };
}
function jm(e, t) {
  if (!Array.isArray(t))
    return e;
  const [n, r] = e.selection, o = [], i = Array.from(e.value).reduce((s, a, l) => {
    const c = t[l];
    return l === n && o.push(s.length), l === r && o.push(s.length), Tc(c) && c === a ? s : s + a;
  }, "");
  return o.length < 2 && o.push(...Array(2 - o.length).fill(i.length)), {
    value: i,
    selection: [o[0], o[1]]
  };
}
class bd {
  constructor(t, n) {
    this.initialElementState = t, this.maskOptions = n, this.value = "", this.selection = [0, 0];
    const {
      value: r,
      selection: o
    } = Ma(t, this.getMaskExpression(t));
    this.value = r, this.selection = o;
  }
  addCharacters([t, n], r) {
    const {
      value: o
    } = this, i = this.getMaskExpression({
      value: o.slice(0, t) + r + o.slice(n),
      selection: [t + r.length, t + r.length]
    }), s = {
      value: o,
      selection: [t, n]
    }, a = jm(s, i), [l, c] = t9(a, r, this.maskOptions.overwriteMode).selection, u = a.value.slice(0, l) + r, d = u.length, f = Ma({
      value: u + a.value.slice(c),
      selection: [d, d]
    }, i, s);
    if (o.slice(0, l) === Ma({
      value: u,
      selection: [d, d]
    }, i, s).value || e9(this, f))
      throw new Error("Invalid mask value");
    this.value = f.value, this.selection = f.selection;
  }
  deleteCharacters([t, n]) {
    if (t === n || !n)
      return;
    const {
      value: r
    } = this, o = this.getMaskExpression({
      value: r.slice(0, t) + r.slice(n),
      selection: [t, t]
    }), i = {
      value: r,
      selection: [t, n]
    }, s = jm(i, o), [a, l] = s.selection, c = s.value.slice(0, a) + s.value.slice(l), u = Ma({
      value: c,
      selection: [a, a]
    }, o, i);
    this.value = u.value, this.selection = u.selection;
  }
  getMaskExpression(t) {
    const {
      mask: n
    } = this.maskOptions;
    return typeof n == "function" ? n(t) : n;
  }
}
class o9 {
  constructor(t) {
    this.element = t, this.listeners = [];
  }
  listen(t, n, r) {
    const o = n;
    this.element.addEventListener(t, o, r), this.listeners.push(() => this.element.removeEventListener(t, o));
  }
  destroy() {
    this.listeners.forEach((t) => t());
  }
}
function ss(e, t, n) {
  return e.ctrlKey === !!(t & 1) && e.altKey === !!(t & 2) && e.shiftKey === !!(t & 4) && e.metaKey === !!(t & 8) && e.keyCode === n;
}
function i9(e) {
  return ss(
    e,
    1,
    89
    /* Y */
  ) || // Windows
  ss(
    e,
    5,
    90
    /* Z */
  ) || // Windows & Android
  ss(
    e,
    12,
    90
    /* Z */
  );
}
function s9(e) {
  return ss(
    e,
    1,
    90
    /* Z */
  ) || // Windows & Android
  ss(
    e,
    8,
    90
    /* Z */
  );
}
function a9(e) {
  return "onbeforeinput" in e;
}
function l9({
  key: e,
  ctrlKey: t,
  metaKey: n,
  altKey: r
}) {
  const o = t || n || r, i = /^.$/u.test(e);
  return !o && e !== "Backspace" && i;
}
function c9({
  value: e,
  selection: t
}, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  const i = n ? e.slice(r).indexOf(`
`) + 1 || e.length : e.slice(0, o).lastIndexOf(`
`) + 1;
  return [n ? r : i, n ? i : o];
}
function Um({
  value: e,
  selection: t
}, n) {
  const [r, o] = t;
  return r !== o ? [r, o] : (n ? [r, o + 1] : [r - 1, o]).map((s) => Math.min(Math.max(s, 0), e.length));
}
const Ym = /\s+$/g, Gm = /^\s+/g, Km = /\s/;
function u9({
  value: e,
  selection: t
}, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  if (n) {
    const l = e.slice(r), [c] = l.match(Gm) || [""], u = l.replace(Gm, "").search(Km);
    return [r, u !== -1 ? r + c.length + u : e.length];
  }
  const i = e.slice(0, o), [s] = i.match(Ym) || [""], a = i.replace(Ym, "").split("").reverse().findIndex((l) => l.match(Km));
  return [a !== -1 ? o - s.length - a : 0, o];
}
function Pl(e = []) {
  return (t, ...n) => e.reduce((r, o) => Object.assign(Object.assign({}, r), o(r, ...n)), t);
}
function d9(e, t) {
  const n = Object.assign(Object.assign({}, Rc), t), r = Pl(n.preprocessors), o = Pl(n.postprocessors), i = typeof e == "string" ? {
    value: e,
    selection: [0, 0]
  } : e, {
    elementState: s
  } = r({
    elementState: i,
    data: ""
  }, "validation"), a = new bd(s, n), {
    value: l,
    selection: c
  } = o(a, i);
  return typeof e == "string" ? l : {
    value: l,
    selection: c
  };
}
class f9 extends Q4 {
  constructor(t, n) {
    super(), this.element = t, this.maskitoOptions = n, this.isTextArea = this.element.nodeName === "TEXTAREA", this.eventListener = new o9(this.element), this.options = Object.assign(Object.assign({}, Rc), this.maskitoOptions), this.preprocessor = Pl(this.options.preprocessors), this.postprocessor = Pl(this.options.postprocessors), this.teardowns = this.options.plugins.map((r) => r(this.element, this.options)), this.ensureValueFitsMask(), this.updateHistory(this.elementState), this.eventListener.listen("keydown", (r) => {
      if (i9(r))
        return r.preventDefault(), this.redo();
      if (s9(r))
        return r.preventDefault(), this.undo();
    }), a9(t) ? this.eventListener.listen("beforeinput", (r) => {
      const o = r.inputType.includes("Forward");
      switch (this.updateHistory(this.elementState), r.inputType) {
        case "historyUndo":
          return r.preventDefault(), this.undo();
        case "historyRedo":
          return r.preventDefault(), this.redo();
        case "deleteByCut":
        case "deleteContentBackward":
        case "deleteContentForward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: Um(this.elementState, o)
          });
        case "deleteWordForward":
        case "deleteWordBackward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: u9(this.elementState, o),
            force: !0
          });
        case "deleteSoftLineBackward":
        case "deleteSoftLineForward":
        case "deleteHardLineBackward":
        case "deleteHardLineForward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: c9(this.elementState, o),
            force: !0
          });
        case "insertLineBreak":
          return this.handleEnter(r);
        case "insertFromPaste":
        case "insertText":
        case "insertFromDrop":
        default:
          return this.handleInsert(r, r.data || "");
      }
    }) : (this.eventListener.listen("keydown", (r) => this.handleKeydown(r)), this.eventListener.listen("paste", (r) => {
      var o;
      return this.handleInsert(r, ((o = r.clipboardData) === null || o === void 0 ? void 0 : o.getData("text/plain")) || "");
    })), this.eventListener.listen("input", () => {
      this.ensureValueFitsMask(), this.updateHistory(this.elementState);
    });
  }
  get elementState() {
    const {
      value: t,
      selectionStart: n,
      selectionEnd: r
    } = this.element;
    return {
      value: t,
      selection: [n || 0, r || 0]
    };
  }
  get maxLength() {
    const {
      maxLength: t
    } = this.element;
    return t === -1 ? 1 / 0 : t;
  }
  destroy() {
    this.eventListener.destroy(), this.teardowns.forEach((t) => t == null ? void 0 : t());
  }
  updateElementState({
    value: t,
    selection: n
  }, r = {
    inputType: "insertText",
    data: null
  }) {
    const o = this.elementState.value;
    this.updateValue(t), this.updateSelectionRange(n), o !== t && this.dispatchInputEvent(r);
  }
  updateSelectionRange([t, n]) {
    var r, o;
    (this.element.selectionStart !== t || this.element.selectionEnd !== n) && ((o = (r = this.element).setSelectionRange) === null || o === void 0 || o.call(r, t, n));
  }
  updateValue(t) {
    this.element.value = t;
  }
  ensureValueFitsMask() {
    this.updateElementState(d9(this.elementState, this.options));
  }
  dispatchInputEvent(t = {
    inputType: "insertText",
    data: null
  }) {
    const n = typeof window < "u" ? window : globalThis;
    n != null && n.InputEvent && this.element.dispatchEvent(new InputEvent("input", Object.assign(Object.assign({}, t), {
      bubbles: !0,
      cancelable: !1
    })));
  }
  handleKeydown(t) {
    const n = t.key, r = n === "Delete";
    switch (n) {
      case "Backspace":
      case "Delete":
        return this.handleDelete({
          event: t,
          isForward: r,
          selection: Um(this.elementState, r)
        });
      case "Enter":
        return this.handleEnter(t);
    }
    l9(t) && this.handleInsert(t, n);
  }
  handleDelete({
    event: t,
    selection: n,
    isForward: r,
    force: o = !1
  }) {
    const i = {
      value: this.elementState.value,
      selection: n
    }, [s, a] = i.selection, {
      elementState: l
    } = this.preprocessor({
      elementState: i,
      data: ""
    }, r ? "deleteForward" : "deleteBackward"), c = new bd(l, this.options), [u, d] = l.selection;
    c.deleteCharacters([u, d]);
    const f = this.postprocessor(c, i);
    if (i.value.slice(0, s) + i.value.slice(a) === f.value && !o)
      return;
    if (t.preventDefault(), J4(i, l, c, f))
      return this.updateSelectionRange(r ? [d, d] : [u, u]);
    const p = r ? "deleteContentForward" : "deleteContentBackward";
    this.updateElementState(f, {
      inputType: "inputType" in t ? t.inputType : p,
      data: null
    }), this.updateHistory(f);
  }
  handleInsert(t, n) {
    const r = this.elementState, {
      elementState: o,
      data: i = n
    } = this.preprocessor({
      data: n,
      elementState: r
    }, "insert"), s = new bd(o, this.options);
    try {
      s.addCharacters(o.selection, i);
    } catch {
      return t.preventDefault();
    }
    const [a, l] = o.selection, c = o.value.slice(0, a) + n + o.value.slice(l), u = this.postprocessor(s, r);
    if (u.value.length > this.maxLength)
      return t.preventDefault();
    c !== u.value && (t.preventDefault(), this.updateElementState(u, {
      data: n,
      inputType: "inputType" in t ? t.inputType : "insertText"
    }), this.updateHistory(u));
  }
  handleEnter(t) {
    this.isTextArea && this.handleInsert(t, `
`);
  }
}
const h9 = /* @__PURE__ */ new Date("0001-01-01"), p9 = /* @__PURE__ */ new Date("9999-12-31"), g9 = "–", m9 = "—", v9 = "-", b9 = "−", y9 = [v9, g9, m9, b9], x9 = [":", "."];
function yd(e, t, n) {
  const r = Math.min(Number(n), Math.max(Number(t), Number(e)));
  return e instanceof Date ? new Date(r) : r;
}
const bx = (e) => {
  var t, n, r;
  return {
    day: ((t = e.match(/d/g)) === null || t === void 0 ? void 0 : t.length) || 0,
    month: ((n = e.match(/m/g)) === null || n === void 0 ? void 0 : n.length) || 0,
    year: ((r = e.match(/y/g)) === null || r === void 0 ? void 0 : r.length) || 0
  };
};
function w9(e) {
  return {
    day: String(e.getDate()).padStart(2, "0"),
    month: String(e.getMonth() + 1).padStart(2, "0"),
    year: String(e.getFullYear()).padStart(4, "0"),
    hours: String(e.getHours()).padStart(2, "0"),
    minutes: String(e.getMinutes()).padStart(2, "0"),
    seconds: String(e.getSeconds()).padStart(2, "0"),
    milliseconds: String(e.getMilliseconds()).padStart(3, "0")
  };
}
function C9(e, t) {
  return e.length < t.length ? !1 : e.split(/\D/).every((n) => !n.match(/^0+$/));
}
function yx(e, t, n) {
  const r = t.replace(/\W/g, "").length;
  return e.replace(n, "").match(new RegExp(`(\\D*\\d[^\\d\\s]*){1,${r}}`, "g")) || [];
}
function xx(e) {
  return e.reduce((t, [n, r]) => Object.assign(Object.assign({}, t), {
    [n]: r
  }), {});
}
function wx(e, t) {
  const n = t.replace(/[^dmy]/g, ""), r = e.replace(/\D+/g, ""), o = {
    day: r.slice(n.indexOf("d"), n.lastIndexOf("d") + 1),
    month: r.slice(n.indexOf("m"), n.lastIndexOf("m") + 1),
    year: r.slice(n.indexOf("y"), n.lastIndexOf("y") + 1)
  };
  return xx(Object.entries(o).filter(([i, s]) => !!s).sort(([i], [s]) => t.toLowerCase().indexOf(i[0]) > t.toLowerCase().indexOf(s[0]) ? 1 : -1));
}
function _9(e, t) {
  var n, r, o, i, s, a, l;
  const c = ((n = e.year) === null || n === void 0 ? void 0 : n.length) === 2 ? `20${e.year}` : e.year, u = new Date(Number(c ?? "0"), Number((r = e.month) !== null && r !== void 0 ? r : "1") - 1, Number((o = e.day) !== null && o !== void 0 ? o : "1"), Number((i = t == null ? void 0 : t.hours) !== null && i !== void 0 ? i : "0"), Number((s = t == null ? void 0 : t.minutes) !== null && s !== void 0 ? s : "0"), Number((a = t == null ? void 0 : t.seconds) !== null && a !== void 0 ? a : "0"), Number((l = t == null ? void 0 : t.milliseconds) !== null && l !== void 0 ? l : "0"));
  return u.setFullYear(Number(c ?? "0")), u;
}
const E9 = ", ";
function Il({
  day: e,
  month: t,
  year: n,
  hours: r,
  minutes: o,
  seconds: i,
  milliseconds: s
}, a, l) {
  var c;
  const u = ((c = a.match(/y/g)) === null || c === void 0 ? void 0 : c.length) === 2 ? n == null ? void 0 : n.slice(-2) : n;
  return (a + (l ? E9 + l : "")).replace(/d+/g, e ?? "").replace(/m+/g, t ?? "").replace(/y+/g, u ?? "").replace(/H+/g, r ?? "").replace(/MSS/g, s ?? "").replace(/M+/g, o ?? "").replace(/S+/g, i ?? "").replace(/^\D+/g, "").replace(/\D+$/g, "");
}
function xd(e, t, n = 0) {
  return Number(e.padEnd(t.length, "0")) <= Number(t) ? {
    validatedSegmentValue: e,
    prefixedZeroesCount: n
  } : e.endsWith("0") ? xd(`0${e.slice(0, t.length - 1)}`, t, n + 1) : xd(`${e.slice(0, t.length - 1)}0`, t, n);
}
const S9 = {
  day: 31,
  month: 12,
  year: 9999
};
function M9({
  dateString: e,
  dateModeTemplate: t,
  offset: n,
  selection: [r, o]
}) {
  const i = wx(e, t), s = Object.entries(i), a = {};
  let l = 0;
  for (const [d, f] of s) {
    const h = Il(a, t), p = S9[d], g = h.length && 1, v = n + h.length + g + bx(t)[d], y = v >= r && v === o;
    if (y && Number(f) > Number(p))
      return {
        validatedDateString: "",
        updatedSelection: [r, o]
      };
    if (y && Number(f) < 1)
      return {
        validatedDateString: "",
        updatedSelection: [r, o]
      };
    const {
      validatedSegmentValue: b,
      prefixedZeroesCount: w
    } = xd(f, `${p}`);
    l += w, a[d] = b;
  }
  const c = Il(a, t), u = c.length - e.length;
  return {
    validatedDateString: c,
    updatedSelection: [r + l + u, o + l + u]
  };
}
const Cx = /[\\^$.*+?()[\]{}|]/g, O9 = RegExp(Cx.source);
function _x(e) {
  return e && O9.test(e) ? e.replace(Cx, "\\$&") : e;
}
function R9({
  activeElement: e
}) {
  if (!(e != null && e.shadowRoot))
    return e;
  let t = e.shadowRoot.activeElement;
  for (; t != null && t.shadowRoot; )
    t = t.shadowRoot.activeElement;
  return t;
}
function T9(e, t) {
  const n = bx(t);
  return xx(Object.entries(e).map(([r, o]) => {
    const i = n[r];
    return [r, o.length === i && o.match(/^0+$/) ? "1".padStart(i, "0") : o];
  }));
}
function k9({
  dateModeTemplate: e,
  min: t = h9,
  max: n = p9,
  rangeSeparator: r = "",
  dateSegmentSeparator: o = "."
}) {
  return ({
    value: i,
    selection: s
  }) => {
    const a = r && i.endsWith(r), l = yx(i, e, r);
    let c = "";
    for (const u of l) {
      c += c ? r : "";
      const d = wx(u, e);
      if (!C9(u, e)) {
        const p = T9(d, e), g = Il(p, e), v = u.endsWith(o) ? o : "";
        c += g + v;
        continue;
      }
      const f = _9(d), h = yd(f, t, n);
      c += Il(w9(h), e);
    }
    return {
      selection: s,
      value: c + (a ? r : "")
    };
  };
}
function P9({
  dateModeTemplate: e,
  dateSegmentsSeparator: t,
  rangeSeparator: n = ""
}) {
  return ({
    elementState: r,
    data: o
  }) => {
    const {
      value: i,
      selection: s
    } = r;
    if (o === t)
      return {
        elementState: r,
        data: s[0] === i.length ? o : ""
      };
    if (y9.includes(o))
      return {
        elementState: r,
        data: n
      };
    const a = o.replace(new RegExp(`[^\\d${_x(t)}${n}]`, "g"), "");
    if (!a)
      return {
        elementState: r,
        data: ""
      };
    const [l, c] = s;
    let u = c + o.length;
    const d = i.slice(0, l) + a + i.slice(u), f = yx(d, e, n);
    let h = "";
    const p = !!n && d.includes(n);
    for (const v of f) {
      const {
        validatedDateString: y,
        updatedSelection: b
      } = M9({
        dateString: v,
        dateModeTemplate: e,
        offset: h ? h.length + n.length : 0,
        selection: [l, u]
      });
      if (v && !y)
        return {
          elementState: r,
          data: ""
        };
      u = b[1], h += p && h ? n + y : y;
    }
    const g = h.slice(l, u);
    return {
      elementState: {
        selection: s,
        value: h.slice(0, l) + g.split(t).map((v) => "0".repeat(v.length)).join(t) + h.slice(u)
      },
      data: g
    };
  };
}
function I9(e) {
  return (t) => {
    const n = t.ownerDocument;
    let r = 0;
    const o = () => r++, i = () => r--, s = () => {
      if (R9(n) !== t)
        return;
      if (r)
        return n.addEventListener("mouseup", s, {
          once: !0,
          passive: !0
        });
      const a = t.selectionStart || 0, l = t.selectionEnd || 0, [c, u] = e(t.value, [a, l]);
      (c > a || u < l) && t.setSelectionRange(yd(a, c, u), yd(l, c, u));
    };
    return n.addEventListener("selectionchange", s, {
      passive: !0
    }), n.addEventListener("mousedown", o, {
      passive: !0
    }), n.addEventListener("mouseup", i, {
      passive: !0
    }), () => {
      n.removeEventListener("selectionchange", s), n.removeEventListener("mousedown", o), n.removeEventListener("mouseup", i);
    };
  };
}
function qm(e, t, n) {
  return (r, o) => {
    const i = () => t(r, o);
    return r.addEventListener(e, i, n), () => r.removeEventListener(e, i, n);
  };
}
function N9(e, t = !1) {
  const n = (i) => {
    for (let s = i.length - 1; s >= 0; s--)
      if (i[s] !== e[s])
        return i.slice(0, s + 1);
    return "";
  }, r = [I9((i) => [0, n(i).length])];
  let o = !1;
  if (t) {
    const i = qm("focus", (a) => {
      o = !0, a.value += e.slice(a.value.length), a.dispatchEvent(new Event("input"));
    }, {
      capture: !0
    }), s = qm("blur", (a) => {
      o = !1, a.value = n(a.value), a.dispatchEvent(new Event("input"));
    }, {
      capture: !0
    });
    r.push(i, s);
  }
  return {
    plugins: r,
    removePlaceholder: n,
    preprocessors: [({
      elementState: i,
      data: s
    }) => {
      const {
        value: a,
        selection: l
      } = i;
      return {
        elementState: {
          selection: l,
          value: n(a)
        },
        data: s
      };
    }],
    postprocessors: [({
      value: i,
      selection: s
    }, a) => a.value && (o || !t) ? {
      value: i + e.slice(i.length),
      selection: s
    } : {
      value: i,
      selection: s
    }]
  };
}
function D9() {
  return ({
    elementState: e
  }, t) => {
    const {
      value: n,
      selection: r
    } = e;
    if (!n || A9(n, r))
      return {
        elementState: e
      };
    const [o, i] = r, s = n.slice(o, i).replace(/\d/g, "0"), a = n.slice(0, o) + s + n.slice(i);
    return t === "validation" || t === "insert" && o === i ? {
      elementState: {
        selection: r,
        value: a
      }
    } : {
      elementState: {
        selection: t === "deleteBackward" || t === "insert" ? [o, o] : [i, i],
        value: a
      }
    };
  };
}
function A9(e, [t, n]) {
  return n === e.length;
}
function L9({
  mode: e,
  separator: t = ".",
  max: n,
  min: r
}) {
  const o = e.split("/").join(t);
  return Object.assign(Object.assign({}, Rc), {
    mask: Array.from(o).map((i) => i === t ? i : /\d/),
    overwriteMode: "replace",
    preprocessors: [D9(), P9({
      dateModeTemplate: o,
      dateSegmentsSeparator: t
    })],
    postprocessors: [k9({
      min: r,
      max: n,
      dateModeTemplate: o,
      dateSegmentSeparator: t
    })]
  });
}
new RegExp(`[${x9.map(_x).join("")}]$`);
const $9 = typeof window < "u" ? _s : Le, F9 = ({
  options: e = Rc,
  elementPredicate: t = Z4
} = {}) => {
  const [n, r] = dt(null), o = st((i) => {
    r(i);
  }, []);
  return $9(() => {
    if (!n)
      return;
    const i = new f9(t(n), e);
    return () => {
      i.destroy();
    };
  }, [e, n, t]), o;
};
function V9(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Sr(e);
  Le(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const wd = "dismissableLayer.update", B9 = "dismissableLayer.pointerDownOutside", H9 = "dismissableLayer.focusOutside";
let Xm;
const W9 = /* @__PURE__ */ Wn({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), z9 = /* @__PURE__ */ mt((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: s, onInteractOutside: a, onDismiss: l, ...c } = e, u = ir(W9), [d, f] = dt(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = dt({}), g = rr(
    t,
    (R) => f(R)
  ), v = Array.from(u.layers), [y] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), b = v.indexOf(y), w = d ? v.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, x = w >= b, E = j9((R) => {
    const M = R.target, I = [
      ...u.branches
    ].some(
      (P) => P.contains(M)
    );
    !x || I || (i == null || i(R), a == null || a(R), R.defaultPrevented || l == null || l());
  }, h), S = U9((R) => {
    const M = R.target;
    [
      ...u.branches
    ].some(
      (P) => P.contains(M)
    ) || (s == null || s(R), a == null || a(R), R.defaultPrevented || l == null || l());
  }, h);
  return V9((R) => {
    w === u.layers.size - 1 && (o == null || o(R), !R.defaultPrevented && l && (R.preventDefault(), l()));
  }, h), Le(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Xm = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), Zm(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Xm);
      };
  }, [
    d,
    h,
    r,
    u
  ]), Le(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), Zm());
  }, [
    d,
    u
  ]), Le(() => {
    const R = () => p({});
    return document.addEventListener(wd, R), () => document.removeEventListener(wd, R);
  }, []), /* @__PURE__ */ Pe(Cn.div, He({}, c, {
    ref: g,
    style: {
      pointerEvents: C ? x ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: tn(e.onFocusCapture, S.onFocusCapture),
    onBlurCapture: tn(e.onBlurCapture, S.onBlurCapture),
    onPointerDownCapture: tn(e.onPointerDownCapture, E.onPointerDownCapture)
  }));
});
function j9(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Sr(e), r = Be(!1), o = Be(() => {
  });
  return Le(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let c = function() {
          Ex(B9, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, {
          once: !0
        })) : c();
      }
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function U9(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Sr(e), r = Be(!1);
  return Le(() => {
    const o = (i) => {
      i.target && !r.current && Ex(H9, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Zm() {
  const e = new CustomEvent(wd);
  document.dispatchEvent(e);
}
function Ex(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? X6(o, i) : o.dispatchEvent(i);
}
let bu = 0;
function Y9() {
  Le(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Qm()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Qm()), bu++, () => {
      bu === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), bu--;
    };
  }, []);
}
function Qm() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const yu = "focusScope.autoFocusOnMount", xu = "focusScope.autoFocusOnUnmount", Jm = {
  bubbles: !1,
  cancelable: !0
}, G9 = /* @__PURE__ */ mt((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...s } = e, [a, l] = dt(null), c = Sr(o), u = Sr(i), d = Be(null), f = rr(
    t,
    (g) => l(g)
  ), h = Be({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Le(() => {
    if (r) {
      let g = function(w) {
        if (h.paused || !a)
          return;
        const C = w.target;
        a.contains(C) ? d.current = C : Ar(d.current, {
          select: !0
        });
      }, v = function(w) {
        if (h.paused || !a)
          return;
        const C = w.relatedTarget;
        C !== null && (a.contains(C) || Ar(d.current, {
          select: !0
        }));
      }, y = function(w) {
        const C = document.activeElement;
        for (const x of w)
          x.removedNodes.length > 0 && (a != null && a.contains(C) || Ar(a));
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", v);
      const b = new MutationObserver(y);
      return a && b.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", v), b.disconnect();
      };
    }
  }, [
    r,
    a,
    h.paused
  ]), Le(() => {
    if (a) {
      tv.add(h);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const y = new CustomEvent(yu, Jm);
        a.addEventListener(yu, c), a.dispatchEvent(y), y.defaultPrevented || (K9(J9(Sx(a)), {
          select: !0
        }), document.activeElement === g && Ar(a));
      }
      return () => {
        a.removeEventListener(yu, c), setTimeout(() => {
          const y = new CustomEvent(xu, Jm);
          a.addEventListener(xu, u), a.dispatchEvent(y), y.defaultPrevented || Ar(g ?? document.body, {
            select: !0
          }), a.removeEventListener(xu, u), tv.remove(h);
        }, 0);
      };
    }
  }, [
    a,
    c,
    u,
    h
  ]);
  const p = st((g) => {
    if (!n && !r || h.paused)
      return;
    const v = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, y = document.activeElement;
    if (v && y) {
      const b = g.currentTarget, [w, C] = q9(b);
      w && C ? !g.shiftKey && y === C ? (g.preventDefault(), n && Ar(w, {
        select: !0
      })) : g.shiftKey && y === w && (g.preventDefault(), n && Ar(C, {
        select: !0
      })) : y === b && g.preventDefault();
    }
  }, [
    n,
    r,
    h.paused
  ]);
  return /* @__PURE__ */ Pe(Cn.div, He({
    tabIndex: -1
  }, s, {
    ref: f,
    onKeyDown: p
  }));
});
function K9(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Ar(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function q9(e) {
  const t = Sx(e), n = ev(t, e), r = ev(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Sx(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function ev(e, t) {
  for (const n of e)
    if (!X9(n, {
      upTo: t
    }))
      return n;
}
function X9(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Z9(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ar(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Z9(e) && t && e.select();
  }
}
const tv = Q9();
function Q9() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = nv(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = nv(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function nv(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function J9(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const e8 = ["top", "right", "bottom", "left"], xs = Math.min, fo = Math.max, t8 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, n8 = {
  start: "end",
  end: "start"
};
function Cd(e, t, n) {
  return fo(e, xs(t, n));
}
function Mr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Or(e) {
  return e.split("-")[0];
}
function Mi(e) {
  return e.split("-")[1];
}
function Ph(e) {
  return e === "x" ? "y" : "x";
}
function Ih(e) {
  return e === "y" ? "height" : "width";
}
function Oi(e) {
  return ["top", "bottom"].includes(Or(e)) ? "y" : "x";
}
function Nh(e) {
  return Ph(Oi(e));
}
function r8(e, t, n) {
  n === void 0 && (n = !1);
  const r = Mi(e), o = Nh(e), i = Ih(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = Nl(s)), [s, Nl(s)];
}
function o8(e) {
  const t = Nl(e);
  return [_d(e), t, _d(t)];
}
function _d(e) {
  return e.replace(/start|end/g, (t) => n8[t]);
}
function i8(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function s8(e, t, n, r) {
  const o = Mi(e);
  let i = i8(Or(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(_d)))), i;
}
function Nl(e) {
  return e.replace(/left|right|bottom|top/g, (t) => t8[t]);
}
function a8(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Mx(e) {
  return typeof e != "number" ? a8(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Dl(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function rv(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = Oi(t), s = Nh(t), a = Ih(s), l = Or(t), c = i === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[a] / 2 - o[a] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Mi(t)) {
    case "start":
      h[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[s] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const l8 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = i.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = rv(c, r, l), f = r, h = {}, p = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: v,
      fn: y
    } = a[g], {
      x: b,
      y: w,
      data: C,
      reset: x
    } = await y({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: h,
      rects: c,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (u = b ?? u, d = w ?? d, h = {
      ...h,
      [v]: {
        ...h[v],
        ...C
      }
    }, x && p <= 50) {
      p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (c = x.rects === !0 ? await s.getElementRects({
        reference: e,
        floating: t,
        strategy: o
      }) : x.rects), {
        x: u,
        y: d
      } = rv(c, f, l)), g = -1;
      continue;
    }
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: h
  };
};
async function ws(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Mr(t, e), p = Mx(h), v = a[f ? d === "floating" ? "reference" : "floating" : d], y = Dl(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(v))) == null || n ? v : v.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), b = d === "floating" ? {
    ...s.floating,
    x: r,
    y: o
  } : s.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), C = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Dl(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: b,
    offsetParent: w,
    strategy: l
  }) : b);
  return {
    top: (y.top - x.top + p.top) / C.y,
    bottom: (x.bottom - y.bottom + p.bottom) / C.y,
    left: (y.left - x.left + p.left) / C.x,
    right: (x.right - y.right + p.right) / C.x
  };
}
const ov = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: a
    } = t, {
      element: l,
      padding: c = 0
    } = Mr(e, t) || {};
    if (l == null)
      return {};
    const u = Mx(c), d = {
      x: n,
      y: r
    }, f = Nh(o), h = Ih(f), p = await s.getDimensions(l), g = f === "y", v = g ? "top" : "left", y = g ? "bottom" : "right", b = g ? "clientHeight" : "clientWidth", w = i.reference[h] + i.reference[f] - d[f] - i.floating[h], C = d[f] - i.reference[f], x = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let E = x ? x[b] : 0;
    (!E || !await (s.isElement == null ? void 0 : s.isElement(x))) && (E = a.floating[b] || i.floating[h]);
    const S = w / 2 - C / 2, R = E / 2 - p[h] / 2 - 1, M = xs(u[v], R), I = xs(u[y], R), P = M, k = E - p[h] - I, O = E / 2 - p[h] / 2 + S, F = Cd(P, O, k), L = Mi(o) != null && O != F && i.reference[h] / 2 - (O < P ? M : I) - p[h] / 2 < 0 ? O < P ? P - O : k - O : 0;
    return {
      [f]: d[f] - L,
      data: {
        [f]: F,
        centerOffset: O - F + L
      }
    };
  }
}), Ox = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        middlewareData: o,
        rects: i,
        initialPlacement: s,
        platform: a,
        elements: l
      } = t, {
        mainAxis: c = !0,
        crossAxis: u = !0,
        fallbackPlacements: d,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: p = !0,
        ...g
      } = Mr(e, t), v = Or(r), y = Or(s) === s, b = await (a.isRTL == null ? void 0 : a.isRTL(l.floating)), w = d || (y || !p ? [Nl(s)] : o8(s));
      !d && h !== "none" && w.push(...s8(s, p, h, b));
      const C = [s, ...w], x = await ws(t, g), E = [];
      let S = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (c && E.push(x[v]), u) {
        const P = r8(r, i, b);
        E.push(x[P[0]], x[P[1]]);
      }
      if (S = [...S, {
        placement: r,
        overflows: E
      }], !E.every((P) => P <= 0)) {
        var R, M;
        const P = (((R = o.flip) == null ? void 0 : R.index) || 0) + 1, k = C[P];
        if (k)
          return {
            data: {
              index: P,
              overflows: S
            },
            reset: {
              placement: k
            }
          };
        let O = (M = S.filter((F) => F.overflows[0] <= 0).sort((F, T) => F.overflows[1] - T.overflows[1])[0]) == null ? void 0 : M.placement;
        if (!O)
          switch (f) {
            case "bestFit": {
              var I;
              const F = (I = S.map((T) => [T.placement, T.overflows.filter((L) => L > 0).reduce((L, A) => L + A, 0)]).sort((T, L) => T[1] - L[1])[0]) == null ? void 0 : I[0];
              F && (O = F);
              break;
            }
            case "initialPlacement":
              O = s;
              break;
          }
        if (r !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
};
function iv(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function sv(e) {
  return e8.some((t) => e[t] >= 0);
}
const c8 = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = Mr(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await ws(t, {
            ...o,
            elementContext: "reference"
          }), s = iv(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: sv(s)
            }
          };
        }
        case "escaped": {
          const i = await ws(t, {
            ...o,
            altBoundary: !0
          }), s = iv(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: sv(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function u8(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = Or(n), a = Mi(n), l = Oi(n) === "y", c = ["left", "top"].includes(s) ? -1 : 1, u = i && l ? -1 : 1, d = Mr(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return a && typeof p == "number" && (h = a === "end" ? p * -1 : p), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const Rx = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, o = await u8(t, e);
      return {
        x: n + o.x,
        y: r + o.y,
        data: o
      };
    }
  };
}, Tx = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (v) => {
            let {
              x: y,
              y: b
            } = v;
            return {
              x: y,
              y: b
            };
          }
        },
        ...l
      } = Mr(e, t), c = {
        x: n,
        y: r
      }, u = await ws(t, l), d = Oi(Or(o)), f = Ph(d);
      let h = c[f], p = c[d];
      if (i) {
        const v = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", b = h + u[v], w = h - u[y];
        h = Cd(b, h, w);
      }
      if (s) {
        const v = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", b = p + u[v], w = p - u[y];
        p = Cd(b, p, w);
      }
      const g = a.fn({
        ...t,
        [f]: h,
        [d]: p
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
}, d8 = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = Mr(e, t), u = {
        x: n,
        y: r
      }, d = Oi(o), f = Ph(d);
      let h = u[f], p = u[d];
      const g = Mr(a, t), v = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const w = f === "y" ? "height" : "width", C = i.reference[f] - i.floating[w] + v.mainAxis, x = i.reference[f] + i.reference[w] - v.mainAxis;
        h < C ? h = C : h > x && (h = x);
      }
      if (c) {
        var y, b;
        const w = f === "y" ? "width" : "height", C = ["top", "left"].includes(Or(o)), x = i.reference[d] - i.floating[w] + (C && ((y = s.offset) == null ? void 0 : y[d]) || 0) + (C ? 0 : v.crossAxis), E = i.reference[d] + i.reference[w] + (C ? 0 : ((b = s.offset) == null ? void 0 : b[d]) || 0) - (C ? v.crossAxis : 0);
        p < x ? p = x : p > E && (p = E);
      }
      return {
        [f]: h,
        [d]: p
      };
    }
  };
}, kx = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: i
      } = t, {
        apply: s = () => {
        },
        ...a
      } = Mr(e, t), l = await ws(t, a), c = Or(n), u = Mi(n), d = Oi(n) === "y", {
        width: f,
        height: h
      } = r.floating;
      let p, g;
      c === "top" || c === "bottom" ? (p = c, g = u === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (g = c, p = u === "end" ? "top" : "bottom");
      const v = h - l[p], y = f - l[g], b = !t.middlewareData.shift;
      let w = v, C = y;
      if (d) {
        const E = f - l.left - l.right;
        C = u || b ? xs(y, E) : E;
      } else {
        const E = h - l.top - l.bottom;
        w = u || b ? xs(v, E) : E;
      }
      if (b && !u) {
        const E = fo(l.left, 0), S = fo(l.right, 0), R = fo(l.top, 0), M = fo(l.bottom, 0);
        d ? C = f - 2 * (E !== 0 || S !== 0 ? E + S : fo(l.left, l.right)) : w = h - 2 * (R !== 0 || M !== 0 ? R + M : fo(l.top, l.bottom));
      }
      await s({
        ...t,
        availableWidth: C,
        availableHeight: w
      });
      const x = await o.getDimensions(i.floating);
      return f !== x.width || h !== x.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
}, Ed = Math.min, ii = Math.max, Al = Math.round, Oa = Math.floor, Yr = (e) => ({
  x: e,
  y: e
});
function Gr(e) {
  return Px(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function xn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function kr(e) {
  var t;
  return (t = (Px(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Px(e) {
  return e instanceof Node || e instanceof xn(e).Node;
}
function Rr(e) {
  return e instanceof Element || e instanceof xn(e).Element;
}
function or(e) {
  return e instanceof HTMLElement || e instanceof xn(e).HTMLElement;
}
function av(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof xn(e).ShadowRoot;
}
function Ks(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = An(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function f8(e) {
  return ["table", "td", "th"].includes(Gr(e));
}
function Dh(e) {
  const t = Ah(), n = An(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function h8(e) {
  let t = bi(e);
  for (; or(t) && !kc(t); ) {
    if (Dh(t))
      return t;
    t = bi(t);
  }
  return null;
}
function Ah() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function kc(e) {
  return ["html", "body", "#document"].includes(Gr(e));
}
function An(e) {
  return xn(e).getComputedStyle(e);
}
function Pc(e) {
  return Rr(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function bi(e) {
  if (Gr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    av(e) && e.host || // Fallback.
    kr(e)
  );
  return av(t) ? t.host : t;
}
function Ix(e) {
  const t = bi(e);
  return kc(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : or(t) && Ks(t) ? t : Ix(t);
}
function Ll(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = Ix(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = xn(r);
  return o ? t.concat(i, i.visualViewport || [], Ks(r) ? r : []) : t.concat(r, Ll(r));
}
function Nx(e) {
  const t = An(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = or(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, a = Al(n) !== i || Al(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function Lh(e) {
  return Rr(e) ? e : e.contextElement;
}
function si(e) {
  const t = Lh(e);
  if (!or(t))
    return Yr(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Nx(t);
  let s = (i ? Al(n.width) : n.width) / r, a = (i ? Al(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const p8 = /* @__PURE__ */ Yr(0);
function Dx(e) {
  const t = xn(e);
  return !Ah() || !t.visualViewport ? p8 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function g8(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== xn(e) ? !1 : t;
}
function Po(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Lh(e);
  let s = Yr(1);
  t && (r ? Rr(r) && (s = si(r)) : s = si(e));
  const a = g8(i, n, r) ? Dx(i) : Yr(0);
  let l = (o.left + a.x) / s.x, c = (o.top + a.y) / s.y, u = o.width / s.x, d = o.height / s.y;
  if (i) {
    const f = xn(i), h = r && Rr(r) ? xn(r) : r;
    let p = f.frameElement;
    for (; p && r && h !== f; ) {
      const g = si(p), v = p.getBoundingClientRect(), y = An(p), b = v.left + (p.clientLeft + parseFloat(y.paddingLeft)) * g.x, w = v.top + (p.clientTop + parseFloat(y.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += b, c += w, p = xn(p).frameElement;
    }
  }
  return Dl({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function m8(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const o = or(n), i = kr(n);
  if (n === i)
    return t;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = Yr(1);
  const l = Yr(0);
  if ((o || !o && r !== "fixed") && ((Gr(n) !== "body" || Ks(i)) && (s = Pc(n)), or(n))) {
    const c = Po(n);
    a = si(n), l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  }
  return {
    width: t.width * a.x,
    height: t.height * a.y,
    x: t.x * a.x - s.scrollLeft * a.x + l.x,
    y: t.y * a.y - s.scrollTop * a.y + l.y
  };
}
function v8(e) {
  return Array.from(e.getClientRects());
}
function Ax(e) {
  return Po(kr(e)).left + Pc(e).scrollLeft;
}
function b8(e) {
  const t = kr(e), n = Pc(e), r = e.ownerDocument.body, o = ii(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = ii(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Ax(e);
  const a = -n.scrollTop;
  return An(r).direction === "rtl" && (s += ii(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
function y8(e, t) {
  const n = xn(e), r = kr(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    const c = Ah();
    (!c || c && t === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function x8(e, t) {
  const n = Po(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = or(e) ? si(e) : Yr(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function lv(e, t, n) {
  let r;
  if (t === "viewport")
    r = y8(e, n);
  else if (t === "document")
    r = b8(kr(e));
  else if (Rr(t))
    r = x8(t, n);
  else {
    const o = Dx(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Dl(r);
}
function Lx(e, t) {
  const n = bi(e);
  return n === t || !Rr(n) || kc(n) ? !1 : An(n).position === "fixed" || Lx(n, t);
}
function w8(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ll(e).filter((a) => Rr(a) && Gr(a) !== "body"), o = null;
  const i = An(e).position === "fixed";
  let s = i ? bi(e) : e;
  for (; Rr(s) && !kc(s); ) {
    const a = An(s), l = Dh(s);
    !l && a.position === "fixed" && (o = null), (i ? !l && !o : !l && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Ks(s) && !l && Lx(e, s)) ? r = r.filter((u) => u !== s) : o = a, s = bi(s);
  }
  return t.set(e, r), r;
}
function C8(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? w8(t, this._c) : [].concat(n), r], a = s[0], l = s.reduce((c, u) => {
    const d = lv(t, u, o);
    return c.top = ii(d.top, c.top), c.right = Ed(d.right, c.right), c.bottom = Ed(d.bottom, c.bottom), c.left = ii(d.left, c.left), c;
  }, lv(t, a, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function _8(e) {
  return Nx(e);
}
function E8(e, t, n) {
  const r = or(t), o = kr(t), i = n === "fixed", s = Po(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Yr(0);
  if (r || !r && !i)
    if ((Gr(t) !== "body" || Ks(o)) && (a = Pc(t)), r) {
      const c = Po(t, !0, i, t);
      l.x = c.x + t.clientLeft, l.y = c.y + t.clientTop;
    } else
      o && (l.x = Ax(o));
  return {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function cv(e, t) {
  return !or(e) || An(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function $x(e, t) {
  const n = xn(e);
  if (!or(e))
    return n;
  let r = cv(e, t);
  for (; r && f8(r) && An(r).position === "static"; )
    r = cv(r, t);
  return r && (Gr(r) === "html" || Gr(r) === "body" && An(r).position === "static" && !Dh(r)) ? n : r || h8(e) || n;
}
const S8 = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const o = this.getOffsetParent || $x, i = this.getDimensions;
  return {
    reference: E8(t, await o(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await i(n)
    }
  };
};
function M8(e) {
  return An(e).direction === "rtl";
}
const O8 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: m8,
  getDocumentElement: kr,
  getClippingRect: C8,
  getOffsetParent: $x,
  getElementRects: S8,
  getClientRects: v8,
  getDimensions: _8,
  getScale: si,
  isElement: Rr,
  isRTL: M8
};
function R8(e, t) {
  let n = null, r;
  const o = kr(e);
  function i() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function s(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), i();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (a || t(), !d || !f)
      return;
    const h = Oa(u), p = Oa(o.clientWidth - (c + d)), g = Oa(o.clientHeight - (u + f)), v = Oa(c), b = {
      rootMargin: -h + "px " + -p + "px " + -g + "px " + -v + "px",
      threshold: ii(0, Ed(1, l)) || 1
    };
    let w = !0;
    function C(x) {
      const E = x[0].intersectionRatio;
      if (E !== l) {
        if (!w)
          return s();
        E ? s(!1, E) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      w = !1;
    }
    try {
      n = new IntersectionObserver(C, {
        ...b,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(C, b);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function Fx(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Lh(e), u = o || i ? [...c ? Ll(c) : [], ...Ll(t)] : [];
  u.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), i && y.addEventListener("resize", n);
  });
  const d = c && a ? R8(c, n) : null;
  let f = -1, h = null;
  s && (h = new ResizeObserver((y) => {
    let [b] = y;
    b && b.target === c && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      h && h.observe(t);
    })), n();
  }), c && !l && h.observe(c), h.observe(t));
  let p, g = l ? Po(e) : null;
  l && v();
  function v() {
    const y = Po(e);
    g && (y.x !== g.x || y.y !== g.y || y.width !== g.width || y.height !== g.height) && n(), g = y, p = requestAnimationFrame(v);
  }
  return n(), () => {
    u.forEach((y) => {
      o && y.removeEventListener("scroll", n), i && y.removeEventListener("resize", n);
    }), d && d(), h && h.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const T8 = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: O8,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return l8(e, t, {
    ...o,
    platform: i
  });
}, k8 = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? ov({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? ov({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var Za = typeof document < "u" ? _s : Le;
function $l(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!$l(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !$l(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Vx(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function uv(e, t) {
  const n = Vx(e);
  return Math.round(t * n) / n;
}
function dv(e) {
  const t = m.useRef(e);
  return Za(() => {
    t.current = e;
  }), t;
}
function Bx(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = m.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = m.useState(r);
  $l(f, r) || h(r);
  const [p, g] = m.useState(null), [v, y] = m.useState(null), b = m.useCallback((L) => {
    L != E.current && (E.current = L, g(L));
  }, [g]), w = m.useCallback((L) => {
    L !== S.current && (S.current = L, y(L));
  }, [y]), C = i || p, x = s || v, E = m.useRef(null), S = m.useRef(null), R = m.useRef(u), M = dv(l), I = dv(o), P = m.useCallback(() => {
    if (!E.current || !S.current)
      return;
    const L = {
      placement: t,
      strategy: n,
      middleware: f
    };
    I.current && (L.platform = I.current), T8(E.current, S.current, L).then((A) => {
      const N = {
        ...A,
        isPositioned: !0
      };
      k.current && !$l(R.current, N) && (R.current = N, nn.flushSync(() => {
        d(N);
      }));
    });
  }, [f, t, n, I]);
  Za(() => {
    c === !1 && R.current.isPositioned && (R.current.isPositioned = !1, d((L) => ({
      ...L,
      isPositioned: !1
    })));
  }, [c]);
  const k = m.useRef(!1);
  Za(() => (k.current = !0, () => {
    k.current = !1;
  }), []), Za(() => {
    if (C && (E.current = C), x && (S.current = x), C && x) {
      if (M.current)
        return M.current(C, x, P);
      P();
    }
  }, [C, x, P, M]);
  const O = m.useMemo(() => ({
    reference: E,
    floating: S,
    setReference: b,
    setFloating: w
  }), [b, w]), F = m.useMemo(() => ({
    reference: C,
    floating: x
  }), [C, x]), T = m.useMemo(() => {
    const L = {
      position: n,
      left: 0,
      top: 0
    };
    if (!F.floating)
      return L;
    const A = uv(F.floating, u.x), N = uv(F.floating, u.y);
    return a ? {
      ...L,
      transform: "translate(" + A + "px, " + N + "px)",
      ...Vx(F.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: A,
      top: N
    };
  }, [n, a, F.floating, u.x, u.y]);
  return m.useMemo(() => ({
    ...u,
    update: P,
    refs: O,
    elements: F,
    floatingStyles: T
  }), [u, P, O, F, T]);
}
const P8 = /* @__PURE__ */ mt((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ Pe(Cn.svg, He({}, i, {
    ref: t,
    width: r,
    height: o,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ Pe("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), I8 = P8;
function N8(e) {
  const [t, n] = dt(void 0);
  return vi(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, a;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          s = c.inlineSize, a = c.blockSize;
        } else
          s = e.offsetWidth, a = e.offsetHeight;
        n({
          width: s,
          height: a
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const Hx = "Popper", [Wx, zx] = js(Hx), [D8, jx] = Wx(Hx), A8 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = dt(null);
  return /* @__PURE__ */ Pe(D8, {
    scope: t,
    anchor: r,
    onAnchorChange: o
  }, n);
}, L8 = "PopperAnchor", $8 = /* @__PURE__ */ mt((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...o } = e, i = jx(L8, n), s = Be(null), a = rr(t, s);
  return Le(() => {
    i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
  }), r ? null : /* @__PURE__ */ Pe(Cn.div, He({}, o, {
    ref: a
  }));
}), Ux = "PopperContent", [F8, V8] = Wx(Ux), B8 = /* @__PURE__ */ mt((e, t) => {
  var n, r, o, i, s, a, l, c;
  const { __scopePopper: u, side: d = "bottom", sideOffset: f = 0, align: h = "center", alignOffset: p = 0, arrowPadding: g = 0, collisionBoundary: v = [], collisionPadding: y = 0, sticky: b = "partial", hideWhenDetached: w = !1, avoidCollisions: C = !0, onPlaced: x, ...E } = e, S = jx(Ux, u), [R, M] = dt(null), I = rr(
    t,
    (K) => M(K)
  ), [P, k] = dt(null), O = N8(P), F = (n = O == null ? void 0 : O.width) !== null && n !== void 0 ? n : 0, T = (r = O == null ? void 0 : O.height) !== null && r !== void 0 ? r : 0, L = d + (h !== "center" ? "-" + h : ""), A = typeof y == "number" ? y : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...y
  }, N = Array.isArray(v) ? v : [
    v
  ], B = N.length > 0, $ = {
    padding: A,
    boundary: N.filter(j8),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: B
  }, { refs: U, floatingStyles: G, placement: H, isPositioned: q, middlewareData: j } = Bx({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: L,
    whileElementsMounted: Fx,
    elements: {
      reference: S.anchor
    },
    middleware: [
      Rx({
        mainAxis: f + T,
        alignmentAxis: p
      }),
      C && Tx({
        mainAxis: !0,
        crossAxis: !1,
        limiter: b === "partial" ? d8() : void 0,
        ...$
      }),
      C && Ox({
        ...$
      }),
      kx({
        ...$,
        apply: ({ elements: K, rects: ce, availableWidth: ee, availableHeight: re }) => {
          const { width: le, height: de } = ce.reference, be = K.floating.style;
          be.setProperty("--radix-popper-available-width", `${ee}px`), be.setProperty("--radix-popper-available-height", `${re}px`), be.setProperty("--radix-popper-anchor-width", `${le}px`), be.setProperty("--radix-popper-anchor-height", `${de}px`);
        }
      }),
      P && k8({
        element: P,
        padding: g
      }),
      U8({
        arrowWidth: F,
        arrowHeight: T
      }),
      w && c8({
        strategy: "referenceHidden"
      })
    ]
  }), [W, z] = Yx(H), X = Sr(x);
  vi(() => {
    q && (X == null || X());
  }, [
    q,
    X
  ]);
  const J = (o = j.arrow) === null || o === void 0 ? void 0 : o.x, ne = (i = j.arrow) === null || i === void 0 ? void 0 : i.y, Q = ((s = j.arrow) === null || s === void 0 ? void 0 : s.centerOffset) !== 0, [D, te] = dt();
  return vi(() => {
    R && te(window.getComputedStyle(R).zIndex);
  }, [
    R
  ]), /* @__PURE__ */ Pe("div", {
    ref: U.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...G,
      transform: q ? G.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: D,
      "--radix-popper-transform-origin": [
        (a = j.transformOrigin) === null || a === void 0 ? void 0 : a.x,
        (l = j.transformOrigin) === null || l === void 0 ? void 0 : l.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ Pe(F8, {
    scope: u,
    placedSide: W,
    onArrowChange: k,
    arrowX: J,
    arrowY: ne,
    shouldHideArrow: Q
  }, /* @__PURE__ */ Pe(Cn.div, He({
    "data-side": W,
    "data-align": z
  }, E, {
    ref: I,
    style: {
      ...E.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: q ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (c = j.hide) !== null && c !== void 0 && c.referenceHidden ? 0 : void 0
    }
  }))));
}), H8 = "PopperArrow", W8 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, z8 = /* @__PURE__ */ mt(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = V8(H8, r), s = W8[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ Pe("span", {
      ref: i.onArrowChange,
      style: {
        position: "absolute",
        left: i.arrowX,
        top: i.arrowY,
        [s]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[i.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[i.placedSide],
        visibility: i.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ Pe(I8, He({}, o, {
      ref: n,
      style: {
        ...o.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function j8(e) {
  return e !== null;
}
const U8 = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o, i, s;
    const { placement: a, rects: l, middlewareData: c } = t, d = ((n = c.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = d ? 0 : e.arrowWidth, h = d ? 0 : e.arrowHeight, [p, g] = Yx(a), v = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[g], y = ((r = (o = c.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + f / 2, b = ((i = (s = c.arrow) === null || s === void 0 ? void 0 : s.y) !== null && i !== void 0 ? i : 0) + h / 2;
    let w = "", C = "";
    return p === "bottom" ? (w = d ? v : `${y}px`, C = `${-h}px`) : p === "top" ? (w = d ? v : `${y}px`, C = `${l.floating.height + h}px`) : p === "right" ? (w = `${-h}px`, C = d ? v : `${b}px`) : p === "left" && (w = `${l.floating.width + h}px`, C = d ? v : `${b}px`), {
      data: {
        x: w,
        y: C
      }
    };
  }
});
function Yx(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const Y8 = A8, Gx = $8, G8 = B8, K8 = z8;
function q8(e, t) {
  return Vv((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const $h = (e) => {
  const { present: t, children: n } = e, r = X8(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Zo.only(n), i = rr(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Wl(o, {
    ref: i
  }) : null;
};
$h.displayName = "Presence";
function X8(e) {
  const [t, n] = dt(), r = Be({}), o = Be(e), i = Be("none"), s = e ? "mounted" : "unmounted", [a, l] = q8(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Le(() => {
    const c = Ra(r.current);
    i.current = a === "mounted" ? c : "none";
  }, [
    a
  ]), vi(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const f = i.current, h = Ra(c);
      e ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    l
  ]), vi(() => {
    if (t) {
      const c = (d) => {
        const h = Ra(r.current).includes(d.animationName);
        d.target === t && h && Pd(
          () => l("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === t && (i.current = Ra(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [
    t,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(a),
    ref: st((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function Ra(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
var Z8 = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Uo = /* @__PURE__ */ new WeakMap(), Ta = /* @__PURE__ */ new WeakMap(), ka = {}, wu = 0, Kx = function(e) {
  return e && (e.host || Kx(e.parentNode));
}, Q8 = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Kx(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, J8 = function(e, t, n, r) {
  var o = Q8(t, Array.isArray(e) ? e : [e]);
  ka[n] || (ka[n] = /* @__PURE__ */ new WeakMap());
  var i = ka[n], s = [], a = /* @__PURE__ */ new Set(), l = new Set(o), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  o.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else {
        var h = f.getAttribute(r), p = h !== null && h !== "false", g = (Uo.get(f) || 0) + 1, v = (i.get(f) || 0) + 1;
        Uo.set(f, g), i.set(f, v), s.push(f), g === 1 && p && Ta.set(f, !0), v === 1 && f.setAttribute(n, "true"), p || f.setAttribute(r, "true");
      }
    });
  };
  return u(t), a.clear(), wu++, function() {
    s.forEach(function(d) {
      var f = Uo.get(d) - 1, h = i.get(d) - 1;
      Uo.set(d, f), i.set(d, h), f || (Ta.has(d) || d.removeAttribute(r), Ta.delete(d)), h || d.removeAttribute(n);
    }), wu--, wu || (Uo = /* @__PURE__ */ new WeakMap(), Uo = /* @__PURE__ */ new WeakMap(), Ta = /* @__PURE__ */ new WeakMap(), ka = {});
  };
}, e7 = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || Z8(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), J8(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, ln = function() {
  return ln = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, ln.apply(this, arguments);
};
function qx(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function t7(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Qa = "right-scroll-bar-position", Ja = "width-before-scroll-bar", n7 = "with-scroll-bars-hidden", r7 = "--removed-body-scroll-bar-size";
function o7(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function i7(e, t) {
  var n = dt(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function s7(e, t) {
  return i7(t || null, function(n) {
    return e.forEach(function(r) {
      return o7(r, n);
    });
  });
}
function a7(e) {
  return e;
}
function l7(e, t) {
  t === void 0 && (t = a7);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var l = function() {
        var u = s;
        s = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          s.push(u), c();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return o;
}
function c7(e) {
  e === void 0 && (e = {});
  var t = l7(null);
  return t.options = ln({ async: !0, ssr: !1 }, e), t;
}
var Xx = function(e) {
  var t = e.sideCar, n = qx(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return m.createElement(r, ln({}, n));
};
Xx.isSideCarExport = !0;
function u7(e, t) {
  return e.useMedium(t), Xx;
}
var Zx = c7(), Cu = function() {
}, Ic = m.forwardRef(function(e, t) {
  var n = m.useRef(null), r = m.useState({
    onScrollCapture: Cu,
    onWheelCapture: Cu,
    onTouchMoveCapture: Cu
  }), o = r[0], i = r[1], s = e.forwardProps, a = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, h = e.noIsolation, p = e.inert, g = e.allowPinchZoom, v = e.as, y = v === void 0 ? "div" : v, b = qx(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), w = f, C = s7([n, t]), x = ln(ln({}, b), o);
  return m.createElement(
    m.Fragment,
    null,
    u && m.createElement(w, { sideCar: Zx, removeScrollBar: c, shards: d, noIsolation: h, inert: p, setCallbacks: i, allowPinchZoom: !!g, lockRef: n }),
    s ? m.cloneElement(m.Children.only(a), ln(ln({}, x), { ref: C })) : m.createElement(y, ln({}, x, { className: l, ref: C }), a)
  );
});
Ic.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ic.classNames = {
  fullWidth: Ja,
  zeroRight: Qa
};
var fv, d7 = function() {
  if (fv)
    return fv;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function f7() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = d7();
  return t && e.setAttribute("nonce", t), e;
}
function h7(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function p7(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var g7 = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = f7()) && (h7(t, n), p7(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, m7 = function() {
  var e = g7();
  return function(t, n) {
    m.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Qx = function() {
  var e = m7(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, v7 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, _u = function(e) {
  return parseInt(e || "", 10) || 0;
}, b7 = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [_u(n), _u(r), _u(o)];
}, y7 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return v7;
  var t = b7(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, x7 = Qx(), w7 = function(e, t, n, r) {
  var o = e.left, i = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(n7, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Qa, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Ja, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Qa, " .").concat(Qa, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Ja, " .").concat(Ja, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(r7, ": ").concat(a, `px;
  }
`);
}, C7 = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r, i = m.useMemo(function() {
    return y7(o);
  }, [o]);
  return m.createElement(x7, { styles: w7(i, !t, o, n ? "" : "!important") });
}, Sd = !1;
if (typeof window < "u")
  try {
    var Pa = Object.defineProperty({}, "passive", {
      get: function() {
        return Sd = !0, !0;
      }
    });
    window.addEventListener("test", Pa, Pa), window.removeEventListener("test", Pa, Pa);
  } catch {
    Sd = !1;
  }
var Yo = Sd ? { passive: !1 } : !1, _7 = function(e) {
  return e.tagName === "TEXTAREA";
}, Jx = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !_7(e) && n[t] === "visible")
  );
}, E7 = function(e) {
  return Jx(e, "overflowY");
}, S7 = function(e) {
  return Jx(e, "overflowX");
}, hv = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = ew(e, n);
    if (r) {
      var o = tw(e, n), i = o[1], s = o[2];
      if (i > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, M7 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, O7 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, ew = function(e, t) {
  return e === "v" ? E7(t) : S7(t);
}, tw = function(e, t) {
  return e === "v" ? M7(t) : O7(t);
}, R7 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, T7 = function(e, t, n, r, o) {
  var i = R7(e, window.getComputedStyle(t).direction), s = i * r, a = n.target, l = t.contains(a), c = !1, u = s > 0, d = 0, f = 0;
  do {
    var h = tw(e, a), p = h[0], g = h[1], v = h[2], y = g - v - i * p;
    (p || y) && ew(e, a) && (d += y, f += p), a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (t.contains(a) || t === a)
  );
  return (u && (o && d === 0 || !o && s > d) || !u && (o && f === 0 || !o && -s > f)) && (c = !0), c;
}, Ia = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, pv = function(e) {
  return [e.deltaX, e.deltaY];
}, gv = function(e) {
  return e && "current" in e ? e.current : e;
}, k7 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, P7 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, I7 = 0, Go = [];
function N7(e) {
  var t = m.useRef([]), n = m.useRef([0, 0]), r = m.useRef(), o = m.useState(I7++)[0], i = m.useState(function() {
    return Qx();
  })[0], s = m.useRef(e);
  m.useEffect(function() {
    s.current = e;
  }, [e]), m.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = t7([e.lockRef.current], (e.shards || []).map(gv), !0).filter(Boolean);
      return g.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = m.useCallback(function(g, v) {
    if ("touches" in g && g.touches.length === 2)
      return !s.current.allowPinchZoom;
    var y = Ia(g), b = n.current, w = "deltaX" in g ? g.deltaX : b[0] - y[0], C = "deltaY" in g ? g.deltaY : b[1] - y[1], x, E = g.target, S = Math.abs(w) > Math.abs(C) ? "h" : "v";
    if ("touches" in g && S === "h" && E.type === "range")
      return !1;
    var R = hv(S, E);
    if (!R)
      return !0;
    if (R ? x = S : (x = S === "v" ? "h" : "v", R = hv(S, E)), !R)
      return !1;
    if (!r.current && "changedTouches" in g && (w || C) && (r.current = x), !x)
      return !0;
    var M = r.current || x;
    return T7(M, v, g, M === "h" ? w : C, !0);
  }, []), l = m.useCallback(function(g) {
    var v = g;
    if (!(!Go.length || Go[Go.length - 1] !== i)) {
      var y = "deltaY" in v ? pv(v) : Ia(v), b = t.current.filter(function(x) {
        return x.name === v.type && x.target === v.target && k7(x.delta, y);
      })[0];
      if (b && b.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!b) {
        var w = (s.current.shards || []).map(gv).filter(Boolean).filter(function(x) {
          return x.contains(v.target);
        }), C = w.length > 0 ? a(v, w[0]) : !s.current.noIsolation;
        C && v.cancelable && v.preventDefault();
      }
    }
  }, []), c = m.useCallback(function(g, v, y, b) {
    var w = { name: g, delta: v, target: y, should: b };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== w;
      });
    }, 1);
  }, []), u = m.useCallback(function(g) {
    n.current = Ia(g), r.current = void 0;
  }, []), d = m.useCallback(function(g) {
    c(g.type, pv(g), g.target, a(g, e.lockRef.current));
  }, []), f = m.useCallback(function(g) {
    c(g.type, Ia(g), g.target, a(g, e.lockRef.current));
  }, []);
  m.useEffect(function() {
    return Go.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Yo), document.addEventListener("touchmove", l, Yo), document.addEventListener("touchstart", u, Yo), function() {
      Go = Go.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, Yo), document.removeEventListener("touchmove", l, Yo), document.removeEventListener("touchstart", u, Yo);
    };
  }, []);
  var h = e.removeScrollBar, p = e.inert;
  return m.createElement(
    m.Fragment,
    null,
    p ? m.createElement(i, { styles: P7(o) }) : null,
    h ? m.createElement(C7, { gapMode: "margin" }) : null
  );
}
const D7 = u7(Zx, N7);
var nw = m.forwardRef(function(e, t) {
  return m.createElement(Ic, ln({}, e, { ref: t, sideCar: D7 }));
});
nw.classNames = Ic.classNames;
const A7 = nw, rw = "Popover", [ow, m$] = js(rw, [
  zx
]), qs = zx(), [L7, no] = ow(rw), $7 = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: s = !1 } = e, a = qs(t), l = Be(null), [c, u] = dt(!1), [d = !1, f] = Us({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ Pe(Y8, a, /* @__PURE__ */ Pe(L7, {
    scope: t,
    contentId: X1(),
    triggerRef: l,
    open: d,
    onOpenChange: f,
    onOpenToggle: st(
      () => f(
        (h) => !h
      ),
      [
        f
      ]
    ),
    hasCustomAnchor: c,
    onCustomAnchorAdd: st(
      () => u(!0),
      []
    ),
    onCustomAnchorRemove: st(
      () => u(!1),
      []
    ),
    modal: s
  }, n));
}, F7 = "PopoverAnchor", V7 = /* @__PURE__ */ mt((e, t) => {
  const { __scopePopover: n, ...r } = e, o = no(F7, n), i = qs(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: a } = o;
  return Le(() => (s(), () => a()), [
    s,
    a
  ]), /* @__PURE__ */ Pe(Gx, He({}, i, r, {
    ref: t
  }));
}), B7 = "PopoverTrigger", H7 = /* @__PURE__ */ mt((e, t) => {
  const { __scopePopover: n, ...r } = e, o = no(B7, n), i = qs(n), s = rr(t, o.triggerRef), a = /* @__PURE__ */ Pe(Cn.button, He({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": aw(o.open)
  }, r, {
    ref: s,
    onClick: tn(e.onClick, o.onOpenToggle)
  }));
  return o.hasCustomAnchor ? a : /* @__PURE__ */ Pe(Gx, He({
    asChild: !0
  }, i), a);
}), iw = "PopoverPortal", [W7, z7] = ow(iw, {
  forceMount: void 0
}), j7 = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = no(iw, t);
  return /* @__PURE__ */ Pe(W7, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ Pe($h, {
    present: n || i.open
  }, /* @__PURE__ */ Pe(Ly, {
    asChild: !0,
    container: o
  }, r)));
}, Cs = "PopoverContent", U7 = /* @__PURE__ */ mt((e, t) => {
  const n = z7(Cs, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, i = no(Cs, e.__scopePopover);
  return /* @__PURE__ */ Pe($h, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ Pe(Y7, He({}, o, {
    ref: t
  })) : /* @__PURE__ */ Pe(G7, He({}, o, {
    ref: t
  })));
}), Y7 = /* @__PURE__ */ mt((e, t) => {
  const n = no(Cs, e.__scopePopover), r = Be(null), o = rr(t, r), i = Be(!1);
  return Le(() => {
    const s = r.current;
    if (s)
      return e7(s);
  }, []), /* @__PURE__ */ Pe(A7, {
    as: mi,
    allowPinchZoom: !0
  }, /* @__PURE__ */ Pe(sw, He({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: tn(e.onCloseAutoFocus, (s) => {
      var a;
      s.preventDefault(), i.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: tn(e.onPointerDownOutside, (s) => {
      const a = s.detail.originalEvent, l = a.button === 0 && a.ctrlKey === !0, c = a.button === 2 || l;
      i.current = c;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: tn(
      e.onFocusOutside,
      (s) => s.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), G7 = /* @__PURE__ */ mt((e, t) => {
  const n = no(Cs, e.__scopePopover), r = Be(!1), o = Be(!1);
  return /* @__PURE__ */ Pe(sw, He({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var s;
      if ((s = e.onCloseAutoFocus) === null || s === void 0 || s.call(e, i), !i.defaultPrevented) {
        var a;
        r.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus(), i.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (i) => {
      var s, a;
      (s = e.onInteractOutside) === null || s === void 0 || s.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const l = i.target;
      ((a = n.triggerRef.current) === null || a === void 0 ? void 0 : a.contains(l)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
    }
  }));
}), sw = /* @__PURE__ */ mt((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, disableOutsidePointerEvents: s, onEscapeKeyDown: a, onPointerDownOutside: l, onFocusOutside: c, onInteractOutside: u, ...d } = e, f = no(Cs, n), h = qs(n);
  return Y9(), /* @__PURE__ */ Pe(G9, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ Pe(z9, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onInteractOutside: u,
    onEscapeKeyDown: a,
    onPointerDownOutside: l,
    onFocusOutside: c,
    onDismiss: () => f.onOpenChange(!1)
  }, /* @__PURE__ */ Pe(G8, He({
    "data-state": aw(f.open),
    role: "dialog",
    id: f.contentId
  }, h, d, {
    ref: t,
    style: {
      ...d.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), K7 = "PopoverClose", q7 = /* @__PURE__ */ mt((e, t) => {
  const { __scopePopover: n, ...r } = e, o = no(K7, n);
  return /* @__PURE__ */ Pe(Cn.button, He({
    type: "button"
  }, r, {
    ref: t,
    onClick: tn(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
}), X7 = /* @__PURE__ */ mt((e, t) => {
  const { __scopePopover: n, ...r } = e, o = qs(n);
  return /* @__PURE__ */ Pe(K8, He({}, o, r, {
    ref: t
  }));
});
function aw(e) {
  return e ? "open" : "closed";
}
const lw = $7, Z7 = V7, cw = H7, uw = j7, dw = U7, Q7 = q7, J7 = X7, eA = ({
  name: e,
  id: t,
  className: n,
  selected: r,
  onSelect: o,
  disablePortal: i = !1,
  fromDate: s,
  toDate: a
}) => {
  const [l, c] = m.useState(!1), { inputRef: u, inputProps: d, setInputValue: f, month: h, setMonth: p } = gn(
    {
      onSelect: o,
      selected: r,
      fromDate: s,
      toDate: a
    }
  ), g = (y) => {
    y ? (o(Qt(y, gn.valueFormatString)), c(!1)) : (o(""), f(""));
  }, v = i ? m.Fragment : uw;
  return /* @__PURE__ */ Z(lw, { open: l, onOpenChange: c, children: [
    /* @__PURE__ */ _(Z7, { asChild: !0, children: /* @__PURE__ */ _(
      rA,
      {
        ref: u,
        icon: /* @__PURE__ */ _(cw, { className: "pointer-events-auto -m-1 rounded p-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500", children: /* @__PURE__ */ _(HM, { className: "h-5 w-5" }) }),
        className: n,
        id: t,
        name: e,
        ...d
      }
    ) }),
    /* @__PURE__ */ _(v, { children: /* @__PURE__ */ _(
      dw,
      {
        className: "z-10",
        side: "bottom",
        sideOffset: 4,
        collisionPadding: 4,
        children: /* @__PURE__ */ _(
          mx,
          {
            mode: "single",
            className: "shadow-3",
            initialFocus: !0,
            onSelect: g,
            selected: r ? qo(r, gn.valueFormatString, /* @__PURE__ */ new Date()) : void 0,
            month: h,
            onMonthChange: p,
            fromDate: s,
            toDate: a
          }
        )
      }
    ) })
  ] });
};
eA.displayName = "DatePicker";
const Na = L9({
  mode: "dd/mm/yyyy",
  separator: "-"
}), { plugins: tA, ...mv } = N9(
  "dd-mm-yyyy",
  !0
), nA = {
  ...Na,
  plugins: tA.concat(Na.plugins || []),
  preprocessors: [
    // Always put it BEFORE all other preprocessors
    ...mv.preprocessors,
    ...Na.preprocessors
  ],
  postprocessors: [
    ...Na.postprocessors,
    // Always put it AFTER all other postprocessors
    ...mv.postprocessors
  ]
}, gn = ({
  selected: e,
  onSelect: t,
  fromDate: n,
  toDate: r
}) => {
  const [o, i] = m.useState(""), [s, a] = m.useState(), l = F9({ options: nA });
  return m.useEffect(() => {
    e && (a(qo(e, gn.valueFormatString, /* @__PURE__ */ new Date())), i(
      Qt(
        qo(e, gn.valueFormatString, /* @__PURE__ */ new Date()),
        gn.inputFormatString
      )
    ));
  }, [e]), {
    inputRef: l,
    setInputValue: i,
    month: s,
    setMonth: a,
    inputProps: {
      value: o,
      onBlur: (c) => {
        if (!c.target.value) {
          t == null || t(""), a(/* @__PURE__ */ new Date());
          return;
        }
        const u = qo(
          c.target.value,
          gn.inputFormatString,
          /* @__PURE__ */ new Date()
        ), d = n && Rn(n, u) > 0, f = r && Rn(u, r) > 0;
        if (!Uf(u) || d || f) {
          i(
            e ? Qt(
              qo(e, gn.valueFormatString, /* @__PURE__ */ new Date()),
              gn.inputFormatString
            ) : ""
          );
          return;
        }
        t == null || t(Qt(u, gn.valueFormatString)), a(u);
      },
      onChange: () => {
      },
      onInput: (c) => i(c.currentTarget.value)
    }
  };
};
gn.valueFormatString = "yyyy-MM-dd";
gn.inputFormatString = "dd-MM-yyyy";
gn.monthValueFormatString = "yyyy-MM";
const rA = m.forwardRef(({ className: e, icon: t, ...n }, r) => /* @__PURE__ */ _(
  z1,
  {
    ref: r,
    containerClassName: e,
    icon: t,
    type: "text",
    placeholder: "dd-mm-yyyy",
    ...n
  }
)), oA = lw, iA = cw, sA = Q7, v$ = J7, aA = Y.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ _(uw, { children: /* @__PURE__ */ _(dw, { ...t, ref: n, children: e }) })), lA = R1, fw = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  P1,
  {
    ref: n,
    className: oe("text-sm font-medium text-foundations-boldest", e),
    "data-slot": "progress-value",
    ...t
  }
));
fw.displayName = "ProgressValue";
const hw = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  T1,
  {
    ref: n,
    className: oe("h-2 rounded-sm bg-foundations-subtlest", e),
    "data-slot": "progress-track",
    ...t
  }
));
hw.displayName = "ProgressTrack";
const pw = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  k1,
  {
    ref: n,
    className: oe("rounded-sm bg-info-bold", e),
    "data-slot": "progress-indicator",
    ...t
  }
));
pw.displayName = "ProgressIndicator";
const b$ = Object.assign(lA, {
  Label: I1,
  Track: hw,
  Indicator: pw,
  Value: fw
}), cA = GN, uA = E1, gw = Y.forwardRef(
  ({
    children: e,
    sideOffset: t = 4,
    align: n = "end",
    alignOffset: r = 0,
    side: o = "bottom",
    ...i
  }, s) => /* @__PURE__ */ _(S1, { children: /* @__PURE__ */ _(
    M1,
    {
      align: n,
      alignOffset: r,
      "data-slot": "popover-positioner",
      side: o,
      sideOffset: t,
      children: /* @__PURE__ */ _(O1, { ...i, ref: s, children: e })
    }
  ) })
);
gw.displayName = "PopoverPopup";
const y$ = Object.assign(cA, {
  Trigger: uA,
  Popup: gw
});
function dA(e, t, n = []) {
  m.useEffect(() => {
    const r = setTimeout(() => {
      e();
    }, t);
    return () => {
      clearTimeout(r);
    };
  }, [t, ...n]);
}
const mw = m.createContext(null), ur = () => {
  const e = m.useContext(mw);
  if (!e)
    throw new Error(
      "useDropdownSearchContext must be used within <DropdownSearch />"
    );
  return e;
};
function Xn(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function De() {
  return De = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, De.apply(this, arguments);
}
function vv(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Md(e, t) {
  return Md = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Md(e, t);
}
function fA(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Md(e, t);
}
var Od = { exports: {} }, Da = { exports: {} }, ot = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bv;
function hA() {
  if (bv)
    return ot;
  bv = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function w(x) {
    if (typeof x == "object" && x !== null) {
      var E = x.$$typeof;
      switch (E) {
        case t:
          switch (x = x.type, x) {
            case l:
            case c:
            case r:
            case i:
            case o:
            case d:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case a:
                case u:
                case p:
                case h:
                case s:
                  return x;
                default:
                  return E;
              }
          }
        case n:
          return E;
      }
    }
  }
  function C(x) {
    return w(x) === c;
  }
  return ot.AsyncMode = l, ot.ConcurrentMode = c, ot.ContextConsumer = a, ot.ContextProvider = s, ot.Element = t, ot.ForwardRef = u, ot.Fragment = r, ot.Lazy = p, ot.Memo = h, ot.Portal = n, ot.Profiler = i, ot.StrictMode = o, ot.Suspense = d, ot.isAsyncMode = function(x) {
    return C(x) || w(x) === l;
  }, ot.isConcurrentMode = C, ot.isContextConsumer = function(x) {
    return w(x) === a;
  }, ot.isContextProvider = function(x) {
    return w(x) === s;
  }, ot.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, ot.isForwardRef = function(x) {
    return w(x) === u;
  }, ot.isFragment = function(x) {
    return w(x) === r;
  }, ot.isLazy = function(x) {
    return w(x) === p;
  }, ot.isMemo = function(x) {
    return w(x) === h;
  }, ot.isPortal = function(x) {
    return w(x) === n;
  }, ot.isProfiler = function(x) {
    return w(x) === i;
  }, ot.isStrictMode = function(x) {
    return w(x) === o;
  }, ot.isSuspense = function(x) {
    return w(x) === d;
  }, ot.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === c || x === i || x === o || x === d || x === f || typeof x == "object" && x !== null && (x.$$typeof === p || x.$$typeof === h || x.$$typeof === s || x.$$typeof === a || x.$$typeof === u || x.$$typeof === v || x.$$typeof === y || x.$$typeof === b || x.$$typeof === g);
  }, ot.typeOf = w, ot;
}
var it = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yv;
function pA() {
  return yv || (yv = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function w(D) {
      return typeof D == "string" || typeof D == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      D === r || D === c || D === i || D === o || D === d || D === f || typeof D == "object" && D !== null && (D.$$typeof === p || D.$$typeof === h || D.$$typeof === s || D.$$typeof === a || D.$$typeof === u || D.$$typeof === v || D.$$typeof === y || D.$$typeof === b || D.$$typeof === g);
    }
    function C(D) {
      if (typeof D == "object" && D !== null) {
        var te = D.$$typeof;
        switch (te) {
          case t:
            var K = D.type;
            switch (K) {
              case l:
              case c:
              case r:
              case i:
              case o:
              case d:
                return K;
              default:
                var ce = K && K.$$typeof;
                switch (ce) {
                  case a:
                  case u:
                  case p:
                  case h:
                  case s:
                    return ce;
                  default:
                    return te;
                }
            }
          case n:
            return te;
        }
      }
    }
    var x = l, E = c, S = a, R = s, M = t, I = u, P = r, k = p, O = h, F = n, T = i, L = o, A = d, N = !1;
    function B(D) {
      return N || (N = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(D) || C(D) === l;
    }
    function $(D) {
      return C(D) === c;
    }
    function U(D) {
      return C(D) === a;
    }
    function G(D) {
      return C(D) === s;
    }
    function H(D) {
      return typeof D == "object" && D !== null && D.$$typeof === t;
    }
    function q(D) {
      return C(D) === u;
    }
    function j(D) {
      return C(D) === r;
    }
    function W(D) {
      return C(D) === p;
    }
    function z(D) {
      return C(D) === h;
    }
    function X(D) {
      return C(D) === n;
    }
    function J(D) {
      return C(D) === i;
    }
    function ne(D) {
      return C(D) === o;
    }
    function Q(D) {
      return C(D) === d;
    }
    it.AsyncMode = x, it.ConcurrentMode = E, it.ContextConsumer = S, it.ContextProvider = R, it.Element = M, it.ForwardRef = I, it.Fragment = P, it.Lazy = k, it.Memo = O, it.Portal = F, it.Profiler = T, it.StrictMode = L, it.Suspense = A, it.isAsyncMode = B, it.isConcurrentMode = $, it.isContextConsumer = U, it.isContextProvider = G, it.isElement = H, it.isForwardRef = q, it.isFragment = j, it.isLazy = W, it.isMemo = z, it.isPortal = X, it.isProfiler = J, it.isStrictMode = ne, it.isSuspense = Q, it.isValidElementType = w, it.typeOf = C;
  }()), it;
}
var xv;
function vw() {
  return xv || (xv = 1, process.env.NODE_ENV === "production" ? Da.exports = hA() : Da.exports = pA()), Da.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Eu, wv;
function gA() {
  if (wv)
    return Eu;
  wv = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Eu = o() ? Object.assign : function(i, s) {
    for (var a, l = r(i), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        t.call(a, d) && (l[d] = a[d]);
      if (e) {
        c = e(a);
        for (var f = 0; f < c.length; f++)
          n.call(a, c[f]) && (l[c[f]] = a[c[f]]);
      }
    }
    return l;
  }, Eu;
}
var Su, Cv;
function Fh() {
  if (Cv)
    return Su;
  Cv = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Su = e, Su;
}
var Mu, _v;
function bw() {
  return _v || (_v = 1, Mu = Function.call.bind(Object.prototype.hasOwnProperty)), Mu;
}
var Ou, Ev;
function mA() {
  if (Ev)
    return Ou;
  Ev = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Fh(), n = {}, r = bw();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(i, s, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (r(i, u)) {
          var d;
          try {
            if (typeof i[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = i[u](s, u, l, a, null, t);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            e(
              "Failed " + a + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Ou = o, Ou;
}
var Ru, Sv;
function vA() {
  if (Sv)
    return Ru;
  Sv = 1;
  var e = vw(), t = gA(), n = Fh(), r = bw(), o = mA(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Ru = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d($) {
      var U = $ && (c && $[c] || $[u]);
      if (typeof U == "function")
        return U;
    }
    var f = "<<anonymous>>", h = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: b(),
      arrayOf: w,
      element: C(),
      elementType: x(),
      instanceOf: E,
      node: I(),
      objectOf: R,
      oneOf: S,
      oneOfType: M,
      shape: k,
      exact: O
    };
    function p($, U) {
      return $ === U ? $ !== 0 || 1 / $ === 1 / U : $ !== $ && U !== U;
    }
    function g($, U) {
      this.message = $, this.data = U && typeof U == "object" ? U : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function v($) {
      if (process.env.NODE_ENV !== "production")
        var U = {}, G = 0;
      function H(j, W, z, X, J, ne, Q) {
        if (X = X || f, ne = ne || z, Q !== n) {
          if (l) {
            var D = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw D.name = "Invariant Violation", D;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var te = X + ":" + z;
            !U[te] && // Avoid spamming the console because they are often not actionable except for lib authors
            G < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + ne + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), U[te] = !0, G++);
          }
        }
        return W[z] == null ? j ? W[z] === null ? new g("The " + J + " `" + ne + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new g("The " + J + " `" + ne + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : $(W, z, X, J, ne);
      }
      var q = H.bind(null, !1);
      return q.isRequired = H.bind(null, !0), q;
    }
    function y($) {
      function U(G, H, q, j, W, z) {
        var X = G[H], J = L(X);
        if (J !== $) {
          var ne = A(X);
          return new g(
            "Invalid " + j + " `" + W + "` of type " + ("`" + ne + "` supplied to `" + q + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return v(U);
    }
    function b() {
      return v(s);
    }
    function w($) {
      function U(G, H, q, j, W) {
        if (typeof $ != "function")
          return new g("Property `" + W + "` of component `" + q + "` has invalid PropType notation inside arrayOf.");
        var z = G[H];
        if (!Array.isArray(z)) {
          var X = L(z);
          return new g("Invalid " + j + " `" + W + "` of type " + ("`" + X + "` supplied to `" + q + "`, expected an array."));
        }
        for (var J = 0; J < z.length; J++) {
          var ne = $(z, J, q, j, W + "[" + J + "]", n);
          if (ne instanceof Error)
            return ne;
        }
        return null;
      }
      return v(U);
    }
    function C() {
      function $(U, G, H, q, j) {
        var W = U[G];
        if (!a(W)) {
          var z = L(W);
          return new g("Invalid " + q + " `" + j + "` of type " + ("`" + z + "` supplied to `" + H + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v($);
    }
    function x() {
      function $(U, G, H, q, j) {
        var W = U[G];
        if (!e.isValidElementType(W)) {
          var z = L(W);
          return new g("Invalid " + q + " `" + j + "` of type " + ("`" + z + "` supplied to `" + H + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v($);
    }
    function E($) {
      function U(G, H, q, j, W) {
        if (!(G[H] instanceof $)) {
          var z = $.name || f, X = B(G[H]);
          return new g("Invalid " + j + " `" + W + "` of type " + ("`" + X + "` supplied to `" + q + "`, expected ") + ("instance of `" + z + "`."));
        }
        return null;
      }
      return v(U);
    }
    function S($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function U(G, H, q, j, W) {
        for (var z = G[H], X = 0; X < $.length; X++)
          if (p(z, $[X]))
            return null;
        var J = JSON.stringify($, function(Q, D) {
          var te = A(D);
          return te === "symbol" ? String(D) : D;
        });
        return new g("Invalid " + j + " `" + W + "` of value `" + String(z) + "` " + ("supplied to `" + q + "`, expected one of " + J + "."));
      }
      return v(U);
    }
    function R($) {
      function U(G, H, q, j, W) {
        if (typeof $ != "function")
          return new g("Property `" + W + "` of component `" + q + "` has invalid PropType notation inside objectOf.");
        var z = G[H], X = L(z);
        if (X !== "object")
          return new g("Invalid " + j + " `" + W + "` of type " + ("`" + X + "` supplied to `" + q + "`, expected an object."));
        for (var J in z)
          if (r(z, J)) {
            var ne = $(z, J, q, j, W + "." + J, n);
            if (ne instanceof Error)
              return ne;
          }
        return null;
      }
      return v(U);
    }
    function M($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var U = 0; U < $.length; U++) {
        var G = $[U];
        if (typeof G != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + N(G) + " at index " + U + "."
          ), s;
      }
      function H(q, j, W, z, X) {
        for (var J = [], ne = 0; ne < $.length; ne++) {
          var Q = $[ne], D = Q(q, j, W, z, X, n);
          if (D == null)
            return null;
          D.data && r(D.data, "expectedType") && J.push(D.data.expectedType);
        }
        var te = J.length > 0 ? ", expected one of type [" + J.join(", ") + "]" : "";
        return new g("Invalid " + z + " `" + X + "` supplied to " + ("`" + W + "`" + te + "."));
      }
      return v(H);
    }
    function I() {
      function $(U, G, H, q, j) {
        return F(U[G]) ? null : new g("Invalid " + q + " `" + j + "` supplied to " + ("`" + H + "`, expected a ReactNode."));
      }
      return v($);
    }
    function P($, U, G, H, q) {
      return new g(
        ($ || "React class") + ": " + U + " type `" + G + "." + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + q + "`."
      );
    }
    function k($) {
      function U(G, H, q, j, W) {
        var z = G[H], X = L(z);
        if (X !== "object")
          return new g("Invalid " + j + " `" + W + "` of type `" + X + "` " + ("supplied to `" + q + "`, expected `object`."));
        for (var J in $) {
          var ne = $[J];
          if (typeof ne != "function")
            return P(q, j, W, J, A(ne));
          var Q = ne(z, J, q, j, W + "." + J, n);
          if (Q)
            return Q;
        }
        return null;
      }
      return v(U);
    }
    function O($) {
      function U(G, H, q, j, W) {
        var z = G[H], X = L(z);
        if (X !== "object")
          return new g("Invalid " + j + " `" + W + "` of type `" + X + "` " + ("supplied to `" + q + "`, expected `object`."));
        var J = t({}, G[H], $);
        for (var ne in J) {
          var Q = $[ne];
          if (r($, ne) && typeof Q != "function")
            return P(q, j, W, ne, A(Q));
          if (!Q)
            return new g(
              "Invalid " + j + " `" + W + "` key `" + ne + "` supplied to `" + q + "`.\nBad object: " + JSON.stringify(G[H], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var D = Q(z, ne, q, j, W + "." + ne, n);
          if (D)
            return D;
        }
        return null;
      }
      return v(U);
    }
    function F($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(F);
          if ($ === null || a($))
            return !0;
          var U = d($);
          if (U) {
            var G = U.call($), H;
            if (U !== $.entries) {
              for (; !(H = G.next()).done; )
                if (!F(H.value))
                  return !1;
            } else
              for (; !(H = G.next()).done; ) {
                var q = H.value;
                if (q && !F(q[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function T($, U) {
      return $ === "symbol" ? !0 : U ? U["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && U instanceof Symbol : !1;
    }
    function L($) {
      var U = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : T(U, $) ? "symbol" : U;
    }
    function A($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var U = L($);
      if (U === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return U;
    }
    function N($) {
      var U = A($);
      switch (U) {
        case "array":
        case "object":
          return "an " + U;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + U;
        default:
          return U;
      }
    }
    function B($) {
      return !$.constructor || !$.constructor.name ? f : $.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, Ru;
}
var Tu, Mv;
function bA() {
  if (Mv)
    return Tu;
  Mv = 1;
  var e = Fh();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Tu = function() {
    function r(s, a, l, c, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Tu;
}
if (process.env.NODE_ENV !== "production") {
  var yA = vw(), xA = !0;
  Od.exports = vA()(yA.isElement, xA);
} else
  Od.exports = bA()();
var wA = Od.exports;
const ue = /* @__PURE__ */ JC(wA);
var Rd = { exports: {} }, ft = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ov;
function CA() {
  if (Ov)
    return ft;
  Ov = 1;
  var e = 60103, t = 60106, n = 60107, r = 60108, o = 60114, i = 60109, s = 60110, a = 60112, l = 60113, c = 60120, u = 60115, d = 60116, f = 60121, h = 60122, p = 60117, g = 60129, v = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var y = Symbol.for;
    e = y("react.element"), t = y("react.portal"), n = y("react.fragment"), r = y("react.strict_mode"), o = y("react.profiler"), i = y("react.provider"), s = y("react.context"), a = y("react.forward_ref"), l = y("react.suspense"), c = y("react.suspense_list"), u = y("react.memo"), d = y("react.lazy"), f = y("react.block"), h = y("react.server.block"), p = y("react.fundamental"), g = y("react.debug_trace_mode"), v = y("react.legacy_hidden");
  }
  function b(O) {
    if (typeof O == "object" && O !== null) {
      var F = O.$$typeof;
      switch (F) {
        case e:
          switch (O = O.type, O) {
            case n:
            case o:
            case r:
            case l:
            case c:
              return O;
            default:
              switch (O = O && O.$$typeof, O) {
                case s:
                case a:
                case d:
                case u:
                case i:
                  return O;
                default:
                  return F;
              }
          }
        case t:
          return F;
      }
    }
  }
  var w = i, C = e, x = a, E = n, S = d, R = u, M = t, I = o, P = r, k = l;
  return ft.ContextConsumer = s, ft.ContextProvider = w, ft.Element = C, ft.ForwardRef = x, ft.Fragment = E, ft.Lazy = S, ft.Memo = R, ft.Portal = M, ft.Profiler = I, ft.StrictMode = P, ft.Suspense = k, ft.isAsyncMode = function() {
    return !1;
  }, ft.isConcurrentMode = function() {
    return !1;
  }, ft.isContextConsumer = function(O) {
    return b(O) === s;
  }, ft.isContextProvider = function(O) {
    return b(O) === i;
  }, ft.isElement = function(O) {
    return typeof O == "object" && O !== null && O.$$typeof === e;
  }, ft.isForwardRef = function(O) {
    return b(O) === a;
  }, ft.isFragment = function(O) {
    return b(O) === n;
  }, ft.isLazy = function(O) {
    return b(O) === d;
  }, ft.isMemo = function(O) {
    return b(O) === u;
  }, ft.isPortal = function(O) {
    return b(O) === t;
  }, ft.isProfiler = function(O) {
    return b(O) === o;
  }, ft.isStrictMode = function(O) {
    return b(O) === r;
  }, ft.isSuspense = function(O) {
    return b(O) === l;
  }, ft.isValidElementType = function(O) {
    return typeof O == "string" || typeof O == "function" || O === n || O === o || O === g || O === r || O === l || O === c || O === v || typeof O == "object" && O !== null && (O.$$typeof === d || O.$$typeof === u || O.$$typeof === i || O.$$typeof === s || O.$$typeof === a || O.$$typeof === p || O.$$typeof === f || O[0] === h);
  }, ft.typeOf = b, ft;
}
var ht = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rv;
function _A() {
  return Rv || (Rv = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, n = 60107, r = 60108, o = 60114, i = 60109, s = 60110, a = 60112, l = 60113, c = 60120, u = 60115, d = 60116, f = 60121, h = 60122, p = 60117, g = 60129, v = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var y = Symbol.for;
      e = y("react.element"), t = y("react.portal"), n = y("react.fragment"), r = y("react.strict_mode"), o = y("react.profiler"), i = y("react.provider"), s = y("react.context"), a = y("react.forward_ref"), l = y("react.suspense"), c = y("react.suspense_list"), u = y("react.memo"), d = y("react.lazy"), f = y("react.block"), h = y("react.server.block"), p = y("react.fundamental"), y("react.scope"), y("react.opaque.id"), g = y("react.debug_trace_mode"), y("react.offscreen"), v = y("react.legacy_hidden");
    }
    var b = !1;
    function w(Q) {
      return !!(typeof Q == "string" || typeof Q == "function" || Q === n || Q === o || Q === g || Q === r || Q === l || Q === c || Q === v || b || typeof Q == "object" && Q !== null && (Q.$$typeof === d || Q.$$typeof === u || Q.$$typeof === i || Q.$$typeof === s || Q.$$typeof === a || Q.$$typeof === p || Q.$$typeof === f || Q[0] === h));
    }
    function C(Q) {
      if (typeof Q == "object" && Q !== null) {
        var D = Q.$$typeof;
        switch (D) {
          case e:
            var te = Q.type;
            switch (te) {
              case n:
              case o:
              case r:
              case l:
              case c:
                return te;
              default:
                var K = te && te.$$typeof;
                switch (K) {
                  case s:
                  case a:
                  case d:
                  case u:
                  case i:
                    return K;
                  default:
                    return D;
                }
            }
          case t:
            return D;
        }
      }
    }
    var x = s, E = i, S = e, R = a, M = n, I = d, P = u, k = t, O = o, F = r, T = l, L = !1, A = !1;
    function N(Q) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function B(Q) {
      return A || (A = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function $(Q) {
      return C(Q) === s;
    }
    function U(Q) {
      return C(Q) === i;
    }
    function G(Q) {
      return typeof Q == "object" && Q !== null && Q.$$typeof === e;
    }
    function H(Q) {
      return C(Q) === a;
    }
    function q(Q) {
      return C(Q) === n;
    }
    function j(Q) {
      return C(Q) === d;
    }
    function W(Q) {
      return C(Q) === u;
    }
    function z(Q) {
      return C(Q) === t;
    }
    function X(Q) {
      return C(Q) === o;
    }
    function J(Q) {
      return C(Q) === r;
    }
    function ne(Q) {
      return C(Q) === l;
    }
    ht.ContextConsumer = x, ht.ContextProvider = E, ht.Element = S, ht.ForwardRef = R, ht.Fragment = M, ht.Lazy = I, ht.Memo = P, ht.Portal = k, ht.Profiler = O, ht.StrictMode = F, ht.Suspense = T, ht.isAsyncMode = N, ht.isConcurrentMode = B, ht.isContextConsumer = $, ht.isContextProvider = U, ht.isElement = G, ht.isForwardRef = H, ht.isFragment = q, ht.isLazy = j, ht.isMemo = W, ht.isPortal = z, ht.isProfiler = X, ht.isStrictMode = J, ht.isSuspense = ne, ht.isValidElementType = w, ht.typeOf = C;
  }()), ht;
}
process.env.NODE_ENV === "production" ? Rd.exports = CA() : Rd.exports = _A();
var Tv = Rd.exports;
let kv = (e) => typeof e == "object" && e != null && e.nodeType === 1, Pv = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", ku = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    let n = getComputedStyle(e, null);
    return Pv(n.overflowY, t) || Pv(n.overflowX, t) || ((r) => {
      let o = ((i) => {
        if (!i.ownerDocument || !i.ownerDocument.defaultView)
          return null;
        try {
          return i.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!o && (o.clientHeight < r.scrollHeight || o.clientWidth < r.scrollWidth);
    })(e);
  }
  return !1;
}, Aa = (e, t, n, r, o, i, s, a) => i < e && s > t || i > e && s < t ? 0 : i <= e && a <= n || s >= t && a >= n ? i - e - r : s > t && a < n || i < e && a > n ? s - t + o : 0, EA = (e) => {
  let t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
};
var SA = (e, t) => {
  var n, r, o, i, s, a;
  if (typeof document > "u")
    return [];
  let { scrollMode: l, block: c, inline: u, boundary: d, skipOverflowHiddenElements: f } = t, h = typeof d == "function" ? d : (F) => F !== d;
  if (!kv(e))
    throw new TypeError("Invalid target");
  let p = document.scrollingElement || document.documentElement, g = [], v = e;
  for (; kv(v) && h(v); ) {
    if (v = EA(v), v === p) {
      g.push(v);
      break;
    }
    v != null && v === document.body && ku(v) && !ku(document.documentElement) || v != null && ku(v, f) && g.push(v);
  }
  let y = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, b = (i = (o = window.visualViewport) == null ? void 0 : o.height) != null ? i : innerHeight, w = (s = window.scrollX) != null ? s : pageXOffset, C = (a = window.scrollY) != null ? a : pageYOffset, { height: x, width: E, top: S, right: R, bottom: M, left: I } = e.getBoundingClientRect(), P = c === "start" || c === "nearest" ? S : c === "end" ? M : S + x / 2, k = u === "center" ? I + E / 2 : u === "end" ? R : I, O = [];
  for (let F = 0; F < g.length; F++) {
    let T = g[F], { height: L, width: A, top: N, right: B, bottom: $, left: U } = T.getBoundingClientRect();
    if (l === "if-needed" && S >= 0 && I >= 0 && M <= b && R <= y && S >= N && M <= $ && I >= U && R <= B)
      return O;
    let G = getComputedStyle(T), H = parseInt(G.borderLeftWidth, 10), q = parseInt(G.borderTopWidth, 10), j = parseInt(G.borderRightWidth, 10), W = parseInt(G.borderBottomWidth, 10), z = 0, X = 0, J = "offsetWidth" in T ? T.offsetWidth - T.clientWidth - H - j : 0, ne = "offsetHeight" in T ? T.offsetHeight - T.clientHeight - q - W : 0, Q = "offsetWidth" in T ? T.offsetWidth === 0 ? 0 : A / T.offsetWidth : 0, D = "offsetHeight" in T ? T.offsetHeight === 0 ? 0 : L / T.offsetHeight : 0;
    if (p === T)
      z = c === "start" ? P : c === "end" ? P - b : c === "nearest" ? Aa(C, C + b, b, q, W, C + P, C + P + x, x) : P - b / 2, X = u === "start" ? k : u === "center" ? k - y / 2 : u === "end" ? k - y : Aa(w, w + y, y, H, j, w + k, w + k + E, E), z = Math.max(0, z + C), X = Math.max(0, X + w);
    else {
      z = c === "start" ? P - N - q : c === "end" ? P - $ + W + ne : c === "nearest" ? Aa(N, $, L, q, W + ne, P, P + x, x) : P - (N + L / 2) + ne / 2, X = u === "start" ? k - U - H : u === "center" ? k - (U + A / 2) + J / 2 : u === "end" ? k - B + j + J : Aa(U, B, A, H, j + J, k, k + E, E);
      let { scrollLeft: te, scrollTop: K } = T;
      z = Math.max(0, Math.min(K + z / D, T.scrollHeight - L / D + ne)), X = Math.max(0, Math.min(te + X / Q, T.scrollWidth - A / Q + J)), P += K - z, k += te - X;
    }
    O.push({ el: T, top: z, left: X });
  }
  return O;
}, MA = 0;
function Iv(e) {
  return typeof e == "function" ? e : Mn;
}
function Mn() {
}
function yw(e, t) {
  if (e) {
    var n = SA(e, {
      boundary: t,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function(r) {
      var o = r.el, i = r.top, s = r.left;
      o.scrollTop = i, o.scrollLeft = s;
    });
  }
}
function Nv(e, t, n) {
  var r = e === t || t instanceof n.Node && e.contains && e.contains(t);
  return r;
}
function Vh(e, t) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function o() {
    for (var i = arguments.length, s = new Array(i), a = 0; a < i; a++)
      s[a] = arguments[a];
    r(), n = setTimeout(function() {
      n = null, e.apply(void 0, s);
    }, t);
  }
  return o.cancel = r, o;
}
function zt() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
      i[s - 1] = arguments[s];
    return t.some(function(a) {
      return a && a.apply(void 0, [r].concat(i)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function Xo() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    t.forEach(function(o) {
      typeof o == "function" ? o(r) : o && (o.current = r);
    });
  };
}
function xw() {
  return String(MA++);
}
function ww(e) {
  var t = e.isOpen, n = e.resultCount, r = e.previousResultCount;
  return t ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function Dv(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function Cw(e) {
  return typeof e.type == "string";
}
function _w(e) {
  return e.props;
}
function OA(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var RA = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function La(e) {
  e === void 0 && (e = {});
  var t = {};
  return RA.forEach(function(n) {
    e.hasOwnProperty(n) && (t[n] = e[n]);
  }), t;
}
function Fl(e, t) {
  return Object.keys(e).reduce(function(n, r) {
    return n[r] = Vl(t, r) ? t[r] : e[r], n;
  }, {});
}
function Vl(e, t) {
  return e[t] !== void 0;
}
function Td(e) {
  var t = e.key, n = e.keyCode;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function TA(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function mo(e, t, n, r, o) {
  o === void 0 && (o = !1);
  var i = n.length;
  if (i === 0)
    return -1;
  var s = i - 1;
  (typeof e != "number" || e < 0 || e > s) && (e = t > 0 ? -1 : s + 1);
  var a = e + t;
  a < 0 ? a = o ? s : 0 : a > s && (a = o ? 0 : s);
  var l = yi(a, t < 0, n, r, o);
  return l === -1 ? e >= i ? -1 : e : l;
}
function yi(e, t, n, r, o) {
  o === void 0 && (o = !1);
  var i = n.length;
  if (t) {
    for (var s = e; s >= 0; s--)
      if (!r(n[s], s))
        return s;
  } else
    for (var a = e; a < i; a++)
      if (!r(n[a], a))
        return a;
  return o ? yi(t ? i - 1 : 0, t, n, r) : -1;
}
function Bl(e, t, n, r) {
  return r === void 0 && (r = !0), t.some(function(o) {
    return o && (Nv(o, e, n) || r && Nv(o, n.document.activeElement, n));
  });
}
var Bh = Mn;
process.env.NODE_ENV !== "production" && (Bh = function(t, n, r) {
  var o = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(t).forEach(function(i) {
    n[i] !== void 0 && r[i] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + i + '" to be uncontrolled. ' + o) : n[i] === void 0 && r[i] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + i + '" to be controlled. ' + o);
  });
});
var kA = Vh(function(e) {
  Sw(e).textContent = "";
}, 500);
function Ew(e, t) {
  var n = Sw(t);
  e && (n.textContent = e, kA(t));
}
function Sw(e) {
  e === void 0 && (e = document);
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
var Mw = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, Ow = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, Rw = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, el = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, tl = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Tw = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, kw = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, Pw = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, Iw = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, Nw = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, Dw = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, Aw = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, Lw = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, kd = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, $w = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, Fw = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, Vw = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, PA = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: Mw,
  mouseUp: Ow,
  itemMouseEnter: Rw,
  keyDownArrowUp: el,
  keyDownArrowDown: tl,
  keyDownEscape: Tw,
  keyDownEnter: kw,
  keyDownHome: Pw,
  keyDownEnd: Iw,
  clickItem: Nw,
  blurInput: Dw,
  changeInput: Aw,
  keyDownSpaceButton: Lw,
  clickButton: kd,
  blurButton: $w,
  controlledPropUpdatedSelectedItem: Fw,
  touchEnd: Vw
}), IA = ["refKey", "ref"], NA = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], DA = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], AA = ["refKey", "ref"], LA = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], $A = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    fA(n, t);
    function n(o) {
      var i;
      i = t.call(this, o) || this, i.id = i.props.id || "downshift-" + xw(), i.menuId = i.props.menuId || i.id + "-menu", i.labelId = i.props.labelId || i.id + "-label", i.inputId = i.props.inputId || i.id + "-input", i.getItemId = i.props.getItemId || function(b) {
        return i.id + "-item-" + b;
      }, i.input = null, i.items = [], i.itemCount = null, i.previousResultCount = 0, i.timeoutIds = [], i.internalSetTimeout = function(b, w) {
        var C = setTimeout(function() {
          i.timeoutIds = i.timeoutIds.filter(function(x) {
            return x !== C;
          }), b();
        }, w);
        i.timeoutIds.push(C);
      }, i.setItemCount = function(b) {
        i.itemCount = b;
      }, i.unsetItemCount = function() {
        i.itemCount = null;
      }, i.isItemDisabled = function(b, w) {
        var C = i.getItemNodeFromIndex(w);
        return C && C.hasAttribute("disabled");
      }, i.setHighlightedIndex = function(b, w) {
        b === void 0 && (b = i.props.defaultHighlightedIndex), w === void 0 && (w = {}), w = La(w), i.internalSetState(De({
          highlightedIndex: b
        }, w));
      }, i.clearSelection = function(b) {
        i.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: i.props.defaultHighlightedIndex,
          isOpen: i.props.defaultIsOpen
        }, b);
      }, i.selectItem = function(b, w, C) {
        w = La(w), i.internalSetState(De({
          isOpen: i.props.defaultIsOpen,
          highlightedIndex: i.props.defaultHighlightedIndex,
          selectedItem: b,
          inputValue: i.props.itemToString(b)
        }, w), C);
      }, i.selectItemAtIndex = function(b, w, C) {
        var x = i.items[b];
        x != null && i.selectItem(x, w, C);
      }, i.selectHighlightedItem = function(b, w) {
        return i.selectItemAtIndex(i.getState().highlightedIndex, b, w);
      }, i.internalSetState = function(b, w) {
        var C, x, E = {}, S = typeof b == "function";
        return !S && b.hasOwnProperty("inputValue") && i.props.onInputValueChange(b.inputValue, De({}, i.getStateAndHelpers(), b)), i.setState(function(R) {
          R = i.getState(R);
          var M = S ? b(R) : b;
          M = i.props.stateReducer(R, M), C = M.hasOwnProperty("selectedItem");
          var I = {};
          return C && M.selectedItem !== R.selectedItem && (x = M.selectedItem), M.type = M.type || Mw, Object.keys(M).forEach(function(P) {
            R[P] !== M[P] && (E[P] = M[P]), P !== "type" && (M[P], Vl(i.props, P) || (I[P] = M[P]));
          }), S && M.hasOwnProperty("inputValue") && i.props.onInputValueChange(M.inputValue, De({}, i.getStateAndHelpers(), M)), I;
        }, function() {
          Iv(w)();
          var R = Object.keys(E).length > 1;
          R && i.props.onStateChange(E, i.getStateAndHelpers()), C && i.props.onSelect(b.selectedItem, i.getStateAndHelpers()), x !== void 0 && i.props.onChange(x, i.getStateAndHelpers()), i.props.onUserAction(E, i.getStateAndHelpers());
        });
      }, i.rootRef = function(b) {
        return i._rootNode = b;
      }, i.getRootProps = function(b, w) {
        var C, x = b === void 0 ? {} : b, E = x.refKey, S = E === void 0 ? "ref" : E, R = x.ref, M = Xn(x, IA), I = w === void 0 ? {} : w, P = I.suppressRefError, k = P === void 0 ? !1 : P;
        i.getRootProps.called = !0, i.getRootProps.refKey = S, i.getRootProps.suppressRefError = k;
        var O = i.getState(), F = O.isOpen;
        return De((C = {}, C[S] = Xo(R, i.rootRef), C.role = "combobox", C["aria-expanded"] = F, C["aria-haspopup"] = "listbox", C["aria-owns"] = F ? i.menuId : void 0, C["aria-labelledby"] = i.labelId, C), M);
      }, i.keyDownHandlers = {
        ArrowDown: function(w) {
          var C = this;
          if (w.preventDefault(), this.getState().isOpen) {
            var x = w.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(x, {
              type: tl
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: tl
            }, function() {
              var E = C.getItemCount();
              if (E > 0) {
                var S = C.getState(), R = S.highlightedIndex, M = mo(R, 1, {
                  length: E
                }, C.isItemDisabled, !0);
                C.setHighlightedIndex(M, {
                  type: tl
                });
              }
            });
        },
        ArrowUp: function(w) {
          var C = this;
          if (w.preventDefault(), this.getState().isOpen) {
            var x = w.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(x, {
              type: el
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: el
            }, function() {
              var E = C.getItemCount();
              if (E > 0) {
                var S = C.getState(), R = S.highlightedIndex, M = mo(R, -1, {
                  length: E
                }, C.isItemDisabled, !0);
                C.setHighlightedIndex(M, {
                  type: el
                });
              }
            });
        },
        Enter: function(w) {
          if (w.which !== 229) {
            var C = this.getState(), x = C.isOpen, E = C.highlightedIndex;
            if (x && E != null) {
              w.preventDefault();
              var S = this.items[E], R = this.getItemNodeFromIndex(E);
              if (S == null || R && R.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: kw
              });
            }
          }
        },
        Escape: function(w) {
          w.preventDefault(), this.reset(De({
            type: Tw
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, i.buttonKeyDownHandlers = De({}, i.keyDownHandlers, {
        " ": function(w) {
          w.preventDefault(), this.toggleMenu({
            type: Lw
          });
        }
      }), i.inputKeyDownHandlers = De({}, i.keyDownHandlers, {
        Home: function(w) {
          var C = this.getState(), x = C.isOpen;
          if (x) {
            w.preventDefault();
            var E = this.getItemCount();
            if (!(E <= 0 || !x)) {
              var S = yi(0, !1, {
                length: E
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: Pw
              });
            }
          }
        },
        End: function(w) {
          var C = this.getState(), x = C.isOpen;
          if (x) {
            w.preventDefault();
            var E = this.getItemCount();
            if (!(E <= 0 || !x)) {
              var S = yi(E - 1, !0, {
                length: E
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: Iw
              });
            }
          }
        }
      }), i.getToggleButtonProps = function(b) {
        var w = b === void 0 ? {} : b, C = w.onClick;
        w.onPress;
        var x = w.onKeyDown, E = w.onKeyUp, S = w.onBlur, R = Xn(w, NA), M = i.getState(), I = M.isOpen, P = {
          onClick: zt(C, i.buttonHandleClick),
          onKeyDown: zt(x, i.buttonHandleKeyDown),
          onKeyUp: zt(E, i.buttonHandleKeyUp),
          onBlur: zt(S, i.buttonHandleBlur)
        }, k = R.disabled ? {} : P;
        return De({
          type: "button",
          role: "button",
          "aria-label": I ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, k, R);
      }, i.buttonHandleKeyUp = function(b) {
        b.preventDefault();
      }, i.buttonHandleKeyDown = function(b) {
        var w = Td(b);
        i.buttonKeyDownHandlers[w] && i.buttonKeyDownHandlers[w].call(vv(i), b);
      }, i.buttonHandleClick = function(b) {
        b.preventDefault(), i.props.environment.document.activeElement === i.props.environment.document.body && b.target.focus(), process.env.NODE_ENV === "test" ? i.toggleMenu({
          type: kd
        }) : i.internalSetTimeout(function() {
          return i.toggleMenu({
            type: kd
          });
        });
      }, i.buttonHandleBlur = function(b) {
        var w = b.target;
        i.internalSetTimeout(function() {
          !i.isMouseDown && (i.props.environment.document.activeElement == null || i.props.environment.document.activeElement.id !== i.inputId) && i.props.environment.document.activeElement !== w && i.reset({
            type: $w
          });
        });
      }, i.getLabelProps = function(b) {
        return De({
          htmlFor: i.inputId,
          id: i.labelId
        }, b);
      }, i.getInputProps = function(b) {
        var w = b === void 0 ? {} : b, C = w.onKeyDown, x = w.onBlur, E = w.onChange, S = w.onInput;
        w.onChangeText;
        var R = Xn(w, DA), M, I = {};
        M = "onChange";
        var P = i.getState(), k = P.inputValue, O = P.isOpen, F = P.highlightedIndex;
        if (!R.disabled) {
          var T;
          I = (T = {}, T[M] = zt(E, S, i.inputHandleChange), T.onKeyDown = zt(C, i.inputHandleKeyDown), T.onBlur = zt(x, i.inputHandleBlur), T);
        }
        return De({
          "aria-autocomplete": "list",
          "aria-activedescendant": O && typeof F == "number" && F >= 0 ? i.getItemId(F) : void 0,
          "aria-controls": O ? i.menuId : void 0,
          "aria-labelledby": R && R["aria-label"] ? void 0 : i.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: k,
          id: i.inputId
        }, I, R);
      }, i.inputHandleKeyDown = function(b) {
        var w = Td(b);
        w && i.inputKeyDownHandlers[w] && i.inputKeyDownHandlers[w].call(vv(i), b);
      }, i.inputHandleChange = function(b) {
        i.internalSetState({
          type: Aw,
          isOpen: !0,
          inputValue: b.target.value,
          highlightedIndex: i.props.defaultHighlightedIndex
        });
      }, i.inputHandleBlur = function() {
        i.internalSetTimeout(function() {
          var b = i.props.environment.document && !!i.props.environment.document.activeElement && !!i.props.environment.document.activeElement.dataset && i.props.environment.document.activeElement.dataset.toggle && i._rootNode && i._rootNode.contains(i.props.environment.document.activeElement);
          !i.isMouseDown && !b && i.reset({
            type: Dw
          });
        });
      }, i.menuRef = function(b) {
        i._menuNode = b;
      }, i.getMenuProps = function(b, w) {
        var C, x = b === void 0 ? {} : b, E = x.refKey, S = E === void 0 ? "ref" : E, R = x.ref, M = Xn(x, AA), I = w === void 0 ? {} : w, P = I.suppressRefError, k = P === void 0 ? !1 : P;
        return i.getMenuProps.called = !0, i.getMenuProps.refKey = S, i.getMenuProps.suppressRefError = k, De((C = {}, C[S] = Xo(R, i.menuRef), C.role = "listbox", C["aria-labelledby"] = M && M["aria-label"] ? void 0 : i.labelId, C.id = i.menuId, C), M);
      }, i.getItemProps = function(b) {
        var w, C = b === void 0 ? {} : b, x = C.onMouseMove, E = C.onMouseDown, S = C.onClick;
        C.onPress;
        var R = C.index, M = C.item, I = M === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : OA("getItemProps", "item") : M, P = Xn(C, LA);
        R === void 0 ? (i.items.push(I), R = i.items.indexOf(I)) : i.items[R] = I;
        var k = "onClick", O = S, F = (w = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: zt(x, function() {
            R !== i.getState().highlightedIndex && (i.setHighlightedIndex(R, {
              type: Rw
            }), i.avoidScrolling = !0, i.internalSetTimeout(function() {
              return i.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: zt(E, function(L) {
            L.preventDefault();
          })
        }, w[k] = zt(O, function() {
          i.selectItemAtIndex(R, {
            type: Nw
          });
        }), w), T = P.disabled ? {
          onMouseDown: F.onMouseDown
        } : F;
        return De({
          id: i.getItemId(R),
          role: "option",
          "aria-selected": i.getState().highlightedIndex === R
        }, T, P);
      }, i.clearItems = function() {
        i.items = [];
      }, i.reset = function(b, w) {
        b === void 0 && (b = {}), b = La(b), i.internalSetState(function(C) {
          var x = C.selectedItem;
          return De({
            isOpen: i.props.defaultIsOpen,
            highlightedIndex: i.props.defaultHighlightedIndex,
            inputValue: i.props.itemToString(x)
          }, b);
        }, w);
      }, i.toggleMenu = function(b, w) {
        b === void 0 && (b = {}), b = La(b), i.internalSetState(function(C) {
          var x = C.isOpen;
          return De({
            isOpen: !x
          }, x && {
            highlightedIndex: i.props.defaultHighlightedIndex
          }, b);
        }, function() {
          var C = i.getState(), x = C.isOpen, E = C.highlightedIndex;
          x && i.getItemCount() > 0 && typeof E == "number" && i.setHighlightedIndex(E, b), Iv(w)();
        });
      }, i.openMenu = function(b) {
        i.internalSetState({
          isOpen: !0
        }, b);
      }, i.closeMenu = function(b) {
        i.internalSetState({
          isOpen: !1
        }, b);
      }, i.updateStatus = Vh(function() {
        var b = i.getState(), w = i.items[b.highlightedIndex], C = i.getItemCount(), x = i.props.getA11yStatusMessage(De({
          itemToString: i.props.itemToString,
          previousResultCount: i.previousResultCount,
          resultCount: C,
          highlightedItem: w
        }, b));
        i.previousResultCount = C, Ew(x, i.props.environment.document);
      }, 200);
      var s = i.props, a = s.defaultHighlightedIndex, l = s.initialHighlightedIndex, c = l === void 0 ? a : l, u = s.defaultIsOpen, d = s.initialIsOpen, f = d === void 0 ? u : d, h = s.initialInputValue, p = h === void 0 ? "" : h, g = s.initialSelectedItem, v = g === void 0 ? null : g, y = i.getState({
        highlightedIndex: c,
        isOpen: f,
        inputValue: p,
        selectedItem: v
      });
      return y.selectedItem != null && i.props.initialInputValue === void 0 && (y.inputValue = i.props.itemToString(y.selectedItem)), i.state = y, i;
    }
    var r = n.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(i) {
        clearTimeout(i);
      }), this.timeoutIds = [];
    }, r.getState = function(i) {
      return i === void 0 && (i = this.state), Fl(i, this.props);
    }, r.getItemCount = function() {
      var i = this.items.length;
      return this.itemCount != null ? i = this.itemCount : this.props.itemCount !== void 0 && (i = this.props.itemCount), i;
    }, r.getItemNodeFromIndex = function(i) {
      return this.props.environment.document.getElementById(this.getItemId(i));
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var i = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(i, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(i, s) {
      var a = this.getItemCount(), l = this.getState(), c = l.highlightedIndex;
      if (a > 0) {
        var u = mo(c, i, {
          length: a
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(u, s);
      }
    }, r.getStateAndHelpers = function() {
      var i = this.getState(), s = i.highlightedIndex, a = i.inputValue, l = i.selectedItem, c = i.isOpen, u = this.props.itemToString, d = this.id, f = this.getRootProps, h = this.getToggleButtonProps, p = this.getLabelProps, g = this.getMenuProps, v = this.getInputProps, y = this.getItemProps, b = this.openMenu, w = this.closeMenu, C = this.toggleMenu, x = this.selectItem, E = this.selectItemAtIndex, S = this.selectHighlightedItem, R = this.setHighlightedIndex, M = this.clearSelection, I = this.clearItems, P = this.reset, k = this.setItemCount, O = this.unsetItemCount, F = this.internalSetState;
      return {
        // prop getters
        getRootProps: f,
        getToggleButtonProps: h,
        getLabelProps: p,
        getMenuProps: g,
        getInputProps: v,
        getItemProps: y,
        // actions
        reset: P,
        openMenu: b,
        closeMenu: w,
        toggleMenu: C,
        selectItem: x,
        selectItemAtIndex: E,
        selectHighlightedItem: S,
        setHighlightedIndex: R,
        clearSelection: M,
        clearItems: I,
        setItemCount: k,
        unsetItemCount: O,
        setState: F,
        // props
        itemToString: u,
        // derived
        id: d,
        // state
        highlightedIndex: s,
        inputValue: a,
        isOpen: c,
        selectedItem: l
      };
    }, r.componentDidMount = function() {
      var i = this;
      process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && Av(this._menuNode, this.getMenuProps);
      {
        var s = function() {
          i.isMouseDown = !0;
        }, a = function(h) {
          i.isMouseDown = !1;
          var p = Bl(h.target, [i._rootNode, i._menuNode], i.props.environment);
          !p && i.getState().isOpen && i.reset({
            type: Ow
          }, function() {
            return i.props.onOuterClick(i.getStateAndHelpers());
          });
        }, l = function() {
          i.isTouchMove = !1;
        }, c = function() {
          i.isTouchMove = !0;
        }, u = function(h) {
          var p = Bl(h.target, [i._rootNode, i._menuNode], i.props.environment, !1);
          !i.isTouchMove && !p && i.getState().isOpen && i.reset({
            type: Vw
          }, function() {
            return i.props.onOuterClick(i.getStateAndHelpers());
          });
        }, d = this.props.environment;
        d.addEventListener("mousedown", s), d.addEventListener("mouseup", a), d.addEventListener("touchstart", l), d.addEventListener("touchmove", c), d.addEventListener("touchend", u), this.cleanup = function() {
          i.internalClearTimeouts(), i.updateStatus.cancel(), d.removeEventListener("mousedown", s), d.removeEventListener("mouseup", a), d.removeEventListener("touchstart", l), d.removeEventListener("touchmove", c), d.removeEventListener("touchend", u);
        };
      }
    }, r.shouldScroll = function(i, s) {
      var a = this.props.highlightedIndex === void 0 ? this.getState() : this.props, l = a.highlightedIndex, c = s.highlightedIndex === void 0 ? i : s, u = c.highlightedIndex, d = l && this.getState().isOpen && !i.isOpen, f = l !== u;
      return d || f;
    }, r.componentDidUpdate = function(i, s) {
      process.env.NODE_ENV !== "production" && (Bh(this.state, i, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && Av(this._menuNode, this.getMenuProps)), Vl(this.props, "selectedItem") && this.props.selectedItemChanged(i.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: Fw,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(s, i) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var i = Dv(this.props.children, Mn);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var s = Dv(i(this.getStateAndHelpers()));
      if (!s)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && FA(s, this.getRootProps), s;
      if (Cw(s))
        return /* @__PURE__ */ Wl(s, this.getRootProps(_w(s)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(ZC);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: ww,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && TA(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: Mn,
    onInputValueChange: Mn,
    onUserAction: Mn,
    onChange: Mn,
    onSelect: Mn,
    onOuterClick: Mn,
    selectedItemChanged: function(n, r) {
      return n !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? {} : window
    ),
    stateReducer: function(n, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: yw
  }, e.stateChangeTypes = PA, e;
}();
process.env.NODE_ENV !== "production" && ($A.propTypes = {
  children: ue.func,
  defaultHighlightedIndex: ue.number,
  defaultIsOpen: ue.bool,
  initialHighlightedIndex: ue.number,
  initialSelectedItem: ue.any,
  initialInputValue: ue.string,
  initialIsOpen: ue.bool,
  getA11yStatusMessage: ue.func,
  itemToString: ue.func,
  onChange: ue.func,
  onSelect: ue.func,
  onStateChange: ue.func,
  onInputValueChange: ue.func,
  onUserAction: ue.func,
  onOuterClick: ue.func,
  selectedItemChanged: ue.func,
  stateReducer: ue.func,
  itemCount: ue.number,
  id: ue.string,
  environment: ue.shape({
    addEventListener: ue.func.isRequired,
    removeEventListener: ue.func.isRequired,
    document: ue.shape({
      createElement: ue.func.isRequired,
      getElementById: ue.func.isRequired,
      activeElement: ue.any.isRequired,
      body: ue.any.isRequired
    }).isRequired,
    Node: ue.func.isRequired
  }),
  suppressRefError: ue.bool,
  scrollIntoView: ue.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: ue.any,
  isOpen: ue.bool,
  inputValue: ue.string,
  highlightedIndex: ue.number,
  labelId: ue.string,
  inputId: ue.string,
  menuId: ue.string,
  getItemId: ue.func
  /* eslint-enable react/no-unused-prop-types */
});
function Av(e, t) {
  var n = t.refKey;
  e || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function FA(e, t) {
  var n = t.refKey, r = n !== "ref", o = !Cw(e);
  o && !r && !Tv.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !o && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !Tv.isForwardRef(e) && !_w(e)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var VA = ["isInitialMount", "highlightedIndex", "items", "environment"], Bw = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function BA(e, t, n) {
  var r = e.props, o = e.type, i = {};
  Object.keys(t).forEach(function(s) {
    HA(s, e, t, n), n[s] !== t[s] && (i[s] = n[s]);
  }), r.onStateChange && Object.keys(i).length && r.onStateChange(De({
    type: o
  }, i));
}
function HA(e, t, n, r) {
  var o = t.props, i = t.type, s = "on" + Hh(e) + "Change";
  o[s] && r[e] !== void 0 && r[e] !== n[e] && o[s](De({
    type: i
  }, r));
}
function WA(e, t) {
  return t.changes;
}
function zA(e) {
  var t = e.selectedItem, n = e.itemToString;
  return t ? n(t) + " has been selected." : "";
}
var jA = Vh(function(e, t) {
  Ew(e(), t);
}, 200), UA = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? _s : Le, YA = "useId" in Y ? function(t) {
  var n = t.id, r = t.labelId, o = t.menuId, i = t.getItemId, s = t.toggleButtonId, a = t.inputId, l = "downshift-" + Y.useId();
  n || (n = l);
  var c = Be({
    labelId: r || n + "-label",
    menuId: o || n + "-menu",
    getItemId: i || function(u) {
      return n + "-item-" + u;
    },
    toggleButtonId: s || n + "-toggle-button",
    inputId: a || n + "-input"
  });
  return c.current;
} : function(t) {
  var n = t.id, r = n === void 0 ? "downshift-" + xw() : n, o = t.labelId, i = t.menuId, s = t.getItemId, a = t.toggleButtonId, l = t.inputId, c = Be({
    labelId: o || r + "-label",
    menuId: i || r + "-menu",
    getItemId: s || function(u) {
      return r + "-item-" + u;
    },
    toggleButtonId: a || r + "-toggle-button",
    inputId: l || r + "-input"
  });
  return c.current;
};
function GA(e, t, n, r) {
  var o, i;
  if (e === void 0) {
    if (t === void 0)
      throw new Error(r);
    o = n[t], i = t;
  } else
    i = t === void 0 ? n.indexOf(e) : t, o = e;
  return [o, i];
}
function KA(e) {
  return e ? String(e) : "";
}
function Hh(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function Hw(e) {
  var t = Be(e);
  return t.current = e, t;
}
function qA(e, t, n) {
  var r = Be(), o = Be(), i = st(function(f, h) {
    o.current = h, f = Fl(f, h.props);
    var p = e(f, h), g = h.props.stateReducer(f, De({}, h, {
      changes: p
    }));
    return g;
  }, [e]), s = Vv(i, t), a = s[0], l = s[1], c = Hw(n), u = st(function(f) {
    return l(De({
      props: c.current
    }, f));
  }, [c]), d = o.current;
  return Le(function() {
    d && r.current && r.current !== a && BA(d, Fl(r.current, d.props), a), r.current = a;
  }, [a, n, d]), [a, u];
}
var as = {
  itemToString: KA,
  stateReducer: WA,
  getA11ySelectionMessage: zA,
  scrollIntoView: yw,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? {} : window
  )
};
function Qn(e, t, n) {
  n === void 0 && (n = Bw);
  var r = e["default" + Hh(t)];
  return r !== void 0 ? r : n[t];
}
function Zi(e, t, n) {
  n === void 0 && (n = Bw);
  var r = e[t];
  if (r !== void 0)
    return r;
  var o = e["initial" + Hh(t)];
  return o !== void 0 ? o : Qn(e, t, n);
}
function XA(e) {
  var t = Zi(e, "selectedItem"), n = Zi(e, "isOpen"), r = Zi(e, "highlightedIndex"), o = Zi(e, "inputValue");
  return {
    highlightedIndex: r < 0 && t && n ? e.items.indexOf(t) : r,
    isOpen: n,
    selectedItem: t,
    inputValue: o
  };
}
function ls(e, t, n) {
  var r = e.items, o = e.initialHighlightedIndex, i = e.defaultHighlightedIndex, s = t.selectedItem, a = t.highlightedIndex;
  return r.length === 0 ? -1 : o !== void 0 && a === o ? o : i !== void 0 ? i : s ? r.indexOf(s) : n === 0 ? -1 : n < 0 ? r.length - 1 : 0;
}
function ZA(e, t, n, r) {
  var o = Be({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return Le(function() {
    if ((n == null ? void 0 : n.addEventListener) != null) {
      var i = function() {
        o.current.isMouseDown = !0;
      }, s = function(d) {
        o.current.isMouseDown = !1, e && !Bl(d.target, t.map(function(f) {
          return f.current;
        }), n) && r();
      }, a = function() {
        o.current.isTouchMove = !1;
      }, l = function() {
        o.current.isTouchMove = !0;
      }, c = function(d) {
        e && !o.current.isTouchMove && !Bl(d.target, t.map(function(f) {
          return f.current;
        }), n, !1) && r();
      };
      return n.addEventListener("mousedown", i), n.addEventListener("mouseup", s), n.addEventListener("touchstart", a), n.addEventListener("touchmove", l), n.addEventListener("touchend", c), function() {
        n.removeEventListener("mousedown", i), n.removeEventListener("mouseup", s), n.removeEventListener("touchstart", a), n.removeEventListener("touchmove", l), n.removeEventListener("touchend", c);
      };
    }
  }, [e, n]), o;
}
var Ww = function() {
  return Mn;
};
process.env.NODE_ENV !== "production" && (Ww = function() {
  for (var t = Be(!0), n = arguments.length, r = new Array(n), o = 0; o < n; o++)
    r[o] = arguments[o];
  var i = Be(r.reduce(function(a, l) {
    return a[l] = {}, a;
  }, {}));
  Le(function() {
    Object.keys(i.current).forEach(function(a) {
      var l = i.current[a];
      if (t.current && !Object.keys(l).length) {
        console.error("downshift: You forgot to call the " + a + " getter function on your component / element.");
        return;
      }
      var c = l.suppressRefError, u = l.refKey, d = l.elementRef;
      (!d || !d.current) && !c && console.error('downshift: The ref prop "' + u + '" from ' + a + " was not applied correctly on your element.");
    }), t.current = !1;
  });
  var s = st(function(a, l, c, u) {
    i.current[a] = {
      suppressRefError: l,
      refKey: c,
      elementRef: u
    };
  }, []);
  return s;
});
function Lv(e, t, n) {
  var r = n.isInitialMount, o = n.highlightedIndex, i = n.items, s = n.environment, a = Xn(n, VA);
  Le(function() {
    r || jA(function() {
      return e(De({
        highlightedIndex: o,
        highlightedItem: i[o],
        resultCount: i.length
      }, a));
    }, s.document);
  }, t);
}
function QA(e) {
  var t = e.highlightedIndex, n = e.isOpen, r = e.itemRefs, o = e.getItemNodeFromIndex, i = e.menuElement, s = e.scrollIntoView, a = Be(!0);
  return UA(function() {
    t < 0 || !n || !Object.keys(r.current).length || (a.current === !1 ? a.current = !0 : s(o(t), i));
  }, [t]), a;
}
var zw = Mn;
process.env.NODE_ENV !== "production" && (zw = function(t) {
  var n = t.isInitialMount, r = t.props, o = t.state, i = Be(r);
  Le(function() {
    n || (Bh(o, i.current, r), i.current = r);
  }, [o, r, n]);
});
function $v(e, t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = ((r = e.items) == null ? void 0 : r.length) && t >= 0;
  return De({
    isOpen: !1,
    highlightedIndex: -1
  }, o && De({
    selectedItem: e.items[t],
    isOpen: Qn(e, "isOpen"),
    highlightedIndex: Qn(e, "highlightedIndex")
  }, n && {
    inputValue: e.itemToString(e.items[t])
  }));
}
var jw = {
  environment: ue.shape({
    addEventListener: ue.func.isRequired,
    removeEventListener: ue.func.isRequired,
    document: ue.shape({
      createElement: ue.func.isRequired,
      getElementById: ue.func.isRequired,
      activeElement: ue.any.isRequired,
      body: ue.any.isRequired
    }).isRequired,
    Node: ue.func.isRequired
  }),
  itemToString: ue.func,
  stateReducer: ue.func
}, Uw = De({}, jw, {
  getA11yStatusMessage: ue.func,
  highlightedIndex: ue.number,
  defaultHighlightedIndex: ue.number,
  initialHighlightedIndex: ue.number,
  isOpen: ue.bool,
  defaultIsOpen: ue.bool,
  initialIsOpen: ue.bool,
  selectedItem: ue.any,
  initialSelectedItem: ue.any,
  defaultSelectedItem: ue.any,
  id: ue.string,
  labelId: ue.string,
  menuId: ue.string,
  getItemId: ue.func,
  toggleButtonId: ue.string,
  onSelectedItemChange: ue.func,
  onHighlightedIndexChange: ue.func,
  onStateChange: ue.func,
  onIsOpenChange: ue.func,
  scrollIntoView: ue.func
});
function JA(e, t, n) {
  var r = t.type, o = t.props, i;
  switch (r) {
    case n.ItemMouseMove:
      i = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case n.MenuMouseLeave:
      i = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      i = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : ls(o, e, 0)
      };
      break;
    case n.FunctionOpenMenu:
      i = {
        isOpen: !0,
        highlightedIndex: ls(o, e, 0)
      };
      break;
    case n.FunctionCloseMenu:
      i = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      i = {
        highlightedIndex: t.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      i = {
        inputValue: t.inputValue
      };
      break;
    case n.FunctionReset:
      i = {
        highlightedIndex: Qn(o, "highlightedIndex"),
        isOpen: Qn(o, "isOpen"),
        selectedItem: Qn(o, "selectedItem"),
        inputValue: Qn(o, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return De({}, e, i);
}
ln(ln({}, Uw), { items: ue.array.isRequired, isItemDisabled: ue.func, getA11ySelectionMessage: ue.func });
function eL(e) {
  var t = e.isOpen, n = e.resultCount, r = e.previousResultCount;
  return t ? n ? n !== r ? "".concat(n, " result").concat(n === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
ln(ln({}, as), { getA11yStatusMessage: eL, isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var Wh = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, zh = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, jh = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, Uh = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, Yh = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, Gh = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Kh = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, qh = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, Xh = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, Hl = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, Zh = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, Yw = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, Gw = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, Qh = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, Kw = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, qw = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, Xw = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, Zw = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, Qw = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, Jh = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, Jw = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, eC = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, ep = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, tC = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: Wh,
  InputKeyDownArrowUp: zh,
  InputKeyDownEscape: jh,
  InputKeyDownHome: Uh,
  InputKeyDownEnd: Yh,
  InputKeyDownPageUp: Gh,
  InputKeyDownPageDown: Kh,
  InputKeyDownEnter: qh,
  InputChange: Xh,
  InputBlur: Hl,
  InputClick: Zh,
  MenuMouseLeave: Yw,
  ItemMouseMove: Gw,
  ItemClick: Qh,
  ToggleButtonClick: Kw,
  FunctionToggleMenu: qw,
  FunctionOpenMenu: Xw,
  FunctionCloseMenu: Zw,
  FunctionSetHighlightedIndex: Qw,
  FunctionSelectItem: Jh,
  FunctionSetInputValue: Jw,
  FunctionReset: eC,
  ControlledPropUpdatedSelectedItem: ep
});
function tL(e) {
  var t = XA(e), n = t.selectedItem, r = t.inputValue;
  return r === "" && n && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (r = e.itemToString(n)), De({}, t, {
    inputValue: r
  });
}
var nL = De({}, Uw, {
  items: ue.array.isRequired,
  isItemDisabled: ue.func,
  selectedItemChanged: ue.func,
  getA11ySelectionMessage: ue.func,
  inputValue: ue.string,
  defaultInputValue: ue.string,
  initialInputValue: ue.string,
  inputId: ue.string,
  onInputValueChange: ue.func
});
function rL(e, t, n) {
  var r = Be(), o = qA(e, t, n), i = o[0], s = o[1];
  return Le(function() {
    Vl(n, "selectedItem") && (n.selectedItemChanged(r.current, n.selectedItem) && s({
      type: ep,
      inputValue: n.itemToString(n.selectedItem)
    }), r.current = i.selectedItem === r.current ? n.selectedItem : i.selectedItem);
  }, [i.selectedItem, n.selectedItem]), [Fl(i, n), s];
}
var nC = Mn;
process.env.NODE_ENV !== "production" && (nC = function(t, n) {
  ue.checkPropTypes(nL, t, "prop", n.name);
});
var oL = De({}, as, {
  selectedItemChanged: function(t, n) {
    return t !== n;
  },
  getA11yStatusMessage: ww,
  isItemDisabled: function() {
    return !1;
  }
});
function iL(e, t) {
  var n, r = t.type, o = t.props, i = t.altKey, s;
  switch (r) {
    case Qh:
      s = {
        isOpen: Qn(o, "isOpen"),
        highlightedIndex: Qn(o, "highlightedIndex"),
        selectedItem: o.items[t.index],
        inputValue: o.itemToString(o.items[t.index])
      };
      break;
    case Wh:
      e.isOpen ? s = {
        highlightedIndex: mo(e.highlightedIndex, 1, o.items, o.isItemDisabled, !0)
      } : s = {
        highlightedIndex: i && e.selectedItem == null ? -1 : ls(o, e, 1),
        isOpen: o.items.length >= 0
      };
      break;
    case zh:
      e.isOpen ? i ? s = $v(o, e.highlightedIndex) : s = {
        highlightedIndex: mo(e.highlightedIndex, -1, o.items, o.isItemDisabled, !0)
      } : s = {
        highlightedIndex: ls(o, e, -1),
        isOpen: o.items.length >= 0
      };
      break;
    case qh:
      s = $v(o, e.highlightedIndex);
      break;
    case jh:
      s = De({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case Gh:
      s = {
        highlightedIndex: mo(e.highlightedIndex, -10, o.items, o.isItemDisabled, !0)
      };
      break;
    case Kh:
      s = {
        highlightedIndex: mo(e.highlightedIndex, 10, o.items, o.isItemDisabled, !0)
      };
      break;
    case Uh:
      s = {
        highlightedIndex: yi(0, !1, o.items, o.isItemDisabled)
      };
      break;
    case Yh:
      s = {
        highlightedIndex: yi(o.items.length - 1, !0, o.items, o.isItemDisabled)
      };
      break;
    case Hl:
      s = De({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = o.items) == null ? void 0 : n.length) && t.selectItem && {
        selectedItem: o.items[e.highlightedIndex],
        inputValue: o.itemToString(o.items[e.highlightedIndex])
      });
      break;
    case Xh:
      s = {
        isOpen: !0,
        highlightedIndex: Qn(o, "highlightedIndex"),
        inputValue: t.inputValue
      };
      break;
    case Zh:
      s = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : ls(o, e, 0)
      };
      break;
    case Jh:
      s = {
        selectedItem: t.selectedItem,
        inputValue: o.itemToString(t.selectedItem)
      };
      break;
    case ep:
      s = {
        inputValue: t.inputValue
      };
      break;
    default:
      return JA(e, t, tC);
  }
  return De({}, e, s);
}
var sL = ["onMouseLeave", "refKey", "ref"], aL = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], lL = ["onClick", "onPress", "refKey", "ref"], cL = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
jt.stateChangeTypes = tC;
function jt(e) {
  e === void 0 && (e = {}), nC(e, jt);
  var t = De({}, oL, e), n = t.items, r = t.scrollIntoView, o = t.environment, i = t.getA11yStatusMessage, s = t.getA11ySelectionMessage, a = t.itemToString, l = tL(t), c = rL(iL, l, t), u = c[0], d = c[1], f = u.isOpen, h = u.highlightedIndex, p = u.selectedItem, g = u.inputValue, v = Be(null), y = Be({}), b = Be(null), w = Be(null), C = Be(!0), x = YA(t), E = Be(), S = Hw({
    state: u,
    props: t
  }), R = st(function(j) {
    return y.current[x.getItemId(j)];
  }, [x]);
  Lv(i, [f, h, g, n], De({
    isInitialMount: C.current,
    previousResultCount: E.current,
    items: n,
    environment: o,
    itemToString: a
  }, u)), Lv(s, [p], De({
    isInitialMount: C.current,
    previousResultCount: E.current,
    items: n,
    environment: o,
    itemToString: a
  }, u));
  var M = QA({
    menuElement: v.current,
    highlightedIndex: h,
    isOpen: f,
    itemRefs: y,
    scrollIntoView: r,
    getItemNodeFromIndex: R
  });
  zw({
    isInitialMount: C.current,
    props: t,
    state: u
  }), Le(function() {
    var j = Zi(t, "isOpen");
    j && b.current && b.current.focus();
  }, []), Le(function() {
    C.current || (E.current = n.length);
  });
  var I = ZA(f, [b, v, w], o, function() {
    d({
      type: Hl,
      selectItem: !1
    });
  }), P = Ww("getInputProps", "getMenuProps");
  Le(function() {
    return C.current = !1, function() {
      C.current = !0;
    };
  }, []), Le(function() {
    var j;
    if (!f)
      y.current = {};
    else if (((j = o.document) == null ? void 0 : j.activeElement) !== b.current) {
      var W;
      b == null || (W = b.current) == null || W.focus();
    }
  }, [f, o]);
  var k = ai(function() {
    return {
      ArrowDown: function(W) {
        W.preventDefault(), d({
          type: Wh,
          altKey: W.altKey
        });
      },
      ArrowUp: function(W) {
        W.preventDefault(), d({
          type: zh,
          altKey: W.altKey
        });
      },
      Home: function(W) {
        S.current.state.isOpen && (W.preventDefault(), d({
          type: Uh
        }));
      },
      End: function(W) {
        S.current.state.isOpen && (W.preventDefault(), d({
          type: Yh
        }));
      },
      Escape: function(W) {
        var z = S.current.state;
        (z.isOpen || z.inputValue || z.selectedItem || z.highlightedIndex > -1) && (W.preventDefault(), d({
          type: jh
        }));
      },
      Enter: function(W) {
        var z = S.current.state;
        !z.isOpen || W.which === 229 || (W.preventDefault(), d({
          type: qh
        }));
      },
      PageUp: function(W) {
        S.current.state.isOpen && (W.preventDefault(), d({
          type: Gh
        }));
      },
      PageDown: function(W) {
        S.current.state.isOpen && (W.preventDefault(), d({
          type: Kh
        }));
      }
    };
  }, [d, S]), O = st(function(j) {
    return De({
      id: x.labelId,
      htmlFor: x.inputId
    }, j);
  }, [x]), F = st(function(j, W) {
    var z, X = j === void 0 ? {} : j, J = X.onMouseLeave, ne = X.refKey, Q = ne === void 0 ? "ref" : ne, D = X.ref, te = Xn(X, sL), K = W === void 0 ? {} : W, ce = K.suppressRefError, ee = ce === void 0 ? !1 : ce;
    return P("getMenuProps", ee, Q, v), De((z = {}, z[Q] = Xo(D, function(re) {
      v.current = re;
    }), z.id = x.menuId, z.role = "listbox", z["aria-labelledby"] = te && te["aria-label"] ? void 0 : "" + x.labelId, z.onMouseLeave = zt(J, function() {
      d({
        type: Yw
      });
    }), z), te);
  }, [d, P, x]), T = st(function(j) {
    var W, z, X = j === void 0 ? {} : j, J = X.item, ne = X.index, Q = X.refKey, D = Q === void 0 ? "ref" : Q, te = X.ref, K = X.onMouseMove, ce = X.onMouseDown, ee = X.onClick;
    X.onPress;
    var re = X.disabled, le = Xn(X, aL);
    re !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var de = S.current, be = de.props, ye = de.state, Ce = GA(J, ne, be.items, "Pass either item or index to getItemProps!"), ie = Ce[0], he = Ce[1], fe = be.isItemDisabled(ie, he), Se = "onClick", Me = ee, $e = function() {
      he !== ye.highlightedIndex && (M.current = !1, d({
        type: Gw,
        index: he,
        disabled: fe
      }));
    }, Ne = function() {
      d({
        type: Qh,
        index: he
      });
    }, Fe = function(bt) {
      return bt.preventDefault();
    };
    return De((W = {}, W[D] = Xo(te, function(Ae) {
      Ae && (y.current[x.getItemId(he)] = Ae);
    }), W["aria-disabled"] = fe, W["aria-selected"] = "" + (he === ye.highlightedIndex), W.id = x.getItemId(he), W.role = "option", W), !fe && (z = {}, z[Se] = zt(Me, Ne), z), {
      onMouseMove: zt(K, $e),
      onMouseDown: zt(ce, Fe)
    }, le);
  }, [d, S, M, x]), L = st(function(j) {
    var W, z = j === void 0 ? {} : j, X = z.onClick;
    z.onPress;
    var J = z.refKey, ne = J === void 0 ? "ref" : J, Q = z.ref, D = Xn(z, lL), te = S.current.state, K = function() {
      d({
        type: Kw
      });
    };
    return De((W = {}, W[ne] = Xo(Q, function(ce) {
      w.current = ce;
    }), W["aria-controls"] = x.menuId, W["aria-expanded"] = te.isOpen, W.id = x.toggleButtonId, W.tabIndex = -1, W), !D.disabled && De({}, {
      onClick: zt(X, K)
    }), D);
  }, [d, S, x]), A = st(function(j, W) {
    var z, X = j === void 0 ? {} : j, J = X.onKeyDown, ne = X.onChange, Q = X.onInput, D = X.onBlur;
    X.onChangeText;
    var te = X.onClick, K = X.refKey, ce = K === void 0 ? "ref" : K, ee = X.ref, re = Xn(X, cL), le = W === void 0 ? {} : W, de = le.suppressRefError, be = de === void 0 ? !1 : de;
    P("getInputProps", be, ce, b);
    var ye = S.current.state, Ce = function(Fe) {
      var Ae = Td(Fe);
      Ae && k[Ae] && k[Ae](Fe);
    }, ie = function(Fe) {
      d({
        type: Xh,
        inputValue: Fe.target.value
      });
    }, he = function(Fe) {
      if (ye.isOpen && !I.current.isMouseDown) {
        var Ae = Fe.relatedTarget === null && o.document.activeElement !== o.document.body;
        d({
          type: Hl,
          selectItem: !Ae
        });
      }
    }, fe = function() {
      d({
        type: Zh
      });
    }, Se = "onChange", Me = {};
    if (!re.disabled) {
      var $e;
      Me = ($e = {}, $e[Se] = zt(ne, Q, ie), $e.onKeyDown = zt(J, Ce), $e.onBlur = zt(D, he), $e.onClick = zt(te, fe), $e);
    }
    return De((z = {}, z[ce] = Xo(ee, function(Ne) {
      b.current = Ne;
    }), z["aria-activedescendant"] = ye.isOpen && ye.highlightedIndex > -1 ? x.getItemId(ye.highlightedIndex) : "", z["aria-autocomplete"] = "list", z["aria-controls"] = x.menuId, z["aria-expanded"] = ye.isOpen, z["aria-labelledby"] = re && re["aria-label"] ? void 0 : x.labelId, z.autoComplete = "off", z.id = x.inputId, z.role = "combobox", z.value = ye.inputValue, z), Me, re);
  }, [P, S, x, k, d, I, o]), N = st(function() {
    d({
      type: qw
    });
  }, [d]), B = st(function() {
    d({
      type: Zw
    });
  }, [d]), $ = st(function() {
    d({
      type: Xw
    });
  }, [d]), U = st(function(j) {
    d({
      type: Qw,
      highlightedIndex: j
    });
  }, [d]), G = st(function(j) {
    d({
      type: Jh,
      selectedItem: j
    });
  }, [d]), H = st(function(j) {
    d({
      type: Jw,
      inputValue: j
    });
  }, [d]), q = st(function() {
    d({
      type: eC
    });
  }, [d]);
  return {
    // prop getters.
    getItemProps: T,
    getLabelProps: O,
    getMenuProps: F,
    getInputProps: A,
    getToggleButtonProps: L,
    // actions.
    toggleMenu: N,
    openMenu: $,
    closeMenu: B,
    setHighlightedIndex: U,
    setInputValue: H,
    selectItem: G,
    reset: q,
    // state.
    highlightedIndex: h,
    isOpen: f,
    selectedItem: p,
    inputValue: g
  };
}
function uL(e) {
  var t = e.removedSelectedItem, n = e.itemToString;
  return n(t) + " has been removed.";
}
De({}, jw, {
  selectedItems: ue.array,
  initialSelectedItems: ue.array,
  defaultSelectedItems: ue.array,
  getA11yRemovalMessage: ue.func,
  activeIndex: ue.number,
  initialActiveIndex: ue.number,
  defaultActiveIndex: ue.number,
  onActiveIndexChange: ue.func,
  onSelectedItemsChange: ue.func,
  keyNavigationNext: ue.string,
  keyNavigationPrevious: ue.string
});
as.itemToString, as.stateReducer, as.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
function Wi(e, t, n) {
  let r = n.initialDeps ?? [], o;
  return () => {
    var i, s, a, l;
    let c;
    n.key && ((i = n.debug) != null && i.call(n)) && (c = Date.now());
    const u = e();
    if (!(u.length !== r.length || u.some((h, p) => r[p] !== h)))
      return o;
    r = u;
    let f;
    if (n.key && ((s = n.debug) != null && s.call(n)) && (f = Date.now()), o = t(...u), n.key && ((a = n.debug) != null && a.call(n))) {
      const h = Math.round((Date.now() - c) * 100) / 100, p = Math.round((Date.now() - f) * 100) / 100, g = p / 16, v = (y, b) => {
        for (y = String(y); y.length < b; )
          y = " " + y;
        return y;
      };
      console.info(
        `%c⏱ ${v(p, 5)} /${v(h, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * g, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (l = n == null ? void 0 : n.onChange) == null || l.call(n, o), o;
  };
}
function Pu(e, t) {
  if (e === void 0)
    throw new Error(`Unexpected undefined${t ? `: ${t}` : ""}`);
  return e;
}
const dL = (e, t) => Math.abs(e - t) < 1, fL = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
}, hL = (e) => e, pL = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let o = t; o <= n; o++)
    r.push(o);
  return r;
}, gL = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (s) => {
    const { width: a, height: l } = s;
    t({ width: Math.round(a), height: Math.round(l) });
  };
  if (o(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const i = new r.ResizeObserver((s) => {
    const a = s[0];
    if (a != null && a.borderBoxSize) {
      const l = a.borderBoxSize[0];
      if (l) {
        o({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    o(n.getBoundingClientRect());
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, Fv = {
  passive: !0
}, mL = typeof window > "u" ? !0 : "onscrollend" in window, vL = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let o = 0;
  const i = mL ? () => {
  } : fL(
    r,
    () => {
      t(o, !1);
    },
    e.options.isScrollingResetDelay
  ), s = (c) => () => {
    o = n[e.options.horizontal ? "scrollLeft" : "scrollTop"], i(), t(o, c);
  }, a = s(!0), l = s(!1);
  return l(), n.addEventListener("scroll", a, Fv), n.addEventListener("scrollend", l, Fv), () => {
    n.removeEventListener("scroll", a), n.removeEventListener("scrollend", l);
  };
}, bL = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, yL = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, i;
  const s = e + t;
  (i = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || i.call(o, {
    [r.options.horizontal ? "left" : "top"]: s,
    behavior: n
  });
};
class xL {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }));
      return {
        disconnect: () => {
          var o;
          return (o = r()) == null ? void 0 : o.disconnect();
        },
        observe: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, o]) => {
        typeof o > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: hL,
        rangeExtractor: pL,
        onChange: () => {
        },
        measureElement: bL,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        ...n
      };
    }, this.notify = (n, r) => {
      var o, i;
      const { startIndex: s, endIndex: a } = this.range ?? {
        startIndex: void 0,
        endIndex: void 0
      }, l = this.calculateRange();
      (n || s !== (l == null ? void 0 : l.startIndex) || a !== (l == null ? void 0 : l.endIndex)) && ((i = (o = this.options).onChange) == null || i.call(o, this, r));
    }, this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.observer.disconnect(), this.elementsCache.clear();
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.notify(!1, !1);
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.notify(!1, !1);
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o;
            const s = this.isScrolling;
            this.isScrolling = i, this.notify(s !== i, i);
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let s = r - 1; s >= 0; s--) {
        const a = n[s];
        if (o.has(a.lane))
          continue;
        const l = i.get(
          a.lane
        );
        if (l == null || a.end > l.end ? i.set(a.lane, a) : a.end < l.end && o.set(a.lane, !0), o.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((s, a) => s.end === a.end ? s.index - a.index : s.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = Wi(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, o, i, s) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: s
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Wi(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: o, getItemKey: i, enabled: s }, a) => {
        var l;
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((d) => {
          this.itemSizeCache.set(d.key, d.size);
        }));
        const c = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const u = this.measurementsCache.slice(0, c);
        for (let d = c; d < n; d++) {
          let f = (l = this.measurementsCache[d]) == null ? void 0 : l.measureElement;
          f || (f = (C) => {
            const x = i(d), E = this.elementsCache.get(x);
            if (!C) {
              E && (this.observer.unobserve(E), this.elementsCache.delete(x));
              return;
            }
            E !== C && (E && this.observer.unobserve(E), this.observer.observe(C), this.elementsCache.set(x, C)), C.isConnected && this.resizeItem(
              d,
              this.options.measureElement(C, void 0, this)
            );
          });
          const h = i(d), p = this.options.lanes === 1 ? u[d - 1] : this.getFurthestMeasurement(u, d), g = p ? p.end + this.options.gap : r + o, v = a.get(h), y = typeof v == "number" ? v : this.options.estimateSize(d), b = g + y, w = p ? p.lane : d % this.options.lanes;
          u[d] = {
            index: d,
            start: g,
            size: y,
            end: b,
            key: h,
            lane: w,
            measureElement: f
          };
        }
        return this.measurementsCache = u, u;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Wi(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, r, o) => this.range = n.length > 0 && r > 0 ? wL({
        measurements: n,
        outerSize: r,
        scrollOffset: o
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = Wi(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, r, o, i) => r === null ? [] : n({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: o,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const o = this.indexFromElement(n), i = this.getMeasurements()[o];
      if (!i || !n.isConnected) {
        this.elementsCache.forEach((a, l) => {
          a === n && (this.observer.unobserve(n), this.elementsCache.delete(l));
        });
        return;
      }
      const s = this.elementsCache.get(i.key);
      s !== n && (s && this.observer.unobserve(s), this.observer.observe(n), this.elementsCache.set(i.key, n)), this.resizeItem(o, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const o = this.getMeasurements()[n];
      if (!o)
        return;
      const i = this.itemSizeCache.get(o.key) ?? o.size, s = r - i;
      s !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, s, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", s), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, r)), this.notify(!0, !1));
    }, this.measureElement = (n) => {
      n && this._measureElement(n, void 0);
    }, this.getVirtualItems = Wi(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let i = 0, s = n.length; i < s; i++) {
          const a = n[i], l = r[a];
          o.push(l);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return Pu(
          r[rC(
            0,
            r.length - 1,
            (o) => Pu(r[o]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r) => {
      const o = this.getSize(), i = this.getScrollOffset();
      r === "auto" && (n <= i ? r = "start" : n >= i + o ? r = "end" : r = "start"), r === "start" ? n = n : r === "end" ? n = n - o : r === "center" && (n = n - o / 2);
      const s = this.options.horizontal ? "scrollWidth" : "scrollHeight", l = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[s] : this.scrollElement[s] : 0) - o;
      return Math.max(Math.min(l, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.getMeasurements()[n];
      if (!o)
        return;
      const i = this.getSize(), s = this.getScrollOffset();
      if (r === "auto")
        if (o.end >= s + i - this.options.scrollPaddingEnd)
          r = "end";
        else if (o.start <= s + this.options.scrollPaddingStart)
          r = "start";
        else
          return [s, r];
      const a = r === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(a, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: o } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(n, r);
      if (!i)
        return;
      const [s, a] = i;
      this._scrollToOffset(s, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [c] = Pu(
            this.getOffsetForIndex(n, a)
          );
          dL(c, this.getScrollOffset()) || this.scrollToIndex(n, { align: a, behavior: o });
        } else
          this.scrollToIndex(n, { align: a, behavior: o });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      return r.length === 0 ? o = this.options.paddingStart : o = this.options.lanes === 1 ? ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((i) => i.end)
      ), o - this.options.scrollMargin + this.options.paddingEnd;
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      var n, r;
      this.itemSizeCache = /* @__PURE__ */ new Map(), (r = (n = this.options).onChange) == null || r.call(n, this, !1);
    }, this.setOptions(t);
  }
}
const rC = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, i = n(o);
    if (i < r)
      e = o + 1;
    else if (i > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function wL({
  measurements: e,
  outerSize: t,
  scrollOffset: n
}) {
  const r = e.length - 1, i = rC(0, r, (a) => e[a].start, n);
  let s = i;
  for (; s < r && e[s].end < n + t; )
    s++;
  return { startIndex: i, endIndex: s };
}
const CL = typeof document < "u" ? m.useLayoutEffect : m.useEffect;
function _L(e) {
  const t = m.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (o, i) => {
      var s;
      i ? Pd(t) : t(), (s = e.onChange) == null || s.call(e, o, i);
    }
  }, [r] = m.useState(
    () => new xL(n)
  );
  return r.setOptions(n), m.useEffect(() => r._didMount(), []), CL(() => r._willUpdate()), r;
}
function oC(e) {
  return _L({
    observeElementRect: gL,
    observeElementOffset: vL,
    scrollToFn: yL,
    ...e
  });
}
function iC({
  items: e,
  inputValue: t,
  onInputValueChange: n,
  isItemDisabled: r
}) {
  const {
    isOpen: o,
    selected: i,
    onSelect: s,
    displayedValueKey: a,
    multiple: l,
    withConfirmation: c,
    setIsOpen: u,
    resettable: d = !0,
    options: f
  } = ur(), [h, p] = m.useState(i), g = c ? h : i, v = ML({
    items: e,
    selectedItem: g
  }), y = m.useRef(null), b = oC({
    count: v.length,
    getScrollElement: () => y.current,
    estimateSize: m.useCallback(() => 36, []),
    overscan: 5,
    paddingStart: 4,
    paddingEnd: 4,
    scrollPaddingEnd: 4,
    scrollPaddingStart: 4,
    gap: 2,
    getItemKey: m.useCallback(
      (x) => {
        var E;
        return (E = v[x]) == null ? void 0 : E[0];
      },
      [v]
    ),
    enabled: o
  }), w = m.useMemo(() => {
    if (r)
      return (x, E) => r(x, E, g);
  }, [r, g]);
  return {
    ...jt({
      isOpen: !0,
      inputValue: t,
      onInputValueChange: ({ inputValue: x }) => n(x ?? ""),
      onIsOpenChange: ({ isOpen: x, type: E }) => {
        E !== jt.stateChangeTypes.InputBlur && u(!!x);
      },
      items: v,
      itemToString: (x) => x != null && x[1] ? a ? x[1][a] : x[1] : "",
      selectedItem: g,
      onSelectedItemChange: ({ selectedItem: x }) => {
        if ((x == null ? void 0 : x[0]) === "__SELECT_ALL__" && f) {
          if (!l)
            return;
          const M = (g || []).length === f.length && f.length > 0;
          let I;
          M ? I = [] : I = f, (c ? p : s)(I);
          return;
        }
        if (!l) {
          c ? p(x) : s(x);
          return;
        }
        const E = g.findIndex(
          ([R]) => R === (x == null ? void 0 : x[0])
        ), S = c ? p : s;
        E > 0 ? S([
          ...g.slice(0, E),
          ...g.slice(E + 1)
        ]) : S(E === 0 ? [...g.slice(1)] : [...g, x]);
      },
      ...w ? { isItemDisabled: w } : void 0,
      stateReducer: m.useMemo(
        () => l || c ? SL : EL({ resettable: d }),
        [l, c, d]
      ),
      scrollIntoView() {
      },
      onHighlightedIndexChange: ({ highlightedIndex: x, type: E }) => {
        E !== jt.stateChangeTypes.MenuMouseLeave && x !== void 0 && b.scrollToIndex(x);
      }
    }),
    selectedItem: g,
    resetSelectionBuffer: () => p([]),
    setSelectionBuffer: p,
    virtualizer: b,
    listRef: y,
    sortedItems: v
  };
}
const EL = ({ resettable: e }) => (t, n) => {
  var i;
  const { changes: r, type: o } = n;
  switch (o) {
    case jt.stateChangeTypes.ControlledPropUpdatedSelectedItem:
      return {
        ...r,
        inputValue: ""
        // reset input value on popover opening
      };
    case jt.stateChangeTypes.InputKeyDownEnter:
    case jt.stateChangeTypes.ItemClick:
      return e ? {
        ...r,
        selectedItem: ((i = t.selectedItem) == null ? void 0 : i[0]) === r.selectedItem[0] ? [] : r.selectedItem
      } : r;
    case jt.stateChangeTypes.InputBlur:
      return {
        ...r,
        selectedItem: t.selectedItem,
        // don't select on blur
        highlightedIndex: t.highlightedIndex,
        inputValue: t.inputValue
      };
    case jt.stateChangeTypes.InputClick:
      return {
        ...r,
        isOpen: !0
      };
    default:
      return r;
  }
}, SL = (e, t) => {
  const { changes: n, type: r } = t;
  switch (r) {
    case jt.stateChangeTypes.ControlledPropUpdatedSelectedItem:
      return {
        ...n,
        inputValue: e.inputValue || ""
      };
    case jt.stateChangeTypes.InputKeyDownEnter:
    case jt.stateChangeTypes.ItemClick:
      return {
        ...n,
        isOpen: !0,
        // keep dropdown open after selection
        highlightedIndex: e.highlightedIndex,
        // keep highlighted index position
        inputValue: e.inputValue
        // keep search query
      };
    case jt.stateChangeTypes.InputBlur:
      return {
        ...n,
        selectedItem: e.selectedItem,
        // don't select on blur
        highlightedIndex: e.highlightedIndex,
        inputValue: e.inputValue
      };
    case jt.stateChangeTypes.InputClick:
      return {
        ...n,
        isOpen: !0
      };
    default:
      return n;
  }
};
function ML({
  items: e,
  selectedItem: t
}) {
  const { isOpen: n, multiple: r, getOptions: o } = ur(), i = !!o, s = m.useRef(null);
  return m.useEffect(() => {
    i || (n && !s.current && r ? s.current = new Set(
      (t || []).map(([l]) => l)
    ) : n || (s.current = null));
  }, [i, n, r, t]), m.useMemo(() => {
    var f;
    if (i || !r || !s.current)
      return e;
    const l = s.current, c = ((f = e[0]) == null ? void 0 : f[0]) === "__SELECT_ALL__" ? e[0] : null, d = [...c ? e.slice(1) : e].sort((h, p) => {
      const g = l.has(h[0]), v = l.has(p[0]);
      return g && !v ? -1 : !g && v ? 1 : 0;
    });
    return c ? [c, ...d] : d;
  }, [r, i, e, s.current]);
}
function OL({
  value: e,
  defaultValue: t,
  finalValue: n,
  onChange: r = () => {
  }
}) {
  const [o, i] = dt(
    t !== void 0 ? t : n
  ), s = (a, ...l) => {
    i(a), r == null || r(a, ...l);
  };
  return e !== void 0 ? [e, r, !0] : [o, s, !1];
}
const sC = "__SELECT_ALL__", x$ = (e) => {
  var r;
  const [t, n] = OL({
    value: e.isOpen,
    defaultValue: !1,
    onChange: e.onOpenChange
  });
  return /* @__PURE__ */ _(
    mw.Provider,
    {
      value: {
        ...e,
        withConfirmation: e.withConfirmation,
        setIsOpen: n,
        isOpen: t
      },
      children: /* @__PURE__ */ Z(oA, { open: t, onOpenChange: n, children: [
        /* @__PURE__ */ _(RL, { ref: e.triggerRef }),
        /* @__PURE__ */ Z(
          aA,
          {
            sideOffset: 6,
            collisionPadding: 10,
            ...e.contentProps,
            className: oe(
              `line
            z-50
            flex max-h-[min(var(--radix-popover-content-available-height),26rem)]
             w-[var(--radix-popover-content-available-width)]
           max-w-[max(var(--radix-popover-trigger-width),_16rem)] flex-col overflow-hidden
          rounded-md
          bg-foundations-default py-1 shadow-2`,
              (r = e.contentProps) == null ? void 0 : r.className
            ),
            children: [
              e.options && /* @__PURE__ */ _(IL, {}),
              e.getOptions && /* @__PURE__ */ _(NL, {})
            ]
          }
        )
      ] })
    }
  );
}, RL = m.forwardRef(
  (e, t) => {
    const {
      selected: n,
      prefixText: r,
      prefixIcon: o,
      disabled: i,
      className: s,
      multiple: a,
      error: l,
      onBlur: c,
      displayedValue: u,
      CustomTrigger: d
    } = ur();
    return /* @__PURE__ */ Z(
      iA,
      {
        ref: t,
        type: "button",
        role: "combobox",
        "aria-haspopup": "listbox",
        className: oe(
          "flex w-full select-none items-center rounded-md border border-foundations-bold bg-foundations-default py-2 pl-3 pr-2 text-left text-sm text-foundations-subtle focus:border-info-bold focus:text-info focus:shadow-3 focus:outline-none focus:ring-1 focus:ring-info-bold disabled:cursor-not-allowed aria-expanded:border-info-bold aria-expanded:text-info aria-expanded:shadow-3 aria-expanded:ring-1 aria-expanded:ring-info-bold",
          !i && "group/drop-down hover:shadow-3",
          l && "border-danger-bold focus:border-danger-bold focus:ring-danger-bold [&:focus>svg]:!text-danger [&>svg]:text-danger",
          s
        ),
        disabled: i,
        onBlur: c,
        children: [
          d || /* @__PURE__ */ Z(Ot, { children: [
            r && /* @__PURE__ */ _("span", { className: "-my-2 mr-3 flex-shrink-0 border-r border-r-foundations-subtle py-2 pr-3 text-sm text-foundations-subtle", children: r }),
            o && /* @__PURE__ */ _(o, { className: "-ml-1 mr-3 h-5 w-5" }),
            /* @__PURE__ */ _(
              "span",
              {
                className: oe(
                  "value min-w-0 flex-1 truncate text-sm text-foundations-subtle",
                  {
                    "text-foundations-bolder": a ? n.length : n == null ? void 0 : n[1]
                  }
                ),
                children: u ? u(n) : a ? /* @__PURE__ */ _(TL, {}) : /* @__PURE__ */ _(kL, {})
              }
            )
          ] }),
          /* @__PURE__ */ _(f0, { className: "ml-2 h-5 w-5 shrink-0 transition-transform group-aria-expanded/drop-down:rotate-180" })
        ]
      }
    );
  }
), TL = () => {
  const { label: e, selected: t, displayedValueKey: n } = ur();
  return t != null && t.length ? /* @__PURE__ */ _(Ot, { children: t.map(
    ([r, o]) => n ? o[n] : o
  ).join(", ") }) : /* @__PURE__ */ _(Ot, { children: e });
}, kL = () => {
  const { label: e, selected: t, displayedValueKey: n } = ur();
  return t != null && t[1] ? /* @__PURE__ */ _(Ot, { children: n ? t[1][n] : t[1] }) : /* @__PURE__ */ _(Ot, { children: e });
}, aC = ({ errorMsg: e }) => /* @__PURE__ */ Z("div", { className: "my-4 flex flex-col items-center space-y-4", children: [
  /* @__PURE__ */ _(H1, {}),
  /* @__PURE__ */ _("p", { className: "text-center text-sm text-foundations-subtle", children: e || "No matching data available" })
] }), PL = () => /* @__PURE__ */ _("div", { className: "my-4 flex flex-col items-center", children: /* @__PURE__ */ _(hD, {}) }), IL = () => {
  const {
    options: e = [],
    filterBy: t,
    displayedValueKey: n,
    onSelect: r,
    setIsOpen: o,
    ExtraBodyContent: i,
    searchTerm: s,
    onSearch: a,
    isItemDisabled: l,
    multiple: c,
    disableSelectAll: u
  } = ur(), [d, f] = m.useState(""), h = pd(t), p = !!t, g = s ?? d, v = a ?? f, y = m.useMemo(
    () => e.filter(([T, L]) => {
      var A;
      return p ? h(d, L) : n ? (A = L[n]) == null ? void 0 : A.toLowerCase().includes(d == null ? void 0 : d.toLowerCase()) : L == null ? void 0 : L.toLowerCase().includes(d == null ? void 0 : d.toLowerCase());
    }),
    [e, d, p, h, n]
  ), b = m.useMemo(
    () => [[sC, "Select All"], ...e],
    [e]
  ), w = m.useMemo(() => !c || u || y.length === 0 || g.trim() !== "" ? y : b, [c, u, y, g]), {
    getLabelProps: C,
    getMenuProps: x,
    getInputProps: E,
    getItemProps: S,
    highlightedIndex: R,
    selectedItem: M,
    resetSelectionBuffer: I,
    listRef: P,
    virtualizer: k,
    sortedItems: O
  } = iC({
    items: w,
    inputValue: g,
    onInputValueChange: v,
    isItemDisabled: l
  }), F = k.getVirtualItems();
  return /* @__PURE__ */ Z(Ot, { children: [
    /* @__PURE__ */ _(lC, { getLabelProps: C, getInputProps: E }),
    i,
    /* @__PURE__ */ Z(
      "ul",
      {
        className: "relative my-1 w-full  overflow-y-auto",
        ...x({
          ref: P,
          style: { maxHeight: 350 }
        }),
        children: [
          /* @__PURE__ */ _("li", { style: { height: k.getTotalSize() } }, "total-size"),
          F.length ? F.map((T) => /* @__PURE__ */ _(
            cC,
            {
              ref: k.measureElement,
              "data-index": T.index,
              "data-highlighted": R === T.index,
              option: O[T.index],
              getItemProps: S,
              index: T.index,
              selectedItem: M,
              style: {
                position: "absolute",
                top: 0,
                left: "0.5rem",
                width: "calc(100% - 1rem)",
                transform: `translateY(${T.start}px)`
              }
            },
            T.key
          )) : /* @__PURE__ */ _(aC, {})
        ]
      }
    ),
    /* @__PURE__ */ _(
      uC,
      {
        onReset: I,
        onApply: () => {
          r(M), o(!1);
        }
      }
    )
  ] });
}, NL = () => {
  const {
    getOptions: e,
    dependencies: t = [],
    onSelect: n,
    setIsOpen: r,
    ExtraBodyContent: o,
    parseGetOptionsError: i,
    isItemDisabled: s,
    selected: a,
    multiple: l,
    disableEmptySearch: c
  } = ur(), [u, d] = m.useState(""), [f, h] = m.useState(!0), [p, g] = m.useState(null), [v, y] = m.useState([]), b = m.useMemo(() => [
    ...l && a ? a.filter(
      (I) => {
        var P;
        return (P = I[1]) == null ? void 0 : P.toLowerCase().includes(u == null ? void 0 : u.toLowerCase());
      }
    ) : [],
    ...a ? v.filter(
      (I) => !a.some(
        (P) => P[0] === I[0]
      )
    ) : v
  ], [v]), {
    getLabelProps: w,
    getMenuProps: C,
    getInputProps: x,
    getItemProps: E,
    highlightedIndex: S,
    selectedItem: R,
    resetSelectionBuffer: M
  } = iC({
    items: b,
    inputValue: u,
    onInputValueChange: d,
    isItemDisabled: s
  });
  return dA(
    () => {
      if (c && u === "") {
        y([]), h(!1), g(null);
        return;
      }
      h(!0), e(u).then(y).catch((I) => {
        const P = i != null && i(I) || typeof I == "string" ? I : null;
        g(P || null);
      }).finally(() => h(!1));
    },
    500,
    [u, ...t]
  ), /* @__PURE__ */ Z(Ot, { children: [
    /* @__PURE__ */ _(lC, { getLabelProps: w, getInputProps: x }),
    o,
    /* @__PURE__ */ _(
      "ul",
      {
        className: "my-1 flex-1 space-y-1 overflow-y-auto px-2",
        ...C(),
        children: f ? /* @__PURE__ */ _(PL, {}) : b.length ? b.map((I, P) => /* @__PURE__ */ _(
          cC,
          {
            "data-highlighted": S === P,
            option: I,
            getItemProps: E,
            index: P,
            selectedItem: R
          },
          I[0]
        )) : /* @__PURE__ */ _(aC, { errorMsg: p })
      }
    ),
    /* @__PURE__ */ _(
      uC,
      {
        onReset: M,
        onApply: () => {
          n(R), r(!1);
        }
      }
    )
  ] });
}, lC = ({
  getLabelProps: e,
  getInputProps: t
}) => {
  const {
    label: n,
    name: r,
    placeholder: o = "Search",
    disableSearch: i
  } = ur();
  return /* @__PURE__ */ Z("div", { className: "border-b border-foundations-subtle p-4 pt-3", children: [
    /* @__PURE__ */ Z("div", { className: "flex items-center justify-between space-x-2", children: [
      /* @__PURE__ */ _(
        "label",
        {
          title: n,
          className: "select-none truncate font-medium text-foundations-bolder",
          ...e(),
          children: n
        }
      ),
      /* @__PURE__ */ _(sA, { className: "shrink-0 text-foundations-subtler hover:text-info focus:text-info focus:outline-none ", children: /* @__PURE__ */ _(g0, { className: "h-5 w-5" }) })
    ] }),
    /* @__PURE__ */ Z(
      "div",
      {
        className: oe("relative mt-3", i && "invisible mt-0 h-0"),
        children: [
          /* @__PURE__ */ _(
            "input",
            {
              className: "w-full rounded-md border border-foundations-bold bg-foundations-default py-1.5 pl-10 pr-2 text-foundations-bolder placeholder:text-foundations-subtle focus:border-info-bold focus:ring-1 focus:ring-info-bold",
              placeholder: o,
              ...t({ name: r })
            }
          ),
          /* @__PURE__ */ _("div", { className: "pointer-events-none absolute inset-y-0 left-0 inline-flex items-center pl-2", children: /* @__PURE__ */ _(KM, { className: "h-5 w-5 text-foundations-subtler " }) })
        ]
      }
    )
  ] });
}, DL = dn(
  "group flex items-center justify-between gap-1 rounded p-2 text-sm text-foundations-bolder",
  {
    variants: {
      multiple: {
        true: "aria-disabled:cursor-not-allowed aria-disabled:text-foundations-subtler data-[highlighted=true]:bg-foundations-subtlest",
        false: "aria-disabled:cursor-not-allowed aria-disabled:text-foundations-subtler data-[highlighted=true]:bg-info-bold data-[highlighted=true]:data-[selected=true]:bg-info-bolder data-[selected=true]:bg-info-bold data-[highlighted=true]:text-foundations-inverse data-[selected=true]:text-foundations-inverse"
      }
    },
    defaultVariants: {
      multiple: !1
    }
  }
), cC = m.forwardRef(({ selectedItem: e, option: t, getItemProps: n, index: r, ...o }, i) => {
  const { multiple: s, renderOption: a, options: l } = ur(), [c, u] = t, d = c === sC, f = m.useMemo(() => {
    if (!d || !l)
      return null;
    const p = e == null ? void 0 : e.length, g = p === l.length && l.length > 0;
    return { allSelected: g, isIndeterminate: !g && !(p === 0) };
  }, [d, l, e]), h = s && !d ? e == null ? void 0 : e.some(([p]) => p === c) : c === (e == null ? void 0 : e[0]);
  return /* @__PURE__ */ Z(
    "li",
    {
      "data-selected": h,
      className: oe(
        DL({ multiple: s }),
        d && "text-xs text-foundations-subtle"
      ),
      ...n({ item: t, index: r, ref: i }),
      ...o,
      children: [
        /* @__PURE__ */ _("div", { className: "flex flex-1 items-center justify-between overflow-hidden", children: d ? /* @__PURE__ */ Z("span", { className: "font-medium", children: [
          u,
          " ",
          l != null && l.length ? `(${l == null ? void 0 : l.length})` : null
        ] }) : a ? a(u) : /* @__PURE__ */ Z(Ot, { children: [
          /* @__PURE__ */ _("span", { children: u }),
          !s && /* @__PURE__ */ _(eo, { className: "invisible h-5 w-5 flex-shrink-0 group-data-[selected=true]:visible" })
        ] }) }),
        s && /* @__PURE__ */ _(
          q1,
          {
            tabIndex: -1,
            checked: d ? f == null ? void 0 : f.allSelected : h,
            isIndeterminate: d ? f == null ? void 0 : f.isIndeterminate : !1,
            readOnly: !0,
            className: "pointer-events-none flex-shrink-0 select-none"
          }
        )
      ]
    }
  );
}), uC = ({
  onReset: e,
  onApply: t
}) => {
  const { withConfirmation: n, ExtraFooterAction: r, resettable: o } = ur();
  return n ? /* @__PURE__ */ Z("div", { className: "border-t border-t-neutral-200 px-6 py-4", children: [
    r,
    /* @__PURE__ */ Z("div", { className: "flex space-x-4", children: [
      /* @__PURE__ */ _(
        rl,
        {
          variant: "secondary",
          onClick: () => {
            o && e();
          },
          className: "flex-1",
          children: "Reset"
        }
      ),
      /* @__PURE__ */ _(rl, { onClick: t, className: "flex-1", children: "Apply" })
    ] })
  ] }) : null;
}, dC = m.createContext(null), fC = () => {
  const e = m.useContext(dC);
  if (!e)
    throw new Error("useSelectContext must be used within <Select />");
  return e;
}, AL = (e) => {
  const [t, n] = m.useState(!1), [r, o] = m.useState(""), {
    selected: i,
    onSelect: s,
    options: a,
    placement: l = "bottom",
    className: c,
    contentClassName: u,
    displayedValueKey: d,
    filterBy: f
  } = e, h = m.useRef(!1), p = m.useMemo(() => h.current ? a.filter(([M, I]) => {
    if (typeof I == "string")
      return I.toLowerCase().includes(r == null ? void 0 : r.toLowerCase());
    if (f)
      return f(r, I);
    if (d)
      return I[d].toLowerCase().includes(r == null ? void 0 : r.toLowerCase());
  }) : a, [t, a, r, d]), g = m.useCallback(
    (M, I) => {
      var O;
      const { changes: P, type: k } = I;
      switch (k) {
        case jt.stateChangeTypes.InputKeyDownEscape:
        case jt.stateChangeTypes.InputBlur:
          return {
            ...P,
            selectedItem: M.selectedItem,
            inputValue: (O = M.selectedItem) != null && O[1] ? d ? M.selectedItem[1][d] : M.selectedItem[1] : ""
          };
        default:
          return P;
      }
    },
    [d]
  ), v = m.useRef(null), y = oC({
    count: p.length,
    getScrollElement: () => v.current,
    estimateSize: m.useCallback(() => 36, []),
    overscan: 5,
    paddingStart: 4,
    paddingEnd: 4,
    scrollPaddingEnd: 4,
    scrollPaddingStart: 4,
    gap: 2,
    getItemKey: m.useCallback(
      (M) => {
        var I;
        return (I = p == null ? void 0 : p[M]) == null ? void 0 : I[0];
      },
      [p]
    ),
    enabled: t
  }), {
    getInputProps: b,
    getMenuProps: w,
    getItemProps: C,
    highlightedIndex: x,
    getToggleButtonProps: E
  } = jt({
    isOpen: t,
    onIsOpenChange: ({ isOpen: M, ...I }) => {
      h.current = !1, n(!!M);
    },
    onInputValueChange: ({ inputValue: M }) => {
      h.current = !0, o(M ?? "");
    },
    items: p,
    itemToString: (M) => M != null && M[1] ? d ? M[1][d] : M[1] : "",
    selectedItem: i,
    onSelectedItemChange: ({ selectedItem: M }) => {
      s(M);
    },
    stateReducer: g,
    scrollIntoView() {
    },
    onHighlightedIndexChange: ({ highlightedIndex: M, type: I }) => {
      I !== jt.stateChangeTypes.MenuMouseLeave && M !== void 0 && y.scrollToIndex(M);
    }
  }), { refs: S, floatingStyles: R } = Bx({
    open: t,
    placement: l,
    middleware: [
      Rx(6),
      Ox(),
      Tx(),
      kx({
        apply: ({ elements: M, rects: I, availableWidth: P, availableHeight: k }) => {
          const { width: O, height: F } = I.reference, T = M.floating.style;
          T.setProperty("--available-width", `${P}px`), T.setProperty(
            "--available-height",
            `${k}px`
          ), T.setProperty("--trigger-width", `${O}px`), T.setProperty("--trigger-height", `${F}px`);
        },
        padding: 10
      })
    ],
    whileElementsMounted: Fx
  });
  return /* @__PURE__ */ _(dC.Provider, { value: e, children: /* @__PURE__ */ Z("div", { ref: S.setReference, className: c, children: [
    /* @__PURE__ */ _(
      hC,
      {
        getInputProps: b,
        getToggleButtonProps: E
      }
    ),
    /* @__PURE__ */ _($y, { children: /* @__PURE__ */ _(
      "ul",
      {
        className: oe(
          "z-50 max-h-[min(var(--available-height),_12.5rem)] w-[var(--available-width)] max-w-[max(var(--trigger-width),_18rem)] overflow-y-auto rounded-md bg-foundations-default shadow-2",
          !t && "hidden",
          u
        ),
        ...w({
          ref: K1([S.setFloating, v]),
          style: R
        }),
        children: e.options && /* @__PURE__ */ Z(Ot, { children: [
          /* @__PURE__ */ _(
            "li",
            {
              style: { height: y.getTotalSize() }
            },
            "total-size"
          ),
          /* @__PURE__ */ _(
            gC,
            {
              virtualizer: y,
              getItemProps: C,
              highlightedIndex: x,
              filteredOptions: p
            }
          )
        ] })
      }
    ) })
  ] }) });
};
AL.displayName = "Select";
const hC = ({
  getInputProps: e,
  getToggleButtonProps: t
}) => {
  const {
    selected: n,
    id: r,
    name: o,
    disabled: i,
    prefixText: s,
    prefixIcon: a,
    placeholder: l,
    inputClassName: c,
    onBlur: u,
    error: d,
    inputRef: f
  } = fC();
  return /* @__PURE__ */ Z("div", { className: "relative", children: [
    /* @__PURE__ */ _(
      "input",
      {
        className: oe(
          "peer w-full overflow-ellipsis rounded-md border border-foundations-bold bg-foundations-default p-2 pr-8 text-left text-sm text-foundations-subtle focus:border-info-bold focus:text-foundations-boldest focus:shadow-3 focus:outline-none focus:ring-1 focus:ring-info-bold disabled:cursor-not-allowed  disabled:border-foundations-subtle disabled:bg-foundations-subtelst-02 disabled:text-foundations-subtler aria-expanded:border-info-bold aria-expanded:shadow-3 aria-expanded:ring-1 aria-expanded:ring-info-bold",
          {
            "hover:shadow-3": !i,
            "text-foundations-boldest": n == null ? void 0 : n[1],
            "pl-9": a,
            "pl-16": s,
            "border-danger-bold focus:border-danger-bold focus:ring-danger-bold": d
          },
          c
        ),
        ...e({
          onBlur: u,
          disabled: i,
          placeholder: l,
          name: o,
          id: r,
          ref: f
        })
      }
    ),
    s && /* @__PURE__ */ _("span", { className: "pointer-events-none absolute inset-y-0 left-0 top-0 flex flex-shrink-0 items-center justify-center border-r border-r-foundations-bold px-3 text-sm text-foundations-subtle", children: s }),
    a && /* @__PURE__ */ _(a, { className: "pointer-events-none absolute left-2 top-1/2 h-5 w-5 -translate-y-1/2 text-foundations-subtler peer-focus:text-info peer-aria-expanded:text-info" }),
    /* @__PURE__ */ _(
      "button",
      {
        ...t({ disabled: i, type: "button" }),
        className: "absolute inset-y-0 right-2 flex flex-shrink-0 items-center justify-center text-foundations-subtler transition-transform disabled:cursor-not-allowed peer-focus:text-info peer-aria-expanded:rotate-180 peer-aria-expanded:text-info",
        children: /* @__PURE__ */ _(f0, { className: " h-5 w-5 " })
      }
    )
  ] });
};
hC.displayName = "SelectInput";
const pC = () => /* @__PURE__ */ Z("div", { className: "my-4 flex flex-col items-center space-y-4 text-center", children: [
  /* @__PURE__ */ _(H1, {}),
  /* @__PURE__ */ _("p", { className: "text-sm text-foundations-subtle", children: "No matching data available" })
] });
pC.displayName = "EmptyOptions";
const gC = ({
  highlightedIndex: e,
  getItemProps: t,
  filteredOptions: n,
  virtualizer: r
}) => {
  const o = r.getVirtualItems();
  return /* @__PURE__ */ _(Ot, { children: o.length ? o.map((i) => /* @__PURE__ */ _(
    mC,
    {
      ref: r.measureElement,
      "data-index": i.index,
      "data-highlighted": e === i.index,
      option: n[i.index],
      getItemProps: t,
      index: i.index,
      style: {
        position: "absolute",
        top: 0,
        left: "0.5rem",
        width: "calc(100% - 1rem)",
        transform: `translateY(${i.start}px)`
      }
    },
    i.key
  )) : /* @__PURE__ */ _(pC, {}) });
};
gC.displayName = "SelectOptions";
const LL = dn(
  "group flex items-center justify-between rounded p-2 text-sm text-foundations-subtle",
  {
    variants: {
      multiple: {
        true: "data-[highlighted=true]:bg-foundations-subtlest",
        false: "data-[highlighted=true]:bg-info-bold data-[highlighted=true]:data-[selected=true]:bg-info-bolder data-[selected=true]:bg-info-bold data-[highlighted=true]:text-foundations-inverse data-[selected=true]:text-foundations-inverse"
      }
    },
    defaultVariants: {
      multiple: !1
    }
  }
), mC = m.forwardRef(({ option: e, getItemProps: t, index: n, ...r }, o) => {
  const { renderOption: i, selected: s } = fC(), [a, l] = e, c = a === (s == null ? void 0 : s[0]);
  return /* @__PURE__ */ _(
    "li",
    {
      "data-selected": c,
      className: LL(),
      ...t({
        item: e,
        index: n,
        ref: o
      }),
      ...r,
      children: /* @__PURE__ */ _("div", { className: "flex flex-1 items-center justify-between", children: i ? i(l, c) : /* @__PURE__ */ Z(Ot, { children: [
        /* @__PURE__ */ _("span", { children: l }),
        /* @__PURE__ */ _(eo, { className: "invisible h-5 w-5 group-data-[selected=true]:visible" })
      ] }) })
    }
  );
});
mC.displayName = "Option";
const $L = m.forwardRef(
  ({
    savedFileName: e = null,
    multiple: t = !1,
    accept: n,
    showAcceptedFilesHint: r = !0,
    label: o = "",
    hint: i = "",
    uploadingProgress: s = 0,
    uploadedFiles: a = [],
    onFilesChange: l,
    withUploadConfirmation: c = !1,
    onUploadConfirmed: u,
    isUploadButtonDisabled: d = !1,
    isUploadButtonLoading: f = !1,
    isUploadButtonTooltipDisabled: h = !1,
    uploadButtonTooltipText: p = ""
  }, g) => {
    var M;
    const v = s > 0 && s < 100, y = m.useMemo(
      () => `UploadFiles${o.split(" ").join("")}`,
      [o]
    ), [b, w] = m.useState(!1), C = m.useRef(null), x = a.length > 0 || !!e, E = m.useCallback(
      (I) => {
        var P;
        if (w(!1), (P = I.target.files) != null && P.length) {
          if (v)
            return;
          l([...I.target.files]);
        }
      },
      [l]
    ), S = m.useCallback(
      (I) => {
        I.preventDefault(), w(!0);
      },
      []
    ), R = m.useCallback(
      (I) => {
        I.preventDefault(), w(!1);
      },
      []
    );
    return /* @__PURE__ */ Z(Ot, { children: [
      o && /* @__PURE__ */ Z(
        "label",
        {
          htmlFor: y,
          className: "mb-2 inline-flex items-center gap-2",
          children: [
            /* @__PURE__ */ _("span", { className: "block text-sm font-medium text-foundations-bold", children: o }),
            i && /* @__PURE__ */ _(Yp, { delay: 0, children: /* @__PURE__ */ Z(xt, { children: [
              /* @__PURE__ */ _(
                xt.Trigger,
                {
                  render: /* @__PURE__ */ _("div", { className: "flex h-6 w-6 items-center justify-center rounded-full bg-neutral-100" }),
                  children: /* @__PURE__ */ _(
                    GM,
                    {
                      width: 16,
                      height: 16,
                      className: " text-foundations-subtler"
                    }
                  )
                }
              ),
              /* @__PURE__ */ _(
                xt.Popup,
                {
                  variant: "dark",
                  side: "top",
                  size: "sm",
                  collisionPadding: 4,
                  children: i
                }
              )
            ] }) })
          ]
        }
      ),
      /* @__PURE__ */ Z("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ Z(
          "div",
          {
            ref: g,
            className: oe(
              "relative flex w-full items-center justify-center gap-2 overflow-hidden rounded border border-dashed border-neutral-300 p-4 text-foundations-subtle transition-all duration-200",
              {
                "border-blue-500 bg-neutral-50 text-blue-500": b,
                "pointer-events-none border-solid border-blue-200": v,
                "pointer-events-none border-solid border-green-200": x,
                "p-2": c
              }
            ),
            children: [
              v ? /* @__PURE__ */ Z(Ot, { children: [
                /* @__PURE__ */ _(
                  Hy,
                  {
                    variant: "primary",
                    value: s,
                    size: 26,
                    strokeWidth: 4,
                    strokeClassName: "stroke-neutral-800",
                    strokeLinecap: "square"
                  }
                ),
                /* @__PURE__ */ Z("p", { className: "p-1 text-xs font-medium", children: [
                  "Uploading (",
                  s,
                  "%)"
                ] }),
                /* @__PURE__ */ _(
                  "div",
                  {
                    className: "absolute bottom-0 left-0 h-[5px] bg-blue-500",
                    style: { width: `${s}%` }
                  }
                )
              ] }) : /* @__PURE__ */ _(Ot, { children: x ? /* @__PURE__ */ Z(Ot, { children: [
                /* @__PURE__ */ _("div", { className: "flex h-6 w-6 items-center justify-center rounded-full bg-green-100", children: /* @__PURE__ */ _(
                  eo,
                  {
                    width: 16,
                    height: 16,
                    className: "text-green-500"
                  }
                ) }),
                /* @__PURE__ */ _("p", { className: "p-1 text-xs font-medium", children: ((M = a[0]) == null ? void 0 : M.name) || e })
              ] }) : /* @__PURE__ */ Z(Ot, { children: [
                /* @__PURE__ */ _(
                  tg,
                  {
                    width: 20,
                    height: 20,
                    className: "pointer-events-none text-foundations-subtle"
                  }
                ),
                /* @__PURE__ */ Z("p", { className: "pointer-events-none p-1 text-xs font-medium", children: [
                  "Drop file or click here to",
                  " ",
                  c ? "browse" : "upload"
                ] })
              ] }) }),
              /* @__PURE__ */ _(
                "input",
                {
                  id: y,
                  className: "absolute inset-0 cursor-pointer opacity-0",
                  ref: C,
                  type: "file",
                  accept: n,
                  multiple: t,
                  onChange: E,
                  onDragEnter: S,
                  onDragLeave: R
                }
              )
            ]
          }
        ),
        c && /* @__PURE__ */ _(Yp, { children: /* @__PURE__ */ Z(
          xt,
          {
            disabled: !p || h,
            children: [
              /* @__PURE__ */ _(
                xt.Trigger,
                {
                  render: /* @__PURE__ */ _(
                    rl,
                    {
                      className: "disabled:pointer-events-auto",
                      disabled: d,
                      isLoading: f,
                      onClick: () => u == null ? void 0 : u(a)
                    }
                  ),
                  children: "Upload"
                }
              ),
              /* @__PURE__ */ _(xt.Popup, { children: p })
            ]
          }
        ) })
      ] }),
      n && r && /* @__PURE__ */ Z("p", { className: "mt-[6px] text-xs text-foundations-subtle", children: [
        "Supported file types: ",
        n.split(",").join(" ")
      ] }),
      x && /* @__PURE__ */ Z(
        "button",
        {
          type: "button",
          className: "flex items-center justify-center gap-2 px-4 py-[6px] text-foundations-subtle",
          onClick: () => {
            var I;
            return (I = C.current) == null ? void 0 : I.click();
          },
          children: [
            /* @__PURE__ */ _(tg, { width: 20, height: 20 }),
            /* @__PURE__ */ _("span", { className: "text-xs font-medium", children: c ? "Browse files" : "Re-upload file" })
          ]
        }
      )
    ] });
  }
);
$L.displayName = "UploadArea";
const FL = b1, vC = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  w1,
  {
    "data-slot": "menu-trigger",
    className: oe("", e),
    ...t
  }
));
vC.displayName = "MenuTrigger";
const tp = m.forwardRef(
  ({
    children: e,
    className: t,
    sideOffset: n = 4,
    align: r = "end",
    alignOffset: o = 0,
    side: i = "bottom",
    ...s
  }, a) => /* @__PURE__ */ Z(u1, { children: [
    /* @__PURE__ */ _(t1, {}),
    /* @__PURE__ */ _(
      d1,
      {
        align: r,
        alignOffset: o,
        className: "z-50",
        "data-slot": "menu-positioner",
        side: i,
        sideOffset: n,
        children: /* @__PURE__ */ _(
          c1,
          {
            ref: a,
            className: oe(
              "relative flex max-h-[--available-height] w-56 origin-[--transform-origin] overflow-y-auto overflow-x-hidden rounded-md border border-foundations-subtle bg-foundations-default bg-clip-padding p-2 text-foundations-bolder shadow-lg transition-[scale,opacity] data-[open]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[open]:fade-in-0 data-[closed]:zoom-out-95 data-[open]:zoom-in-95",
              t
            ),
            "data-slot": "menu-popup",
            ...s,
            children: /* @__PURE__ */ _("div", { className: "w-full", children: e })
          }
        )
      }
    )
  ] })
);
tp.displayName = "MenuPopup";
const VL = dn(
  "relative flex cursor-pointer select-none scroll-m-1 items-center gap-2 rounded px-4 py-2 text-sm text-foundations-bolder outline-none transition-colors data-[disabled]:pointer-events-none data-[highlighted]:bg-foundations-subtlest data-[disabled]:opacity-50",
  {
    variants: {
      variant: {
        destructive: "destructive-menu text-danger"
      }
    }
  }
), bC = m.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ _(
  s1,
  {
    ref: r,
    className: oe(VL({ variant: t }), e),
    "data-slot": "menu-item",
    "data-variant": t,
    ...n
  }
));
bC.displayName = "MenuItem";
const BL = (e) => /* @__PURE__ */ _(DN, { "data-slot": "menu-sub", ...e }), yC = m.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ Z(
  C1,
  {
    ref: r,
    className: oe(
      "data-disabled:pointer-events-none data-disabled:opacity-64 flex items-center gap-2 rounded-sm px-2 py-1 outline-none data-[highlighted]:bg-foundations-subtlest sm:text-sm",
      e
    ),
    "data-slot": "menu-sub-trigger",
    ...n,
    children: [
      t,
      /* @__PURE__ */ _(Rf, { className: "ms-auto h-4 w-4 text-foundations-subtler" })
    ]
  }
));
yC.displayName = "MenuSubTrigger";
const xC = m.forwardRef(
  ({ className: e, sideOffset: t = 0, alignOffset: n = -4, align: r = "start", ...o }, i) => /* @__PURE__ */ _(
    tp,
    {
      ref: i,
      align: r,
      alignOffset: n,
      className: e,
      "data-slot": "menu-sub-content",
      side: "inline-end",
      sideOffset: t,
      ...o
    }
  )
);
xC.displayName = "MenuSubPopup";
const wC = m.forwardRef((e, t) => /* @__PURE__ */ _(o1, { ref: t, "data-slot": "menu-group", ...e }));
wC.displayName = "MenuGroup";
const CC = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  i1,
  {
    ref: n,
    className: oe(
      "p-2 text-xs font-medium uppercase text-foundations-subtle",
      e
    ),
    "data-slot": "menu-label",
    ...t
  }
));
CC.displayName = "MenuGroupLabel";
const _C = m.forwardRef((e, t) => /* @__PURE__ */ _(
  f1,
  {
    ref: t,
    "data-slot": "menu-radio-group",
    ...e
  }
));
_C.displayName = "MenuRadioGroup";
const EC = m.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ Z(
  h1,
  {
    ref: r,
    className: oe(
      "relative grid cursor-pointer select-none scroll-m-1 grid-cols-[1fr_1rem] items-center gap-2 rounded p-2 ps-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[highlighted]:bg-foundations-subtlest data-[checked]:text-info data-[disabled]:opacity-50 sm:text-sm",
      e
    ),
    "data-slot": "menu-radio-item",
    ...n,
    children: [
      /* @__PURE__ */ _("span", { className: "col-start-1", children: t }),
      /* @__PURE__ */ _(p1, { className: "col-start-2", children: /* @__PURE__ */ _(eo, { className: "pointer-events-auto h-4 w-4 shrink-0" }) })
    ]
  }
));
EC.displayName = "MenuRadioItem";
const SC = m.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ Z(
  n1,
  {
    ref: o,
    checked: n,
    className: oe(
      "relative grid cursor-pointer select-none scroll-m-1 grid-cols-[1rem_1fr] items-center gap-2 rounded px-4 py-2 pe-4 ps-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[highlighted]:bg-foundations-subtlest data-[disabled]:opacity-50 sm:text-sm",
      e
    ),
    "data-slot": "menu-checkbox-item",
    ...r,
    children: [
      /* @__PURE__ */ _(r1, { className: "col-start-1", children: /* @__PURE__ */ _(eo, { className: "pointer-events-auto h-4 w-4 shrink-0" }) }),
      /* @__PURE__ */ _("span", { className: "col-start-2", children: t })
    ]
  }
));
SC.displayName = "MenuCheckboxItem";
const HL = m.forwardRef(({ Icon: e, className: t, ...n }, r) => /* @__PURE__ */ _(
  e,
  {
    ref: r,
    className: oe("h-4 w-4", t),
    "aria-hidden": "true",
    ...n
  }
)), WL = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  qy,
  {
    ref: n,
    className: oe(
      "-mx-2 my-1.5 border-t border-foundations-subtle",
      e
    ),
    "data-slot": "menu-separator",
    ...t
  }
)), w$ = Object.assign(FL, {
  Trigger: vC,
  Popup: tp,
  Group: wC,
  Item: bC,
  Icon: HL,
  CheckboxItem: SC,
  RadioGroup: _C,
  RadioItem: EC,
  GroupLabel: CC,
  Separator: WL,
  Sub: BL,
  SubTrigger: yC,
  SubPopup: xC
}), zL = m.forwardRef(
  ({ steps: e, currentStepIndex: t }, n) => {
    const r = (i) => i === t, o = (i) => i < t;
    return /* @__PURE__ */ _("nav", { ref: n, "aria-label": "progress", children: /* @__PURE__ */ _("ol", { className: "flex flex-wrap", children: e.map((i, s) => /* @__PURE__ */ Z("li", { className: "flex items-center", children: [
      s > 0 && /* @__PURE__ */ _("hr", { className: "mx-2 h-[1px] w-8 bg-foundations-bold" }),
      /* @__PURE__ */ Z("div", { className: "flex flex-wrap items-center justify-center gap-2", children: [
        o(s) ? /* @__PURE__ */ _(jL, {}) : /* @__PURE__ */ _(UL, { isActive: r(s) }),
        /* @__PURE__ */ _(
          "span",
          {
            className: oe(
              "text-sm font-medium",
              r(s) ? "text-foundations-boldest" : "text-foundations-subtle"
            ),
            children: i
          }
        )
      ] })
    ] }, `${s}-${i}`)) }) });
  }
);
zL.displayName = "Stepper";
const jL = () => /* @__PURE__ */ _("span", { className: "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-info-subtler p-1", children: /* @__PURE__ */ _(eo, { className: "h-4 w-4 text-info" }) }), UL = ({ isActive: e }) => /* @__PURE__ */ _(
  "span",
  {
    className: oe(
      "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-foundations-subtlest",
      e ? "bg-info-bold" : "bg-foundations-subtlest"
    ),
    children: /* @__PURE__ */ _(
      "span",
      {
        className: oe(
          "h-[10px] w-[10px] rounded-full bg-foundations-subtle",
          e ? "bg-white" : "bg-foundations-subtle"
        )
      }
    )
  }
), MC = m.createContext(null), np = () => {
  const e = m.useContext(MC);
  if (!e)
    throw new Error("useSheetContext must be used within <SheetContext />");
  return e;
};
function YL({ noBackdrop: e, container: t, ...n }) {
  return /* @__PURE__ */ _(
    MC.Provider,
    {
      value: {
        noBackdrop: e,
        container: t
      },
      children: /* @__PURE__ */ _(
        d0,
        {
          modal: e ? !1 : n.modal,
          ...n
        }
      )
    }
  );
}
function OC(e) {
  return /* @__PURE__ */ _(Cf, { ...e });
}
function GL(e) {
  return /* @__PURE__ */ _(Of, { "data-slot": "sheet-trigger", ...e });
}
function RC({ className: e, ...t }) {
  return /* @__PURE__ */ Z(
    hc,
    {
      "data-slot": "sheet-close",
      className: oe("shrink-0", e),
      ...t,
      children: [
        /* @__PURE__ */ _(
          g0,
          {
            className: "h-6 w-6 text-foundations-subtler hover:text-foundations-subtle",
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ _("span", { className: "sr-only", children: "Close" })
      ]
    }
  );
}
function TC({ className: e, ...t }) {
  const { container: n } = np();
  return /* @__PURE__ */ _(
    gf,
    {
      className: oe(
        "pointer-events-none fixed inset-0 z-50 bg-[rgba(0,0,0,0.40)] transition-opacity duration-300",
        "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
        "data-[ending-style]:ease-in data-[starting-style]:ease-out",
        !!n && "absolute",
        e
      ),
      "data-slot": "sheet-backdrop",
      ...t
    }
  );
}
function kC({
  className: e,
  side: t,
  inset: n,
  ...r
}) {
  const { container: o } = np();
  return /* @__PURE__ */ _(
    Sf,
    {
      className: oe(
        // "grid-rows-[1fr_auto_1fr] justify-items-center p-4",
        "pointer-events-none fixed inset-0 z-50 grid",
        t === "bottom" && "grid grid-rows-[1fr_auto] pt-12",
        t === "top" && "grid grid-rows-[auto_1fr] pb-12",
        t === "left" && "flex justify-start",
        t === "right" && "flex justify-end",
        n && "sm:p-3",
        !!o && "absolute",
        e
      ),
      "data-slot": "sheet-viewport",
      ...r
    }
  );
}
function KL({
  className: e,
  children: t,
  side: n = "right",
  inset: r = !0,
  ...o
}) {
  const { noBackdrop: i, container: s } = np();
  return /* @__PURE__ */ Z(OC, { container: s, children: [
    !i && /* @__PURE__ */ _(TC, {}),
    /* @__PURE__ */ _(kC, { side: n, inset: r, children: /* @__PURE__ */ _(
      wf,
      {
        className: oe(
          "pointer-events-auto relative flex max-h-full min-h-0 w-full min-w-0 flex-col overflow-hidden border border-foundations-subtle bg-foundations-default bg-clip-padding shadow-xl transition-all duration-300 ease-in-out will-change-transform",
          "before:pointer-events-none before:absolute before:inset-0 before:shadow-[0_1px_--theme(--color-black/6%)]",
          "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 dark:before:shadow-[0_-1px_--theme(--color-white/6%)] max-sm:before:hidden",
          n === "bottom" && "row-start-2 border-t data-[ending-style]:translate-y-11 data-[starting-style]:translate-y-11",
          n === "top" && "border-b data-[ending-style]:-translate-y-11 data-[starting-style]:-translate-y-11",
          n === "left" && "max-w-md border-r data-[ending-style]:-translate-x-11 data-[starting-style]:-translate-x-11",
          n === "right" && "col-start-2 max-w-md border-l data-[ending-style]:translate-x-11 data-[starting-style]:translate-x-11",
          r && "sm:**:data-[slot=sheet-footer]:rounded-b-[calc(var(--radius-xl)-1px)] before:hidden sm:rounded-xl sm:before:rounded-[calc(var(--radius-xl)-1px)]",
          e
        ),
        "data-slot": "sheet-popup",
        ...o,
        children: t
      }
    ) })
  ] });
}
const PC = m.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ Z(
  "div",
  {
    ref: r,
    className: oe(
      "flex items-center justify-between gap-2 border-b border-b-foundations-subtle px-8 py-6 text-lg font-medium text-foundations-boldest",
      e
    ),
    "data-slot": "sheet-header",
    ...n,
    children: [
      /* @__PURE__ */ _("div", { className: "flex min-w-0 flex-1 flex-col gap-1.5", children: t }),
      /* @__PURE__ */ _(RC, { className: "shrink-0" })
    ]
  }
));
PC.displayName = "SheetHeader";
function qL({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: oe(
        "mt-auto flex flex-row-reverse gap-4 border-t border-t-foundations-subtle bg-foundations-default px-8 py-6",
        e
      ),
      "data-slot": "sheet-footer",
      ...t
    }
  );
}
const IC = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "span",
  {
    ref: n,
    className: oe(
      "text-xs font-medium uppercase leading-6 text-foundations-bold",
      e
    ),
    "data-slot": "sheet-subheading",
    ...t
  }
));
IC.displayName = "SheetSubHeading";
const NC = m.forwardRef(
  ({ className: e, render: t, ...n }, r) => /* @__PURE__ */ _(
    Mf,
    {
      ref: r,
      render: t || /* @__PURE__ */ _("h3", {}),
      className: oe(
        "text-lg font-medium leading-6 text-foundations-boldest",
        e
      ),
      "data-slot": "sheet-title",
      ...n
    }
  )
);
NC.displayName = "SheetTitle";
function XL({
  className: e,
  ref: t,
  ...n
}) {
  return /* @__PURE__ */ _(
    bf,
    {
      ref: t,
      className: oe("text-sm text-foundations-subtle", e),
      "data-slot": "sheet-description",
      ...n
    }
  );
}
function ZL({ className: e, ...t }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: oe("flex-1 overflow-auto p-8", e),
      "data-slot": "sheet-panel",
      ...t
    }
  );
}
const C$ = Object.assign(YL, {
  Trigger: GL,
  Portal: OC,
  Close: RC,
  Backdrop: TC,
  Popup: KL,
  Header: PC,
  SubHeading: IC,
  Footer: qL,
  Title: NC,
  Description: XL,
  Panel: ZL,
  Viewport: kC
}), _$ = Y.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "div",
  {
    ref: n,
    className: oe(
      "pointer-events-none absolute bottom-0 left-0 z-20 h-16 w-full bg-gradient-to-t from-[theme(backgroundColor.foundations-default)] to-transparent",
      e
    ),
    ...t
  }
)), DC = m.forwardRef((e, t) => /* @__PURE__ */ _(Zy, { ref: t, "data-slot": "collapsible", ...e }));
DC.displayName = "Collapsible";
const rp = m.forwardRef((e, t) => /* @__PURE__ */ _(
  Qy,
  {
    ref: t,
    "data-slot": "collapsible-trigger",
    ...e
  }
));
rp.displayName = "CollapsibleTrigger";
const QL = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  Jy,
  {
    ref: n,
    "data-slot": "collapsible-panel",
    className: oe(
      "h-[--collapsible-panel-height] overflow-hidden transition-[height] duration-200 data-[ending-style]:h-0 data-[starting-style]:h-0",
      e
    ),
    ...t
  }
));
rp.displayName = "CollapsiblePanel";
const E$ = Object.assign(DC, {
  Trigger: rp,
  Panel: QL
}), S$ = ({
  id: e,
  link: t,
  className: n,
  size: r = "sm",
  "data-testid": o
}) => {
  const { name: i, url: s } = t || {};
  return /* @__PURE__ */ Z("div", { className: oe("flex min-w-0 items-center gap-1", n), children: [
    /* @__PURE__ */ _(
      s0,
      {
        size: "sm",
        hoverable: !1,
        render: s ? /* @__PURE__ */ _(
          Ch,
          {
            href: s,
            target: "_blank",
            variant: "standalone",
            showExternalIcon: !1,
            size: r,
            className: "block",
            onClick: (a) => a.stopPropagation(),
            children: i || e
          }
        ) : /* @__PURE__ */ _(
          "span",
          {
            className: oe(
              "truncate text-foundations-subtle",
              r === "md" ? "text-sm" : "text-xs"
            ),
            children: e
          }
        )
      }
    ),
    /* @__PURE__ */ _(JL, { id: e, dataTestId: o })
  ] });
}, JL = ({
  id: e,
  dataTestId: t
}) => {
  const [n, r] = dt(!1), { copy: o, isCopied: i } = W1();
  return /* @__PURE__ */ Z(xt, { open: n, children: [
    /* @__PURE__ */ _(
      xt.Trigger,
      {
        delay: 0,
        render: /* @__PURE__ */ _(
          cs,
          {
            size: "sm",
            className: "inline-flex shrink-0 px-1 py-0.5",
            onMouseEnter: () => r(!0),
            onMouseLeave: () => r(!1),
            onFocus: () => r(!0),
            onBlur: () => r(!1),
            variant: "tertiary",
            onClick: (s) => {
              s.stopPropagation(), i || o(e);
            },
            "data-testid": t
          }
        ),
        children: i ? /* @__PURE__ */ _(eo, { className: "text-success" }) : /* @__PURE__ */ _(h0, { className: "" })
      }
    ),
    /* @__PURE__ */ _(xt.Popup, { size: "sm", children: i ? "Copied!" : "Copy ID" })
  ] });
}, AC = m.forwardRef(({ ...e }, t) => /* @__PURE__ */ _("nav", { ref: t, "aria-label": "breadcrumb", "data-slot": "breadcrumb", ...e }));
AC.displayName = "Breadcrumb";
const LC = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "ol",
  {
    ref: n,
    className: oe(
      "flex flex-wrap items-center break-words text-sm",
      e
    ),
    "data-slot": "breadcrumb-list",
    ...t
  }
));
LC.displayName = "BreadcrumbList";
const $C = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "li",
  {
    ref: n,
    className: oe("inline-flex items-center gap-1.5", e),
    "data-slot": "breadcrumb-item",
    ...t
  }
));
$C.displayName = "BreadcrumbItem";
const FC = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  Ch,
  {
    ref: n,
    showExternalIcon: !1,
    className: oe("rounded-md p-2 hover:bg-foundations-subtlest", e),
    ...t
  }
));
FC.displayName = "BreadcrumbLink";
const VC = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "span",
  {
    ref: n,
    "aria-current": "page",
    "aria-disabled": "true",
    className: oe("py-2 pl-2 font-medium text-foundations-bolder", e),
    "data-slot": "breadcrumb-page",
    role: "link",
    ...t
  }
));
VC.displayName = "BreadcrumbPage";
const BC = m.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ _(
  "li",
  {
    ref: r,
    "aria-hidden": "true",
    className: oe("text-foundations-subtler [&>svg]:size-4", t),
    "data-slot": "breadcrumb-separator",
    role: "presentation",
    ...n,
    children: e ?? /* @__PURE__ */ _(Rf, {})
  }
));
BC.displayName = "BreadcrumbSeparator";
const HC = m.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ Z(
  "li",
  {
    ref: r,
    "aria-hidden": "true",
    className: oe("text-info", t),
    "data-slot": "breadcrumb-ellipsis",
    role: "presentation",
    ...n,
    children: [
      /* @__PURE__ */ _(zM, { className: "size-4" }),
      /* @__PURE__ */ _("span", { className: "sr-only", children: "More" })
    ]
  }
));
HC.displayName = "BreadcrumbEllipsis";
const M$ = Object.assign(AC, {
  List: LC,
  Item: $C,
  Link: FC,
  Page: VC,
  Separator: BC,
  Ellipsis: HC
}), WC = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  L1,
  {
    ref: n,
    className: oe("flex flex-col", e),
    "data-slot": "tabs",
    ...t
  }
));
WC.displayName = "Tabs";
const zC = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  V1,
  {
    ref: n,
    className: oe(
      "flex items-end gap-4 border-b border-foundations-subtler",
      e
    ),
    "data-slot": "tabs-list",
    ...t
  }
));
zC.displayName = "TabsList";
const jC = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  $1,
  {
    ref: n,
    className: oe(
      // general tab styles
      "-mb-px shrink-0 items-center gap-x-1.5 gap-y-1 whitespace-nowrap rounded-t border-b-2 border-b-transparent px-2 pb-1.5 pt-2 text-left text-sm font-medium text-foundations-subtle outline-none first-of-type:pl-0 [&_svg]:pointer-events-none [&_svg]:shrink-0",
      // layout
      "flex items-center [&:has([data-slot='tab-description'])]:grid [&:has([data-slot='tab-description'])]:grid-cols-[auto_auto_1fr]",
      // hover styles
      "hover:border-foundations-bold hover:text-foundations-bold",
      // focus styles
      "focus:border-foundations-subtle focus:text-info",
      // active tab default styles
      "data-[active]:border-b-2 data-[active]:border-info-bold data-[active]:text-foundations-bolder",
      // active tab hover styles
      "hover:data-[active]:border-info-bolder hover:data-[active]:text-foundations-boldest",
      // active tab focus styles
      "focus:data-[active]:border-info-bolder focus:data-[active]:text-info",
      // disabled tab styles
      "data-[disabled]:pointer-events-none data-[disabled]:border-foundations-subtler data-[disabled]:text-foundations-subtler",
      e
    ),
    ...t
  }
));
jC.displayName = "TabsTab";
const UC = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  F1,
  {
    ref: n,
    className: oe("flex-1 pt-6", e),
    "data-slot": "tabs-content",
    ...t
  }
));
UC.displayName = "TabsPanel";
const YC = m.forwardRef(({ className: e, variant: t = "light", size: n = "sm", children: r, ...o }, i) => /* @__PURE__ */ Z(xt, { children: [
  /* @__PURE__ */ _(
    xt.Trigger,
    {
      ref: i,
      render: /* @__PURE__ */ _(
        "span",
        {
          className: "inline-block rounded-full bg-foundations-subtlest p-0.5",
          "data-slot": "tab-hint"
        }
      ),
      children: /* @__PURE__ */ _(
        p0,
        {
          "data-slot": "hint-icon",
          className: oe("h-4 w-4 text-foundations-subtle", e)
        }
      )
    }
  ),
  /* @__PURE__ */ _(xt.Popup, { size: n, variant: t, ...o, children: r })
] }));
YC.displayName = "TabsTabHint";
const GC = m.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "span",
  {
    ref: n,
    "data-slot": "tab-description",
    className: oe("col-span-3 text-xs font-normal", e),
    ...t
  }
));
GC.displayName = "TabsTabDescription";
const O$ = Object.assign(WC, {
  List: zC,
  Tab: jC,
  Panel: UC,
  Hint: YC,
  Description: GC
});
function R$(e) {
  const { fileInputDom: t, accept: n, onSelect: r } = e ?? {}, o = Be(null), [i, s] = dt(null), [a, l] = dt(!1), [c, u] = dt(null), d = st(() => {
    o.current && (o.current.value = "");
  }, []), f = st(async () => {
    var g, v;
    const p = (v = (g = o.current) == null ? void 0 : g.files) == null ? void 0 : v[0];
    s(p || null);
    try {
      l(!0), p && await (r == null ? void 0 : r(p, d));
    } catch (y) {
      u(y);
    } finally {
      l(!1);
    }
  }, [r]);
  return Le(() => {
    o.current || (o.current = t ?? document.createElement("input"), o.current.type = "file", o.current.accept = n ?? "*/*", o.current.disabled = (e == null ? void 0 : e.disabled) ?? !1, o.current.addEventListener("change", f));
  }, [t, f]), { file: i, isLoading: a, error: c, selectFile: () => {
    o.current && o.current.click();
  } };
}
function T$({
  currency: e,
  amount: t,
  compact: n = !1
}) {
  const r = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: e,
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    notation: n ? "compact" : "standard"
  });
  return n ? r.format(t) : r.format(t).replace(/^(\D+)\s*(.+)$/, "$2$1").trim();
}
function k$({
  value: e,
  compact: t = !1
}) {
  return new Intl.NumberFormat(void 0, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    notation: t ? "compact" : "standard"
  }).format(e);
}
export {
  h$ as AccessDeniedIllustration,
  lD as Alert,
  sD as Badge,
  y$ as BasePopover,
  M$ as Breadcrumb,
  rl as Button,
  q_ as ButtonGroup,
  Jv as ButtonSpinner,
  mx as Calendar,
  uD as Card,
  s$ as Chart,
  zf as ChartJS,
  A6 as ChartProvider,
  q1 as Checkbox,
  eN as CircleChart,
  E$ as Collapsible,
  bD as CopyIconButton,
  S$ as CopyIdButton,
  rA as DateInput,
  eA as DatePicker,
  r$ as Dialog,
  l$ as DiffPercentageBadge,
  x$ as DropdownSearch,
  c$ as EmptyStateIllustration,
  u$ as EmptyStateIllustration2,
  d$ as EmptyStateIllustration3,
  f$ as EmptyStateIllustration4,
  nN as HorizontalBarsChart,
  cs as IconButton,
  z1 as Input,
  DD as InputOTP,
  Ch as Link,
  dD as LinkBox,
  fD as LinkOverlay,
  w$ as Menu,
  H1 as NoMatchingResultIllustration,
  b3 as Option,
  v3 as OptionsGroup,
  _$ as OverflowIndicator,
  s0 as OverflowText,
  oA as Popover,
  v$ as PopoverArrow,
  sA as PopoverClose,
  aA as PopoverContent,
  iA as PopoverTrigger,
  $y as Portal,
  b$ as ProgressBar,
  Hy as ProgressRadial,
  VD as Radio,
  sC as SELECT_ALL_VALUE,
  hD as SearchIllustration,
  AL as Select,
  C$ as Sheet,
  hM as Skeleton,
  mi as Slot,
  zL as Stepper,
  p$ as Switch,
  O$ as Tabs,
  xt as Tooltip,
  Yp as TooltipProvider,
  cM as TooltipRoot,
  $L as UploadArea,
  aD as alertVariants,
  iD as badgeVariants,
  Qv as buttonVariants,
  oe as cn,
  a$ as createScale,
  dn as cva,
  T$ as formatCurrency,
  k$ as formatNumber,
  yr as getColorFromCssVariable,
  X_ as iconButtonVariants,
  BD as linkVariants,
  FD as switchThumbVariants,
  $D as switchVariants,
  pd as useCallbackRef,
  Fs as useChart,
  jt as useCombobox,
  W1 as useCopyToClipboard,
  gn as useDateInput,
  OL as useUncontrolled,
  R$ as useUploadFile
};
